function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea8c4"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea8c4"] = parcelRequire;
}
parcelRequire.register("iwYKF", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d7da5726a9ca36a2$export$ffb0004e005737fa, (v) => $d7da5726a9ca36a2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d7da5726a9ca36a2$export$34b9dba7ce09269b, (v) => $d7da5726a9ca36a2$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d7da5726a9ca36a2$export$25062201e9e25d76, (v) => $d7da5726a9ca36a2$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7da5726a9ca36a2$export$ffb0004e005737fa;
var $d7da5726a9ca36a2$export$34b9dba7ce09269b;
var $d7da5726a9ca36a2$export$25062201e9e25d76;
"use strict";

var $lx97N = parcelRequire("lx97N");
var $d7da5726a9ca36a2$var$k = Symbol.for("react.element"), $d7da5726a9ca36a2$var$l = Symbol.for("react.fragment"), $d7da5726a9ca36a2$var$m = Object.prototype.hasOwnProperty, $d7da5726a9ca36a2$var$n = $lx97N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d7da5726a9ca36a2$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d7da5726a9ca36a2$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d7da5726a9ca36a2$var$m.call(a, b) && !$d7da5726a9ca36a2$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d7da5726a9ca36a2$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d7da5726a9ca36a2$var$n.current
    };
}
$d7da5726a9ca36a2$export$ffb0004e005737fa = $d7da5726a9ca36a2$var$l;
$d7da5726a9ca36a2$export$34b9dba7ce09269b = $d7da5726a9ca36a2$var$q;
$d7da5726a9ca36a2$export$25062201e9e25d76 = $d7da5726a9ca36a2$var$q;

});
parcelRequire.register("lx97N", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8E8IG"));

});
parcelRequire.register("8E8IG", function(module, exports) {

$parcel$export(module.exports, "Children", () => $64b8d2b03b5764eb$export$dca3b0875bd9a954, (v) => $64b8d2b03b5764eb$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $64b8d2b03b5764eb$export$16fa2f45be04daa8, (v) => $64b8d2b03b5764eb$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $64b8d2b03b5764eb$export$ffb0004e005737fa, (v) => $64b8d2b03b5764eb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $64b8d2b03b5764eb$export$e2c29f18771995cb, (v) => $64b8d2b03b5764eb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $64b8d2b03b5764eb$export$221d75b3f55bb0bd, (v) => $64b8d2b03b5764eb$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $64b8d2b03b5764eb$export$5f8d39834fd61797, (v) => $64b8d2b03b5764eb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $64b8d2b03b5764eb$export$74bf444e3cd11ea5, (v) => $64b8d2b03b5764eb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $64b8d2b03b5764eb$export$ae55be85d98224ed, (v) => $64b8d2b03b5764eb$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $64b8d2b03b5764eb$export$e530037191fcd5d7, (v) => $64b8d2b03b5764eb$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $64b8d2b03b5764eb$export$fd42f52fd3ae1109, (v) => $64b8d2b03b5764eb$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $64b8d2b03b5764eb$export$c8a8987d4410bf2d, (v) => $64b8d2b03b5764eb$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $64b8d2b03b5764eb$export$d38cd72104c1f0e9, (v) => $64b8d2b03b5764eb$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $64b8d2b03b5764eb$export$7d1e3a5e95ceca43, (v) => $64b8d2b03b5764eb$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $64b8d2b03b5764eb$export$257a8862b851cb5b, (v) => $64b8d2b03b5764eb$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $64b8d2b03b5764eb$export$a8257692ac88316c, (v) => $64b8d2b03b5764eb$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $64b8d2b03b5764eb$export$488013bae63b21da, (v) => $64b8d2b03b5764eb$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $64b8d2b03b5764eb$export$7c73462e0d25e514, (v) => $64b8d2b03b5764eb$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $64b8d2b03b5764eb$export$7568632d0d33d16d, (v) => $64b8d2b03b5764eb$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $64b8d2b03b5764eb$export$88948ce120ea2619, (v) => $64b8d2b03b5764eb$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $64b8d2b03b5764eb$export$35808ee640e87ca7, (v) => $64b8d2b03b5764eb$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $64b8d2b03b5764eb$export$fae74005e78b1a27, (v) => $64b8d2b03b5764eb$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e, (v) => $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $64b8d2b03b5764eb$export$6a7bc4e911dc01cf, (v) => $64b8d2b03b5764eb$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $64b8d2b03b5764eb$export$6d9c69b0de29b591, (v) => $64b8d2b03b5764eb$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $64b8d2b03b5764eb$export$f680877a34711e37, (v) => $64b8d2b03b5764eb$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $64b8d2b03b5764eb$export$d5a552a76deda3c2, (v) => $64b8d2b03b5764eb$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $64b8d2b03b5764eb$export$aaabe4eda9ed9969, (v) => $64b8d2b03b5764eb$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $64b8d2b03b5764eb$export$e5c5a5f917a5871c, (v) => $64b8d2b03b5764eb$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $64b8d2b03b5764eb$export$1538c33de8887b59, (v) => $64b8d2b03b5764eb$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $64b8d2b03b5764eb$export$13e3392192263954, (v) => $64b8d2b03b5764eb$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $64b8d2b03b5764eb$export$b8f5890fc79d6aca, (v) => $64b8d2b03b5764eb$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $64b8d2b03b5764eb$export$60241385465d0a34, (v) => $64b8d2b03b5764eb$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $64b8d2b03b5764eb$export$306c0aa65ff9ec16, (v) => $64b8d2b03b5764eb$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $64b8d2b03b5764eb$export$7b286972b8d8ccbf, (v) => $64b8d2b03b5764eb$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $64b8d2b03b5764eb$export$83d89fbfd8236492, (v) => $64b8d2b03b5764eb$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $64b8d2b03b5764eb$export$dca3b0875bd9a954;
var $64b8d2b03b5764eb$export$16fa2f45be04daa8;
var $64b8d2b03b5764eb$export$ffb0004e005737fa;
var $64b8d2b03b5764eb$export$e2c29f18771995cb;
var $64b8d2b03b5764eb$export$221d75b3f55bb0bd;
var $64b8d2b03b5764eb$export$5f8d39834fd61797;
var $64b8d2b03b5764eb$export$74bf444e3cd11ea5;
var $64b8d2b03b5764eb$export$ae55be85d98224ed;
var $64b8d2b03b5764eb$export$e530037191fcd5d7;
var $64b8d2b03b5764eb$export$fd42f52fd3ae1109;
var $64b8d2b03b5764eb$export$c8a8987d4410bf2d;
var $64b8d2b03b5764eb$export$d38cd72104c1f0e9;
var $64b8d2b03b5764eb$export$7d1e3a5e95ceca43;
var $64b8d2b03b5764eb$export$257a8862b851cb5b;
var $64b8d2b03b5764eb$export$a8257692ac88316c;
var $64b8d2b03b5764eb$export$488013bae63b21da;
var $64b8d2b03b5764eb$export$7c73462e0d25e514;
var $64b8d2b03b5764eb$export$7568632d0d33d16d;
var $64b8d2b03b5764eb$export$88948ce120ea2619;
var $64b8d2b03b5764eb$export$35808ee640e87ca7;
var $64b8d2b03b5764eb$export$fae74005e78b1a27;
var $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e;
var $64b8d2b03b5764eb$export$6a7bc4e911dc01cf;
var $64b8d2b03b5764eb$export$6d9c69b0de29b591;
var $64b8d2b03b5764eb$export$f680877a34711e37;
var $64b8d2b03b5764eb$export$d5a552a76deda3c2;
var $64b8d2b03b5764eb$export$aaabe4eda9ed9969;
var $64b8d2b03b5764eb$export$e5c5a5f917a5871c;
var $64b8d2b03b5764eb$export$1538c33de8887b59;
var $64b8d2b03b5764eb$export$13e3392192263954;
var $64b8d2b03b5764eb$export$b8f5890fc79d6aca;
var $64b8d2b03b5764eb$export$60241385465d0a34;
var $64b8d2b03b5764eb$export$306c0aa65ff9ec16;
var $64b8d2b03b5764eb$export$7b286972b8d8ccbf;
var $64b8d2b03b5764eb$export$83d89fbfd8236492;
"use strict";
var $64b8d2b03b5764eb$var$l = Symbol.for("react.element"), $64b8d2b03b5764eb$var$n = Symbol.for("react.portal"), $64b8d2b03b5764eb$var$p = Symbol.for("react.fragment"), $64b8d2b03b5764eb$var$q = Symbol.for("react.strict_mode"), $64b8d2b03b5764eb$var$r = Symbol.for("react.profiler"), $64b8d2b03b5764eb$var$t = Symbol.for("react.provider"), $64b8d2b03b5764eb$var$u = Symbol.for("react.context"), $64b8d2b03b5764eb$var$v = Symbol.for("react.forward_ref"), $64b8d2b03b5764eb$var$w = Symbol.for("react.suspense"), $64b8d2b03b5764eb$var$x = Symbol.for("react.memo"), $64b8d2b03b5764eb$var$y = Symbol.for("react.lazy"), $64b8d2b03b5764eb$var$z = Symbol.iterator;
function $64b8d2b03b5764eb$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $64b8d2b03b5764eb$var$z && a[$64b8d2b03b5764eb$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $64b8d2b03b5764eb$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $64b8d2b03b5764eb$var$C = Object.assign, $64b8d2b03b5764eb$var$D = {};
function $64b8d2b03b5764eb$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b8d2b03b5764eb$var$D;
    this.updater = e || $64b8d2b03b5764eb$var$B;
}
$64b8d2b03b5764eb$var$E.prototype.isReactComponent = {};
$64b8d2b03b5764eb$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$64b8d2b03b5764eb$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $64b8d2b03b5764eb$var$F() {}
$64b8d2b03b5764eb$var$F.prototype = $64b8d2b03b5764eb$var$E.prototype;
function $64b8d2b03b5764eb$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b8d2b03b5764eb$var$D;
    this.updater = e || $64b8d2b03b5764eb$var$B;
}
var $64b8d2b03b5764eb$var$H = $64b8d2b03b5764eb$var$G.prototype = new $64b8d2b03b5764eb$var$F;
$64b8d2b03b5764eb$var$H.constructor = $64b8d2b03b5764eb$var$G;
$64b8d2b03b5764eb$var$C($64b8d2b03b5764eb$var$H, $64b8d2b03b5764eb$var$E.prototype);
$64b8d2b03b5764eb$var$H.isPureReactComponent = !0;
var $64b8d2b03b5764eb$var$I = Array.isArray, $64b8d2b03b5764eb$var$J = Object.prototype.hasOwnProperty, $64b8d2b03b5764eb$var$K = {
    current: null
}, $64b8d2b03b5764eb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $64b8d2b03b5764eb$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$64b8d2b03b5764eb$var$J.call(b, d) && !$64b8d2b03b5764eb$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $64b8d2b03b5764eb$var$K.current
    };
}
function $64b8d2b03b5764eb$var$N(a, b) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $64b8d2b03b5764eb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $64b8d2b03b5764eb$var$l;
}
function $64b8d2b03b5764eb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $64b8d2b03b5764eb$var$P = /\/+/g;
function $64b8d2b03b5764eb$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $64b8d2b03b5764eb$var$escape("" + a.key) : b.toString(36);
}
function $64b8d2b03b5764eb$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $64b8d2b03b5764eb$var$l:
                case $64b8d2b03b5764eb$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $64b8d2b03b5764eb$var$Q(h, 0) : d, $64b8d2b03b5764eb$var$I(c) ? (e = "", null != a && (e = a.replace($64b8d2b03b5764eb$var$P, "$&/") + "/"), $64b8d2b03b5764eb$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($64b8d2b03b5764eb$var$O(c) && (c = $64b8d2b03b5764eb$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($64b8d2b03b5764eb$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($64b8d2b03b5764eb$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $64b8d2b03b5764eb$var$Q(k, g);
        h += $64b8d2b03b5764eb$var$R(k, b, e, f, c);
    }
    else if (f = $64b8d2b03b5764eb$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $64b8d2b03b5764eb$var$Q(k, g++), h += $64b8d2b03b5764eb$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $64b8d2b03b5764eb$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $64b8d2b03b5764eb$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $64b8d2b03b5764eb$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $64b8d2b03b5764eb$var$U = {
    current: null
}, $64b8d2b03b5764eb$var$V = {
    transition: null
}, $64b8d2b03b5764eb$var$W = {
    ReactCurrentDispatcher: $64b8d2b03b5764eb$var$U,
    ReactCurrentBatchConfig: $64b8d2b03b5764eb$var$V,
    ReactCurrentOwner: $64b8d2b03b5764eb$var$K
};
$64b8d2b03b5764eb$export$dca3b0875bd9a954 = {
    map: $64b8d2b03b5764eb$var$S,
    forEach: function(a, b, e) {
        $64b8d2b03b5764eb$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $64b8d2b03b5764eb$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $64b8d2b03b5764eb$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$64b8d2b03b5764eb$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$64b8d2b03b5764eb$export$16fa2f45be04daa8 = $64b8d2b03b5764eb$var$E;
$64b8d2b03b5764eb$export$ffb0004e005737fa = $64b8d2b03b5764eb$var$p;
$64b8d2b03b5764eb$export$e2c29f18771995cb = $64b8d2b03b5764eb$var$r;
$64b8d2b03b5764eb$export$221d75b3f55bb0bd = $64b8d2b03b5764eb$var$G;
$64b8d2b03b5764eb$export$5f8d39834fd61797 = $64b8d2b03b5764eb$var$q;
$64b8d2b03b5764eb$export$74bf444e3cd11ea5 = $64b8d2b03b5764eb$var$w;
$64b8d2b03b5764eb$export$ae55be85d98224ed = $64b8d2b03b5764eb$var$W;
$64b8d2b03b5764eb$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $64b8d2b03b5764eb$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $64b8d2b03b5764eb$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$64b8d2b03b5764eb$var$J.call(b, f) && !$64b8d2b03b5764eb$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$64b8d2b03b5764eb$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $64b8d2b03b5764eb$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $64b8d2b03b5764eb$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$64b8d2b03b5764eb$export$c8a8987d4410bf2d = $64b8d2b03b5764eb$var$M;
$64b8d2b03b5764eb$export$d38cd72104c1f0e9 = function(a) {
    var b = $64b8d2b03b5764eb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$64b8d2b03b5764eb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$64b8d2b03b5764eb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$v,
        render: a
    };
};
$64b8d2b03b5764eb$export$a8257692ac88316c = $64b8d2b03b5764eb$var$O;
$64b8d2b03b5764eb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $64b8d2b03b5764eb$var$T
    };
};
$64b8d2b03b5764eb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$64b8d2b03b5764eb$export$7568632d0d33d16d = function(a) {
    var b = $64b8d2b03b5764eb$var$V.transition;
    $64b8d2b03b5764eb$var$V.transition = {};
    try {
        a();
    } finally{
        $64b8d2b03b5764eb$var$V.transition = b;
    }
};
$64b8d2b03b5764eb$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$64b8d2b03b5764eb$export$35808ee640e87ca7 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useCallback(a, b);
};
$64b8d2b03b5764eb$export$fae74005e78b1a27 = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useContext(a);
};
$64b8d2b03b5764eb$export$dc8fbce3eb94dc1e = function() {};
$64b8d2b03b5764eb$export$6a7bc4e911dc01cf = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useDeferredValue(a);
};
$64b8d2b03b5764eb$export$6d9c69b0de29b591 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useEffect(a, b);
};
$64b8d2b03b5764eb$export$f680877a34711e37 = function() {
    return $64b8d2b03b5764eb$var$U.current.useId();
};
$64b8d2b03b5764eb$export$d5a552a76deda3c2 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useImperativeHandle(a, b, e);
};
$64b8d2b03b5764eb$export$aaabe4eda9ed9969 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useInsertionEffect(a, b);
};
$64b8d2b03b5764eb$export$e5c5a5f917a5871c = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useLayoutEffect(a, b);
};
$64b8d2b03b5764eb$export$1538c33de8887b59 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useMemo(a, b);
};
$64b8d2b03b5764eb$export$13e3392192263954 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useReducer(a, b, e);
};
$64b8d2b03b5764eb$export$b8f5890fc79d6aca = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useRef(a);
};
$64b8d2b03b5764eb$export$60241385465d0a34 = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useState(a);
};
$64b8d2b03b5764eb$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useSyncExternalStore(a, b, e);
};
$64b8d2b03b5764eb$export$7b286972b8d8ccbf = function() {
    return $64b8d2b03b5764eb$var$U.current.useTransition();
};
$64b8d2b03b5764eb$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("f2Jil", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $af3a2d87ccb15d29$export$ae55be85d98224ed, (v) => $af3a2d87ccb15d29$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $af3a2d87ccb15d29$export$d39a5bbd09211389, (v) => $af3a2d87ccb15d29$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $af3a2d87ccb15d29$export$882461b6382ed46c, (v) => $af3a2d87ccb15d29$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $af3a2d87ccb15d29$export$466bfc07425424d5, (v) => $af3a2d87ccb15d29$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $af3a2d87ccb15d29$export$cd75ccfd720a3cd4, (v) => $af3a2d87ccb15d29$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $af3a2d87ccb15d29$export$fa8d919ba61d84db, (v) => $af3a2d87ccb15d29$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $af3a2d87ccb15d29$export$757ceba2d55c277e, (v) => $af3a2d87ccb15d29$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $af3a2d87ccb15d29$export$b3890eb0ae9dca99, (v) => $af3a2d87ccb15d29$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $af3a2d87ccb15d29$export$502457920280e6be, (v) => $af3a2d87ccb15d29$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $af3a2d87ccb15d29$export$c78a37762a8d58e1, (v) => $af3a2d87ccb15d29$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $af3a2d87ccb15d29$export$dc54d992c10e8a18, (v) => $af3a2d87ccb15d29$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $af3a2d87ccb15d29$export$83d89fbfd8236492, (v) => $af3a2d87ccb15d29$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $af3a2d87ccb15d29$export$ae55be85d98224ed;
var $af3a2d87ccb15d29$export$d39a5bbd09211389;
var $af3a2d87ccb15d29$export$882461b6382ed46c;
var $af3a2d87ccb15d29$export$466bfc07425424d5;
var $af3a2d87ccb15d29$export$cd75ccfd720a3cd4;
var $af3a2d87ccb15d29$export$fa8d919ba61d84db;
var $af3a2d87ccb15d29$export$757ceba2d55c277e;
var $af3a2d87ccb15d29$export$b3890eb0ae9dca99;
var $af3a2d87ccb15d29$export$502457920280e6be;
var $af3a2d87ccb15d29$export$c78a37762a8d58e1;
var $af3a2d87ccb15d29$export$dc54d992c10e8a18;
var $af3a2d87ccb15d29$export$83d89fbfd8236492;
"use strict";

var $lx97N = parcelRequire("lx97N");

var $7DCHO = parcelRequire("7DCHO");
function $af3a2d87ccb15d29$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $af3a2d87ccb15d29$var$da = new Set, $af3a2d87ccb15d29$var$ea = {};
function $af3a2d87ccb15d29$var$fa(a, b) {
    $af3a2d87ccb15d29$var$ha(a, b);
    $af3a2d87ccb15d29$var$ha(a + "Capture", b);
}
function $af3a2d87ccb15d29$var$ha(a, b) {
    $af3a2d87ccb15d29$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$af3a2d87ccb15d29$var$da.add(b[a]);
}
var $af3a2d87ccb15d29$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $af3a2d87ccb15d29$var$ja = Object.prototype.hasOwnProperty, $af3a2d87ccb15d29$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $af3a2d87ccb15d29$var$la = {}, $af3a2d87ccb15d29$var$ma = {};
function $af3a2d87ccb15d29$var$oa(a) {
    if ($af3a2d87ccb15d29$var$ja.call($af3a2d87ccb15d29$var$ma, a)) return !0;
    if ($af3a2d87ccb15d29$var$ja.call($af3a2d87ccb15d29$var$la, a)) return !1;
    if ($af3a2d87ccb15d29$var$ka.test(a)) return $af3a2d87ccb15d29$var$ma[a] = !0;
    $af3a2d87ccb15d29$var$la[a] = !0;
    return !1;
}
function $af3a2d87ccb15d29$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $af3a2d87ccb15d29$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $af3a2d87ccb15d29$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $af3a2d87ccb15d29$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $af3a2d87ccb15d29$var$ra = /[\-:]([a-z])/g;
function $af3a2d87ccb15d29$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$af3a2d87ccb15d29$var$z.xlinkHref = new $af3a2d87ccb15d29$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $af3a2d87ccb15d29$var$ta(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$z.hasOwnProperty(b) ? $af3a2d87ccb15d29$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $af3a2d87ccb15d29$var$qa(b, c, e, d) && (c = null), d || null === e ? $af3a2d87ccb15d29$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $af3a2d87ccb15d29$var$ua = $lx97N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $af3a2d87ccb15d29$var$va = Symbol.for("react.element"), $af3a2d87ccb15d29$var$wa = Symbol.for("react.portal"), $af3a2d87ccb15d29$var$ya = Symbol.for("react.fragment"), $af3a2d87ccb15d29$var$za = Symbol.for("react.strict_mode"), $af3a2d87ccb15d29$var$Aa = Symbol.for("react.profiler"), $af3a2d87ccb15d29$var$Ba = Symbol.for("react.provider"), $af3a2d87ccb15d29$var$Ca = Symbol.for("react.context"), $af3a2d87ccb15d29$var$Da = Symbol.for("react.forward_ref"), $af3a2d87ccb15d29$var$Ea = Symbol.for("react.suspense"), $af3a2d87ccb15d29$var$Fa = Symbol.for("react.suspense_list"), $af3a2d87ccb15d29$var$Ga = Symbol.for("react.memo"), $af3a2d87ccb15d29$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $af3a2d87ccb15d29$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $af3a2d87ccb15d29$var$Ja = Symbol.iterator;
function $af3a2d87ccb15d29$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $af3a2d87ccb15d29$var$Ja && a[$af3a2d87ccb15d29$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $af3a2d87ccb15d29$var$A = Object.assign, $af3a2d87ccb15d29$var$La;
function $af3a2d87ccb15d29$var$Ma(a) {
    if (void 0 === $af3a2d87ccb15d29$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $af3a2d87ccb15d29$var$La = b && b[1] || "";
    }
    return "\n" + $af3a2d87ccb15d29$var$La + a;
}
var $af3a2d87ccb15d29$var$Na = !1;
function $af3a2d87ccb15d29$var$Oa(a, b) {
    if (!a || $af3a2d87ccb15d29$var$Na) return "";
    $af3a2d87ccb15d29$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $af3a2d87ccb15d29$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $af3a2d87ccb15d29$var$Ma(a) : "";
}
function $af3a2d87ccb15d29$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $af3a2d87ccb15d29$var$Ma(a.type);
        case 16:
            return $af3a2d87ccb15d29$var$Ma("Lazy");
        case 13:
            return $af3a2d87ccb15d29$var$Ma("Suspense");
        case 19:
            return $af3a2d87ccb15d29$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $af3a2d87ccb15d29$var$Oa(a.type, !1), a;
        case 11:
            return a = $af3a2d87ccb15d29$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $af3a2d87ccb15d29$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $af3a2d87ccb15d29$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $af3a2d87ccb15d29$var$ya:
            return "Fragment";
        case $af3a2d87ccb15d29$var$wa:
            return "Portal";
        case $af3a2d87ccb15d29$var$Aa:
            return "Profiler";
        case $af3a2d87ccb15d29$var$za:
            return "StrictMode";
        case $af3a2d87ccb15d29$var$Ea:
            return "Suspense";
        case $af3a2d87ccb15d29$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $af3a2d87ccb15d29$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $af3a2d87ccb15d29$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $af3a2d87ccb15d29$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $af3a2d87ccb15d29$var$Ga:
            return b = a.displayName || null, null !== b ? b : $af3a2d87ccb15d29$var$Qa(a.type) || "Memo";
        case $af3a2d87ccb15d29$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $af3a2d87ccb15d29$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $af3a2d87ccb15d29$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $af3a2d87ccb15d29$var$Qa(b);
        case 8:
            return b === $af3a2d87ccb15d29$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $af3a2d87ccb15d29$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $af3a2d87ccb15d29$var$Ua(a) {
    var b = $af3a2d87ccb15d29$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $af3a2d87ccb15d29$var$Va(a) {
    a._valueTracker || (a._valueTracker = $af3a2d87ccb15d29$var$Ua(a));
}
function $af3a2d87ccb15d29$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $af3a2d87ccb15d29$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $af3a2d87ccb15d29$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $af3a2d87ccb15d29$var$Ya(a, b) {
    var c = b.checked;
    return $af3a2d87ccb15d29$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $af3a2d87ccb15d29$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $af3a2d87ccb15d29$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $af3a2d87ccb15d29$var$ab(a, b) {
    b = b.checked;
    null != b && $af3a2d87ccb15d29$var$ta(a, "checked", b, !1);
}
function $af3a2d87ccb15d29$var$bb(a, b) {
    $af3a2d87ccb15d29$var$ab(a, b);
    var c = $af3a2d87ccb15d29$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $af3a2d87ccb15d29$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $af3a2d87ccb15d29$var$cb(a, b.type, $af3a2d87ccb15d29$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $af3a2d87ccb15d29$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $af3a2d87ccb15d29$var$cb(a, b, c) {
    if ("number" !== b || $af3a2d87ccb15d29$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $af3a2d87ccb15d29$var$eb = Array.isArray;
function $af3a2d87ccb15d29$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $af3a2d87ccb15d29$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $af3a2d87ccb15d29$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($af3a2d87ccb15d29$var$p(91));
    return $af3a2d87ccb15d29$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $af3a2d87ccb15d29$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($af3a2d87ccb15d29$var$p(92));
            if ($af3a2d87ccb15d29$var$eb(c)) {
                if (1 < c.length) throw Error($af3a2d87ccb15d29$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $af3a2d87ccb15d29$var$Sa(c)
    };
}
function $af3a2d87ccb15d29$var$ib(a, b) {
    var c = $af3a2d87ccb15d29$var$Sa(b.value), d = $af3a2d87ccb15d29$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $af3a2d87ccb15d29$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $af3a2d87ccb15d29$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $af3a2d87ccb15d29$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $af3a2d87ccb15d29$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $af3a2d87ccb15d29$var$mb, $af3a2d87ccb15d29$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $af3a2d87ccb15d29$var$mb = $af3a2d87ccb15d29$var$mb || document.createElement("div");
        $af3a2d87ccb15d29$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $af3a2d87ccb15d29$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $af3a2d87ccb15d29$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $af3a2d87ccb15d29$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $af3a2d87ccb15d29$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($af3a2d87ccb15d29$var$pb).forEach(function(a) {
    $af3a2d87ccb15d29$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $af3a2d87ccb15d29$var$pb[b] = $af3a2d87ccb15d29$var$pb[a];
    });
});
function $af3a2d87ccb15d29$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $af3a2d87ccb15d29$var$pb.hasOwnProperty(a) && $af3a2d87ccb15d29$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $af3a2d87ccb15d29$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $af3a2d87ccb15d29$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $af3a2d87ccb15d29$var$tb = $af3a2d87ccb15d29$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $af3a2d87ccb15d29$var$ub(a, b) {
    if (b) {
        if ($af3a2d87ccb15d29$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($af3a2d87ccb15d29$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($af3a2d87ccb15d29$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($af3a2d87ccb15d29$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($af3a2d87ccb15d29$var$p(62));
    }
}
function $af3a2d87ccb15d29$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $af3a2d87ccb15d29$var$wb = null;
function $af3a2d87ccb15d29$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $af3a2d87ccb15d29$var$yb = null, $af3a2d87ccb15d29$var$zb = null, $af3a2d87ccb15d29$var$Ab = null;
function $af3a2d87ccb15d29$var$Bb(a) {
    if (a = $af3a2d87ccb15d29$var$Cb(a)) {
        if ("function" !== typeof $af3a2d87ccb15d29$var$yb) throw Error($af3a2d87ccb15d29$var$p(280));
        var b = a.stateNode;
        b && (b = $af3a2d87ccb15d29$var$Db(b), $af3a2d87ccb15d29$var$yb(a.stateNode, a.type, b));
    }
}
function $af3a2d87ccb15d29$var$Eb(a) {
    $af3a2d87ccb15d29$var$zb ? $af3a2d87ccb15d29$var$Ab ? $af3a2d87ccb15d29$var$Ab.push(a) : $af3a2d87ccb15d29$var$Ab = [
        a
    ] : $af3a2d87ccb15d29$var$zb = a;
}
function $af3a2d87ccb15d29$var$Fb() {
    if ($af3a2d87ccb15d29$var$zb) {
        var a = $af3a2d87ccb15d29$var$zb, b = $af3a2d87ccb15d29$var$Ab;
        $af3a2d87ccb15d29$var$Ab = $af3a2d87ccb15d29$var$zb = null;
        $af3a2d87ccb15d29$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$af3a2d87ccb15d29$var$Bb(b[a]);
    }
}
function $af3a2d87ccb15d29$var$Gb(a, b) {
    return a(b);
}
function $af3a2d87ccb15d29$var$Hb() {}
var $af3a2d87ccb15d29$var$Ib = !1;
function $af3a2d87ccb15d29$var$Jb(a, b, c) {
    if ($af3a2d87ccb15d29$var$Ib) return a(b, c);
    $af3a2d87ccb15d29$var$Ib = !0;
    try {
        return $af3a2d87ccb15d29$var$Gb(a, b, c);
    } finally{
        if ($af3a2d87ccb15d29$var$Ib = !1, null !== $af3a2d87ccb15d29$var$zb || null !== $af3a2d87ccb15d29$var$Ab) $af3a2d87ccb15d29$var$Hb(), $af3a2d87ccb15d29$var$Fb();
    }
}
function $af3a2d87ccb15d29$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $af3a2d87ccb15d29$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($af3a2d87ccb15d29$var$p(231, b, typeof c));
    return c;
}
var $af3a2d87ccb15d29$var$Lb = !1;
if ($af3a2d87ccb15d29$var$ia) try {
    var $af3a2d87ccb15d29$var$Mb = {};
    Object.defineProperty($af3a2d87ccb15d29$var$Mb, "passive", {
        get: function() {
            $af3a2d87ccb15d29$var$Lb = !0;
        }
    });
    window.addEventListener("test", $af3a2d87ccb15d29$var$Mb, $af3a2d87ccb15d29$var$Mb);
    window.removeEventListener("test", $af3a2d87ccb15d29$var$Mb, $af3a2d87ccb15d29$var$Mb);
} catch (a) {
    $af3a2d87ccb15d29$var$Lb = !1;
}
function $af3a2d87ccb15d29$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $af3a2d87ccb15d29$var$Ob = !1, $af3a2d87ccb15d29$var$Pb = null, $af3a2d87ccb15d29$var$Qb = !1, $af3a2d87ccb15d29$var$Rb = null, $af3a2d87ccb15d29$var$Sb = {
    onError: function(a) {
        $af3a2d87ccb15d29$var$Ob = !0;
        $af3a2d87ccb15d29$var$Pb = a;
    }
};
function $af3a2d87ccb15d29$var$Tb(a, b, c, d, e, f, g, h, k) {
    $af3a2d87ccb15d29$var$Ob = !1;
    $af3a2d87ccb15d29$var$Pb = null;
    $af3a2d87ccb15d29$var$Nb.apply($af3a2d87ccb15d29$var$Sb, arguments);
}
function $af3a2d87ccb15d29$var$Ub(a, b, c, d, e, f, g, h, k) {
    $af3a2d87ccb15d29$var$Tb.apply(this, arguments);
    if ($af3a2d87ccb15d29$var$Ob) {
        if ($af3a2d87ccb15d29$var$Ob) {
            var l = $af3a2d87ccb15d29$var$Pb;
            $af3a2d87ccb15d29$var$Ob = !1;
            $af3a2d87ccb15d29$var$Pb = null;
        } else throw Error($af3a2d87ccb15d29$var$p(198));
        $af3a2d87ccb15d29$var$Qb || ($af3a2d87ccb15d29$var$Qb = !0, $af3a2d87ccb15d29$var$Rb = l);
    }
}
function $af3a2d87ccb15d29$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $af3a2d87ccb15d29$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Xb(a) {
    if ($af3a2d87ccb15d29$var$Vb(a) !== a) throw Error($af3a2d87ccb15d29$var$p(188));
}
function $af3a2d87ccb15d29$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $af3a2d87ccb15d29$var$Vb(a);
        if (null === b) throw Error($af3a2d87ccb15d29$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $af3a2d87ccb15d29$var$Xb(e), a;
                if (f === d) return $af3a2d87ccb15d29$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($af3a2d87ccb15d29$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($af3a2d87ccb15d29$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($af3a2d87ccb15d29$var$p(190));
    }
    if (3 !== c.tag) throw Error($af3a2d87ccb15d29$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $af3a2d87ccb15d29$var$Zb(a) {
    a = $af3a2d87ccb15d29$var$Yb(a);
    return null !== a ? $af3a2d87ccb15d29$var$$b(a) : null;
}
function $af3a2d87ccb15d29$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $af3a2d87ccb15d29$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$ac = $7DCHO.unstable_scheduleCallback, $af3a2d87ccb15d29$var$bc = $7DCHO.unstable_cancelCallback, $af3a2d87ccb15d29$var$cc = $7DCHO.unstable_shouldYield, $af3a2d87ccb15d29$var$dc = $7DCHO.unstable_requestPaint, $af3a2d87ccb15d29$var$B = $7DCHO.unstable_now, $af3a2d87ccb15d29$var$ec = $7DCHO.unstable_getCurrentPriorityLevel, $af3a2d87ccb15d29$var$fc = $7DCHO.unstable_ImmediatePriority, $af3a2d87ccb15d29$var$gc = $7DCHO.unstable_UserBlockingPriority, $af3a2d87ccb15d29$var$hc = $7DCHO.unstable_NormalPriority, $af3a2d87ccb15d29$var$ic = $7DCHO.unstable_LowPriority, $af3a2d87ccb15d29$var$jc = $7DCHO.unstable_IdlePriority, $af3a2d87ccb15d29$var$kc = null, $af3a2d87ccb15d29$var$lc = null;
function $af3a2d87ccb15d29$var$mc(a) {
    if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onCommitFiberRoot) try {
        $af3a2d87ccb15d29$var$lc.onCommitFiberRoot($af3a2d87ccb15d29$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $af3a2d87ccb15d29$var$oc = Math.clz32 ? Math.clz32 : $af3a2d87ccb15d29$var$nc, $af3a2d87ccb15d29$var$pc = Math.log, $af3a2d87ccb15d29$var$qc = Math.LN2;
function $af3a2d87ccb15d29$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($af3a2d87ccb15d29$var$pc(a) / $af3a2d87ccb15d29$var$qc | 0) | 0;
}
var $af3a2d87ccb15d29$var$rc = 64, $af3a2d87ccb15d29$var$sc = 4194304;
function $af3a2d87ccb15d29$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $af3a2d87ccb15d29$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $af3a2d87ccb15d29$var$tc(h) : (f &= g, 0 !== f && (d = $af3a2d87ccb15d29$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $af3a2d87ccb15d29$var$tc(g) : 0 !== f && (d = $af3a2d87ccb15d29$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $af3a2d87ccb15d29$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $af3a2d87ccb15d29$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $af3a2d87ccb15d29$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $af3a2d87ccb15d29$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $af3a2d87ccb15d29$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $af3a2d87ccb15d29$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $af3a2d87ccb15d29$var$yc() {
    var a = $af3a2d87ccb15d29$var$rc;
    $af3a2d87ccb15d29$var$rc <<= 1;
    0 === ($af3a2d87ccb15d29$var$rc & 4194240) && ($af3a2d87ccb15d29$var$rc = 64);
    return a;
}
function $af3a2d87ccb15d29$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $af3a2d87ccb15d29$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $af3a2d87ccb15d29$var$oc(b);
    a[b] = c;
}
function $af3a2d87ccb15d29$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $af3a2d87ccb15d29$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $af3a2d87ccb15d29$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $af3a2d87ccb15d29$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $af3a2d87ccb15d29$var$C = 0;
function $af3a2d87ccb15d29$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $af3a2d87ccb15d29$var$Ec, $af3a2d87ccb15d29$var$Fc, $af3a2d87ccb15d29$var$Gc, $af3a2d87ccb15d29$var$Hc, $af3a2d87ccb15d29$var$Ic, $af3a2d87ccb15d29$var$Jc = !1, $af3a2d87ccb15d29$var$Kc = [], $af3a2d87ccb15d29$var$Lc = null, $af3a2d87ccb15d29$var$Mc = null, $af3a2d87ccb15d29$var$Nc = null, $af3a2d87ccb15d29$var$Oc = new Map, $af3a2d87ccb15d29$var$Pc = new Map, $af3a2d87ccb15d29$var$Qc = [], $af3a2d87ccb15d29$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $af3a2d87ccb15d29$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $af3a2d87ccb15d29$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $af3a2d87ccb15d29$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $af3a2d87ccb15d29$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $af3a2d87ccb15d29$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $af3a2d87ccb15d29$var$Pc.delete(b.pointerId);
    }
}
function $af3a2d87ccb15d29$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $af3a2d87ccb15d29$var$Cb(b), null !== b && $af3a2d87ccb15d29$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $af3a2d87ccb15d29$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $af3a2d87ccb15d29$var$Lc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $af3a2d87ccb15d29$var$Mc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $af3a2d87ccb15d29$var$Nc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $af3a2d87ccb15d29$var$Oc.set(f, $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $af3a2d87ccb15d29$var$Pc.set(f, $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $af3a2d87ccb15d29$var$Vc(a) {
    var b = $af3a2d87ccb15d29$var$Wc(a.target);
    if (null !== b) {
        var c = $af3a2d87ccb15d29$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $af3a2d87ccb15d29$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $af3a2d87ccb15d29$var$Ic(a.priority, function() {
                        $af3a2d87ccb15d29$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $af3a2d87ccb15d29$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $af3a2d87ccb15d29$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $af3a2d87ccb15d29$var$wb = d;
            c.target.dispatchEvent(d);
            $af3a2d87ccb15d29$var$wb = null;
        } else return b = $af3a2d87ccb15d29$var$Cb(c), null !== b && $af3a2d87ccb15d29$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Zc(a, b, c) {
    $af3a2d87ccb15d29$var$Xc(a) && c.delete(b);
}
function $af3a2d87ccb15d29$var$$c() {
    $af3a2d87ccb15d29$var$Jc = !1;
    null !== $af3a2d87ccb15d29$var$Lc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Lc) && ($af3a2d87ccb15d29$var$Lc = null);
    null !== $af3a2d87ccb15d29$var$Mc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Mc) && ($af3a2d87ccb15d29$var$Mc = null);
    null !== $af3a2d87ccb15d29$var$Nc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Nc) && ($af3a2d87ccb15d29$var$Nc = null);
    $af3a2d87ccb15d29$var$Oc.forEach($af3a2d87ccb15d29$var$Zc);
    $af3a2d87ccb15d29$var$Pc.forEach($af3a2d87ccb15d29$var$Zc);
}
function $af3a2d87ccb15d29$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $af3a2d87ccb15d29$var$Jc || ($af3a2d87ccb15d29$var$Jc = !0, $7DCHO.unstable_scheduleCallback($7DCHO.unstable_NormalPriority, $af3a2d87ccb15d29$var$$c)));
}
function $af3a2d87ccb15d29$var$bd(a) {
    function b(b) {
        return $af3a2d87ccb15d29$var$ad(b, a);
    }
    if (0 < $af3a2d87ccb15d29$var$Kc.length) {
        $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Kc[0], a);
        for(var c = 1; c < $af3a2d87ccb15d29$var$Kc.length; c++){
            var d = $af3a2d87ccb15d29$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $af3a2d87ccb15d29$var$Lc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Lc, a);
    null !== $af3a2d87ccb15d29$var$Mc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Mc, a);
    null !== $af3a2d87ccb15d29$var$Nc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Nc, a);
    $af3a2d87ccb15d29$var$Oc.forEach(b);
    $af3a2d87ccb15d29$var$Pc.forEach(b);
    for(c = 0; c < $af3a2d87ccb15d29$var$Qc.length; c++)d = $af3a2d87ccb15d29$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $af3a2d87ccb15d29$var$Qc.length && (c = $af3a2d87ccb15d29$var$Qc[0], null === c.blockedOn);)$af3a2d87ccb15d29$var$Vc(c), null === c.blockedOn && $af3a2d87ccb15d29$var$Qc.shift();
}
var $af3a2d87ccb15d29$var$cd = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$dd = !0;
function $af3a2d87ccb15d29$var$ed(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$C, f = $af3a2d87ccb15d29$var$cd.transition;
    $af3a2d87ccb15d29$var$cd.transition = null;
    try {
        $af3a2d87ccb15d29$var$C = 1, $af3a2d87ccb15d29$var$fd(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$C = e, $af3a2d87ccb15d29$var$cd.transition = f;
    }
}
function $af3a2d87ccb15d29$var$gd(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$C, f = $af3a2d87ccb15d29$var$cd.transition;
    $af3a2d87ccb15d29$var$cd.transition = null;
    try {
        $af3a2d87ccb15d29$var$C = 4, $af3a2d87ccb15d29$var$fd(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$C = e, $af3a2d87ccb15d29$var$cd.transition = f;
    }
}
function $af3a2d87ccb15d29$var$fd(a, b, c, d) {
    if ($af3a2d87ccb15d29$var$dd) {
        var e = $af3a2d87ccb15d29$var$Yc(a, b, c, d);
        if (null === e) $af3a2d87ccb15d29$var$hd(a, b, d, $af3a2d87ccb15d29$var$id, c), $af3a2d87ccb15d29$var$Sc(a, d);
        else if ($af3a2d87ccb15d29$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($af3a2d87ccb15d29$var$Sc(a, d), b & 4 && -1 < $af3a2d87ccb15d29$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $af3a2d87ccb15d29$var$Cb(e);
                null !== f && $af3a2d87ccb15d29$var$Ec(f);
                f = $af3a2d87ccb15d29$var$Yc(a, b, c, d);
                null === f && $af3a2d87ccb15d29$var$hd(a, b, d, $af3a2d87ccb15d29$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $af3a2d87ccb15d29$var$hd(a, b, d, null, c);
    }
}
var $af3a2d87ccb15d29$var$id = null;
function $af3a2d87ccb15d29$var$Yc(a, b, c, d) {
    $af3a2d87ccb15d29$var$id = null;
    a = $af3a2d87ccb15d29$var$xb(d);
    a = $af3a2d87ccb15d29$var$Wc(a);
    if (null !== a) {
        if (b = $af3a2d87ccb15d29$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $af3a2d87ccb15d29$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $af3a2d87ccb15d29$var$id = a;
    return null;
}
function $af3a2d87ccb15d29$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($af3a2d87ccb15d29$var$ec()){
                case $af3a2d87ccb15d29$var$fc:
                    return 1;
                case $af3a2d87ccb15d29$var$gc:
                    return 4;
                case $af3a2d87ccb15d29$var$hc:
                case $af3a2d87ccb15d29$var$ic:
                    return 16;
                case $af3a2d87ccb15d29$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $af3a2d87ccb15d29$var$kd = null, $af3a2d87ccb15d29$var$ld = null, $af3a2d87ccb15d29$var$md = null;
function $af3a2d87ccb15d29$var$nd() {
    if ($af3a2d87ccb15d29$var$md) return $af3a2d87ccb15d29$var$md;
    var a, b = $af3a2d87ccb15d29$var$ld, c = b.length, d, e = "value" in $af3a2d87ccb15d29$var$kd ? $af3a2d87ccb15d29$var$kd.value : $af3a2d87ccb15d29$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $af3a2d87ccb15d29$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $af3a2d87ccb15d29$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $af3a2d87ccb15d29$var$pd() {
    return !0;
}
function $af3a2d87ccb15d29$var$qd() {
    return !1;
}
function $af3a2d87ccb15d29$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $af3a2d87ccb15d29$var$pd : $af3a2d87ccb15d29$var$qd;
        this.isPropagationStopped = $af3a2d87ccb15d29$var$qd;
        return this;
    }
    $af3a2d87ccb15d29$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $af3a2d87ccb15d29$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $af3a2d87ccb15d29$var$pd);
        },
        persist: function() {},
        isPersistent: $af3a2d87ccb15d29$var$pd
    });
    return b;
}
var $af3a2d87ccb15d29$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $af3a2d87ccb15d29$var$td = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$sd), $af3a2d87ccb15d29$var$ud = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    view: 0,
    detail: 0
}), $af3a2d87ccb15d29$var$vd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$ud), $af3a2d87ccb15d29$var$wd, $af3a2d87ccb15d29$var$xd, $af3a2d87ccb15d29$var$yd, $af3a2d87ccb15d29$var$Ad = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $af3a2d87ccb15d29$var$yd && ($af3a2d87ccb15d29$var$yd && "mousemove" === a.type ? ($af3a2d87ccb15d29$var$wd = a.screenX - $af3a2d87ccb15d29$var$yd.screenX, $af3a2d87ccb15d29$var$xd = a.screenY - $af3a2d87ccb15d29$var$yd.screenY) : $af3a2d87ccb15d29$var$xd = $af3a2d87ccb15d29$var$wd = 0, $af3a2d87ccb15d29$var$yd = a);
        return $af3a2d87ccb15d29$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $af3a2d87ccb15d29$var$xd;
    }
}), $af3a2d87ccb15d29$var$Bd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ad), $af3a2d87ccb15d29$var$Cd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    dataTransfer: 0
}), $af3a2d87ccb15d29$var$Dd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Cd), $af3a2d87ccb15d29$var$Ed = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    relatedTarget: 0
}), $af3a2d87ccb15d29$var$Fd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ed), $af3a2d87ccb15d29$var$Gd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af3a2d87ccb15d29$var$Hd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Gd), $af3a2d87ccb15d29$var$Id = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $af3a2d87ccb15d29$var$Jd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Id), $af3a2d87ccb15d29$var$Kd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    data: 0
}), $af3a2d87ccb15d29$var$Ld = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Kd), $af3a2d87ccb15d29$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $af3a2d87ccb15d29$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $af3a2d87ccb15d29$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $af3a2d87ccb15d29$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $af3a2d87ccb15d29$var$Od[a]) ? !!b[a] : !1;
}
function $af3a2d87ccb15d29$var$zd() {
    return $af3a2d87ccb15d29$var$Pd;
}
var $af3a2d87ccb15d29$var$Qd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $af3a2d87ccb15d29$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $af3a2d87ccb15d29$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $af3a2d87ccb15d29$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $af3a2d87ccb15d29$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $af3a2d87ccb15d29$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $af3a2d87ccb15d29$var$Rd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Qd), $af3a2d87ccb15d29$var$Sd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $af3a2d87ccb15d29$var$Td = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Sd), $af3a2d87ccb15d29$var$Ud = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd
}), $af3a2d87ccb15d29$var$Vd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ud), $af3a2d87ccb15d29$var$Wd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af3a2d87ccb15d29$var$Xd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Wd), $af3a2d87ccb15d29$var$Yd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $af3a2d87ccb15d29$var$Zd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Yd), $af3a2d87ccb15d29$var$$d = [
    9,
    13,
    27,
    32
], $af3a2d87ccb15d29$var$ae = $af3a2d87ccb15d29$var$ia && "CompositionEvent" in window, $af3a2d87ccb15d29$var$be = null;
$af3a2d87ccb15d29$var$ia && "documentMode" in document && ($af3a2d87ccb15d29$var$be = document.documentMode);
var $af3a2d87ccb15d29$var$ce = $af3a2d87ccb15d29$var$ia && "TextEvent" in window && !$af3a2d87ccb15d29$var$be, $af3a2d87ccb15d29$var$de = $af3a2d87ccb15d29$var$ia && (!$af3a2d87ccb15d29$var$ae || $af3a2d87ccb15d29$var$be && 8 < $af3a2d87ccb15d29$var$be && 11 >= $af3a2d87ccb15d29$var$be), $af3a2d87ccb15d29$var$ee = String.fromCharCode(32), $af3a2d87ccb15d29$var$fe = !1;
function $af3a2d87ccb15d29$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $af3a2d87ccb15d29$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $af3a2d87ccb15d29$var$ie = !1;
function $af3a2d87ccb15d29$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $af3a2d87ccb15d29$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $af3a2d87ccb15d29$var$fe = !0;
            return $af3a2d87ccb15d29$var$ee;
        case "textInput":
            return a = b.data, a === $af3a2d87ccb15d29$var$ee && $af3a2d87ccb15d29$var$fe ? null : a;
        default:
            return null;
    }
}
function $af3a2d87ccb15d29$var$ke(a, b) {
    if ($af3a2d87ccb15d29$var$ie) return "compositionend" === a || !$af3a2d87ccb15d29$var$ae && $af3a2d87ccb15d29$var$ge(a, b) ? (a = $af3a2d87ccb15d29$var$nd(), $af3a2d87ccb15d29$var$md = $af3a2d87ccb15d29$var$ld = $af3a2d87ccb15d29$var$kd = null, $af3a2d87ccb15d29$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $af3a2d87ccb15d29$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $af3a2d87ccb15d29$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $af3a2d87ccb15d29$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$af3a2d87ccb15d29$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $af3a2d87ccb15d29$var$ne(a, b, c, d) {
    $af3a2d87ccb15d29$var$Eb(d);
    b = $af3a2d87ccb15d29$var$oe(b, "onChange");
    0 < b.length && (c = new $af3a2d87ccb15d29$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $af3a2d87ccb15d29$var$pe = null, $af3a2d87ccb15d29$var$qe = null;
function $af3a2d87ccb15d29$var$re(a) {
    $af3a2d87ccb15d29$var$se(a, 0);
}
function $af3a2d87ccb15d29$var$te(a) {
    var b = $af3a2d87ccb15d29$var$ue(a);
    if ($af3a2d87ccb15d29$var$Wa(b)) return a;
}
function $af3a2d87ccb15d29$var$ve(a, b) {
    if ("change" === a) return b;
}
var $af3a2d87ccb15d29$var$we = !1;
if ($af3a2d87ccb15d29$var$ia) {
    var $af3a2d87ccb15d29$var$xe;
    if ($af3a2d87ccb15d29$var$ia) {
        var $af3a2d87ccb15d29$var$ye = "oninput" in document;
        if (!$af3a2d87ccb15d29$var$ye) {
            var $af3a2d87ccb15d29$var$ze = document.createElement("div");
            $af3a2d87ccb15d29$var$ze.setAttribute("oninput", "return;");
            $af3a2d87ccb15d29$var$ye = "function" === typeof $af3a2d87ccb15d29$var$ze.oninput;
        }
        $af3a2d87ccb15d29$var$xe = $af3a2d87ccb15d29$var$ye;
    } else $af3a2d87ccb15d29$var$xe = !1;
    $af3a2d87ccb15d29$var$we = $af3a2d87ccb15d29$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $af3a2d87ccb15d29$var$Ae() {
    $af3a2d87ccb15d29$var$pe && ($af3a2d87ccb15d29$var$pe.detachEvent("onpropertychange", $af3a2d87ccb15d29$var$Be), $af3a2d87ccb15d29$var$qe = $af3a2d87ccb15d29$var$pe = null);
}
function $af3a2d87ccb15d29$var$Be(a) {
    if ("value" === a.propertyName && $af3a2d87ccb15d29$var$te($af3a2d87ccb15d29$var$qe)) {
        var b = [];
        $af3a2d87ccb15d29$var$ne(b, $af3a2d87ccb15d29$var$qe, a, $af3a2d87ccb15d29$var$xb(a));
        $af3a2d87ccb15d29$var$Jb($af3a2d87ccb15d29$var$re, b);
    }
}
function $af3a2d87ccb15d29$var$Ce(a, b, c) {
    "focusin" === a ? ($af3a2d87ccb15d29$var$Ae(), $af3a2d87ccb15d29$var$pe = b, $af3a2d87ccb15d29$var$qe = c, $af3a2d87ccb15d29$var$pe.attachEvent("onpropertychange", $af3a2d87ccb15d29$var$Be)) : "focusout" === a && $af3a2d87ccb15d29$var$Ae();
}
function $af3a2d87ccb15d29$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $af3a2d87ccb15d29$var$te($af3a2d87ccb15d29$var$qe);
}
function $af3a2d87ccb15d29$var$Ee(a, b) {
    if ("click" === a) return $af3a2d87ccb15d29$var$te(b);
}
function $af3a2d87ccb15d29$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $af3a2d87ccb15d29$var$te(b);
}
function $af3a2d87ccb15d29$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $af3a2d87ccb15d29$var$He = "function" === typeof Object.is ? Object.is : $af3a2d87ccb15d29$var$Ge;
function $af3a2d87ccb15d29$var$Ie(a, b) {
    if ($af3a2d87ccb15d29$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$af3a2d87ccb15d29$var$ja.call(b, e) || !$af3a2d87ccb15d29$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $af3a2d87ccb15d29$var$Ke(a, b) {
    var c = $af3a2d87ccb15d29$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $af3a2d87ccb15d29$var$Je(c);
    }
}
function $af3a2d87ccb15d29$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $af3a2d87ccb15d29$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $af3a2d87ccb15d29$var$Me() {
    for(var a = window, b = $af3a2d87ccb15d29$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $af3a2d87ccb15d29$var$Xa(a.document);
    }
    return b;
}
function $af3a2d87ccb15d29$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $af3a2d87ccb15d29$var$Oe(a) {
    var b = $af3a2d87ccb15d29$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $af3a2d87ccb15d29$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $af3a2d87ccb15d29$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $af3a2d87ccb15d29$var$Ke(c, f);
                var g = $af3a2d87ccb15d29$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $af3a2d87ccb15d29$var$Pe = $af3a2d87ccb15d29$var$ia && "documentMode" in document && 11 >= document.documentMode, $af3a2d87ccb15d29$var$Qe = null, $af3a2d87ccb15d29$var$Re = null, $af3a2d87ccb15d29$var$Se = null, $af3a2d87ccb15d29$var$Te = !1;
function $af3a2d87ccb15d29$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $af3a2d87ccb15d29$var$Te || null == $af3a2d87ccb15d29$var$Qe || $af3a2d87ccb15d29$var$Qe !== $af3a2d87ccb15d29$var$Xa(d) || (d = $af3a2d87ccb15d29$var$Qe, "selectionStart" in d && $af3a2d87ccb15d29$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $af3a2d87ccb15d29$var$Se && $af3a2d87ccb15d29$var$Ie($af3a2d87ccb15d29$var$Se, d) || ($af3a2d87ccb15d29$var$Se = d, d = $af3a2d87ccb15d29$var$oe($af3a2d87ccb15d29$var$Re, "onSelect"), 0 < d.length && (b = new $af3a2d87ccb15d29$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $af3a2d87ccb15d29$var$Qe)));
}
function $af3a2d87ccb15d29$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $af3a2d87ccb15d29$var$We = {
    animationend: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationIteration"),
    animationstart: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationStart"),
    transitionend: $af3a2d87ccb15d29$var$Ve("Transition", "TransitionEnd")
}, $af3a2d87ccb15d29$var$Xe = {}, $af3a2d87ccb15d29$var$Ye = {};
$af3a2d87ccb15d29$var$ia && ($af3a2d87ccb15d29$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $af3a2d87ccb15d29$var$We.animationend.animation, delete $af3a2d87ccb15d29$var$We.animationiteration.animation, delete $af3a2d87ccb15d29$var$We.animationstart.animation), "TransitionEvent" in window || delete $af3a2d87ccb15d29$var$We.transitionend.transition);
function $af3a2d87ccb15d29$var$Ze(a) {
    if ($af3a2d87ccb15d29$var$Xe[a]) return $af3a2d87ccb15d29$var$Xe[a];
    if (!$af3a2d87ccb15d29$var$We[a]) return a;
    var b = $af3a2d87ccb15d29$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $af3a2d87ccb15d29$var$Ye) return $af3a2d87ccb15d29$var$Xe[a] = b[c];
    return a;
}
var $af3a2d87ccb15d29$var$$e = $af3a2d87ccb15d29$var$Ze("animationend"), $af3a2d87ccb15d29$var$af = $af3a2d87ccb15d29$var$Ze("animationiteration"), $af3a2d87ccb15d29$var$bf = $af3a2d87ccb15d29$var$Ze("animationstart"), $af3a2d87ccb15d29$var$cf = $af3a2d87ccb15d29$var$Ze("transitionend"), $af3a2d87ccb15d29$var$df = new Map, $af3a2d87ccb15d29$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $af3a2d87ccb15d29$var$ff(a, b) {
    $af3a2d87ccb15d29$var$df.set(a, b);
    $af3a2d87ccb15d29$var$fa(b, [
        a
    ]);
}
for(var $af3a2d87ccb15d29$var$gf = 0; $af3a2d87ccb15d29$var$gf < $af3a2d87ccb15d29$var$ef.length; $af3a2d87ccb15d29$var$gf++){
    var $af3a2d87ccb15d29$var$hf = $af3a2d87ccb15d29$var$ef[$af3a2d87ccb15d29$var$gf], $af3a2d87ccb15d29$var$jf = $af3a2d87ccb15d29$var$hf.toLowerCase(), $af3a2d87ccb15d29$var$kf = $af3a2d87ccb15d29$var$hf[0].toUpperCase() + $af3a2d87ccb15d29$var$hf.slice(1);
    $af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$jf, "on" + $af3a2d87ccb15d29$var$kf);
}
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$$e, "onAnimationEnd");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$af, "onAnimationIteration");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$bf, "onAnimationStart");
$af3a2d87ccb15d29$var$ff("dblclick", "onDoubleClick");
$af3a2d87ccb15d29$var$ff("focusin", "onFocus");
$af3a2d87ccb15d29$var$ff("focusout", "onBlur");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$cf, "onTransitionEnd");
$af3a2d87ccb15d29$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$af3a2d87ccb15d29$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$af3a2d87ccb15d29$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$af3a2d87ccb15d29$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$af3a2d87ccb15d29$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$af3a2d87ccb15d29$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$af3a2d87ccb15d29$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$af3a2d87ccb15d29$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$af3a2d87ccb15d29$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$af3a2d87ccb15d29$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $af3a2d87ccb15d29$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $af3a2d87ccb15d29$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($af3a2d87ccb15d29$var$lf));
function $af3a2d87ccb15d29$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $af3a2d87ccb15d29$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $af3a2d87ccb15d29$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af3a2d87ccb15d29$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af3a2d87ccb15d29$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($af3a2d87ccb15d29$var$Qb) throw a = $af3a2d87ccb15d29$var$Rb, $af3a2d87ccb15d29$var$Qb = !1, $af3a2d87ccb15d29$var$Rb = null, a;
}
function $af3a2d87ccb15d29$var$D(a, b) {
    var c = b[$af3a2d87ccb15d29$var$of];
    void 0 === c && (c = b[$af3a2d87ccb15d29$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($af3a2d87ccb15d29$var$pf(b, a, 2, !1), c.add(d));
}
function $af3a2d87ccb15d29$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $af3a2d87ccb15d29$var$pf(c, a, d, b);
}
var $af3a2d87ccb15d29$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $af3a2d87ccb15d29$var$sf(a) {
    if (!a[$af3a2d87ccb15d29$var$rf]) {
        a[$af3a2d87ccb15d29$var$rf] = !0;
        $af3a2d87ccb15d29$var$da.forEach(function(b) {
            "selectionchange" !== b && ($af3a2d87ccb15d29$var$mf.has(b) || $af3a2d87ccb15d29$var$qf(b, !1, a), $af3a2d87ccb15d29$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$af3a2d87ccb15d29$var$rf] || (b[$af3a2d87ccb15d29$var$rf] = !0, $af3a2d87ccb15d29$var$qf("selectionchange", !1, b));
    }
}
function $af3a2d87ccb15d29$var$pf(a, b, c, d) {
    switch($af3a2d87ccb15d29$var$jd(b)){
        case 1:
            var e = $af3a2d87ccb15d29$var$ed;
            break;
        case 4:
            e = $af3a2d87ccb15d29$var$gd;
            break;
        default:
            e = $af3a2d87ccb15d29$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$af3a2d87ccb15d29$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $af3a2d87ccb15d29$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $af3a2d87ccb15d29$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $af3a2d87ccb15d29$var$Jb(function() {
        var d = f, e = $af3a2d87ccb15d29$var$xb(c), g = [];
        a: {
            var h = $af3a2d87ccb15d29$var$df.get(a);
            if (void 0 !== h) {
                var k = $af3a2d87ccb15d29$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $af3a2d87ccb15d29$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $af3a2d87ccb15d29$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $af3a2d87ccb15d29$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $af3a2d87ccb15d29$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $af3a2d87ccb15d29$var$Vd;
                        break;
                    case $af3a2d87ccb15d29$var$$e:
                    case $af3a2d87ccb15d29$var$af:
                    case $af3a2d87ccb15d29$var$bf:
                        k = $af3a2d87ccb15d29$var$Hd;
                        break;
                    case $af3a2d87ccb15d29$var$cf:
                        k = $af3a2d87ccb15d29$var$Xd;
                        break;
                    case "scroll":
                        k = $af3a2d87ccb15d29$var$vd;
                        break;
                    case "wheel":
                        k = $af3a2d87ccb15d29$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $af3a2d87ccb15d29$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $af3a2d87ccb15d29$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $af3a2d87ccb15d29$var$Kb(w, x), null != F && t.push($af3a2d87ccb15d29$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $af3a2d87ccb15d29$var$wb && (n = c.relatedTarget || c.fromElement) && ($af3a2d87ccb15d29$var$Wc(n) || n[$af3a2d87ccb15d29$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $af3a2d87ccb15d29$var$Wc(n) : null, null !== n && (J = $af3a2d87ccb15d29$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $af3a2d87ccb15d29$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $af3a2d87ccb15d29$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $af3a2d87ccb15d29$var$ue(k);
                        u = null == n ? h : $af3a2d87ccb15d29$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $af3a2d87ccb15d29$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $af3a2d87ccb15d29$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $af3a2d87ccb15d29$var$vf(F))u++;
                            for(; 0 < w - u;)t = $af3a2d87ccb15d29$var$vf(t), w--;
                            for(; 0 < u - w;)x = $af3a2d87ccb15d29$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $af3a2d87ccb15d29$var$vf(t);
                                x = $af3a2d87ccb15d29$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $af3a2d87ccb15d29$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $af3a2d87ccb15d29$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $af3a2d87ccb15d29$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $af3a2d87ccb15d29$var$ve;
                else if ($af3a2d87ccb15d29$var$me(h)) {
                    if ($af3a2d87ccb15d29$var$we) na = $af3a2d87ccb15d29$var$Fe;
                    else {
                        na = $af3a2d87ccb15d29$var$De;
                        var xa = $af3a2d87ccb15d29$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $af3a2d87ccb15d29$var$Ee);
                if (na && (na = na(a, d))) {
                    $af3a2d87ccb15d29$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $af3a2d87ccb15d29$var$cb(h, "number", h.value);
            }
            xa = d ? $af3a2d87ccb15d29$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($af3a2d87ccb15d29$var$me(xa) || "true" === xa.contentEditable) $af3a2d87ccb15d29$var$Qe = xa, $af3a2d87ccb15d29$var$Re = d, $af3a2d87ccb15d29$var$Se = null;
                    break;
                case "focusout":
                    $af3a2d87ccb15d29$var$Se = $af3a2d87ccb15d29$var$Re = $af3a2d87ccb15d29$var$Qe = null;
                    break;
                case "mousedown":
                    $af3a2d87ccb15d29$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $af3a2d87ccb15d29$var$Te = !1;
                    $af3a2d87ccb15d29$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($af3a2d87ccb15d29$var$Pe) break;
                case "keydown":
                case "keyup":
                    $af3a2d87ccb15d29$var$Ue(g, c, e);
            }
            var $a;
            if ($af3a2d87ccb15d29$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $af3a2d87ccb15d29$var$ie ? $af3a2d87ccb15d29$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($af3a2d87ccb15d29$var$de && "ko" !== c.locale && ($af3a2d87ccb15d29$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $af3a2d87ccb15d29$var$ie && ($a = $af3a2d87ccb15d29$var$nd()) : ($af3a2d87ccb15d29$var$kd = e, $af3a2d87ccb15d29$var$ld = "value" in $af3a2d87ccb15d29$var$kd ? $af3a2d87ccb15d29$var$kd.value : $af3a2d87ccb15d29$var$kd.textContent, $af3a2d87ccb15d29$var$ie = !0)), xa = $af3a2d87ccb15d29$var$oe(d, ba), 0 < xa.length && (ba = new $af3a2d87ccb15d29$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $af3a2d87ccb15d29$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $af3a2d87ccb15d29$var$ce ? $af3a2d87ccb15d29$var$je(a, c) : $af3a2d87ccb15d29$var$ke(a, c)) d = $af3a2d87ccb15d29$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $af3a2d87ccb15d29$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $af3a2d87ccb15d29$var$se(g, b);
    });
}
function $af3a2d87ccb15d29$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $af3a2d87ccb15d29$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $af3a2d87ccb15d29$var$Kb(a, c), null != f && d.unshift($af3a2d87ccb15d29$var$tf(a, f, e)), f = $af3a2d87ccb15d29$var$Kb(a, b), null != f && d.push($af3a2d87ccb15d29$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $af3a2d87ccb15d29$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $af3a2d87ccb15d29$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $af3a2d87ccb15d29$var$Kb(c, f), null != k && g.unshift($af3a2d87ccb15d29$var$tf(c, k, h))) : e || (k = $af3a2d87ccb15d29$var$Kb(c, f), null != k && g.push($af3a2d87ccb15d29$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $af3a2d87ccb15d29$var$xf = /\r\n?/g, $af3a2d87ccb15d29$var$yf = /\u0000|\uFFFD/g;
function $af3a2d87ccb15d29$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($af3a2d87ccb15d29$var$xf, "\n").replace($af3a2d87ccb15d29$var$yf, "");
}
function $af3a2d87ccb15d29$var$Af(a, b, c) {
    b = $af3a2d87ccb15d29$var$zf(b);
    if ($af3a2d87ccb15d29$var$zf(a) !== b && c) throw Error($af3a2d87ccb15d29$var$p(425));
}
function $af3a2d87ccb15d29$var$Bf() {}
var $af3a2d87ccb15d29$var$Cf = null, $af3a2d87ccb15d29$var$Df = null;
function $af3a2d87ccb15d29$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $af3a2d87ccb15d29$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $af3a2d87ccb15d29$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $af3a2d87ccb15d29$var$Hf = "function" === typeof Promise ? Promise : void 0, $af3a2d87ccb15d29$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $af3a2d87ccb15d29$var$Hf ? function(a) {
    return $af3a2d87ccb15d29$var$Hf.resolve(null).then(a).catch($af3a2d87ccb15d29$var$If);
} : $af3a2d87ccb15d29$var$Ff;
function $af3a2d87ccb15d29$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $af3a2d87ccb15d29$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $af3a2d87ccb15d29$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $af3a2d87ccb15d29$var$bd(b);
}
function $af3a2d87ccb15d29$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $af3a2d87ccb15d29$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$Nf = Math.random().toString(36).slice(2), $af3a2d87ccb15d29$var$Of = "__reactFiber$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Pf = "__reactProps$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$uf = "__reactContainer$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$of = "__reactEvents$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Qf = "__reactListeners$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Rf = "__reactHandles$" + $af3a2d87ccb15d29$var$Nf;
function $af3a2d87ccb15d29$var$Wc(a) {
    var b = a[$af3a2d87ccb15d29$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$af3a2d87ccb15d29$var$uf] || c[$af3a2d87ccb15d29$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $af3a2d87ccb15d29$var$Mf(a); null !== a;){
                if (c = a[$af3a2d87ccb15d29$var$Of]) return c;
                a = $af3a2d87ccb15d29$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Cb(a) {
    a = a[$af3a2d87ccb15d29$var$Of] || a[$af3a2d87ccb15d29$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $af3a2d87ccb15d29$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($af3a2d87ccb15d29$var$p(33));
}
function $af3a2d87ccb15d29$var$Db(a) {
    return a[$af3a2d87ccb15d29$var$Pf] || null;
}
var $af3a2d87ccb15d29$var$Sf = [], $af3a2d87ccb15d29$var$Tf = -1;
function $af3a2d87ccb15d29$var$Uf(a) {
    return {
        current: a
    };
}
function $af3a2d87ccb15d29$var$E(a) {
    0 > $af3a2d87ccb15d29$var$Tf || (a.current = $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf], $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf] = null, $af3a2d87ccb15d29$var$Tf--);
}
function $af3a2d87ccb15d29$var$G(a, b) {
    $af3a2d87ccb15d29$var$Tf++;
    $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf] = a.current;
    a.current = b;
}
var $af3a2d87ccb15d29$var$Vf = {}, $af3a2d87ccb15d29$var$H = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Vf), $af3a2d87ccb15d29$var$Wf = $af3a2d87ccb15d29$var$Uf(!1), $af3a2d87ccb15d29$var$Xf = $af3a2d87ccb15d29$var$Vf;
function $af3a2d87ccb15d29$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $af3a2d87ccb15d29$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $af3a2d87ccb15d29$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $af3a2d87ccb15d29$var$$f() {
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
}
function $af3a2d87ccb15d29$var$ag(a, b, c) {
    if ($af3a2d87ccb15d29$var$H.current !== $af3a2d87ccb15d29$var$Vf) throw Error($af3a2d87ccb15d29$var$p(168));
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, b);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, c);
}
function $af3a2d87ccb15d29$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($af3a2d87ccb15d29$var$p(108, $af3a2d87ccb15d29$var$Ra(a) || "Unknown", e));
    return $af3a2d87ccb15d29$var$A({}, c, d);
}
function $af3a2d87ccb15d29$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $af3a2d87ccb15d29$var$Vf;
    $af3a2d87ccb15d29$var$Xf = $af3a2d87ccb15d29$var$H.current;
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, a);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, $af3a2d87ccb15d29$var$Wf.current);
    return !0;
}
function $af3a2d87ccb15d29$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($af3a2d87ccb15d29$var$p(169));
    c ? (a = $af3a2d87ccb15d29$var$bg(a, b, $af3a2d87ccb15d29$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H), $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, a)) : $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, c);
}
var $af3a2d87ccb15d29$var$eg = null, $af3a2d87ccb15d29$var$fg = !1, $af3a2d87ccb15d29$var$gg = !1;
function $af3a2d87ccb15d29$var$hg(a) {
    null === $af3a2d87ccb15d29$var$eg ? $af3a2d87ccb15d29$var$eg = [
        a
    ] : $af3a2d87ccb15d29$var$eg.push(a);
}
function $af3a2d87ccb15d29$var$ig(a) {
    $af3a2d87ccb15d29$var$fg = !0;
    $af3a2d87ccb15d29$var$hg(a);
}
function $af3a2d87ccb15d29$var$jg() {
    if (!$af3a2d87ccb15d29$var$gg && null !== $af3a2d87ccb15d29$var$eg) {
        $af3a2d87ccb15d29$var$gg = !0;
        var a = 0, b = $af3a2d87ccb15d29$var$C;
        try {
            var c = $af3a2d87ccb15d29$var$eg;
            for($af3a2d87ccb15d29$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $af3a2d87ccb15d29$var$eg = null;
            $af3a2d87ccb15d29$var$fg = !1;
        } catch (e) {
            throw null !== $af3a2d87ccb15d29$var$eg && ($af3a2d87ccb15d29$var$eg = $af3a2d87ccb15d29$var$eg.slice(a + 1)), $af3a2d87ccb15d29$var$ac($af3a2d87ccb15d29$var$fc, $af3a2d87ccb15d29$var$jg), e;
        } finally{
            $af3a2d87ccb15d29$var$C = b, $af3a2d87ccb15d29$var$gg = !1;
        }
    }
    return null;
}
var $af3a2d87ccb15d29$var$kg = [], $af3a2d87ccb15d29$var$lg = 0, $af3a2d87ccb15d29$var$mg = null, $af3a2d87ccb15d29$var$ng = 0, $af3a2d87ccb15d29$var$og = [], $af3a2d87ccb15d29$var$pg = 0, $af3a2d87ccb15d29$var$qg = null, $af3a2d87ccb15d29$var$rg = 1, $af3a2d87ccb15d29$var$sg = "";
function $af3a2d87ccb15d29$var$tg(a, b) {
    $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg++] = $af3a2d87ccb15d29$var$ng;
    $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg++] = $af3a2d87ccb15d29$var$mg;
    $af3a2d87ccb15d29$var$mg = a;
    $af3a2d87ccb15d29$var$ng = b;
}
function $af3a2d87ccb15d29$var$ug(a, b, c) {
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$rg;
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$sg;
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$qg;
    $af3a2d87ccb15d29$var$qg = a;
    var d = $af3a2d87ccb15d29$var$rg;
    a = $af3a2d87ccb15d29$var$sg;
    var e = 32 - $af3a2d87ccb15d29$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $af3a2d87ccb15d29$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $af3a2d87ccb15d29$var$rg = 1 << 32 - $af3a2d87ccb15d29$var$oc(b) + e | c << e | d;
        $af3a2d87ccb15d29$var$sg = f + a;
    } else $af3a2d87ccb15d29$var$rg = 1 << f | c << e | d, $af3a2d87ccb15d29$var$sg = a;
}
function $af3a2d87ccb15d29$var$vg(a) {
    null !== a.return && ($af3a2d87ccb15d29$var$tg(a, 1), $af3a2d87ccb15d29$var$ug(a, 1, 0));
}
function $af3a2d87ccb15d29$var$wg(a) {
    for(; a === $af3a2d87ccb15d29$var$mg;)$af3a2d87ccb15d29$var$mg = $af3a2d87ccb15d29$var$kg[--$af3a2d87ccb15d29$var$lg], $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg] = null, $af3a2d87ccb15d29$var$ng = $af3a2d87ccb15d29$var$kg[--$af3a2d87ccb15d29$var$lg], $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg] = null;
    for(; a === $af3a2d87ccb15d29$var$qg;)$af3a2d87ccb15d29$var$qg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null, $af3a2d87ccb15d29$var$sg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null, $af3a2d87ccb15d29$var$rg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null;
}
var $af3a2d87ccb15d29$var$xg = null, $af3a2d87ccb15d29$var$yg = null, $af3a2d87ccb15d29$var$I = !1, $af3a2d87ccb15d29$var$zg = null;
function $af3a2d87ccb15d29$var$Ag(a, b) {
    var c = $af3a2d87ccb15d29$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $af3a2d87ccb15d29$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $af3a2d87ccb15d29$var$qg ? {
                id: $af3a2d87ccb15d29$var$rg,
                overflow: $af3a2d87ccb15d29$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $af3a2d87ccb15d29$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $af3a2d87ccb15d29$var$Eg(a) {
    if ($af3a2d87ccb15d29$var$I) {
        var b = $af3a2d87ccb15d29$var$yg;
        if (b) {
            var c = b;
            if (!$af3a2d87ccb15d29$var$Cg(a, b)) {
                if ($af3a2d87ccb15d29$var$Dg(a)) throw Error($af3a2d87ccb15d29$var$p(418));
                b = $af3a2d87ccb15d29$var$Lf(c.nextSibling);
                var d = $af3a2d87ccb15d29$var$xg;
                b && $af3a2d87ccb15d29$var$Cg(a, b) ? $af3a2d87ccb15d29$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $af3a2d87ccb15d29$var$I = !1, $af3a2d87ccb15d29$var$xg = a);
            }
        } else {
            if ($af3a2d87ccb15d29$var$Dg(a)) throw Error($af3a2d87ccb15d29$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $af3a2d87ccb15d29$var$I = !1;
            $af3a2d87ccb15d29$var$xg = a;
        }
    }
}
function $af3a2d87ccb15d29$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $af3a2d87ccb15d29$var$xg = a;
}
function $af3a2d87ccb15d29$var$Gg(a) {
    if (a !== $af3a2d87ccb15d29$var$xg) return !1;
    if (!$af3a2d87ccb15d29$var$I) return $af3a2d87ccb15d29$var$Fg(a), $af3a2d87ccb15d29$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$af3a2d87ccb15d29$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $af3a2d87ccb15d29$var$yg)) {
        if ($af3a2d87ccb15d29$var$Dg(a)) throw $af3a2d87ccb15d29$var$Hg(), Error($af3a2d87ccb15d29$var$p(418));
        for(; b;)$af3a2d87ccb15d29$var$Ag(a, b), b = $af3a2d87ccb15d29$var$Lf(b.nextSibling);
    }
    $af3a2d87ccb15d29$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($af3a2d87ccb15d29$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $af3a2d87ccb15d29$var$yg = null;
        }
    } else $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$xg ? $af3a2d87ccb15d29$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $af3a2d87ccb15d29$var$Hg() {
    for(var a = $af3a2d87ccb15d29$var$yg; a;)a = $af3a2d87ccb15d29$var$Lf(a.nextSibling);
}
function $af3a2d87ccb15d29$var$Ig() {
    $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$xg = null;
    $af3a2d87ccb15d29$var$I = !1;
}
function $af3a2d87ccb15d29$var$Jg(a) {
    null === $af3a2d87ccb15d29$var$zg ? $af3a2d87ccb15d29$var$zg = [
        a
    ] : $af3a2d87ccb15d29$var$zg.push(a);
}
var $af3a2d87ccb15d29$var$Kg = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig;
function $af3a2d87ccb15d29$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $af3a2d87ccb15d29$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $af3a2d87ccb15d29$var$Mg = $af3a2d87ccb15d29$var$Uf(null), $af3a2d87ccb15d29$var$Ng = null, $af3a2d87ccb15d29$var$Og = null, $af3a2d87ccb15d29$var$Pg = null;
function $af3a2d87ccb15d29$var$Qg() {
    $af3a2d87ccb15d29$var$Pg = $af3a2d87ccb15d29$var$Og = $af3a2d87ccb15d29$var$Ng = null;
}
function $af3a2d87ccb15d29$var$Rg(a) {
    var b = $af3a2d87ccb15d29$var$Mg.current;
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Mg);
    a._currentValue = b;
}
function $af3a2d87ccb15d29$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $af3a2d87ccb15d29$var$Tg(a, b) {
    $af3a2d87ccb15d29$var$Ng = a;
    $af3a2d87ccb15d29$var$Pg = $af3a2d87ccb15d29$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($af3a2d87ccb15d29$var$Ug = !0), a.firstContext = null);
}
function $af3a2d87ccb15d29$var$Vg(a) {
    var b = a._currentValue;
    if ($af3a2d87ccb15d29$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $af3a2d87ccb15d29$var$Og) {
            if (null === $af3a2d87ccb15d29$var$Ng) throw Error($af3a2d87ccb15d29$var$p(308));
            $af3a2d87ccb15d29$var$Og = a;
            $af3a2d87ccb15d29$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $af3a2d87ccb15d29$var$Og = $af3a2d87ccb15d29$var$Og.next = a;
    }
    return b;
}
var $af3a2d87ccb15d29$var$Wg = null;
function $af3a2d87ccb15d29$var$Xg(a) {
    null === $af3a2d87ccb15d29$var$Wg ? $af3a2d87ccb15d29$var$Wg = [
        a
    ] : $af3a2d87ccb15d29$var$Wg.push(a);
}
function $af3a2d87ccb15d29$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $af3a2d87ccb15d29$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $af3a2d87ccb15d29$var$Zg(a, d);
}
function $af3a2d87ccb15d29$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $af3a2d87ccb15d29$var$$g = !1;
function $af3a2d87ccb15d29$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $af3a2d87ccb15d29$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $af3a2d87ccb15d29$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $af3a2d87ccb15d29$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($af3a2d87ccb15d29$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $af3a2d87ccb15d29$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $af3a2d87ccb15d29$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $af3a2d87ccb15d29$var$Zg(a, c);
}
function $af3a2d87ccb15d29$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af3a2d87ccb15d29$var$Cc(a, c);
    }
}
function $af3a2d87ccb15d29$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $af3a2d87ccb15d29$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $af3a2d87ccb15d29$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $af3a2d87ccb15d29$var$A({}, q, r);
                            break a;
                        case 2:
                            $af3a2d87ccb15d29$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $af3a2d87ccb15d29$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $af3a2d87ccb15d29$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($af3a2d87ccb15d29$var$p(191, e));
            e.call(d);
        }
    }
}
var $af3a2d87ccb15d29$var$jh = (new $lx97N.Component).refs;
function $af3a2d87ccb15d29$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $af3a2d87ccb15d29$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $af3a2d87ccb15d29$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $af3a2d87ccb15d29$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af3a2d87ccb15d29$var$L(), e = $af3a2d87ccb15d29$var$lh(a), f = $af3a2d87ccb15d29$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af3a2d87ccb15d29$var$dh(a, f, e);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, e, d), $af3a2d87ccb15d29$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af3a2d87ccb15d29$var$L(), e = $af3a2d87ccb15d29$var$lh(a), f = $af3a2d87ccb15d29$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af3a2d87ccb15d29$var$dh(a, f, e);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, e, d), $af3a2d87ccb15d29$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $af3a2d87ccb15d29$var$L(), d = $af3a2d87ccb15d29$var$lh(a), e = $af3a2d87ccb15d29$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $af3a2d87ccb15d29$var$dh(a, e, d);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, d, c), $af3a2d87ccb15d29$var$eh(b, a, d));
    }
};
function $af3a2d87ccb15d29$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$af3a2d87ccb15d29$var$Ie(c, d) || !$af3a2d87ccb15d29$var$Ie(e, f) : !0;
}
function $af3a2d87ccb15d29$var$ph(a, b, c) {
    var d = !1, e = $af3a2d87ccb15d29$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $af3a2d87ccb15d29$var$Vg(f) : (e = $af3a2d87ccb15d29$var$Zf(b) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $af3a2d87ccb15d29$var$Yf(a, e) : $af3a2d87ccb15d29$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $af3a2d87ccb15d29$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $af3a2d87ccb15d29$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $af3a2d87ccb15d29$var$nh.enqueueReplaceState(b, b.state, null);
}
function $af3a2d87ccb15d29$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $af3a2d87ccb15d29$var$jh;
    $af3a2d87ccb15d29$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $af3a2d87ccb15d29$var$Vg(f) : (f = $af3a2d87ccb15d29$var$Zf(b) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, e.context = $af3a2d87ccb15d29$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($af3a2d87ccb15d29$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $af3a2d87ccb15d29$var$nh.enqueueReplaceState(e, e.state, null), $af3a2d87ccb15d29$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $af3a2d87ccb15d29$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($af3a2d87ccb15d29$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($af3a2d87ccb15d29$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $af3a2d87ccb15d29$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($af3a2d87ccb15d29$var$p(284));
        if (!c._owner) throw Error($af3a2d87ccb15d29$var$p(290, a));
    }
    return a;
}
function $af3a2d87ccb15d29$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($af3a2d87ccb15d29$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $af3a2d87ccb15d29$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $af3a2d87ccb15d29$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $af3a2d87ccb15d29$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $af3a2d87ccb15d29$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $af3a2d87ccb15d29$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $af3a2d87ccb15d29$var$Ha && $af3a2d87ccb15d29$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $af3a2d87ccb15d29$var$sh(a, b, c), d.return = a, d;
        d = $af3a2d87ccb15d29$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $af3a2d87ccb15d29$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $af3a2d87ccb15d29$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $af3a2d87ccb15d29$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $af3a2d87ccb15d29$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return c = $af3a2d87ccb15d29$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $af3a2d87ccb15d29$var$sh(a, null, b), c.return = a, c;
                case $af3a2d87ccb15d29$var$wa:
                    return b = $af3a2d87ccb15d29$var$zh(b, a.mode, c), b.return = a, b;
                case $af3a2d87ccb15d29$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($af3a2d87ccb15d29$var$eb(b) || $af3a2d87ccb15d29$var$Ka(b)) return b = $af3a2d87ccb15d29$var$Ah(b, a.mode, c, null), b.return = a, b;
            $af3a2d87ccb15d29$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $af3a2d87ccb15d29$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $af3a2d87ccb15d29$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($af3a2d87ccb15d29$var$eb(c) || $af3a2d87ccb15d29$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $af3a2d87ccb15d29$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $af3a2d87ccb15d29$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $af3a2d87ccb15d29$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($af3a2d87ccb15d29$var$eb(d) || $af3a2d87ccb15d29$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $af3a2d87ccb15d29$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $af3a2d87ccb15d29$var$Ka(h);
        if ("function" !== typeof l) throw Error($af3a2d87ccb15d29$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($af3a2d87ccb15d29$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $af3a2d87ccb15d29$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $af3a2d87ccb15d29$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $af3a2d87ccb15d29$var$Ha && $af3a2d87ccb15d29$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $af3a2d87ccb15d29$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $af3a2d87ccb15d29$var$ya ? (d = $af3a2d87ccb15d29$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $af3a2d87ccb15d29$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $af3a2d87ccb15d29$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $af3a2d87ccb15d29$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $af3a2d87ccb15d29$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $af3a2d87ccb15d29$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($af3a2d87ccb15d29$var$eb(f)) return n(a, d, f, h);
            if ($af3a2d87ccb15d29$var$Ka(f)) return t(a, d, f, h);
            $af3a2d87ccb15d29$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $af3a2d87ccb15d29$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $af3a2d87ccb15d29$var$Bh = $af3a2d87ccb15d29$var$vh(!0), $af3a2d87ccb15d29$var$Ch = $af3a2d87ccb15d29$var$vh(!1), $af3a2d87ccb15d29$var$Dh = {}, $af3a2d87ccb15d29$var$Eh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh), $af3a2d87ccb15d29$var$Fh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh), $af3a2d87ccb15d29$var$Gh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh);
function $af3a2d87ccb15d29$var$Hh(a) {
    if (a === $af3a2d87ccb15d29$var$Dh) throw Error($af3a2d87ccb15d29$var$p(174));
    return a;
}
function $af3a2d87ccb15d29$var$Ih(a, b) {
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Gh, b);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Fh, a);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, $af3a2d87ccb15d29$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $af3a2d87ccb15d29$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $af3a2d87ccb15d29$var$lb(b, a);
    }
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, b);
}
function $af3a2d87ccb15d29$var$Jh() {
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Fh);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Gh);
}
function $af3a2d87ccb15d29$var$Kh(a) {
    $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
    var b = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
    var c = $af3a2d87ccb15d29$var$lb(b, a.type);
    b !== c && ($af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Fh, a), $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, c));
}
function $af3a2d87ccb15d29$var$Lh(a) {
    $af3a2d87ccb15d29$var$Fh.current === a && ($af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Fh));
}
var $af3a2d87ccb15d29$var$M = $af3a2d87ccb15d29$var$Uf(0);
function $af3a2d87ccb15d29$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$Nh = [];
function $af3a2d87ccb15d29$var$Oh() {
    for(var a = 0; a < $af3a2d87ccb15d29$var$Nh.length; a++)$af3a2d87ccb15d29$var$Nh[a]._workInProgressVersionPrimary = null;
    $af3a2d87ccb15d29$var$Nh.length = 0;
}
var $af3a2d87ccb15d29$var$Ph = $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher, $af3a2d87ccb15d29$var$Qh = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$Rh = 0, $af3a2d87ccb15d29$var$N = null, $af3a2d87ccb15d29$var$O = null, $af3a2d87ccb15d29$var$P = null, $af3a2d87ccb15d29$var$Sh = !1, $af3a2d87ccb15d29$var$Th = !1, $af3a2d87ccb15d29$var$Uh = 0, $af3a2d87ccb15d29$var$Vh = 0;
function $af3a2d87ccb15d29$var$Q() {
    throw Error($af3a2d87ccb15d29$var$p(321));
}
function $af3a2d87ccb15d29$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$af3a2d87ccb15d29$var$He(a[c], b[c])) return !1;
    return !0;
}
function $af3a2d87ccb15d29$var$Xh(a, b, c, d, e, f) {
    $af3a2d87ccb15d29$var$Rh = f;
    $af3a2d87ccb15d29$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $af3a2d87ccb15d29$var$Ph.current = null === a || null === a.memoizedState ? $af3a2d87ccb15d29$var$Yh : $af3a2d87ccb15d29$var$Zh;
    a = c(d, e);
    if ($af3a2d87ccb15d29$var$Th) {
        f = 0;
        do {
            $af3a2d87ccb15d29$var$Th = !1;
            $af3a2d87ccb15d29$var$Uh = 0;
            if (25 <= f) throw Error($af3a2d87ccb15d29$var$p(301));
            f += 1;
            $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = null;
            b.updateQueue = null;
            $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$$h;
            a = c(d, e);
        }while ($af3a2d87ccb15d29$var$Th);
    }
    $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$ai;
    b = null !== $af3a2d87ccb15d29$var$O && null !== $af3a2d87ccb15d29$var$O.next;
    $af3a2d87ccb15d29$var$Rh = 0;
    $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = $af3a2d87ccb15d29$var$N = null;
    $af3a2d87ccb15d29$var$Sh = !1;
    if (b) throw Error($af3a2d87ccb15d29$var$p(300));
    return a;
}
function $af3a2d87ccb15d29$var$bi() {
    var a = 0 !== $af3a2d87ccb15d29$var$Uh;
    $af3a2d87ccb15d29$var$Uh = 0;
    return a;
}
function $af3a2d87ccb15d29$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState = $af3a2d87ccb15d29$var$P = a : $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$P.next = a;
    return $af3a2d87ccb15d29$var$P;
}
function $af3a2d87ccb15d29$var$di() {
    if (null === $af3a2d87ccb15d29$var$O) {
        var a = $af3a2d87ccb15d29$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $af3a2d87ccb15d29$var$O.next;
    var b = null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState : $af3a2d87ccb15d29$var$P.next;
    if (null !== b) $af3a2d87ccb15d29$var$P = b, $af3a2d87ccb15d29$var$O = a;
    else {
        if (null === a) throw Error($af3a2d87ccb15d29$var$p(310));
        $af3a2d87ccb15d29$var$O = a;
        a = {
            memoizedState: $af3a2d87ccb15d29$var$O.memoizedState,
            baseState: $af3a2d87ccb15d29$var$O.baseState,
            baseQueue: $af3a2d87ccb15d29$var$O.baseQueue,
            queue: $af3a2d87ccb15d29$var$O.queue,
            next: null
        };
        null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState = $af3a2d87ccb15d29$var$P = a : $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$P.next = a;
    }
    return $af3a2d87ccb15d29$var$P;
}
function $af3a2d87ccb15d29$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $af3a2d87ccb15d29$var$fi(a) {
    var b = $af3a2d87ccb15d29$var$di(), c = b.queue;
    if (null === c) throw Error($af3a2d87ccb15d29$var$p(311));
    c.lastRenderedReducer = a;
    var d = $af3a2d87ccb15d29$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($af3a2d87ccb15d29$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $af3a2d87ccb15d29$var$N.lanes |= m;
                $af3a2d87ccb15d29$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $af3a2d87ccb15d29$var$He(d, b.memoizedState) || ($af3a2d87ccb15d29$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $af3a2d87ccb15d29$var$N.lanes |= f, $af3a2d87ccb15d29$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $af3a2d87ccb15d29$var$gi(a) {
    var b = $af3a2d87ccb15d29$var$di(), c = b.queue;
    if (null === c) throw Error($af3a2d87ccb15d29$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $af3a2d87ccb15d29$var$He(f, b.memoizedState) || ($af3a2d87ccb15d29$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $af3a2d87ccb15d29$var$hi() {}
function $af3a2d87ccb15d29$var$ii(a, b) {
    var c = $af3a2d87ccb15d29$var$N, d = $af3a2d87ccb15d29$var$di(), e = b(), f = !$af3a2d87ccb15d29$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $af3a2d87ccb15d29$var$Ug = !0);
    d = d.queue;
    $af3a2d87ccb15d29$var$ji($af3a2d87ccb15d29$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $af3a2d87ccb15d29$var$P && $af3a2d87ccb15d29$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $af3a2d87ccb15d29$var$li(9, $af3a2d87ccb15d29$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $af3a2d87ccb15d29$var$R) throw Error($af3a2d87ccb15d29$var$p(349));
        0 !== ($af3a2d87ccb15d29$var$Rh & 30) || $af3a2d87ccb15d29$var$ni(c, b, e);
    }
    return e;
}
function $af3a2d87ccb15d29$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $af3a2d87ccb15d29$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af3a2d87ccb15d29$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $af3a2d87ccb15d29$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $af3a2d87ccb15d29$var$oi(b) && $af3a2d87ccb15d29$var$pi(a);
}
function $af3a2d87ccb15d29$var$ki(a, b, c) {
    return c(function() {
        $af3a2d87ccb15d29$var$oi(b) && $af3a2d87ccb15d29$var$pi(a);
    });
}
function $af3a2d87ccb15d29$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$af3a2d87ccb15d29$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $af3a2d87ccb15d29$var$pi(a) {
    var b = $af3a2d87ccb15d29$var$Zg(a, 1);
    null !== b && $af3a2d87ccb15d29$var$mh(b, a, 1, -1);
}
function $af3a2d87ccb15d29$var$qi(a) {
    var b = $af3a2d87ccb15d29$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $af3a2d87ccb15d29$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $af3a2d87ccb15d29$var$ri.bind(null, $af3a2d87ccb15d29$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $af3a2d87ccb15d29$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $af3a2d87ccb15d29$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af3a2d87ccb15d29$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $af3a2d87ccb15d29$var$si() {
    return $af3a2d87ccb15d29$var$di().memoizedState;
}
function $af3a2d87ccb15d29$var$ti(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$ci();
    $af3a2d87ccb15d29$var$N.flags |= a;
    e.memoizedState = $af3a2d87ccb15d29$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $af3a2d87ccb15d29$var$ui(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $af3a2d87ccb15d29$var$O) {
        var g = $af3a2d87ccb15d29$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $af3a2d87ccb15d29$var$Wh(d, g.deps)) {
            e.memoizedState = $af3a2d87ccb15d29$var$li(b, c, f, d);
            return;
        }
    }
    $af3a2d87ccb15d29$var$N.flags |= a;
    e.memoizedState = $af3a2d87ccb15d29$var$li(1 | b, c, f, d);
}
function $af3a2d87ccb15d29$var$vi(a, b) {
    return $af3a2d87ccb15d29$var$ti(8390656, 8, a, b);
}
function $af3a2d87ccb15d29$var$ji(a, b) {
    return $af3a2d87ccb15d29$var$ui(2048, 8, a, b);
}
function $af3a2d87ccb15d29$var$wi(a, b) {
    return $af3a2d87ccb15d29$var$ui(4, 2, a, b);
}
function $af3a2d87ccb15d29$var$xi(a, b) {
    return $af3a2d87ccb15d29$var$ui(4, 4, a, b);
}
function $af3a2d87ccb15d29$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $af3a2d87ccb15d29$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $af3a2d87ccb15d29$var$ui(4, 4, $af3a2d87ccb15d29$var$yi.bind(null, b, a), c);
}
function $af3a2d87ccb15d29$var$Ai() {}
function $af3a2d87ccb15d29$var$Bi(a, b) {
    var c = $af3a2d87ccb15d29$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af3a2d87ccb15d29$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af3a2d87ccb15d29$var$Ci(a, b) {
    var c = $af3a2d87ccb15d29$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af3a2d87ccb15d29$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af3a2d87ccb15d29$var$Di(a, b, c) {
    if (0 === ($af3a2d87ccb15d29$var$Rh & 21)) return a.baseState && (a.baseState = !1, $af3a2d87ccb15d29$var$Ug = !0), a.memoizedState = c;
    $af3a2d87ccb15d29$var$He(c, b) || (c = $af3a2d87ccb15d29$var$yc(), $af3a2d87ccb15d29$var$N.lanes |= c, $af3a2d87ccb15d29$var$hh |= c, a.baseState = !0);
    return b;
}
function $af3a2d87ccb15d29$var$Ei(a, b) {
    var c = $af3a2d87ccb15d29$var$C;
    $af3a2d87ccb15d29$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $af3a2d87ccb15d29$var$Qh.transition;
    $af3a2d87ccb15d29$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $af3a2d87ccb15d29$var$C = c, $af3a2d87ccb15d29$var$Qh.transition = d;
    }
}
function $af3a2d87ccb15d29$var$Fi() {
    return $af3a2d87ccb15d29$var$di().memoizedState;
}
function $af3a2d87ccb15d29$var$Gi(a, b, c) {
    var d = $af3a2d87ccb15d29$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af3a2d87ccb15d29$var$Hi(a)) $af3a2d87ccb15d29$var$Ii(b, c);
    else if (c = $af3a2d87ccb15d29$var$Yg(a, b, c, d), null !== c) {
        var e = $af3a2d87ccb15d29$var$L();
        $af3a2d87ccb15d29$var$mh(c, a, d, e);
        $af3a2d87ccb15d29$var$Ji(c, b, d);
    }
}
function $af3a2d87ccb15d29$var$ri(a, b, c) {
    var d = $af3a2d87ccb15d29$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af3a2d87ccb15d29$var$Hi(a)) $af3a2d87ccb15d29$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($af3a2d87ccb15d29$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $af3a2d87ccb15d29$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $af3a2d87ccb15d29$var$Yg(a, b, e, d);
        null !== c && (e = $af3a2d87ccb15d29$var$L(), $af3a2d87ccb15d29$var$mh(c, a, d, e), $af3a2d87ccb15d29$var$Ji(c, b, d));
    }
}
function $af3a2d87ccb15d29$var$Hi(a) {
    var b = a.alternate;
    return a === $af3a2d87ccb15d29$var$N || null !== b && b === $af3a2d87ccb15d29$var$N;
}
function $af3a2d87ccb15d29$var$Ii(a, b) {
    $af3a2d87ccb15d29$var$Th = $af3a2d87ccb15d29$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $af3a2d87ccb15d29$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af3a2d87ccb15d29$var$Cc(a, c);
    }
}
var $af3a2d87ccb15d29$var$ai = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Q,
    useContext: $af3a2d87ccb15d29$var$Q,
    useEffect: $af3a2d87ccb15d29$var$Q,
    useImperativeHandle: $af3a2d87ccb15d29$var$Q,
    useInsertionEffect: $af3a2d87ccb15d29$var$Q,
    useLayoutEffect: $af3a2d87ccb15d29$var$Q,
    useMemo: $af3a2d87ccb15d29$var$Q,
    useReducer: $af3a2d87ccb15d29$var$Q,
    useRef: $af3a2d87ccb15d29$var$Q,
    useState: $af3a2d87ccb15d29$var$Q,
    useDebugValue: $af3a2d87ccb15d29$var$Q,
    useDeferredValue: $af3a2d87ccb15d29$var$Q,
    useTransition: $af3a2d87ccb15d29$var$Q,
    useMutableSource: $af3a2d87ccb15d29$var$Q,
    useSyncExternalStore: $af3a2d87ccb15d29$var$Q,
    useId: $af3a2d87ccb15d29$var$Q,
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$Yh = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: function(a, b) {
        $af3a2d87ccb15d29$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $af3a2d87ccb15d29$var$ti(4194308, 4, $af3a2d87ccb15d29$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $af3a2d87ccb15d29$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $af3a2d87ccb15d29$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $af3a2d87ccb15d29$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $af3a2d87ccb15d29$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $af3a2d87ccb15d29$var$Gi.bind(null, $af3a2d87ccb15d29$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $af3a2d87ccb15d29$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $af3a2d87ccb15d29$var$qi,
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        return $af3a2d87ccb15d29$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$qi(!1), b = a[0];
        a = $af3a2d87ccb15d29$var$Ei.bind(null, a[1]);
        $af3a2d87ccb15d29$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $af3a2d87ccb15d29$var$N, e = $af3a2d87ccb15d29$var$ci();
        if ($af3a2d87ccb15d29$var$I) {
            if (void 0 === c) throw Error($af3a2d87ccb15d29$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $af3a2d87ccb15d29$var$R) throw Error($af3a2d87ccb15d29$var$p(349));
            0 !== ($af3a2d87ccb15d29$var$Rh & 30) || $af3a2d87ccb15d29$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $af3a2d87ccb15d29$var$vi($af3a2d87ccb15d29$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $af3a2d87ccb15d29$var$li(9, $af3a2d87ccb15d29$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $af3a2d87ccb15d29$var$ci(), b = $af3a2d87ccb15d29$var$R.identifierPrefix;
        if ($af3a2d87ccb15d29$var$I) {
            var c = $af3a2d87ccb15d29$var$sg;
            var d = $af3a2d87ccb15d29$var$rg;
            c = (d & ~(1 << 32 - $af3a2d87ccb15d29$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $af3a2d87ccb15d29$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $af3a2d87ccb15d29$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$Zh = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Bi,
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$ji,
    useImperativeHandle: $af3a2d87ccb15d29$var$zi,
    useInsertionEffect: $af3a2d87ccb15d29$var$wi,
    useLayoutEffect: $af3a2d87ccb15d29$var$xi,
    useMemo: $af3a2d87ccb15d29$var$Ci,
    useReducer: $af3a2d87ccb15d29$var$fi,
    useRef: $af3a2d87ccb15d29$var$si,
    useState: function() {
        return $af3a2d87ccb15d29$var$fi($af3a2d87ccb15d29$var$ei);
    },
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        var b = $af3a2d87ccb15d29$var$di();
        return $af3a2d87ccb15d29$var$Di(b, $af3a2d87ccb15d29$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$fi($af3a2d87ccb15d29$var$ei)[0], b = $af3a2d87ccb15d29$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af3a2d87ccb15d29$var$hi,
    useSyncExternalStore: $af3a2d87ccb15d29$var$ii,
    useId: $af3a2d87ccb15d29$var$Fi,
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$$h = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Bi,
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$ji,
    useImperativeHandle: $af3a2d87ccb15d29$var$zi,
    useInsertionEffect: $af3a2d87ccb15d29$var$wi,
    useLayoutEffect: $af3a2d87ccb15d29$var$xi,
    useMemo: $af3a2d87ccb15d29$var$Ci,
    useReducer: $af3a2d87ccb15d29$var$gi,
    useRef: $af3a2d87ccb15d29$var$si,
    useState: function() {
        return $af3a2d87ccb15d29$var$gi($af3a2d87ccb15d29$var$ei);
    },
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        var b = $af3a2d87ccb15d29$var$di();
        return null === $af3a2d87ccb15d29$var$O ? b.memoizedState = a : $af3a2d87ccb15d29$var$Di(b, $af3a2d87ccb15d29$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$gi($af3a2d87ccb15d29$var$ei)[0], b = $af3a2d87ccb15d29$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af3a2d87ccb15d29$var$hi,
    useSyncExternalStore: $af3a2d87ccb15d29$var$ii,
    useId: $af3a2d87ccb15d29$var$Fi,
    unstable_isNewReconciler: !1
};
function $af3a2d87ccb15d29$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $af3a2d87ccb15d29$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $af3a2d87ccb15d29$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $af3a2d87ccb15d29$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $af3a2d87ccb15d29$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $af3a2d87ccb15d29$var$Oi(a, b, c) {
    c = $af3a2d87ccb15d29$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $af3a2d87ccb15d29$var$Pi || ($af3a2d87ccb15d29$var$Pi = !0, $af3a2d87ccb15d29$var$Qi = d);
        $af3a2d87ccb15d29$var$Mi(a, b);
    };
    return c;
}
function $af3a2d87ccb15d29$var$Ri(a, b, c) {
    c = $af3a2d87ccb15d29$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $af3a2d87ccb15d29$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $af3a2d87ccb15d29$var$Mi(a, b);
        "function" !== typeof d && (null === $af3a2d87ccb15d29$var$Si ? $af3a2d87ccb15d29$var$Si = new Set([
            this
        ]) : $af3a2d87ccb15d29$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $af3a2d87ccb15d29$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $af3a2d87ccb15d29$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $af3a2d87ccb15d29$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $af3a2d87ccb15d29$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $af3a2d87ccb15d29$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $af3a2d87ccb15d29$var$ch(-1, 1), b.tag = 2, $af3a2d87ccb15d29$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $af3a2d87ccb15d29$var$Xi = $af3a2d87ccb15d29$var$ua.ReactCurrentOwner, $af3a2d87ccb15d29$var$Ug = !1;
function $af3a2d87ccb15d29$var$Yi(a, b, c, d) {
    b.child = null === a ? $af3a2d87ccb15d29$var$Ch(b, null, c, d) : $af3a2d87ccb15d29$var$Bh(b, a.child, c, d);
}
function $af3a2d87ccb15d29$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $af3a2d87ccb15d29$var$Tg(b, e);
    d = $af3a2d87ccb15d29$var$Xh(a, b, c, d, f, e);
    c = $af3a2d87ccb15d29$var$bi();
    if (null !== a && !$af3a2d87ccb15d29$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af3a2d87ccb15d29$var$$i(a, b, e);
    $af3a2d87ccb15d29$var$I && c && $af3a2d87ccb15d29$var$vg(b);
    b.flags |= 1;
    $af3a2d87ccb15d29$var$Yi(a, b, d, e);
    return b.child;
}
function $af3a2d87ccb15d29$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$af3a2d87ccb15d29$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $af3a2d87ccb15d29$var$cj(a, b, f, d, e);
        a = $af3a2d87ccb15d29$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $af3a2d87ccb15d29$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $af3a2d87ccb15d29$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $af3a2d87ccb15d29$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $af3a2d87ccb15d29$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($af3a2d87ccb15d29$var$Ie(f, d) && a.ref === b.ref) {
            if ($af3a2d87ccb15d29$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($af3a2d87ccb15d29$var$Ug = !0);
            else return b.lanes = a.lanes, $af3a2d87ccb15d29$var$$i(a, b, e);
        }
    }
    return $af3a2d87ccb15d29$var$dj(a, b, c, d, e);
}
function $af3a2d87ccb15d29$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj);
            $af3a2d87ccb15d29$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= d;
    $af3a2d87ccb15d29$var$Yi(a, b, e, c);
    return b.child;
}
function $af3a2d87ccb15d29$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $af3a2d87ccb15d29$var$dj(a, b, c, d, e) {
    var f = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current;
    f = $af3a2d87ccb15d29$var$Yf(b, f);
    $af3a2d87ccb15d29$var$Tg(b, e);
    c = $af3a2d87ccb15d29$var$Xh(a, b, c, d, f, e);
    d = $af3a2d87ccb15d29$var$bi();
    if (null !== a && !$af3a2d87ccb15d29$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af3a2d87ccb15d29$var$$i(a, b, e);
    $af3a2d87ccb15d29$var$I && d && $af3a2d87ccb15d29$var$vg(b);
    b.flags |= 1;
    $af3a2d87ccb15d29$var$Yi(a, b, c, e);
    return b.child;
}
function $af3a2d87ccb15d29$var$ij(a, b, c, d, e) {
    if ($af3a2d87ccb15d29$var$Zf(c)) {
        var f = !0;
        $af3a2d87ccb15d29$var$cg(b);
    } else f = !1;
    $af3a2d87ccb15d29$var$Tg(b, e);
    if (null === b.stateNode) $af3a2d87ccb15d29$var$jj(a, b), $af3a2d87ccb15d29$var$ph(b, c, d), $af3a2d87ccb15d29$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $af3a2d87ccb15d29$var$Vg(l) : (l = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, l = $af3a2d87ccb15d29$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $af3a2d87ccb15d29$var$qh(b, g, d, l);
        $af3a2d87ccb15d29$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $af3a2d87ccb15d29$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $af3a2d87ccb15d29$var$Wf.current || $af3a2d87ccb15d29$var$$g ? ("function" === typeof m && ($af3a2d87ccb15d29$var$kh(b, c, m, d), k = b.memoizedState), (h = $af3a2d87ccb15d29$var$$g || $af3a2d87ccb15d29$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $af3a2d87ccb15d29$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $af3a2d87ccb15d29$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $af3a2d87ccb15d29$var$Vg(k) : (k = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, k = $af3a2d87ccb15d29$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $af3a2d87ccb15d29$var$qh(b, g, d, k);
        $af3a2d87ccb15d29$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $af3a2d87ccb15d29$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $af3a2d87ccb15d29$var$Wf.current || $af3a2d87ccb15d29$var$$g ? ("function" === typeof y && ($af3a2d87ccb15d29$var$kh(b, c, y, d), n = b.memoizedState), (l = $af3a2d87ccb15d29$var$$g || $af3a2d87ccb15d29$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $af3a2d87ccb15d29$var$kj(a, b, c, d, f, e);
}
function $af3a2d87ccb15d29$var$kj(a, b, c, d, e, f) {
    $af3a2d87ccb15d29$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $af3a2d87ccb15d29$var$dg(b, c, !1), $af3a2d87ccb15d29$var$$i(a, b, f);
    d = b.stateNode;
    $af3a2d87ccb15d29$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $af3a2d87ccb15d29$var$Bh(b, a.child, null, f), b.child = $af3a2d87ccb15d29$var$Bh(b, null, h, f)) : $af3a2d87ccb15d29$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $af3a2d87ccb15d29$var$dg(b, c, !0);
    return b.child;
}
function $af3a2d87ccb15d29$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $af3a2d87ccb15d29$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $af3a2d87ccb15d29$var$ag(a, b.context, !1);
    $af3a2d87ccb15d29$var$Ih(a, b.containerInfo);
}
function $af3a2d87ccb15d29$var$mj(a, b, c, d, e) {
    $af3a2d87ccb15d29$var$Ig();
    $af3a2d87ccb15d29$var$Jg(e);
    b.flags |= 256;
    $af3a2d87ccb15d29$var$Yi(a, b, c, d);
    return b.child;
}
var $af3a2d87ccb15d29$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $af3a2d87ccb15d29$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $af3a2d87ccb15d29$var$pj(a, b, c) {
    var d = b.pendingProps, e = $af3a2d87ccb15d29$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, e & 1);
    if (null === a) {
        $af3a2d87ccb15d29$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $af3a2d87ccb15d29$var$qj(g, d, 0, null), a = $af3a2d87ccb15d29$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $af3a2d87ccb15d29$var$oj(c), b.memoizedState = $af3a2d87ccb15d29$var$nj, a) : $af3a2d87ccb15d29$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $af3a2d87ccb15d29$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $af3a2d87ccb15d29$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $af3a2d87ccb15d29$var$wh(h, f) : (f = $af3a2d87ccb15d29$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $af3a2d87ccb15d29$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $af3a2d87ccb15d29$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $af3a2d87ccb15d29$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $af3a2d87ccb15d29$var$rj(a, b) {
    b = $af3a2d87ccb15d29$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $af3a2d87ccb15d29$var$tj(a, b, c, d) {
    null !== d && $af3a2d87ccb15d29$var$Jg(d);
    $af3a2d87ccb15d29$var$Bh(b, a.child, null, c);
    a = $af3a2d87ccb15d29$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $af3a2d87ccb15d29$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $af3a2d87ccb15d29$var$Li(Error($af3a2d87ccb15d29$var$p(422))), $af3a2d87ccb15d29$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $af3a2d87ccb15d29$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $af3a2d87ccb15d29$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $af3a2d87ccb15d29$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $af3a2d87ccb15d29$var$oj(g);
        b.memoizedState = $af3a2d87ccb15d29$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $af3a2d87ccb15d29$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($af3a2d87ccb15d29$var$p(419));
        d = $af3a2d87ccb15d29$var$Li(f, d, void 0);
        return $af3a2d87ccb15d29$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($af3a2d87ccb15d29$var$Ug || h) {
        d = $af3a2d87ccb15d29$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $af3a2d87ccb15d29$var$Zg(a, e), $af3a2d87ccb15d29$var$mh(d, a, e, -1));
        }
        $af3a2d87ccb15d29$var$uj();
        d = $af3a2d87ccb15d29$var$Li(Error($af3a2d87ccb15d29$var$p(421)));
        return $af3a2d87ccb15d29$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $af3a2d87ccb15d29$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(e.nextSibling);
    $af3a2d87ccb15d29$var$xg = b;
    $af3a2d87ccb15d29$var$I = !0;
    $af3a2d87ccb15d29$var$zg = null;
    null !== a && ($af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$rg, $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$sg, $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$qg, $af3a2d87ccb15d29$var$rg = a.id, $af3a2d87ccb15d29$var$sg = a.overflow, $af3a2d87ccb15d29$var$qg = b);
    b = $af3a2d87ccb15d29$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $af3a2d87ccb15d29$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $af3a2d87ccb15d29$var$Sg(a.return, b, c);
}
function $af3a2d87ccb15d29$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $af3a2d87ccb15d29$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $af3a2d87ccb15d29$var$Yi(a, b, d.children, c);
    d = $af3a2d87ccb15d29$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $af3a2d87ccb15d29$var$wj(a, c, b);
            else if (19 === a.tag) $af3a2d87ccb15d29$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $af3a2d87ccb15d29$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $af3a2d87ccb15d29$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $af3a2d87ccb15d29$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $af3a2d87ccb15d29$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $af3a2d87ccb15d29$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $af3a2d87ccb15d29$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $af3a2d87ccb15d29$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $af3a2d87ccb15d29$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($af3a2d87ccb15d29$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $af3a2d87ccb15d29$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $af3a2d87ccb15d29$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $af3a2d87ccb15d29$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $af3a2d87ccb15d29$var$lj(b);
            $af3a2d87ccb15d29$var$Ig();
            break;
        case 5:
            $af3a2d87ccb15d29$var$Kh(b);
            break;
        case 1:
            $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$cg(b);
            break;
        case 4:
            $af3a2d87ccb15d29$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $af3a2d87ccb15d29$var$pj(a, b, c);
                $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1);
                a = $af3a2d87ccb15d29$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $af3a2d87ccb15d29$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $af3a2d87ccb15d29$var$ej(a, b, c);
    }
    return $af3a2d87ccb15d29$var$$i(a, b, c);
}
var $af3a2d87ccb15d29$var$Aj, $af3a2d87ccb15d29$var$Bj, $af3a2d87ccb15d29$var$Cj, $af3a2d87ccb15d29$var$Dj;
$af3a2d87ccb15d29$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$af3a2d87ccb15d29$var$Bj = function() {};
$af3a2d87ccb15d29$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $af3a2d87ccb15d29$var$Ya(a, e);
                d = $af3a2d87ccb15d29$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $af3a2d87ccb15d29$var$A({}, e, {
                    value: void 0
                });
                d = $af3a2d87ccb15d29$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $af3a2d87ccb15d29$var$gb(a, e);
                d = $af3a2d87ccb15d29$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $af3a2d87ccb15d29$var$Bf);
        }
        $af3a2d87ccb15d29$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $af3a2d87ccb15d29$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$af3a2d87ccb15d29$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $af3a2d87ccb15d29$var$Ej(a, b) {
    if (!$af3a2d87ccb15d29$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $af3a2d87ccb15d29$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $af3a2d87ccb15d29$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $af3a2d87ccb15d29$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $af3a2d87ccb15d29$var$S(b), null;
        case 1:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), $af3a2d87ccb15d29$var$S(b), null;
        case 3:
            d = b.stateNode;
            $af3a2d87ccb15d29$var$Jh();
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
            $af3a2d87ccb15d29$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $af3a2d87ccb15d29$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $af3a2d87ccb15d29$var$zg && ($af3a2d87ccb15d29$var$Gj($af3a2d87ccb15d29$var$zg), $af3a2d87ccb15d29$var$zg = null));
            $af3a2d87ccb15d29$var$Bj(a, b);
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 5:
            $af3a2d87ccb15d29$var$Lh(b);
            var e = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $af3a2d87ccb15d29$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($af3a2d87ccb15d29$var$p(166));
                    $af3a2d87ccb15d29$var$S(b);
                    return null;
                }
                a = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
                if ($af3a2d87ccb15d29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$af3a2d87ccb15d29$var$Of] = b;
                    d[$af3a2d87ccb15d29$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $af3a2d87ccb15d29$var$D("cancel", d);
                            $af3a2d87ccb15d29$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $af3a2d87ccb15d29$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $af3a2d87ccb15d29$var$lf.length; e++)$af3a2d87ccb15d29$var$D($af3a2d87ccb15d29$var$lf[e], d);
                            break;
                        case "source":
                            $af3a2d87ccb15d29$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $af3a2d87ccb15d29$var$D("error", d);
                            $af3a2d87ccb15d29$var$D("load", d);
                            break;
                        case "details":
                            $af3a2d87ccb15d29$var$D("toggle", d);
                            break;
                        case "input":
                            $af3a2d87ccb15d29$var$Za(d, f);
                            $af3a2d87ccb15d29$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $af3a2d87ccb15d29$var$D("invalid", d);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$hb(d, f), $af3a2d87ccb15d29$var$D("invalid", d);
                    }
                    $af3a2d87ccb15d29$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $af3a2d87ccb15d29$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $af3a2d87ccb15d29$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $af3a2d87ccb15d29$var$Va(d);
                            $af3a2d87ccb15d29$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$Va(d);
                            $af3a2d87ccb15d29$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $af3a2d87ccb15d29$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $af3a2d87ccb15d29$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$af3a2d87ccb15d29$var$Of] = b;
                    a[$af3a2d87ccb15d29$var$Pf] = d;
                    $af3a2d87ccb15d29$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $af3a2d87ccb15d29$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $af3a2d87ccb15d29$var$D("cancel", a);
                                $af3a2d87ccb15d29$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $af3a2d87ccb15d29$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $af3a2d87ccb15d29$var$lf.length; e++)$af3a2d87ccb15d29$var$D($af3a2d87ccb15d29$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $af3a2d87ccb15d29$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $af3a2d87ccb15d29$var$D("error", a);
                                $af3a2d87ccb15d29$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $af3a2d87ccb15d29$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $af3a2d87ccb15d29$var$Za(a, d);
                                e = $af3a2d87ccb15d29$var$Ya(a, d);
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $af3a2d87ccb15d29$var$A({}, d, {
                                    value: void 0
                                });
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            case "textarea":
                                $af3a2d87ccb15d29$var$hb(a, d);
                                e = $af3a2d87ccb15d29$var$gb(a, d);
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $af3a2d87ccb15d29$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $af3a2d87ccb15d29$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $af3a2d87ccb15d29$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $af3a2d87ccb15d29$var$ob(a, k) : "number" === typeof k && $af3a2d87ccb15d29$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $af3a2d87ccb15d29$var$D("scroll", a) : null != k && $af3a2d87ccb15d29$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $af3a2d87ccb15d29$var$Va(a);
                                $af3a2d87ccb15d29$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $af3a2d87ccb15d29$var$Va(a);
                                $af3a2d87ccb15d29$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $af3a2d87ccb15d29$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $af3a2d87ccb15d29$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $af3a2d87ccb15d29$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $af3a2d87ccb15d29$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $af3a2d87ccb15d29$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($af3a2d87ccb15d29$var$p(166));
                c = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
                $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
                if ($af3a2d87ccb15d29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$af3a2d87ccb15d29$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $af3a2d87ccb15d29$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $af3a2d87ccb15d29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$af3a2d87ccb15d29$var$Of] = b, b.stateNode = d;
            }
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 13:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($af3a2d87ccb15d29$var$I && null !== $af3a2d87ccb15d29$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $af3a2d87ccb15d29$var$Hg(), $af3a2d87ccb15d29$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $af3a2d87ccb15d29$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($af3a2d87ccb15d29$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($af3a2d87ccb15d29$var$p(317));
                        f[$af3a2d87ccb15d29$var$Of] = b;
                    } else $af3a2d87ccb15d29$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $af3a2d87ccb15d29$var$S(b);
                    f = !1;
                } else null !== $af3a2d87ccb15d29$var$zg && ($af3a2d87ccb15d29$var$Gj($af3a2d87ccb15d29$var$zg), $af3a2d87ccb15d29$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($af3a2d87ccb15d29$var$M.current & 1) ? 0 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 3) : $af3a2d87ccb15d29$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 4:
            return $af3a2d87ccb15d29$var$Jh(), $af3a2d87ccb15d29$var$Bj(a, b), null === a && $af3a2d87ccb15d29$var$sf(b.stateNode.containerInfo), $af3a2d87ccb15d29$var$S(b), null;
        case 10:
            return $af3a2d87ccb15d29$var$Rg(b.type._context), $af3a2d87ccb15d29$var$S(b), null;
        case 17:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), $af3a2d87ccb15d29$var$S(b), null;
        case 19:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            f = b.memoizedState;
            if (null === f) return $af3a2d87ccb15d29$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $af3a2d87ccb15d29$var$Ej(f, !1);
                else {
                    if (0 !== $af3a2d87ccb15d29$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $af3a2d87ccb15d29$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $af3a2d87ccb15d29$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $af3a2d87ccb15d29$var$B() > $af3a2d87ccb15d29$var$Hj && (b.flags |= 128, d = !0, $af3a2d87ccb15d29$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $af3a2d87ccb15d29$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $af3a2d87ccb15d29$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$af3a2d87ccb15d29$var$I) return $af3a2d87ccb15d29$var$S(b), null;
                    } else 2 * $af3a2d87ccb15d29$var$B() - f.renderingStartTime > $af3a2d87ccb15d29$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $af3a2d87ccb15d29$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $af3a2d87ccb15d29$var$B(), b.sibling = null, c = $af3a2d87ccb15d29$var$M.current, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, d ? c & 1 | 2 : c & 1), b;
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 22:
        case 23:
            return $af3a2d87ccb15d29$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($af3a2d87ccb15d29$var$gj & 1073741824) && ($af3a2d87ccb15d29$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $af3a2d87ccb15d29$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($af3a2d87ccb15d29$var$p(156, b.tag));
}
function $af3a2d87ccb15d29$var$Jj(a, b) {
    $af3a2d87ccb15d29$var$wg(b);
    switch(b.tag){
        case 1:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $af3a2d87ccb15d29$var$Jh(), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H), $af3a2d87ccb15d29$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $af3a2d87ccb15d29$var$Lh(b), null;
        case 13:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($af3a2d87ccb15d29$var$p(340));
                $af3a2d87ccb15d29$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M), null;
        case 4:
            return $af3a2d87ccb15d29$var$Jh(), null;
        case 10:
            return $af3a2d87ccb15d29$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $af3a2d87ccb15d29$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $af3a2d87ccb15d29$var$Kj = !1, $af3a2d87ccb15d29$var$U = !1, $af3a2d87ccb15d29$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $af3a2d87ccb15d29$var$V = null;
function $af3a2d87ccb15d29$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $af3a2d87ccb15d29$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $af3a2d87ccb15d29$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $af3a2d87ccb15d29$var$W(a, b, d);
    }
}
var $af3a2d87ccb15d29$var$Oj = !1;
function $af3a2d87ccb15d29$var$Pj(a, b) {
    $af3a2d87ccb15d29$var$Cf = $af3a2d87ccb15d29$var$dd;
    a = $af3a2d87ccb15d29$var$Me();
    if ($af3a2d87ccb15d29$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $af3a2d87ccb15d29$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $af3a2d87ccb15d29$var$dd = !1;
    for($af3a2d87ccb15d29$var$V = b; null !== $af3a2d87ccb15d29$var$V;)if (b = $af3a2d87ccb15d29$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $af3a2d87ccb15d29$var$V = a;
    else for(; null !== $af3a2d87ccb15d29$var$V;){
        b = $af3a2d87ccb15d29$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $af3a2d87ccb15d29$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(163));
            }
        } catch (F) {
            $af3a2d87ccb15d29$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $af3a2d87ccb15d29$var$V = a;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
    n = $af3a2d87ccb15d29$var$Oj;
    $af3a2d87ccb15d29$var$Oj = !1;
    return n;
}
function $af3a2d87ccb15d29$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $af3a2d87ccb15d29$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $af3a2d87ccb15d29$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $af3a2d87ccb15d29$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $af3a2d87ccb15d29$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $af3a2d87ccb15d29$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$af3a2d87ccb15d29$var$Of], delete b[$af3a2d87ccb15d29$var$Pf], delete b[$af3a2d87ccb15d29$var$of], delete b[$af3a2d87ccb15d29$var$Qf], delete b[$af3a2d87ccb15d29$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $af3a2d87ccb15d29$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $af3a2d87ccb15d29$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $af3a2d87ccb15d29$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $af3a2d87ccb15d29$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $af3a2d87ccb15d29$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($af3a2d87ccb15d29$var$Wj(a, b, c), a = a.sibling; null !== a;)$af3a2d87ccb15d29$var$Wj(a, b, c), a = a.sibling;
}
function $af3a2d87ccb15d29$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($af3a2d87ccb15d29$var$Xj(a, b, c), a = a.sibling; null !== a;)$af3a2d87ccb15d29$var$Xj(a, b, c), a = a.sibling;
}
var $af3a2d87ccb15d29$var$X = null, $af3a2d87ccb15d29$var$Yj = !1;
function $af3a2d87ccb15d29$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$af3a2d87ccb15d29$var$ak(a, b, c), c = c.sibling;
}
function $af3a2d87ccb15d29$var$ak(a, b, c) {
    if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onCommitFiberUnmount) try {
        $af3a2d87ccb15d29$var$lc.onCommitFiberUnmount($af3a2d87ccb15d29$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $af3a2d87ccb15d29$var$U || $af3a2d87ccb15d29$var$Mj(c, b);
        case 6:
            var d = $af3a2d87ccb15d29$var$X, e = $af3a2d87ccb15d29$var$Yj;
            $af3a2d87ccb15d29$var$X = null;
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            $af3a2d87ccb15d29$var$X = d;
            $af3a2d87ccb15d29$var$Yj = e;
            null !== $af3a2d87ccb15d29$var$X && ($af3a2d87ccb15d29$var$Yj ? (a = $af3a2d87ccb15d29$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $af3a2d87ccb15d29$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $af3a2d87ccb15d29$var$X && ($af3a2d87ccb15d29$var$Yj ? (a = $af3a2d87ccb15d29$var$X, c = c.stateNode, 8 === a.nodeType ? $af3a2d87ccb15d29$var$Kf(a.parentNode, c) : 1 === a.nodeType && $af3a2d87ccb15d29$var$Kf(a, c), $af3a2d87ccb15d29$var$bd(a)) : $af3a2d87ccb15d29$var$Kf($af3a2d87ccb15d29$var$X, c.stateNode));
            break;
        case 4:
            d = $af3a2d87ccb15d29$var$X;
            e = $af3a2d87ccb15d29$var$Yj;
            $af3a2d87ccb15d29$var$X = c.stateNode.containerInfo;
            $af3a2d87ccb15d29$var$Yj = !0;
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            $af3a2d87ccb15d29$var$X = d;
            $af3a2d87ccb15d29$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$af3a2d87ccb15d29$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $af3a2d87ccb15d29$var$Nj(c, b, g) : 0 !== (f & 4) && $af3a2d87ccb15d29$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 1:
            if (!$af3a2d87ccb15d29$var$U && ($af3a2d87ccb15d29$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $af3a2d87ccb15d29$var$W(c, b, h);
            }
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 21:
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($af3a2d87ccb15d29$var$U = (d = $af3a2d87ccb15d29$var$U) || null !== c.memoizedState, $af3a2d87ccb15d29$var$Zj(a, b, c), $af3a2d87ccb15d29$var$U = d) : $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        default:
            $af3a2d87ccb15d29$var$Zj(a, b, c);
    }
}
function $af3a2d87ccb15d29$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $af3a2d87ccb15d29$var$Lj);
        b.forEach(function(b) {
            var d = $af3a2d87ccb15d29$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $af3a2d87ccb15d29$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $af3a2d87ccb15d29$var$X = h.stateNode;
                        $af3a2d87ccb15d29$var$Yj = !1;
                        break a;
                    case 3:
                        $af3a2d87ccb15d29$var$X = h.stateNode.containerInfo;
                        $af3a2d87ccb15d29$var$Yj = !0;
                        break a;
                    case 4:
                        $af3a2d87ccb15d29$var$X = h.stateNode.containerInfo;
                        $af3a2d87ccb15d29$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $af3a2d87ccb15d29$var$X) throw Error($af3a2d87ccb15d29$var$p(160));
            $af3a2d87ccb15d29$var$ak(f, g, e);
            $af3a2d87ccb15d29$var$X = null;
            $af3a2d87ccb15d29$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $af3a2d87ccb15d29$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$af3a2d87ccb15d29$var$ek(b, a), b = b.sibling;
}
function $af3a2d87ccb15d29$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4) {
                try {
                    $af3a2d87ccb15d29$var$Qj(3, a, a.return), $af3a2d87ccb15d29$var$Rj(3, a);
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
                try {
                    $af3a2d87ccb15d29$var$Qj(5, a, a.return);
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 512 && null !== c && $af3a2d87ccb15d29$var$Mj(c, c.return);
            break;
        case 5:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 512 && null !== c && $af3a2d87ccb15d29$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $af3a2d87ccb15d29$var$ob(e, "");
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $af3a2d87ccb15d29$var$ab(e, f);
                    $af3a2d87ccb15d29$var$vb(h, g);
                    var l = $af3a2d87ccb15d29$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $af3a2d87ccb15d29$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $af3a2d87ccb15d29$var$nb(e, q) : "children" === m ? $af3a2d87ccb15d29$var$ob(e, q) : $af3a2d87ccb15d29$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $af3a2d87ccb15d29$var$bb(e, f);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $af3a2d87ccb15d29$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $af3a2d87ccb15d29$var$fb(e, !!f.multiple, f.defaultValue, !0) : $af3a2d87ccb15d29$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$af3a2d87ccb15d29$var$Pf] = f;
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($af3a2d87ccb15d29$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $af3a2d87ccb15d29$var$bd(b.containerInfo);
            } catch (t) {
                $af3a2d87ccb15d29$var$W(a, a.return, t);
            }
            break;
        case 4:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            break;
        case 13:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($af3a2d87ccb15d29$var$gk = $af3a2d87ccb15d29$var$B()));
            d & 4 && $af3a2d87ccb15d29$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($af3a2d87ccb15d29$var$U = (l = $af3a2d87ccb15d29$var$U) || m, $af3a2d87ccb15d29$var$dk(b, a), $af3a2d87ccb15d29$var$U = l) : $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($af3a2d87ccb15d29$var$V = a, m = a.child; null !== m;){
                    for(q = $af3a2d87ccb15d29$var$V = m; null !== $af3a2d87ccb15d29$var$V;){
                        r = $af3a2d87ccb15d29$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $af3a2d87ccb15d29$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $af3a2d87ccb15d29$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $af3a2d87ccb15d29$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $af3a2d87ccb15d29$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $af3a2d87ccb15d29$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $af3a2d87ccb15d29$var$V = y) : $af3a2d87ccb15d29$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $af3a2d87ccb15d29$var$rb("display", g));
                            } catch (t) {
                                $af3a2d87ccb15d29$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $af3a2d87ccb15d29$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 4 && $af3a2d87ccb15d29$var$bk(a);
            break;
        case 21:
            break;
        default:
            $af3a2d87ccb15d29$var$dk(b, a), $af3a2d87ccb15d29$var$fk(a);
    }
}
function $af3a2d87ccb15d29$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($af3a2d87ccb15d29$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($af3a2d87ccb15d29$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($af3a2d87ccb15d29$var$ob(e, ""), d.flags &= -33);
                    var f = $af3a2d87ccb15d29$var$Vj(a);
                    $af3a2d87ccb15d29$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $af3a2d87ccb15d29$var$Vj(a);
                    $af3a2d87ccb15d29$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(161));
            }
        } catch (k) {
            $af3a2d87ccb15d29$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $af3a2d87ccb15d29$var$ik(a, b, c) {
    $af3a2d87ccb15d29$var$V = a;
    $af3a2d87ccb15d29$var$jk(a, b, c);
}
function $af3a2d87ccb15d29$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $af3a2d87ccb15d29$var$V;){
        var e = $af3a2d87ccb15d29$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $af3a2d87ccb15d29$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $af3a2d87ccb15d29$var$U;
                h = $af3a2d87ccb15d29$var$Kj;
                var l = $af3a2d87ccb15d29$var$U;
                $af3a2d87ccb15d29$var$Kj = g;
                if (($af3a2d87ccb15d29$var$U = k) && !l) for($af3a2d87ccb15d29$var$V = e; null !== $af3a2d87ccb15d29$var$V;)g = $af3a2d87ccb15d29$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $af3a2d87ccb15d29$var$kk(e) : null !== k ? (k.return = g, $af3a2d87ccb15d29$var$V = k) : $af3a2d87ccb15d29$var$kk(e);
                for(; null !== f;)$af3a2d87ccb15d29$var$V = f, $af3a2d87ccb15d29$var$jk(f, b, c), f = f.sibling;
                $af3a2d87ccb15d29$var$V = e;
                $af3a2d87ccb15d29$var$Kj = h;
                $af3a2d87ccb15d29$var$U = l;
            }
            $af3a2d87ccb15d29$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $af3a2d87ccb15d29$var$V = f) : $af3a2d87ccb15d29$var$lk(a, b, c);
    }
}
function $af3a2d87ccb15d29$var$lk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $af3a2d87ccb15d29$var$U || $af3a2d87ccb15d29$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$af3a2d87ccb15d29$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $af3a2d87ccb15d29$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $af3a2d87ccb15d29$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $af3a2d87ccb15d29$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $af3a2d87ccb15d29$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($af3a2d87ccb15d29$var$p(163));
                }
                $af3a2d87ccb15d29$var$U || b.flags & 512 && $af3a2d87ccb15d29$var$Sj(b);
            } catch (r) {
                $af3a2d87ccb15d29$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af3a2d87ccb15d29$var$V = c;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
function $af3a2d87ccb15d29$var$hk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af3a2d87ccb15d29$var$V = c;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
function $af3a2d87ccb15d29$var$kk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Rj(4, b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $af3a2d87ccb15d29$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Sj(b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Sj(b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $af3a2d87ccb15d29$var$W(b, b.return, k);
        }
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $af3a2d87ccb15d29$var$V = h;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
var $af3a2d87ccb15d29$var$mk = Math.ceil, $af3a2d87ccb15d29$var$nk = $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher, $af3a2d87ccb15d29$var$ok = $af3a2d87ccb15d29$var$ua.ReactCurrentOwner, $af3a2d87ccb15d29$var$pk = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$K = 0, $af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Y = null, $af3a2d87ccb15d29$var$Z = 0, $af3a2d87ccb15d29$var$gj = 0, $af3a2d87ccb15d29$var$fj = $af3a2d87ccb15d29$var$Uf(0), $af3a2d87ccb15d29$var$T = 0, $af3a2d87ccb15d29$var$qk = null, $af3a2d87ccb15d29$var$hh = 0, $af3a2d87ccb15d29$var$rk = 0, $af3a2d87ccb15d29$var$sk = 0, $af3a2d87ccb15d29$var$tk = null, $af3a2d87ccb15d29$var$uk = null, $af3a2d87ccb15d29$var$gk = 0, $af3a2d87ccb15d29$var$Hj = Infinity, $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Pi = !1, $af3a2d87ccb15d29$var$Qi = null, $af3a2d87ccb15d29$var$Si = null, $af3a2d87ccb15d29$var$wk = !1, $af3a2d87ccb15d29$var$xk = null, $af3a2d87ccb15d29$var$yk = 0, $af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = null, $af3a2d87ccb15d29$var$Bk = -1, $af3a2d87ccb15d29$var$Ck = 0;
function $af3a2d87ccb15d29$var$L() {
    return 0 !== ($af3a2d87ccb15d29$var$K & 6) ? $af3a2d87ccb15d29$var$B() : -1 !== $af3a2d87ccb15d29$var$Bk ? $af3a2d87ccb15d29$var$Bk : $af3a2d87ccb15d29$var$Bk = $af3a2d87ccb15d29$var$B();
}
function $af3a2d87ccb15d29$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($af3a2d87ccb15d29$var$K & 2) && 0 !== $af3a2d87ccb15d29$var$Z) return $af3a2d87ccb15d29$var$Z & -$af3a2d87ccb15d29$var$Z;
    if (null !== $af3a2d87ccb15d29$var$Kg.transition) return 0 === $af3a2d87ccb15d29$var$Ck && ($af3a2d87ccb15d29$var$Ck = $af3a2d87ccb15d29$var$yc()), $af3a2d87ccb15d29$var$Ck;
    a = $af3a2d87ccb15d29$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $af3a2d87ccb15d29$var$jd(a.type);
    return a;
}
function $af3a2d87ccb15d29$var$mh(a, b, c, d) {
    if (50 < $af3a2d87ccb15d29$var$zk) throw $af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = null, Error($af3a2d87ccb15d29$var$p(185));
    $af3a2d87ccb15d29$var$Ac(a, c, d);
    if (0 === ($af3a2d87ccb15d29$var$K & 2) || a !== $af3a2d87ccb15d29$var$R) a === $af3a2d87ccb15d29$var$R && (0 === ($af3a2d87ccb15d29$var$K & 2) && ($af3a2d87ccb15d29$var$rk |= c), 4 === $af3a2d87ccb15d29$var$T && $af3a2d87ccb15d29$var$Dk(a, $af3a2d87ccb15d29$var$Z)), $af3a2d87ccb15d29$var$Ek(a, d), 1 === c && 0 === $af3a2d87ccb15d29$var$K && 0 === (b.mode & 1) && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$fg && $af3a2d87ccb15d29$var$jg());
}
function $af3a2d87ccb15d29$var$Ek(a, b) {
    var c = a.callbackNode;
    $af3a2d87ccb15d29$var$wc(a, b);
    var d = $af3a2d87ccb15d29$var$uc(a, a === $af3a2d87ccb15d29$var$R ? $af3a2d87ccb15d29$var$Z : 0);
    if (0 === d) null !== c && $af3a2d87ccb15d29$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $af3a2d87ccb15d29$var$bc(c);
        if (1 === b) 0 === a.tag ? $af3a2d87ccb15d29$var$ig($af3a2d87ccb15d29$var$Fk.bind(null, a)) : $af3a2d87ccb15d29$var$hg($af3a2d87ccb15d29$var$Fk.bind(null, a)), $af3a2d87ccb15d29$var$Jf(function() {
            0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$jg();
        }), c = null;
        else {
            switch($af3a2d87ccb15d29$var$Dc(d)){
                case 1:
                    c = $af3a2d87ccb15d29$var$fc;
                    break;
                case 4:
                    c = $af3a2d87ccb15d29$var$gc;
                    break;
                case 16:
                    c = $af3a2d87ccb15d29$var$hc;
                    break;
                case 536870912:
                    c = $af3a2d87ccb15d29$var$jc;
                    break;
                default:
                    c = $af3a2d87ccb15d29$var$hc;
            }
            c = $af3a2d87ccb15d29$var$Gk(c, $af3a2d87ccb15d29$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $af3a2d87ccb15d29$var$Hk(a, b) {
    $af3a2d87ccb15d29$var$Bk = -1;
    $af3a2d87ccb15d29$var$Ck = 0;
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    var c = a.callbackNode;
    if ($af3a2d87ccb15d29$var$Ik() && a.callbackNode !== c) return null;
    var d = $af3a2d87ccb15d29$var$uc(a, a === $af3a2d87ccb15d29$var$R ? $af3a2d87ccb15d29$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $af3a2d87ccb15d29$var$Jk(a, d);
    else {
        b = d;
        var e = $af3a2d87ccb15d29$var$K;
        $af3a2d87ccb15d29$var$K |= 2;
        var f = $af3a2d87ccb15d29$var$Kk();
        if ($af3a2d87ccb15d29$var$R !== a || $af3a2d87ccb15d29$var$Z !== b) $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$Lk(a, b);
        for(;;)try {
            $af3a2d87ccb15d29$var$Mk();
            break;
        } catch (h) {
            $af3a2d87ccb15d29$var$Nk(a, h);
        }
        $af3a2d87ccb15d29$var$Qg();
        $af3a2d87ccb15d29$var$nk.current = f;
        $af3a2d87ccb15d29$var$K = e;
        null !== $af3a2d87ccb15d29$var$Y ? b = 0 : ($af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Z = 0, b = $af3a2d87ccb15d29$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $af3a2d87ccb15d29$var$xc(a), 0 !== e && (d = e, b = $af3a2d87ccb15d29$var$Ok(a, e)));
        if (1 === b) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, d), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
        if (6 === b) $af3a2d87ccb15d29$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$af3a2d87ccb15d29$var$Pk(e) && (b = $af3a2d87ccb15d29$var$Jk(a, d), 2 === b && (f = $af3a2d87ccb15d29$var$xc(a), 0 !== f && (d = f, b = $af3a2d87ccb15d29$var$Ok(a, f))), 1 === b)) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, d), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($af3a2d87ccb15d29$var$p(345));
                case 2:
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 3:
                    $af3a2d87ccb15d29$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $af3a2d87ccb15d29$var$gk + 500 - $af3a2d87ccb15d29$var$B(), 10 < b)) {
                        if (0 !== $af3a2d87ccb15d29$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $af3a2d87ccb15d29$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $af3a2d87ccb15d29$var$Ff($af3a2d87ccb15d29$var$Qk.bind(null, a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk), b);
                        break;
                    }
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 4:
                    $af3a2d87ccb15d29$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $af3a2d87ccb15d29$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $af3a2d87ccb15d29$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $af3a2d87ccb15d29$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $af3a2d87ccb15d29$var$Ff($af3a2d87ccb15d29$var$Qk.bind(null, a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk), d);
                        break;
                    }
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 5:
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(329));
            }
        }
    }
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    return a.callbackNode === c ? $af3a2d87ccb15d29$var$Hk.bind(null, a) : null;
}
function $af3a2d87ccb15d29$var$Ok(a, b) {
    var c = $af3a2d87ccb15d29$var$tk;
    a.current.memoizedState.isDehydrated && ($af3a2d87ccb15d29$var$Lk(a, b).flags |= 256);
    a = $af3a2d87ccb15d29$var$Jk(a, b);
    2 !== a && (b = $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$uk = c, null !== b && $af3a2d87ccb15d29$var$Gj(b));
    return a;
}
function $af3a2d87ccb15d29$var$Gj(a) {
    null === $af3a2d87ccb15d29$var$uk ? $af3a2d87ccb15d29$var$uk = a : $af3a2d87ccb15d29$var$uk.push.apply($af3a2d87ccb15d29$var$uk, a);
}
function $af3a2d87ccb15d29$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$af3a2d87ccb15d29$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Dk(a, b) {
    b &= ~$af3a2d87ccb15d29$var$sk;
    b &= ~$af3a2d87ccb15d29$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $af3a2d87ccb15d29$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $af3a2d87ccb15d29$var$Fk(a) {
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    $af3a2d87ccb15d29$var$Ik();
    var b = $af3a2d87ccb15d29$var$uc(a, 0);
    if (0 === (b & 1)) return $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), null;
    var c = $af3a2d87ccb15d29$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $af3a2d87ccb15d29$var$xc(a);
        0 !== d && (b = d, c = $af3a2d87ccb15d29$var$Ok(a, d));
    }
    if (1 === c) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, b), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
    if (6 === c) throw Error($af3a2d87ccb15d29$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    return null;
}
function $af3a2d87ccb15d29$var$Rk(a, b) {
    var c = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 1;
    try {
        return a(b);
    } finally{
        $af3a2d87ccb15d29$var$K = c, 0 === $af3a2d87ccb15d29$var$K && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$fg && $af3a2d87ccb15d29$var$jg());
    }
}
function $af3a2d87ccb15d29$var$Sk(a) {
    null !== $af3a2d87ccb15d29$var$xk && 0 === $af3a2d87ccb15d29$var$xk.tag && 0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$Ik();
    var b = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 1;
    var c = $af3a2d87ccb15d29$var$pk.transition, d = $af3a2d87ccb15d29$var$C;
    try {
        if ($af3a2d87ccb15d29$var$pk.transition = null, $af3a2d87ccb15d29$var$C = 1, a) return a();
    } finally{
        $af3a2d87ccb15d29$var$C = d, $af3a2d87ccb15d29$var$pk.transition = c, $af3a2d87ccb15d29$var$K = b, 0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$jg();
    }
}
function $af3a2d87ccb15d29$var$Ij() {
    $af3a2d87ccb15d29$var$gj = $af3a2d87ccb15d29$var$fj.current;
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$fj);
}
function $af3a2d87ccb15d29$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $af3a2d87ccb15d29$var$Gf(c));
    if (null !== $af3a2d87ccb15d29$var$Y) for(c = $af3a2d87ccb15d29$var$Y.return; null !== c;){
        var d = c;
        $af3a2d87ccb15d29$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $af3a2d87ccb15d29$var$$f();
                break;
            case 3:
                $af3a2d87ccb15d29$var$Jh();
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
                $af3a2d87ccb15d29$var$Oh();
                break;
            case 5:
                $af3a2d87ccb15d29$var$Lh(d);
                break;
            case 4:
                $af3a2d87ccb15d29$var$Jh();
                break;
            case 13:
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
                break;
            case 19:
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
                break;
            case 10:
                $af3a2d87ccb15d29$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $af3a2d87ccb15d29$var$Ij();
        }
        c = c.return;
    }
    $af3a2d87ccb15d29$var$R = a;
    $af3a2d87ccb15d29$var$Y = a = $af3a2d87ccb15d29$var$wh(a.current, null);
    $af3a2d87ccb15d29$var$Z = $af3a2d87ccb15d29$var$gj = b;
    $af3a2d87ccb15d29$var$T = 0;
    $af3a2d87ccb15d29$var$qk = null;
    $af3a2d87ccb15d29$var$sk = $af3a2d87ccb15d29$var$rk = $af3a2d87ccb15d29$var$hh = 0;
    $af3a2d87ccb15d29$var$uk = $af3a2d87ccb15d29$var$tk = null;
    if (null !== $af3a2d87ccb15d29$var$Wg) {
        for(b = 0; b < $af3a2d87ccb15d29$var$Wg.length; b++)if (c = $af3a2d87ccb15d29$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $af3a2d87ccb15d29$var$Wg = null;
    }
    return a;
}
function $af3a2d87ccb15d29$var$Nk(a, b) {
    do {
        var c = $af3a2d87ccb15d29$var$Y;
        try {
            $af3a2d87ccb15d29$var$Qg();
            $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$ai;
            if ($af3a2d87ccb15d29$var$Sh) {
                for(var d = $af3a2d87ccb15d29$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $af3a2d87ccb15d29$var$Sh = !1;
            }
            $af3a2d87ccb15d29$var$Rh = 0;
            $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = $af3a2d87ccb15d29$var$N = null;
            $af3a2d87ccb15d29$var$Th = !1;
            $af3a2d87ccb15d29$var$Uh = 0;
            $af3a2d87ccb15d29$var$ok.current = null;
            if (null === c || null === c.return) {
                $af3a2d87ccb15d29$var$T = 1;
                $af3a2d87ccb15d29$var$qk = b;
                $af3a2d87ccb15d29$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $af3a2d87ccb15d29$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $af3a2d87ccb15d29$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $af3a2d87ccb15d29$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $af3a2d87ccb15d29$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $af3a2d87ccb15d29$var$Ti(f, l, b);
                            $af3a2d87ccb15d29$var$uj();
                            break a;
                        }
                        k = Error($af3a2d87ccb15d29$var$p(426));
                    }
                } else if ($af3a2d87ccb15d29$var$I && h.mode & 1) {
                    var J = $af3a2d87ccb15d29$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $af3a2d87ccb15d29$var$Wi(J, g, h, f, b);
                        $af3a2d87ccb15d29$var$Jg($af3a2d87ccb15d29$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $af3a2d87ccb15d29$var$Ki(k, h);
                4 !== $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 2);
                null === $af3a2d87ccb15d29$var$tk ? $af3a2d87ccb15d29$var$tk = [
                    f
                ] : $af3a2d87ccb15d29$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $af3a2d87ccb15d29$var$Oi(f, k, b);
                            $af3a2d87ccb15d29$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $af3a2d87ccb15d29$var$Si || !$af3a2d87ccb15d29$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $af3a2d87ccb15d29$var$Ri(f, h, b);
                                $af3a2d87ccb15d29$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $af3a2d87ccb15d29$var$Tk(c);
        } catch (na) {
            b = na;
            $af3a2d87ccb15d29$var$Y === c && null !== c && ($af3a2d87ccb15d29$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $af3a2d87ccb15d29$var$Kk() {
    var a = $af3a2d87ccb15d29$var$nk.current;
    $af3a2d87ccb15d29$var$nk.current = $af3a2d87ccb15d29$var$ai;
    return null === a ? $af3a2d87ccb15d29$var$ai : a;
}
function $af3a2d87ccb15d29$var$uj() {
    if (0 === $af3a2d87ccb15d29$var$T || 3 === $af3a2d87ccb15d29$var$T || 2 === $af3a2d87ccb15d29$var$T) $af3a2d87ccb15d29$var$T = 4;
    null === $af3a2d87ccb15d29$var$R || 0 === ($af3a2d87ccb15d29$var$hh & 268435455) && 0 === ($af3a2d87ccb15d29$var$rk & 268435455) || $af3a2d87ccb15d29$var$Dk($af3a2d87ccb15d29$var$R, $af3a2d87ccb15d29$var$Z);
}
function $af3a2d87ccb15d29$var$Jk(a, b) {
    var c = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 2;
    var d = $af3a2d87ccb15d29$var$Kk();
    if ($af3a2d87ccb15d29$var$R !== a || $af3a2d87ccb15d29$var$Z !== b) $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Lk(a, b);
    for(;;)try {
        $af3a2d87ccb15d29$var$Uk();
        break;
    } catch (e) {
        $af3a2d87ccb15d29$var$Nk(a, e);
    }
    $af3a2d87ccb15d29$var$Qg();
    $af3a2d87ccb15d29$var$K = c;
    $af3a2d87ccb15d29$var$nk.current = d;
    if (null !== $af3a2d87ccb15d29$var$Y) throw Error($af3a2d87ccb15d29$var$p(261));
    $af3a2d87ccb15d29$var$R = null;
    $af3a2d87ccb15d29$var$Z = 0;
    return $af3a2d87ccb15d29$var$T;
}
function $af3a2d87ccb15d29$var$Uk() {
    for(; null !== $af3a2d87ccb15d29$var$Y;)$af3a2d87ccb15d29$var$Vk($af3a2d87ccb15d29$var$Y);
}
function $af3a2d87ccb15d29$var$Mk() {
    for(; null !== $af3a2d87ccb15d29$var$Y && !$af3a2d87ccb15d29$var$cc();)$af3a2d87ccb15d29$var$Vk($af3a2d87ccb15d29$var$Y);
}
function $af3a2d87ccb15d29$var$Vk(a) {
    var b = $af3a2d87ccb15d29$var$Wk(a.alternate, a, $af3a2d87ccb15d29$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $af3a2d87ccb15d29$var$Tk(a) : $af3a2d87ccb15d29$var$Y = b;
    $af3a2d87ccb15d29$var$ok.current = null;
}
function $af3a2d87ccb15d29$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $af3a2d87ccb15d29$var$Fj(c, b, $af3a2d87ccb15d29$var$gj), null !== c) {
                $af3a2d87ccb15d29$var$Y = c;
                return;
            }
        } else {
            c = $af3a2d87ccb15d29$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $af3a2d87ccb15d29$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $af3a2d87ccb15d29$var$T = 6;
                $af3a2d87ccb15d29$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $af3a2d87ccb15d29$var$Y = b;
            return;
        }
        $af3a2d87ccb15d29$var$Y = b = a;
    }while (null !== b);
    0 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 5);
}
function $af3a2d87ccb15d29$var$Qk(a, b, c) {
    var d = $af3a2d87ccb15d29$var$C, e = $af3a2d87ccb15d29$var$pk.transition;
    try {
        $af3a2d87ccb15d29$var$pk.transition = null, $af3a2d87ccb15d29$var$C = 1, $af3a2d87ccb15d29$var$Xk(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$pk.transition = e, $af3a2d87ccb15d29$var$C = d;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Xk(a, b, c, d) {
    do $af3a2d87ccb15d29$var$Ik();
    while (null !== $af3a2d87ccb15d29$var$xk);
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($af3a2d87ccb15d29$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $af3a2d87ccb15d29$var$Bc(a, f);
    a === $af3a2d87ccb15d29$var$R && ($af3a2d87ccb15d29$var$Y = $af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $af3a2d87ccb15d29$var$wk || ($af3a2d87ccb15d29$var$wk = !0, $af3a2d87ccb15d29$var$Gk($af3a2d87ccb15d29$var$hc, function() {
        $af3a2d87ccb15d29$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $af3a2d87ccb15d29$var$pk.transition;
        $af3a2d87ccb15d29$var$pk.transition = null;
        var g = $af3a2d87ccb15d29$var$C;
        $af3a2d87ccb15d29$var$C = 1;
        var h = $af3a2d87ccb15d29$var$K;
        $af3a2d87ccb15d29$var$K |= 4;
        $af3a2d87ccb15d29$var$ok.current = null;
        $af3a2d87ccb15d29$var$Pj(a, c);
        $af3a2d87ccb15d29$var$ek(c, a);
        $af3a2d87ccb15d29$var$Oe($af3a2d87ccb15d29$var$Df);
        $af3a2d87ccb15d29$var$dd = !!$af3a2d87ccb15d29$var$Cf;
        $af3a2d87ccb15d29$var$Df = $af3a2d87ccb15d29$var$Cf = null;
        a.current = c;
        $af3a2d87ccb15d29$var$ik(c, a, e);
        $af3a2d87ccb15d29$var$dc();
        $af3a2d87ccb15d29$var$K = h;
        $af3a2d87ccb15d29$var$C = g;
        $af3a2d87ccb15d29$var$pk.transition = f;
    } else a.current = c;
    $af3a2d87ccb15d29$var$wk && ($af3a2d87ccb15d29$var$wk = !1, $af3a2d87ccb15d29$var$xk = a, $af3a2d87ccb15d29$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($af3a2d87ccb15d29$var$Si = null);
    $af3a2d87ccb15d29$var$mc(c.stateNode, d);
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($af3a2d87ccb15d29$var$Pi) throw $af3a2d87ccb15d29$var$Pi = !1, a = $af3a2d87ccb15d29$var$Qi, $af3a2d87ccb15d29$var$Qi = null, a;
    0 !== ($af3a2d87ccb15d29$var$yk & 1) && 0 !== a.tag && $af3a2d87ccb15d29$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $af3a2d87ccb15d29$var$Ak ? $af3a2d87ccb15d29$var$zk++ : ($af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = a) : $af3a2d87ccb15d29$var$zk = 0;
    $af3a2d87ccb15d29$var$jg();
    return null;
}
function $af3a2d87ccb15d29$var$Ik() {
    if (null !== $af3a2d87ccb15d29$var$xk) {
        var a = $af3a2d87ccb15d29$var$Dc($af3a2d87ccb15d29$var$yk), b = $af3a2d87ccb15d29$var$pk.transition, c = $af3a2d87ccb15d29$var$C;
        try {
            $af3a2d87ccb15d29$var$pk.transition = null;
            $af3a2d87ccb15d29$var$C = 16 > a ? 16 : a;
            if (null === $af3a2d87ccb15d29$var$xk) var d = !1;
            else {
                a = $af3a2d87ccb15d29$var$xk;
                $af3a2d87ccb15d29$var$xk = null;
                $af3a2d87ccb15d29$var$yk = 0;
                if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(331));
                var e = $af3a2d87ccb15d29$var$K;
                $af3a2d87ccb15d29$var$K |= 4;
                for($af3a2d87ccb15d29$var$V = a.current; null !== $af3a2d87ccb15d29$var$V;){
                    var f = $af3a2d87ccb15d29$var$V, g = f.child;
                    if (0 !== ($af3a2d87ccb15d29$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($af3a2d87ccb15d29$var$V = l; null !== $af3a2d87ccb15d29$var$V;){
                                    var m = $af3a2d87ccb15d29$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $af3a2d87ccb15d29$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $af3a2d87ccb15d29$var$V = q;
                                    else for(; null !== $af3a2d87ccb15d29$var$V;){
                                        m = $af3a2d87ccb15d29$var$V;
                                        var r = m.sibling, y = m.return;
                                        $af3a2d87ccb15d29$var$Tj(m);
                                        if (m === l) {
                                            $af3a2d87ccb15d29$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $af3a2d87ccb15d29$var$V = r;
                                            break;
                                        }
                                        $af3a2d87ccb15d29$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $af3a2d87ccb15d29$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $af3a2d87ccb15d29$var$V = g;
                    else b: for(; null !== $af3a2d87ccb15d29$var$V;){
                        f = $af3a2d87ccb15d29$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $af3a2d87ccb15d29$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $af3a2d87ccb15d29$var$V = x;
                            break b;
                        }
                        $af3a2d87ccb15d29$var$V = f.return;
                    }
                }
                var w = a.current;
                for($af3a2d87ccb15d29$var$V = w; null !== $af3a2d87ccb15d29$var$V;){
                    g = $af3a2d87ccb15d29$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $af3a2d87ccb15d29$var$V = u;
                    else b: for(g = w; null !== $af3a2d87ccb15d29$var$V;){
                        h = $af3a2d87ccb15d29$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $af3a2d87ccb15d29$var$Rj(9, h);
                            }
                        } catch (na) {
                            $af3a2d87ccb15d29$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $af3a2d87ccb15d29$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $af3a2d87ccb15d29$var$V = F;
                            break b;
                        }
                        $af3a2d87ccb15d29$var$V = h.return;
                    }
                }
                $af3a2d87ccb15d29$var$K = e;
                $af3a2d87ccb15d29$var$jg();
                if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onPostCommitFiberRoot) try {
                    $af3a2d87ccb15d29$var$lc.onPostCommitFiberRoot($af3a2d87ccb15d29$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $af3a2d87ccb15d29$var$C = c, $af3a2d87ccb15d29$var$pk.transition = b;
        }
    }
    return !1;
}
function $af3a2d87ccb15d29$var$Yk(a, b, c) {
    b = $af3a2d87ccb15d29$var$Ki(c, b);
    b = $af3a2d87ccb15d29$var$Oi(a, b, 1);
    a = $af3a2d87ccb15d29$var$dh(a, b, 1);
    b = $af3a2d87ccb15d29$var$L();
    null !== a && ($af3a2d87ccb15d29$var$Ac(a, 1, b), $af3a2d87ccb15d29$var$Ek(a, b));
}
function $af3a2d87ccb15d29$var$W(a, b, c) {
    if (3 === a.tag) $af3a2d87ccb15d29$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $af3a2d87ccb15d29$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $af3a2d87ccb15d29$var$Si || !$af3a2d87ccb15d29$var$Si.has(d))) {
                a = $af3a2d87ccb15d29$var$Ki(c, a);
                a = $af3a2d87ccb15d29$var$Ri(b, a, 1);
                b = $af3a2d87ccb15d29$var$dh(b, a, 1);
                a = $af3a2d87ccb15d29$var$L();
                null !== b && ($af3a2d87ccb15d29$var$Ac(b, 1, a), $af3a2d87ccb15d29$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $af3a2d87ccb15d29$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $af3a2d87ccb15d29$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $af3a2d87ccb15d29$var$R === a && ($af3a2d87ccb15d29$var$Z & c) === c && (4 === $af3a2d87ccb15d29$var$T || 3 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$Z & 130023424) === $af3a2d87ccb15d29$var$Z && 500 > $af3a2d87ccb15d29$var$B() - $af3a2d87ccb15d29$var$gk ? $af3a2d87ccb15d29$var$Lk(a, 0) : $af3a2d87ccb15d29$var$sk |= c);
    $af3a2d87ccb15d29$var$Ek(a, b);
}
function $af3a2d87ccb15d29$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $af3a2d87ccb15d29$var$sc, $af3a2d87ccb15d29$var$sc <<= 1, 0 === ($af3a2d87ccb15d29$var$sc & 130023424) && ($af3a2d87ccb15d29$var$sc = 4194304)));
    var c = $af3a2d87ccb15d29$var$L();
    a = $af3a2d87ccb15d29$var$Zg(a, b);
    null !== a && ($af3a2d87ccb15d29$var$Ac(a, b, c), $af3a2d87ccb15d29$var$Ek(a, c));
}
function $af3a2d87ccb15d29$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $af3a2d87ccb15d29$var$Zk(a, c);
}
function $af3a2d87ccb15d29$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($af3a2d87ccb15d29$var$p(314));
    }
    null !== d && d.delete(b);
    $af3a2d87ccb15d29$var$Zk(a, c);
}
var $af3a2d87ccb15d29$var$Wk;
$af3a2d87ccb15d29$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $af3a2d87ccb15d29$var$Wf.current) $af3a2d87ccb15d29$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $af3a2d87ccb15d29$var$Ug = !1, $af3a2d87ccb15d29$var$zj(a, b, c);
            $af3a2d87ccb15d29$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $af3a2d87ccb15d29$var$Ug = !1, $af3a2d87ccb15d29$var$I && 0 !== (b.flags & 1048576) && $af3a2d87ccb15d29$var$ug(b, $af3a2d87ccb15d29$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $af3a2d87ccb15d29$var$jj(a, b);
            a = b.pendingProps;
            var e = $af3a2d87ccb15d29$var$Yf(b, $af3a2d87ccb15d29$var$H.current);
            $af3a2d87ccb15d29$var$Tg(b, c);
            e = $af3a2d87ccb15d29$var$Xh(null, b, d, a, e, c);
            var f = $af3a2d87ccb15d29$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $af3a2d87ccb15d29$var$Zf(d) ? (f = !0, $af3a2d87ccb15d29$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $af3a2d87ccb15d29$var$ah(b), e.updater = $af3a2d87ccb15d29$var$nh, b.stateNode = e, e._reactInternals = b, $af3a2d87ccb15d29$var$rh(b, d, a, c), b = $af3a2d87ccb15d29$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $af3a2d87ccb15d29$var$I && f && $af3a2d87ccb15d29$var$vg(b), $af3a2d87ccb15d29$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $af3a2d87ccb15d29$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $af3a2d87ccb15d29$var$$k(d);
                a = $af3a2d87ccb15d29$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $af3a2d87ccb15d29$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $af3a2d87ccb15d29$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $af3a2d87ccb15d29$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $af3a2d87ccb15d29$var$aj(null, b, d, $af3a2d87ccb15d29$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($af3a2d87ccb15d29$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $af3a2d87ccb15d29$var$lj(b);
                if (null === a) throw Error($af3a2d87ccb15d29$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $af3a2d87ccb15d29$var$bh(a, b);
                $af3a2d87ccb15d29$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $af3a2d87ccb15d29$var$Ki(Error($af3a2d87ccb15d29$var$p(423)), b);
                        b = $af3a2d87ccb15d29$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $af3a2d87ccb15d29$var$Ki(Error($af3a2d87ccb15d29$var$p(424)), b);
                        b = $af3a2d87ccb15d29$var$mj(a, b, d, c, e);
                        break a;
                    } else for($af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(b.stateNode.containerInfo.firstChild), $af3a2d87ccb15d29$var$xg = b, $af3a2d87ccb15d29$var$I = !0, $af3a2d87ccb15d29$var$zg = null, c = $af3a2d87ccb15d29$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $af3a2d87ccb15d29$var$Ig();
                    if (d === e) {
                        b = $af3a2d87ccb15d29$var$$i(a, b, c);
                        break a;
                    }
                    $af3a2d87ccb15d29$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $af3a2d87ccb15d29$var$Kh(b), null === a && $af3a2d87ccb15d29$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $af3a2d87ccb15d29$var$Ef(d, e) ? g = null : null !== f && $af3a2d87ccb15d29$var$Ef(d, f) && (b.flags |= 32), $af3a2d87ccb15d29$var$hj(a, b), $af3a2d87ccb15d29$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $af3a2d87ccb15d29$var$Eg(b), null;
        case 13:
            return $af3a2d87ccb15d29$var$pj(a, b, c);
        case 4:
            return $af3a2d87ccb15d29$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $af3a2d87ccb15d29$var$Bh(b, null, d, c) : $af3a2d87ccb15d29$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$Zi(a, b, d, e, c);
        case 7:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($af3a2d87ccb15d29$var$He(f.value, g)) {
                        if (f.children === e.children && !$af3a2d87ccb15d29$var$Wf.current) {
                            b = $af3a2d87ccb15d29$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $af3a2d87ccb15d29$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $af3a2d87ccb15d29$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($af3a2d87ccb15d29$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $af3a2d87ccb15d29$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $af3a2d87ccb15d29$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $af3a2d87ccb15d29$var$Tg(b, c), e = $af3a2d87ccb15d29$var$Vg(e), d = d(e), b.flags |= 1, $af3a2d87ccb15d29$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $af3a2d87ccb15d29$var$Lg(d, b.pendingProps), e = $af3a2d87ccb15d29$var$Lg(d.type, e), $af3a2d87ccb15d29$var$aj(a, b, d, e, c);
        case 15:
            return $af3a2d87ccb15d29$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$jj(a, b), b.tag = 1, $af3a2d87ccb15d29$var$Zf(d) ? (a = !0, $af3a2d87ccb15d29$var$cg(b)) : a = !1, $af3a2d87ccb15d29$var$Tg(b, c), $af3a2d87ccb15d29$var$ph(b, d, e), $af3a2d87ccb15d29$var$rh(b, d, e, c), $af3a2d87ccb15d29$var$kj(null, b, d, !0, a, c);
        case 19:
            return $af3a2d87ccb15d29$var$yj(a, b, c);
        case 22:
            return $af3a2d87ccb15d29$var$ej(a, b, c);
    }
    throw Error($af3a2d87ccb15d29$var$p(156, b.tag));
};
function $af3a2d87ccb15d29$var$Gk(a, b) {
    return $af3a2d87ccb15d29$var$ac(a, b);
}
function $af3a2d87ccb15d29$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $af3a2d87ccb15d29$var$Bg(a, b, c, d) {
    return new $af3a2d87ccb15d29$var$al(a, b, c, d);
}
function $af3a2d87ccb15d29$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $af3a2d87ccb15d29$var$$k(a) {
    if ("function" === typeof a) return $af3a2d87ccb15d29$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $af3a2d87ccb15d29$var$Da) return 11;
        if (a === $af3a2d87ccb15d29$var$Ga) return 14;
    }
    return 2;
}
function $af3a2d87ccb15d29$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $af3a2d87ccb15d29$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $af3a2d87ccb15d29$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $af3a2d87ccb15d29$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $af3a2d87ccb15d29$var$ya:
            return $af3a2d87ccb15d29$var$Ah(c.children, e, f, b);
        case $af3a2d87ccb15d29$var$za:
            g = 8;
            e |= 8;
            break;
        case $af3a2d87ccb15d29$var$Aa:
            return a = $af3a2d87ccb15d29$var$Bg(12, c, b, e | 2), a.elementType = $af3a2d87ccb15d29$var$Aa, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Ea:
            return a = $af3a2d87ccb15d29$var$Bg(13, c, b, e), a.elementType = $af3a2d87ccb15d29$var$Ea, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Fa:
            return a = $af3a2d87ccb15d29$var$Bg(19, c, b, e), a.elementType = $af3a2d87ccb15d29$var$Fa, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Ia:
            return $af3a2d87ccb15d29$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $af3a2d87ccb15d29$var$Ba:
                    g = 10;
                    break a;
                case $af3a2d87ccb15d29$var$Ca:
                    g = 9;
                    break a;
                case $af3a2d87ccb15d29$var$Da:
                    g = 11;
                    break a;
                case $af3a2d87ccb15d29$var$Ga:
                    g = 14;
                    break a;
                case $af3a2d87ccb15d29$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($af3a2d87ccb15d29$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $af3a2d87ccb15d29$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $af3a2d87ccb15d29$var$Ah(a, b, c, d) {
    a = $af3a2d87ccb15d29$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $af3a2d87ccb15d29$var$qj(a, b, c, d) {
    a = $af3a2d87ccb15d29$var$Bg(22, a, d, b);
    a.elementType = $af3a2d87ccb15d29$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $af3a2d87ccb15d29$var$xh(a, b, c) {
    a = $af3a2d87ccb15d29$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $af3a2d87ccb15d29$var$zh(a, b, c) {
    b = $af3a2d87ccb15d29$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $af3a2d87ccb15d29$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $af3a2d87ccb15d29$var$zc(0);
    this.expirationTimes = $af3a2d87ccb15d29$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $af3a2d87ccb15d29$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $af3a2d87ccb15d29$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $af3a2d87ccb15d29$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $af3a2d87ccb15d29$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $af3a2d87ccb15d29$var$ah(f);
    return a;
}
function $af3a2d87ccb15d29$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $af3a2d87ccb15d29$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $af3a2d87ccb15d29$var$el(a) {
    if (!a) return $af3a2d87ccb15d29$var$Vf;
    a = a._reactInternals;
    a: {
        if ($af3a2d87ccb15d29$var$Vb(a) !== a || 1 !== a.tag) throw Error($af3a2d87ccb15d29$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($af3a2d87ccb15d29$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($af3a2d87ccb15d29$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($af3a2d87ccb15d29$var$Zf(c)) return $af3a2d87ccb15d29$var$bg(a, c, b);
    }
    return b;
}
function $af3a2d87ccb15d29$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $af3a2d87ccb15d29$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $af3a2d87ccb15d29$var$el(null);
    c = a.current;
    d = $af3a2d87ccb15d29$var$L();
    e = $af3a2d87ccb15d29$var$lh(c);
    f = $af3a2d87ccb15d29$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $af3a2d87ccb15d29$var$dh(c, f, e);
    a.current.lanes = e;
    $af3a2d87ccb15d29$var$Ac(a, e, d);
    $af3a2d87ccb15d29$var$Ek(a, d);
    return a;
}
function $af3a2d87ccb15d29$var$gl(a, b, c, d) {
    var e = b.current, f = $af3a2d87ccb15d29$var$L(), g = $af3a2d87ccb15d29$var$lh(e);
    c = $af3a2d87ccb15d29$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $af3a2d87ccb15d29$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $af3a2d87ccb15d29$var$dh(e, b, g);
    null !== a && ($af3a2d87ccb15d29$var$mh(a, e, g, f), $af3a2d87ccb15d29$var$eh(a, e, g));
    return g;
}
function $af3a2d87ccb15d29$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $af3a2d87ccb15d29$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $af3a2d87ccb15d29$var$jl(a, b) {
    $af3a2d87ccb15d29$var$il(a, b);
    (a = a.alternate) && $af3a2d87ccb15d29$var$il(a, b);
}
function $af3a2d87ccb15d29$var$kl() {
    return null;
}
var $af3a2d87ccb15d29$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $af3a2d87ccb15d29$var$ml(a) {
    this._internalRoot = a;
}
$af3a2d87ccb15d29$var$nl.prototype.render = $af3a2d87ccb15d29$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($af3a2d87ccb15d29$var$p(409));
    $af3a2d87ccb15d29$var$gl(a, b, null, null);
};
$af3a2d87ccb15d29$var$nl.prototype.unmount = $af3a2d87ccb15d29$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $af3a2d87ccb15d29$var$Sk(function() {
            $af3a2d87ccb15d29$var$gl(null, a, null, null);
        });
        b[$af3a2d87ccb15d29$var$uf] = null;
    }
};
function $af3a2d87ccb15d29$var$nl(a) {
    this._internalRoot = a;
}
$af3a2d87ccb15d29$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $af3a2d87ccb15d29$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $af3a2d87ccb15d29$var$Qc.length && 0 !== b && b < $af3a2d87ccb15d29$var$Qc[c].priority; c++);
        $af3a2d87ccb15d29$var$Qc.splice(c, 0, a);
        0 === c && $af3a2d87ccb15d29$var$Vc(a);
    }
};
function $af3a2d87ccb15d29$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $af3a2d87ccb15d29$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $af3a2d87ccb15d29$var$ql() {}
function $af3a2d87ccb15d29$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $af3a2d87ccb15d29$var$hl(g);
                f.call(a);
            };
        }
        var g = $af3a2d87ccb15d29$var$fl(b, d, a, 0, null, !1, !1, "", $af3a2d87ccb15d29$var$ql);
        a._reactRootContainer = g;
        a[$af3a2d87ccb15d29$var$uf] = g.current;
        $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
        $af3a2d87ccb15d29$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $af3a2d87ccb15d29$var$hl(k);
            h.call(a);
        };
    }
    var k = $af3a2d87ccb15d29$var$cl(a, 0, !1, null, null, !1, !1, "", $af3a2d87ccb15d29$var$ql);
    a._reactRootContainer = k;
    a[$af3a2d87ccb15d29$var$uf] = k.current;
    $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
    $af3a2d87ccb15d29$var$Sk(function() {
        $af3a2d87ccb15d29$var$gl(b, k, c, d);
    });
    return k;
}
function $af3a2d87ccb15d29$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $af3a2d87ccb15d29$var$hl(g);
                h.call(a);
            };
        }
        $af3a2d87ccb15d29$var$gl(b, g, a, e);
    } else g = $af3a2d87ccb15d29$var$rl(c, b, a, e, d);
    return $af3a2d87ccb15d29$var$hl(g);
}
$af3a2d87ccb15d29$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $af3a2d87ccb15d29$var$tc(b.pendingLanes);
                0 !== c && ($af3a2d87ccb15d29$var$Cc(b, c | 1), $af3a2d87ccb15d29$var$Ek(b, $af3a2d87ccb15d29$var$B()), 0 === ($af3a2d87ccb15d29$var$K & 6) && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$jg()));
            }
            break;
        case 13:
            $af3a2d87ccb15d29$var$Sk(function() {
                var b = $af3a2d87ccb15d29$var$Zg(a, 1);
                if (null !== b) {
                    var c = $af3a2d87ccb15d29$var$L();
                    $af3a2d87ccb15d29$var$mh(b, a, 1, c);
                }
            }), $af3a2d87ccb15d29$var$jl(a, 1);
    }
};
$af3a2d87ccb15d29$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $af3a2d87ccb15d29$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $af3a2d87ccb15d29$var$L();
            $af3a2d87ccb15d29$var$mh(b, a, 134217728, c);
        }
        $af3a2d87ccb15d29$var$jl(a, 134217728);
    }
};
$af3a2d87ccb15d29$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $af3a2d87ccb15d29$var$lh(a), c = $af3a2d87ccb15d29$var$Zg(a, b);
        if (null !== c) {
            var d = $af3a2d87ccb15d29$var$L();
            $af3a2d87ccb15d29$var$mh(c, a, b, d);
        }
        $af3a2d87ccb15d29$var$jl(a, b);
    }
};
$af3a2d87ccb15d29$var$Hc = function() {
    return $af3a2d87ccb15d29$var$C;
};
$af3a2d87ccb15d29$var$Ic = function(a, b) {
    var c = $af3a2d87ccb15d29$var$C;
    try {
        return $af3a2d87ccb15d29$var$C = a, b();
    } finally{
        $af3a2d87ccb15d29$var$C = c;
    }
};
$af3a2d87ccb15d29$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $af3a2d87ccb15d29$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $af3a2d87ccb15d29$var$Db(d);
                        if (!e) throw Error($af3a2d87ccb15d29$var$p(90));
                        $af3a2d87ccb15d29$var$Wa(d);
                        $af3a2d87ccb15d29$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $af3a2d87ccb15d29$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $af3a2d87ccb15d29$var$fb(a, !!c.multiple, b, !1);
    }
};
$af3a2d87ccb15d29$var$Gb = $af3a2d87ccb15d29$var$Rk;
$af3a2d87ccb15d29$var$Hb = $af3a2d87ccb15d29$var$Sk;
var $af3a2d87ccb15d29$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $af3a2d87ccb15d29$var$Cb,
        $af3a2d87ccb15d29$var$ue,
        $af3a2d87ccb15d29$var$Db,
        $af3a2d87ccb15d29$var$Eb,
        $af3a2d87ccb15d29$var$Fb,
        $af3a2d87ccb15d29$var$Rk
    ]
}, $af3a2d87ccb15d29$var$ul = {
    findFiberByHostInstance: $af3a2d87ccb15d29$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $af3a2d87ccb15d29$var$vl = {
    bundleType: $af3a2d87ccb15d29$var$ul.bundleType,
    version: $af3a2d87ccb15d29$var$ul.version,
    rendererPackageName: $af3a2d87ccb15d29$var$ul.rendererPackageName,
    rendererConfig: $af3a2d87ccb15d29$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $af3a2d87ccb15d29$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $af3a2d87ccb15d29$var$ul.findFiberByHostInstance || $af3a2d87ccb15d29$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $af3a2d87ccb15d29$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$af3a2d87ccb15d29$var$wl.isDisabled && $af3a2d87ccb15d29$var$wl.supportsFiber) try {
        $af3a2d87ccb15d29$var$kc = $af3a2d87ccb15d29$var$wl.inject($af3a2d87ccb15d29$var$vl), $af3a2d87ccb15d29$var$lc = $af3a2d87ccb15d29$var$wl;
    } catch (a) {}
}
$af3a2d87ccb15d29$export$ae55be85d98224ed = $af3a2d87ccb15d29$var$tl;
$af3a2d87ccb15d29$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$af3a2d87ccb15d29$var$ol(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$dl(a, b, null, c);
};
$af3a2d87ccb15d29$export$882461b6382ed46c = function(a, b) {
    if (!$af3a2d87ccb15d29$var$ol(a)) throw Error($af3a2d87ccb15d29$var$p(299));
    var c = !1, d = "", e = $af3a2d87ccb15d29$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $af3a2d87ccb15d29$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$af3a2d87ccb15d29$var$uf] = b.current;
    $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $af3a2d87ccb15d29$var$ml(b);
};
$af3a2d87ccb15d29$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($af3a2d87ccb15d29$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($af3a2d87ccb15d29$var$p(268, a));
    }
    a = $af3a2d87ccb15d29$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$af3a2d87ccb15d29$export$cd75ccfd720a3cd4 = function(a) {
    return $af3a2d87ccb15d29$var$Sk(a);
};
$af3a2d87ccb15d29$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$pl(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$sl(null, a, b, !0, c);
};
$af3a2d87ccb15d29$export$757ceba2d55c277e = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$ol(a)) throw Error($af3a2d87ccb15d29$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $af3a2d87ccb15d29$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $af3a2d87ccb15d29$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$af3a2d87ccb15d29$var$uf] = b.current;
    $af3a2d87ccb15d29$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $af3a2d87ccb15d29$var$nl(b);
};
$af3a2d87ccb15d29$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$pl(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$sl(null, a, b, !1, c);
};
$af3a2d87ccb15d29$export$502457920280e6be = function(a) {
    if (!$af3a2d87ccb15d29$var$pl(a)) throw Error($af3a2d87ccb15d29$var$p(40));
    return a._reactRootContainer ? ($af3a2d87ccb15d29$var$Sk(function() {
        $af3a2d87ccb15d29$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$af3a2d87ccb15d29$var$uf] = null;
        });
    }), !0) : !1;
};
$af3a2d87ccb15d29$export$c78a37762a8d58e1 = $af3a2d87ccb15d29$var$Rk;
$af3a2d87ccb15d29$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$af3a2d87ccb15d29$var$pl(c)) throw Error($af3a2d87ccb15d29$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($af3a2d87ccb15d29$var$p(38));
    return $af3a2d87ccb15d29$var$sl(a, b, c, !1, d);
};
$af3a2d87ccb15d29$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("7DCHO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("59RiQ"));

});
parcelRequire.register("59RiQ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3c1723e4455f0262$export$c4744153514ff05d, (v) => $3c1723e4455f0262$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3c1723e4455f0262$export$3e506c1ccc9cc1a7, (v) => $3c1723e4455f0262$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3c1723e4455f0262$export$e26fe2ed2fa76875, (v) => $3c1723e4455f0262$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3c1723e4455f0262$export$502329bbf4b505b1, (v) => $3c1723e4455f0262$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3c1723e4455f0262$export$6e3807111c4874c4, (v) => $3c1723e4455f0262$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3c1723e4455f0262$export$c27134553091fb3a, (v) => $3c1723e4455f0262$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3c1723e4455f0262$export$33ee1acdc04fd2a2, (v) => $3c1723e4455f0262$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3c1723e4455f0262$export$b00a404bbd5edef2, (v) => $3c1723e4455f0262$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3c1723e4455f0262$export$8352ce38b91d0c62, (v) => $3c1723e4455f0262$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3c1723e4455f0262$export$d66a1c1c77bd778b, (v) => $3c1723e4455f0262$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3c1723e4455f0262$export$d3dfb8e4810cb555, (v) => $3c1723e4455f0262$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3c1723e4455f0262$export$839f9183b0465a69, (v) => $3c1723e4455f0262$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3c1723e4455f0262$export$72fdf0e06517287b, (v) => $3c1723e4455f0262$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3c1723e4455f0262$export$4b844e58a3e414b4, (v) => $3c1723e4455f0262$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3c1723e4455f0262$export$816d2913ae6b83b1, (v) => $3c1723e4455f0262$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3c1723e4455f0262$export$61bcfe829111a1d0, (v) => $3c1723e4455f0262$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3c1723e4455f0262$export$7ee8c9beb337bc3f, (v) => $3c1723e4455f0262$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3c1723e4455f0262$export$b5836b71941fa3ed, (v) => $3c1723e4455f0262$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3c1723e4455f0262$export$cf845f2c119da08a, (v) => $3c1723e4455f0262$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c1723e4455f0262$export$c4744153514ff05d;
var $3c1723e4455f0262$export$3e506c1ccc9cc1a7;
var $3c1723e4455f0262$export$e26fe2ed2fa76875;
var $3c1723e4455f0262$export$502329bbf4b505b1;
var $3c1723e4455f0262$export$6e3807111c4874c4;
var $3c1723e4455f0262$export$c27134553091fb3a;
var $3c1723e4455f0262$export$33ee1acdc04fd2a2;
var $3c1723e4455f0262$export$b00a404bbd5edef2;
var $3c1723e4455f0262$export$8352ce38b91d0c62;
var $3c1723e4455f0262$export$d66a1c1c77bd778b;
var $3c1723e4455f0262$export$d3dfb8e4810cb555;
var $3c1723e4455f0262$export$839f9183b0465a69;
var $3c1723e4455f0262$export$72fdf0e06517287b;
var $3c1723e4455f0262$export$4b844e58a3e414b4;
var $3c1723e4455f0262$export$816d2913ae6b83b1;
var $3c1723e4455f0262$export$61bcfe829111a1d0;
var $3c1723e4455f0262$export$7ee8c9beb337bc3f;
var $3c1723e4455f0262$export$b5836b71941fa3ed;
var $3c1723e4455f0262$export$cf845f2c119da08a;
"use strict";
function $3c1723e4455f0262$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3c1723e4455f0262$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3c1723e4455f0262$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3c1723e4455f0262$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3c1723e4455f0262$var$g(C, c)) n < e && 0 > $3c1723e4455f0262$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3c1723e4455f0262$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3c1723e4455f0262$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3c1723e4455f0262$var$l = performance;
    $3c1723e4455f0262$export$c4744153514ff05d = function() {
        return $3c1723e4455f0262$var$l.now();
    };
} else {
    var $3c1723e4455f0262$var$p = Date, $3c1723e4455f0262$var$q = $3c1723e4455f0262$var$p.now();
    $3c1723e4455f0262$export$c4744153514ff05d = function() {
        return $3c1723e4455f0262$var$p.now() - $3c1723e4455f0262$var$q;
    };
}
var $3c1723e4455f0262$var$r = [], $3c1723e4455f0262$var$t = [], $3c1723e4455f0262$var$u = 1, $3c1723e4455f0262$var$v = null, $3c1723e4455f0262$var$y = 3, $3c1723e4455f0262$var$z = !1, $3c1723e4455f0262$var$A = !1, $3c1723e4455f0262$var$B = !1, $3c1723e4455f0262$var$D = "function" === typeof setTimeout ? setTimeout : null, $3c1723e4455f0262$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3c1723e4455f0262$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3c1723e4455f0262$var$G(a) {
    for(var b = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t); null !== b;){
        if (null === b.callback) $3c1723e4455f0262$var$k($3c1723e4455f0262$var$t);
        else if (b.startTime <= a) $3c1723e4455f0262$var$k($3c1723e4455f0262$var$t), b.sortIndex = b.expirationTime, $3c1723e4455f0262$var$f($3c1723e4455f0262$var$r, b);
        else break;
        b = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t);
    }
}
function $3c1723e4455f0262$var$H(a) {
    $3c1723e4455f0262$var$B = !1;
    $3c1723e4455f0262$var$G(a);
    if (!$3c1723e4455f0262$var$A) {
        if (null !== $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r)) $3c1723e4455f0262$var$A = !0, $3c1723e4455f0262$var$I($3c1723e4455f0262$var$J);
        else {
            var b = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t);
            null !== b && $3c1723e4455f0262$var$K($3c1723e4455f0262$var$H, b.startTime - a);
        }
    }
}
function $3c1723e4455f0262$var$J(a, b) {
    $3c1723e4455f0262$var$A = !1;
    $3c1723e4455f0262$var$B && ($3c1723e4455f0262$var$B = !1, $3c1723e4455f0262$var$E($3c1723e4455f0262$var$L), $3c1723e4455f0262$var$L = -1);
    $3c1723e4455f0262$var$z = !0;
    var c = $3c1723e4455f0262$var$y;
    try {
        $3c1723e4455f0262$var$G(b);
        for($3c1723e4455f0262$var$v = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r); null !== $3c1723e4455f0262$var$v && (!($3c1723e4455f0262$var$v.expirationTime > b) || a && !$3c1723e4455f0262$var$M());){
            var d = $3c1723e4455f0262$var$v.callback;
            if ("function" === typeof d) {
                $3c1723e4455f0262$var$v.callback = null;
                $3c1723e4455f0262$var$y = $3c1723e4455f0262$var$v.priorityLevel;
                var e = d($3c1723e4455f0262$var$v.expirationTime <= b);
                b = $3c1723e4455f0262$export$c4744153514ff05d();
                "function" === typeof e ? $3c1723e4455f0262$var$v.callback = e : $3c1723e4455f0262$var$v === $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r) && $3c1723e4455f0262$var$k($3c1723e4455f0262$var$r);
                $3c1723e4455f0262$var$G(b);
            } else $3c1723e4455f0262$var$k($3c1723e4455f0262$var$r);
            $3c1723e4455f0262$var$v = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r);
        }
        if (null !== $3c1723e4455f0262$var$v) var w = !0;
        else {
            var m = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t);
            null !== m && $3c1723e4455f0262$var$K($3c1723e4455f0262$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3c1723e4455f0262$var$v = null, $3c1723e4455f0262$var$y = c, $3c1723e4455f0262$var$z = !1;
    }
}
var $3c1723e4455f0262$var$N = !1, $3c1723e4455f0262$var$O = null, $3c1723e4455f0262$var$L = -1, $3c1723e4455f0262$var$P = 5, $3c1723e4455f0262$var$Q = -1;
function $3c1723e4455f0262$var$M() {
    return $3c1723e4455f0262$export$c4744153514ff05d() - $3c1723e4455f0262$var$Q < $3c1723e4455f0262$var$P ? !1 : !0;
}
function $3c1723e4455f0262$var$R() {
    if (null !== $3c1723e4455f0262$var$O) {
        var a = $3c1723e4455f0262$export$c4744153514ff05d();
        $3c1723e4455f0262$var$Q = a;
        var b = !0;
        try {
            b = $3c1723e4455f0262$var$O(!0, a);
        } finally{
            b ? $3c1723e4455f0262$var$S() : ($3c1723e4455f0262$var$N = !1, $3c1723e4455f0262$var$O = null);
        }
    } else $3c1723e4455f0262$var$N = !1;
}
var $3c1723e4455f0262$var$S;
if ("function" === typeof $3c1723e4455f0262$var$F) $3c1723e4455f0262$var$S = function() {
    $3c1723e4455f0262$var$F($3c1723e4455f0262$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3c1723e4455f0262$var$T = new MessageChannel, $3c1723e4455f0262$var$U = $3c1723e4455f0262$var$T.port2;
    $3c1723e4455f0262$var$T.port1.onmessage = $3c1723e4455f0262$var$R;
    $3c1723e4455f0262$var$S = function() {
        $3c1723e4455f0262$var$U.postMessage(null);
    };
} else $3c1723e4455f0262$var$S = function() {
    $3c1723e4455f0262$var$D($3c1723e4455f0262$var$R, 0);
};
function $3c1723e4455f0262$var$I(a) {
    $3c1723e4455f0262$var$O = a;
    $3c1723e4455f0262$var$N || ($3c1723e4455f0262$var$N = !0, $3c1723e4455f0262$var$S());
}
function $3c1723e4455f0262$var$K(a, b) {
    $3c1723e4455f0262$var$L = $3c1723e4455f0262$var$D(function() {
        a($3c1723e4455f0262$export$c4744153514ff05d());
    }, b);
}
$3c1723e4455f0262$export$3e506c1ccc9cc1a7 = 5;
$3c1723e4455f0262$export$e26fe2ed2fa76875 = 1;
$3c1723e4455f0262$export$502329bbf4b505b1 = 4;
$3c1723e4455f0262$export$6e3807111c4874c4 = 3;
$3c1723e4455f0262$export$c27134553091fb3a = null;
$3c1723e4455f0262$export$33ee1acdc04fd2a2 = 2;
$3c1723e4455f0262$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3c1723e4455f0262$export$8352ce38b91d0c62 = function() {
    $3c1723e4455f0262$var$A || $3c1723e4455f0262$var$z || ($3c1723e4455f0262$var$A = !0, $3c1723e4455f0262$var$I($3c1723e4455f0262$var$J));
};
$3c1723e4455f0262$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3c1723e4455f0262$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3c1723e4455f0262$export$d3dfb8e4810cb555 = function() {
    return $3c1723e4455f0262$var$y;
};
$3c1723e4455f0262$export$839f9183b0465a69 = function() {
    return $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r);
};
$3c1723e4455f0262$export$72fdf0e06517287b = function(a) {
    switch($3c1723e4455f0262$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3c1723e4455f0262$var$y;
    }
    var c = $3c1723e4455f0262$var$y;
    $3c1723e4455f0262$var$y = b;
    try {
        return a();
    } finally{
        $3c1723e4455f0262$var$y = c;
    }
};
$3c1723e4455f0262$export$4b844e58a3e414b4 = function() {};
$3c1723e4455f0262$export$816d2913ae6b83b1 = function() {};
$3c1723e4455f0262$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3c1723e4455f0262$var$y;
    $3c1723e4455f0262$var$y = a;
    try {
        return b();
    } finally{
        $3c1723e4455f0262$var$y = c;
    }
};
$3c1723e4455f0262$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3c1723e4455f0262$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3c1723e4455f0262$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3c1723e4455f0262$var$f($3c1723e4455f0262$var$t, a), null === $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r) && a === $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t) && ($3c1723e4455f0262$var$B ? ($3c1723e4455f0262$var$E($3c1723e4455f0262$var$L), $3c1723e4455f0262$var$L = -1) : $3c1723e4455f0262$var$B = !0, $3c1723e4455f0262$var$K($3c1723e4455f0262$var$H, c - d))) : (a.sortIndex = e, $3c1723e4455f0262$var$f($3c1723e4455f0262$var$r, a), $3c1723e4455f0262$var$A || $3c1723e4455f0262$var$z || ($3c1723e4455f0262$var$A = !0, $3c1723e4455f0262$var$I($3c1723e4455f0262$var$J)));
    return a;
};
$3c1723e4455f0262$export$b5836b71941fa3ed = $3c1723e4455f0262$var$M;
$3c1723e4455f0262$export$cf845f2c119da08a = function(a) {
    var b = $3c1723e4455f0262$var$y;
    return function() {
        var c = $3c1723e4455f0262$var$y;
        $3c1723e4455f0262$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3c1723e4455f0262$var$y = c;
        }
    };
};

});



parcelRequire.register("1LbwH", function(module, exports) {

$parcel$export(module.exports, "languageDataProp", () => $14831f1c512a5db9$export$27a2e78097f753f7);
$parcel$export(module.exports, "defineLanguageFacet", () => $14831f1c512a5db9$export$b57f683f43553b99);
$parcel$export(module.exports, "sublanguageProp", () => $14831f1c512a5db9$export$4afc6f37514bbb67);
$parcel$export(module.exports, "Language", () => $14831f1c512a5db9$export$ce4fe1c9e6520c1a);
$parcel$export(module.exports, "syntaxTree", () => $14831f1c512a5db9$export$7fc98e56a4ca6be1);
$parcel$export(module.exports, "LRLanguage", () => $14831f1c512a5db9$export$b243968d9fb6db03);
$parcel$export(module.exports, "ensureSyntaxTree", () => $14831f1c512a5db9$export$8694796f3a52e973);
$parcel$export(module.exports, "ParseContext", () => $14831f1c512a5db9$export$3fcb7c01ff2a41fa);
$parcel$export(module.exports, "LanguageSupport", () => $14831f1c512a5db9$export$cbdefefa8a51dd3b);
$parcel$export(module.exports, "LanguageDescription", () => $14831f1c512a5db9$export$50ab82debf88f71);
$parcel$export(module.exports, "indentUnit", () => $14831f1c512a5db9$export$9e0d0c2ce4d3ceb5);
$parcel$export(module.exports, "indentNodeProp", () => $14831f1c512a5db9$export$72c7d4c52b3c6460);
$parcel$export(module.exports, "delimitedIndent", () => $14831f1c512a5db9$export$60e82ea306899488);
$parcel$export(module.exports, "flatIndent", () => $14831f1c512a5db9$export$4764c629086182f2);
$parcel$export(module.exports, "continuedIndent", () => $14831f1c512a5db9$export$688ff433e7e7cc5c);
$parcel$export(module.exports, "foldService", () => $14831f1c512a5db9$export$40014037e3ef64a);
$parcel$export(module.exports, "foldNodeProp", () => $14831f1c512a5db9$export$9b075a85eb4377d8);
$parcel$export(module.exports, "foldInside", () => $14831f1c512a5db9$export$48672beae16a681b);
$parcel$export(module.exports, "bracketMatchingHandle", () => $14831f1c512a5db9$export$ca7d74cd5b9f1011);

var $6DlXS = parcelRequire("6DlXS");

var $hB7kI = parcelRequire("hB7kI");

var $BEVwA = parcelRequire("BEVwA");

var $6yW7d = parcelRequire("6yW7d");

var $luNHI = parcelRequire("luNHI");
var $14831f1c512a5db9$var$_a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ const $14831f1c512a5db9$export$27a2e78097f753f7 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function $14831f1c512a5db9$export$b57f683f43553b99(baseData) {
    return (0, $hB7kI.Facet).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
Syntax node prop used to register sublanguages. Should be added to
the top level node type for the language.
*/ const $14831f1c512a5db9$export$4afc6f37514bbb67 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class $14831f1c512a5db9$export$ce4fe1c9e6520c1a {
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, extraExtensions = [], /**
    A language name.
    */ name = ""){
        this.data = data;
        this.name = name;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, $hB7kI.EditorState).prototype.hasOwnProperty("tree")) Object.defineProperty((0, $hB7kI.EditorState).prototype, "tree", {
            get () {
                return $14831f1c512a5db9$export$7fc98e56a4ca6be1(this);
            }
        });
        this.parser = parser;
        this.extension = [
            $14831f1c512a5db9$export$789c912f57fe164c.of(this),
            (0, $hB7kI.EditorState).languageData.of((state, pos, side)=>{
                let top = $14831f1c512a5db9$var$topNodeAt(state, pos, side), data = top.type.prop($14831f1c512a5db9$export$27a2e78097f753f7);
                if (!data) return [];
                let base = state.facet(data), sub = top.type.prop($14831f1c512a5db9$export$4afc6f37514bbb67);
                if (sub) {
                    let innerNode = top.resolve(pos - top.from, side);
                    for (let sublang of sub)if (sublang.test(innerNode, state)) {
                        let data = state.facet(sublang.facet);
                        return sublang.type == "replace" ? data : data.concat(base);
                    }
                }
                return base;
            })
        ].concat(extraExtensions);
    }
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos, side = -1) {
        return $14831f1c512a5db9$var$topNodeAt(state, pos, side).type.prop($14831f1c512a5db9$export$27a2e78097f753f7) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        let lang = state.facet($14831f1c512a5db9$export$789c912f57fe164c);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        let result = [];
        let explore = (tree, from)=>{
            if (tree.prop($14831f1c512a5db9$export$27a2e78097f753f7) == this.data) {
                result.push({
                    from: from,
                    to: from + tree.length
                });
                return;
            }
            let mount = tree.prop((0, $6DlXS.NodeProp).mounted);
            if (mount) {
                if (mount.tree.prop($14831f1c512a5db9$export$27a2e78097f753f7) == this.data) {
                    if (mount.overlay) for (let r of mount.overlay)result.push({
                        from: r.from + from,
                        to: r.to + from
                    });
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    let size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(let i = 0; i < tree.children.length; i++){
                let ch = tree.children[i];
                if (ch instanceof (0, $6DlXS.Tree)) explore(ch, tree.positions[i] + from);
            }
        };
        explore($14831f1c512a5db9$export$7fc98e56a4ca6be1(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
}
/**
@internal
*/ $14831f1c512a5db9$export$ce4fe1c9e6520c1a.setState = /*@__PURE__*/ (0, $hB7kI.StateEffect).define();
function $14831f1c512a5db9$var$topNodeAt(state, pos, side) {
    let topLang = state.facet($14831f1c512a5db9$export$789c912f57fe164c), tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(state).topNode;
    if (!topLang || topLang.allowsNesting) {
        for(let node = tree; node; node = node.enter(pos, side, (0, $6DlXS.IterMode).ExcludeBuffers))if (node.type.isTop) tree = node;
    }
    return tree;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser)
parsers.
*/ class $14831f1c512a5db9$export$b243968d9fb6db03 extends $14831f1c512a5db9$export$ce4fe1c9e6520c1a {
    constructor(data, parser, name){
        super(data, parser, [], name);
        this.parser = parser;
    }
    /**
    Define a language from a parser.
    */ static define(spec) {
        let data = $14831f1c512a5db9$export$b57f683f43553b99(spec.languageData);
        return new $14831f1c512a5db9$export$b243968d9fb6db03(data, spec.parser.configure({
            props: [
                $14831f1c512a5db9$export$27a2e78097f753f7.add((type)=>type.isTop ? data : undefined)
            ]
        }), spec.name);
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser and optionally a new name.
    */ configure(options, name) {
        return new $14831f1c512a5db9$export$b243968d9fb6db03(this.data, this.parser.configure(options), name || this.name);
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function $14831f1c512a5db9$export$7fc98e56a4ca6be1(state) {
    let field = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state, false);
    return field ? field.tree : (0, $6DlXS.Tree).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function $14831f1c512a5db9$export$8694796f3a52e973(state, upto, timeout = 50) {
    var _a;
    let parse = (_a = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    if (!parse) return null;
    let oldVieport = parse.viewport;
    parse.updateViewport({
        from: 0,
        to: upto
    });
    let result = parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
    parse.updateViewport(oldVieport);
    return result;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function $14831f1c512a5db9$export$2c95b013b0941e86(state, upto = state.doc.length) {
    var _a;
    return ((_a = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function $14831f1c512a5db9$export$b3bcb61c35026d72(view, upto = view.viewport.to, timeout = 100) {
    let success = $14831f1c512a5db9$export$8694796f3a52e973(view.state, upto, timeout);
    if (success != $14831f1c512a5db9$export$7fc98e56a4ca6be1(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function $14831f1c512a5db9$export$23c0ee92d6189d3f(view) {
    var _a;
    return ((_a = view.plugin($14831f1c512a5db9$var$parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
/**
Lezer-style
[`Input`](https://lezer.codemirror.net/docs/ref#common.Input)
object for a [`Text`](https://codemirror.net/6/docs/ref/#state.Text) object.
*/ class $14831f1c512a5db9$export$78c262ab5af874ad {
    /**
    Create an input object for the given document.
    */ constructor(doc){
        this.doc = doc;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
    get length() {
        return this.doc.length;
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        let stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
}
let $14831f1c512a5db9$var$currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class $14831f1c512a5db9$export$3fcb7c01ff2a41fa {
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ fragments = [], /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new $14831f1c512a5db9$export$3fcb7c01ff2a41fa(parser, state, [], (0, $6DlXS.Tree).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new $14831f1c512a5db9$export$78c262ab5af874ad(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, $6DlXS.Tree).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                let endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                let done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, $6DlXS.TreeFragment).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        let pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, $6DlXS.TreeFragment).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        let prev = $14831f1c512a5db9$var$currentContext;
        $14831f1c512a5db9$var$currentContext = this;
        try {
            return f();
        } finally{
            $14831f1c512a5db9$var$currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(let r; r = this.tempSkipped.pop();)fragments = $14831f1c512a5db9$var$cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        let { fragments: fragments, tree: tree, treeLen: treeLen, viewport: viewport, skipped: skipped } = this;
        this.takeTree();
        if (!changes.empty) {
            let ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                }));
            fragments = (0, $6DlXS.TreeFragment).applyChanges(fragments, ranges);
            tree = (0, $6DlXS.Tree).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                for (let r of this.skipped){
                    let from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                    if (from < to) skipped.push({
                        from: from,
                        to: to
                    });
                }
            }
        }
        return new $14831f1c512a5db9$export$3fcb7c01ff2a41fa(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        let startLen = this.skipped.length;
        for(let i = 0; i < this.skipped.length; i++){
            let { from: from, to: to } = this.skipped[i];
            if (from < viewport.to && to > viewport.from) {
                this.fragments = $14831f1c512a5db9$var$cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from: from,
            to: to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, $6DlXS.Parser) {
            createParse(input, fragments, ranges) {
                let from = ranges[0].from, to = ranges[ranges.length - 1].to;
                let parser = {
                    parsedPos: from,
                    advance () {
                        let cx = $14831f1c512a5db9$var$currentContext;
                        if (cx) {
                            for (let r of ranges)cx.tempSkipped.push(r);
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, $6DlXS.Tree)((0, $6DlXS.NodeType).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        let frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return $14831f1c512a5db9$var$currentContext;
    }
}
function $14831f1c512a5db9$var$cutFragments(fragments, from, to) {
    return (0, $6DlXS.TreeFragment).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class $14831f1c512a5db9$var$LanguageState {
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        let newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        let upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Apply */ , upto)) newCx.takeTree();
        return new $14831f1c512a5db9$var$LanguageState(newCx);
    }
    static init(state) {
        let vpTo = Math.min(3000 /* InitViewport */ , state.doc.length);
        let parseState = $14831f1c512a5db9$export$3fcb7c01ff2a41fa.create(state.facet($14831f1c512a5db9$export$789c912f57fe164c).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Apply */ , vpTo)) parseState.takeTree();
        return new $14831f1c512a5db9$var$LanguageState(parseState);
    }
}
$14831f1c512a5db9$export$ce4fe1c9e6520c1a.state = /*@__PURE__*/ (0, $hB7kI.StateField).define({
    create: $14831f1c512a5db9$var$LanguageState.init,
    update (value, tr) {
        for (let e of tr.effects)if (e.is($14831f1c512a5db9$export$ce4fe1c9e6520c1a.setState)) return e.value;
        if (tr.startState.facet($14831f1c512a5db9$export$789c912f57fe164c) != tr.state.facet($14831f1c512a5db9$export$789c912f57fe164c)) return $14831f1c512a5db9$var$LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
let $14831f1c512a5db9$var$requestIdle = (callback)=>{
    let timeout = setTimeout(()=>callback(), 500 /* MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") $14831f1c512a5db9$var$requestIdle = (callback)=>{
    let idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* MinPause */ 
        });
    }, 100 /* MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
const $14831f1c512a5db9$var$isInputPending = typeof navigator != "undefined" && (($14831f1c512a5db9$var$_a = navigator.scheduling) === null || $14831f1c512a5db9$var$_a === void 0 ? void 0 : $14831f1c512a5db9$var$_a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
const $14831f1c512a5db9$var$parseWorker = /*@__PURE__*/ (0, $BEVwA.ViewPlugin).fromClass(class ParseWorker {
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
    update(update) {
        let cx = this.view.state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        let { state: state } = this.view, field = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = $14831f1c512a5db9$var$requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        let now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* ChunkTime */ ;
            this.chunkBudget = 3000 /* ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        let { state: state, viewport: { to: vpTo } } = this.view, field = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* MaxParseAhead */ )) return;
        let endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Slice */ , deadline && !$14831f1c512a5db9$var$isInputPending ? Math.max(25 /* MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        let done = field.context.work(()=>{
            return $14831f1c512a5db9$var$isInputPending && $14831f1c512a5db9$var$isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: $14831f1c512a5db9$export$ce4fe1c9e6520c1a.setState.of(new $14831f1c512a5db9$var$LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, $BEVwA.logException)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state. Used
by `Language` object's `extension` property (so you don't need to
manually wrap your languages in this). Can be used to access the
current language on a state.
*/ const $14831f1c512a5db9$export$789c912f57fe164c = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: (language)=>[
            $14831f1c512a5db9$export$ce4fe1c9e6520c1a.state,
            $14831f1c512a5db9$var$parseWorker,
            (0, $BEVwA.EditorView).contentAttributes.compute([
                language
            ], (state)=>{
                let lang = state.facet(language);
                return lang && lang.name ? {
                    "data-language": lang.name
                } : {};
            })
        ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class $14831f1c512a5db9$export$cbdefefa8a51dd3b {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ support = []){
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class $14831f1c512a5db9$export$50ab82debf88f71 {
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        let { load: load, support: support } = spec;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new $14831f1c512a5db9$export$50ab82debf88f71(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        for (let d of descs)if (d.filename && d.filename.test(filename)) return d;
        let ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            for (let d of descs)if (d.extensions.indexOf(ext[1]) > -1) return d;
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name, fuzzy = true) {
        name = name.toLowerCase();
        for (let d of descs)if (d.alias.some((a)=>a == name)) return d;
        if (fuzzy) for (let d of descs)for (let a of d.alias){
            let found = name.indexOf(a);
            if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d;
        }
        return null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth, as a column number (see
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)), at the start of a given
line. A return value of `null` indicates no indentation can be
determined, and the line should inherit the indentation of the one
above it. A return value of `undefined` defers to the next indent
service.
*/ const $14831f1c512a5db9$export$5952625dce50d1f3 = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
Facet for overriding the unit by which indentation happens. Should
be a string consisting either entirely of the same whitespace
character. When not set, this defaults to 2 spaces.
*/ const $14831f1c512a5db9$export$9e0d0c2ce4d3ceb5 = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        let unit = values[0];
        if (!unit || /\S/.test(unit) || Array.from(unit).some((e)=>e != unit[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return unit;
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function $14831f1c512a5db9$export$ad3205d09311a797(state) {
    let unit = state.facet($14831f1c512a5db9$export$9e0d0c2ce4d3ceb5);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function $14831f1c512a5db9$export$db5a40e207b40576(state, cols) {
    let result = "", ts = state.tabSize, ch = state.facet($14831f1c512a5db9$export$9e0d0c2ce4d3ceb5)[0];
    if (ch == "	") {
        while(cols >= ts){
            result += "	";
            cols -= ts;
        }
        ch = " ";
    }
    for(let i = 0; i < cols; i++)result += ch;
    return result;
}
/**
Get the indentation, as a column number, at the given position.
Will first consult any [indent services](https://codemirror.net/6/docs/ref/#language.indentService)
that are registered, and if none of those return an indentation,
this will check the syntax tree for the [indent node
prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp) and use that if found. Returns a
number when an indentation could be determined, and null
otherwise.
*/ function $14831f1c512a5db9$export$a2d3c9dbce6d2211(context, pos) {
    if (context instanceof (0, $hB7kI.EditorState)) context = new $14831f1c512a5db9$export$eeab79349cc2f7c8(context);
    for (let service of context.state.facet($14831f1c512a5db9$export$5952625dce50d1f3)){
        let result = service(context, pos);
        if (result !== undefined) return result;
    }
    let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(context.state);
    return tree ? $14831f1c512a5db9$var$syntaxIndentation(context, tree, pos) : null;
}
/**
Create a change set that auto-indents all lines touched by the
given document range.
*/ function $14831f1c512a5db9$export$2fc72a4ad8b85e40(state, from, to) {
    let updated = Object.create(null);
    let context = new $14831f1c512a5db9$export$eeab79349cc2f7c8(state, {
        overrideIndentation: (start)=>{
            var _a;
            return (_a = updated[start]) !== null && _a !== void 0 ? _a : -1;
        }
    });
    let changes = [];
    for(let pos = from; pos <= to;){
        let line = state.doc.lineAt(pos);
        pos = line.to + 1;
        let indent = $14831f1c512a5db9$export$a2d3c9dbce6d2211(context, line.from);
        if (indent == null) continue;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = $14831f1c512a5db9$export$db5a40e207b40576(state, indent);
        if (cur != norm) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    }
    return state.changes(changes);
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class $14831f1c512a5db9$export$eeab79349cc2f7c8 {
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ options = {}){
        this.state = state;
        this.options = options;
        this.unit = $14831f1c512a5db9$export$ad3205d09311a797(state);
    }
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos, bias = 1) {
        let line = this.state.doc.lineAt(pos);
        let { simulateBreak: simulateBreak, simulateDoubleBreak: simulateDoubleBreak } = this.options;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos, bias = 1) {
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        let { text: text, from: from } = this.lineAt(pos, bias);
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let result = this.countColumn(text, pos - from);
        let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line, pos = line.length) {
        return (0, $hB7kI.countColumn)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let override = this.options.overrideIndentation;
        if (override) {
            let overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number (see also
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)) or null, where null
indicates that no definitive indentation can be determined.
*/ const $14831f1c512a5db9$export$72c7d4c52b3c6460 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
// Compute the indentation for a given position from the syntax tree.
function $14831f1c512a5db9$var$syntaxIndentation(cx, ast, pos) {
    return $14831f1c512a5db9$var$indentFrom(ast.resolveInner(pos).enterUnfinishedNodesBefore(pos), pos, cx);
}
function $14831f1c512a5db9$var$ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function $14831f1c512a5db9$var$indentStrategy(tree) {
    let strategy = tree.type.prop($14831f1c512a5db9$export$72c7d4c52b3c6460);
    if (strategy) return strategy;
    let first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, $6DlXS.NodeProp).closedBy))) {
        let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>$14831f1c512a5db9$var$delimitedStrategy(cx, true, 1, undefined, closed && !$14831f1c512a5db9$var$ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? $14831f1c512a5db9$var$topIndent : null;
}
function $14831f1c512a5db9$var$indentFrom(node, pos, base) {
    for(; node; node = node.parent){
        let strategy = $14831f1c512a5db9$var$indentStrategy(node);
        if (strategy) return strategy($14831f1c512a5db9$export$8aaeb0848a33f7c3.create(base, pos, node));
    }
    return null;
}
function $14831f1c512a5db9$var$topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class $14831f1c512a5db9$export$8aaeb0848a33f7c3 extends $14831f1c512a5db9$export$eeab79349cc2f7c8 {
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    The syntax tree node to which the indentation strategy
    applies.
    */ node){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.node = node;
    }
    /**
    @internal
    */ static create(base, pos, node) {
        return new $14831f1c512a5db9$export$8aaeb0848a33f7c3(base, pos, node);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        return this.baseIndentFor(this.node);
    }
    /**
    Get the indentation for the reference line of the given node
    (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
    */ baseIndentFor(node) {
        let line = this.state.doc.lineAt(node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            let atBreak = node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if ($14831f1c512a5db9$var$isParent(atBreak, node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        let parent = this.node.parent;
        return parent ? $14831f1c512a5db9$var$indentFrom(parent, this.pos, this.base) : 0;
    }
}
function $14831f1c512a5db9$var$isParent(parent, of) {
    for(let cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function $14831f1c512a5db9$var$bracketedAligned(context) {
    let tree = context.node;
    let openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    let sim = context.options.simulateBreak;
    let openLine = context.state.doc.lineAt(openToken.from);
    let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(let pos = openToken.to;;){
        let next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) return next.from < lineEnd ? openToken : null;
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function $14831f1c512a5db9$export$60e82ea306899488({ closing: closing, align: align = true, units: units = 1 }) {
    return (context)=>$14831f1c512a5db9$var$delimitedStrategy(context, align, units, closing);
}
function $14831f1c512a5db9$var$delimitedStrategy(context, align, units, closing, closedAt) {
    let after = context.textAfter, space = after.match(/^\s*/)[0].length;
    let closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    let aligned = align ? $14831f1c512a5db9$var$bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ const $14831f1c512a5db9$export$4764c629086182f2 = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function $14831f1c512a5db9$export$688ff433e7e7cc5c({ except: except, units: units = 1 } = {}) {
    return (context)=>{
        let matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
const $14831f1c512a5db9$var$DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function $14831f1c512a5db9$export$9bcaf6e2125ee117() {
    return (0, $hB7kI.EditorState).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        let rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        let doc = tr.newDoc, { head: head } = tr.newSelection.main, line = doc.lineAt(head);
        if (head > line.from + $14831f1c512a5db9$var$DontIndentBeyond) return tr;
        let lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        let { state: state } = tr, last = -1, changes = [];
        for (let { head: head } of state.selection.ranges){
            let line = state.doc.lineAt(head);
            if (line.from == last) continue;
            last = line.from;
            let indent = $14831f1c512a5db9$export$a2d3c9dbce6d2211(state, line.from);
            if (indent == null) continue;
            let cur = /^\s*/.exec(line.text)[0];
            let norm = $14831f1c512a5db9$export$db5a40e207b40576(state, indent);
            if (cur != norm) changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
        return changes.length ? [
            tr,
            {
                changes: changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ const $14831f1c512a5db9$export$40014037e3ef64a = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ const $14831f1c512a5db9$export$9b075a85eb4377d8 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function $14831f1c512a5db9$export$48672beae16a681b(node) {
    let first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function $14831f1c512a5db9$var$syntaxFolding(state, start, end) {
    let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(state);
    if (tree.length < end) return null;
    let inner = tree.resolveInner(end, 1);
    let found = null;
    for(let cur = inner; cur; cur = cur.parent){
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        let prop = cur.type.prop($14831f1c512a5db9$export$9b075a85eb4377d8);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !$14831f1c512a5db9$var$isUnfinished(cur))) {
            let value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function $14831f1c512a5db9$var$isUnfinished(node) {
    let ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function $14831f1c512a5db9$export$cbe8a3d55245b07d(state, lineStart, lineEnd) {
    for (let service of state.facet($14831f1c512a5db9$export$40014037e3ef64a)){
        let result = service(state, lineStart, lineEnd);
        if (result) return result;
    }
    return $14831f1c512a5db9$var$syntaxFolding(state, lineStart, lineEnd);
}
function $14831f1c512a5db9$var$mapRange(range, mapping) {
    let from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from: from,
        to: to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ const $14831f1c512a5db9$export$a123efe007ad265 = /*@__PURE__*/ (0, $hB7kI.StateEffect).define({
    map: $14831f1c512a5db9$var$mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ const $14831f1c512a5db9$export$bf2507dc398fc1ab = /*@__PURE__*/ (0, $hB7kI.StateEffect).define({
    map: $14831f1c512a5db9$var$mapRange
});
function $14831f1c512a5db9$var$selectedLines(view) {
    let lines = [];
    for (let { head: head } of view.state.selection.ranges){
        if (lines.some((l)=>l.from <= head && l.to >= head)) continue;
        lines.push(view.lineBlockAt(head));
    }
    return lines;
}
/**
The state field that stores the folded ranges (as a [decoration
set](https://codemirror.net/6/docs/ref/#view.DecorationSet)). Can be passed to
[`EditorState.toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) and
[`fromJSON`](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) to serialize the fold
state.
*/ const $14831f1c512a5db9$export$6955fe1f7c578abb = /*@__PURE__*/ (0, $hB7kI.StateField).define({
    create () {
        return (0, $BEVwA.Decoration).none;
    },
    update (folded, tr) {
        folded = folded.map(tr.changes);
        for (let e of tr.effects){
            if (e.is($14831f1c512a5db9$export$a123efe007ad265) && !$14831f1c512a5db9$var$foldExists(folded, e.value.from, e.value.to)) folded = folded.update({
                add: [
                    $14831f1c512a5db9$var$foldWidget.range(e.value.from, e.value.to)
                ]
            });
            else if (e.is($14831f1c512a5db9$export$bf2507dc398fc1ab)) folded = folded.update({
                filter: (from, to)=>e.value.from != from || e.value.to != to,
                filterFrom: e.value.from,
                filterTo: e.value.to
            });
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) {
            let onSelection = false, { head: head } = tr.selection.main;
            folded.between(head, head, (a, b)=>{
                if (a < head && b > head) onSelection = true;
            });
            if (onSelection) folded = folded.update({
                filterFrom: head,
                filterTo: head,
                filter: (a, b)=>b <= head || a >= head
            });
        }
        return folded;
    },
    provide: (f)=>(0, $BEVwA.EditorView).decorations.from(f),
    toJSON (folded, state) {
        let ranges = [];
        folded.between(0, state.doc.length, (from, to)=>{
            ranges.push(from, to);
        });
        return ranges;
    },
    fromJSON (value) {
        if (!Array.isArray(value) || value.length % 2) throw new RangeError("Invalid JSON for fold state");
        let ranges = [];
        for(let i = 0; i < value.length;){
            let from = value[i++], to = value[i++];
            if (typeof from != "number" || typeof to != "number") throw new RangeError("Invalid JSON for fold state");
            ranges.push($14831f1c512a5db9$var$foldWidget.range(from, to));
        }
        return (0, $BEVwA.Decoration).set(ranges, true);
    }
});
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function $14831f1c512a5db9$export$2b3c199812391e05(state) {
    return state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false) || (0, $hB7kI.RangeSet).empty;
}
function $14831f1c512a5db9$var$findFold(state, from, to) {
    var _a;
    let found = null;
    (_a = state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from: from,
            to: to
        };
    });
    return found;
}
function $14831f1c512a5db9$var$foldExists(folded, from, to) {
    let found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function $14831f1c512a5db9$var$maybeEnable(state, other) {
    return state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false) ? other : other.concat((0, $hB7kI.StateEffect).appendConfig.of($14831f1c512a5db9$export$2c875b83a85d0f31()));
}
/**
Fold the lines that are selected, if possible.
*/ const $14831f1c512a5db9$export$52e96be2adbea02a = (view)=>{
    for (let line of $14831f1c512a5db9$var$selectedLines(view)){
        let range = $14831f1c512a5db9$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (range) {
            view.dispatch({
                effects: $14831f1c512a5db9$var$maybeEnable(view.state, [
                    $14831f1c512a5db9$export$a123efe007ad265.of(range),
                    $14831f1c512a5db9$var$announceFold(view, range)
                ])
            });
            return true;
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ const $14831f1c512a5db9$export$f4cd5e9f2c073861 = (view)=>{
    if (!view.state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false)) return false;
    let effects = [];
    for (let line of $14831f1c512a5db9$var$selectedLines(view)){
        let folded = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($14831f1c512a5db9$export$bf2507dc398fc1ab.of(folded), $14831f1c512a5db9$var$announceFold(view, folded, false));
    }
    if (effects.length) view.dispatch({
        effects: effects
    });
    return effects.length > 0;
};
function $14831f1c512a5db9$var$announceFold(view, range, fold = true) {
    let lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, $BEVwA.EditorView).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ const $14831f1c512a5db9$export$5396d9eaf1c0ba76 = (view)=>{
    let { state: state } = view, effects = [];
    for(let pos = 0; pos < state.doc.length;){
        let line = view.lineBlockAt(pos), range = $14831f1c512a5db9$export$cbe8a3d55245b07d(state, line.from, line.to);
        if (range) effects.push($14831f1c512a5db9$export$a123efe007ad265.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: $14831f1c512a5db9$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ const $14831f1c512a5db9$export$5671b24df569b27d = (view)=>{
    let field = view.state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false);
    if (!field || !field.size) return false;
    let effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push($14831f1c512a5db9$export$bf2507dc398fc1ab.of({
            from: from,
            to: to
        }));
    });
    view.dispatch({
        effects: effects
    });
    return true;
};
// Find the foldable region containing the given line, if one exists
function $14831f1c512a5db9$var$foldableContainer(view, lineBlock) {
    // Look backwards through line blocks until we find a foldable region that
    // intersects with the line
    for(let line = lineBlock;;){
        let foldableRegion = $14831f1c512a5db9$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (foldableRegion && foldableRegion.to > lineBlock.from) return foldableRegion;
        if (!line.from) return null;
        line = view.lineBlockAt(line.from - 1);
    }
}
/**
Toggle folding at cursors. Unfolds if there is an existing fold
starting in that line, tries to find a foldable range around it
otherwise.
*/ const $14831f1c512a5db9$export$b23e83f59d68c8f1 = (view)=>{
    let effects = [];
    for (let line of $14831f1c512a5db9$var$selectedLines(view)){
        let folded = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($14831f1c512a5db9$export$bf2507dc398fc1ab.of(folded), $14831f1c512a5db9$var$announceFold(view, folded, false));
        else {
            let foldRange = $14831f1c512a5db9$var$foldableContainer(view, line);
            if (foldRange) effects.push($14831f1c512a5db9$export$a123efe007ad265.of(foldRange), $14831f1c512a5db9$var$announceFold(view, foldRange));
        }
    }
    if (effects.length > 0) view.dispatch({
        effects: $14831f1c512a5db9$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ const $14831f1c512a5db9$export$39c52376a8936d67 = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: $14831f1c512a5db9$export$52e96be2adbea02a
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: $14831f1c512a5db9$export$f4cd5e9f2c073861
    },
    {
        key: "Ctrl-Alt-[",
        run: $14831f1c512a5db9$export$5396d9eaf1c0ba76
    },
    {
        key: "Ctrl-Alt-]",
        run: $14831f1c512a5db9$export$5671b24df569b27d
    }
];
const $14831f1c512a5db9$var$defaultConfig = {
    placeholderDOM: null,
    placeholderText: "…"
};
const $14831f1c512a5db9$var$foldConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (values) {
        return (0, $hB7kI.combineConfig)(values, $14831f1c512a5db9$var$defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function $14831f1c512a5db9$export$2c875b83a85d0f31(config) {
    let result = [
        $14831f1c512a5db9$export$6955fe1f7c578abb,
        $14831f1c512a5db9$var$baseTheme$1
    ];
    if (config) result.push($14831f1c512a5db9$var$foldConfig.of(config));
    return result;
}
const $14831f1c512a5db9$var$foldWidget = /*@__PURE__*/ (0, $BEVwA.Decoration).replace({
    widget: /*@__PURE__*/ new class extends (0, $BEVwA.WidgetType) {
        toDOM(view) {
            let { state: state } = view, conf = state.facet($14831f1c512a5db9$var$foldConfig);
            let onclick = (event)=>{
                let line = view.lineBlockAt(view.posAtDOM(event.target));
                let folded = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to);
                if (folded) view.dispatch({
                    effects: $14831f1c512a5db9$export$bf2507dc398fc1ab.of(folded)
                });
                event.preventDefault();
            };
            if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick);
            let element = document.createElement("span");
            element.textContent = conf.placeholderText;
            element.setAttribute("aria-label", state.phrase("folded code"));
            element.title = state.phrase("unfold");
            element.className = "cm-foldPlaceholder";
            element.onclick = onclick;
            return element;
        }
    }
});
const $14831f1c512a5db9$var$foldGutterDefaults = {
    openText: "⌄",
    closedText: "›",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: ()=>false
};
class $14831f1c512a5db9$var$FoldMarker extends (0, $BEVwA.GutterMarker) {
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        let span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function $14831f1c512a5db9$export$c4dcf64f741b6228(config = {}) {
    let fullConfig = Object.assign(Object.assign({}, $14831f1c512a5db9$var$foldGutterDefaults), config);
    let canFold = new $14831f1c512a5db9$var$FoldMarker(fullConfig, true), canUnfold = new $14831f1c512a5db9$var$FoldMarker(fullConfig, false);
    let markers = (0, $BEVwA.ViewPlugin).fromClass(class {
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet($14831f1c512a5db9$export$789c912f57fe164c) != update.state.facet($14831f1c512a5db9$export$789c912f57fe164c) || update.startState.field($14831f1c512a5db9$export$6955fe1f7c578abb, false) != update.state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false) || $14831f1c512a5db9$export$7fc98e56a4ca6be1(update.startState) != $14831f1c512a5db9$export$7fc98e56a4ca6be1(update.state) || fullConfig.foldingChanged(update)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            let builder = new (0, $hB7kI.RangeSetBuilder)();
            for (let line of view.viewportLineBlocks){
                let mark = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to) ? canUnfold : $14831f1c512a5db9$export$cbe8a3d55245b07d(view.state, line.from, line.to) ? canFold : null;
                if (mark) builder.add(line.from, line.from, mark);
            }
            return builder.finish();
        }
    });
    let { domEventHandlers: domEventHandlers } = fullConfig;
    return [
        markers,
        (0, $BEVwA.gutter)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, $hB7kI.RangeSet).empty;
            },
            initialSpacer () {
                return new $14831f1c512a5db9$var$FoldMarker(fullConfig, false);
            },
            domEventHandlers: Object.assign(Object.assign({}, domEventHandlers), {
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    let folded = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: $14831f1c512a5db9$export$bf2507dc398fc1ab.of(folded)
                        });
                        return true;
                    }
                    let range = $14831f1c512a5db9$export$cbe8a3d55245b07d(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: $14831f1c512a5db9$export$a123efe007ad265.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            })
        }),
        $14831f1c512a5db9$export$2c875b83a85d0f31()
    ];
}
const $14831f1c512a5db9$var$baseTheme$1 = /*@__PURE__*/ (0, $BEVwA.EditorView).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with higlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class $14831f1c512a5db9$export$4819f093bdd5b4a {
    constructor(/**
    The tag styles used to create this highlight style.
    */ specs, options){
        this.specs = specs;
        let modSpec;
        function def(spec) {
            let cls = (0, $luNHI.StyleModule).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        const scopeOpt = options.scope;
        this.scope = scopeOpt instanceof $14831f1c512a5db9$export$ce4fe1c9e6520c1a ? (type)=>type.prop($14831f1c512a5db9$export$27a2e78097f753f7) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, $6yW7d.tagHighlighter)(specs.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all: all
        }).style;
        this.module = modSpec ? new (0, $luNHI.StyleModule)(modSpec) : null;
        this.themeType = options.themeType;
    }
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new $14831f1c512a5db9$export$4819f093bdd5b4a(specs, options || {});
    }
}
const $14831f1c512a5db9$var$highlighterFacet = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $14831f1c512a5db9$var$fallbackHighlighter = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function $14831f1c512a5db9$var$getHighlighters(state) {
    let main = state.facet($14831f1c512a5db9$var$highlighterFacet);
    return main.length ? main : state.facet($14831f1c512a5db9$var$fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function $14831f1c512a5db9$export$ec1b956ff3a16361(highlighter, options) {
    let ext = [
        $14831f1c512a5db9$var$treeHighlighter
    ], themeType;
    if (highlighter instanceof $14831f1c512a5db9$export$4819f093bdd5b4a) {
        if (highlighter.module) ext.push((0, $BEVwA.EditorView).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push($14831f1c512a5db9$var$fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push($14831f1c512a5db9$var$highlighterFacet.computeN([
        (0, $BEVwA.EditorView).darkTheme
    ], (state)=>{
        return state.facet((0, $BEVwA.EditorView).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push($14831f1c512a5db9$var$highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function $14831f1c512a5db9$export$8ca2b052028e8782(state, tags, scope) {
    let highlighters = $14831f1c512a5db9$var$getHighlighters(state);
    let result = null;
    if (highlighters) {
        for (let highlighter of highlighters)if (!highlighter.scope || scope && highlighter.scope(scope)) {
            let cls = highlighter.style(tags);
            if (cls) result = result ? result + " " + cls : cls;
        }
    }
    return result;
}
class $14831f1c512a5db9$var$TreeHighlighter {
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.buildDeco(view, $14831f1c512a5db9$var$getHighlighters(view.state));
    }
    update(update) {
        let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(update.state), highlighters = $14831f1c512a5db9$var$getHighlighters(update.state);
        let styleChange = highlighters != $14831f1c512a5db9$var$getHighlighters(update.startState);
        if (tree.length < update.view.viewport.to && !styleChange && tree.type == this.tree.type) this.decorations = this.decorations.map(update.changes);
        else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, $BEVwA.Decoration).none;
        let builder = new (0, $hB7kI.RangeSetBuilder)();
        for (let { from: from, to: to } of view.visibleRanges)(0, $6yW7d.highlightTree)(this.tree, highlighters, (from, to, style)=>{
            builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, $BEVwA.Decoration).mark({
                class: style
            })));
        }, from, to);
        return builder.finish();
    }
}
const $14831f1c512a5db9$var$treeHighlighter = /*@__PURE__*/ (0, $hB7kI.Prec).high(/*@__PURE__*/ (0, $BEVwA.ViewPlugin).fromClass($14831f1c512a5db9$var$TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ const $14831f1c512a5db9$export$bb02a6818dd48320 = /*@__PURE__*/ $14831f1c512a5db9$export$4819f093bdd5b4a.define([
    {
        tag: (0, $6yW7d.tags).meta,
        color: "#404740"
    },
    {
        tag: (0, $6yW7d.tags).link,
        textDecoration: "underline"
    },
    {
        tag: (0, $6yW7d.tags).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, $6yW7d.tags).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $6yW7d.tags).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $6yW7d.tags).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $6yW7d.tags).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, $6yW7d.tags).atom,
            (0, $6yW7d.tags).bool,
            (0, $6yW7d.tags).url,
            (0, $6yW7d.tags).contentSeparator,
            (0, $6yW7d.tags).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, $6yW7d.tags).literal,
            (0, $6yW7d.tags).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, $6yW7d.tags).string,
            (0, $6yW7d.tags).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, $6yW7d.tags).regexp,
            (0, $6yW7d.tags).escape,
            /*@__PURE__*/ (0, $6yW7d.tags).special((0, $6yW7d.tags).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, $6yW7d.tags).definition((0, $6yW7d.tags).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, $6yW7d.tags).local((0, $6yW7d.tags).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, $6yW7d.tags).typeName,
            (0, $6yW7d.tags).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, $6yW7d.tags).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, $6yW7d.tags).special((0, $6yW7d.tags).variableName),
            (0, $6yW7d.tags).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, $6yW7d.tags).definition((0, $6yW7d.tags).propertyName),
        color: "#00c"
    },
    {
        tag: (0, $6yW7d.tags).comment,
        color: "#940"
    },
    {
        tag: (0, $6yW7d.tags).invalid,
        color: "#f00"
    }
]);
const $14831f1c512a5db9$var$baseTheme = /*@__PURE__*/ (0, $BEVwA.EditorView).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
const $14831f1c512a5db9$var$DefaultScanDist = 10000, $14831f1c512a5db9$var$DefaultBrackets = "()[]{}";
const $14831f1c512a5db9$var$bracketMatchingConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (configs) {
        return (0, $hB7kI.combineConfig)(configs, {
            afterCursor: true,
            brackets: $14831f1c512a5db9$var$DefaultBrackets,
            maxScanDistance: $14831f1c512a5db9$var$DefaultScanDist,
            renderMatch: $14831f1c512a5db9$var$defaultRenderMatch
        });
    }
});
const $14831f1c512a5db9$var$matchingMark = /*@__PURE__*/ (0, $BEVwA.Decoration).mark({
    class: "cm-matchingBracket"
}), $14831f1c512a5db9$var$nonmatchingMark = /*@__PURE__*/ (0, $BEVwA.Decoration).mark({
    class: "cm-nonmatchingBracket"
});
function $14831f1c512a5db9$var$defaultRenderMatch(match) {
    let decorations = [];
    let mark = match.matched ? $14831f1c512a5db9$var$matchingMark : $14831f1c512a5db9$var$nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
const $14831f1c512a5db9$var$bracketMatchingState = /*@__PURE__*/ (0, $hB7kI.StateField).define({
    create () {
        return (0, $BEVwA.Decoration).none;
    },
    update (deco, tr) {
        if (!tr.docChanged && !tr.selection) return deco;
        let decorations = [];
        let config = tr.state.facet($14831f1c512a5db9$var$bracketMatchingConfig);
        for (let range of tr.state.selection.ranges){
            if (!range.empty) continue;
            let match = $14831f1c512a5db9$export$3391942603e90cda(tr.state, range.head, -1, config) || range.head > 0 && $14831f1c512a5db9$export$3391942603e90cda(tr.state, range.head - 1, 1, config) || config.afterCursor && ($14831f1c512a5db9$export$3391942603e90cda(tr.state, range.head, 1, config) || range.head < tr.state.doc.length && $14831f1c512a5db9$export$3391942603e90cda(tr.state, range.head + 1, -1, config));
            if (match) decorations = decorations.concat(config.renderMatch(match, tr.state));
        }
        return (0, $BEVwA.Decoration).set(decorations, true);
    },
    provide: (f)=>(0, $BEVwA.EditorView).decorations.from(f)
});
const $14831f1c512a5db9$var$bracketMatchingUnique = [
    $14831f1c512a5db9$var$bracketMatchingState,
    $14831f1c512a5db9$var$baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function $14831f1c512a5db9$export$cef7edfd214be605(config = {}) {
    return [
        $14831f1c512a5db9$var$bracketMatchingConfig.of(config),
        $14831f1c512a5db9$var$bracketMatchingUnique
    ];
}
/**
When larger syntax nodes, such as HTML tags, are marked as
opening/closing, it can be a bit messy to treat the whole node as
a matchable bracket. This node prop allows you to define, for such
a node, a ‘handle’—the part of the node that is highlighted, and
that the cursor must be on to activate highlighting in the first
place.
*/ const $14831f1c512a5db9$export$ca7d74cd5b9f1011 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
function $14831f1c512a5db9$var$matchingNodes(node, dir, brackets) {
    let byProp = node.prop(dir < 0 ? (0, $6DlXS.NodeProp).openedBy : (0, $6DlXS.NodeProp).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        let index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
function $14831f1c512a5db9$var$findHandle(node) {
    let hasHandle = node.type.prop($14831f1c512a5db9$export$ca7d74cd5b9f1011);
    return hasHandle ? hasHandle(node.node) : node;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function $14831f1c512a5db9$export$3391942603e90cda(state, pos, dir, config = {}) {
    let maxScanDistance = config.maxScanDistance || $14831f1c512a5db9$var$DefaultScanDist, brackets = config.brackets || $14831f1c512a5db9$var$DefaultBrackets;
    let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(state), node = tree.resolveInner(pos, dir);
    for(let cur = node; cur; cur = cur.parent){
        let matches = $14831f1c512a5db9$var$matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) {
            let handle = $14831f1c512a5db9$var$findHandle(cur);
            if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to)) return $14831f1c512a5db9$var$matchMarkedBrackets(state, pos, dir, cur, handle, matches, brackets);
        }
    }
    return $14831f1c512a5db9$var$matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function $14831f1c512a5db9$var$matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
    let parent = token.parent, firstToken = {
        from: handle.from,
        to: handle.to
    };
    let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
            let endHandle = $14831f1c512a5db9$var$findHandle(cursor);
            return {
                start: firstToken,
                end: endHandle ? {
                    from: endHandle.from,
                    to: endHandle.to
                } : undefined,
                matched: true
            };
        } else if ($14831f1c512a5db9$var$matchingNodes(cursor.type, dir, brackets)) depth++;
        else if ($14831f1c512a5db9$var$matchingNodes(cursor.type, -dir, brackets)) {
            if (depth == 0) {
                let endHandle = $14831f1c512a5db9$var$findHandle(cursor);
                return {
                    start: firstToken,
                    end: endHandle && endHandle.from < endHandle.to ? {
                        from: endHandle.from,
                        to: endHandle.to
                    } : undefined,
                    matched: false
                };
            }
            depth--;
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function $14831f1c512a5db9$var$matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    let bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    let startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(let distance = 0; !iter.next().done && distance <= maxScanDistance;){
        let text = iter.value;
        if (dir < 0) distance += text.length;
        let basePos = pos + distance * dir;
        for(let pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos != end; pos += dir){
            let found = brackets.indexOf(text[pos]);
            if (found < 0 || tree.resolveInner(basePos + pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + pos,
                    to: basePos + pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function $14831f1c512a5db9$var$countCol(string, end, tabSize, startIndex = 0, startValue = 0) {
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    let n = startValue;
    for(let i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class $14831f1c512a5db9$export$72a09304cc8c1940 {
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit, overrideIndent){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        this.overrideIndent = overrideIndent;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        let ch = this.string.charAt(this.pos);
        let ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        let start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        let start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        let found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = $14831f1c512a5db9$var$countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        var _a;
        return (_a = this.overrideIndent) !== null && _a !== void 0 ? _a : $14831f1c512a5db9$var$countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            let cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            let substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            let match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
}
function $14831f1c512a5db9$var$fullParser(spec) {
    return {
        name: spec.name || "",
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || $14831f1c512a5db9$var$defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || $14831f1c512a5db9$var$noTokens
    };
}
function $14831f1c512a5db9$var$defaultCopyState(state) {
    if (typeof state != "object") return state;
    let newState = {};
    for(let prop in state){
        let val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
const $14831f1c512a5db9$var$IndentedFrom = /*@__PURE__*/ new WeakMap();
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class $14831f1c512a5db9$export$5ee3cc23916207d8 extends $14831f1c512a5db9$export$ce4fe1c9e6520c1a {
    constructor(parser){
        let data = $14831f1c512a5db9$export$b57f683f43553b99(parser.languageData);
        let p = $14831f1c512a5db9$var$fullParser(parser), self;
        let impl = new class extends (0, $6DlXS.Parser) {
            createParse(input, fragments, ranges) {
                return new $14831f1c512a5db9$var$Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [
            $14831f1c512a5db9$export$5952625dce50d1f3.of((cx, pos)=>this.getIndent(cx, pos))
        ], parser.name);
        this.topNode = $14831f1c512a5db9$var$docID(data);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, $6DlXS.NodeProp)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new $14831f1c512a5db9$var$TokenTable(p.tokenTable) : $14831f1c512a5db9$var$defaultTokenTable;
    }
    /**
    Define a stream language.
    */ static define(spec) {
        return new $14831f1c512a5db9$export$5ee3cc23916207d8(spec);
    }
    getIndent(cx, pos) {
        let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(cx.state), at = tree.resolve(pos);
        while(at && at.type != this.topNode)at = at.parent;
        if (!at) return null;
        let from = undefined;
        let { overrideIndentation: overrideIndentation } = cx.options;
        if (overrideIndentation) {
            from = $14831f1c512a5db9$var$IndentedFrom.get(cx.state);
            if (from != null && from < pos - 1e4) from = undefined;
        }
        let start = $14831f1c512a5db9$var$findState(this, tree, 0, at.from, from !== null && from !== void 0 ? from : pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = 0;
        }
        if (pos - statePos > 10000 /* MaxIndentScanDist */ ) return null;
        while(statePos < pos){
            let line = cx.state.doc.lineAt(statePos), end = Math.min(pos, line.to);
            if (line.length) {
                let indentation = overrideIndentation ? overrideIndentation(line.from) : -1;
                let stream = new $14831f1c512a5db9$export$72a09304cc8c1940(line.text, cx.state.tabSize, cx.unit, indentation < 0 ? undefined : indentation);
                while(stream.pos < end - line.from)$14831f1c512a5db9$var$readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == pos) break;
            statePos = line.to + 1;
        }
        let line = cx.lineAt(pos);
        if (overrideIndentation && from == null) $14831f1c512a5db9$var$IndentedFrom.set(cx.state, line.from);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(line.text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
}
function $14831f1c512a5db9$var$findState(lang, tree, off, startPos, before) {
    let state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(let i = tree.children.length - 1; i >= 0; i--){
        let child = tree.children[i], pos = off + tree.positions[i];
        let found = child instanceof (0, $6DlXS.Tree) && pos < before && $14831f1c512a5db9$var$findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function $14831f1c512a5db9$var$cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && tree.type == lang.topNode) inside = true;
    for(let i = tree.children.length - 1; i >= 0; i--){
        let pos = tree.positions[i], child = tree.children[i], inner;
        if (pos < to && child instanceof (0, $6DlXS.Tree)) {
            if (!(inner = $14831f1c512a5db9$var$cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, $6DlXS.Tree)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function $14831f1c512a5db9$var$findStartInFragments(lang, fragments, startPos, editorState) {
    for (let f of fragments){
        let from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
        let found = from <= startPos && to > startPos && $14831f1c512a5db9$var$findState(lang, f.tree, 0 - f.offset, startPos, to), tree;
        if (found && (tree = $14831f1c512a5db9$var$cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
            state: found.state,
            tree: tree
        };
    }
    return {
        state: lang.streamParser.startState(editorState ? $14831f1c512a5db9$export$ad3205d09311a797(editorState) : 4),
        tree: (0, $6DlXS.Tree).empty
    };
}
class $14831f1c512a5db9$var$Parse {
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        let context = $14831f1c512a5db9$export$3fcb7c01ff2a41fa.get(), from = ranges[0].from;
        let { state: state, tree: tree } = $14831f1c512a5db9$var$findStartInFragments(lang, fragments, from, context === null || context === void 0 ? void 0 : context.state);
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(let i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* MaxDistanceBeforeViewport */ ) {
            this.state = this.lang.streamParser.startState($14831f1c512a5db9$export$ad3205d09311a797(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
    advance() {
        let context = $14831f1c512a5db9$export$3fcb7c01ff2a41fa.get();
        let parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        let end = Math.min(parseEnd, this.chunkStart + 2048 /* ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        let chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            let eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        let from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(let index = this.rangeIndex;;){
            let rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            let rangeStart = this.ranges[index].from;
            let after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line: line,
            end: end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            let end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            let start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, size, offset) {
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            let len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        let { line: line, end: end } = this.nextLine(), offset = 0, { streamParser: streamParser } = this.lang;
        let stream = new $14831f1c512a5db9$export$72a09304cc8c1940(line, context ? context.state.tabSize : 4, context ? $14831f1c512a5db9$export$ad3205d09311a797(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            let token = $14831f1c512a5db9$var$readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, 4, offset);
            if (stream.start > 10000 /* MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        let tree = (0, $6DlXS.Tree).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet: $14831f1c512a5db9$var$nodeSet,
            topID: 0,
            maxBufferLength: 2048 /* ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, $6DlXS.Tree)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, $6DlXS.Tree)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
}
function $14831f1c512a5db9$var$readToken(token, stream, state) {
    stream.start = stream.pos;
    for(let i = 0; i < 10; i++){
        let result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
const $14831f1c512a5db9$var$noTokens = /*@__PURE__*/ Object.create(null);
const $14831f1c512a5db9$var$typeArray = [
    (0, $6DlXS.NodeType).none
];
const $14831f1c512a5db9$var$nodeSet = /*@__PURE__*/ new (0, $6DlXS.NodeSet)($14831f1c512a5db9$var$typeArray);
const $14831f1c512a5db9$var$warned = [];
const $14831f1c512a5db9$var$defaultTable = /*@__PURE__*/ Object.create(null);
for (let [legacyName, name] of [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
])$14831f1c512a5db9$var$defaultTable[legacyName] = /*@__PURE__*/ $14831f1c512a5db9$var$createTokenType($14831f1c512a5db9$var$noTokens, name);
class $14831f1c512a5db9$var$TokenTable {
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), $14831f1c512a5db9$var$defaultTable);
    }
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = $14831f1c512a5db9$var$createTokenType(this.extra, tag));
    }
}
const $14831f1c512a5db9$var$defaultTokenTable = /*@__PURE__*/ new $14831f1c512a5db9$var$TokenTable($14831f1c512a5db9$var$noTokens);
function $14831f1c512a5db9$var$warnForPart(part, msg) {
    if ($14831f1c512a5db9$var$warned.indexOf(part) > -1) return;
    $14831f1c512a5db9$var$warned.push(part);
    console.warn(msg);
}
function $14831f1c512a5db9$var$createTokenType(extra, tagStr) {
    let tag = null;
    for (let part of tagStr.split(".")){
        let value = extra[part] || (0, $6yW7d.tags)[part];
        if (!value) $14831f1c512a5db9$var$warnForPart(part, `Unknown highlighting tag ${part}`);
        else if (typeof value == "function") {
            if (!tag) $14831f1c512a5db9$var$warnForPart(part, `Modifier ${part} used at start of tag`);
            else tag = value(tag);
        } else if (tag) $14831f1c512a5db9$var$warnForPart(part, `Tag ${part} used as modifier`);
        else tag = value;
    }
    if (!tag) return 0;
    let name = tagStr.replace(/ /g, "_"), type = (0, $6DlXS.NodeType).define({
        id: $14831f1c512a5db9$var$typeArray.length,
        name: name,
        props: [
            (0, $6yW7d.styleTags)({
                [name]: tag
            })
        ]
    });
    $14831f1c512a5db9$var$typeArray.push(type);
    return type.id;
}
function $14831f1c512a5db9$var$docID(data) {
    let type = (0, $6DlXS.NodeType).define({
        id: $14831f1c512a5db9$var$typeArray.length,
        name: "Document",
        props: [
            $14831f1c512a5db9$export$27a2e78097f753f7.add(()=>data)
        ]
    });
    $14831f1c512a5db9$var$typeArray.push(type);
    return type;
}

});
parcelRequire.register("6DlXS", function(module, exports) {

$parcel$export(module.exports, "DefaultBufferLength", () => $4d476c57e17b24ca$export$de305a849879ffa);
$parcel$export(module.exports, "NodeProp", () => $4d476c57e17b24ca$export$b8034b9bc18acd90);
$parcel$export(module.exports, "NodeType", () => $4d476c57e17b24ca$export$f06e977173f1857c);
$parcel$export(module.exports, "NodeSet", () => $4d476c57e17b24ca$export$7fad5fb00d8de02c);
$parcel$export(module.exports, "IterMode", () => $4d476c57e17b24ca$export$b0e28367f55837aa);
$parcel$export(module.exports, "Tree", () => $4d476c57e17b24ca$export$7fbedc92909ed28e);
$parcel$export(module.exports, "NodeWeakMap", () => $4d476c57e17b24ca$export$7f13b5dc44c541ae);
$parcel$export(module.exports, "TreeFragment", () => $4d476c57e17b24ca$export$3ae2ede6dca97077);
$parcel$export(module.exports, "Parser", () => $4d476c57e17b24ca$export$7acfa6ed01010e37);
$parcel$export(module.exports, "parseMixed", () => $4d476c57e17b24ca$export$5dcc455959c76221);
// FIXME profile adding a per-Tree TreeNode cache, validating it by
// parent pointer
/// The default maximum length of a `TreeBuffer` node.
const $4d476c57e17b24ca$export$de305a849879ffa = 1024;
let $4d476c57e17b24ca$var$nextPropID = 0;
class $4d476c57e17b24ca$var$Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/// Each [node type](#common.NodeType) or [individual tree](#common.Tree)
/// can have metadata associated with it in props. Instances of this
/// class represent prop names.
class $4d476c57e17b24ca$export$b8034b9bc18acd90 {
    /// Create a new node prop type.
    constructor(config = {}){
        this.id = $4d476c57e17b24ca$var$nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
    }
    /// This is meant to be used with
    /// [`NodeSet.extend`](#common.NodeSet.extend) or
    /// [`LRParser.configure`](#lr.ParserConfig.props) to compute
    /// prop values for each node type in the set. Takes a [match
    /// object](#common.NodeType^match) or function that returns undefined
    /// if the node type doesn't get this prop, and the prop's value if
    /// it does.
    add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = $4d476c57e17b24ca$export$f06e977173f1857c.match(match);
        return (type)=>{
            let result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
}
/// Prop that is used to describe matching delimiters. For opening
/// delimiters, this holds an array of node names (written as a
/// space-separated string when declaring this prop in a grammar)
/// for the node types of closing delimiters that match it.
$4d476c57e17b24ca$export$b8034b9bc18acd90.closedBy = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/// The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
/// attached to closing delimiters, holding an array of node names
/// of types of matching opening delimiters.
$4d476c57e17b24ca$export$b8034b9bc18acd90.openedBy = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/// Used to assign node types to groups (for example, all node
/// types that represent an expression could be tagged with an
/// `"Expression"` group).
$4d476c57e17b24ca$export$b8034b9bc18acd90.group = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/// The hash of the [context](#lr.ContextTracker.constructor)
/// that the node was parsed in, if any. Used to limit reuse of
/// contextual nodes.
$4d476c57e17b24ca$export$b8034b9bc18acd90.contextHash = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    perNode: true
});
/// The distance beyond the end of the node that the tokenizer
/// looked ahead for any of the tokens inside the node. (The LR
/// parser only stores this when it is larger than 25, for
/// efficiency reasons.)
$4d476c57e17b24ca$export$b8034b9bc18acd90.lookAhead = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    perNode: true
});
/// This per-node prop is used to replace a given node, or part of a
/// node, with another tree. This is useful to include trees from
/// different languages in mixed-language parsers.
$4d476c57e17b24ca$export$b8034b9bc18acd90.mounted = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    perNode: true
});
/// A mounted tree, which can be [stored](#common.NodeProp^mounted) on
/// a tree node to indicate that parts of its content are
/// represented by another tree.
class $4d476c57e17b24ca$export$358cdd8bd77577cc {
    constructor(/// The inner tree.
    tree, /// If this is null, this tree replaces the entire node (it will
    /// be included in the regular iteration instead of its host
    /// node). If not, only the given ranges are considered to be
    /// covered by this tree. This is used for trees that are mixed in
    /// a way that isn't strictly hierarchical. Such mounted trees are
    /// only entered by [`resolveInner`](#common.Tree.resolveInner)
    /// and [`enter`](#common.SyntaxNode.enter).
    overlay, /// The parser used to create this subtree.
    parser){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
    }
}
const $4d476c57e17b24ca$var$noProps = Object.create(null);
/// Each node in a syntax tree has a node type associated with it.
class $4d476c57e17b24ca$export$f06e977173f1857c {
    /// @internal
    constructor(/// The name of the node type. Not necessarily unique, but if the
    /// grammar was written properly, different node types with the
    /// same name within a node set should play the same semantic
    /// role.
    name, /// @internal
    props, /// The id of this node in its set. Corresponds to the term ids
    /// used in the parser.
    id, /// @internal
    flags = 0){
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
    /// Define a node type.
    static define(spec) {
        let props = spec.props && spec.props.length ? Object.create(null) : $4d476c57e17b24ca$var$noProps;
        let flags = (spec.top ? 1 /* NodeFlag.Top */  : 0) | (spec.skipped ? 2 /* NodeFlag.Skipped */  : 0) | (spec.error ? 4 /* NodeFlag.Error */  : 0) | (spec.name == null ? 8 /* NodeFlag.Anonymous */  : 0);
        let type = new $4d476c57e17b24ca$export$f06e977173f1857c(spec.name || "", props, spec.id, flags);
        if (spec.props) for (let src of spec.props){
            if (!Array.isArray(src)) src = src(type);
            if (src) {
                if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                props[src[0].id] = src[1];
            }
        }
        return type;
    }
    /// Retrieves a node prop for this type. Will return `undefined` if
    /// the prop isn't present on this node.
    prop(prop) {
        return this.props[prop.id];
    }
    /// True when this is the top node of a grammar.
    get isTop() {
        return (this.flags & 1 /* NodeFlag.Top */ ) > 0;
    }
    /// True when this node is produced by a skip rule.
    get isSkipped() {
        return (this.flags & 2 /* NodeFlag.Skipped */ ) > 0;
    }
    /// Indicates whether this is an error node.
    get isError() {
        return (this.flags & 4 /* NodeFlag.Error */ ) > 0;
    }
    /// When true, this node type doesn't correspond to a user-declared
    /// named node, for example because it is used to cache repetition.
    get isAnonymous() {
        return (this.flags & 8 /* NodeFlag.Anonymous */ ) > 0;
    }
    /// Returns true when this node's name or one of its
    /// [groups](#common.NodeProp^group) matches the given string.
    is(name) {
        if (typeof name == "string") {
            if (this.name == name) return true;
            let group = this.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /// Create a function from node types to arbitrary values by
    /// specifying an object whose property names are node or
    /// [group](#common.NodeProp^group) names. Often useful with
    /// [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    /// names, separated by spaces, in a single property name to map
    /// multiple node names to a single value.
    static match(map) {
        let direct = Object.create(null);
        for(let prop in map)for (let name of prop.split(" "))direct[name] = map[prop];
        return (node)=>{
            for(let groups = node.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.group), i = -1; i < (groups ? groups.length : 0); i++){
                let found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
}
/// An empty dummy node type to use when no actual type is available.
$4d476c57e17b24ca$export$f06e977173f1857c.none = new $4d476c57e17b24ca$export$f06e977173f1857c("", Object.create(null), 0, 8 /* NodeFlag.Anonymous */ );
/// A node set holds a collection of node types. It is used to
/// compactly represent trees by storing their type ids, rather than a
/// full pointer to the type object, in a numeric array. Each parser
/// [has](#lr.LRParser.nodeSet) a node set, and [tree
/// buffers](#common.TreeBuffer) can only store collections of nodes
/// from the same set. A set can have a maximum of 2**16 (65536) node
/// types in it, so that the ids fit into 16-bit typed array slots.
class $4d476c57e17b24ca$export$7fad5fb00d8de02c {
    /// Create a set with the given types. The `id` property of each
    /// type should correspond to its position within the array.
    constructor(/// The node types in this set, by id.
    types){
        this.types = types;
        for(let i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    /// Create a copy of this set with some node properties added. The
    /// arguments to this method can be created with
    /// [`NodeProp.add`](#common.NodeProp.add).
    extend(...props) {
        let newTypes = [];
        for (let type of this.types){
            let newProps = null;
            for (let source of props){
                let add = source(type);
                if (add) {
                    if (!newProps) newProps = Object.assign({}, type.props);
                    newProps[add[0].id] = add[1];
                }
            }
            newTypes.push(newProps ? new $4d476c57e17b24ca$export$f06e977173f1857c(type.name, newProps, type.id, type.flags) : type);
        }
        return new $4d476c57e17b24ca$export$7fad5fb00d8de02c(newTypes);
    }
}
const $4d476c57e17b24ca$var$CachedNode = new WeakMap(), $4d476c57e17b24ca$var$CachedInnerNode = new WeakMap();
/// Options that control iteration. Can be combined with the `|`
/// operator to enable multiple ones.
var $4d476c57e17b24ca$export$b0e28367f55837aa;
(function(IterMode) {
    /// When enabled, iteration will only visit [`Tree`](#common.Tree)
    /// objects, not nodes packed into
    /// [`TreeBuffer`](#common.TreeBuffer)s.
    IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /// Enable this to make iteration include anonymous nodes (such as
    /// the nodes that wrap repeated grammar constructs into a balanced
    /// tree).
    IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /// By default, regular [mounted](#common.NodeProp^mounted) nodes
    /// replace their base node in iteration. Enable this to ignore them
    /// instead.
    IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /// This option only applies in
    /// [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    /// library to not enter mounted overlays if one covers the given
    /// position.
    IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})($4d476c57e17b24ca$export$b0e28367f55837aa || ($4d476c57e17b24ca$export$b0e28367f55837aa = {}));
/// A piece of syntax tree. There are two ways to approach these
/// trees: the way they are actually stored in memory, and the
/// convenient way.
///
/// Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
/// objects. By packing detail information into `TreeBuffer` leaf
/// nodes, the representation is made a lot more memory-efficient.
///
/// However, when you want to actually work with tree nodes, this
/// representation is very awkward, so most client code will want to
/// use the [`TreeCursor`](#common.TreeCursor) or
/// [`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
/// a view on some part of this data structure, and can be used to
/// move around to adjacent nodes.
class $4d476c57e17b24ca$export$7fbedc92909ed28e {
    /// Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    constructor(/// The type of the top node.
    type, /// This node's child nodes.
    children, /// The positions (offsets relative to the start of this tree) of
    /// the children.
    positions, /// The total length of this tree
    length, /// Per-node [node props](#common.NodeProp) to associate with this node.
    props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /// @internal
        this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            for (let [prop, value] of props)this.props[typeof prop == "number" ? prop : prop.id] = value;
        }
    }
    /// @internal
    toString() {
        let mounted = this.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.mounted);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        let children = "";
        for (let ch of this.children){
            let str = ch.toString();
            if (str) {
                if (children) children += ",";
                children += str;
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /// Get a [tree cursor](#common.TreeCursor) positioned at the top of
    /// the tree. Mode can be used to [control](#common.IterMode) which
    /// nodes the cursor visits.
    cursor(mode = 0) {
        return new $4d476c57e17b24ca$export$3ae4554f36e54a34(this.topNode, mode);
    }
    /// Get a [tree cursor](#common.TreeCursor) pointing into this tree
    /// at the given position and side (see
    /// [`moveTo`](#common.TreeCursor.moveTo).
    cursorAt(pos, side = 0, mode = 0) {
        let scope = $4d476c57e17b24ca$var$CachedNode.get(this) || this.topNode;
        let cursor = new $4d476c57e17b24ca$export$3ae4554f36e54a34(scope);
        cursor.moveTo(pos, side);
        $4d476c57e17b24ca$var$CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /// Get a [syntax node](#common.SyntaxNode) object for the top of the
    /// tree.
    get topNode() {
        return new $4d476c57e17b24ca$var$TreeNode(this, 0, 0, null);
    }
    /// Get the [syntax node](#common.SyntaxNode) at the given position.
    /// If `side` is -1, this will move into nodes that end at the
    /// position. If 1, it'll move into nodes that start at the
    /// position. With 0, it'll only enter nodes that cover the position
    /// from both sides.
    ///
    /// Note that this will not enter
    /// [overlays](#common.MountedTree.overlay), and you often want
    /// [`resolveInner`](#common.Tree.resolveInner) instead.
    resolve(pos, side = 0) {
        let node = $4d476c57e17b24ca$var$resolveNode($4d476c57e17b24ca$var$CachedNode.get(this) || this.topNode, pos, side, false);
        $4d476c57e17b24ca$var$CachedNode.set(this, node);
        return node;
    }
    /// Like [`resolve`](#common.Tree.resolve), but will enter
    /// [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    /// pointing into the innermost overlaid tree at the given position
    /// (with parent links going through all parent structure, including
    /// the host trees).
    resolveInner(pos, side = 0) {
        let node = $4d476c57e17b24ca$var$resolveNode($4d476c57e17b24ca$var$CachedInnerNode.get(this) || this.topNode, pos, side, true);
        $4d476c57e17b24ca$var$CachedInnerNode.set(this, node);
        return node;
    }
    /// Iterate over the tree and its children, calling `enter` for any
    /// node that touches the `from`/`to` region (if given) before
    /// running over such a node's children, and `leave` (if given) when
    /// leaving the node. When `enter` returns `false`, that node will
    /// not have its children iterated over (or `leave` called).
    iterate(spec) {
        let { enter: enter, leave: leave, from: from = 0, to: to = this.length } = spec;
        let mode = spec.mode || 0, anon = (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous) > 0;
        for(let c = this.cursor(mode | $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous);;){
            let entered = false;
            if (c.from <= to && c.to >= from && (!anon && c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && (anon || !c.type.isAnonymous)) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /// Get the value of the given [node prop](#common.NodeProp) for this
    /// node. Works with both per-node and per-type props.
    prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /// Returns the node's [per-node props](#common.NodeProp.perNode) in a
    /// format that can be passed to the [`Tree`](#common.Tree)
    /// constructor.
    get propValues() {
        let result = [];
        if (this.props) for(let id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /// Balance the direct children of this tree, producing a copy of
    /// which may have children grouped into subtrees with type
    /// [`NodeType.none`](#common.NodeType^none).
    balance(config = {}) {
        return this.children.length <= 8 /* Balance.BranchFactor */  ? this : $4d476c57e17b24ca$var$balanceRange($4d476c57e17b24ca$export$f06e977173f1857c.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new $4d476c57e17b24ca$export$7fbedc92909ed28e(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new $4d476c57e17b24ca$export$7fbedc92909ed28e($4d476c57e17b24ca$export$f06e977173f1857c.none, children, positions, length)));
    }
    /// Build a tree from a postfix-ordered buffer of node information,
    /// or a cursor over such a buffer.
    static build(data) {
        return $4d476c57e17b24ca$var$buildTree(data);
    }
}
/// The empty tree
$4d476c57e17b24ca$export$7fbedc92909ed28e.empty = new $4d476c57e17b24ca$export$7fbedc92909ed28e($4d476c57e17b24ca$export$f06e977173f1857c.none, [], [], 0);
class $4d476c57e17b24ca$var$FlatBufferCursor {
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new $4d476c57e17b24ca$var$FlatBufferCursor(this.buffer, this.index);
    }
}
/// Tree buffers contain (type, start, end, endIndex) quads for each
/// node. In such a buffer, nodes are stored in prefix order (parents
/// before children, with the endIndex of the parent indicating which
/// children belong to it).
class $4d476c57e17b24ca$export$33300581b70be371 {
    /// Create a tree buffer.
    constructor(/// The buffer's content.
    buffer, /// The total length of the group of nodes in the buffer.
    length, /// The node set used in this buffer.
    set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
    /// @internal
    get type() {
        return $4d476c57e17b24ca$export$f06e977173f1857c.none;
    }
    /// @internal
    toString() {
        let result = [];
        for(let index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /// @internal
    childString(index) {
        let id = this.buffer[index], endIndex = this.buffer[index + 3];
        let type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        let children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /// @internal
    findChild(startIndex, endIndex, dir, pos, side) {
        let { buffer: buffer } = this, pick = -1;
        for(let i = startIndex; i != endIndex; i = buffer[i + 3])if ($4d476c57e17b24ca$var$checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /// @internal
    slice(startI, endI, from) {
        let b = this.buffer;
        let copy = new Uint16Array(endI - startI), len = 0;
        for(let i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            let to = copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
            len = Math.max(len, to);
        }
        return new $4d476c57e17b24ca$export$33300581b70be371(copy, len, this.set);
    }
}
function $4d476c57e17b24ca$var$checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Side.Before */ :
            return from < pos;
        case -1 /* Side.AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Side.Around */ :
            return from < pos && to > pos;
        case 1 /* Side.AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* Side.After */ :
            return to > pos;
        case 4 /* Side.DontCare */ :
            return true;
    }
}
function $4d476c57e17b24ca$var$enterUnfinishedNodesBefore(node, pos) {
    let scan = node.childBefore(pos);
    while(scan){
        let last = scan.lastChild;
        if (!last || last.to != scan.to) break;
        if (last.type.isError && last.from == last.to) {
            node = scan;
            scan = last.prevSibling;
        } else scan = last;
    }
    return node;
}
function $4d476c57e17b24ca$var$resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        let parent = !overlays && node instanceof $4d476c57e17b24ca$var$TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    let mode = overlays ? 0 : $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent)if (scan instanceof $4d476c57e17b24ca$var$TreeNode && scan.index < 0 && ((_a = parent.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent;
    }
    for(;;){
        let inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class $4d476c57e17b24ca$var$TreeNode {
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side, mode = 0) {
        for(let parent = this;;){
            for(let { children: children, positions: positions } = parent._tree, e = dir > 0 ? children.length : -1; i != e; i += dir){
                let next = children[i], start = positions[i] + parent.from;
                if (!$4d476c57e17b24ca$var$checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof $4d476c57e17b24ca$export$33300581b70be371) {
                    if (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.ExcludeBuffers) continue;
                    let index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new $4d476c57e17b24ca$var$BufferNode(new $4d476c57e17b24ca$var$BufferContext(parent, next, i, start), null, index);
                } else if (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous || !next.type.isAnonymous || $4d476c57e17b24ca$var$hasChild(next)) {
                    let mounted;
                    if (!(mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreMounts) && next.props && (mounted = next.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.mounted)) && !mounted.overlay) return new $4d476c57e17b24ca$var$TreeNode(mounted.tree, start, i, parent);
                    let inner = new $4d476c57e17b24ca$var$TreeNode(next, start, i, parent);
                    return mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
                }
            }
            if (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        let mounted;
        if (!(mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreOverlays) && (mounted = this._tree.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.mounted)) && mounted.overlay) {
            let rPos = pos - this.from;
            for (let { from: from, to: to } of mounted.overlay){
                if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to >= rPos : to > rPos)) return new $4d476c57e17b24ca$var$TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        let val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* Side.DontCare */ ) : null;
    }
    cursor(mode = 0) {
        return new $4d476c57e17b24ca$export$3ae4554f36e54a34(this, mode);
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    resolve(pos, side = 0) {
        return $4d476c57e17b24ca$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $4d476c57e17b24ca$var$resolveNode(this, pos, side, true);
    }
    enterUnfinishedNodesBefore(pos) {
        return $4d476c57e17b24ca$var$enterUnfinishedNodesBefore(this, pos);
    }
    getChild(type, before = null, after = null) {
        let r = $4d476c57e17b24ca$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $4d476c57e17b24ca$var$getChildren(this, type, before, after);
    }
    /// @internal
    toString() {
        return this._tree.toString();
    }
    get node() {
        return this;
    }
    matchContext(context) {
        return $4d476c57e17b24ca$var$matchNodeContext(this, context);
    }
}
function $4d476c57e17b24ca$var$getChildren(node, type, before, after) {
    let cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) {
        while(!cur.type.is(before))if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function $4d476c57e17b24ca$var$matchNodeContext(node, context, i = context.length - 1) {
    for(let p = node.parent; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class $4d476c57e17b24ca$var$BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class $4d476c57e17b24ca$var$BufferNode {
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(context, _parent, index){
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
    child(dir, pos, side) {
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new $4d476c57e17b24ca$var$BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        if (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.ExcludeBuffers) return null;
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new $4d476c57e17b24ca$var$BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* Side.DontCare */ );
    }
    get nextSibling() {
        let { buffer: buffer } = this.context;
        let after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new $4d476c57e17b24ca$var$BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        let { buffer: buffer } = this.context;
        let parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new $4d476c57e17b24ca$var$BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
    }
    cursor(mode = 0) {
        return new $4d476c57e17b24ca$export$3ae4554f36e54a34(this, mode);
    }
    get tree() {
        return null;
    }
    toTree() {
        let children = [], positions = [];
        let { buffer: buffer } = this.context;
        let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            let from = buffer.buffer[this.index + 1];
            children.push(buffer.slice(startI, endI, from));
            positions.push(0);
        }
        return new $4d476c57e17b24ca$export$7fbedc92909ed28e(this.type, children, positions, this.to - this.from);
    }
    resolve(pos, side = 0) {
        return $4d476c57e17b24ca$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $4d476c57e17b24ca$var$resolveNode(this, pos, side, true);
    }
    enterUnfinishedNodesBefore(pos) {
        return $4d476c57e17b24ca$var$enterUnfinishedNodesBefore(this, pos);
    }
    /// @internal
    toString() {
        return this.context.buffer.childString(this.index);
    }
    getChild(type, before = null, after = null) {
        let r = $4d476c57e17b24ca$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $4d476c57e17b24ca$var$getChildren(this, type, before, after);
    }
    get node() {
        return this;
    }
    matchContext(context) {
        return $4d476c57e17b24ca$var$matchNodeContext(this, context);
    }
}
/// A tree cursor object focuses on a given node in a syntax tree, and
/// allows you to move to adjacent nodes.
class $4d476c57e17b24ca$export$3ae4554f36e54a34 {
    /// Shorthand for `.type.name`.
    get name() {
        return this.type.name;
    }
    /// @internal
    constructor(node, /// @internal
    mode = 0){
        this.mode = mode;
        /// @internal
        this.buffer = null;
        this.stack = [];
        /// @internal
        this.index = 0;
        this.bufferNode = null;
        if (node instanceof $4d476c57e17b24ca$var$TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(let n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        let { start: start, buffer: buffer } = this.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    yield(node) {
        if (!node) return false;
        if (node instanceof $4d476c57e17b24ca$var$TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /// @internal
    toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /// @internal
    enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        let { buffer: buffer } = this.buffer;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /// Move the cursor to this node's first child. When this returns
    /// false, the node has no child, and the cursor has not been moved.
    firstChild() {
        return this.enterChild(1, 0, 4 /* Side.DontCare */ );
    }
    /// Move the cursor to this node's last child.
    lastChild() {
        return this.enterChild(-1, 0, 4 /* Side.DontCare */ );
    }
    /// Move the cursor to the first child that ends after `pos`.
    childAfter(pos) {
        return this.enterChild(1, pos, 2 /* Side.After */ );
    }
    /// Move to the last child that starts before `pos`.
    childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Side.Before */ );
    }
    /// Move the cursor to the child around `pos`. If side is -1 the
    /// child may end at that position, when 1 it may start there. This
    /// will also enter [overlaid](#common.MountedTree.overlay)
    /// [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    /// set to false.
    enter(pos, side, mode = this.mode) {
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & $4d476c57e17b24ca$export$b0e28367f55837aa.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /// Move to the node's parent node, if this isn't the top node.
    parent() {
        if (!this.buffer) return this.yieldNode(this.mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        let parent = this.mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /// @internal
    sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode));
        let { buffer: buffer } = this.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            let parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
        } else {
            let after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode)) : false;
    }
    /// Move to this node's next sibling, if any.
    nextSibling() {
        return this.sibling(1);
    }
    /// Move to this node's previous sibling, if any.
    prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        let index, parent, { buffer: buffer } = this;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(let i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            ({ index: index, parent: parent } = buffer);
        } else ({ index: index, _parent: parent } = this._tree);
        for(; parent; { index: index, _parent: parent } = parent){
            if (index > -1) for(let i = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i != e; i += dir){
                let child = parent._tree.children[i];
                if (this.mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous || child instanceof $4d476c57e17b24ca$export$33300581b70be371 || !child.type.isAnonymous || $4d476c57e17b24ca$var$hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* Side.DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /// Move to the next node in a
    /// [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
    /// traversal, going from a node to its first child or, if the
    /// current node is empty or `enter` is false, its next sibling or
    /// the next sibling of the first parent node that has one.
    next(enter = true) {
        return this.move(1, enter);
    }
    /// Move to the next node in a last-to-first pre-order traveral. A
    /// node is followed by its last child or, if it has none, its
    /// previous sibling or the previous sibling of the first parent
    /// node that has one.
    prev(enter = true) {
        return this.move(-1, enter);
    }
    /// Move the cursor to the innermost node that covers `pos`. If
    /// `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    /// it will enter nodes that start at `pos`.
    moveTo(pos, side = 0) {
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /// Get a [syntax node](#common.SyntaxNode) at the cursor's current
    /// position.
    get node() {
        if (!this.buffer) return this._tree;
        let cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(let index = this.index, d = this.stack.length; d >= 0;){
            for(let c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(let i = depth; i < this.stack.length; i++)result = new $4d476c57e17b24ca$var$BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new $4d476c57e17b24ca$var$BufferNode(this.buffer, result, this.index);
    }
    /// Get the [tree](#common.Tree) that represents the current node, if
    /// any. Will return null when the node is in a [tree
    /// buffer](#common.TreeBuffer).
    get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /// Iterate over the current node and all its descendants, calling
    /// `enter` when entering a node and `leave`, if given, when leaving
    /// one. When `enter` returns `false`, any children of that node are
    /// skipped, and `leave` isn't called for it.
    iterate(enter, leave) {
        for(let depth = 0;;){
            let mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (this.nextSibling()) break;
                if (!depth) return;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /// Test whether the current node matches a given context—a sequence
    /// of direct parent node names. Empty strings in the context array
    /// are treated as wildcards.
    matchContext(context) {
        if (!this.buffer) return $4d476c57e17b24ca$var$matchNodeContext(this.node, context);
        let { buffer: buffer } = this.buffer, { types: types } = buffer.set;
        for(let i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return $4d476c57e17b24ca$var$matchNodeContext(this.node, context, i);
            let type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
}
function $4d476c57e17b24ca$var$hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof $4d476c57e17b24ca$export$33300581b70be371 || !ch.type.isAnonymous || $4d476c57e17b24ca$var$hasChild(ch));
}
function $4d476c57e17b24ca$var$buildTree(data) {
    var _a;
    let { buffer: buffer, nodeSet: nodeSet, maxBufferLength: maxBufferLength = $4d476c57e17b24ca$export$de305a849879ffa, reused: reused = [], minRepeatType: minRepeatType = nodeSet.types.length } = data;
    let cursor = Array.isArray(buffer) ? new $4d476c57e17b24ca$var$FlatBufferCursor(buffer, buffer.length) : buffer;
    let types = nodeSet.types;
    let contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat) {
        let { id: id, start: start, end: end, size: size } = cursor;
        let lookAheadAtStart = lookAhead;
        while(size < 0){
            cursor.next();
            if (size == -1 /* SpecialRecord.Reuse */ ) {
                let node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* SpecialRecord.ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* SpecialRecord.LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        let type = types[id], node, buffer;
        let startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            let data = new Uint16Array(buffer.size - buffer.skip);
            let endPos = cursor.pos - buffer.size, index = data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, data, index);
            node = new $4d476c57e17b24ca$export$33300581b70be371(data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            let endPos = cursor.pos - size;
            cursor.next();
            let localChildren = [], localPositions = [];
            let localInRepeat = id >= minRepeatType ? id : -1;
            let lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos)if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                if (cursor.end <= lastEnd - maxBufferLength) {
                    makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart);
                    lastGroup = localChildren.length;
                    lastEnd = cursor.end;
                }
                cursor.next();
            } else takeNode(start, endPos, localChildren, localPositions, localInRepeat);
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                let make = makeBalanced(type);
                node = $4d476c57e17b24ca$var$balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end);
        }
        children.push(node);
        positions.push(startPos);
    }
    function makeBalanced(type) {
        return (children, positions, length)=>{
            let lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof $4d476c57e17b24ca$export$7fbedc92909ed28e) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead) {
        let localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length, lookAhead = 0, props) {
        if (contextHash) {
            let pair = [
                $4d476c57e17b24ca$export$b8034b9bc18acd90.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            let pair = [
                $4d476c57e17b24ca$export$b8034b9bc18acd90.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        return new $4d476c57e17b24ca$export$7fbedc92909ed28e(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        let fork = cursor.fork();
        let size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        let result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(let minPos = fork.pos - maxSize; fork.pos > minPos;){
            let nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            let startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            let localSkipped = fork.id >= minRepeatType ? 4 : 0;
            let nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* SpecialRecord.ContextChange */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        let { id: id, start: start, end: end, size: size } = cursor;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            let startIndex = index;
            if (size > 4) {
                let endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* SpecialRecord.ContextChange */ ) contextHash = id;
        else if (size == -4 /* SpecialRecord.LookAhead */ ) lookAhead = id;
        return index;
    }
    let children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1);
    let length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new $4d476c57e17b24ca$export$7fbedc92909ed28e(types[data.topID], children.reverse(), positions.reverse(), length);
}
const $4d476c57e17b24ca$var$nodeSizeCache = new WeakMap;
function $4d476c57e17b24ca$var$nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof $4d476c57e17b24ca$export$33300581b70be371 || node.type != balanceType) return 1;
    let size = $4d476c57e17b24ca$var$nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        for (let child of node.children){
            if (child.type != balanceType || !(child instanceof $4d476c57e17b24ca$export$7fbedc92909ed28e)) {
                size = 1;
                break;
            }
            size += $4d476c57e17b24ca$var$nodeSize(balanceType, child);
        }
        $4d476c57e17b24ca$var$nodeSizeCache.set(node, size);
    }
    return size;
}
function $4d476c57e17b24ca$var$balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    let total = 0;
    for(let i = from; i < to; i++)total += $4d476c57e17b24ca$var$nodeSize(balanceType, children[i]);
    let maxChild = Math.ceil(total * 1.5 / 8 /* Balance.BranchFactor */ );
    let localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(let i = from; i < to;){
            let groupFrom = i, groupStart = positions[i], groupSize = $4d476c57e17b24ca$var$nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                let nextSize = $4d476c57e17b24ca$var$nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    let only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                let length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push($4d476c57e17b24ca$var$balanceRange(balanceType, children, positions, groupFrom, i, groupStart, length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/// Provides a way to associate values with pieces of trees. As long
/// as that part of the tree is reused, the associated values can be
/// retrieved from an updated tree.
class $4d476c57e17b24ca$export$7f13b5dc44c541ae {
    constructor(){
        this.map = new WeakMap();
    }
    setBuffer(buffer, index, value) {
        let inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        let inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /// Set the value for this syntax node.
    set(node, value) {
        if (node instanceof $4d476c57e17b24ca$var$BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof $4d476c57e17b24ca$var$TreeNode) this.map.set(node.tree, value);
    }
    /// Retrieve value for this syntax node, if it exists in the map.
    get(node) {
        return node instanceof $4d476c57e17b24ca$var$BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof $4d476c57e17b24ca$var$TreeNode ? this.map.get(node.tree) : undefined;
    }
    /// Set the value for the node that a cursor currently points to.
    cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /// Retrieve the value for the node that a cursor currently points
    /// to.
    cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
}
/// Tree fragments are used during [incremental
/// parsing](#common.Parser.startParse) to track parts of old trees
/// that can be reused in a new parse. An array of fragments is used
/// to track regions of an old tree whose nodes might be reused in new
/// parses. Use the static
/// [`applyChanges`](#common.TreeFragment^applyChanges) method to
/// update fragments for document changes.
class $4d476c57e17b24ca$export$3ae2ede6dca97077 {
    /// Construct a tree fragment. You'll usually want to use
    /// [`addTree`](#common.TreeFragment^addTree) and
    /// [`applyChanges`](#common.TreeFragment^applyChanges) instead of
    /// calling this directly.
    constructor(/// The start of the unchanged range pointed to by this fragment.
    /// This refers to an offset in the _updated_ document (as opposed
    /// to the original tree).
    from, /// The end of the unchanged range.
    to, /// The tree that this fragment is based on.
    tree, /// The offset between the fragment's tree and the document that
    /// this fragment can be used against. Add this when going from
    /// document to tree positions, subtract it to go from tree to
    /// document positions.
    offset, openStart = false, openEnd = false){
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Open.Start */  : 0) | (openEnd ? 2 /* Open.End */  : 0);
    }
    /// Whether the start of the fragment represents the start of a
    /// parse, or the end of a change. (In the second case, it may not
    /// be safe to reuse some nodes at the start, depending on the
    /// parsing algorithm.)
    get openStart() {
        return (this.open & 1 /* Open.Start */ ) > 0;
    }
    /// Whether the end of the fragment represents the end of a
    /// full-document parse, or the start of a change.
    get openEnd() {
        return (this.open & 2 /* Open.End */ ) > 0;
    }
    /// Create a set of fragments from a freshly parsed tree, or update
    /// an existing set of fragments by replacing the ones that overlap
    /// with a tree with content from the new tree. When `partial` is
    /// true, the parse is treated as incomplete, and the resulting
    /// fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    /// true.
    static addTree(tree, fragments = [], partial = false) {
        let result = [
            new $4d476c57e17b24ca$export$3ae2ede6dca97077(0, tree.length, tree, 0, false, partial)
        ];
        for (let f of fragments)if (f.to > tree.length) result.push(f);
        return result;
    }
    /// Apply a set of edits to an array of fragments, removing or
    /// splitting fragments as necessary to remove edited ranges, and
    /// adjusting offsets for fragments that moved.
    static applyChanges(fragments, changes, minGap = 128) {
        if (!changes.length) return fragments;
        let result = [];
        let fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(let cI = 0, pos = 0, off = 0;; cI++){
            let nextC = cI < changes.length ? changes[cI] : null;
            let nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                let cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new $4d476c57e17b24ca$export$3ae2ede6dca97077(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
}
/// A superclass that parsers should extend.
class $4d476c57e17b24ca$export$7acfa6ed01010e37 {
    /// Start a parse, returning a [partial parse](#common.PartialParse)
    /// object. [`fragments`](#common.TreeFragment) can be passed in to
    /// make the parse incremental.
    ///
    /// By default, the entire input is parsed. You can pass `ranges`,
    /// which should be a sorted array of non-empty, non-overlapping
    /// ranges, to parse only those ranges. The tree returned in that
    /// case will start at `ranges[0].from`.
    startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new $4d476c57e17b24ca$var$StringInput(input);
        ranges = !ranges ? [
            new $4d476c57e17b24ca$var$Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new $4d476c57e17b24ca$var$Range(r.from, r.to)) : [
            new $4d476c57e17b24ca$var$Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /// Run a full parse, returning the resulting tree.
    parse(input, fragments, ranges) {
        let parse = this.startParse(input, fragments, ranges);
        for(;;){
            let done = parse.advance();
            if (done) return done;
        }
    }
}
class $4d476c57e17b24ca$var$StringInput {
    constructor(string){
        this.string = string;
    }
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
}
/// Create a parse wrapper that, after the inner parse completes,
/// scans its tree for mixed language regions with the `nest`
/// function, runs the resulting [inner parses](#common.NestedParse),
/// and then [mounts](#common.NodeProp^mounted) their results onto the
/// tree.
function $4d476c57e17b24ca$export$5dcc455959c76221(nest) {
    return (parse, input, fragments, ranges)=>new $4d476c57e17b24ca$var$MixedParse(parse, nest, input, fragments, ranges);
}
class $4d476c57e17b24ca$var$InnerParse {
    constructor(parser, parse, overlay, target, ranges){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.target = target;
        this.ranges = ranges;
        if (!ranges.length || ranges.some((r)=>r.from >= r.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
    }
}
class $4d476c57e17b24ca$var$ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
const $4d476c57e17b24ca$var$stoppedInner = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    perNode: true
});
class $4d476c57e17b24ca$var$MixedParse {
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
    advance() {
        if (this.baseParse) {
            let done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            if (this.stoppedAt != null) for (let inner of this.inner)inner.parse.stopAt(this.stoppedAt);
        }
        if (this.innerDone == this.inner.length) {
            let result = this.baseTree;
            if (this.stoppedAt != null) result = new $4d476c57e17b24ca$export$7fbedc92909ed28e(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    $4d476c57e17b24ca$var$stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        let inner = this.inner[this.innerDone], done = inner.parse.advance();
        if (done) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            let props = Object.assign(Object.create(null), inner.target.props);
            props[$4d476c57e17b24ca$export$b8034b9bc18acd90.mounted.id] = new $4d476c57e17b24ca$export$358cdd8bd77577cc(done, inner.overlay, inner.parser);
            inner.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        let pos = this.input.length;
        for(let i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].ranges[0].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(let i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        let fragmentCursor = new $4d476c57e17b24ca$var$FragmentCursor(this.fragments);
        let overlay = null;
        let covered = null;
        let cursor = new $4d476c57e17b24ca$export$3ae4554f36e54a34(new $4d476c57e17b24ca$var$TreeNode(this.baseTree, this.ranges[0].from, 0, null), $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous | $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreMounts);
        scan: for(let nest, isCovered; this.stoppedAt == null || cursor.from < this.stoppedAt;){
            let enter = true, range;
            if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    let match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    if (match) for (let r of match.mount.overlay){
                        let from = r.from + match.pos, to = r.to + match.pos;
                        if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                            from: from,
                            to: to
                        });
                    }
                }
                enter = false;
            } else if (covered && (isCovered = $4d476c57e17b24ca$var$checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered != 2 /* Cover.Full */ ;
            else if (!cursor.type.isAnonymous && cursor.from < cursor.to && (nest = this.nest(cursor, this.input))) {
                if (!cursor.tree) $4d476c57e17b24ca$var$materialize(cursor);
                let oldMounts = fragmentCursor.findMounts(cursor.from, nest.parser);
                if (typeof nest.overlay == "function") overlay = new $4d476c57e17b24ca$var$ActiveOverlay(nest.parser, nest.overlay, oldMounts, this.inner.length, cursor.from, cursor.tree, overlay);
                else {
                    let ranges = $4d476c57e17b24ca$var$punchRanges(this.ranges, nest.overlay || [
                        new $4d476c57e17b24ca$var$Range(cursor.from, cursor.to)
                    ]);
                    if (ranges.length) this.inner.push(new $4d476c57e17b24ca$var$InnerParse(nest.parser, nest.parser.startParse(this.input, $4d476c57e17b24ca$var$enterFragments(oldMounts, ranges), ranges), nest.overlay ? nest.overlay.map((r)=>new $4d476c57e17b24ca$var$Range(r.from - cursor.from, r.to - cursor.from)) : null, cursor.tree, ranges));
                    if (!nest.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges: ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new $4d476c57e17b24ca$var$Range(cursor.from, cursor.to);
                if (range.from < range.to) overlay.ranges.push(range);
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) break scan;
                if (overlay && !--overlay.depth) {
                    let ranges = $4d476c57e17b24ca$var$punchRanges(this.ranges, overlay.ranges);
                    if (ranges.length) this.inner.splice(overlay.index, 0, new $4d476c57e17b24ca$var$InnerParse(overlay.parser, overlay.parser.startParse(this.input, $4d476c57e17b24ca$var$enterFragments(overlay.mounts, ranges), ranges), overlay.ranges.map((r)=>new $4d476c57e17b24ca$var$Range(r.from - overlay.start, r.to - overlay.start)), overlay.target, ranges));
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
        }
    }
}
function $4d476c57e17b24ca$var$checkCover(covered, from, to) {
    for (let range of covered){
        if (range.from >= to) break;
        if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Cover.Full */  : 1 /* Cover.Partial */ ;
    }
    return 0 /* Cover.None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function $4d476c57e17b24ca$var$sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        let from = buf.buffer[startI + 1];
        nodes.push(buf.slice(startI, endI, from));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function $4d476c57e17b24ca$var$materialize(cursor) {
    let { node: node } = cursor, depth = 0;
    // Scan up to the nearest tree
    do {
        cursor.parent();
        depth++;
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    let i = 0, base = cursor.tree, off = 0;
    for(;; i++){
        off = base.positions[i] + cursor.from;
        if (off <= node.from && off + base.children[i].length >= node.to) break;
    }
    let buf = base.children[i], b = buf.buffer;
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length) {
        let i = startI;
        while(b[i + 2] + off <= node.from)i = b[i + 3];
        let children = [], positions = [];
        $4d476c57e17b24ca$var$sliceBuf(buf, startI, i, children, positions, innerOffset);
        let from = b[i + 1], to = b[i + 2];
        let isTarget = from + off == node.from && to + off == node.to && b[i] == node.type.id;
        children.push(isTarget ? node.toTree() : split(i + 4, b[i + 3], buf.set.types[b[i]], from, to - from));
        positions.push(from - innerOffset);
        $4d476c57e17b24ca$var$sliceBuf(buf, b[i + 3], endI, children, positions, innerOffset);
        return new $4d476c57e17b24ca$export$7fbedc92909ed28e(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, $4d476c57e17b24ca$export$f06e977173f1857c.none, 0, buf.length);
    // Move the cursor back to the target node
    for(let d = 0; d <= depth; d++)cursor.childAfter(node.from);
}
class $4d476c57e17b24ca$var$StructureCursor {
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor($4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous | $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreMounts);
    }
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        let { cursor: cursor } = this, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreOverlays | $4d476c57e17b24ca$export$b0e28367f55837aa.ExcludeBuffers)) ;
            else if (!cursor.next(false)) this.done = true;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(let tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof $4d476c57e17b24ca$export$7fbedc92909ed28e) tree = tree.children[0];
            else break;
        }
        return false;
    }
}
class $4d476c57e17b24ca$var$FragmentCursor {
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            let first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop($4d476c57e17b24ca$var$stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new $4d476c57e17b24ca$var$StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            let frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop($4d476c57e17b24ca$var$stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new $4d476c57e17b24ca$var$StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        let result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(let pos = this.inner.cursor.node; pos; pos = pos.parent){
                let mount = (_a = pos.tree) === null || _a === void 0 ? void 0 : _a.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.mounted);
                if (mount && mount.parser == parser) for(let i = this.fragI; i < this.fragments.length; i++){
                    let frag = this.fragments[i];
                    if (frag.from >= pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag: frag,
                        pos: pos.from - frag.offset,
                        mount: mount
                    });
                }
            }
        }
        return result;
    }
}
function $4d476c57e17b24ca$var$punchRanges(outer, ranges) {
    let copy = null, current = ranges;
    for(let i = 1, j = 0; i < outer.length; i++){
        let gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            let r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new $4d476c57e17b24ca$var$Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new $4d476c57e17b24ca$var$Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new $4d476c57e17b24ca$var$Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function $4d476c57e17b24ca$var$findCoverChanges(a, b, from, to) {
    let iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    let result = [];
    for(;;){
        let nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        let nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            let start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new $4d476c57e17b24ca$var$Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function $4d476c57e17b24ca$var$enterFragments(mounts, ranges) {
    let result = [];
    for (let { pos: pos, mount: mount, frag: frag } of mounts){
        let startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
        let from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
        if (mount.overlay) {
            let overlay = mount.overlay.map((r)=>new $4d476c57e17b24ca$var$Range(r.from + pos, r.to + pos));
            let changes = $4d476c57e17b24ca$var$findCoverChanges(ranges, overlay, from, to);
            for(let i = 0, pos = from;; i++){
                let last = i == changes.length, end = last ? to : changes[i].from;
                if (end > pos) result.push(new $4d476c57e17b24ca$export$3ae2ede6dca97077(pos, end, mount.tree, -startPos, frag.from >= pos || frag.openStart, frag.to <= end || frag.openEnd));
                if (last) break;
                pos = changes[i].to;
            }
        } else result.push(new $4d476c57e17b24ca$export$3ae2ede6dca97077(from, to, mount.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
    }
    return result;
}

});

parcelRequire.register("hB7kI", function(module, exports) {

$parcel$export(module.exports, "Text", () => $ccfb9497d8ef598f$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "findClusterBreak", () => $ccfb9497d8ef598f$export$a0fa439fd515e1ed);
$parcel$export(module.exports, "codePointAt", () => $ccfb9497d8ef598f$export$42977f40461e1360);
$parcel$export(module.exports, "codePointSize", () => $ccfb9497d8ef598f$export$a870abf234f6353c);
$parcel$export(module.exports, "fromCodePoint", () => $ccfb9497d8ef598f$export$73bfc63873071f74);
$parcel$export(module.exports, "MapMode", () => $ccfb9497d8ef598f$export$39cf3280165f92aa);
$parcel$export(module.exports, "ChangeSet", () => $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c);
$parcel$export(module.exports, "EditorSelection", () => $ccfb9497d8ef598f$export$3bb1bd44aee62999);
$parcel$export(module.exports, "Facet", () => $ccfb9497d8ef598f$export$ef7d5e9b79fa1504);
$parcel$export(module.exports, "StateField", () => $ccfb9497d8ef598f$export$34381b1ce2130245);
$parcel$export(module.exports, "Prec", () => $ccfb9497d8ef598f$export$b92464a736444411);
$parcel$export(module.exports, "Annotation", () => $ccfb9497d8ef598f$export$9279461326b8700a);
$parcel$export(module.exports, "StateEffect", () => $ccfb9497d8ef598f$export$95000d4efaa4321f);
$parcel$export(module.exports, "Transaction", () => $ccfb9497d8ef598f$export$febc5573c75cefb0);
$parcel$export(module.exports, "CharCategory", () => $ccfb9497d8ef598f$export$239a3d59567c1401);
$parcel$export(module.exports, "EditorState", () => $ccfb9497d8ef598f$export$afa855cbfaff27f2);
$parcel$export(module.exports, "combineConfig", () => $ccfb9497d8ef598f$export$4e19c0b693794a7e);
$parcel$export(module.exports, "RangeValue", () => $ccfb9497d8ef598f$export$d60f08ed93a48611);
$parcel$export(module.exports, "RangeSet", () => $ccfb9497d8ef598f$export$34cb5241245008dd);
$parcel$export(module.exports, "RangeSetBuilder", () => $ccfb9497d8ef598f$export$89e09ce03c7e8594);
$parcel$export(module.exports, "countColumn", () => $ccfb9497d8ef598f$export$20b4ab289374d0ac);
$parcel$export(module.exports, "findColumn", () => $ccfb9497d8ef598f$export$718b3d71c384ca05);
/**
The data structure for documents. @nonabstract
*/ class $ccfb9497d8ef598f$export$5f1af8db9871e1d6 {
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        let parts = [];
        this.decompose(0, from, parts, 2 /* Open.To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* Open.To */ );
        this.decompose(to, this.length, parts, 1 /* Open.From */ );
        return $ccfb9497d8ef598f$var$TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from, to = this.length) {
        let parts = [];
        this.decompose(from, to, parts, 0);
        return $ccfb9497d8ef598f$var$TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        let a = new $ccfb9497d8ef598f$var$RawTextCursor(this), b = new $ccfb9497d8ef598f$var$RawTextCursor(other);
        for(let skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter(dir = 1) {
        return new $ccfb9497d8ef598f$var$RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from, to = this.length) {
        return new $ccfb9497d8ef598f$var$PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        let inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            let start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new $ccfb9497d8ef598f$var$LineCursor(inner);
    }
    /**
    Return the document as a string, using newline characters to
    separate lines.
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        let lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    @internal
    */ constructor(){}
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty;
        return text.length <= 32 /* Tree.Branch */  ? new $ccfb9497d8ef598f$var$TextLeaf(text) : $ccfb9497d8ef598f$var$TextNode.from($ccfb9497d8ef598f$var$TextLeaf.split(text, []));
    }
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class $ccfb9497d8ef598f$var$TextLeaf extends $ccfb9497d8ef598f$export$5f1af8db9871e1d6 {
    constructor(text, length = $ccfb9497d8ef598f$var$textLength(text)){
        super();
        this.text = text;
        this.length = length;
    }
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new $ccfb9497d8ef598f$export$17d680238e50603e(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        let text = from <= 0 && to >= this.length ? this : new $ccfb9497d8ef598f$var$TextLeaf($ccfb9497d8ef598f$var$sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* Open.From */ ) {
            let prev = target.pop();
            let joined = $ccfb9497d8ef598f$var$appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Tree.Branch */ ) target.push(new $ccfb9497d8ef598f$var$TextLeaf(joined, prev.length + text.length));
            else {
                let mid = joined.length >> 1;
                target.push(new $ccfb9497d8ef598f$var$TextLeaf(joined.slice(0, mid)), new $ccfb9497d8ef598f$var$TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof $ccfb9497d8ef598f$var$TextLeaf)) return super.replace(from, to, text);
        let lines = $ccfb9497d8ef598f$var$appendText(this.text, $ccfb9497d8ef598f$var$appendText(text.text, $ccfb9497d8ef598f$var$sliceText(this.text, 0, from)), to);
        let newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Tree.Branch */ ) return new $ccfb9497d8ef598f$var$TextLeaf(lines, newLen);
        return $ccfb9497d8ef598f$var$TextNode.from($ccfb9497d8ef598f$var$TextLeaf.split(lines, []), newLen);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        let result = "";
        for(let pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            let line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let line of this.text)target.push(line);
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        let part = [], len = -1;
        for (let line of text){
            part.push(line);
            len += line.length + 1;
            if (part.length == 32 /* Tree.Branch */ ) {
                target.push(new $ccfb9497d8ef598f$var$TextLeaf(part, len));
                part = [];
                len = -1;
            }
        }
        if (len > -1) target.push(new $ccfb9497d8ef598f$var$TextLeaf(part, len));
        return target;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class $ccfb9497d8ef598f$var$TextNode extends $ccfb9497d8ef598f$export$5f1af8db9871e1d6 {
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        for (let child of children)this.lines += child.lines;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(let i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                let childOpen = open & ((pos <= from ? 1 /* Open.From */  : 0) | (end >= to ? 2 /* Open.To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        if (text.lines < this.lines) for(let i = 0, pos = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                let updated = child.replace(from - pos, to - pos, text);
                let totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    let copy = this.children.slice();
                    copy[i] = updated;
                    return new $ccfb9497d8ef598f$var$TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        let result = "";
        for(let i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let child of this.children)child.flatten(target);
    }
    scanIdentical(other, dir) {
        if (!(other instanceof $ccfb9497d8ef598f$var$TextNode)) return 0;
        let length = 0;
        let [iA, iB, eA, eB] = dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            let chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children, length = children.reduce((l, ch)=>l + ch.length + 1, -1)) {
        let lines = 0;
        for (let ch of children)lines += ch.lines;
        if (lines < 32 /* Tree.Branch */ ) {
            let flat = [];
            for (let ch of children)ch.flatten(flat);
            return new $ccfb9497d8ef598f$var$TextLeaf(flat, length);
        }
        let chunk = Math.max(32 /* Tree.Branch */ , lines >> 5 /* Tree.BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            let last;
            if (child.lines > maxChunk && child instanceof $ccfb9497d8ef598f$var$TextNode) for (let node of child.children)add(node);
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof $ccfb9497d8ef598f$var$TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof $ccfb9497d8ef598f$var$TextLeaf && child.lines + last.lines <= 32 /* Tree.Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new $ccfb9497d8ef598f$var$TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : $ccfb9497d8ef598f$var$TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        for (let child of children)add(child);
        flush();
        return chunked.length == 1 ? chunked[0] : new $ccfb9497d8ef598f$var$TextNode(chunked, length);
    }
}
$ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty = /*@__PURE__*/ new $ccfb9497d8ef598f$var$TextLeaf([
    ""
], 0);
function $ccfb9497d8ef598f$var$textLength(text) {
    let length = -1;
    for (let line of text)length += line.length + 1;
    return length;
}
function $ccfb9497d8ef598f$var$appendText(text, target, from = 0, to = 1e9) {
    for(let pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        let line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function $ccfb9497d8ef598f$var$sliceText(text, from, to) {
    return $ccfb9497d8ef598f$var$appendText(text, [
        ""
    ], from, to);
}
class $ccfb9497d8ef598f$var$RawTextCursor {
    constructor(text, dir = 1){
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof $ccfb9497d8ef598f$var$TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            let last = this.nodes.length - 1;
            let top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            let size = top instanceof $ccfb9497d8ef598f$var$TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof $ccfb9497d8ef598f$var$TextLeaf) {
                // Move to the next string
                let next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                let next = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next.length) {
                    skip -= next.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next);
                    this.offsets.push(dir > 0 ? 1 : (next instanceof $ccfb9497d8ef598f$var$TextLeaf ? next.text.length : next.children.length) << 1);
                }
            }
        }
    }
    next(skip = 0) {
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
}
class $ccfb9497d8ef598f$var$PartialTextCursor {
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new $ccfb9497d8ef598f$var$RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        let { value: value } = this.cursor.next(skip);
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next(skip = 0) {
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
}
class $ccfb9497d8ef598f$var$LineCursor {
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
    next(skip = 0) {
        let { done: done, lineBreak: lineBreak, value: value } = this.inner.next(skip);
        if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
}
if (typeof Symbol != "undefined") {
    $ccfb9497d8ef598f$export$5f1af8db9871e1d6.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    $ccfb9497d8ef598f$var$RawTextCursor.prototype[Symbol.iterator] = $ccfb9497d8ef598f$var$PartialTextCursor.prototype[Symbol.iterator] = $ccfb9497d8ef598f$var$LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class $ccfb9497d8ef598f$export$17d680238e50603e {
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
}
// Compressed representation of the Grapheme_Cluster_Break=Extend
// information from
// http://www.unicode.org/Public/13.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
// Each pair of elements represents a range, as an offet from the
// previous range and a length. Numbers are in base-36, with the empty
// string being a shorthand for 1.
let $ccfb9497d8ef598f$var$extend = /*@__PURE__*/ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
// Convert offsets into absolute values
for(let i = 1; i < $ccfb9497d8ef598f$var$extend.length; i++)$ccfb9497d8ef598f$var$extend[i] += $ccfb9497d8ef598f$var$extend[i - 1];
function $ccfb9497d8ef598f$var$isExtendingChar(code) {
    for(let i = 1; i < $ccfb9497d8ef598f$var$extend.length; i += 2)if ($ccfb9497d8ef598f$var$extend[i] > code) return $ccfb9497d8ef598f$var$extend[i - 1] <= code;
    return false;
}
function $ccfb9497d8ef598f$var$isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
const $ccfb9497d8ef598f$var$ZWJ = 0x200d;
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function $ccfb9497d8ef598f$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (forward ? $ccfb9497d8ef598f$var$nextClusterBreak : $ccfb9497d8ef598f$var$prevClusterBreak)(str, pos, includeExtending);
}
function $ccfb9497d8ef598f$var$nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && $ccfb9497d8ef598f$var$surrogateLow(str.charCodeAt(pos)) && $ccfb9497d8ef598f$var$surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    let prev = $ccfb9497d8ef598f$export$42977f40461e1360(str, pos);
    pos += $ccfb9497d8ef598f$export$a870abf234f6353c(prev);
    while(pos < str.length){
        let next = $ccfb9497d8ef598f$export$42977f40461e1360(str, pos);
        if (prev == $ccfb9497d8ef598f$var$ZWJ || next == $ccfb9497d8ef598f$var$ZWJ || includeExtending && $ccfb9497d8ef598f$var$isExtendingChar(next)) {
            pos += $ccfb9497d8ef598f$export$a870abf234f6353c(next);
            prev = next;
        } else if ($ccfb9497d8ef598f$var$isRegionalIndicator(next)) {
            let countBefore = 0, i = pos - 2;
            while(i >= 0 && $ccfb9497d8ef598f$var$isRegionalIndicator($ccfb9497d8ef598f$export$42977f40461e1360(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function $ccfb9497d8ef598f$var$prevClusterBreak(str, pos, includeExtending) {
    while(pos > 0){
        let found = $ccfb9497d8ef598f$var$nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function $ccfb9497d8ef598f$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $ccfb9497d8ef598f$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function $ccfb9497d8ef598f$export$42977f40461e1360(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$ccfb9497d8ef598f$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$ccfb9497d8ef598f$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function $ccfb9497d8ef598f$export$73bfc63873071f74(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The amount of positions a character takes up a JavaScript string.
*/ function $ccfb9497d8ef598f$export$a870abf234f6353c(code) {
    return code < 0x10000 ? 1 : 2;
}
const $ccfb9497d8ef598f$var$DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var $ccfb9497d8ef598f$export$39cf3280165f92aa = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}($ccfb9497d8ef598f$export$39cf3280165f92aa || ($ccfb9497d8ef598f$export$39cf3280165f92aa = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class $ccfb9497d8ef598f$export$34b6a936f2bb06a2 {
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    /**
    @internal
    */ constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
    /**
    The length of the document before the change.
    */ get length() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2){
            let ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(let i = 0, posA = 0, posB = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f, individual = false) {
        $ccfb9497d8ef598f$var$iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        let sections = [];
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new $ccfb9497d8ef598f$export$34b6a936f2bb06a2(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : $ccfb9497d8ef598f$var$composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `other` happened before the ones in `this`.
    */ mapDesc(other, before = false) {
        return other.empty ? this : $ccfb9497d8ef598f$var$mapSet(this, other, before);
    }
    mapPos(pos, assoc = -1, mode = $ccfb9497d8ef598f$export$39cf3280165f92aa.Simple) {
        let posA = 0, posB = 0;
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != $ccfb9497d8ef598f$export$39cf3280165f92aa.Simple && endA >= pos && (mode == $ccfb9497d8ef598f$export$39cf3280165f92aa.TrackDel && posA < pos && endA > pos || mode == $ccfb9497d8ef598f$export$39cf3280165f92aa.TrackBefore && posA < pos || mode == $ccfb9497d8ef598f$export$39cf3280165f92aa.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from, to = from) {
        for(let i = 0, pos = 0; i < this.sections.length && pos <= to;){
            let len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        let result = "";
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new $ccfb9497d8ef598f$export$34b6a936f2bb06a2(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new $ccfb9497d8ef598f$export$34b6a936f2bb06a2(sections);
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c extends $ccfb9497d8ef598f$export$34b6a936f2bb06a2 {
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        $ccfb9497d8ef598f$var$iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other, before = false) {
        return $ccfb9497d8ef598f$var$mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        let sections = this.sections.slice(), inserted = [];
        for(let i = 0, pos = 0; i < sections.length; i += 2){
            let len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                let index = i >> 1;
                while(inserted.length < index)inserted.push($ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty);
            }
            pos += len;
        }
        return new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : $ccfb9497d8ef598f$var$composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other, before = false) {
        return other.empty ? this : $ccfb9497d8ef598f$var$mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f, individual = false) {
        $ccfb9497d8ef598f$var$iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return $ccfb9497d8ef598f$export$34b6a936f2bb06a2.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        let resultSections = [], resultInserted = [], filteredSections = [];
        let iter = new $ccfb9497d8ef598f$var$SectionIter(this);
        done: for(let i = 0, pos = 0;;){
            let next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                let len = Math.min(iter.len, next - pos);
                $ccfb9497d8ef598f$var$addSection(filteredSections, len, -1);
                let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                $ccfb9497d8ef598f$var$addSection(resultSections, len, ins);
                if (ins > 0) $ccfb9497d8ef598f$var$addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            let end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                let len = Math.min(iter.len, end - pos);
                $ccfb9497d8ef598f$var$addSection(resultSections, len, -1);
                $ccfb9497d8ef598f$var$addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len);
                pos += len;
            }
        }
        return {
            changes: new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(resultSections, resultInserted),
            filtered: $ccfb9497d8ef598f$export$34b6a936f2bb06a2.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        let parts = [];
        for(let i = 0; i < this.sections.length; i += 2){
            let len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        let sections = [], inserted = [], pos = 0;
        let total = null;
        function flush(force = false) {
            if (!force && !sections.length) return;
            if (pos < length) $ccfb9497d8ef598f$var$addSection(sections, length - pos, -1);
            let set = new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            if (Array.isArray(spec)) for (let sub of spec)process(sub);
            else if (spec instanceof $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                let { from: from, to: to = from, insert: insert } = spec;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                let insText = !insert ? $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty : typeof insert == "string" ? $ccfb9497d8ef598f$export$5f1af8db9871e1d6.of(insert.split(lineSep || $ccfb9497d8ef598f$var$DefaultSplit)) : insert;
                let insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) $ccfb9497d8ef598f$var$addSection(sections, from - pos, -1);
                $ccfb9497d8ef598f$var$addSection(sections, to - from, insLen);
                $ccfb9497d8ef598f$var$addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        let sections = [], inserted = [];
        for(let i = 0; i < json.length; i++){
            let part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push($ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty);
                inserted[i] = $ccfb9497d8ef598f$export$5f1af8db9871e1d6.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        }
        return new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(sections, inserted);
    }
}
function $ccfb9497d8ef598f$var$addSection(sections, len, ins, forceJoin = false) {
    if (len == 0 && ins <= 0) return;
    let last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function $ccfb9497d8ef598f$var$addInsert(values, sections, value) {
    if (value.length == 0) return;
    let index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push($ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty);
        values.push(value);
    }
}
function $ccfb9497d8ef598f$var$iterChanges(desc, f, individual) {
    let inserted = desc.inserted;
    for(let posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        let len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            let endA = posA, endB = posB, text = $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function $ccfb9497d8ef598f$var$mapSet(setA, setB, before, mkSet = false) {
    // Produce a copy of setA that applies to the document after setB
    // has been applied (assuming both start at the same document).
    let sections = [], insert = mkSet ? [] : null;
    let a = new $ccfb9497d8ef598f$var$SectionIter(setA), b = new $ccfb9497d8ef598f$var$SectionIter(setB);
    // Iterate over both sets in parallel. inserted tracks, for changes
    // in A that have to be processed piece-by-piece, whether their
    // content has been inserted already, and refers to the section
    // index.
    for(let inserted = -1;;){
        if (a.ins == -1 && b.ins == -1) {
            // Move across ranges skipped by both sets.
            let len = Math.min(a.len, b.len);
            $ccfb9497d8ef598f$var$addSection(sections, len, -1);
            a.forward(len);
            b.forward(len);
        } else if (b.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b.len < a.len || b.len == a.len && !before))) {
            // If there's a change in B that comes before the next change in
            // A (ordered by start pos, then len, then before flag), skip
            // that (and process any changes in A it covers).
            let len = b.len;
            $ccfb9497d8ef598f$var$addSection(sections, b.ins, -1);
            while(len){
                let piece = Math.min(a.len, len);
                if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
                    $ccfb9497d8ef598f$var$addSection(sections, 0, a.ins);
                    if (insert) $ccfb9497d8ef598f$var$addInsert(insert, sections, a.text);
                    inserted = a.i;
                }
                a.forward(piece);
                len -= piece;
            }
            b.next();
        } else if (a.ins >= 0) {
            // Process the part of a change in A up to the start of the next
            // non-deletion change in B (if overlapping).
            let len = 0, left = a.len;
            while(left){
                if (b.ins == -1) {
                    let piece = Math.min(left, b.len);
                    len += piece;
                    left -= piece;
                    b.forward(piece);
                } else if (b.ins == 0 && b.len < left) {
                    left -= b.len;
                    b.next();
                } else break;
            }
            $ccfb9497d8ef598f$var$addSection(sections, len, inserted < a.i ? a.ins : 0);
            if (insert && inserted < a.i) $ccfb9497d8ef598f$var$addInsert(insert, sections, a.text);
            inserted = a.i;
            a.forward(a.len - left);
        } else if (a.done && b.done) return insert ? $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $ccfb9497d8ef598f$export$34b6a936f2bb06a2.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function $ccfb9497d8ef598f$var$composeSets(setA, setB, mkSet = false) {
    let sections = [];
    let insert = mkSet ? [] : null;
    let a = new $ccfb9497d8ef598f$var$SectionIter(setA), b = new $ccfb9497d8ef598f$var$SectionIter(setB);
    for(let open = false;;){
        if (a.done && b.done) return insert ? $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $ccfb9497d8ef598f$export$34b6a936f2bb06a2.create(sections);
        else if (a.ins == 0) {
            $ccfb9497d8ef598f$var$addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            $ccfb9497d8ef598f$var$addSection(sections, 0, b.ins, open);
            if (insert) $ccfb9497d8ef598f$var$addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            let len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                let insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                $ccfb9497d8ef598f$var$addSection(sections, len, insB, open);
                if (insert && insB) $ccfb9497d8ef598f$var$addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                $ccfb9497d8ef598f$var$addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) $ccfb9497d8ef598f$var$addInsert(insert, sections, a.textBit(len));
            } else {
                $ccfb9497d8ef598f$var$addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) $ccfb9497d8ef598f$var$addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class $ccfb9497d8ef598f$var$SectionIter {
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
    next() {
        let { sections: sections } = this.set;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length ? $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty : inserted[index];
    }
    textBit(len) {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4 {
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags){
        this.from = from;
        this.to = to;
        this.flags = flags;
    }
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 16 /* RangeFlag.Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 16 /* RangeFlag.Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 4 /* RangeFlag.AssocBefore */  ? -1 : this.flags & 8 /* RangeFlag.AssocAfter */  ? 1 : 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        let level = this.flags & 3 /* RangeFlag.BidiLevelMask */ ;
        return level == 3 ? null : level;
    }
    /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ get goalColumn() {
        let value = this.flags >> 5 /* RangeFlag.GoalColumnOffset */ ;
        return value == 33554431 /* RangeFlag.NoGoalColumn */  ? undefined : value;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change, assoc = -1) {
        let from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4(from, to, this.flags);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from, to = from) {
        if (from <= this.anchor && to >= this.anchor) return $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(from, to);
        let head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(this.anchor, head);
    }
    /**
    Compare this range to another range.
    */ eq(other) {
        return this.anchor == other.anchor && this.head == other.head;
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags) {
        return new $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4(from, to, flags);
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class $ccfb9497d8ef598f$export$3bb1bd44aee62999 {
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change, assoc = -1) {
        if (change.empty) return this;
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection.
    */ eq(other) {
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(let i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i])) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new $ccfb9497d8ef598f$export$3bb1bd44aee62999([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range, main = true) {
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range, which = this.mainIndex) {
        let ranges = this.ranges.slice();
        ranges[which] = range;
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new $ccfb9497d8ef598f$export$3bb1bd44aee62999(json.ranges.map((r)=>$ccfb9497d8ef598f$export$7bd1839c3c5d5bd4.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor, head = anchor) {
        return new $ccfb9497d8ef598f$export$3bb1bd44aee62999([
            $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges, mainIndex = 0) {
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(let pos = 0, i = 0; i < ranges.length; i++){
            let range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return $ccfb9497d8ef598f$export$3bb1bd44aee62999.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new $ccfb9497d8ef598f$export$3bb1bd44aee62999(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
        return $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 4 /* RangeFlag.AssocBefore */  : 8 /* RangeFlag.AssocAfter */ ) | (bidiLevel == null ? 3 : Math.min(2, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 33554431 /* RangeFlag.NoGoalColumn */ ) << 5 /* RangeFlag.GoalColumnOffset */ );
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn, bidiLevel) {
        let flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 33554431 /* RangeFlag.NoGoalColumn */ ) << 5 /* RangeFlag.GoalColumnOffset */  | (bidiLevel == null ? 3 : Math.min(2, bidiLevel));
        return head < anchor ? $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4.create(head, anchor, 24 /* RangeFlag.AssocAfter */  | flags) : $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4.create(anchor, head, (head > anchor ? 4 /* RangeFlag.AssocBefore */  : 0) | flags);
    }
    /**
    @internal
    */ static normalized(ranges, mainIndex = 0) {
        let main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(let i = 1; i < ranges.length; i++){
            let range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                let from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(to, from) : $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(from, to));
            }
        }
        return new $ccfb9497d8ef598f$export$3bb1bd44aee62999(ranges, mainIndex);
    }
}
function $ccfb9497d8ef598f$var$checkSelection(selection, docLength) {
    for (let range of selection.ranges)if (range.to > docLength) throw new RangeError("Selection points outside of document");
}
let $ccfb9497d8ef598f$var$nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).
*/ class $ccfb9497d8ef598f$export$ef7d5e9b79fa1504 {
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, enables){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        /**
        @internal
        */ this.id = $ccfb9497d8ef598f$var$nextID++;
        this.default = combine([]);
        this.extensions = typeof enables == "function" ? enables(this) : enables;
    }
    /**
    Define a new facet.
    */ static define(config = {}) {
        return new $ccfb9497d8ef598f$export$ef7d5e9b79fa1504(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? $ccfb9497d8ef598f$var$sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new $ccfb9497d8ef598f$var$FacetProvider([], this, 0 /* Provider.Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $ccfb9497d8ef598f$var$FacetProvider(deps, this, 1 /* Provider.Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $ccfb9497d8ef598f$var$FacetProvider(deps, this, 2 /* Provider.Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
}
function $ccfb9497d8ef598f$var$sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class $ccfb9497d8ef598f$var$FacetProvider {
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = $ccfb9497d8ef598f$var$nextID++;
    }
    dynamicSlot(addresses) {
        var _a;
        let getter = this.value;
        let compare = this.facet.compareInput;
        let id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Provider.Multi */ ;
        let depDoc = false, depSel = false, depAddrs = [];
        for (let dep of this.dependencies){
            if (dep == "doc") depDoc = true;
            else if (dep == "selection") depSel = true;
            else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || $ccfb9497d8ef598f$var$ensureAll(state, depAddrs)) {
                    let newVal = getter(state);
                    if (multi ? !$ccfb9497d8ef598f$var$compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* SlotStatus.Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                let newVal, oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    let oldVal = $ccfb9497d8ef598f$var$getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof $ccfb9497d8ef598f$export$ef7d5e9b79fa1504 ? oldState.facet(dep) === state.facet(dep) : dep instanceof $ccfb9497d8ef598f$export$34381b1ce2130245 ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? $ccfb9497d8ef598f$var$compareArray(newVal = getter(state), oldVal, compare) : compare(newVal = getter(state), oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                } else newVal = getter(state);
                state.values[idx] = newVal;
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
}
function $ccfb9497d8ef598f$var$compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function $ccfb9497d8ef598f$var$ensureAll(state, addrs) {
    let changed = false;
    for (let addr of addrs)if ($ccfb9497d8ef598f$var$ensureAddr(state, addr) & 1 /* SlotStatus.Changed */ ) changed = true;
    return changed;
}
function $ccfb9497d8ef598f$var$dynamicFacetSlot(addresses, facet, providers) {
    let providerAddrs = providers.map((p)=>addresses[p.id]);
    let providerTypes = providers.map((p)=>p.type);
    let dynamic = providerAddrs.filter((p)=>!(p & 1));
    let idx = addresses[facet.id] >> 1;
    function get(state) {
        let values = [];
        for(let i = 0; i < providerAddrs.length; i++){
            let value = $ccfb9497d8ef598f$var$getAddr(state, providerAddrs[i]);
            if (providerTypes[i] == 2 /* Provider.Multi */ ) for (let val of value)values.push(val);
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            for (let addr of providerAddrs)$ccfb9497d8ef598f$var$ensureAddr(state, addr);
            state.values[idx] = get(state);
            return 1 /* SlotStatus.Changed */ ;
        },
        update (state, tr) {
            if (!$ccfb9497d8ef598f$var$ensureAll(state, dynamic)) return 0;
            let value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        },
        reconfigure (state, oldState) {
            let depChanged = $ccfb9497d8ef598f$var$ensureAll(state, providerAddrs);
            let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && $ccfb9497d8ef598f$var$sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            let value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        }
    };
}
const $ccfb9497d8ef598f$var$initField = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class $ccfb9497d8ef598f$export$34381b1ce2130245 {
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
    /**
    Define a state field.
    */ static define(config) {
        let field = new $ccfb9497d8ef598f$export$34381b1ce2130245($ccfb9497d8ef598f$var$nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        let init = state.facet($ccfb9497d8ef598f$var$initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        let idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update: (state, tr)=>{
                let oldVal = state.values[idx];
                let value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* SlotStatus.Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            $ccfb9497d8ef598f$var$initField.of({
                field: this,
                create: create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
}
const $ccfb9497d8ef598f$var$Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function $ccfb9497d8ef598f$var$prec(value) {
    return (ext)=>new $ccfb9497d8ef598f$var$PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ const $ccfb9497d8ef598f$export$b92464a736444411 = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.lowest)
};
class $ccfb9497d8ef598f$var$PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class $ccfb9497d8ef598f$export$d51c0172eb2c2431 {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new $ccfb9497d8ef598f$var$CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return $ccfb9497d8ef598f$export$d51c0172eb2c2431.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class $ccfb9497d8ef598f$var$CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
}
class $ccfb9497d8ef598f$var$Configuration {
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* SlotStatus.Unresolved */ );
    }
    staticFacet(facet) {
        let addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        let fields = [];
        let facets = Object.create(null);
        let newCompartments = new Map();
        for (let ext of $ccfb9497d8ef598f$var$flatten(base, compartments, newCompartments))if (ext instanceof $ccfb9497d8ef598f$export$34381b1ce2130245) fields.push(ext);
        else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
        let address = Object.create(null);
        let staticValues = [];
        let dynamicSlots = [];
        for (let field of fields){
            address[field.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a)=>field.slot(a));
        }
        let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(let id in facets){
            let providers = facets[id], facet = providers[0].facet;
            let oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Provider.Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if ($ccfb9497d8ef598f$var$sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    let value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                for (let p of providers)if (p.type == 0 /* Provider.Static */ ) {
                    address[p.id] = staticValues.length << 1 | 1;
                    staticValues.push(p.value);
                } else {
                    address[p.id] = dynamicSlots.length << 1;
                    dynamicSlots.push((a)=>p.dynamicSlot(a));
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>$ccfb9497d8ef598f$var$dynamicFacetSlot(a, facet, providers));
            }
        }
        let dynamic = dynamicSlots.map((f)=>f(address));
        return new $ccfb9497d8ef598f$var$Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
}
function $ccfb9497d8ef598f$var$flatten(extension, compartments, newCompartments) {
    let result = [
        [],
        [],
        [],
        [],
        []
    ];
    let seen = new Map();
    function inner(ext, prec) {
        let known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            let found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof $ccfb9497d8ef598f$var$CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        if (Array.isArray(ext)) for (let e of ext)inner(e, prec);
        else if (ext instanceof $ccfb9497d8ef598f$var$CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            let content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof $ccfb9497d8ef598f$var$PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof $ccfb9497d8ef598f$export$34381b1ce2130245) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof $ccfb9497d8ef598f$var$FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, $ccfb9497d8ef598f$var$Prec_.default);
        } else {
            let content = ext.extension;
            if (!content) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content, prec);
        }
    }
    inner(extension, $ccfb9497d8ef598f$var$Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function $ccfb9497d8ef598f$var$ensureAddr(state, addr) {
    if (addr & 1) return 2 /* SlotStatus.Computed */ ;
    let idx = addr >> 1;
    let status = state.status[idx];
    if (status == 4 /* SlotStatus.Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* SlotStatus.Computed */ ) return status;
    state.status[idx] = 4 /* SlotStatus.Computing */ ;
    let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* SlotStatus.Computed */  | changed;
}
function $ccfb9497d8ef598f$var$getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const $ccfb9497d8ef598f$var$languageData = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define();
const $ccfb9497d8ef598f$var$allowMultipleSelections = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
const $ccfb9497d8ef598f$var$lineSeparator = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
const $ccfb9497d8ef598f$var$changeFilter = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define();
const $ccfb9497d8ef598f$var$transactionFilter = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define();
const $ccfb9497d8ef598f$var$transactionExtender = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define();
const $ccfb9497d8ef598f$var$readOnly = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class $ccfb9497d8ef598f$export$9279461326b8700a {
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Define a new type of annotation.
    */ static define() {
        return new $ccfb9497d8ef598f$export$f50c3066a53a6f2c();
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class $ccfb9497d8ef598f$export$f50c3066a53a6f2c {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new $ccfb9497d8ef598f$export$9279461326b8700a(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class $ccfb9497d8ef598f$export$e41ff6bd17cc4417 {
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new $ccfb9497d8ef598f$export$95000d4efaa4321f(this, value);
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class $ccfb9497d8ef598f$export$95000d4efaa4321f {
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        let mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new $ccfb9497d8ef598f$export$95000d4efaa4321f(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds. It should be a type that
    doesn't include `undefined`, since that is used in
    [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
    removed.
    */ static define(spec = {}) {
        return new $ccfb9497d8ef598f$export$e41ff6bd17cc4417(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        let result = [];
        for (let effect of effects){
            let mapped = effect.map(mapping);
            if (mapped) result.push(mapped);
        }
        return result;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.reconfigure = /*@__PURE__*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.define();
/**
Append extensions to the top-level configuration of the editor.
*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.appendConfig = /*@__PURE__*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class $ccfb9497d8ef598f$export$febc5573c75cefb0 {
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) $ccfb9497d8ef598f$var$checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == $ccfb9497d8ef598f$export$febc5573c75cefb0.time)) this.annotations = annotations.concat($ccfb9497d8ef598f$export$febc5573c75cefb0.time.of(Date.now()));
    }
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new $ccfb9497d8ef598f$export$febc5573c75cefb0(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        for (let ann of this.annotations)if (ann.type == type) return ann.value;
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        let e = this.annotation($ccfb9497d8ef598f$export$febc5573c75cefb0.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ $ccfb9497d8ef598f$export$febc5573c75cefb0.time = /*@__PURE__*/ $ccfb9497d8ef598f$export$9279461326b8700a.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ $ccfb9497d8ef598f$export$febc5573c75cefb0.userEvent = /*@__PURE__*/ $ccfb9497d8ef598f$export$9279461326b8700a.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ $ccfb9497d8ef598f$export$febc5573c75cefb0.addToHistory = /*@__PURE__*/ $ccfb9497d8ef598f$export$9279461326b8700a.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ $ccfb9497d8ef598f$export$febc5573c75cefb0.remote = /*@__PURE__*/ $ccfb9497d8ef598f$export$9279461326b8700a.define();
function $ccfb9497d8ef598f$var$joinRanges(a, b) {
    let result = [];
    for(let iA = 0, iB = 0;;){
        let from, to;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function $ccfb9497d8ef598f$var$mergeTransaction(a, b, sequential) {
    var _a;
    let mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes: changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: $ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects(a.effects, mapForA).concat($ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function $ccfb9497d8ef598f$var$resolveTransactionInner(state, spec, docSize) {
    let sel = spec.selection, annotations = $ccfb9497d8ef598f$var$asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat($ccfb9497d8ef598f$export$febc5573c75cefb0.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c ? spec.changes : $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.of(spec.changes || [], docSize, state.facet($ccfb9497d8ef598f$var$lineSeparator)),
        selection: sel && (sel instanceof $ccfb9497d8ef598f$export$3bb1bd44aee62999 ? sel : $ccfb9497d8ef598f$export$3bb1bd44aee62999.single(sel.anchor, sel.head)),
        effects: $ccfb9497d8ef598f$var$asArray(spec.effects),
        annotations: annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function $ccfb9497d8ef598f$var$resolveTransaction(state, specs, filter) {
    let s = $ccfb9497d8ef598f$var$resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(let i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        let seq = !!specs[i].sequential;
        s = $ccfb9497d8ef598f$var$mergeTransaction(s, $ccfb9497d8ef598f$var$resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    let tr = $ccfb9497d8ef598f$export$febc5573c75cefb0.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return $ccfb9497d8ef598f$var$extendTransaction(filter ? $ccfb9497d8ef598f$var$filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function $ccfb9497d8ef598f$var$filterTransaction(tr) {
    let state = tr.startState;
    // Change filters
    let result = true;
    for (let filter of state.facet($ccfb9497d8ef598f$var$changeFilter)){
        let value = filter(tr);
        if (value === false) {
            result = false;
            break;
        }
        if (Array.isArray(value)) result = result === true ? value : $ccfb9497d8ef598f$var$joinRanges(result, value);
    }
    if (result !== true) {
        let changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.empty(state.doc.length);
        } else {
            let filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
        }
        tr = $ccfb9497d8ef598f$export$febc5573c75cefb0.create(state, changes, tr.selection && tr.selection.map(back), $ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    let filters = state.facet($ccfb9497d8ef598f$var$transactionFilter);
    for(let i = filters.length - 1; i >= 0; i--){
        let filtered = filters[i](tr);
        if (filtered instanceof $ccfb9497d8ef598f$export$febc5573c75cefb0) tr = filtered;
        else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof $ccfb9497d8ef598f$export$febc5573c75cefb0) tr = filtered[0];
        else tr = $ccfb9497d8ef598f$var$resolveTransaction(state, $ccfb9497d8ef598f$var$asArray(filtered), false);
    }
    return tr;
}
function $ccfb9497d8ef598f$var$extendTransaction(tr) {
    let state = tr.startState, extenders = state.facet($ccfb9497d8ef598f$var$transactionExtender), spec = tr;
    for(let i = extenders.length - 1; i >= 0; i--){
        let extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = $ccfb9497d8ef598f$var$mergeTransaction(spec, $ccfb9497d8ef598f$var$resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : $ccfb9497d8ef598f$export$febc5573c75cefb0.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const $ccfb9497d8ef598f$var$none = [];
function $ccfb9497d8ef598f$var$asArray(value) {
    return value == null ? $ccfb9497d8ef598f$var$none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var $ccfb9497d8ef598f$export$239a3d59567c1401 = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}($ccfb9497d8ef598f$export$239a3d59567c1401 || ($ccfb9497d8ef598f$export$239a3d59567c1401 = {}));
const $ccfb9497d8ef598f$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let $ccfb9497d8ef598f$var$wordChar;
try {
    $ccfb9497d8ef598f$var$wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function $ccfb9497d8ef598f$var$hasWordChar(str) {
    if ($ccfb9497d8ef598f$var$wordChar) return $ccfb9497d8ef598f$var$wordChar.test(str);
    for(let i = 0; i < str.length; i++){
        let ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || $ccfb9497d8ef598f$var$nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function $ccfb9497d8ef598f$var$makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return $ccfb9497d8ef598f$export$239a3d59567c1401.Space;
        if ($ccfb9497d8ef598f$var$hasWordChar(char)) return $ccfb9497d8ef598f$export$239a3d59567c1401.Word;
        for(let i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return $ccfb9497d8ef598f$export$239a3d59567c1401.Word;
        return $ccfb9497d8ef598f$export$239a3d59567c1401.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class $ccfb9497d8ef598f$export$afa855cbfaff27f2 {
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(let i = 0; i < this.config.dynamicSlots.length; i++)$ccfb9497d8ef598f$var$ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
    field(field, require = true) {
        let addr = this.config.address[field.id];
        if (addr == null) {
            if (require) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        $ccfb9497d8ef598f$var$ensureAddr(this, addr);
        return $ccfb9497d8ef598f$var$getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update(...specs) {
        return $ccfb9497d8ef598f$var$resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        let conf = this.config, { base: base, compartments: compartments } = conf;
        for (let effect of tr.effects){
            if (effect.is($ccfb9497d8ef598f$export$d51c0172eb2c2431.reconfigure)) {
                if (conf) {
                    compartments = new Map;
                    conf.compartments.forEach((val, key)=>compartments.set(key, val));
                    conf = null;
                }
                compartments.set(effect.value.compartment, effect.value.extension);
            } else if (effect.is($ccfb9497d8ef598f$export$95000d4efaa4321f.reconfigure)) {
                conf = null;
                base = effect.value;
            } else if (effect.is($ccfb9497d8ef598f$export$95000d4efaa4321f.appendConfig)) {
                conf = null;
                base = $ccfb9497d8ef598f$var$asArray(base).concat(effect.value);
            }
        }
        let startValues;
        if (!conf) {
            conf = $ccfb9497d8ef598f$var$Configuration.resolve(base, compartments, this);
            let intermediateState = new $ccfb9497d8ef598f$export$afa855cbfaff27f2(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        new $ccfb9497d8ef598f$export$afa855cbfaff27f2(conf, tr.newDoc, tr.newSelection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: $ccfb9497d8ef598f$export$3bb1bd44aee62999.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        let sel = this.selection;
        let result1 = f(sel.ranges[0]);
        let changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        let effects = $ccfb9497d8ef598f$var$asArray(result1.effects);
        for(let i = 1; i < sel.ranges.length; i++){
            let result = f(sel.ranges[i]);
            let newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(let j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            let mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = $ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects(effects, newMapped).concat($ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects($ccfb9497d8ef598f$var$asArray(result.effects), mapBy));
        }
        return {
            changes: changes,
            selection: $ccfb9497d8ef598f$export$3bb1bd44aee62999.create(ranges, sel.mainIndex),
            effects: effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes(spec = []) {
        if (spec instanceof $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c) return spec;
        return $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.of(spec, this.doc.length, this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return $ccfb9497d8ef598f$export$5f1af8db9871e1d6.of(string.split(this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator) || $ccfb9497d8ef598f$var$DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc(from = 0, to = this.doc.length) {
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        let addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        $ccfb9497d8ef598f$var$ensureAddr(this, addr);
        return $ccfb9497d8ef598f$var$getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        let result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(let prop in fields){
            let value = fields[prop];
            if (value instanceof $ccfb9497d8ef598f$export$34381b1ce2130245 && this.config.address[value.id] != null) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json, config = {}, fields) {
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        let fieldInit = [];
        if (fields) {
            for(let prop in fields)if (Object.prototype.hasOwnProperty.call(json, prop)) {
                let field = fields[prop], value = json[prop];
                fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
            }
        }
        return $ccfb9497d8ef598f$export$afa855cbfaff27f2.create({
            doc: json.doc,
            selection: $ccfb9497d8ef598f$export$3bb1bd44aee62999.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create(config = {}) {
        let configuration = $ccfb9497d8ef598f$var$Configuration.resolve(config.extensions || [], new Map);
        let doc = config.doc instanceof $ccfb9497d8ef598f$export$5f1af8db9871e1d6 ? config.doc : $ccfb9497d8ef598f$export$5f1af8db9871e1d6.of((config.doc || "").split(configuration.staticFacet($ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator) || $ccfb9497d8ef598f$var$DefaultSplit));
        let selection = !config.selection ? $ccfb9497d8ef598f$export$3bb1bd44aee62999.single(0) : config.selection instanceof $ccfb9497d8ef598f$export$3bb1bd44aee62999 ? config.selection : $ccfb9497d8ef598f$export$3bb1bd44aee62999.single(config.selection.anchor, config.selection.head);
        $ccfb9497d8ef598f$var$checkSelection(selection, doc.length);
        if (!configuration.staticFacet($ccfb9497d8ef598f$var$allowMultipleSelections)) selection = selection.asSingle();
        return new $ccfb9497d8ef598f$export$afa855cbfaff27f2(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet($ccfb9497d8ef598f$var$readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase, ...insert) {
        for (let map of this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.phrases))if (Object.prototype.hasOwnProperty.call(map, phrase)) {
            phrase = map[phrase];
            break;
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            let n = +(i || 1);
            return !n || n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    
    Examples of language data fields are...
    
    - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
      comment syntax.
    - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
      for providing language-specific completion sources.
    - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
      characters that should be considered part of words in this
      language.
    - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
      bracket closing behavior.
    */ languageDataAt(name, pos, side = -1) {
        let values = [];
        for (let provider of this.facet($ccfb9497d8ef598f$var$languageData)){
            for (let result of provider(this, pos, side))if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        return $ccfb9497d8ef598f$var$makeCategorizer(this.languageDataAt("wordChars", at).join(""));
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        let { text: text, from: from, length: length } = this.doc.lineAt(pos);
        let cat = this.charCategorizer(pos);
        let start = pos - from, end = pos - from;
        while(start > 0){
            let prev = $ccfb9497d8ef598f$export$a0fa439fd515e1ed(text, start, false);
            if (cat(text.slice(prev, start)) != $ccfb9497d8ef598f$export$239a3d59567c1401.Word) break;
            start = prev;
        }
        while(end < length){
            let next = $ccfb9497d8ef598f$export$a0fa439fd515e1ed(text, end);
            if (cat(text.slice(end, next)) != $ccfb9497d8ef598f$export$239a3d59567c1401.Word) break;
            end = next;
        }
        return start == end ? null : $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(start + from, end + from);
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.allowMultipleSelections = $ccfb9497d8ef598f$var$allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.tabSize = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator = $ccfb9497d8ef598f$var$lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.readOnly = $ccfb9497d8ef598f$var$readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.phrases = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    compare (a, b) {
        let kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.languageData = $ccfb9497d8ef598f$var$languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.changeFilter = $ccfb9497d8ef598f$var$changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.transactionFilter = $ccfb9497d8ef598f$var$transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.transactionExtender = $ccfb9497d8ef598f$var$transactionExtender;
$ccfb9497d8ef598f$export$d51c0172eb2c2431.reconfigure = /*@__PURE__*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function $ccfb9497d8ef598f$export$4e19c0b693794a7e(configs, defaults, combine = {}) {
    let result = {};
    for (let config of configs)for (let key of Object.keys(config)){
        let value = config[key], current = result[key];
        if (current === undefined) result[key] = value;
        else if (current === value || value === undefined) ; // No conflict
        else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
        else throw new Error("Config merge conflict for field " + key);
    }
    for(let key in defaults)if (result[key] === undefined) result[key] = defaults[key];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class $ccfb9497d8ef598f$export$d60f08ed93a48611 {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from, to = from) {
        return $ccfb9497d8ef598f$export$9a58ef0d7ad3278c.create(from, to, this);
    }
}
$ccfb9497d8ef598f$export$d60f08ed93a48611.prototype.startSide = $ccfb9497d8ef598f$export$d60f08ed93a48611.prototype.endSide = 0;
$ccfb9497d8ef598f$export$d60f08ed93a48611.prototype.point = false;
$ccfb9497d8ef598f$export$d60f08ed93a48611.prototype.mapMode = $ccfb9497d8ef598f$export$39cf3280165f92aa.TrackDel;
/**
A range associates a value with a range of positions.
*/ class $ccfb9497d8ef598f$export$9a58ef0d7ad3278c {
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
    /**
    @internal
    */ static create(from, to, value) {
        return new $ccfb9497d8ef598f$export$9a58ef0d7ad3278c(from, to, value);
    }
}
function $ccfb9497d8ef598f$var$cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class $ccfb9497d8ef598f$var$Chunk {
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end, startAt = 0) {
        let arr = end ? this.to : this.from;
        for(let lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            let mid = lo + hi >> 1;
            let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(let i = this.findIndex(from, -1000000000 /* C.Far */ , true), e = this.findIndex(to, 1000000000 /* C.Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        let value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(let i = 0; i < this.value.length; i++){
            let val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom, newTo;
            if (curFrom == curTo) {
                let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new $ccfb9497d8ef598f$var$Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class $ccfb9497d8ef598f$export$34cb5241245008dd {
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new $ccfb9497d8ef598f$export$34cb5241245008dd(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        let last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        let size = this.nextLayer.size;
        for (let chunk of this.chunk)size += chunk.value.length;
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        let { add: add = [], sort: sort = false, filterFrom: filterFrom = 0, filterTo: filterTo = this.length } = updateSpec;
        let filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort($ccfb9497d8ef598f$var$cmpRange);
        if (this.isEmpty) return add.length ? $ccfb9497d8ef598f$export$34cb5241245008dd.of(add) : this;
        let cur = new $ccfb9497d8ef598f$var$LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        let builder = new $ccfb9497d8ef598f$export$89e09ce03c7e8594();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                let range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push($ccfb9497d8ef598f$export$9a58ef0d7ad3278c.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? $ccfb9497d8ef598f$export$34cb5241245008dd.empty : this.nextLayer.update({
            add: spill,
            filter: filter,
            filterFrom: filterFrom,
            filterTo: filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        let chunks = [], chunkPos = [], maxPoint = -1;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            let touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                let { mapped: mapped, pos: pos } = chunk.map(start, changes);
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        let next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new $ccfb9497d8ef598f$export$34cb5241245008dd(chunkPos, chunks, next || $ccfb9497d8ef598f$export$34cb5241245008dd.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter(from = 0) {
        return $ccfb9497d8ef598f$var$HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets, from = 0) {
        return $ccfb9497d8ef598f$var$HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration.
    */ textDiff, comparator, /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = -1) {
        let a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let sharedChunks = $ccfb9497d8ef598f$var$findSharedChunks(a, b, textDiff);
        let sideA = new $ccfb9497d8ef598f$var$SpanCursor(a, sharedChunks, minPointSize);
        let sideB = new $ccfb9497d8ef598f$var$SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>$ccfb9497d8ef598f$var$compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) $ccfb9497d8ef598f$var$compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets, from = 0, to) {
        if (to == null) to = 999999999;
        let a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        let b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        let sharedChunks = $ccfb9497d8ef598f$var$findSharedChunks(a, b);
        let sideA = new $ccfb9497d8ef598f$var$SpanCursor(a, sharedChunks, 0).goto(from), sideB = new $ccfb9497d8ef598f$var$SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !$ccfb9497d8ef598f$var$sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator, /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = -1) {
        let cursor = new $ccfb9497d8ef598f$var$SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        let openRanges = cursor.openStart;
        for(;;){
            let curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                let active = cursor.activeForPoint(cursor.to);
                let openCount = cursor.pointFrom < from ? active.length + 1 : Math.min(active.length, openRanges);
                iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
                openRanges = Math.min(cursor.openEnd(curTo), active.length);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, openRanges);
                openRanges = cursor.openEnd(curTo);
            }
            if (cursor.to > to) return openRanges + (cursor.point && cursor.to > to ? 1 : 0);
            pos = cursor.to;
            cursor.next();
        }
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges, sort = false) {
        let build = new $ccfb9497d8ef598f$export$89e09ce03c7e8594();
        for (let range of ranges instanceof $ccfb9497d8ef598f$export$9a58ef0d7ad3278c ? [
            ranges
        ] : sort ? $ccfb9497d8ef598f$var$lazySort(ranges) : ranges)build.add(range.from, range.to, range.value);
        return build.finish();
    }
}
/**
The empty set of ranges.
*/ $ccfb9497d8ef598f$export$34cb5241245008dd.empty = /*@__PURE__*/ new $ccfb9497d8ef598f$export$34cb5241245008dd([], [], null, -1);
function $ccfb9497d8ef598f$var$lazySort(ranges) {
    if (ranges.length > 1) for(let prev = ranges[0], i = 1; i < ranges.length; i++){
        let cur = ranges[i];
        if ($ccfb9497d8ef598f$var$cmpRange(prev, cur) > 0) return ranges.slice().sort($ccfb9497d8ef598f$var$cmpRange);
        prev = cur;
    }
    return ranges;
}
$ccfb9497d8ef598f$export$34cb5241245008dd.empty.nextLayer = $ccfb9497d8ef598f$export$34cb5241245008dd.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class $ccfb9497d8ef598f$export$89e09ce03c7e8594 {
    finishChunk(newArrays) {
        this.chunks.push(new $ccfb9497d8ef598f$var$Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* C.Far */ ;
        this.lastTo = -1000000000 /* C.Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new $ccfb9497d8ef598f$export$89e09ce03c7e8594)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        let diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* C.ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        let last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner($ccfb9497d8ef598f$export$34cb5241245008dd.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        let result = $ccfb9497d8ef598f$export$34cb5241245008dd.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
}
function $ccfb9497d8ef598f$var$findSharedChunks(a, b, textDiff) {
    let inA = new Map();
    for (let set of a)for(let i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
    let shared = new Set();
    for (let set of b)for(let i = 0; i < set.chunk.length; i++){
        let known = inA.get(set.chunk[i]);
        if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set.chunkPos[i] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set.chunk[i].length))) shared.add(set.chunk[i]);
    }
    return shared;
}
class $ccfb9497d8ef598f$var$LayerCursor {
    constructor(layer, skip, minPoint, rank = 0){
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            let next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            break;
        } else {
            let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            let from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
}
class $ccfb9497d8ef598f$var$HeapCursor {
    constructor(heap){
        this.heap = heap;
    }
    static from(sets, skip = null, minPoint = -1) {
        let heap = [];
        for(let i = 0; i < sets.length; i++){
            for(let cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new $ccfb9497d8ef598f$var$LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new $ccfb9497d8ef598f$var$HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        for (let cur of this.heap)cur.goto(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$ccfb9497d8ef598f$var$heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        for (let cur of this.heap)cur.forward(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$ccfb9497d8ef598f$var$heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            let top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            $ccfb9497d8ef598f$var$heapBubble(this.heap, 0);
        }
    }
}
function $ccfb9497d8ef598f$var$heapBubble(heap, index) {
    for(let cur = heap[index];;){
        let childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        let child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class $ccfb9497d8ef598f$var$SpanCursor {
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* C.Far */ ;
        this.endSide = 0;
        // The amount of open active ranges at the start of the iterator.
        // Not including points.
        this.openStart = -1;
        this.cursor = $ccfb9497d8ef598f$var$HeapCursor.from(sets, skip, minPoint);
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        $ccfb9497d8ef598f$var$remove(this.active, index);
        $ccfb9497d8ef598f$var$remove(this.activeTo, index);
        $ccfb9497d8ef598f$var$remove(this.activeRank, index);
        this.minActive = $ccfb9497d8ef598f$var$findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        let i = 0, { value: value, to: to, rank: rank } = this.cursor;
        while(i < this.activeRank.length && this.activeRank[i] <= rank)i++;
        $ccfb9497d8ef598f$var$insert(this.active, i, value);
        $ccfb9497d8ef598f$var$insert(this.activeTo, i, to);
        $ccfb9497d8ef598f$var$insert(this.activeRank, i, rank);
        if (trackOpen) $ccfb9497d8ef598f$var$insert(trackOpen, i, this.cursor.from);
        this.minActive = $ccfb9497d8ef598f$var$findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        let from = this.to, wasPoint = this.point;
        this.point = null;
        let trackOpen = this.openStart < 0 ? [] : null;
        for(;;){
            let a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) $ccfb9497d8ef598f$var$remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* C.Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                let nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            this.openStart = 0;
            for(let i = trackOpen.length - 1; i >= 0 && trackOpen[i] < from; i--)this.openStart++;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        let active = [];
        for(let i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        let open = 0;
        for(let i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
}
function $ccfb9497d8ef598f$var$compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    let endB = startB + length;
    let pos = startB, dPos = startB - startA;
    for(;;){
        let diff = a.to + dPos - b.to || a.endSide - b.endSide;
        let end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        if (a.point || b.point) {
            if (!(a.point && b.point && (a.point == b.point || a.point.eq(b.point)) && $ccfb9497d8ef598f$var$sameValues(a.activeForPoint(a.to), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
        } else if (clipEnd > pos && !$ccfb9497d8ef598f$var$sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
        if (end > endB) break;
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function $ccfb9497d8ef598f$var$sameValues(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] != b[i] && !a[i].eq(b[i])) return false;
    return true;
}
function $ccfb9497d8ef598f$var$remove(array, index) {
    for(let i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function $ccfb9497d8ef598f$var$insert(array, index, value) {
    for(let i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function $ccfb9497d8ef598f$var$findMinIndex(value, array) {
    let found = -1, foundPos = 1000000000 /* C.Far */ ;
    for(let i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function $ccfb9497d8ef598f$export$20b4ab289374d0ac(string, tabSize, to = string.length) {
    let n = 0;
    for(let i = 0; i < to;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = $ccfb9497d8ef598f$export$a0fa439fd515e1ed(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function $ccfb9497d8ef598f$export$718b3d71c384ca05(string, col, tabSize, strict) {
    for(let i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = $ccfb9497d8ef598f$export$a0fa439fd515e1ed(string, i);
    }
    return strict === true ? -1 : string.length;
}

});

parcelRequire.register("BEVwA", function(module, exports) {

$parcel$export(module.exports, "WidgetType", () => $071334078f8d3f8a$export$95cdd842edb044c5);
$parcel$export(module.exports, "Decoration", () => $071334078f8d3f8a$export$10e30b733df217ea);
$parcel$export(module.exports, "logException", () => $071334078f8d3f8a$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "ViewPlugin", () => $071334078f8d3f8a$export$44d5eccfd62adda7);
$parcel$export(module.exports, "Direction", () => $071334078f8d3f8a$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "EditorView", () => $071334078f8d3f8a$export$eece2fccabbb77c5);
$parcel$export(module.exports, "keymap", () => $071334078f8d3f8a$export$5043418e2ef368d5);
$parcel$export(module.exports, "showTooltip", () => $071334078f8d3f8a$export$dba11b50e1aa3c12);
$parcel$export(module.exports, "getTooltip", () => $071334078f8d3f8a$export$46455b4476d4b8e1);
$parcel$export(module.exports, "GutterMarker", () => $071334078f8d3f8a$export$591ab4c909549043);
$parcel$export(module.exports, "gutter", () => $071334078f8d3f8a$export$f2b922cb4a245974);

var $hB7kI = parcelRequire("hB7kI");

var $luNHI = parcelRequire("luNHI");

var $lNHdE = parcelRequire("lNHdE");
function $071334078f8d3f8a$var$getSelection(root) {
    let target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function $071334078f8d3f8a$var$contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function $071334078f8d3f8a$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $071334078f8d3f8a$var$hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return $071334078f8d3f8a$var$contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function $071334078f8d3f8a$var$clientRectsFor(dom) {
    if (dom.nodeType == 3) return $071334078f8d3f8a$var$textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function $071334078f8d3f8a$var$isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? $071334078f8d3f8a$var$scanFor(node, off, targetNode, targetOff, -1) || $071334078f8d3f8a$var$scanFor(node, off, targetNode, targetOff, 1) : false;
}
function $071334078f8d3f8a$var$domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function $071334078f8d3f8a$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $071334078f8d3f8a$var$maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = $071334078f8d3f8a$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? $071334078f8d3f8a$var$maxOffset(node) : 0;
        } else return false;
    }
}
function $071334078f8d3f8a$var$maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $071334078f8d3f8a$var$flattenRect(rect, left) {
    let x = left ? rect.left : rect.right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function $071334078f8d3f8a$var$windowRect(win) {
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function $071334078f8d3f8a$var$scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    for(let cur = dom, stop = false; cur && !stop;){
        if (cur.nodeType == 1) {
            let bounding, top = cur == doc.body;
            if (top) bounding = $071334078f8d3f8a$var$windowRect(win);
            else {
                if (/^(fixed|sticky)$/.test(getComputedStyle(cur).position)) stop = true;
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.assignedSlot || cur.parentNode;
                    continue;
                }
                let rect = cur.getBoundingClientRect();
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: rect.left,
                    right: rect.left + cur.clientWidth,
                    top: rect.top,
                    bottom: rect.top + cur.clientHeight
                };
            }
            let moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top) {
                    moveY = -(bounding.top - rect.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + moveY + yMargin;
                } else if (rect.bottom > bounding.bottom) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = -(bounding.top + moveY - rect.top + yMargin);
                }
            } else {
                let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left) {
                    moveX = -(bounding.left - rect.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + moveX + xMargin;
                } else if (rect.right > bounding.right) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = -(bounding.left + moveX - rect.left + xMargin);
                }
            } else {
                let targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    let movedX = 0, movedY = 0;
                    if (moveY) {
                        let start = cur.scrollTop;
                        cur.scrollTop += moveY;
                        movedY = cur.scrollTop - start;
                    }
                    if (moveX) {
                        let start = cur.scrollLeft;
                        cur.scrollLeft += moveX;
                        movedX = cur.scrollLeft - start;
                    }
                    rect = {
                        left: rect.left - movedX,
                        top: rect.top - movedY,
                        right: rect.right - movedX,
                        bottom: rect.bottom - movedY
                    };
                    if (movedX && Math.abs(movedX - moveX) < 1) x = "nearest";
                    if (movedY && Math.abs(movedY - moveY) < 1) y = "nearest";
                }
            }
            if (top) break;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
function $071334078f8d3f8a$var$scrollableParent(dom) {
    let doc = dom.ownerDocument;
    for(let cur = dom.parentNode; cur;){
        if (cur == doc.body) break;
        else if (cur.nodeType == 1) {
            if (cur.scrollHeight > cur.clientHeight || cur.scrollWidth > cur.clientWidth) return cur;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
    return null;
}
class $071334078f8d3f8a$var$DOMSelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        let { anchorNode: anchorNode, focusNode: focusNode } = range;
        // Clip offsets to node size to avoid crashes when Safari reports bogus offsets (#1152)
        this.set(anchorNode, Math.min(range.anchorOffset, anchorNode ? $071334078f8d3f8a$var$maxOffset(anchorNode) : 0), focusNode, Math.min(range.focusOffset, focusNode ? $071334078f8d3f8a$var$maxOffset(focusNode) : 0));
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
}
let $071334078f8d3f8a$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $071334078f8d3f8a$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($071334078f8d3f8a$var$preventScrollSupported) return dom.focus($071334078f8d3f8a$var$preventScrollSupported);
    let stack = [];
    for(let cur = dom; cur; cur = cur.parentNode){
        stack.push(cur, cur.scrollTop, cur.scrollLeft);
        if (cur == cur.ownerDocument) break;
    }
    dom.focus($071334078f8d3f8a$var$preventScrollSupported == null ? {
        get preventScroll () {
            $071334078f8d3f8a$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$071334078f8d3f8a$var$preventScrollSupported) {
        $071334078f8d3f8a$var$preventScrollSupported = false;
        for(let i = 0; i < stack.length;){
            let elt = stack[i++], top = stack[i++], left = stack[i++];
            if (elt.scrollTop != top) elt.scrollTop = top;
            if (elt.scrollLeft != left) elt.scrollLeft = left;
        }
    }
}
let $071334078f8d3f8a$var$scratchRange;
function $071334078f8d3f8a$var$textRange(node, from, to = from) {
    let range = $071334078f8d3f8a$var$scratchRange || ($071334078f8d3f8a$var$scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function $071334078f8d3f8a$var$dispatchKey(elt, name, code) {
    let options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    let down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    let up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function $071334078f8d3f8a$var$getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function $071334078f8d3f8a$var$clearAttributes(node) {
    while(node.attributes.length)node.removeAttributeNode(node.attributes[0]);
}
function $071334078f8d3f8a$var$atElementStart(doc, selection) {
    let node = selection.focusNode, offset = selection.focusOffset;
    if (!node || selection.anchorNode != node || selection.anchorOffset != offset) return false;
    // Safari can report bogus offsets (#1152)
    offset = Math.min(offset, $071334078f8d3f8a$var$maxOffset(node));
    for(;;){
        if (offset) {
            if (node.nodeType != 1) return false;
            let prev = node.childNodes[offset - 1];
            if (prev.contentEditable == "false") offset--;
            else {
                node = prev;
                offset = $071334078f8d3f8a$var$maxOffset(node);
            }
        } else if (node == doc) return true;
        else {
            offset = $071334078f8d3f8a$var$domIndex(node);
            node = node.parentNode;
        }
    }
}
function $071334078f8d3f8a$var$isScrolledToBottom(elt) {
    return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
class $071334078f8d3f8a$var$DOMPos {
    constructor(node, offset, precise = true){
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
    static before(dom, precise) {
        return new $071334078f8d3f8a$var$DOMPos(dom.parentNode, $071334078f8d3f8a$var$domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new $071334078f8d3f8a$var$DOMPos(dom.parentNode, $071334078f8d3f8a$var$domIndex(dom) + 1, precise);
    }
}
const $071334078f8d3f8a$var$noChildren = [];
class $071334078f8d3f8a$var$ContentView {
    constructor(){
        this.parent = null;
        this.dom = null;
        this.flags = 2 /* NodeDirty */ ;
    }
    get overrideDOMText() {
        return null;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(view) {
        let pos = this.posAtStart;
        for (let child of this.children){
            if (child == view) return pos;
            pos += child.length + child.breakAfter;
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(view) {
        return this.posBefore(view) + view.length;
    }
    sync(view, track) {
        if (this.flags & 2 /* NodeDirty */ ) {
            let parent = this.dom;
            let prev = null, next;
            for (let child of this.children){
                if (child.flags & 7 /* Dirty */ ) {
                    if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
                        let contentView = $071334078f8d3f8a$var$ContentView.get(next);
                        if (!contentView || !contentView.parent && contentView.canReuseDOM(child)) child.reuseDOM(next);
                    }
                    child.sync(view, track);
                    child.flags &= -8 /* Dirty */ ;
                }
                next = prev ? prev.nextSibling : parent.firstChild;
                if (track && !track.written && track.node == parent && next != child.dom) track.written = true;
                if (child.dom.parentNode == parent) while(next && next != child.dom)next = $071334078f8d3f8a$var$rm$1(next);
                else parent.insertBefore(child.dom, next);
                prev = child.dom;
            }
            next = prev ? prev.nextSibling : parent.firstChild;
            if (next && track && track.node == parent) track.written = true;
            while(next)next = $071334078f8d3f8a$var$rm$1(next);
        } else if (this.flags & 1 /* ChildDirty */ ) {
            for (let child of this.children)if (child.flags & 7 /* Dirty */ ) {
                child.sync(view, track);
                child.flags &= -8 /* Dirty */ ;
            }
        }
    }
    reuseDOM(_dom) {}
    localPosFromDOM(node, offset) {
        let after;
        if (node == this.dom) after = this.dom.childNodes[offset];
        else {
            let bias = $071334078f8d3f8a$var$maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
            for(;;){
                let parent = node.parentNode;
                if (parent == this.dom) break;
                if (bias == 0 && parent.firstChild != parent.lastChild) {
                    if (node == parent.firstChild) bias = -1;
                    else bias = 1;
                }
                node = parent;
            }
            if (bias < 0) after = node;
            else after = node.nextSibling;
        }
        if (after == this.dom.firstChild) return 0;
        while(after && !$071334078f8d3f8a$var$ContentView.get(after))after = after.nextSibling;
        if (!after) return this.length;
        for(let i = 0, pos = 0;; i++){
            let child = this.children[i];
            if (child.dom == after) return pos;
            pos += child.length + child.breakAfter;
        }
    }
    domBoundsAround(from, to, offset = 0) {
        let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(let i = 0, pos = offset, prevEnd = offset; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos < from && end > to) return child.domBoundsAround(from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == this.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + this.length : toEnd,
            startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
            endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
        };
    }
    markDirty(andParent = false) {
        this.flags |= 2 /* NodeDirty */ ;
        this.markParentsDirty(andParent);
    }
    markParentsDirty(childList) {
        for(let parent = this.parent; parent; parent = parent.parent){
            if (childList) parent.flags |= 2 /* NodeDirty */ ;
            if (parent.flags & 1 /* ChildDirty */ ) return;
            parent.flags |= 1 /* ChildDirty */ ;
            childList = false;
        }
    }
    setParent(parent) {
        if (this.parent != parent) {
            this.parent = parent;
            if (this.flags & 7 /* Dirty */ ) this.markParentsDirty(true);
        }
    }
    setDOM(dom) {
        if (this.dom) this.dom.cmView = null;
        this.dom = dom;
        dom.cmView = this;
    }
    get rootView() {
        for(let v = this;;){
            let parent = v.parent;
            if (!parent) return v;
            v = parent;
        }
    }
    replaceChildren(from, to, children = $071334078f8d3f8a$var$noChildren) {
        this.markDirty();
        for(let i = from; i < to; i++){
            let child = this.children[i];
            if (child.parent == this) child.destroy();
        }
        this.children.splice(from, to - from, ...children);
        for(let i = 0; i < children.length; i++)children[i].setParent(this);
    }
    ignoreMutation(_rec) {
        return false;
    }
    ignoreEvent(_event) {
        return false;
    }
    childCursor(pos = this.length) {
        return new $071334078f8d3f8a$var$ChildCursor(this.children, pos, this.children.length);
    }
    childPos(pos, bias = 1) {
        return this.childCursor().findPos(pos, bias);
    }
    toString() {
        let name = this.constructor.name.replace("View", "");
        return name + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
    }
    static get(node) {
        return node.cmView;
    }
    get isEditable() {
        return true;
    }
    get isWidget() {
        return false;
    }
    get isHidden() {
        return false;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        return false;
    }
    become(other) {
        return false;
    }
    canReuseDOM(other) {
        return other.constructor == this.constructor && !((this.flags | other.flags) & 8 /* Composition */ );
    }
    // When this is a zero-length view with a side, this should return a
    // number <= 0 to indicate it is before its position, or a
    // number > 0 when after its position.
    getSide() {
        return 0;
    }
    destroy() {
        this.parent = null;
    }
}
$071334078f8d3f8a$var$ContentView.prototype.breakAfter = 0;
// Remove a DOM node and return its next sibling.
function $071334078f8d3f8a$var$rm$1(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
class $071334078f8d3f8a$var$ChildCursor {
    constructor(children, pos, i){
        this.children = children;
        this.pos = pos;
        this.i = i;
        this.off = 0;
    }
    findPos(pos, bias = 1) {
        for(;;){
            if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
                this.off = pos - this.pos;
                return this;
            }
            let next = this.children[--this.i];
            this.pos -= next.length + next.breakAfter;
        }
    }
}
function $071334078f8d3f8a$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, breakAtStart, openStart, openEnd) {
    let { children: children } = parent;
    let before = children.length ? children[fromI] : null;
    let last = insert.length ? insert[insert.length - 1] : null;
    let breakAtEnd = last ? last.breakAfter : breakAtStart;
    // Change within a single child
    if (fromI == toI && before && !breakAtStart && !breakAtEnd && insert.length < 2 && before.merge(fromOff, toOff, insert.length ? last : null, fromOff == 0, openStart, openEnd)) return;
    if (toI < children.length) {
        let after = children[toI];
        // Make sure the end of the child after the update is preserved in `after`
        if (after && toOff < after.length) {
            // If we're splitting a child, separate part of it to avoid that
            // being mangled when updating the child before the update.
            if (fromI == toI) {
                after = after.split(toOff);
                toOff = 0;
            }
            // If the element after the replacement should be merged with
            // the last replacing element, update `content`
            if (!breakAtEnd && last && after.merge(0, toOff, last, true, 0, openEnd)) insert[insert.length - 1] = after;
            else {
                // Remove the start of the after element, if necessary, and
                // add it to `content`.
                if (toOff) after.merge(0, toOff, null, false, 0, openEnd);
                insert.push(after);
            }
        } else if (after === null || after === void 0 ? void 0 : after.breakAfter) {
            // The element at `toI` is entirely covered by this range.
            // Preserve its line break, if any.
            if (last) last.breakAfter = 1;
            else breakAtStart = 1;
        }
        // Since we've handled the next element from the current elements
        // now, make sure `toI` points after that.
        toI++;
    }
    if (before) {
        before.breakAfter = breakAtStart;
        if (fromOff > 0) {
            if (!breakAtStart && insert.length && before.merge(fromOff, before.length, insert[0], false, openStart, 0)) before.breakAfter = insert.shift().breakAfter;
            else if (fromOff < before.length || before.children.length && before.children[before.children.length - 1].length == 0) before.merge(fromOff, before.length, null, false, openStart, 0);
            fromI++;
        }
    }
    // Try to merge widgets on the boundaries of the replacement
    while(fromI < toI && insert.length){
        if (children[toI - 1].become(insert[insert.length - 1])) {
            toI--;
            insert.pop();
            openEnd = insert.length ? 0 : openStart;
        } else if (children[fromI].become(insert[0])) {
            fromI++;
            insert.shift();
            openStart = insert.length ? 0 : openEnd;
        } else break;
    }
    if (!insert.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd)) fromI--;
    if (fromI < toI || insert.length) parent.replaceChildren(fromI, toI, insert);
}
function $071334078f8d3f8a$var$mergeChildrenInto(parent, from, to, insert, openStart, openEnd) {
    let cur = parent.childCursor();
    let { i: toI, off: toOff } = cur.findPos(to, 1);
    let { i: fromI, off: fromOff } = cur.findPos(from, -1);
    let dLen = from - to;
    for (let view of insert)dLen += view.length;
    parent.length += dLen;
    $071334078f8d3f8a$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, 0, openStart, openEnd);
}
const $071334078f8d3f8a$var$LineBreakPlaceholder = "￿";
class $071334078f8d3f8a$var$DOMReader {
    constructor(points, state){
        this.points = points;
        this.text = "";
        this.lineSeparator = state.facet((0, $hB7kI.EditorState).lineSeparator);
    }
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += $071334078f8d3f8a$var$LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        let parent = start.parentNode;
        for(let cur = start;;){
            this.findPointBefore(parent, cur);
            let oldLen = this.text.length;
            this.readNode(cur);
            let next = cur.nextSibling;
            if (next == end) break;
            let view = $071334078f8d3f8a$var$ContentView.get(cur), nextView = $071334078f8d3f8a$var$ContentView.get(next);
            if (view && nextView ? view.breakAfter : (view ? view.breakAfter : $071334078f8d3f8a$var$isBlockElement(cur)) || $071334078f8d3f8a$var$isBlockElement(next) && (cur.nodeName != "BR" || cur.cmIgnore) && this.text.length > oldLen) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        let text = node.nodeValue;
        for (let point of this.points)if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
        for(let off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            let nextBreak = -1, breakSize = 1, m;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                for (let point of this.points)if (point.node == node && point.pos > this.text.length) point.pos -= breakSize - 1;
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        if (node.cmIgnore) return;
        let view = $071334078f8d3f8a$var$ContentView.get(node);
        let fromView = view && view.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(let i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        for (let point of this.points)if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
    }
    findPointInside(node, maxLen) {
        for (let point of this.points)if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + Math.min(maxLen, point.offset);
    }
}
function $071334078f8d3f8a$var$isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
class $071334078f8d3f8a$var$DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
let $071334078f8d3f8a$var$nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
let $071334078f8d3f8a$var$doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
const $071334078f8d3f8a$var$ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec($071334078f8d3f8a$var$nav.userAgent);
const $071334078f8d3f8a$var$ie_upto10 = /*@__PURE__*/ /MSIE \d/.test($071334078f8d3f8a$var$nav.userAgent);
const $071334078f8d3f8a$var$ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($071334078f8d3f8a$var$nav.userAgent);
const $071334078f8d3f8a$var$ie = !!($071334078f8d3f8a$var$ie_upto10 || $071334078f8d3f8a$var$ie_11up || $071334078f8d3f8a$var$ie_edge);
const $071334078f8d3f8a$var$gecko = !$071334078f8d3f8a$var$ie && /*@__PURE__*/ /gecko\/(\d+)/i.test($071334078f8d3f8a$var$nav.userAgent);
const $071334078f8d3f8a$var$chrome = !$071334078f8d3f8a$var$ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec($071334078f8d3f8a$var$nav.userAgent);
const $071334078f8d3f8a$var$webkit = "webkitFontSmoothing" in $071334078f8d3f8a$var$doc.documentElement.style;
const $071334078f8d3f8a$var$safari = !$071334078f8d3f8a$var$ie && /*@__PURE__*/ /Apple Computer/.test($071334078f8d3f8a$var$nav.vendor);
const $071334078f8d3f8a$var$ios = $071334078f8d3f8a$var$safari && /*@__PURE__*/ (/Mobile\/\w+/.test($071334078f8d3f8a$var$nav.userAgent) || $071334078f8d3f8a$var$nav.maxTouchPoints > 2);
var $071334078f8d3f8a$var$browser = {
    mac: $071334078f8d3f8a$var$ios || /*@__PURE__*/ /Mac/.test($071334078f8d3f8a$var$nav.platform),
    windows: /*@__PURE__*/ /Win/.test($071334078f8d3f8a$var$nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test($071334078f8d3f8a$var$nav.platform),
    ie: $071334078f8d3f8a$var$ie,
    ie_version: $071334078f8d3f8a$var$ie_upto10 ? $071334078f8d3f8a$var$doc.documentMode || 6 : $071334078f8d3f8a$var$ie_11up ? +$071334078f8d3f8a$var$ie_11up[1] : $071334078f8d3f8a$var$ie_edge ? +$071334078f8d3f8a$var$ie_edge[1] : 0,
    gecko: $071334078f8d3f8a$var$gecko,
    gecko_version: $071334078f8d3f8a$var$gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec($071334078f8d3f8a$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!$071334078f8d3f8a$var$chrome,
    chrome_version: $071334078f8d3f8a$var$chrome ? +$071334078f8d3f8a$var$chrome[1] : 0,
    ios: $071334078f8d3f8a$var$ios,
    android: /*@__PURE__*/ /Android\b/.test($071334078f8d3f8a$var$nav.userAgent),
    webkit: $071334078f8d3f8a$var$webkit,
    safari: $071334078f8d3f8a$var$safari,
    webkit_version: $071334078f8d3f8a$var$webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: $071334078f8d3f8a$var$doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const $071334078f8d3f8a$var$MaxJoinLen = 256;
class $071334078f8d3f8a$var$TextView extends $071334078f8d3f8a$var$ContentView {
    constructor(text){
        super();
        this.text = text;
    }
    get length() {
        return this.text.length;
    }
    createDOM(textDOM) {
        this.setDOM(textDOM || document.createTextNode(this.text));
    }
    sync(view, track) {
        if (!this.dom) this.createDOM();
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    reuseDOM(dom) {
        if (dom.nodeType == 3) this.createDOM(dom);
    }
    merge(from, to, source) {
        if (this.flags & 8 /* Composition */  || source && (!(source instanceof $071334078f8d3f8a$var$TextView) || this.length - (to - from) + source.length > $071334078f8d3f8a$var$MaxJoinLen || source.flags & 8 /* Composition */ )) return false;
        this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = new $071334078f8d3f8a$var$TextView(this.text.slice(from));
        this.text = this.text.slice(0, from);
        this.markDirty();
        result.flags |= this.flags & 8 /* Composition */ ;
        return result;
    }
    localPosFromDOM(node, offset) {
        return node == this.dom ? offset : offset ? this.text.length : 0;
    }
    domAtPos(pos) {
        return new $071334078f8d3f8a$var$DOMPos(this.dom, pos);
    }
    domBoundsAround(_from, _to, offset) {
        return {
            from: offset,
            to: offset + this.length,
            startDOM: this.dom,
            endDOM: this.dom.nextSibling
        };
    }
    coordsAt(pos, side) {
        return $071334078f8d3f8a$var$textCoords(this.dom, pos, side);
    }
}
class $071334078f8d3f8a$var$MarkView extends $071334078f8d3f8a$var$ContentView {
    constructor(mark, children = [], length = 0){
        super();
        this.mark = mark;
        this.children = children;
        this.length = length;
        for (let ch of children)ch.setParent(this);
    }
    setAttrs(dom) {
        $071334078f8d3f8a$var$clearAttributes(dom);
        if (this.mark.class) dom.className = this.mark.class;
        if (this.mark.attrs) for(let name in this.mark.attrs)dom.setAttribute(name, this.mark.attrs[name]);
        return dom;
    }
    canReuseDOM(other) {
        return super.canReuseDOM(other) && !((this.flags | other.flags) & 8 /* Composition */ );
    }
    reuseDOM(node) {
        if (node.nodeName == this.mark.tagName.toUpperCase()) {
            this.setDOM(node);
            this.flags |= 6 /* NodeDirty */ ;
        }
    }
    sync(view, track) {
        if (!this.dom) this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
        else if (this.flags & 4 /* AttrsDirty */ ) this.setAttrs(this.dom);
        super.sync(view, track);
    }
    merge(from, to, source, _hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $071334078f8d3f8a$var$MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        $071334078f8d3f8a$var$mergeChildrenInto(this, from, to, source ? source.children : [], openStart - 1, openEnd - 1);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = [], off = 0, detachFrom = -1, i = 0;
        for (let elt of this.children){
            let end = off + elt.length;
            if (end > from) result.push(off < from ? elt.split(from - off) : elt);
            if (detachFrom < 0 && off >= from) detachFrom = i;
            off = end;
            i++;
        }
        let length = this.length - from;
        this.length = from;
        if (detachFrom > -1) {
            this.children.length = detachFrom;
            this.markDirty();
        }
        return new $071334078f8d3f8a$var$MarkView(this.mark, result, length);
    }
    domAtPos(pos) {
        return $071334078f8d3f8a$var$inlineDOMAtPos(this, pos);
    }
    coordsAt(pos, side) {
        return $071334078f8d3f8a$var$coordsInChildren(this, pos, side);
    }
}
function $071334078f8d3f8a$var$textCoords(text, pos, side) {
    let length = text.nodeValue.length;
    if (pos > length) pos = length;
    let from = pos, to = pos, flatten = 0;
    if (pos == 0 && side < 0 || pos == length && side >= 0) {
        if (!($071334078f8d3f8a$var$browser.chrome || $071334078f8d3f8a$var$browser.gecko)) {
            if (pos) {
                from--;
                flatten = 1;
            } else if (to < length) {
                to++;
                flatten = -1;
            }
        }
    } else {
        if (side < 0) from--;
        else if (to < length) to++;
    }
    let rects = $071334078f8d3f8a$var$textRange(text, from, to).getClientRects();
    if (!rects.length) return null;
    let rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
    if ($071334078f8d3f8a$var$browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
    return flatten ? $071334078f8d3f8a$var$flattenRect(rect, flatten < 0) : rect || null;
}
// Also used for collapsed ranges that don't have a placeholder widget!
class $071334078f8d3f8a$var$WidgetView extends $071334078f8d3f8a$var$ContentView {
    constructor(widget, length, side){
        super();
        this.widget = widget;
        this.length = length;
        this.side = side;
        this.prevWidget = null;
    }
    static create(widget, length, side) {
        return new $071334078f8d3f8a$var$WidgetView(widget, length, side);
    }
    split(from) {
        let result = $071334078f8d3f8a$var$WidgetView.create(this.widget, this.length - from, this.side);
        this.length -= from;
        return result;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            this.dom.contentEditable = "false";
        }
    }
    getSide() {
        return this.side;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $071334078f8d3f8a$var$WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    become(other) {
        if (other instanceof $071334078f8d3f8a$var$WidgetView && other.side == this.side && this.widget.constructor == other.widget.constructor) {
            if (!this.widget.compare(other.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get overrideDOMText() {
        if (this.length == 0) return (0, $hB7kI.Text).empty;
        let top = this;
        while(top.parent)top = top.parent;
        let { view: view } = top, text = view && view.state.doc, start = this.posAtStart;
        return text ? text.slice(start, start + this.length) : (0, $hB7kI.Text).empty;
    }
    domAtPos(pos) {
        return (this.length ? pos == 0 : this.side > 0) ? $071334078f8d3f8a$var$DOMPos.before(this.dom) : $071334078f8d3f8a$var$DOMPos.after(this.dom, pos == this.length);
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos, side) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        let rects = this.dom.getClientRects(), rect = null;
        if (!rects.length) return null;
        let fromBack = this.side ? this.side < 0 : pos > 0;
        for(let i = fromBack ? rects.length - 1 : 0;; i += fromBack ? -1 : 1){
            rect = rects[i];
            if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
        }
        return $071334078f8d3f8a$var$flattenRect(rect, !fromBack);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    get isHidden() {
        return this.widget.isHidden;
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class $071334078f8d3f8a$var$WidgetBufferView extends $071334078f8d3f8a$var$ContentView {
    constructor(side){
        super();
        this.side = side;
    }
    get length() {
        return 0;
    }
    merge() {
        return false;
    }
    become(other) {
        return other instanceof $071334078f8d3f8a$var$WidgetBufferView && other.side == this.side;
    }
    split() {
        return new $071334078f8d3f8a$var$WidgetBufferView(this.side);
    }
    sync() {
        if (!this.dom) {
            let dom = document.createElement("img");
            dom.className = "cm-widgetBuffer";
            dom.setAttribute("aria-hidden", "true");
            this.setDOM(dom);
        }
    }
    getSide() {
        return this.side;
    }
    domAtPos(pos) {
        return this.side > 0 ? $071334078f8d3f8a$var$DOMPos.before(this.dom) : $071334078f8d3f8a$var$DOMPos.after(this.dom);
    }
    localPosFromDOM() {
        return 0;
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos) {
        return this.dom.getBoundingClientRect();
    }
    get overrideDOMText() {
        return (0, $hB7kI.Text).empty;
    }
    get isHidden() {
        return true;
    }
}
$071334078f8d3f8a$var$TextView.prototype.children = $071334078f8d3f8a$var$WidgetView.prototype.children = $071334078f8d3f8a$var$WidgetBufferView.prototype.children = $071334078f8d3f8a$var$noChildren;
function $071334078f8d3f8a$var$inlineDOMAtPos(parent, pos) {
    let dom = parent.dom, { children: children } = parent, i = 0;
    for(let off = 0; i < children.length; i++){
        let child = children[i], end = off + child.length;
        if (end == off && child.getSide() <= 0) continue;
        if (pos > off && pos < end && child.dom.parentNode == dom) return child.domAtPos(pos - off);
        if (pos <= off) break;
        off = end;
    }
    for(let j = i; j > 0; j--){
        let prev = children[j - 1];
        if (prev.dom.parentNode == dom) return prev.domAtPos(prev.length);
    }
    for(let j = i; j < children.length; j++){
        let next = children[j];
        if (next.dom.parentNode == dom) return next.domAtPos(0);
    }
    return new $071334078f8d3f8a$var$DOMPos(dom, 0);
}
// Assumes `view`, if a mark view, has precisely 1 child.
function $071334078f8d3f8a$var$joinInlineInto(parent, view, open) {
    let last, { children: children } = parent;
    if (open > 0 && view instanceof $071334078f8d3f8a$var$MarkView && children.length && (last = children[children.length - 1]) instanceof $071334078f8d3f8a$var$MarkView && last.mark.eq(view.mark)) $071334078f8d3f8a$var$joinInlineInto(last, view.children[0], open - 1);
    else {
        children.push(view);
        view.setParent(parent);
    }
    parent.length += view.length;
}
function $071334078f8d3f8a$var$coordsInChildren(view, pos, side) {
    let before = null, beforePos = -1, after = null, afterPos = -1;
    function scan(view, pos) {
        for(let i = 0, off = 0; i < view.children.length && off <= pos; i++){
            let child = view.children[i], end = off + child.length;
            if (end >= pos) {
                if (child.children.length) scan(child, pos - off);
                else if ((!after || after.isHidden && side > 0) && (end > pos || off == end && child.getSide() > 0)) {
                    after = child;
                    afterPos = pos - off;
                } else if (off < pos || off == end && child.getSide() < 0 && !child.isHidden) {
                    before = child;
                    beforePos = pos - off;
                }
            }
            off = end;
        }
    }
    scan(view, pos);
    let target = (side < 0 ? before : after) || before || after;
    if (target) return target.coordsAt(Math.max(0, target == before ? beforePos : afterPos), side);
    return $071334078f8d3f8a$var$fallbackRect(view);
}
function $071334078f8d3f8a$var$fallbackRect(view) {
    let last = view.dom.lastChild;
    if (!last) return view.dom.getBoundingClientRect();
    let rects = $071334078f8d3f8a$var$clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function $071334078f8d3f8a$var$combineAttrs(source, target) {
    for(let name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
const $071334078f8d3f8a$var$noAttrs = /*@__PURE__*/ Object.create(null);
function $071334078f8d3f8a$var$attrsEq(a, b, ignore) {
    if (a == b) return true;
    if (!a) a = $071334078f8d3f8a$var$noAttrs;
    if (!b) b = $071334078f8d3f8a$var$noAttrs;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0)) return false;
    for (let key of keysA){
        if (key != ignore && (keysB.indexOf(key) == -1 || a[key] !== b[key])) return false;
    }
    return true;
}
function $071334078f8d3f8a$var$updateAttrs(dom, prev, attrs) {
    let changed = null;
    if (prev) {
        for(let name in prev)if (!(attrs && name in attrs)) dom.removeAttribute(changed = name);
    }
    if (attrs) {
        for(let name in attrs)if (!(prev && prev[name] == attrs[name])) dom.setAttribute(changed = name, attrs[name]);
    }
    return !!changed;
}
function $071334078f8d3f8a$var$getAttrs(dom) {
    let attrs = Object.create(null);
    for(let i = 0; i < dom.attributes.length; i++){
        let attr = dom.attributes[i];
        attrs[attr.name] = attr.value;
    }
    return attrs;
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class $071334078f8d3f8a$export$95cdd842edb044c5 {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom, view) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    For inline widgets that are displayed inline (as opposed to
    `inline-block`) and introduce line breaks (through `<br>` tags
    or textual newlines), this must indicate the amount of line
    breaks they introduce. Defaults to 0.
    */ get lineBreaks() {
        return 0;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    Override the way screen coordinates for positions at/in the
    widget are found. `pos` will be the offset into the widget, and
    `side` the side of the position that is being queried—less than
    zero for before, greater than zero for after, and zero for
    directly at that position.
    */ coordsAt(dom, pos, side) {
        return null;
    }
    /**
    @internal
    */ get isHidden() {
        return false;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var $071334078f8d3f8a$export$48808c686fe495c4 = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}($071334078f8d3f8a$export$48808c686fe495c4 || ($071334078f8d3f8a$export$48808c686fe495c4 = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class $071334078f8d3f8a$export$10e30b733df217ea extends (0, $hB7kI.RangeValue) {
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new $071334078f8d3f8a$var$MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        let side = Math.max(-10000, Math.min(10000, spec.side || 0)), block = !!spec.block;
        side += block && !spec.inlineOrder ? side > 0 ? 300000000 /* BlockAfter */  : -400000000 /* BlockBefore */  : side > 0 ? 100000000 /* InlineAfter */  : -100000000 /* InlineBefore */ ;
        return new $071334078f8d3f8a$var$PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        let block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* GapStart */ ;
            endSide = 400000000 /* GapEnd */ ;
        } else {
            let { start: start, end: end } = $071334078f8d3f8a$var$getInclusive(spec, block);
            startSide = (start ? block ? -300000000 /* BlockIncStart */  : -1 /* InlineIncStart */  : 500000000 /* NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* BlockIncEnd */  : 1 /* InlineIncEnd */  : -600000000 /* NonIncEnd */ ) + 1;
        }
        return new $071334078f8d3f8a$var$PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new $071334078f8d3f8a$var$LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of, sort = false) {
        return (0, $hB7kI.RangeSet).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
}
/**
The empty set of decorations.
*/ $071334078f8d3f8a$export$10e30b733df217ea.none = (0, $hB7kI.RangeSet).empty;
class $071334078f8d3f8a$var$MarkDecoration extends $071334078f8d3f8a$export$10e30b733df217ea {
    constructor(spec){
        let { start: start, end: end } = $071334078f8d3f8a$var$getInclusive(spec);
        super(start ? -1 /* InlineIncStart */  : 500000000 /* NonIncStart */ , end ? 1 /* InlineIncEnd */  : -600000000 /* NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.class = spec.class || "";
        this.attrs = spec.attributes || null;
    }
    eq(other) {
        var _a, _b;
        return this == other || other instanceof $071334078f8d3f8a$var$MarkDecoration && this.tagName == other.tagName && (this.class || ((_a = this.attrs) === null || _a === void 0 ? void 0 : _a.class)) == (other.class || ((_b = other.attrs) === null || _b === void 0 ? void 0 : _b.class)) && $071334078f8d3f8a$var$attrsEq(this.attrs, other.attrs, "class");
    }
    range(from, to = from) {
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
}
$071334078f8d3f8a$var$MarkDecoration.prototype.point = false;
class $071334078f8d3f8a$var$LineDecoration extends $071334078f8d3f8a$export$10e30b733df217ea {
    constructor(spec){
        super(-200000000 /* Line */ , -200000000 /* Line */ , null, spec);
    }
    eq(other) {
        return other instanceof $071334078f8d3f8a$var$LineDecoration && this.spec.class == other.spec.class && $071334078f8d3f8a$var$attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from, to = from) {
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
}
$071334078f8d3f8a$var$LineDecoration.prototype.mapMode = (0, $hB7kI.MapMode).TrackBefore;
$071334078f8d3f8a$var$LineDecoration.prototype.point = true;
class $071334078f8d3f8a$var$PointDecoration extends $071334078f8d3f8a$export$10e30b733df217ea {
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, $hB7kI.MapMode).TrackDel : startSide <= 0 ? (0, $hB7kI.MapMode).TrackBefore : (0, $hB7kI.MapMode).TrackAfter;
    }
    // Only relevant when this.block == true
    get type() {
        return this.startSide < this.endSide ? $071334078f8d3f8a$export$48808c686fe495c4.WidgetRange : this.startSide <= 0 ? $071334078f8d3f8a$export$48808c686fe495c4.WidgetBefore : $071334078f8d3f8a$export$48808c686fe495c4.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
    }
    eq(other) {
        return other instanceof $071334078f8d3f8a$var$PointDecoration && $071334078f8d3f8a$var$widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from, to = from) {
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
}
$071334078f8d3f8a$var$PointDecoration.prototype.point = true;
function $071334078f8d3f8a$var$getInclusive(spec, block = false) {
    let { inclusiveStart: start, inclusiveEnd: end } = spec;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function $071334078f8d3f8a$var$widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function $071334078f8d3f8a$var$addRange(from, to, ranges, margin = 0) {
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
class $071334078f8d3f8a$var$LineView extends $071334078f8d3f8a$var$ContentView {
    constructor(){
        super(...arguments);
        this.children = [];
        this.length = 0;
        this.prevAttrs = undefined;
        this.attrs = null;
        this.breakAfter = 0;
    }
    // Consumes source
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source) {
            if (!(source instanceof $071334078f8d3f8a$var$LineView)) return false;
            if (!this.dom) source.transferDOM(this); // Reuse source.dom when appropriate
        }
        if (hasStart) this.setDeco(source ? source.attrs : null);
        $071334078f8d3f8a$var$mergeChildrenInto(this, from, to, source ? source.children : [], openStart, openEnd);
        return true;
    }
    split(at) {
        let end = new $071334078f8d3f8a$var$LineView;
        end.breakAfter = this.breakAfter;
        if (this.length == 0) return end;
        let { i: i, off: off } = this.childPos(at);
        if (off) {
            end.append(this.children[i].split(off), 0);
            this.children[i].merge(off, this.children[i].length, null, false, 0, 0);
            i++;
        }
        for(let j = i; j < this.children.length; j++)end.append(this.children[j], 0);
        while(i > 0 && this.children[i - 1].length == 0)this.children[--i].destroy();
        this.children.length = i;
        this.markDirty();
        this.length = at;
        return end;
    }
    transferDOM(other) {
        if (!this.dom) return;
        this.markDirty();
        other.setDOM(this.dom);
        other.prevAttrs = this.prevAttrs === undefined ? this.attrs : this.prevAttrs;
        this.prevAttrs = undefined;
        this.dom = null;
    }
    setDeco(attrs) {
        if (!$071334078f8d3f8a$var$attrsEq(this.attrs, attrs)) {
            if (this.dom) {
                this.prevAttrs = this.attrs;
                this.markDirty();
            }
            this.attrs = attrs;
        }
    }
    append(child, openStart) {
        $071334078f8d3f8a$var$joinInlineInto(this, child, openStart);
    }
    // Only called when building a line view in ContentBuilder
    addLineDeco(deco) {
        let attrs = deco.spec.attributes, cls = deco.spec.class;
        if (attrs) this.attrs = $071334078f8d3f8a$var$combineAttrs(attrs, this.attrs || {});
        if (cls) this.attrs = $071334078f8d3f8a$var$combineAttrs({
            class: cls
        }, this.attrs || {});
    }
    domAtPos(pos) {
        return $071334078f8d3f8a$var$inlineDOMAtPos(this, pos);
    }
    reuseDOM(node) {
        if (node.nodeName == "DIV") {
            this.setDOM(node);
            this.flags |= 6 /* NodeDirty */ ;
        }
    }
    sync(view, track) {
        var _a;
        if (!this.dom) {
            this.setDOM(document.createElement("div"));
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        } else if (this.flags & 4 /* AttrsDirty */ ) {
            $071334078f8d3f8a$var$clearAttributes(this.dom);
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        }
        if (this.prevAttrs !== undefined) {
            $071334078f8d3f8a$var$updateAttrs(this.dom, this.prevAttrs, this.attrs);
            this.dom.classList.add("cm-line");
            this.prevAttrs = undefined;
        }
        super.sync(view, track);
        let last = this.dom.lastChild;
        while(last && $071334078f8d3f8a$var$ContentView.get(last) instanceof $071334078f8d3f8a$var$MarkView)last = last.lastChild;
        if (!last || !this.length || last.nodeName != "BR" && ((_a = $071334078f8d3f8a$var$ContentView.get(last)) === null || _a === void 0 ? void 0 : _a.isEditable) == false && (!$071334078f8d3f8a$var$browser.ios || !this.children.some((ch)=>ch instanceof $071334078f8d3f8a$var$TextView))) {
            let hack = document.createElement("BR");
            hack.cmIgnore = true;
            this.dom.appendChild(hack);
        }
    }
    measureTextSize() {
        if (this.children.length == 0 || this.length > 20) return null;
        let totalWidth = 0, textHeight;
        for (let child of this.children){
            if (!(child instanceof $071334078f8d3f8a$var$TextView) || /[^ -~]/.test(child.text)) return null;
            let rects = $071334078f8d3f8a$var$clientRectsFor(child.dom);
            if (rects.length != 1) return null;
            totalWidth += rects[0].width;
            textHeight = rects[0].height;
        }
        return !totalWidth ? null : {
            lineHeight: this.dom.getBoundingClientRect().height,
            charWidth: totalWidth / this.length,
            textHeight: textHeight
        };
    }
    coordsAt(pos, side) {
        let rect = $071334078f8d3f8a$var$coordsInChildren(this, pos, side);
        // Correct rectangle height for empty lines when the returned
        // height is larger than the text height.
        if (!this.children.length && rect && this.parent) {
            let { heightOracle: heightOracle } = this.parent.view.viewState, height = rect.bottom - rect.top;
            if (Math.abs(height - heightOracle.lineHeight) < 2 && heightOracle.textHeight < height) {
                let dist = (height - heightOracle.textHeight) / 2;
                return {
                    top: rect.top + dist,
                    bottom: rect.bottom - dist,
                    left: rect.left,
                    right: rect.left
                };
            }
        }
        return rect;
    }
    become(_other) {
        return false;
    }
    get type() {
        return $071334078f8d3f8a$export$48808c686fe495c4.Text;
    }
    static find(docView, pos) {
        for(let i = 0, off = 0; i < docView.children.length; i++){
            let block = docView.children[i], end = off + block.length;
            if (end >= pos) {
                if (block instanceof $071334078f8d3f8a$var$LineView) return block;
                if (end > pos) break;
            }
            off = end + block.breakAfter;
        }
        return null;
    }
}
class $071334078f8d3f8a$var$BlockWidgetView extends $071334078f8d3f8a$var$ContentView {
    constructor(widget, length, type){
        super();
        this.widget = widget;
        this.length = length;
        this.type = type;
        this.breakAfter = 0;
        this.prevWidget = null;
    }
    merge(from, to, source, _takeDeco, openStart, openEnd) {
        if (source && (!(source instanceof $071334078f8d3f8a$var$BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    domAtPos(pos) {
        return pos == 0 ? $071334078f8d3f8a$var$DOMPos.before(this.dom) : $071334078f8d3f8a$var$DOMPos.after(this.dom, pos == this.length);
    }
    split(at) {
        let len = this.length - at;
        this.length = at;
        let end = new $071334078f8d3f8a$var$BlockWidgetView(this.widget, len, this.type);
        end.breakAfter = this.breakAfter;
        return end;
    }
    get children() {
        return $071334078f8d3f8a$var$noChildren;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            this.dom.contentEditable = "false";
        }
    }
    get overrideDOMText() {
        return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : (0, $hB7kI.Text).empty;
    }
    domBoundsAround() {
        return null;
    }
    become(other) {
        if (other instanceof $071334078f8d3f8a$var$BlockWidgetView && other.widget.constructor == this.widget.constructor) {
            if (!other.widget.compare(this.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            this.type = other.type;
            this.breakAfter = other.breakAfter;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    coordsAt(pos, side) {
        return this.widget.coordsAt(this.dom, pos, side);
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
}
class $071334078f8d3f8a$var$ContentBuilder {
    constructor(doc, pos, end, disallowBlockEffectsFor){
        this.doc = doc;
        this.pos = pos;
        this.end = end;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.content = [];
        this.curLine = null;
        this.breakAtStart = 0;
        this.pendingBuffer = 0 /* No */ ;
        this.bufferMarks = [];
        // Set to false directly after a widget that covers the position after it
        this.atCursorPos = true;
        this.openStart = -1;
        this.openEnd = -1;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
        this.skip = pos;
    }
    posCovered() {
        if (this.content.length == 0) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
        let last = this.content[this.content.length - 1];
        return !last.breakAfter && !(last instanceof $071334078f8d3f8a$var$BlockWidgetView && last.type == $071334078f8d3f8a$export$48808c686fe495c4.WidgetBefore);
    }
    getLine() {
        if (!this.curLine) {
            this.content.push(this.curLine = new $071334078f8d3f8a$var$LineView);
            this.atCursorPos = true;
        }
        return this.curLine;
    }
    flushBuffer(active = this.bufferMarks) {
        if (this.pendingBuffer) {
            this.curLine.append($071334078f8d3f8a$var$wrapMarks(new $071334078f8d3f8a$var$WidgetBufferView(-1), active), active.length);
            this.pendingBuffer = 0 /* No */ ;
        }
    }
    addBlockWidget(view) {
        this.flushBuffer();
        this.curLine = null;
        this.content.push(view);
    }
    finish(openEnd) {
        if (this.pendingBuffer && openEnd <= this.bufferMarks.length) this.flushBuffer();
        else this.pendingBuffer = 0 /* No */ ;
        if (!this.posCovered()) this.getLine();
    }
    buildText(length, active, openStart) {
        while(length > 0){
            if (this.textOff == this.text.length) {
                let { value: value, lineBreak: lineBreak, done: done } = this.cursor.next(this.skip);
                this.skip = 0;
                if (done) throw new Error("Ran out of text content when drawing inline views");
                if (lineBreak) {
                    if (!this.posCovered()) this.getLine();
                    if (this.content.length) this.content[this.content.length - 1].breakAfter = 1;
                    else this.breakAtStart = 1;
                    this.flushBuffer();
                    this.curLine = null;
                    this.atCursorPos = true;
                    length--;
                    continue;
                } else {
                    this.text = value;
                    this.textOff = 0;
                }
            }
            let take = Math.min(this.text.length - this.textOff, length, 512 /* Chunk */ );
            this.flushBuffer(active.slice(active.length - openStart));
            this.getLine().append($071334078f8d3f8a$var$wrapMarks(new $071334078f8d3f8a$var$TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
            this.atCursorPos = true;
            this.textOff += take;
            length -= take;
            openStart = 0;
        }
    }
    span(from, to, active, openStart) {
        this.buildText(to - from, active, openStart);
        this.pos = to;
        if (this.openStart < 0) this.openStart = openStart;
    }
    point(from, to, deco, active, openStart, index) {
        if (this.disallowBlockEffectsFor[index] && deco instanceof $071334078f8d3f8a$var$PointDecoration) {
            if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
            if (to > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
        }
        let len = to - from;
        if (deco instanceof $071334078f8d3f8a$var$PointDecoration) {
            if (deco.block) {
                let { type: type } = deco;
                if (type == $071334078f8d3f8a$export$48808c686fe495c4.WidgetAfter && !this.posCovered()) this.getLine();
                this.addBlockWidget(new $071334078f8d3f8a$var$BlockWidgetView(deco.widget || new $071334078f8d3f8a$var$NullWidget("div"), len, type));
            } else {
                let view = $071334078f8d3f8a$var$WidgetView.create(deco.widget || new $071334078f8d3f8a$var$NullWidget("span"), len, len ? 0 : deco.startSide);
                let cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to || deco.startSide > 0);
                let cursorAfter = !view.isEditable && (from < to || openStart > active.length || deco.startSide <= 0);
                let line = this.getLine();
                if (this.pendingBuffer == 2 /* IfCursor */  && !cursorBefore && !view.isEditable) this.pendingBuffer = 0 /* No */ ;
                this.flushBuffer(active);
                if (cursorBefore) {
                    line.append($071334078f8d3f8a$var$wrapMarks(new $071334078f8d3f8a$var$WidgetBufferView(1), active), openStart);
                    openStart = active.length + Math.max(0, openStart - active.length);
                }
                line.append($071334078f8d3f8a$var$wrapMarks(view, active), openStart);
                this.atCursorPos = cursorAfter;
                this.pendingBuffer = !cursorAfter ? 0 /* No */  : from < to || openStart > active.length ? 1 /* Yes */  : 2 /* IfCursor */ ;
                if (this.pendingBuffer) this.bufferMarks = active.slice();
            }
        } else if (this.doc.lineAt(this.pos).from == this.pos) this.getLine().addLineDeco(deco);
        if (len) {
            // Advance the iterator past the replaced content
            if (this.textOff + len <= this.text.length) this.textOff += len;
            else {
                this.skip += len - (this.text.length - this.textOff);
                this.text = "";
                this.textOff = 0;
            }
            this.pos = to;
        }
        if (this.openStart < 0) this.openStart = openStart;
    }
    static build(text, from, to, decorations, dynamicDecorationMap) {
        let builder = new $071334078f8d3f8a$var$ContentBuilder(text, from, to, dynamicDecorationMap);
        builder.openEnd = (0, $hB7kI.RangeSet).spans(decorations, from, to, builder);
        if (builder.openStart < 0) builder.openStart = builder.openEnd;
        builder.finish(builder.openEnd);
        return builder;
    }
}
function $071334078f8d3f8a$var$wrapMarks(view, active) {
    for (let mark of active)view = new $071334078f8d3f8a$var$MarkView(mark, [
        view
    ], view.length);
    return view;
}
class $071334078f8d3f8a$var$NullWidget extends $071334078f8d3f8a$export$95cdd842edb044c5 {
    constructor(tag){
        super();
        this.tag = tag;
    }
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
        return true;
    }
}
const $071334078f8d3f8a$var$clickAddsSelectionRange = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$dragMovesSelection$1 = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$mouseSelectionStyle = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$exceptionSink = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$updateListener = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$inputHandler = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$focusChangeEffect = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$perLineTextDirection = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
const $071334078f8d3f8a$var$nativeSelectionHidden = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
class $071334078f8d3f8a$var$ScrollTarget {
    constructor(range, y = "nearest", x = "nearest", yMargin = 5, xMargin = 5){
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
    }
    map(changes) {
        return changes.empty ? this : new $071334078f8d3f8a$var$ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin);
    }
}
const $071334078f8d3f8a$var$scrollIntoView = /*@__PURE__*/ (0, $hB7kI.StateEffect).define({
    map: (t, ch)=>t.map(ch)
});
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function $071334078f8d3f8a$export$f86b2a1a2ce291b3(state, exception, context) {
    let handler = state.facet($071334078f8d3f8a$var$exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror) window.onerror(String(exception), context, undefined, undefined, exception);
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
const $071334078f8d3f8a$var$editable = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.length ? values[0] : true
});
let $071334078f8d3f8a$var$nextPluginID = 0;
const $071334078f8d3f8a$var$viewPlugin = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view.
*/ class $071334078f8d3f8a$export$44d5eccfd62adda7 {
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.extension = buildExtensions(this);
    }
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        const { eventHandlers: eventHandlers, provide: provide, decorations: deco } = spec || {};
        return new $071334078f8d3f8a$export$44d5eccfd62adda7($071334078f8d3f8a$var$nextPluginID++, create, eventHandlers, (plugin)=>{
            let ext = [
                $071334078f8d3f8a$var$viewPlugin.of(plugin)
            ];
            if (deco) ext.push($071334078f8d3f8a$var$decorations.of((view)=>{
                let pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : $071334078f8d3f8a$export$10e30b733df217ea.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return $071334078f8d3f8a$export$44d5eccfd62adda7.define((view)=>new cls(view), spec);
    }
}
class $071334078f8d3f8a$var$PluginInstance {
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `false`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.create(view);
            } catch (e) {
                $071334078f8d3f8a$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            let update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                $071334078f8d3f8a$export$f86b2a1a2ce291b3(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            $071334078f8d3f8a$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
}
const $071334078f8d3f8a$var$editorAttributes = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$contentAttributes = /*@__PURE__*/ (0, $hB7kI.Facet).define();
// Provide decorations
const $071334078f8d3f8a$var$decorations = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$atomicRanges = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$scrollMargins = /*@__PURE__*/ (0, $hB7kI.Facet).define();
function $071334078f8d3f8a$var$getScrollMargins(view) {
    let left = 0, right = 0, top = 0, bottom = 0;
    for (let source of view.state.facet($071334078f8d3f8a$var$scrollMargins)){
        let m = source(view);
        if (m) {
            if (m.left != null) left = Math.max(left, m.left);
            if (m.right != null) right = Math.max(right, m.right);
            if (m.top != null) top = Math.max(top, m.top);
            if (m.bottom != null) bottom = Math.max(bottom, m.bottom);
        }
    }
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
    };
}
const $071334078f8d3f8a$var$styleModule = /*@__PURE__*/ (0, $hB7kI.Facet).define();
class $071334078f8d3f8a$var$ChangedRange {
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
    join(other) {
        return new $071334078f8d3f8a$var$ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        let i = set.length, me = this;
        for(; i > 0; i--){
            let range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        let result = [];
        for(let dI = 0, rI = 0, posA = 0, posB = 0;; dI++){
            let next = dI == diff.length ? null : diff[dI], off = posA - posB;
            let end = next ? next.fromB : 1e9;
            while(rI < ranges.length && ranges[rI] < end){
                let from = ranges[rI], to = ranges[rI + 1];
                let fromB = Math.max(posB, from), toB = Math.min(end, to);
                if (fromB <= toB) new $071334078f8d3f8a$var$ChangedRange(fromB + off, toB + off, fromB, toB).addToSet(result);
                if (to > end) break;
                else rI += 2;
            }
            if (!next) return result;
            new $071334078f8d3f8a$var$ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result);
            posA = next.toA;
            posB = next.toB;
        }
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class $071334078f8d3f8a$export$b5b084f95c87edf7 {
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, $hB7kI.ChangeSet).empty(this.startState.doc.length);
        for (let tr of transactions)this.changes = this.changes.compose(tr.changes);
        let changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new $071334078f8d3f8a$var$ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
    }
    /**
    @internal
    */ static create(view, state, transactions) {
        return new $071334078f8d3f8a$export$b5b084f95c87edf7(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* Viewport */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 10 /* Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
}
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var $071334078f8d3f8a$export$cacd6541cfeeb6c1 = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}($071334078f8d3f8a$export$cacd6541cfeeb6c1 || ($071334078f8d3f8a$export$cacd6541cfeeb6c1 = {}));
const $071334078f8d3f8a$var$LTR = $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR, $071334078f8d3f8a$var$RTL = $071334078f8d3f8a$export$cacd6541cfeeb6c1.RTL;
// Decode a string with each type encoded as log2(type)
function $071334078f8d3f8a$var$dec(str) {
    let result = [];
    for(let i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
const $071334078f8d3f8a$var$LowTypes = /*@__PURE__*/ $071334078f8d3f8a$var$dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
const $071334078f8d3f8a$var$ArabicTypes = /*@__PURE__*/ $071334078f8d3f8a$var$dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const $071334078f8d3f8a$var$Brackets = /*@__PURE__*/ Object.create(null), $071334078f8d3f8a$var$BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for (let p of [
    "()",
    "[]",
    "{}"
]){
    let l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    $071334078f8d3f8a$var$Brackets[l] = r;
    $071334078f8d3f8a$var$Brackets[r] = -l;
}
function $071334078f8d3f8a$var$charType(ch) {
    return ch <= 0xf7 ? $071334078f8d3f8a$var$LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* R */  : 0x600 <= ch && ch <= 0x6f9 ? $071334078f8d3f8a$var$ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* AL */  : 0x2000 <= ch && ch <= 0x200b ? 256 /* NI */  : 0xfb50 <= ch && ch <= 0xfdff ? 4 /* AL */  : ch == 0x200c ? 256 /* NI */  : 1 /* L */ ;
}
const $071334078f8d3f8a$var$BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class $071334078f8d3f8a$export$e1ed96b746bb516a {
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? $071334078f8d3f8a$var$RTL : $071334078f8d3f8a$var$LTR;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        let maybe = -1;
        for(let i = 0; i < order.length; i++){
            let span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
}
// Reused array of character types
const $071334078f8d3f8a$var$types = [];
function $071334078f8d3f8a$var$computeOrder(line, direction) {
    let len = line.length, outerType = direction == $071334078f8d3f8a$var$LTR ? 1 /* L */  : 2 /* R */ , oppositeType = direction == $071334078f8d3f8a$var$LTR ? 2 /* R */  : 1 /* L */ ;
    if (!line || outerType == 1 /* L */  && !$071334078f8d3f8a$var$BidiRE.test(line)) return $071334078f8d3f8a$var$trivialOrder(len);
    // W1. Examine each non-spacing mark (NSM) in the level run, and
    // change the type of the NSM to the type of the previous
    // character. If the NSM is at the start of the level run, it will
    // get the type of sor.
    // W2. Search backwards from each instance of a European number
    // until the first strong type (R, L, AL, or sor) is found. If an
    // AL is found, change the type of the European number to Arabic
    // number.
    // W3. Change all ALs to R.
    // (Left after this: L, R, EN, AN, ET, CS, NI)
    for(let i = 0, prev = outerType, prevStrong = outerType; i < len; i++){
        let type = $071334078f8d3f8a$var$charType(line.charCodeAt(i));
        if (type == 512 /* NSM */ ) type = prev;
        else if (type == 8 /* EN */  && prevStrong == 4 /* AL */ ) type = 16 /* AN */ ;
        $071334078f8d3f8a$var$types[i] = type == 4 /* AL */  ? 2 /* R */  : type;
        if (type & 7 /* Strong */ ) prevStrong = type;
        prev = type;
    }
    // W5. A sequence of European terminators adjacent to European
    // numbers changes to all European numbers.
    // W6. Otherwise, separators and terminators change to Other
    // Neutral.
    // W7. Search backwards from each instance of a European number
    // until the first strong type (R, L, or sor) is found. If an L is
    // found, then change the type of the European number to L.
    // (Left after this: L, R, EN+AN, NI)
    for(let i = 0, prev = outerType, prevStrong = outerType; i < len; i++){
        let type = $071334078f8d3f8a$var$types[i];
        if (type == 128 /* CS */ ) {
            if (i < len - 1 && prev == $071334078f8d3f8a$var$types[i + 1] && prev & 24 /* Num */ ) type = $071334078f8d3f8a$var$types[i] = prev;
            else $071334078f8d3f8a$var$types[i] = 256 /* NI */ ;
        } else if (type == 64 /* ET */ ) {
            let end = i + 1;
            while(end < len && $071334078f8d3f8a$var$types[end] == 64 /* ET */ )end++;
            let replace = i && prev == 8 /* EN */  || end < len && $071334078f8d3f8a$var$types[end] == 8 /* EN */  ? prevStrong == 1 /* L */  ? 1 /* L */  : 8 /* EN */  : 256 /* NI */ ;
            for(let j = i; j < end; j++)$071334078f8d3f8a$var$types[j] = replace;
            i = end - 1;
        } else if (type == 8 /* EN */  && prevStrong == 1 /* L */ ) $071334078f8d3f8a$var$types[i] = 1 /* L */ ;
        prev = type;
        if (type & 7 /* Strong */ ) prevStrong = type;
    }
    // N0. Process bracket pairs in an isolating run sequence
    // sequentially in the logical order of the text positions of the
    // opening paired brackets using the logic given below. Within this
    // scope, bidirectional types EN and AN are treated as R.
    for(let i = 0, sI = 0, context = 0, ch, br, type; i < len; i++){
        // Keeps [startIndex, type, strongSeen] triples for each open
        // bracket on BracketStack.
        if (br = $071334078f8d3f8a$var$Brackets[ch = line.charCodeAt(i)]) {
            if (br < 0) {
                for(let sJ = sI - 3; sJ >= 0; sJ -= 3)if ($071334078f8d3f8a$var$BracketStack[sJ + 1] == -br) {
                    let flags = $071334078f8d3f8a$var$BracketStack[sJ + 2];
                    let type = flags & 2 /* EmbedInside */  ? outerType : !(flags & 4 /* OppositeInside */ ) ? 0 : flags & 1 /* OppositeBefore */  ? oppositeType : outerType;
                    if (type) $071334078f8d3f8a$var$types[i] = $071334078f8d3f8a$var$types[$071334078f8d3f8a$var$BracketStack[sJ]] = type;
                    sI = sJ;
                    break;
                }
            } else if ($071334078f8d3f8a$var$BracketStack.length == 189 /* MaxDepth */ ) break;
            else {
                $071334078f8d3f8a$var$BracketStack[sI++] = i;
                $071334078f8d3f8a$var$BracketStack[sI++] = ch;
                $071334078f8d3f8a$var$BracketStack[sI++] = context;
            }
        } else if ((type = $071334078f8d3f8a$var$types[i]) == 2 /* R */  || type == 1 /* L */ ) {
            let embed = type == outerType;
            context = embed ? 0 : 1 /* OppositeBefore */ ;
            for(let sJ = sI - 3; sJ >= 0; sJ -= 3){
                let cur = $071334078f8d3f8a$var$BracketStack[sJ + 2];
                if (cur & 2 /* EmbedInside */ ) break;
                if (embed) $071334078f8d3f8a$var$BracketStack[sJ + 2] |= 2 /* EmbedInside */ ;
                else {
                    if (cur & 4 /* OppositeInside */ ) break;
                    $071334078f8d3f8a$var$BracketStack[sJ + 2] |= 4 /* OppositeInside */ ;
                }
            }
        }
    }
    // N1. A sequence of neutrals takes the direction of the
    // surrounding strong text if the text on both sides has the same
    // direction. European and Arabic numbers act as if they were R in
    // terms of their influence on neutrals. Start-of-level-run (sor)
    // and end-of-level-run (eor) are used at level run boundaries.
    // N2. Any remaining neutrals take the embedding direction.
    // (Left after this: L, R, EN+AN)
    for(let i = 0; i < len; i++)if ($071334078f8d3f8a$var$types[i] == 256 /* NI */ ) {
        let end = i + 1;
        while(end < len && $071334078f8d3f8a$var$types[end] == 256 /* NI */ )end++;
        let beforeL = (i ? $071334078f8d3f8a$var$types[i - 1] : outerType) == 1 /* L */ ;
        let afterL = (end < len ? $071334078f8d3f8a$var$types[end] : outerType) == 1 /* L */ ;
        let replace = beforeL == afterL ? beforeL ? 1 /* L */  : 2 /* R */  : outerType;
        for(let j = i; j < end; j++)$071334078f8d3f8a$var$types[j] = replace;
        i = end - 1;
    }
    // Here we depart from the documented algorithm, in order to avoid
    // building up an actual levels array. Since there are only three
    // levels (0, 1, 2) in an implementation that doesn't take
    // explicit embedding into account, we can build up the order on
    // the fly, without following the level-based algorithm.
    let order = [];
    if (outerType == 1 /* L */ ) for(let i = 0; i < len;){
        let start = i, rtl = $071334078f8d3f8a$var$types[i++] != 1 /* L */ ;
        while(i < len && rtl == ($071334078f8d3f8a$var$types[i] != 1 /* L */ ))i++;
        if (rtl) for(let j = i; j > start;){
            let end = j, l = $071334078f8d3f8a$var$types[--j] != 2 /* R */ ;
            while(j > start && l == ($071334078f8d3f8a$var$types[j - 1] != 2 /* R */ ))j--;
            order.push(new $071334078f8d3f8a$export$e1ed96b746bb516a(j, end, l ? 2 : 1));
        }
        else order.push(new $071334078f8d3f8a$export$e1ed96b746bb516a(start, i, 0));
    }
    else for(let i = 0; i < len;){
        let start = i, rtl = $071334078f8d3f8a$var$types[i++] == 2 /* R */ ;
        while(i < len && rtl == ($071334078f8d3f8a$var$types[i] == 2 /* R */ ))i++;
        order.push(new $071334078f8d3f8a$export$e1ed96b746bb516a(start, i, rtl ? 1 : 2));
    }
    return order;
}
function $071334078f8d3f8a$var$trivialOrder(length) {
    return [
        new $071334078f8d3f8a$export$e1ed96b746bb516a(0, length, 0)
    ];
}
let $071334078f8d3f8a$var$movedOver = "";
function $071334078f8d3f8a$var$moveVisually(line, order, dir, start, forward) {
    var _a;
    let startIndex = start.head - line.from, spanI = -1;
    if (startIndex == 0) {
        if (!forward || !line.length) return null;
        if (order[0].level != dir) {
            startIndex = order[0].side(false, dir);
            spanI = 0;
        }
    } else if (startIndex == line.length) {
        if (forward) return null;
        let last = order[order.length - 1];
        if (last.level != dir) {
            startIndex = last.side(true, dir);
            spanI = order.length - 1;
        }
    }
    if (spanI < 0) spanI = $071334078f8d3f8a$export$e1ed96b746bb516a.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    let span = order[spanI];
    // End of span. (But not end of line--that was checked for above.)
    if (startIndex == span.side(forward, dir)) {
        span = order[spanI += forward ? 1 : -1];
        startIndex = span.side(!forward, dir);
    }
    let indexForward = forward == (span.dir == dir);
    let nextIndex = (0, $hB7kI.findClusterBreak)(line.text, startIndex, indexForward);
    $071334078f8d3f8a$var$movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    if (nextIndex != span.side(forward, dir)) return (0, $hB7kI.EditorSelection).cursor(nextIndex + line.from, indexForward ? -1 : 1, span.level);
    let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (!nextSpan && span.level != dir) return (0, $hB7kI.EditorSelection).cursor(forward ? line.to : line.from, forward ? -1 : 1, dir);
    if (nextSpan && nextSpan.level < span.level) return (0, $hB7kI.EditorSelection).cursor(nextSpan.side(!forward, dir) + line.from, forward ? 1 : -1, nextSpan.level);
    return (0, $hB7kI.EditorSelection).cursor(nextIndex + line.from, forward ? -1 : 1, span.level);
}
class $071334078f8d3f8a$var$DocView extends $071334078f8d3f8a$var$ContentView {
    constructor(view){
        super();
        this.view = view;
        this.decorations = [];
        this.dynamicDecorationMap = [];
        this.hasComposition = null;
        this.markedForComposition = new Set;
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.setDOM(view.contentDOM);
        this.children = [
            new $071334078f8d3f8a$var$LineView
        ];
        this.children[0].setParent(this);
        this.updateDeco();
        this.updateInner([
            new $071334078f8d3f8a$var$ChangedRange(0, 0, 0, view.state.doc.length)
        ], 0, null);
    }
    get length() {
        return this.view.state.doc.length;
    }
    // Update the document view to a given state.
    update(update) {
        let changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every(({ fromA: fromA, toA: toA })=>toA < this.minWidthFrom || fromA > this.minWidthTo)) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        let composition = this.view.inputState.composing < 0 ? null : $071334078f8d3f8a$var$findCompositionRange(this.view, update.changes);
        if (this.hasComposition) {
            this.markedForComposition.clear();
            let { from: from, to: to } = this.hasComposition;
            changedRanges = new $071334078f8d3f8a$var$ChangedRange(from, to, update.changes.mapPos(from, -1), update.changes.mapPos(to, 1)).addToSet(changedRanges.slice());
        }
        this.hasComposition = composition ? {
            from: composition.range.fromB,
            to: composition.range.toB
        } : null;
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if (($071334078f8d3f8a$var$browser.ie || $071334078f8d3f8a$var$browser.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        let prevDeco = this.decorations, deco = this.updateDeco();
        let decoDiff = $071334078f8d3f8a$var$findChangedDeco(prevDeco, deco, update.changes);
        changedRanges = $071334078f8d3f8a$var$ChangedRange.extendWithRanges(changedRanges, decoDiff);
        if (!(this.flags & 7 /* Dirty */ ) && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, update.startState.doc.length, composition);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, oldLength, composition) {
        this.view.viewState.mustMeasureContent = true;
        this.updateChildren(changes, oldLength, composition);
        let { observer: observer } = this.view;
        observer.ignore(()=>{
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.dom.style.height = this.view.viewState.contentHeight + "px";
            this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            let track = $071334078f8d3f8a$var$browser.chrome || $071334078f8d3f8a$var$browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.sync(this.view, track);
            this.flags &= -8 /* Dirty */ ;
            if (track && (track.written || observer.selectionRange.focusNode != track.node)) this.forceSelection = true;
            this.dom.style.height = "";
        });
        this.markedForComposition.forEach((cView)=>cView.flags &= -9 /* Composition */ );
        let gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            for (let child of this.children)if (child instanceof $071334078f8d3f8a$var$BlockWidgetView && child.widget instanceof $071334078f8d3f8a$var$BlockGapWidget) gaps.push(child.dom);
        }
        observer.updateGaps(gaps);
    }
    updateChildren(changes, oldLength, composition) {
        let ranges = composition ? composition.range.addToSet(changes.slice()) : changes;
        let cursor = this.childCursor(oldLength);
        for(let i = ranges.length - 1;; i--){
            let next = i >= 0 ? ranges[i] : null;
            if (!next) break;
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = next, content, breakAtStart, openStart, openEnd;
            if (composition && composition.range.fromB < toB && composition.range.toB > fromB) {
                let before = $071334078f8d3f8a$var$ContentBuilder.build(this.view.state.doc, fromB, composition.range.fromB, this.decorations, this.dynamicDecorationMap);
                let after = $071334078f8d3f8a$var$ContentBuilder.build(this.view.state.doc, composition.range.toB, toB, this.decorations, this.dynamicDecorationMap);
                breakAtStart = before.breakAtStart;
                openStart = before.openStart;
                openEnd = after.openEnd;
                let compLine = this.compositionView(composition);
                if (after.breakAtStart) compLine.breakAfter = 1;
                else if (after.content.length && compLine.merge(compLine.length, compLine.length, after.content[0], false, after.openStart, 0)) {
                    compLine.breakAfter = after.content[0].breakAfter;
                    after.content.shift();
                }
                if (before.content.length && compLine.merge(0, 0, before.content[before.content.length - 1], true, 0, before.openEnd)) before.content.pop();
                content = before.content.concat(compLine).concat(after.content);
            } else ({ content: content, breakAtStart: breakAtStart, openStart: openStart, openEnd: openEnd } = $071334078f8d3f8a$var$ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap));
            let { i: toI, off: toOff } = cursor.findPos(toA, 1);
            let { i: fromI, off: fromOff } = cursor.findPos(fromA, -1);
            $071334078f8d3f8a$var$replaceRange(this, fromI, fromOff, toI, toOff, content, breakAtStart, openStart, openEnd);
        }
        if (composition) this.fixCompositionDOM(composition);
    }
    compositionView(composition) {
        let cur = new $071334078f8d3f8a$var$TextView(composition.text.nodeValue);
        cur.flags |= 8 /* Composition */ ;
        for (let { deco: deco } of composition.marks)cur = new $071334078f8d3f8a$var$MarkView(deco, [
            cur
        ], cur.length);
        let line = new $071334078f8d3f8a$var$LineView;
        line.append(cur, 0);
        return line;
    }
    fixCompositionDOM(composition) {
        let fix = (dom, cView)=>{
            cView.flags |= 8 /* Composition */ ;
            this.markedForComposition.add(cView);
            let prev = $071334078f8d3f8a$var$ContentView.get(dom);
            if (prev != cView) {
                if (prev) prev.dom = null;
                cView.setDOM(dom);
            }
        };
        let pos = this.childPos(composition.range.fromB, 1);
        let cView = this.children[pos.i];
        fix(composition.line, cView);
        for(let i = composition.marks.length - 1; i >= -1; i--){
            pos = cView.childPos(pos.off, 1);
            cView = cView.children[pos.i];
            fix(i >= 0 ? composition.marks[i].node : composition.text, cView);
        }
    }
    // Sync the DOM selection to this.state.selection
    updateSelection(mustRead = false, fromPointer = false) {
        if (mustRead || !this.view.observer.selectionRange.focusNode) this.view.observer.readSelectionRange();
        let activeElt = this.view.root.activeElement, focused = activeElt == this.dom;
        let selectionNotFocus = !focused && $071334078f8d3f8a$var$hasSelection(this.dom, this.view.observer.selectionRange) && !(activeElt && this.dom.contains(activeElt));
        if (!(focused || fromPointer || selectionNotFocus)) return;
        let force = this.forceSelection;
        this.forceSelection = false;
        let main = this.view.state.selection.main;
        // FIXME need to handle the case where the selection falls inside a block range
        let anchor = this.domAtPos(main.anchor);
        let head = main.empty ? anchor : this.domAtPos(main.head);
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if ($071334078f8d3f8a$var$browser.gecko && main.empty && !this.hasComposition && $071334078f8d3f8a$var$betweenUneditable(anchor)) {
            let dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new $071334078f8d3f8a$var$DOMPos(dummy, 0);
            force = true;
        }
        let domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || !$071334078f8d3f8a$var$isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !$071334078f8d3f8a$var$isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if ($071334078f8d3f8a$var$browser.android && $071334078f8d3f8a$var$browser.chrome && this.dom.contains(domSel.focusNode) && $071334078f8d3f8a$var$inUneditable(domSel.focusNode, this.dom)) {
                    this.dom.blur();
                    this.dom.focus({
                        preventScroll: true
                    });
                }
                let rawSel = $071334078f8d3f8a$var$getSelection(this.view.root);
                if (!rawSel) ;
                else if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if ($071334078f8d3f8a$var$browser.gecko) {
                        let nextTo = $071334078f8d3f8a$var$nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* After */ ) {
                            let text = $071334078f8d3f8a$var$nearbyTextNode(anchor.node, anchor.offset, nextTo == 1 /* Before */  ? 1 : -1);
                            if (text) anchor = new $071334078f8d3f8a$var$DOMPos(text, nextTo == 1 /* Before */  ? 0 : text.nodeValue.length);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && domSel.cursorBidiLevel != null) domSel.cursorBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    // Safari will ignore the call above when the editor is
                    // hidden, and then raise an error on the call to extend
                    // (#940).
                    try {
                        rawSel.extend(head.node, head.offset);
                    } catch (_) {}
                } else {
                    // Primitive (IE) way
                    let range = document.createRange();
                    if (main.anchor > main.head) [anchor, head] = [
                        head,
                        anchor
                    ];
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
                if (selectionNotFocus && this.view.root.activeElement == this.dom) {
                    this.dom.blur();
                    if (activeElt) activeElt.focus();
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new $071334078f8d3f8a$var$DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new $071334078f8d3f8a$var$DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    enforceCursorAssoc() {
        if (this.hasComposition) return;
        let { view: view } = this, cursor = view.state.selection.main;
        let sel = $071334078f8d3f8a$var$getSelection(view.root);
        let { anchorNode: anchorNode, anchorOffset: anchorOffset } = view.observer.selectionRange;
        if (!sel || !cursor.empty || !cursor.assoc || !sel.modify) return;
        let line = $071334078f8d3f8a$var$LineView.find(this, cursor.head);
        if (!line) return;
        let lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        let dom = this.domAtPos(cursor.head + cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
        // This can go wrong in corner cases like single-character lines,
        // so check and reset if necessary.
        view.observer.readSelectionRange();
        let newRange = view.observer.selectionRange;
        if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from) sel.collapse(anchorNode, anchorOffset);
    }
    nearest(dom) {
        for(let cur = dom; cur;){
            let domView = $071334078f8d3f8a$var$ContentView.get(cur);
            if (domView && domView.rootView == this) return domView;
            cur = cur.parentNode;
        }
        return null;
    }
    posFromDOM(node, offset) {
        let view = this.nearest(node);
        if (!view) throw new RangeError("Trying to find position for a DOM position outside of the document");
        return view.localPosFromDOM(node, offset) + view.posAtStart;
    }
    domAtPos(pos) {
        let { i: i, off: off } = this.childCursor().findPos(pos, -1);
        for(; i < this.children.length - 1;){
            let child = this.children[i];
            if (off < child.length || child instanceof $071334078f8d3f8a$var$LineView) break;
            i++;
            off = 0;
        }
        return this.children[i].domAtPos(off);
    }
    coordsAt(pos, side) {
        for(let off = this.length, i = this.children.length - 1;; i--){
            let child = this.children[i], start = off - child.breakAfter - child.length;
            if (pos > start || pos == start && child.type != $071334078f8d3f8a$export$48808c686fe495c4.WidgetBefore && child.type != $071334078f8d3f8a$export$48808c686fe495c4.WidgetAfter && (!i || side == 2 || this.children[i - 1].breakAfter || this.children[i - 1].type == $071334078f8d3f8a$export$48808c686fe495c4.WidgetBefore && side > -2)) return child.coordsAt(pos - start, side);
            off = start;
        }
    }
    coordsForChar(pos) {
        let { i: i, off: off } = this.childPos(pos, 1), child = this.children[i];
        if (!(child instanceof $071334078f8d3f8a$var$LineView)) return null;
        while(child.children.length){
            let { i: i, off: childOff } = child.childPos(off, 1);
            for(;; i++){
                if (i == child.children.length) return null;
                if ((child = child.children[i]).length) break;
            }
            off = childOff;
        }
        if (!(child instanceof $071334078f8d3f8a$var$TextView)) return null;
        let end = (0, $hB7kI.findClusterBreak)(child.text, off);
        if (end == off) return null;
        let rects = $071334078f8d3f8a$var$textRange(child.dom, off, end).getClientRects();
        return !rects.length || rects[0].top >= rects[0].bottom ? null : rects[0];
    }
    measureVisibleLineHeights(viewport) {
        let result = [], { from: from, to: to } = viewport;
        let contentWidth = this.view.contentDOM.clientWidth;
        let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        let widest = -1, ltr = this.view.textDirection == $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR;
        for(let pos = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (end > to) break;
            if (pos >= from) {
                let childRect = child.dom.getBoundingClientRect();
                result.push(childRect.height);
                if (isWider) {
                    let last = child.dom.lastChild;
                    let rects = last ? $071334078f8d3f8a$var$clientRectsFor(last) : [];
                    if (rects.length) {
                        let rect = rects[rects.length - 1];
                        let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                        if (width > widest) {
                            widest = width;
                            this.minWidth = contentWidth;
                            this.minWidthFrom = pos;
                            this.minWidthTo = end;
                        }
                    }
                }
            }
            pos = end + child.breakAfter;
        }
        return result;
    }
    textDirectionAt(pos) {
        let { i: i } = this.childPos(pos, 1);
        return getComputedStyle(this.children[i].dom).direction == "rtl" ? $071334078f8d3f8a$export$cacd6541cfeeb6c1.RTL : $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR;
    }
    measureTextSize() {
        for (let child of this.children)if (child instanceof $071334078f8d3f8a$var$LineView) {
            let measure = child.measureTextSize();
            if (measure) return measure;
        }
        // If no workable line exists, force a layout of a measurable element
        let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
        dummy.className = "cm-line";
        dummy.style.width = "99999px";
        dummy.style.position = "absolute";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.dom.appendChild(dummy);
            let rect = $071334078f8d3f8a$var$clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect ? rect.width / 27 : 7;
            textHeight = rect ? rect.height : lineHeight;
            dummy.remove();
        });
        return {
            lineHeight: lineHeight,
            charWidth: charWidth,
            textHeight: textHeight
        };
    }
    childCursor(pos = this.length) {
        // Move back to start of last element when possible, so that
        // `ChildCursor.findPos` doesn't have to deal with the edge case
        // of being after the last element.
        let i = this.children.length;
        if (i) pos -= this.children[--i].length;
        return new $071334078f8d3f8a$var$ChildCursor(this.children, pos, i);
    }
    computeBlockGapDeco() {
        let deco = [], vs = this.view.viewState;
        for(let pos = 0, i = 0;; i++){
            let next = i == vs.viewports.length ? null : vs.viewports[i];
            let end = next ? next.from - 1 : this.length;
            if (end > pos) {
                let height = vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top;
                deco.push($071334078f8d3f8a$export$10e30b733df217ea.replace({
                    widget: new $071334078f8d3f8a$var$BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return $071334078f8d3f8a$export$10e30b733df217ea.set(deco);
    }
    updateDeco() {
        let allDeco = this.view.state.facet($071334078f8d3f8a$var$decorations).map((d, i)=>{
            let dynamic = this.dynamicDecorationMap[i] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        for(let i = allDeco.length; i < allDeco.length + 3; i++)this.dynamicDecorationMap[i] = false;
        return this.decorations = [
            ...allDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
    }
    scrollIntoView(target) {
        let { range: range } = target;
        let rect = this.coordsAt(range.head, range.empty ? range.assoc : range.head > range.anchor ? -1 : 1), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        let margins = $071334078f8d3f8a$var$getScrollMargins(this.view);
        let targetRect = {
            left: rect.left - margins.left,
            top: rect.top - margins.top,
            right: rect.right + margins.right,
            bottom: rect.bottom + margins.bottom
        };
        $071334078f8d3f8a$var$scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, target.xMargin, target.yMargin, this.view.textDirection == $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR);
    }
}
function $071334078f8d3f8a$var$betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
class $071334078f8d3f8a$var$BlockGapWidget extends $071334078f8d3f8a$export$95cdd842edb044c5 {
    constructor(height){
        super();
        this.height = height;
    }
    toDOM() {
        let elt = document.createElement("div");
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
}
function $071334078f8d3f8a$var$findCompositionNode(view) {
    let sel = view.observer.selectionRange;
    let textNode = sel.focusNode && $071334078f8d3f8a$var$nearbyTextNode(sel.focusNode, sel.focusOffset, 0);
    if (!textNode) return null;
    let cView = $071334078f8d3f8a$var$ContentView.get(textNode);
    let from, to;
    if (cView instanceof $071334078f8d3f8a$var$TextView) {
        from = cView.posAtStart;
        to = from + cView.length;
    } else up: for(let offset = 0, node = textNode;;){
        for(let sibling = node.previousSibling, cView; sibling; sibling = sibling.previousSibling){
            if (cView = $071334078f8d3f8a$var$ContentView.get(sibling)) {
                from = to = cView.posAtEnd + offset;
                break up;
            }
            let reader = new $071334078f8d3f8a$var$DOMReader([], view.state);
            reader.readNode(sibling);
            if (reader.text.indexOf($071334078f8d3f8a$var$LineBreakPlaceholder) > -1) return null;
            offset += reader.text.length;
        }
        node = node.parentNode;
        if (!node) return null;
        let parentView = $071334078f8d3f8a$var$ContentView.get(node);
        if (parentView) {
            from = to = parentView.posAtStart + offset;
            break;
        }
    }
    return {
        from: from,
        to: to,
        node: textNode
    };
}
function $071334078f8d3f8a$var$findCompositionRange(view, changes) {
    let found = $071334078f8d3f8a$var$findCompositionNode(view);
    if (!found) return null;
    let { from: fromA, to: toA, node: textNode } = found;
    let fromB = changes.mapPos(fromA, -1), toB = changes.mapPos(toA, 1);
    let text = textNode.nodeValue;
    // Don't try to preserve multi-line compositions
    if (/[\n\r]/.test(text)) return null;
    if (toB - fromB != text.length) {
        // If there is a length mismatch, see if mapping non-inclusively helps
        let fromB2 = changes.mapPos(fromA, 1), toB2 = changes.mapPos(toA, -1);
        if (toB2 - fromB2 == text.length) fromB = fromB2, toB = toB2;
        else if (view.state.doc.sliceString(toB - text.length, toB) == text) fromB = toB - text.length;
        else if (view.state.doc.sliceString(fromB, fromB + text.length) == text) toB = fromB + text.length;
        else return null;
    }
    let { main: main } = view.state.selection;
    if (view.state.doc.sliceString(fromB, toB) != text || fromB > main.head || toB < main.head) return null;
    let marks = [];
    let range = new $071334078f8d3f8a$var$ChangedRange(fromA, toA, fromB, toB);
    for(let parent = textNode.parentNode;; parent = parent.parentNode){
        let parentView = $071334078f8d3f8a$var$ContentView.get(parent);
        if (parentView instanceof $071334078f8d3f8a$var$MarkView) marks.push({
            node: parent,
            deco: parentView.mark
        });
        else if (parentView instanceof $071334078f8d3f8a$var$LineView || parent.nodeName == "DIV" && parent.parentNode == view.contentDOM) return {
            range: range,
            text: textNode,
            marks: marks,
            line: parent
        };
        else if (parent != view.contentDOM) marks.push({
            node: parent,
            deco: new $071334078f8d3f8a$var$MarkDecoration({
                inclusive: true,
                attributes: $071334078f8d3f8a$var$getAttrs(parent),
                tagName: parent.tagName.toLowerCase()
            })
        });
        else return null;
    }
}
function $071334078f8d3f8a$var$nearbyTextNode(startNode, startOffset, side) {
    if (side <= 0) for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3) return node;
        if (node.nodeType == 1 && offset > 0) {
            node = node.childNodes[offset - 1];
            offset = $071334078f8d3f8a$var$maxOffset(node);
        } else break;
    }
    if (side >= 0) for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length && side >= 0) {
            node = node.childNodes[offset];
            offset = 0;
        } else break;
    }
    return null;
}
function $071334078f8d3f8a$var$nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* After */  : 0);
}
class $071334078f8d3f8a$var$DecorationComparator$1 {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $071334078f8d3f8a$var$addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        $071334078f8d3f8a$var$addRange(from, to, this.changes);
    }
}
function $071334078f8d3f8a$var$findChangedDeco(a, b, diff) {
    let comp = new $071334078f8d3f8a$var$DecorationComparator$1;
    (0, $hB7kI.RangeSet).compare(a, b, diff, comp);
    return comp.changes;
}
function $071334078f8d3f8a$var$inUneditable(node, inside) {
    for(let cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == "false") return true;
    }
    return false;
}
function $071334078f8d3f8a$var$groupAt(state, pos, bias = 1) {
    let categorize = state.charCategorizer(pos);
    let line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, $hB7kI.EditorSelection).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    let from = linePos, to = linePos;
    if (bias < 0) from = (0, $hB7kI.findClusterBreak)(line.text, linePos, false);
    else to = (0, $hB7kI.findClusterBreak)(line.text, linePos);
    let cat = categorize(line.text.slice(from, to));
    while(from > 0){
        let prev = (0, $hB7kI.findClusterBreak)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        let next = (0, $hB7kI.findClusterBreak)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, $hB7kI.EditorSelection).range(from + line.from, to + line.from);
}
// Search the DOM for the {node, offset} position closest to the given
// coordinates. Very inefficient and crude, but can usually be avoided
// by calling caret(Position|Range)FromPoint instead.
function $071334078f8d3f8a$var$getdx(x, rect) {
    return rect.left > x ? rect.left - x : Math.max(0, x - rect.right);
}
function $071334078f8d3f8a$var$getdy(y, rect) {
    return rect.top > y ? rect.top - y : Math.max(0, y - rect.bottom);
}
function $071334078f8d3f8a$var$yOverlap(a, b) {
    return a.top < b.bottom - 1 && a.bottom > b.top + 1;
}
function $071334078f8d3f8a$var$upTop(rect, top) {
    return top < rect.top ? {
        top: top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom
    } : rect;
}
function $071334078f8d3f8a$var$upBot(rect, bottom) {
    return bottom > rect.bottom ? {
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: bottom
    } : rect;
}
function $071334078f8d3f8a$var$domPosAtCoords(parent, x, y) {
    let closest, closestRect, closestX, closestY, closestOverlap = false;
    let above, below, aboveRect, belowRect;
    for(let child = parent.firstChild; child; child = child.nextSibling){
        let rects = $071334078f8d3f8a$var$clientRectsFor(child);
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (closestRect && $071334078f8d3f8a$var$yOverlap(closestRect, rect)) rect = $071334078f8d3f8a$var$upTop($071334078f8d3f8a$var$upBot(rect, closestRect.bottom), closestRect.top);
            let dx = $071334078f8d3f8a$var$getdx(x, rect), dy = $071334078f8d3f8a$var$getdy(y, rect);
            if (dx == 0 && dy == 0) return child.nodeType == 3 ? $071334078f8d3f8a$var$domPosInText(child, x, y) : $071334078f8d3f8a$var$domPosAtCoords(child, x, y);
            if (!closest || closestY > dy || closestY == dy && closestX > dx) {
                closest = child;
                closestRect = rect;
                closestX = dx;
                closestY = dy;
                let side = dy ? y < rect.top ? -1 : 1 : dx ? x < rect.left ? -1 : 1 : 0;
                closestOverlap = !side || (side > 0 ? i < rects.length - 1 : i > 0);
            }
            if (dx == 0) {
                if (y > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
                    above = child;
                    aboveRect = rect;
                } else if (y < rect.top && (!belowRect || belowRect.top > rect.top)) {
                    below = child;
                    belowRect = rect;
                }
            } else if (aboveRect && $071334078f8d3f8a$var$yOverlap(aboveRect, rect)) aboveRect = $071334078f8d3f8a$var$upBot(aboveRect, rect.bottom);
            else if (belowRect && $071334078f8d3f8a$var$yOverlap(belowRect, rect)) belowRect = $071334078f8d3f8a$var$upTop(belowRect, rect.top);
        }
    }
    if (aboveRect && aboveRect.bottom >= y) {
        closest = above;
        closestRect = aboveRect;
    } else if (belowRect && belowRect.top <= y) {
        closest = below;
        closestRect = belowRect;
    }
    if (!closest) return {
        node: parent,
        offset: 0
    };
    let clipX = Math.max(closestRect.left, Math.min(closestRect.right, x));
    if (closest.nodeType == 3) return $071334078f8d3f8a$var$domPosInText(closest, clipX, y);
    if (closestOverlap && closest.contentEditable != "false") return $071334078f8d3f8a$var$domPosAtCoords(closest, clipX, y);
    let offset = Array.prototype.indexOf.call(parent.childNodes, closest) + (x >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
    return {
        node: parent,
        offset: offset
    };
}
function $071334078f8d3f8a$var$domPosInText(node, x, y) {
    let len = node.nodeValue.length;
    let closestOffset = -1, closestDY = 1e9, generalSide = 0;
    for(let i = 0; i < len; i++){
        let rects = $071334078f8d3f8a$var$textRange(node, i, i + 1).getClientRects();
        for(let j = 0; j < rects.length; j++){
            let rect = rects[j];
            if (rect.top == rect.bottom) continue;
            if (!generalSide) generalSide = x - rect.left;
            let dy = (rect.top > y ? rect.top - y : y - rect.bottom) - 1;
            if (rect.left - 1 <= x && rect.right + 1 >= x && dy < closestDY) {
                let right = x >= (rect.left + rect.right) / 2, after = right;
                if ($071334078f8d3f8a$var$browser.chrome || $071334078f8d3f8a$var$browser.gecko) {
                    // Check for RTL on browsers that support getting client
                    // rects for empty ranges.
                    let rectBefore = $071334078f8d3f8a$var$textRange(node, i).getBoundingClientRect();
                    if (rectBefore.left == rect.right) after = !right;
                }
                if (dy <= 0) return {
                    node: node,
                    offset: i + (after ? 1 : 0)
                };
                closestOffset = i + (after ? 1 : 0);
                closestDY = dy;
            }
        }
    }
    return {
        node: node,
        offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node.nodeValue.length : 0
    };
}
function $071334078f8d3f8a$var$posAtCoords(view, coords, precise, bias = -1) {
    var _a, _b;
    let content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    let block, { docHeight: docHeight } = view.viewState;
    let { x: x, y: y } = coords, yOffset = y - docTop;
    if (yOffset < 0) return 0;
    if (yOffset > docHeight) return view.state.doc.length;
    // Scan for a text block near the queried y position
    for(let halfLine = view.viewState.heightOracle.textHeight / 2, bounced = false;;){
        block = view.elementAtHeight(yOffset);
        if (block.type == $071334078f8d3f8a$export$48808c686fe495c4.Text) break;
        for(;;){
            // Move the y position out of this block
            yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
            if (yOffset >= 0 && yOffset <= docHeight) break;
            // If the document consists entirely of replaced widgets, we
            // won't find a text block, so return 0
            if (bounced) return precise ? null : 0;
            bounced = true;
            bias = -bias;
        }
    }
    y = docTop + yOffset;
    let lineStart = block.from;
    // If this is outside of the rendered viewport, we can't determine a position
    if (lineStart < view.viewport.from) return view.viewport.from == 0 ? 0 : precise ? null : $071334078f8d3f8a$var$posAtCoordsImprecise(view, content, block, x, y);
    if (lineStart > view.viewport.to) return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : $071334078f8d3f8a$var$posAtCoordsImprecise(view, content, block, x, y);
    // Prefer ShadowRootOrDocument.elementFromPoint if present, fall back to document if not
    let doc = view.dom.ownerDocument;
    let root = view.root.elementFromPoint ? view.root : doc;
    let element = root.elementFromPoint(x, y);
    if (element && !view.contentDOM.contains(element)) element = null;
    // If the element is unexpected, clip x at the sides of the content area and try again
    if (!element) {
        x = Math.max(content.left + 1, Math.min(content.right - 1, x));
        element = root.elementFromPoint(x, y);
        if (element && !view.contentDOM.contains(element)) element = null;
    }
    // There's visible editor content under the point, so we can try
    // using caret(Position|Range)FromPoint as a shortcut
    let node, offset = -1;
    if (element && ((_a = view.docView.nearest(element)) === null || _a === void 0 ? void 0 : _a.isEditable) != false) {
        if (doc.caretPositionFromPoint) {
            let pos = doc.caretPositionFromPoint(x, y);
            if (pos) ({ offsetNode: node, offset: offset } = pos);
        } else if (doc.caretRangeFromPoint) {
            let range = doc.caretRangeFromPoint(x, y);
            if (range) {
                ({ startContainer: node, startOffset: offset } = range);
                if (!view.contentDOM.contains(node) || $071334078f8d3f8a$var$browser.safari && $071334078f8d3f8a$var$isSuspiciousSafariCaretResult(node, offset, x) || $071334078f8d3f8a$var$browser.chrome && $071334078f8d3f8a$var$isSuspiciousChromeCaretResult(node, offset, x)) node = undefined;
            }
        }
    }
    // No luck, do our own (potentially expensive) search
    if (!node || !view.docView.dom.contains(node)) {
        let line = $071334078f8d3f8a$var$LineView.find(view.docView, lineStart);
        if (!line) return yOffset > block.top + block.height / 2 ? block.to : block.from;
        ({ node: node, offset: offset } = $071334078f8d3f8a$var$domPosAtCoords(line.dom, x, y));
    }
    let nearest = view.docView.nearest(node);
    if (!nearest) return null;
    if (nearest.isWidget && ((_b = nearest.dom) === null || _b === void 0 ? void 0 : _b.nodeType) == 1) {
        let rect = nearest.dom.getBoundingClientRect();
        return coords.y < rect.top || coords.y <= rect.bottom && coords.x <= (rect.left + rect.right) / 2 ? nearest.posAtStart : nearest.posAtEnd;
    } else return nearest.localPosFromDOM(node, offset) + nearest.posAtStart;
}
function $071334078f8d3f8a$var$posAtCoordsImprecise(view, contentRect, block, x, y) {
    let into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        let textHeight = view.viewState.heightOracle.textHeight;
        let line = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    let content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, $hB7kI.findColumn)(content, into, view.state.tabSize);
}
// In case of a high line height, Safari's caretRangeFromPoint treats
// the space between lines as belonging to the last character of the
// line before. This is used to detect such a result so that it can be
// ignored (issue #401).
function $071334078f8d3f8a$var$isSuspiciousSafariCaretResult(node, offset, x) {
    let len;
    if (node.nodeType != 3 || offset != (len = node.nodeValue.length)) return false;
    for(let next = node.nextSibling; next; next = next.nextSibling)if (next.nodeType != 1 || next.nodeName != "BR") return false;
    return $071334078f8d3f8a$var$textRange(node, len - 1, len).getBoundingClientRect().left > x;
}
// Chrome will move positions between lines to the start of the next line
function $071334078f8d3f8a$var$isSuspiciousChromeCaretResult(node, offset, x) {
    if (offset != 0) return false;
    for(let cur = node;;){
        let parent = cur.parentNode;
        if (!parent || parent.nodeType != 1 || parent.firstChild != cur) return false;
        if (parent.classList.contains("cm-line")) break;
        cur = parent;
    }
    let rect = node.nodeType == 1 ? node.getBoundingClientRect() : $071334078f8d3f8a$var$textRange(node, 0, Math.max(node.nodeValue.length, 1)).getBoundingClientRect();
    return x - rect.left > 5;
}
function $071334078f8d3f8a$var$blockAt(view, pos) {
    let line = view.lineBlockAt(pos);
    if (Array.isArray(line.type)) for (let l of line.type){
        if (l.to > pos || l.to == pos && (l.to == line.to || l.type == $071334078f8d3f8a$export$48808c686fe495c4.Text)) return l;
    }
    return line;
}
function $071334078f8d3f8a$var$moveToLineBoundary(view, start, forward, includeWrap) {
    let line = $071334078f8d3f8a$var$blockAt(view, start.head);
    let coords = !includeWrap || line.type != $071334078f8d3f8a$export$48808c686fe495c4.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        let editorRect = view.dom.getBoundingClientRect();
        let direction = view.textDirectionAt(line.from);
        let pos = view.posAtCoords({
            x: forward == (direction == $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, $hB7kI.EditorSelection).cursor(pos, forward ? -1 : 1);
    }
    return (0, $hB7kI.EditorSelection).cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function $071334078f8d3f8a$var$moveByChar(view, start, forward, by) {
    let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    let direction = view.textDirectionAt(line.from);
    for(let cur = start, check = null;;){
        let next = $071334078f8d3f8a$var$moveVisually(line, spans, direction, cur, forward), char = $071334078f8d3f8a$var$movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = (0, $hB7kI.EditorSelection).cursor(forward ? line.from : line.to);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function $071334078f8d3f8a$var$byGroup(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start);
    return (next)=>{
        let nextCat = categorize(next);
        if (cat == (0, $hB7kI.CharCategory).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function $071334078f8d3f8a$var$moveVertically(view, start, forward, distance) {
    let startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, $hB7kI.EditorSelection).cursor(startPos, start.assoc);
    let goal = start.goalColumn, startY;
    let rect = view.contentDOM.getBoundingClientRect();
    let startCoords = view.coordsAtPos(startPos), docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        let line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    let resolvedGoal = rect.left + goal;
    let dist = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
    for(let extra = 0;; extra += 10){
        let curY = startY + (dist + extra) * dir;
        let pos = $071334078f8d3f8a$var$posAtCoords(view, {
            x: resolvedGoal,
            y: curY
        }, false, dir);
        if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos)) return (0, $hB7kI.EditorSelection).cursor(pos, start.assoc, undefined, goal);
    }
}
function $071334078f8d3f8a$var$skipAtomicRanges(atoms, pos, bias) {
    for(;;){
        let moved = 0;
        for (let set of atoms)set.between(pos - 1, pos + 1, (from, to, value)=>{
            if (pos > from && pos < to) {
                let side = moved || bias || (pos - from < to - pos ? -1 : 1);
                pos = side < 0 ? from : to;
                moved = side;
            }
        });
        if (!moved) return pos;
    }
}
function $071334078f8d3f8a$var$skipAtoms(view, oldPos, pos) {
    let newPos = $071334078f8d3f8a$var$skipAtomicRanges(view.state.facet($071334078f8d3f8a$var$atomicRanges).map((f)=>f(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
    return newPos == pos.from ? pos : (0, $hB7kI.EditorSelection).cursor(newPos, newPos < pos.from ? 1 : -1);
}
// This will also be where dragging info and such goes
class $071334078f8d3f8a$var$InputState {
    constructor(view){
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.lastTouchTime = 0;
        this.lastFocusTime = 0;
        this.lastScrollTop = 0;
        this.lastScrollLeft = 0;
        this.chromeScrollHack = -1;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastEscPress = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.registeredEvents = [];
        this.customHandlers = [];
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        // End time of the previous composition
        this.compositionEndedAt = 0;
        // Used in a kludge to detect when an Enter keypress should be
        // considered part of the composition on Safari, which fires events
        // in the wrong order
        this.compositionPendingKey = false;
        // Used to categorize changes as part of a composition, even when
        // the mutation events fire shortly after the compositionend event
        this.compositionPendingChange = false;
        this.mouseSelection = null;
        let handleEvent = (handler, event)=>{
            if (this.ignoreDuringComposition(event)) return;
            if (event.type == "keydown" && this.keydown(view, event)) return;
            if (this.mustFlushObserver(event)) view.observer.forceFlush();
            if (this.runCustomHandlers(event.type, view, event)) event.preventDefault();
            else handler(view, event);
        };
        for(let type in $071334078f8d3f8a$var$handlers){
            let handler = $071334078f8d3f8a$var$handlers[type];
            view.contentDOM.addEventListener(type, (event)=>{
                if ($071334078f8d3f8a$var$eventBelongsToEditor(view, event)) handleEvent(handler, event);
            }, $071334078f8d3f8a$var$handlerOptions[type]);
            this.registeredEvents.push(type);
        }
        view.scrollDOM.addEventListener("mousedown", (event)=>{
            if (event.target == view.scrollDOM && event.clientY > view.contentDOM.getBoundingClientRect().bottom) {
                handleEvent($071334078f8d3f8a$var$handlers.mousedown, event);
                if (!event.defaultPrevented && event.button == 2) {
                    // Make sure the content covers the entire scroller height, in order
                    // to catch a native context menu click below it
                    let start = view.contentDOM.style.minHeight;
                    view.contentDOM.style.minHeight = "100%";
                    setTimeout(()=>view.contentDOM.style.minHeight = start, 200);
                }
            }
        });
        view.scrollDOM.addEventListener("drop", (event)=>{
            if (event.target == view.scrollDOM && event.clientY > view.contentDOM.getBoundingClientRect().bottom) handleEvent($071334078f8d3f8a$var$handlers.drop, event);
        });
        if ($071334078f8d3f8a$var$browser.chrome && $071334078f8d3f8a$var$browser.chrome_version == 102) // On Chrome 102, viewport updates somehow stop wheel-based
        // scrolling. Turning off pointer events during the scroll seems
        // to avoid the issue.
        view.scrollDOM.addEventListener("wheel", ()=>{
            if (this.chromeScrollHack < 0) view.contentDOM.style.pointerEvents = "none";
            else window.clearTimeout(this.chromeScrollHack);
            this.chromeScrollHack = setTimeout(()=>{
                this.chromeScrollHack = -1;
                view.contentDOM.style.pointerEvents = "";
            }, 100);
        }, {
            passive: true
        });
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if ($071334078f8d3f8a$var$browser.safari) view.contentDOM.addEventListener("input", ()=>null);
    }
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    ensureHandlers(view, plugins) {
        var _a;
        let handlers;
        this.customHandlers = [];
        for (let plugin of plugins)if (handlers = (_a = plugin.update(view).spec) === null || _a === void 0 ? void 0 : _a.domEventHandlers) {
            this.customHandlers.push({
                plugin: plugin.value,
                handlers: handlers
            });
            for(let type in handlers)if (this.registeredEvents.indexOf(type) < 0 && type != "scroll") {
                this.registeredEvents.push(type);
                view.contentDOM.addEventListener(type, (event)=>{
                    if (!$071334078f8d3f8a$var$eventBelongsToEditor(view, event)) return;
                    if (this.runCustomHandlers(type, view, event)) event.preventDefault();
                });
            }
        }
    }
    runCustomHandlers(type, view, event) {
        for (let set of this.customHandlers){
            let handler = set.handlers[type];
            if (handler) try {
                if (handler.call(set.plugin, event, view) || event.defaultPrevented) return true;
            } catch (e) {
                $071334078f8d3f8a$export$f86b2a1a2ce291b3(view.state, e);
            }
        }
        return false;
    }
    runScrollHandlers(view, event) {
        this.lastScrollTop = view.scrollDOM.scrollTop;
        this.lastScrollLeft = view.scrollDOM.scrollLeft;
        for (let set of this.customHandlers){
            let handler = set.handlers.scroll;
            if (handler) try {
                handler.call(set.plugin, event, view);
            } catch (e) {
                $071334078f8d3f8a$export$f86b2a1a2ce291b3(view.state, e);
            }
        }
    }
    keydown(view, event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && Date.now() < this.lastEscPress + 2000) return true;
        if (event.keyCode != 27 && $071334078f8d3f8a$var$modifierCodes.indexOf(event.keyCode) < 0) view.inputState.lastEscPress = 0;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if ($071334078f8d3f8a$var$browser.android && $071334078f8d3f8a$var$browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Prevent the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        let pending;
        if ($071334078f8d3f8a$var$browser.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = $071334078f8d3f8a$var$PendingKeys.find((key)=>key.keyCode == event.keyCode)) && !event.ctrlKey || $071334078f8d3f8a$var$EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
            this.pendingIOSKey = pending || event;
            setTimeout(()=>this.flushIOSKey(view), 250);
            return true;
        }
        return false;
    }
    flushIOSKey(view) {
        let key = this.pendingIOSKey;
        if (!key) return false;
        this.pendingIOSKey = undefined;
        return $071334078f8d3f8a$var$dispatchKey(view.contentDOM, key.key, key.keyCode);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type)) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if ($071334078f8d3f8a$var$browser.safari && !$071334078f8d3f8a$var$browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
            this.compositionPendingKey = false;
            return true;
        }
        return false;
    }
    mustFlushObserver(event) {
        return event.type == "keydown" && event.keyCode != 229;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
}
const $071334078f8d3f8a$var$PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertLineBreak"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
const $071334078f8d3f8a$var$EmacsyPendingKeys = "dthko";
// Key codes for modifier keys
const $071334078f8d3f8a$var$modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
const $071334078f8d3f8a$var$dragScrollMargin = 6;
function $071334078f8d3f8a$var$dragScrollSpeed(dist) {
    return Math.max(0, dist) * 0.7 + 8;
}
function $071334078f8d3f8a$var$dist(a, b) {
    return Math.max(Math.abs(a.clientX - b.clientX), Math.abs(a.clientY - b.clientY));
}
class $071334078f8d3f8a$var$MouseSelection {
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.startEvent = startEvent;
        this.style = style;
        this.mustSelect = mustSelect;
        this.scrollSpeed = {
            x: 0,
            y: 0
        };
        this.scrolling = -1;
        this.lastEvent = startEvent;
        this.scrollParent = $071334078f8d3f8a$var$scrollableParent(view.contentDOM);
        this.atoms = view.state.facet($071334078f8d3f8a$var$atomicRanges).map((f)=>f(view));
        let doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, $hB7kI.EditorState).allowMultipleSelections) && $071334078f8d3f8a$var$addsSelectionRange(view, startEvent);
        this.dragging = $071334078f8d3f8a$var$isInPrimarySelection(view, startEvent) && $071334078f8d3f8a$var$getClickType(startEvent) == 1 ? null : false;
    }
    start(event) {
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) {
            event.preventDefault();
            this.select(event);
        }
    }
    move(event) {
        var _a;
        if (event.buttons == 0) return this.destroy();
        if (this.dragging || this.dragging == null && $071334078f8d3f8a$var$dist(this.startEvent, event) < 10) return;
        this.select(this.lastEvent = event);
        let sx = 0, sy = 0;
        let rect = ((_a = this.scrollParent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {
            left: 0,
            top: 0,
            right: this.view.win.innerWidth,
            bottom: this.view.win.innerHeight
        };
        let margins = $071334078f8d3f8a$var$getScrollMargins(this.view);
        if (event.clientX - margins.left <= rect.left + $071334078f8d3f8a$var$dragScrollMargin) sx = -$071334078f8d3f8a$var$dragScrollSpeed(rect.left - event.clientX);
        else if (event.clientX + margins.right >= rect.right - $071334078f8d3f8a$var$dragScrollMargin) sx = $071334078f8d3f8a$var$dragScrollSpeed(event.clientX - rect.right);
        if (event.clientY - margins.top <= rect.top + $071334078f8d3f8a$var$dragScrollMargin) sy = -$071334078f8d3f8a$var$dragScrollSpeed(rect.top - event.clientY);
        else if (event.clientY + margins.bottom >= rect.bottom - $071334078f8d3f8a$var$dragScrollMargin) sy = $071334078f8d3f8a$var$dragScrollSpeed(event.clientY - rect.bottom);
        this.setScrollSpeed(sx, sy);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        this.setScrollSpeed(0, 0);
        let doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = null;
    }
    setScrollSpeed(sx, sy) {
        this.scrollSpeed = {
            x: sx,
            y: sy
        };
        if (sx || sy) {
            if (this.scrolling < 0) this.scrolling = setInterval(()=>this.scroll(), 50);
        } else if (this.scrolling > -1) {
            clearInterval(this.scrolling);
            this.scrolling = -1;
        }
    }
    scroll() {
        if (this.scrollParent) {
            this.scrollParent.scrollLeft += this.scrollSpeed.x;
            this.scrollParent.scrollTop += this.scrollSpeed.y;
        } else this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y);
        if (this.dragging === false) this.select(this.lastEvent);
    }
    skipAtoms(sel) {
        let ranges = null;
        for(let i = 0; i < sel.ranges.length; i++){
            let range = sel.ranges[i], updated = null;
            if (range.empty) {
                let pos = $071334078f8d3f8a$var$skipAtomicRanges(this.atoms, range.from, 0);
                if (pos != range.from) updated = (0, $hB7kI.EditorSelection).cursor(pos, -1);
            } else {
                let from = $071334078f8d3f8a$var$skipAtomicRanges(this.atoms, range.from, -1);
                let to = $071334078f8d3f8a$var$skipAtomicRanges(this.atoms, range.to, 1);
                if (from != range.from || to != range.to) updated = (0, $hB7kI.EditorSelection).range(range.from == range.anchor ? from : to, range.from == range.head ? from : to);
            }
            if (updated) {
                if (!ranges) ranges = sel.ranges.slice();
                ranges[i] = updated;
            }
        }
        return ranges ? (0, $hB7kI.EditorSelection).create(ranges, sel.mainIndex) : sel;
    }
    select(event) {
        let { view: view } = this, selection = this.skipAtoms(this.style.get(event, this.extend, this.multiple));
        if (this.mustSelect || !selection.eq(view.state.selection) || selection.main.assoc != view.state.selection.main.assoc && this.dragging === false) this.view.dispatch({
            selection: selection,
            userEvent: "select.pointer"
        });
        this.mustSelect = false;
    }
    update(update) {
        if (update.docChanged && this.dragging) this.dragging = this.dragging.map(update.changes);
        if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
}
function $071334078f8d3f8a$var$addsSelectionRange(view, event) {
    let facet = view.state.facet($071334078f8d3f8a$var$clickAddsSelectionRange);
    return facet.length ? facet[0](event) : $071334078f8d3f8a$var$browser.mac ? event.metaKey : event.ctrlKey;
}
function $071334078f8d3f8a$var$dragMovesSelection(view, event) {
    let facet = view.state.facet($071334078f8d3f8a$var$dragMovesSelection$1);
    return facet.length ? facet[0](event) : $071334078f8d3f8a$var$browser.mac ? !event.altKey : !event.ctrlKey;
}
function $071334078f8d3f8a$var$isInPrimarySelection(view, event) {
    let { main: main } = view.state.selection;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    let sel = $071334078f8d3f8a$var$getSelection(view.root);
    if (!sel || sel.rangeCount == 0) return true;
    let rects = sel.getRangeAt(0).getClientRects();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function $071334078f8d3f8a$var$eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target, cView; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (cView = $071334078f8d3f8a$var$ContentView.get(node)) && cView.ignoreEvent(event)) return false;
    return true;
}
const $071334078f8d3f8a$var$handlers = /*@__PURE__*/ Object.create(null);
const $071334078f8d3f8a$var$handlerOptions = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $071334078f8d3f8a$var$brokenClipboardAPI = $071334078f8d3f8a$var$browser.ie && $071334078f8d3f8a$var$browser.ie_version < 15 || $071334078f8d3f8a$var$browser.ios && $071334078f8d3f8a$var$browser.webkit_version < 604;
function $071334078f8d3f8a$var$capturePaste(view) {
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        $071334078f8d3f8a$var$doPaste(view, target.value);
    }, 50);
}
function $071334078f8d3f8a$var$doPaste(view, input) {
    let { state: state } = view, changes, i = 1, text = state.toText(input);
    let byLine = text.lines == state.selection.ranges.length;
    let linewise = $071334078f8d3f8a$var$lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && $071334078f8d3f8a$var$lastLinewiseCopy == text.toString();
    if (linewise) {
        let lastLine = -1;
        changes = state.changeByRange((range)=>{
            let line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range: range
            };
            lastLine = line.from;
            let insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert: insert
                },
                range: (0, $hB7kI.EditorSelection).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        let line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, $hB7kI.EditorSelection).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
$071334078f8d3f8a$var$handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27) view.inputState.lastEscPress = Date.now();
};
$071334078f8d3f8a$var$handlers.touchstart = (view, e)=>{
    view.inputState.lastTouchTime = Date.now();
    view.inputState.setSelectionOrigin("select.pointer");
};
$071334078f8d3f8a$var$handlers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
$071334078f8d3f8a$var$handlerOptions.touchstart = $071334078f8d3f8a$var$handlerOptions.touchmove = {
    passive: true
};
$071334078f8d3f8a$var$handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if (view.inputState.lastTouchTime > Date.now() - 2000) return; // Ignore touch interaction
    let style = null;
    for (let makeStyle of view.state.facet($071334078f8d3f8a$var$mouseSelectionStyle)){
        style = makeStyle(view, event);
        if (style) break;
    }
    if (!style && event.button == 0) style = $071334078f8d3f8a$var$basicMouseSelection(view, event);
    if (style) {
        let mustFocus = !view.hasFocus;
        view.inputState.startMouseSelection(new $071334078f8d3f8a$var$MouseSelection(view, event, style, mustFocus));
        if (mustFocus) view.observer.ignore(()=>$071334078f8d3f8a$var$focusPreventScroll(view.contentDOM));
        if (view.inputState.mouseSelection) view.inputState.mouseSelection.start(event);
    }
};
function $071334078f8d3f8a$var$rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, $hB7kI.EditorSelection).cursor(pos, bias);
    else if (type == 2) return $071334078f8d3f8a$var$groupAt(view.state, pos, bias);
    else {
        let visual = $071334078f8d3f8a$var$LineView.find(view.docView, pos), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        let from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, $hB7kI.EditorSelection).range(from, to);
    }
}
let $071334078f8d3f8a$var$insideY = (y, rect)=>y >= rect.top && y <= rect.bottom;
let $071334078f8d3f8a$var$inside = (x, y, rect)=>$071334078f8d3f8a$var$insideY(y, rect) && x >= rect.left && x <= rect.right;
// Try to determine, for the given coordinates, associated with the
// given position, whether they are related to the element before or
// the element after the position.
function $071334078f8d3f8a$var$findPositionSide(view, pos, x, y) {
    let line = $071334078f8d3f8a$var$LineView.find(view.docView, pos);
    if (!line) return 1;
    let off = pos - line.posAtStart;
    // Line boundaries point into the line
    if (off == 0) return 1;
    if (off == line.length) return -1;
    // Positions on top of an element point at that element
    let before = line.coordsAt(off, -1);
    if (before && $071334078f8d3f8a$var$inside(x, y, before)) return -1;
    let after = line.coordsAt(off, 1);
    if (after && $071334078f8d3f8a$var$inside(x, y, after)) return 1;
    // This is probably a line wrap point. Pick before if the point is
    // beside it.
    return before && $071334078f8d3f8a$var$insideY(y, before) ? -1 : 1;
}
function $071334078f8d3f8a$var$queryPos(view, event) {
    let pos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    return {
        pos: pos,
        bias: $071334078f8d3f8a$var$findPositionSide(view, pos, event.clientX, event.clientY)
    };
}
const $071334078f8d3f8a$var$BadMouseDetail = $071334078f8d3f8a$var$browser.ie && $071334078f8d3f8a$var$browser.ie_version <= 11;
let $071334078f8d3f8a$var$lastMouseDown = null, $071334078f8d3f8a$var$lastMouseDownCount = 0, $071334078f8d3f8a$var$lastMouseDownTime = 0;
function $071334078f8d3f8a$var$getClickType(event) {
    if (!$071334078f8d3f8a$var$BadMouseDetail) return event.detail;
    let last = $071334078f8d3f8a$var$lastMouseDown, lastTime = $071334078f8d3f8a$var$lastMouseDownTime;
    $071334078f8d3f8a$var$lastMouseDown = event;
    $071334078f8d3f8a$var$lastMouseDownTime = Date.now();
    return $071334078f8d3f8a$var$lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? ($071334078f8d3f8a$var$lastMouseDownCount + 1) % 3 : 1;
}
function $071334078f8d3f8a$var$basicMouseSelection(view, event) {
    let start = $071334078f8d3f8a$var$queryPos(view, event), type = $071334078f8d3f8a$var$getClickType(event);
    let startSel = view.state.selection;
    return {
        update (update) {
            if (update.docChanged) {
                start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
            }
        },
        get (event, extend, multiple) {
            let cur = $071334078f8d3f8a$var$queryPos(view, event), removed;
            let range = $071334078f8d3f8a$var$rangeForClick(view, cur.pos, cur.bias, type);
            if (start.pos != cur.pos && !extend) {
                let startRange = $071334078f8d3f8a$var$rangeForClick(view, start.pos, start.bias, type);
                let from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, $hB7kI.EditorSelection).range(from, to) : (0, $hB7kI.EditorSelection).range(to, from);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to));
            else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = $071334078f8d3f8a$var$removeRangeAround(startSel, cur.pos))) return removed;
            else if (multiple) return startSel.addRange(range);
            else return (0, $hB7kI.EditorSelection).create([
                range
            ]);
        }
    };
}
function $071334078f8d3f8a$var$removeRangeAround(sel, pos) {
    for(let i = 0; i < sel.ranges.length; i++){
        let { from: from, to: to } = sel.ranges[i];
        if (from <= pos && to >= pos) return (0, $hB7kI.EditorSelection).create(sel.ranges.slice(0, i).concat(sel.ranges.slice(i + 1)), sel.mainIndex == i ? 0 : sel.mainIndex - (sel.mainIndex > i ? 1 : 0));
    }
    return null;
}
$071334078f8d3f8a$var$handlers.dragstart = (view, event)=>{
    let { selection: { main: main } } = view.state;
    let { mouseSelection: mouseSelection } = view.inputState;
    if (mouseSelection) mouseSelection.dragging = main;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", view.state.sliceDoc(main.from, main.to));
        event.dataTransfer.effectAllowed = "copyMove";
    }
};
function $071334078f8d3f8a$var$dropText(view, event, text, direct) {
    if (!text) return;
    let dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    event.preventDefault();
    let { mouseSelection: mouseSelection } = view.inputState;
    let del = direct && mouseSelection && mouseSelection.dragging && $071334078f8d3f8a$var$dragMovesSelection(view, event) ? {
        from: mouseSelection.dragging.from,
        to: mouseSelection.dragging.to
    } : null;
    let ins = {
        from: dropPos,
        insert: text
    };
    let changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes: changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
}
$071334078f8d3f8a$var$handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return;
    if (view.state.readOnly) return event.preventDefault();
    let files = event.dataTransfer.files;
    if (files && files.length) {
        event.preventDefault();
        let text = Array(files.length), read = 0;
        let finishFile = ()=>{
            if (++read == files.length) $071334078f8d3f8a$var$dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(let i = 0; i < files.length; i++){
            let reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        }
    } else $071334078f8d3f8a$var$dropText(view, event, event.dataTransfer.getData("Text"), true);
};
$071334078f8d3f8a$var$handlers.paste = (view, event)=>{
    if (view.state.readOnly) return event.preventDefault();
    view.observer.flush();
    let data = $071334078f8d3f8a$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        $071334078f8d3f8a$var$doPaste(view, data.getData("text/plain") || data.getData("text/uri-text"));
        event.preventDefault();
    } else $071334078f8d3f8a$var$capturePaste(view);
};
function $071334078f8d3f8a$var$captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function $071334078f8d3f8a$var$copiedRange(state) {
    let content = [], ranges = [], linewise = false;
    for (let range of state.selection.ranges)if (!range.empty) {
        content.push(state.sliceDoc(range.from, range.to));
        ranges.push(range);
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        let upto = -1;
        for (let { from: from } of state.selection.ranges){
            let line = state.doc.lineAt(from);
            if (line.number > upto) {
                content.push(line.text);
                ranges.push({
                    from: line.from,
                    to: Math.min(state.doc.length, line.to + 1)
                });
            }
            upto = line.number;
        }
        linewise = true;
    }
    return {
        text: content.join(state.lineBreak),
        ranges: ranges,
        linewise: linewise
    };
}
let $071334078f8d3f8a$var$lastLinewiseCopy = null;
$071334078f8d3f8a$var$handlers.copy = $071334078f8d3f8a$var$handlers.cut = (view, event)=>{
    let { text: text, ranges: ranges, linewise: linewise } = $071334078f8d3f8a$var$copiedRange(view.state);
    if (!text && !linewise) return;
    $071334078f8d3f8a$var$lastLinewiseCopy = linewise ? text : null;
    let data = $071334078f8d3f8a$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/plain", text);
    } else $071334078f8d3f8a$var$captureCopy(view, text);
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
};
const $071334078f8d3f8a$var$isFocusChange = /*@__PURE__*/ (0, $hB7kI.Annotation).define();
function $071334078f8d3f8a$var$focusChangeTransaction(state, focus) {
    let effects = [];
    for (let getEffect of state.facet($071334078f8d3f8a$var$focusChangeEffect)){
        let effect = getEffect(state, focus);
        if (effect) effects.push(effect);
    }
    return effects ? state.update({
        effects: effects,
        annotations: $071334078f8d3f8a$var$isFocusChange.of(true)
    }) : null;
}
function $071334078f8d3f8a$var$updateForFocusChange(view) {
    setTimeout(()=>{
        let focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            let tr = $071334078f8d3f8a$var$focusChangeTransaction(view.state, focus);
            if (tr) view.dispatch(tr);
            else view.update([]);
        }
    }, 10);
}
$071334078f8d3f8a$var$handlers.focus = (view)=>{
    view.inputState.lastFocusTime = Date.now();
    // When focusing reset the scroll position, move it back to where it was
    if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
        view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
        view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
    }
    $071334078f8d3f8a$var$updateForFocusChange(view);
};
$071334078f8d3f8a$var$handlers.blur = (view)=>{
    view.observer.clearSelectionRange();
    $071334078f8d3f8a$var$updateForFocusChange(view);
};
$071334078f8d3f8a$var$handlers.compositionstart = $071334078f8d3f8a$var$handlers.compositionupdate = (view)=>{
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) // FIXME possibly set a timeout to clear it again on Android
    view.inputState.composing = 0;
};
$071334078f8d3f8a$var$handlers.compositionend = (view)=>{
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionPendingKey = true;
    view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
    view.inputState.compositionFirstChange = null;
    if ($071334078f8d3f8a$var$browser.chrome && $071334078f8d3f8a$var$browser.android) // Delay flushing for a bit on Android because it'll often fire a
    // bunch of contradictory changes in a row at end of compositon
    view.observer.flushSoon();
    else if (view.inputState.compositionPendingChange) // If we found pending records, schedule a flush.
    Promise.resolve().then(()=>view.observer.flush());
    else // Otherwise, make sure that, if no changes come in soon, the
    // composition view is cleared.
    setTimeout(()=>{
        if (view.inputState.composing < 0 && view.docView.hasComposition) view.update([]);
    }, 50);
};
$071334078f8d3f8a$var$handlers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
$071334078f8d3f8a$var$handlers.beforeinput = (view, event)=>{
    var _a;
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    let pending;
    if ($071334078f8d3f8a$var$browser.chrome && $071334078f8d3f8a$var$browser.android && (pending = $071334078f8d3f8a$var$PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            let startViewHeight = ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
};
const $071334078f8d3f8a$var$wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
class $071334078f8d3f8a$var$HeightOracle {
    constructor(lineWrapping){
        this.lineWrapping = lineWrapping;
        this.doc = (0, $hB7kI.Text).empty;
        this.heightSamples = {};
        this.lineHeight = 14; // The height of an entire line (line-height)
        this.charWidth = 7;
        this.textHeight = 14; // The height of the actual font (font-size)
        this.lineLength = 30;
        // Used to track, during updateHeight, if any actual heights changed
        this.heightChanged = false;
    }
    heightForGap(from, to) {
        let lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.max(0, Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength));
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / (this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return $071334078f8d3f8a$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        let newHeight = false;
        for(let i = 0; i < lineHeights.length; i++){
            let h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
        let lineWrapping = $071334078f8d3f8a$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        let changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.textHeight = textHeight;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(let i = 0; i < knownHeights.length; i++){
                let h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nides. The `heights` array is a sequence of
// block heights, starting from position `from`.
class $071334078f8d3f8a$var$MeasuredHeights {
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
    get more() {
        return this.index < this.heights.length;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class $071334078f8d3f8a$export$ddfdc4ccfe9512bd {
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    @internal Weird packed field that holds an array of children
    for composite blocks, a decoration for block widgets, and a
    number indicating the amount of widget-create line breaks for
    text blocks.
    */ _content){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this._content = _content;
    }
    /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ get type() {
        return typeof this._content == "number" ? $071334078f8d3f8a$export$48808c686fe495c4.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    If this is a widget block, this will return the widget
    associated with it.
    */ get widget() {
        return this._content instanceof $071334078f8d3f8a$var$PointDecoration ? this._content.widget : null;
    }
    /**
    If this is a textblock, this holds the number of line breaks
    that appear in widgets inside the block.
    */ get widgetLineBreaks() {
        return typeof this._content == "number" ? this._content : 0;
    }
    /**
    @internal
    */ join(other) {
        let content = (Array.isArray(this._content) ? this._content : [
            this
        ]).concat(Array.isArray(other._content) ? other._content : [
            other
        ]);
        return new $071334078f8d3f8a$export$ddfdc4ccfe9512bd(this.from, this.length + other.length, this.top, this.height + other.height, content);
    }
}
var $071334078f8d3f8a$var$QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}($071334078f8d3f8a$var$QueryType || ($071334078f8d3f8a$var$QueryType = {}));
const $071334078f8d3f8a$var$Epsilon = 1e-3;
class $071334078f8d3f8a$var$HeightMap {
    constructor(length, height, flags = 2 /* Outdated */ ){
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
    get outdated() {
        return (this.flags & 2 /* Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Outdated */  : 0) | this.flags & -3 /* Outdated */ ;
    }
    setHeight(oracle, height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > $071334078f8d3f8a$var$Epsilon) oracle.heightChanged = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return $071334078f8d3f8a$var$HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        let me = this, doc = oracle.doc;
        for(let i = changes.length - 1; i >= 0; i--){
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = changes[i];
            let start = me.lineAt(fromA, $071334078f8d3f8a$var$QueryType.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
            let end = start.to >= toA ? start : me.lineAt(toA, $071334078f8d3f8a$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, $071334078f8d3f8a$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            let nodes = $071334078f8d3f8a$var$NodeBuilder.build(oracle.setDoc(doc), decorations, fromB, toB);
            me = me.replace(fromA, toA, nodes);
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new $071334078f8d3f8a$var$HeightMapText(0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        let i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    let split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    let split = nodes[j];
                    if (split.break) nodes.splice(j, 1, split.left, null, split.right);
                    else nodes.splice(j, 1, split.left, split.right);
                    j += 2 + split.break;
                    after -= split.size;
                } else break;
            } else if (before < after) {
                let next = nodes[i++];
                if (next) before += next.size;
            } else {
                let next = nodes[--j];
                if (next) after += next.size;
            }
        }
        let brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new $071334078f8d3f8a$var$HeightMapBranch($071334078f8d3f8a$var$HeightMap.of(nodes.slice(0, i)), brk, $071334078f8d3f8a$var$HeightMap.of(nodes.slice(j)));
    }
}
$071334078f8d3f8a$var$HeightMap.prototype.size = 1;
class $071334078f8d3f8a$var$HeightMapBlock extends $071334078f8d3f8a$var$HeightMap {
    constructor(length, height, deco){
        super(length, height);
        this.deco = deco;
    }
    blockAt(_height, _oracle, top, offset) {
        return new $071334078f8d3f8a$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.deco || 0);
    }
    lineAt(_value, _type, oracle, top, offset) {
        return this.blockAt(0, oracle, top, offset);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.blockAt(0, oracle, top, offset));
    }
    updateHeight(oracle, offset = 0, _force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
}
class $071334078f8d3f8a$var$HeightMapText extends $071334078f8d3f8a$var$HeightMapBlock {
    constructor(length, height){
        super(length, height, null);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
        this.breaks = 0; // Number of widget-introduced line breaks on the line
    }
    blockAt(_height, _oracle, top, offset) {
        return new $071334078f8d3f8a$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.breaks);
    }
    replace(_from, _to, nodes) {
        let node = nodes[0];
        if (nodes.length == 1 && (node instanceof $071334078f8d3f8a$var$HeightMapText || node instanceof $071334078f8d3f8a$var$HeightMapGap && node.flags & 4 /* SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof $071334078f8d3f8a$var$HeightMapGap) node = new $071334078f8d3f8a$var$HeightMapText(node.length, this.height);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return $071334078f8d3f8a$var$HeightMap.of(nodes);
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        else if (force || this.outdated) this.setHeight(oracle, Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
}
class $071334078f8d3f8a$var$HeightMapGap extends $071334078f8d3f8a$var$HeightMap {
    constructor(length){
        super(length, 0);
    }
    heightMetrics(oracle, offset) {
        let firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
        let lines = lastLine - firstLine + 1;
        let perLine, perChar = 0;
        if (oracle.lineWrapping) {
            let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
            perLine = totalPerLine / lines;
            if (this.length > lines + 1) perChar = (this.height - totalPerLine) / (this.length - lines - 1);
        } else perLine = this.height / lines;
        return {
            firstLine: firstLine,
            lastLine: lastLine,
            perLine: perLine,
            perChar: perChar
        };
    }
    blockAt(height, oracle, top, offset) {
        let { firstLine: firstLine, lastLine: lastLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        if (oracle.lineWrapping) {
            let guess = offset + Math.round(Math.max(0, Math.min(1, (height - top) / this.height)) * this.length);
            let line = oracle.doc.lineAt(guess), lineHeight = perLine + line.length * perChar;
            let lineTop = Math.max(top, height - lineHeight / 2);
            return new $071334078f8d3f8a$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0);
        } else {
            let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / perLine)));
            let { from: from, length: length } = oracle.doc.line(firstLine + line);
            return new $071334078f8d3f8a$export$ddfdc4ccfe9512bd(from, length, top + perLine * line, perLine, 0);
        }
    }
    lineAt(value, type, oracle, top, offset) {
        if (type == $071334078f8d3f8a$var$QueryType.ByHeight) return this.blockAt(value, oracle, top, offset);
        if (type == $071334078f8d3f8a$var$QueryType.ByPosNoHeight) {
            let { from: from, to: to } = oracle.doc.lineAt(value);
            return new $071334078f8d3f8a$export$ddfdc4ccfe9512bd(from, to - from, 0, 0, 0);
        }
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        let line = oracle.doc.lineAt(value), lineHeight = perLine + line.length * perChar;
        let linesAbove = line.number - firstLine;
        let lineTop = top + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
        return new $071334078f8d3f8a$export$ddfdc4ccfe9512bd(line.from, line.length, Math.max(top, Math.min(lineTop, top + this.height - lineHeight)), lineHeight, 0);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        from = Math.max(from, offset);
        to = Math.min(to, offset + this.length);
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        for(let pos = from, lineTop = top; pos <= to;){
            let line = oracle.doc.lineAt(pos);
            if (pos == from) {
                let linesAbove = line.number - firstLine;
                lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
            }
            let lineHeight = perLine + perChar * line.length;
            f(new $071334078f8d3f8a$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0));
            lineTop += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        let after = this.length - to;
        if (after > 0) {
            let last = nodes[nodes.length - 1];
            if (last instanceof $071334078f8d3f8a$var$HeightMapGap) nodes[nodes.length - 1] = new $071334078f8d3f8a$var$HeightMapGap(last.length + after);
            else nodes.push(null, new $071334078f8d3f8a$var$HeightMapGap(after - 1));
        }
        if (from > 0) {
            let first = nodes[0];
            if (first instanceof $071334078f8d3f8a$var$HeightMapGap) nodes[0] = new $071334078f8d3f8a$var$HeightMapGap(from + first.length);
            else nodes.unshift(new $071334078f8d3f8a$var$HeightMapGap(from - 1), null);
        }
        return $071334078f8d3f8a$var$HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new $071334078f8d3f8a$var$HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new $071334078f8d3f8a$var$HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            if (measured.from > offset) nodes.push(new $071334078f8d3f8a$var$HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                let len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                let height = measured.heights[measured.index++];
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= $071334078f8d3f8a$var$Epsilon) singleHeight = -2;
                let line = new $071334078f8d3f8a$var$HeightMapText(len, height);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new $071334078f8d3f8a$var$HeightMapGap(end - pos).updateHeight(oracle, pos));
            let result = $071334078f8d3f8a$var$HeightMap.of(nodes);
            if (singleHeight < 0 || Math.abs(result.height - this.height) >= $071334078f8d3f8a$var$Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= $071334078f8d3f8a$var$Epsilon) oracle.heightChanged = true;
            return result;
        } else if (force || this.outdated) {
            this.setHeight(oracle, oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
}
class $071334078f8d3f8a$var$HeightMapBranch extends $071334078f8d3f8a$var$HeightMap {
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
    get break() {
        return this.flags & 1 /* Break */ ;
    }
    blockAt(height, oracle, top, offset) {
        let mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, oracle, top, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, oracle, top, offset) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        let left = type == $071334078f8d3f8a$var$QueryType.ByHeight ? value < rightTop : value < rightOffset;
        let base = left ? this.left.lineAt(value, type, oracle, top, offset) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        let subQuery = type == $071334078f8d3f8a$var$QueryType.ByPosNoHeight ? $071334078f8d3f8a$var$QueryType.ByPosNoHeight : $071334078f8d3f8a$var$QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, oracle, top, offset).join(base);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, oracle, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, oracle, rightTop, rightOffset, f);
        } else {
            let mid = this.lineAt(rightOffset, $071334078f8d3f8a$var$QueryType.ByPos, oracle, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, oracle, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, oracle, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        let rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        let result = [];
        if (from > 0) this.decomposeLeft(from, result);
        let left = result.length;
        for (let node of nodes)result.push(node);
        if (from > 0) $071334078f8d3f8a$var$mergeGaps(result, left - 1);
        if (to < this.length) {
            let right = result.length;
            this.decomposeRight(to, result);
            $071334078f8d3f8a$var$mergeGaps(result, right);
        }
        return $071334078f8d3f8a$var$HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        let left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        let left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return $071334078f8d3f8a$var$HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = left;
        this.right = right;
        this.height = left.height + right.height;
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let { left: left, right: right } = this, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
}
function $071334078f8d3f8a$var$mergeGaps(nodes, around) {
    let before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof $071334078f8d3f8a$var$HeightMapGap && (after = nodes[around + 1]) instanceof $071334078f8d3f8a$var$HeightMapGap) nodes.splice(around - 1, 3, new $071334078f8d3f8a$var$HeightMapGap(before.length + 1 + after.length));
}
const $071334078f8d3f8a$var$relevantWidgetHeight = 5;
class $071334078f8d3f8a$var$NodeBuilder {
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            let end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof $071334078f8d3f8a$var$HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new $071334078f8d3f8a$var$HeightMapText(end - this.pos, -1));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            let height = deco.widget ? deco.widget.estimatedHeight : 0;
            let breaks = deco.widget ? deco.widget.lineBreaks : 0;
            if (height < 0) height = this.oracle.lineHeight;
            let len = to - from;
            if (deco.block) this.addBlock(new $071334078f8d3f8a$var$HeightMapBlock(len, height, deco));
            else if (len || breaks || height >= $071334078f8d3f8a$var$relevantWidgetHeight) this.addLineDeco(height, breaks, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        let { from: from, to: to } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new $071334078f8d3f8a$var$HeightMapText(this.pos - from, -1));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        let gap = new $071334078f8d3f8a$var$HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof $071334078f8d3f8a$var$HeightMapText) return last;
        let line = new $071334078f8d3f8a$var$HeightMapText(0, -1);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        var _a;
        this.enterLine();
        let type = (_a = block.deco) === null || _a === void 0 ? void 0 : _a.type;
        if (type == $071334078f8d3f8a$export$48808c686fe495c4.WidgetAfter && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (type != $071334078f8d3f8a$export$48808c686fe495c4.WidgetBefore) this.covering = block;
    }
    addLineDeco(height, breaks, length) {
        let line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        line.breaks += breaks;
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof $071334078f8d3f8a$var$HeightMapText) && !this.isCovered) this.nodes.push(new $071334078f8d3f8a$var$HeightMapText(0, -1));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        let pos = from;
        for (let node of this.nodes){
            if (node instanceof $071334078f8d3f8a$var$HeightMapText) node.updateHeight(this.oracle, pos);
            pos += node ? node.length : 1;
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        let builder = new $071334078f8d3f8a$var$NodeBuilder(from, oracle);
        (0, $hB7kI.RangeSet).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
}
function $071334078f8d3f8a$var$heightRelevantDecoChanges(a, b, diff) {
    let comp = new $071334078f8d3f8a$var$DecorationComparator;
    (0, $hB7kI.RangeSet).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class $071334078f8d3f8a$var$DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) $071334078f8d3f8a$var$addRange(from, to, this.changes, 5);
    }
}
function $071334078f8d3f8a$var$visiblePixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
    let top = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
    for(let parent = dom.parentNode; parent && parent != doc.body;){
        if (parent.nodeType == 1) {
            let elt = parent;
            let style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                let parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = parent == dom.parentNode ? parentRect.bottom : Math.min(bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function $071334078f8d3f8a$var$fullPixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class $071334078f8d3f8a$var$LineGap {
    constructor(from, to, size){
        this.from = from;
        this.to = to;
        this.size = size;
    }
    static same(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++){
            let gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(wrapping) {
        return $071334078f8d3f8a$export$10e30b733df217ea.replace({
            widget: new $071334078f8d3f8a$var$LineGapWidget(this.size, wrapping)
        }).range(this.from, this.to);
    }
}
class $071334078f8d3f8a$var$LineGapWidget extends $071334078f8d3f8a$export$95cdd842edb044c5 {
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        let elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
}
class $071334078f8d3f8a$var$ViewState {
    constructor(state){
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0;
        this.paddingBottom = 0;
        this.contentDOMWidth = 0;
        this.contentDOMHeight = 0;
        this.editorHeight = 0;
        this.editorWidth = 0;
        this.scrollTop = 0;
        this.scrolledToBottom = true;
        // The vertical position (document-relative) to which to anchor the
        // scroll position. -1 means anchor to the end of the document.
        this.scrollAnchorPos = 0;
        // The height at the anchor position. Set by the DOM update phase.
        // -1 means no height available.
        this.scrollAnchorHeight = -1;
        // See VP.MaxDOMHeight
        this.scaler = $071334078f8d3f8a$var$IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        let guessWrapping = state.facet($071334078f8d3f8a$var$contentAttributes).some((v)=>typeof v != "function" && v.class == "cm-lineWrapping");
        this.heightOracle = new $071334078f8d3f8a$var$HeightOracle(guessWrapping);
        this.stateDeco = state.facet($071334078f8d3f8a$var$decorations).filter((d)=>typeof d != "function");
        this.heightMap = $071334078f8d3f8a$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $hB7kI.Text).empty, this.heightOracle.setDoc(state.doc), [
            new $071334078f8d3f8a$var$ChangedRange(0, 0, 0, state.doc.length)
        ]);
        this.viewport = this.getViewport(0, null);
        this.updateViewportLines();
        this.updateForViewport();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = $071334078f8d3f8a$export$10e30b733df217ea.set(this.lineGaps.map((gap)=>gap.draw(false)));
        this.computeVisibleRanges();
    }
    updateForViewport() {
        let viewports = [
            this.viewport
        ], { main: main } = this.state.selection;
        for(let i = 0; i <= 1; i++){
            let pos = i ? main.head : main.anchor;
            if (!viewports.some(({ from: from, to: to })=>pos >= from && pos <= to)) {
                let { from: from, to: to } = this.lineBlockAt(pos);
                viewports.push(new $071334078f8d3f8a$var$Viewport(from, to));
            }
        }
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        this.scaler = this.heightMap.height <= 7000000 /* MaxDOMHeight */  ? $071334078f8d3f8a$var$IdScaler : new $071334078f8d3f8a$var$BigScaler(this.heightOracle, this.heightMap, this.viewports);
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block)=>{
            this.viewportLines.push(this.scaler.scale == 1 ? block : $071334078f8d3f8a$var$scaleBlock(block, this.scaler));
        });
    }
    update(update, scrollTarget = null) {
        this.state = update.state;
        let prevDeco = this.stateDeco;
        this.stateDeco = this.state.facet($071334078f8d3f8a$var$decorations).filter((d)=>typeof d != "function");
        let contentChanges = update.changedRanges;
        let heightChanges = $071334078f8d3f8a$var$ChangedRange.extendWithRanges(contentChanges, $071334078f8d3f8a$var$heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, $hB7kI.ChangeSet).empty(this.state.doc.length)));
        let prevHeight = this.heightMap.height;
        let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight) update.flags |= 2 /* Height */ ;
        if (scrollAnchor) {
            this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
            this.scrollAnchorHeight = scrollAnchor.top;
        } else {
            this.scrollAnchorPos = -1;
            this.scrollAnchorHeight = this.heightMap.height;
        }
        let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        let updateLines = !update.changes.empty || update.flags & 2 /* Height */  || viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        this.updateForViewport();
        if (updateLines) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges();
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet($071334078f8d3f8a$var$nativeSelectionHidden)) this.mustEnforceCursorAssoc = true;
    }
    measure(view) {
        let dom = view.contentDOM, style = window.getComputedStyle(dom);
        let oracle = this.heightOracle;
        let whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? $071334078f8d3f8a$export$cacd6541cfeeb6c1.RTL : $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR;
        let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
        let domRect = dom.getBoundingClientRect();
        let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
        this.contentDOMHeight = domRect.height;
        this.mustMeasureContent = false;
        let result = 0, bias = 0;
        // Vertical padding
        let paddingTop = parseInt(style.paddingTop) || 0, paddingBottom = parseInt(style.paddingBottom) || 0;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 10 /* Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 8 /* Geometry */ ;
        }
        if (this.scrollTop != view.scrollDOM.scrollTop) {
            this.scrollAnchorHeight = -1;
            this.scrollTop = view.scrollDOM.scrollTop;
        }
        this.scrolledToBottom = $071334078f8d3f8a$var$isScrolledToBottom(view.scrollDOM);
        // Pixel viewport
        let pixelViewport = (this.printing ? $071334078f8d3f8a$var$fullPixelRange : $071334078f8d3f8a$var$visiblePixelRange)(dom, this.paddingTop);
        let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView && !this.scrollTarget) return 0;
        let contentWidth = domRect.width;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = domRect.width;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 8 /* Geometry */ ;
        }
        if (measureContent) {
            let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                let { lineHeight: lineHeight, charWidth: charWidth, textHeight: textHeight } = view.docView.measureTextSize();
                refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, contentWidth / charWidth, lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 8 /* Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            oracle.heightChanged = false;
            for (let vp of this.viewports){
                let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                this.heightMap = (refresh ? $071334078f8d3f8a$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $hB7kI.Text).empty, this.heightOracle, [
                    new $071334078f8d3f8a$var$ChangedRange(0, 0, 0, view.state.doc.length)
                ]) : this.heightMap).updateHeight(oracle, 0, refresh, new $071334078f8d3f8a$var$MeasuredHeights(vp.from, heights));
            }
            if (oracle.heightChanged) result |= 2 /* Height */ ;
        }
        let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) this.viewport = this.getViewport(bias, this.scrollTarget);
        this.updateForViewport();
        if (result & 2 /* Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* Margin */  / 2));
        let map = this.heightMap, oracle = this.heightOracle;
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        let viewport = new $071334078f8d3f8a$var$Viewport(map.lineAt(visibleTop - marginTop * 1000 /* Margin */ , $071334078f8d3f8a$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* Margin */ , $071334078f8d3f8a$var$QueryType.ByHeight, oracle, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            let { head: head } = scrollTarget.range;
            if (head < viewport.from || head > viewport.to) {
                let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                let block = map.lineAt(head, $071334078f8d3f8a$var$QueryType.ByPos, oracle, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new $071334078f8d3f8a$var$Viewport(map.lineAt(topPos - 500, $071334078f8d3f8a$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(topPos + viewHeight + 500, $071334078f8d3f8a$var$QueryType.ByHeight, oracle, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        let from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new $071334078f8d3f8a$var$Viewport(this.heightMap.lineAt(from, $071334078f8d3f8a$var$QueryType.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to, $071334078f8d3f8a$var$QueryType.ByPos, this.heightOracle, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate({ from: from, to: to }, bias = 0) {
        if (!this.inView) return true;
        let { top: top } = this.heightMap.lineAt(from, $071334078f8d3f8a$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { bottom: bottom } = this.heightMap.lineAt(to, $071334078f8d3f8a$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        return (from == 0 || top <= visibleTop - Math.max(10 /* MinCoverMargin */ , Math.min(-bias, 250 /* MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* MinCoverMargin */ , Math.min(bias, 250 /* MaxCoverMargin */ ))) && top > visibleTop - 2000 /* Margin */  && bottom < visibleBottom + 2000 /* Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        let mapped = [];
        for (let gap of gaps)if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new $071334078f8d3f8a$var$LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size));
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current, mayMeasure) {
        let wrapping = this.heightOracle.lineWrapping;
        let margin = wrapping ? 10000 /* MarginWrap */  : 2000 /* Margin */ , halfMargin = margin >> 1, doubleMargin = margin << 1;
        // The non-wrapping logic won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR && !wrapping) return [];
        let gaps = [];
        let addGap = (from, to, line, structure)=>{
            if (to - from < halfMargin) return;
            let sel = this.state.selection.main, avoid = [
                sel.from
            ];
            if (!sel.empty) avoid.push(sel.to);
            for (let pos of avoid)if (pos > from && pos < to) {
                addGap(from, pos - 10 /* SelectionMargin */ , line, structure);
                addGap(pos + 10 /* SelectionMargin */ , to, line, structure);
                return;
            }
            let gap = $071334078f8d3f8a$var$find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < halfMargin && Math.abs(gap.to - to) < halfMargin && !avoid.some((pos)=>gap.from < pos && gap.to > pos));
            if (!gap) {
                // When scrolling down, snap gap ends to line starts to avoid shifts in wrapping
                if (to < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r)=>r.from <= to && r.to >= to)) {
                    let lineStart = mayMeasure.moveToLineBoundary((0, $hB7kI.EditorSelection).cursor(to), false, true).head;
                    if (lineStart > from) to = lineStart;
                }
                gap = new $071334078f8d3f8a$var$LineGap(from, to, this.gapSize(line, from, to, structure));
            }
            gaps.push(gap);
        };
        for (let line of this.viewportLines){
            if (line.length < doubleMargin) continue;
            let structure = $071334078f8d3f8a$var$lineStructure(line.from, line.to, this.stateDeco);
            if (structure.total < doubleMargin) continue;
            let target = this.scrollTarget ? this.scrollTarget.range.head : null;
            let viewFrom, viewTo;
            if (wrapping) {
                let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                let top, bot;
                if (target != null) {
                    let targetFrac = $071334078f8d3f8a$var$findFraction(structure, target);
                    let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
                    top = targetFrac - spaceFrac;
                    bot = targetFrac + spaceFrac;
                } else {
                    top = (this.visibleTop - line.top - marginHeight) / line.height;
                    bot = (this.visibleBottom - line.top + marginHeight) / line.height;
                }
                viewFrom = $071334078f8d3f8a$var$findPosition(structure, top);
                viewTo = $071334078f8d3f8a$var$findPosition(structure, bot);
            } else {
                let totalWidth = structure.total * this.heightOracle.charWidth;
                let marginWidth = margin * this.heightOracle.charWidth;
                let left, right;
                if (target != null) {
                    let targetFrac = $071334078f8d3f8a$var$findFraction(structure, target);
                    let spaceFrac = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + marginWidth) / totalWidth;
                    left = targetFrac - spaceFrac;
                    right = targetFrac + spaceFrac;
                } else {
                    left = (this.pixelViewport.left - marginWidth) / totalWidth;
                    right = (this.pixelViewport.right + marginWidth) / totalWidth;
                }
                viewFrom = $071334078f8d3f8a$var$findPosition(structure, left);
                viewTo = $071334078f8d3f8a$var$findPosition(structure, right);
            }
            if (viewFrom > line.from) addGap(line.from, viewFrom, line, structure);
            if (viewTo < line.to) addGap(viewTo, line.to, line, structure);
        }
        return gaps;
    }
    gapSize(line, from, to, structure) {
        let fraction = $071334078f8d3f8a$var$findFraction(structure, to) - $071334078f8d3f8a$var$findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!$071334078f8d3f8a$var$LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = $071334078f8d3f8a$export$10e30b733df217ea.set(gaps.map((gap)=>gap.draw(this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges() {
        let deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        let ranges = [];
        (0, $hB7kI.RangeSet).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from: from,
                    to: to
                });
            },
            point () {}
        }, 20);
        let changed = ranges.length != this.visibleRanges.length || this.visibleRanges.some((r, i)=>r.from != ranges[i].from || r.to != ranges[i].to);
        this.visibleRanges = ranges;
        return changed ? 4 /* Viewport */  : 0;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || $071334078f8d3f8a$var$scaleBlock(this.heightMap.lineAt(pos, $071334078f8d3f8a$var$QueryType.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return $071334078f8d3f8a$var$scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), $071334078f8d3f8a$var$QueryType.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    scrollAnchorAt(scrollTop) {
        let block = this.lineBlockAtHeight(scrollTop + 8);
        return block.from >= this.viewport.from || this.viewportLines[0].top - scrollTop > 200 ? block : this.viewportLines[0];
    }
    elementAtHeight(height) {
        return $071334078f8d3f8a$var$scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
}
class $071334078f8d3f8a$var$Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function $071334078f8d3f8a$var$lineStructure(from, to, stateDeco) {
    let ranges = [], pos = from, total = 0;
    (0, $hB7kI.RangeSet).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to: to
        });
        total += to - pos;
    }
    return {
        total: total,
        ranges: ranges
    };
}
function $071334078f8d3f8a$var$findPosition({ total: total, ranges: ranges }, ratio) {
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    let dist = Math.floor(total * ratio);
    for(let i = 0;; i++){
        let { from: from, to: to } = ranges[i], size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function $071334078f8d3f8a$var$findFraction(structure, pos) {
    let counted = 0;
    for (let { from: from, to: to } of structure.ranges){
        if (pos <= to) {
            counted += pos - from;
            break;
        }
        counted += to - from;
    }
    return counted / structure.total;
}
function $071334078f8d3f8a$var$find(array, f) {
    for (let val of array)if (f(val)) return val;
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
const $071334078f8d3f8a$var$IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1
};
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class $071334078f8d3f8a$var$BigScaler {
    constructor(oracle, heightMap, viewports){
        let vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map(({ from: from, to: to })=>{
            let top = heightMap.lineAt(from, $071334078f8d3f8a$var$QueryType.ByPos, oracle, 0, 0).top;
            let bottom = heightMap.lineAt(to, $071334078f8d3f8a$var$QueryType.ByPos, oracle, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from: from,
                to: to,
                top: top,
                bottom: bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        for (let obj of this.viewports){
            obj.domTop = domBase + (obj.top - base) * this.scale;
            domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
            base = obj.bottom;
        }
    }
    toDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
}
function $071334078f8d3f8a$var$scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new $071334078f8d3f8a$export$ddfdc4ccfe9512bd(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b)=>$071334078f8d3f8a$var$scaleBlock(b, scaler)) : block._content);
}
const $071334078f8d3f8a$var$theme = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (strs)=>strs.join(" ")
});
const $071334078f8d3f8a$var$darkTheme = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.indexOf(true) > -1
});
const $071334078f8d3f8a$var$baseThemeID = /*@__PURE__*/ (0, $luNHI.StyleModule).newName(), $071334078f8d3f8a$var$baseLightID = /*@__PURE__*/ (0, $luNHI.StyleModule).newName(), $071334078f8d3f8a$var$baseDarkID = /*@__PURE__*/ (0, $luNHI.StyleModule).newName();
const $071334078f8d3f8a$var$lightDarkIDs = {
    "&light": "." + $071334078f8d3f8a$var$baseLightID,
    "&dark": "." + $071334078f8d3f8a$var$baseDarkID
};
function $071334078f8d3f8a$var$buildTheme(main, spec, scopes) {
    return new (0, $luNHI.StyleModule)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
const $071334078f8d3f8a$var$baseTheme$1 = /*@__PURE__*/ $071334078f8d3f8a$var$buildTheme("." + $071334078f8d3f8a$var$baseThemeID, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#444"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        insetInlineStart: 0,
        zIndex: 200
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        borderRight: "1px solid #ddd"
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top"
    },
    ".cm-highlightSpace:before": {
        content: "attr(data-display)",
        position: "absolute",
        pointerEvents: "none",
        color: "#888"
    },
    ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, $071334078f8d3f8a$var$lightDarkIDs);
class $071334078f8d3f8a$var$DOMChange {
    constructor(view, start, end, typeOver){
        this.typeOver = typeOver;
        this.bounds = null;
        this.text = "";
        let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
        if (view.state.readOnly && start > -1) // Ignore changes when the editor is read-only
        this.newSel = null;
        else if (start > -1 && (this.bounds = view.docView.domBoundsAround(start, end, 0))) {
            let selPoints = iHead || iAnchor ? [] : $071334078f8d3f8a$var$selectionPoints(view);
            let reader = new $071334078f8d3f8a$var$DOMReader(selPoints, view.state);
            reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
            this.text = reader.text;
            this.newSel = $071334078f8d3f8a$var$selectionFromPoints(selPoints, this.bounds.from);
        } else {
            let domSel = view.observer.selectionRange;
            let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !$071334078f8d3f8a$var$contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
            let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !$071334078f8d3f8a$var$contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
            this.newSel = (0, $hB7kI.EditorSelection).single(anchor, head);
        }
    }
}
function $071334078f8d3f8a$var$applyDOMChange(view, domChange) {
    let change;
    let { newSel: newSel } = domChange, sel = view.state.selection.main;
    let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
    if (domChange.bounds) {
        let { from: from, to: to } = domChange.bounds;
        let preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (lastKey === 8 || $071334078f8d3f8a$var$browser.android && domChange.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        let diff = $071334078f8d3f8a$var$findDiff(view.state.doc.sliceString(from, to, $071334078f8d3f8a$var$LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
        if (diff) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. DomChange drops one of those.
            if ($071334078f8d3f8a$var$browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == $071334078f8d3f8a$var$LineBreakPlaceholder + $071334078f8d3f8a$var$LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, $hB7kI.Text).of(domChange.text.slice(diff.from, diff.toB).split($071334078f8d3f8a$var$LineBreakPlaceholder))
            };
        }
    } else if (newSel && (!view.hasFocus && view.state.facet($071334078f8d3f8a$var$editable) || newSel.main.eq(sel))) newSel = null;
    if (!change && !newSel) return false;
    if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) // Heuristic to notice typing over a selected character
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, sel.to)
    };
    else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) // If the change is inside the selection and covers most of it,
    // assume it is a selection replace (with identical characters at
    // the start/end not included in the diff)
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
    else if (($071334078f8d3f8a$var$browser.mac || $071334078f8d3f8a$var$browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
        // Detect insert-period-on-double-space Mac and Android behavior,
        // and transform it into a regular space insert.
        if (newSel && change.insert.length == 2) newSel = (0, $hB7kI.EditorSelection).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $hB7kI.Text).of([
                " "
            ])
        };
    } else if ($071334078f8d3f8a$var$browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
        // In Chrome, if you insert a space at the start of a wrapped
        // line, it will actually insert a newline and a space, causing a
        // bogus new line to be created in CodeMirror (#968)
        if (newSel) newSel = (0, $hB7kI.EditorSelection).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $hB7kI.Text).of([
                " "
            ])
        };
    }
    if (change) {
        let startState = view.state;
        if ($071334078f8d3f8a$var$browser.ios && view.inputState.flushIOSKey(view)) return true;
        // Android browsers don't fire reasonable key events for enter,
        // backspace, or delete. So this detects changes that look like
        // they're caused by those keys, and reinterprets them as key
        // events. (Some of these keys are also handled by beforeinput
        // events and the pendingAndroidKey mechanism, but that's not
        // reliable in all situations.)
        if ($071334078f8d3f8a$var$browser.android && (change.from == sel.from && change.to == sel.to && change.insert.length == 1 && change.insert.lines == 2 && $071334078f8d3f8a$var$dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from) && $071334078f8d3f8a$var$dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && $071334078f8d3f8a$var$dispatchKey(view.contentDOM, "Delete", 46))) return true;
        let text = change.insert.toString();
        if (view.state.facet($071334078f8d3f8a$var$inputHandler).some((h)=>h(view, change.from, change.to, text))) return true;
        if (view.inputState.composing >= 0) view.inputState.composing++;
        let tr;
        if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
            let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
            let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
            tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
        } else {
            let changes = startState.changes(change);
            let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : undefined;
            // Try to apply a composition change to all cursors
            if (startState.selection.ranges.length > 1 && view.inputState.composing >= 0 && change.to <= sel.to && change.to >= sel.to - 10) {
                let replaced = view.state.sliceDoc(change.from, change.to);
                let composition = $071334078f8d3f8a$var$findCompositionNode(view) || view.state.doc.lineAt(sel.head);
                let offset = sel.to - change.to, size = sel.to - sel.from;
                tr = startState.changeByRange((range)=>{
                    if (range.from == sel.from && range.to == sel.to) return {
                        changes: changes,
                        range: mainSel || range.map(changes)
                    };
                    let to = range.to - offset, from = to - replaced.length;
                    if (range.to - range.from != size || view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                    // changes in the same node work without aborting
                    // composition, so cursors in the composition range are
                    // ignored.
                    composition && range.to >= composition.from && range.from <= composition.to) return {
                        range: range
                    };
                    let rangeChanges = startState.changes({
                        from: from,
                        to: to,
                        insert: change.insert
                    }), selOff = range.to - sel.to;
                    return {
                        changes: rangeChanges,
                        range: !mainSel ? range.map(rangeChanges) : (0, $hB7kI.EditorSelection).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                    };
                });
            } else tr = {
                changes: changes,
                selection: mainSel && startState.selection.replaceRange(mainSel)
            };
        }
        let userEvent = "input.type";
        if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
            view.inputState.compositionPendingChange = false;
            userEvent += ".compose";
            if (view.inputState.compositionFirstChange) {
                userEvent += ".start";
                view.inputState.compositionFirstChange = false;
            }
        }
        view.dispatch(tr, {
            scrollIntoView: true,
            userEvent: userEvent
        });
        return true;
    } else if (newSel && !newSel.main.eq(sel)) {
        let scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView: scrollIntoView,
            userEvent: userEvent
        });
        return true;
    } else return false;
}
function $071334078f8d3f8a$var$findDiff(a, b, preferredPos, preferredSide) {
    let minLen = Math.min(a.length, b.length);
    let from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    let toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        let adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from: from,
        toA: toA,
        toB: toB
    };
}
function $071334078f8d3f8a$var$selectionPoints(view) {
    let result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    let { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = view.observer.selectionRange;
    if (anchorNode) {
        result.push(new $071334078f8d3f8a$var$DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new $071334078f8d3f8a$var$DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function $071334078f8d3f8a$var$selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, $hB7kI.EditorSelection).single(anchor + base, head + base) : null;
}
const $071334078f8d3f8a$var$observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
const $071334078f8d3f8a$var$useCharData = $071334078f8d3f8a$var$browser.ie && $071334078f8d3f8a$var$browser.ie_version <= 11;
class $071334078f8d3f8a$var$DOMObserver {
    constructor(view){
        this.view = view;
        this.active = false;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new $071334078f8d3f8a$var$DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
        this.lastChange = 0;
        this.scrollTargets = [];
        this.intersection = null;
        this.resizeScroll = null;
        this.resizeContent = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            for (let mut of mutations)this.queue.push(mut);
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if (($071334078f8d3f8a$var$browser.ie && $071334078f8d3f8a$var$browser.ie_version <= 11 || $071334078f8d3f8a$var$browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($071334078f8d3f8a$var$useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onScroll = this.onScroll.bind(this);
        if (typeof ResizeObserver == "function") {
            this.resizeScroll = new ResizeObserver(()=>{
                var _a;
                if (((_a = this.view.docView) === null || _a === void 0 ? void 0 : _a.lastUpdate) < Date.now() - 75) this.onResize();
            });
            this.resizeScroll.observe(view.scrollDOM);
            this.resizeContent = new ResizeObserver(()=>this.view.requestMeasure());
            this.resizeContent.observe(view.contentDOM);
        }
        this.addWindowListeners(this.win = view.win);
        this.start();
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {
                threshold: [
                    0,
                    .001
                ]
            });
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
    }
    onScrollChanged(e) {
        this.view.inputState.runScrollHandlers(this.view, e);
        if (this.intersecting) this.view.measure();
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint() {
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            for (let gap of gaps)this.gapIntersection.observe(gap);
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        let wasChanged = this.selectionChanged;
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        let { view: view } = this, sel = this.selectionRange;
        if (view.state.facet($071334078f8d3f8a$var$editable) ? view.root.activeElement != this.dom : !$071334078f8d3f8a$var$hasSelection(view.dom, sel)) return;
        let context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
        if (context && context.ignoreEvent(event)) {
            if (!wasChanged) this.selectionChanged = false;
            return;
        }
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if (($071334078f8d3f8a$var$browser.ie && $071334078f8d3f8a$var$browser.ie_version <= 11 || $071334078f8d3f8a$var$browser.android && $071334078f8d3f8a$var$browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && $071334078f8d3f8a$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        let { view: view } = this;
        // The Selection object is broken in shadow roots in Safari. See
        // https://github.com/codemirror/dev/issues/414
        let range = $071334078f8d3f8a$var$browser.safari && view.root.nodeType == 11 && $071334078f8d3f8a$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $071334078f8d3f8a$var$safariSelectionRangeHack(this.view) || $071334078f8d3f8a$var$getSelection(view.root);
        if (!range || this.selectionRange.eq(range)) return false;
        let local = $071334078f8d3f8a$var$hasSelection(this.dom, range);
        // Detect the situation where the browser has, on focus, moved the
        // selection to the start of the content element. Reset it to the
        // position from the editor state.
        if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && $071334078f8d3f8a$var$atElementStart(this.dom, range)) {
            this.view.inputState.lastFocusTime = 0;
            view.docView.updateSelection();
            return false;
        }
        this.selectionRange.setRange(range);
        if (local) this.selectionChanged = true;
        return true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        let i = 0, changed = null;
        for(let dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
            for (let dom of this.scrollTargets = changed)dom.addEventListener("scroll", this.onScroll);
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, $071334078f8d3f8a$var$observeOptions);
        if ($071334078f8d3f8a$var$useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if ($071334078f8d3f8a$var$useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        var _a;
        if (!this.delayedAndroidKey) {
            let flush = ()=>{
                let key = this.delayedAndroidKey;
                if (key) {
                    this.clearDelayedAndroidKey();
                    this.view.inputState.lastKeyCode = key.keyCode;
                    this.view.inputState.lastKeyTime = Date.now();
                    let flushed = this.flush();
                    if (!flushed && key.force) $071334078f8d3f8a$var$dispatchKey(this.dom, key.key, key.keyCode);
                }
            };
            this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
        }
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key: key,
            keyCode: keyCode,
            // Only run the key handler when no changes are detected if
            // this isn't coming right after another change, in which case
            // it is probably part of a weird chain of updates, and should
            // be ignored if it returns the DOM to its previous state.
            force: this.lastChange < Date.now() - 50 || !!((_a = this.delayedAndroidKey) === null || _a === void 0 ? void 0 : _a.force)
        };
    }
    clearDelayedAndroidKey() {
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = this.view.win.requestAnimationFrame(()=>{
            this.delayedFlush = -1;
            this.flush();
        });
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            this.view.win.cancelAnimationFrame(this.delayedFlush);
            this.delayedFlush = -1;
        }
        this.flush();
    }
    pendingRecords() {
        for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    processRecords() {
        let records = this.pendingRecords();
        if (records.length) this.queue = [];
        let from = -1, to = -1, typeOver = false;
        for (let record of records){
            let range = this.readMutation(record);
            if (!range) continue;
            if (range.typeOver) typeOver = true;
            if (from == -1) ({ from: from, to: to } = range);
            else {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        }
        return {
            from: from,
            to: to,
            typeOver: typeOver
        };
    }
    readChange() {
        let { from: from, to: to, typeOver: typeOver } = this.processRecords();
        let newSel = this.selectionChanged && $071334078f8d3f8a$var$hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return null;
        if (from > -1) this.lastChange = Date.now();
        this.view.inputState.lastFocusTime = 0;
        this.selectionChanged = false;
        return new $071334078f8d3f8a$var$DOMChange(this.view, from, to, typeOver);
    }
    // Apply pending changes, if any
    flush(readSelection = true) {
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return false;
        if (readSelection) this.readSelectionRange();
        let domChange = this.readChange();
        if (!domChange) return false;
        let startState = this.view.state;
        let handled = $071334078f8d3f8a$var$applyDOMChange(this.view, domChange);
        // The view wasn't updated
        if (this.view.state == startState) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        let cView = this.view.docView.nearest(rec.target);
        if (!cView || cView.ignoreMutation(rec)) return null;
        cView.markDirty(rec.type == "attributes");
        if (rec.type == "attributes") cView.flags |= 4 /* AttrsDirty */ ;
        if (rec.type == "childList") {
            let childBefore = $071334078f8d3f8a$var$findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
            let childAfter = $071334078f8d3f8a$var$findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
                to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: cView.posAtStart,
            to: cView.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    setWindow(win) {
        if (win != this.win) {
            this.removeWindowListeners(this.win);
            this.win = win;
            this.addWindowListeners(this.win);
        }
    }
    addWindowListeners(win) {
        win.addEventListener("resize", this.onResize);
        win.addEventListener("beforeprint", this.onPrint);
        win.addEventListener("scroll", this.onScroll);
        win.document.addEventListener("selectionchange", this.onSelectionChange);
    }
    removeWindowListeners(win) {
        win.removeEventListener("scroll", this.onScroll);
        win.removeEventListener("resize", this.onResize);
        win.removeEventListener("beforeprint", this.onPrint);
        win.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    destroy() {
        var _a, _b, _c, _d;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resizeScroll) === null || _c === void 0 || _c.disconnect();
        (_d = this.resizeContent) === null || _d === void 0 || _d.disconnect();
        for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
        this.removeWindowListeners(this.win);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
        this.win.cancelAnimationFrame(this.delayedFlush);
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
    }
}
function $071334078f8d3f8a$var$findChild(cView, dom, dir) {
    while(dom){
        let curView = $071334078f8d3f8a$var$ContentView.get(dom);
        if (curView && curView.parent == cView) return curView;
        let parent = dom.parentNode;
        dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function $071334078f8d3f8a$var$safariSelectionRangeHack(view) {
    let found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    view.dom.ownerDocument.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    if (!found) return null;
    let anchorNode = found.startContainer, anchorOffset = found.startOffset;
    let focusNode = found.endContainer, focusOffset = found.endOffset;
    let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($071334078f8d3f8a$var$isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class $071334078f8d3f8a$export$eece2fccabbb77c5 {
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(config = {}){
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.style.cssText = "position: fixed; top: -10000px";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        this._dispatch = config.dispatch || ((tr)=>this.update([
                tr
            ]));
        this.dispatch = this.dispatch.bind(this);
        this._root = config.root || $071334078f8d3f8a$var$getRoot(config.parent) || document;
        this.viewState = new $071334078f8d3f8a$var$ViewState(config.state || (0, $hB7kI.EditorState).create(config));
        this.plugins = this.state.facet($071334078f8d3f8a$var$viewPlugin).map((spec)=>new $071334078f8d3f8a$var$PluginInstance(spec));
        for (let plugin of this.plugins)plugin.update(this);
        this.observer = new $071334078f8d3f8a$var$DOMObserver(this);
        this.inputState = new $071334078f8d3f8a$var$InputState(this);
        this.inputState.ensureHandlers(this, this.plugins);
        this.docView = new $071334078f8d3f8a$var$DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* Idle */ ;
        this.requestMeasure();
        if (config.parent) config.parent.appendChild(this.dom);
    }
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return this.inputState.composing >= 0;
    }
    /**
    The document or shadow root that the view lives in.
    */ get root() {
        return this._root;
    }
    /**
    @internal
    */ get win() {
        return this.dom.ownerDocument.defaultView || window;
    }
    dispatch(...input) {
        let tr = input.length == 1 && input[0] instanceof (0, $hB7kI.Transaction) ? input[0] : this.state.update(...input);
        this._dispatch(tr, this);
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        let redrawn = false, attrsChanged = false, update;
        let state = this.state;
        for (let tr of transactions){
            if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
            state = tr.state;
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
        if (transactions.some((tr)=>tr.annotation($071334078f8d3f8a$var$isFocusChange))) {
            this.inputState.notifiedFocused = focus;
            // If a focus-change transaction is being dispatched, set this update flag.
            focusFlag = 1 /* Focus */ ;
        } else if (focus != this.inputState.notifiedFocused) {
            this.inputState.notifiedFocused = focus;
            // Schedule a separate focus transaction if necessary, otherwise
            // add a flag to this update
            dispatchFocus = $071334078f8d3f8a$var$focusChangeTransaction(state, focus);
            if (!dispatchFocus) focusFlag = 1 /* Focus */ ;
        }
        // If there was a pending DOM change, eagerly read it and try to
        // apply it after the given transactions.
        let pendingKey = this.observer.delayedAndroidKey, domChange = null;
        if (pendingKey) {
            this.observer.clearDelayedAndroidKey();
            domChange = this.observer.readChange();
            // Only try to apply DOM changes if the transactions didn't
            // change the doc or selection.
            if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection)) domChange = null;
        } else this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, $hB7kI.EditorState).phrases) != this.state.facet((0, $hB7kI.EditorState).phrases)) return this.setState(state);
        update = $071334078f8d3f8a$export$b5b084f95c87edf7.create(this, state, transactions);
        update.flags |= focusFlag;
        let scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* Updating */ ;
            for (let tr of transactions){
                if (scrollTarget) scrollTarget = scrollTarget.map(tr.changes);
                if (tr.scrollIntoView) {
                    let { main: main } = tr.state.selection;
                    scrollTarget = new $071334078f8d3f8a$var$ScrollTarget(main.empty ? main : (0, $hB7kI.EditorSelection).cursor(main.head, main.head > main.anchor ? -1 : 1));
                }
                for (let e of tr.effects)if (e.is($071334078f8d3f8a$var$scrollIntoView)) scrollTarget = e.value;
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = $071334078f8d3f8a$var$CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet($071334078f8d3f8a$var$styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* Idle */ ;
        }
        if (update.startState.facet($071334078f8d3f8a$var$theme) != update.state.facet($071334078f8d3f8a$var$theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (!update.empty) for (let listener of this.state.facet($071334078f8d3f8a$var$updateListener))listener(update);
        if (dispatchFocus || domChange) Promise.resolve().then(()=>{
            if (dispatchFocus && this.state == dispatchFocus.startState) this.dispatch(dispatchFocus);
            if (domChange) {
                if (!$071334078f8d3f8a$var$applyDOMChange(this, domChange) && pendingKey.force) $071334078f8d3f8a$var$dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
            }
        });
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* Updating */ ;
        let hadFocus = this.hasFocus;
        try {
            for (let plugin of this.plugins)plugin.destroy(this);
            this.viewState = new $071334078f8d3f8a$var$ViewState(newState);
            this.plugins = newState.facet($071334078f8d3f8a$var$viewPlugin).map((spec)=>new $071334078f8d3f8a$var$PluginInstance(spec));
            this.pluginMap.clear();
            for (let plugin of this.plugins)plugin.update(this);
            this.docView = new $071334078f8d3f8a$var$DocView(this);
            this.inputState.ensureHandlers(this, this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        let prevSpecs = update.startState.facet($071334078f8d3f8a$var$viewPlugin), specs = update.state.facet($071334078f8d3f8a$var$viewPlugin);
        if (prevSpecs != specs) {
            let newPlugins = [];
            for (let spec of specs){
                let found = prevSpecs.indexOf(spec);
                if (found < 0) newPlugins.push(new $071334078f8d3f8a$var$PluginInstance(spec));
                else {
                    let plugin = this.plugins[found];
                    plugin.mustUpdate = update;
                    newPlugins.push(plugin);
                }
            }
            for (let plugin of this.plugins)if (plugin.mustUpdate != update) plugin.destroy(this);
            this.plugins = newPlugins;
            this.pluginMap.clear();
            this.inputState.ensureHandlers(this, this.plugins);
        } else for (let p of this.plugins)p.mustUpdate = update;
        for(let i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
    }
    /**
    @internal
    */ measure(flush = true) {
        if (this.destroyed) return;
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.forceFlush();
        let updated = null;
        let sDOM = this.scrollDOM, { scrollTop: scrollTop } = sDOM;
        let { scrollAnchorPos: scrollAnchorPos, scrollAnchorHeight: scrollAnchorHeight } = this.viewState;
        if (scrollTop != this.viewState.scrollTop) scrollAnchorHeight = -1;
        this.viewState.scrollAnchorHeight = -1;
        try {
            for(let i = 0;; i++){
                if (scrollAnchorHeight < 0) {
                    if ($071334078f8d3f8a$var$isScrolledToBottom(sDOM)) {
                        scrollAnchorPos = -1;
                        scrollAnchorHeight = this.viewState.heightMap.height;
                    } else {
                        let block = this.viewState.scrollAnchorAt(scrollTop);
                        scrollAnchorPos = block.from;
                        scrollAnchorHeight = block.top;
                    }
                }
                this.updateState = 1 /* Measuring */ ;
                let changed = this.viewState.measure(this);
                if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
                if (i > 5) {
                    console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    break;
                }
                let measuring = [];
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* Viewport */ )) [this.measureRequests, measuring] = [
                    measuring,
                    this.measureRequests
                ];
                let measured = measuring.map((m)=>{
                    try {
                        return m.read(this);
                    } catch (e) {
                        $071334078f8d3f8a$export$f86b2a1a2ce291b3(this.state, e);
                        return $071334078f8d3f8a$var$BadMeasure;
                    }
                });
                let update = $071334078f8d3f8a$export$b5b084f95c87edf7.create(this, this.state, []), redrawn = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                this.updateState = 2 /* Updating */ ;
                if (!update.empty) {
                    this.updatePlugins(update);
                    this.inputState.update(update);
                    this.updateAttrs();
                    redrawn = this.docView.update(update);
                }
                for(let i = 0; i < measuring.length; i++)if (measured[i] != $071334078f8d3f8a$var$BadMeasure) try {
                    let m = measuring[i];
                    if (m.write) m.write(measured[i], this);
                } catch (e) {
                    $071334078f8d3f8a$export$f86b2a1a2ce291b3(this.state, e);
                }
                if (redrawn) this.docView.updateSelection(true);
                if (!update.viewportChanged && this.measureRequests.length == 0) {
                    if (this.viewState.editorHeight) {
                        if (this.viewState.scrollTarget) {
                            this.docView.scrollIntoView(this.viewState.scrollTarget);
                            this.viewState.scrollTarget = null;
                            continue;
                        } else {
                            let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
                            let diff = newAnchorHeight - scrollAnchorHeight;
                            if (diff > 1 || diff < -1) {
                                scrollTop = sDOM.scrollTop = scrollTop + diff;
                                scrollAnchorHeight = -1;
                                continue;
                            }
                        }
                    }
                    break;
                }
            }
        } finally{
            this.updateState = 0 /* Idle */ ;
            this.measureScheduled = -1;
        }
        if (updated && !updated.empty) for (let listener of this.state.facet($071334078f8d3f8a$var$updateListener))listener(updated);
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return $071334078f8d3f8a$var$baseThemeID + " " + (this.state.facet($071334078f8d3f8a$var$darkTheme) ? $071334078f8d3f8a$var$baseDarkID : $071334078f8d3f8a$var$baseLightID) + " " + this.state.facet($071334078f8d3f8a$var$theme);
    }
    updateAttrs() {
        let editorAttrs = $071334078f8d3f8a$var$attrsFromFacet(this, $071334078f8d3f8a$var$editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        let contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            translate: "no",
            contenteditable: !this.state.facet($071334078f8d3f8a$var$editable) ? "false" : "true",
            class: "cm-content",
            style: `${$071334078f8d3f8a$var$browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        $071334078f8d3f8a$var$attrsFromFacet(this, $071334078f8d3f8a$var$contentAttributes, contentAttrs);
        let changed = this.observer.ignore(()=>{
            let changedContent = $071334078f8d3f8a$var$updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            let changedEditor = $071334078f8d3f8a$var$updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        let first = true;
        for (let tr of trs)for (let effect of tr.effects)if (effect.is($071334078f8d3f8a$export$eece2fccabbb77c5.announce)) {
            if (first) this.announceDOM.textContent = "";
            first = false;
            let div = this.announceDOM.appendChild(document.createElement("div"));
            div.textContent = effect.value;
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet($071334078f8d3f8a$var$styleModule);
        (0, $luNHI.StyleModule).mount(this.root, this.styleModules.concat($071334078f8d3f8a$var$baseTheme$1).reverse());
    }
    readMeasured() {
        if (this.updateState == 2 /* Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = this.win.requestAnimationFrame(()=>this.measure());
        if (request) {
            if (this.measureRequests.indexOf(request) > -1) return;
            if (request.key != null) {
                for(let i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        let known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.spec != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.spec == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
    height, again interpreted relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return $071334078f8d3f8a$var$skipAtoms(this, start, $071334078f8d3f8a$var$moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return $071334078f8d3f8a$var$skipAtoms(this, start, $071334078f8d3f8a$var$moveByChar(this, start, forward, (initial)=>$071334078f8d3f8a$var$byGroup(this, start.head, initial)));
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward, includeWrap = true) {
        return $071334078f8d3f8a$var$moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return $071334078f8d3f8a$var$skipAtoms(this, start, $071334078f8d3f8a$var$moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos) {
        return this.docView.domAtPos(pos);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node, offset = 0) {
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords, precise = true) {
        this.readMeasured();
        return $071334078f8d3f8a$var$posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos, side = 1) {
        this.readMeasured();
        let rect = this.docView.coordsAt(pos, side);
        if (!rect || rect.left == rect.right) return rect;
        let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        let span = order[$071334078f8d3f8a$export$e1ed96b746bb516a.find(order, pos - line.from, -1, side)];
        return $071334078f8d3f8a$var$flattenRect(rect, span.dir == $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR == side > 0);
    }
    /**
    Return the rectangle around a given character. If `pos` does not
    point in front of a character that is in the viewport and
    rendered (i.e. not replaced, not a line break), this will return
    null. For space characters that are a line wrap point, this will
    return the position before the line break.
    */ coordsForChar(pos) {
        this.readMeasured();
        return this.docView.coordsForChar(pos);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        let perLine = this.state.facet($071334078f8d3f8a$var$perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > $071334078f8d3f8a$var$MaxBidiLine) return $071334078f8d3f8a$var$trivialOrder(line.length);
        let dir = this.textDirectionAt(line.from);
        for (let entry of this.bidiCache)if (entry.from == line.from && entry.dir == dir) return entry.order;
        let order = $071334078f8d3f8a$var$computeOrder(line.text, dir);
        this.bidiCache.push(new $071334078f8d3f8a$var$CachedOrder(line.from, line.to, dir, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (this.dom.ownerDocument.hasFocus() || $071334078f8d3f8a$var$browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            $071334078f8d3f8a$var$focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
    necessary when moving the editor's existing DOM to a new window or shadow root.
    */ setRoot(root) {
        if (this._root != root) {
            this._root = root;
            this.observer.setWindow((root.nodeType == 9 ? root : root.ownerDocument).defaultView || window);
            this.mountStyles();
        }
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        for (let plugin of this.plugins)plugin.destroy(this);
        this.plugins = [];
        this.inputState.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos, options = {}) {
        return $071334078f8d3f8a$var$scrollIntoView.of(new $071334078f8d3f8a$var$ScrollTarget(typeof pos == "number" ? (0, $hB7kI.EditorSelection).cursor(pos) : pos, options.y, options.x, options.yMargin, options.xMargin));
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return $071334078f8d3f8a$export$44d5eccfd62adda7.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        let prefix = (0, $luNHI.StyleModule).newName();
        let result = [
            $071334078f8d3f8a$var$theme.of(prefix),
            $071334078f8d3f8a$var$styleModule.of($071334078f8d3f8a$var$buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push($071334078f8d3f8a$var$darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, $hB7kI.Prec).lowest($071334078f8d3f8a$var$styleModule.of($071334078f8d3f8a$var$buildTheme("." + $071334078f8d3f8a$var$baseThemeID, spec, $071334078f8d3f8a$var$lightDarkIDs)));
    }
    /**
    Retrieve an editor view instance from the view's DOM
    representation.
    */ static findFromDOM(dom) {
        var _a;
        let content = dom.querySelector(".cm-content");
        let cView = content && $071334078f8d3f8a$var$ContentView.get(content) || $071334078f8d3f8a$var$ContentView.get(dom);
        return ((_a = cView === null || cView === void 0 ? void 0 : cView.rootView) === null || _a === void 0 ? void 0 : _a.view) || null;
    }
}
/**
Facet to add a [style
module](https://github.com/marijnh/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.styleModule = $071334078f8d3f8a$var$styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.inputHandler = $071334078f8d3f8a$var$inputHandler;
/**
This facet can be used to provide functions that create effects
to be dispatched when the editor's focus state changes.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.focusChangeEffect = $071334078f8d3f8a$var$focusChangeEffect;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.perLineTextDirection = $071334078f8d3f8a$var$perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.exceptionSink = $071334078f8d3f8a$var$exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.updateListener = $071334078f8d3f8a$var$updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.editable = $071334078f8d3f8a$var$editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.mouseSelectionStyle = $071334078f8d3f8a$var$mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.dragMovesSelection = $071334078f8d3f8a$var$dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.clickAddsSelectionRange = $071334078f8d3f8a$var$clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.

If you want decorated ranges to behave like atomic units for
cursor motion and deletion purposes, also provide the range set
containing the decorations to
[`EditorView.atomicRanges`](https://codemirror.net/6/docs/ref/#view.EditorView^atomicRanges).
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.decorations = $071334078f8d3f8a$var$decorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.atomicRanges = $071334078f8d3f8a$var$atomicRanges;
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter).
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.scrollMargins = $071334078f8d3f8a$var$scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.darkTheme = $071334078f8d3f8a$var$darkTheme;
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.contentAttributes = $071334078f8d3f8a$var$contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.editorAttributes = $071334078f8d3f8a$var$editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.lineWrapping = /*@__PURE__*/ $071334078f8d3f8a$export$eece2fccabbb77c5.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ $071334078f8d3f8a$export$eece2fccabbb77c5.announce = /*@__PURE__*/ (0, $hB7kI.StateEffect).define();
// Maximum line length for which we compute accurate bidi info
const $071334078f8d3f8a$var$MaxBidiLine = 4096;
const $071334078f8d3f8a$var$BadMeasure = {};
class $071334078f8d3f8a$var$CachedOrder {
    constructor(from, to, dir, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.order = order;
    }
    static update(cache, changes) {
        if (changes.empty) return cache;
        let result = [], lastDir = cache.length ? cache[cache.length - 1].dir : $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR;
        for(let i = Math.max(0, cache.length - 10); i < cache.length; i++){
            let entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new $071334078f8d3f8a$var$CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.order));
        }
        return result;
    }
}
function $071334078f8d3f8a$var$attrsFromFacet(view, facet, base) {
    for(let sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        let source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) $071334078f8d3f8a$var$combineAttrs(value, base);
    }
    return base;
}
const $071334078f8d3f8a$var$currentPlatform = $071334078f8d3f8a$var$browser.mac ? "mac" : $071334078f8d3f8a$var$browser.windows ? "win" : $071334078f8d3f8a$var$browser.linux ? "linux" : "key";
function $071334078f8d3f8a$var$normalizeKeyName(name, platform) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; ++i){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $071334078f8d3f8a$var$modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
const $071334078f8d3f8a$var$handleKeyEvents = /*@__PURE__*/ (0, $hB7kI.Prec).default(/*@__PURE__*/ $071334078f8d3f8a$export$eece2fccabbb77c5.domEventHandlers({
    keydown (event, view) {
        return $071334078f8d3f8a$var$runHandlers($071334078f8d3f8a$var$getKeymap(view.state), event, view, "editor");
    }
}));
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ const $071334078f8d3f8a$export$5043418e2ef368d5 = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    enables: $071334078f8d3f8a$var$handleKeyEvents
});
const $071334078f8d3f8a$var$Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function $071334078f8d3f8a$var$getKeymap(state) {
    let bindings = state.facet($071334078f8d3f8a$export$5043418e2ef368d5);
    let map = $071334078f8d3f8a$var$Keymaps.get(bindings);
    if (!map) $071334078f8d3f8a$var$Keymaps.set(bindings, map = $071334078f8d3f8a$var$buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function $071334078f8d3f8a$export$bce154f45536286e(view, event, scope) {
    return $071334078f8d3f8a$var$runHandlers($071334078f8d3f8a$var$getKeymap(view.state), event, view, scope);
}
let $071334078f8d3f8a$var$storedPrefix = null;
const $071334078f8d3f8a$var$PrefixTimeout = 4000;
function $071334078f8d3f8a$var$buildKeymap(bindings, platform = $071334078f8d3f8a$var$currentPlatform) {
    let bound = Object.create(null);
    let isPrefix = Object.create(null);
    let checkPrefix = (name, is)=>{
        let current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    let add = (scope, key, command, preventDefault, stopPropagation)=>{
        var _a, _b;
        let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        let parts = key.split(/ (?!$)/).map((k)=>$071334078f8d3f8a$var$normalizeKeyName(k, platform));
        for(let i = 1; i < parts.length; i++){
            let prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                stopPropagation: false,
                run: [
                    (view)=>{
                        let ourObj = $071334078f8d3f8a$var$storedPrefix = {
                            view: view,
                            prefix: prefix,
                            scope: scope
                        };
                        setTimeout(()=>{
                            if ($071334078f8d3f8a$var$storedPrefix == ourObj) $071334078f8d3f8a$var$storedPrefix = null;
                        }, $071334078f8d3f8a$var$PrefixTimeout);
                        return true;
                    }
                ]
            };
        }
        let full = parts.join(" ");
        checkPrefix(full, false);
        let binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            stopPropagation: false,
            run: ((_b = (_a = scopeObj._any) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
        });
        if (command) binding.run.push(command);
        if (preventDefault) binding.preventDefault = true;
        if (stopPropagation) binding.stopPropagation = true;
    };
    for (let b of bindings){
        let scopes = b.scope ? b.scope.split(" ") : [
            "editor"
        ];
        if (b.any) for (let scope of scopes){
            let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
            if (!scopeObj._any) scopeObj._any = {
                preventDefault: false,
                stopPropagation: false,
                run: []
            };
            for(let key in scopeObj)scopeObj[key].run.push(b.any);
        }
        let name = b[platform] || b.key;
        if (!name) continue;
        for (let scope of scopes){
            add(scope, name, b.run, b.preventDefault, b.stopPropagation);
            if (b.shift) add(scope, "Shift-" + name, b.shift, b.preventDefault, b.stopPropagation);
        }
    }
    return bound;
}
function $071334078f8d3f8a$var$runHandlers(map, event, view, scope) {
    let name = (0, $lNHdE.keyName)(event);
    let charCode = (0, $hB7kI.codePointAt)(name, 0), isChar = (0, $hB7kI.codePointSize)(charCode) == name.length && name != " ";
    let prefix = "", handled = false, prevented = false, stopPropagation = false;
    if ($071334078f8d3f8a$var$storedPrefix && $071334078f8d3f8a$var$storedPrefix.view == view && $071334078f8d3f8a$var$storedPrefix.scope == scope) {
        prefix = $071334078f8d3f8a$var$storedPrefix.prefix + " ";
        if ($071334078f8d3f8a$var$modifierCodes.indexOf(event.keyCode) < 0) {
            prevented = true;
            $071334078f8d3f8a$var$storedPrefix = null;
        }
    }
    let ran = new Set;
    let runFor = (binding)=>{
        if (binding) {
            for (let cmd of binding.run)if (!ran.has(cmd)) {
                ran.add(cmd);
                if (cmd(view, event)) {
                    if (binding.stopPropagation) stopPropagation = true;
                    return true;
                }
            }
            if (binding.preventDefault) {
                if (binding.stopPropagation) stopPropagation = true;
                prevented = true;
            }
        }
        return false;
    };
    let scopeObj = map[scope], baseName, shiftName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + $071334078f8d3f8a$var$modifiers(name, event, !isChar)])) handled = true;
        else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
        !($071334078f8d3f8a$var$browser.windows && event.ctrlKey && event.altKey) && (baseName = (0, $lNHdE.base)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + $071334078f8d3f8a$var$modifiers(baseName, event, true)])) handled = true;
            else if (event.shiftKey && (shiftName = (0, $lNHdE.shift)[event.keyCode]) != name && shiftName != baseName && runFor(scopeObj[prefix + $071334078f8d3f8a$var$modifiers(shiftName, event, false)])) handled = true;
        } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + $071334078f8d3f8a$var$modifiers(name, event, true)])) handled = true;
        if (!handled && runFor(scopeObj._any)) handled = true;
    }
    if (prevented) handled = true;
    if (handled && stopPropagation) event.stopPropagation();
    return handled;
}
/**
Implementation of [`LayerMarker`](https://codemirror.net/6/docs/ref/#view.LayerMarker) that creates
a rectangle at a given set of coordinates.
*/ class $071334078f8d3f8a$export$9ddce7bd14f42a78 {
    /**
    Create a marker with the given class and dimensions. If `width`
    is null, the DOM element will get no width style.
    */ constructor(className, left, top, width, height){
        this.className = className;
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    draw() {
        let elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    update(elt, prev) {
        if (prev.className != this.className) return false;
        this.adjust(elt);
        return true;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width != null) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
    /**
    Create a set of rectangles for the given selection range,
    assigning them theclass`className`. Will create a single
    rectangle for empty ranges, and a set of selection-style
    rectangles covering the range's content (in a bidi-aware
    way) for non-empty ones.
    */ static forRange(view, className, range) {
        if (range.empty) {
            let pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (!pos) return [];
            let base = $071334078f8d3f8a$var$getBase(view);
            return [
                new $071334078f8d3f8a$export$9ddce7bd14f42a78(className, pos.left - base.left, pos.top - base.top, null, pos.bottom - pos.top)
            ];
        } else return $071334078f8d3f8a$var$rectanglesForRange(view, className, range);
    }
}
function $071334078f8d3f8a$var$getBase(view) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let left = view.textDirection == $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth;
    return {
        left: left - view.scrollDOM.scrollLeft,
        top: rect.top - view.scrollDOM.scrollTop
    };
}
function $071334078f8d3f8a$var$wrappedLine(view, pos, inside) {
    let range = (0, $hB7kI.EditorSelection).cursor(pos);
    return {
        from: Math.max(inside.from, view.moveToLineBoundary(range, false, true).from),
        to: Math.min(inside.to, view.moveToLineBoundary(range, true, true).from),
        type: $071334078f8d3f8a$export$48808c686fe495c4.Text
    };
}
function $071334078f8d3f8a$var$rectanglesForRange(view, className, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    let from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    let ltr = view.textDirection == $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR;
    let content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = $071334078f8d3f8a$var$getBase(view);
    let lineElt = content.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
    let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
    let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
    let startBlock = $071334078f8d3f8a$var$blockAt(view, from), endBlock = $071334078f8d3f8a$var$blockAt(view, to);
    let visualStart = startBlock.type == $071334078f8d3f8a$export$48808c686fe495c4.Text ? startBlock : null;
    let visualEnd = endBlock.type == $071334078f8d3f8a$export$48808c686fe495c4.Text ? endBlock : null;
    if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks)) visualStart = $071334078f8d3f8a$var$wrappedLine(view, from, visualStart);
    if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks)) visualEnd = $071334078f8d3f8a$var$wrappedLine(view, to, visualEnd);
    if (visualStart && visualEnd && visualStart.from == visualEnd.from) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        let top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        let bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        let between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top.bottom + view.defaultLineHeight / 2 < bottom.top) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == $071334078f8d3f8a$export$48808c686fe495c4.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new $071334078f8d3f8a$export$9ddce7bd14f42a78(className, left - base.left, top - base.top - 0.01 /* Epsilon */ , right - left, bottom - top + 0.01 /* Epsilon */ );
    }
    function pieces({ top: top, bottom: bottom, horizontal: horizontal }) {
        let pieces = [];
        for(let i = 0; i < horizontal.length; i += 2)pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        let top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            let fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            let toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            if (!fromCoords || !toCoords) return;
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        let start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        // Split the range by visible range and document line
        for (let r of view.visibleRanges)if (r.to > start && r.from < end) for(let pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
            let docLine = view.state.doc.lineAt(pos);
            for (let span of view.bidiSpans(docLine)){
                let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                if (spanFrom >= endPos) break;
                if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
            }
            pos = docLine.to + 1;
            if (pos >= endPos) break;
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top: top,
            bottom: bottom,
            horizontal: horizontal
        };
    }
    function drawForWidget(block, top) {
        let y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function $071334078f8d3f8a$var$sameMarker(a, b) {
    return a.constructor == b.constructor && a.eq(b);
}
class $071334078f8d3f8a$var$LayerView {
    constructor(view, layer){
        this.view = view;
        this.layer = layer;
        this.drawn = [];
        this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        };
        this.dom = view.scrollDOM.appendChild(document.createElement("div"));
        this.dom.classList.add("cm-layer");
        if (layer.above) this.dom.classList.add("cm-layer-above");
        if (layer.class) this.dom.classList.add(layer.class);
        this.dom.setAttribute("aria-hidden", "true");
        this.setOrder(view.state);
        view.requestMeasure(this.measureReq);
        if (layer.mount) layer.mount(this.dom, view);
    }
    update(update) {
        if (update.startState.facet($071334078f8d3f8a$var$layerOrder) != update.state.facet($071334078f8d3f8a$var$layerOrder)) this.setOrder(update.state);
        if (this.layer.update(update, this.dom) || update.geometryChanged) update.view.requestMeasure(this.measureReq);
    }
    setOrder(state) {
        let pos = 0, order = state.facet($071334078f8d3f8a$var$layerOrder);
        while(pos < order.length && order[pos] != this.layer)pos++;
        this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
    }
    measure() {
        return this.layer.markers(this.view);
    }
    draw(markers) {
        if (markers.length != this.drawn.length || markers.some((p, i)=>!$071334078f8d3f8a$var$sameMarker(p, this.drawn[i]))) {
            let old = this.dom.firstChild, oldI = 0;
            for (let marker of markers)if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
                old = old.nextSibling;
                oldI++;
            } else this.dom.insertBefore(marker.draw(), old);
            while(old){
                let next = old.nextSibling;
                old.remove();
                old = next;
            }
            this.drawn = markers;
        }
    }
    destroy() {
        if (this.layer.destroy) this.layer.destroy(this.dom, this.view);
        this.dom.remove();
    }
}
const $071334078f8d3f8a$var$layerOrder = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
Define a layer.
*/ function $071334078f8d3f8a$export$50a222d9023da98b(config) {
    return [
        $071334078f8d3f8a$export$44d5eccfd62adda7.define((v)=>new $071334078f8d3f8a$var$LayerView(v, config)),
        $071334078f8d3f8a$var$layerOrder.of(config)
    ];
}
const $071334078f8d3f8a$var$CanHidePrimary = !$071334078f8d3f8a$var$browser.ios; // FIXME test IE
const $071334078f8d3f8a$var$selectionConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (configs) {
        return (0, $hB7kI.combineConfig)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function $071334078f8d3f8a$export$17a3d0ab3687347d(config = {}) {
    return [
        $071334078f8d3f8a$var$selectionConfig.of(config),
        $071334078f8d3f8a$var$cursorLayer,
        $071334078f8d3f8a$var$selectionLayer,
        $071334078f8d3f8a$var$hideNativeSelection,
        $071334078f8d3f8a$var$nativeSelectionHidden.of(true)
    ];
}
function $071334078f8d3f8a$var$configChanged(update) {
    return update.startState.facet($071334078f8d3f8a$var$selectionConfig) != update.state.facet($071334078f8d3f8a$var$selectionConfig);
}
const $071334078f8d3f8a$var$cursorLayer = /*@__PURE__*/ $071334078f8d3f8a$export$50a222d9023da98b({
    above: true,
    markers (view) {
        let { state: state } = view, conf = state.facet($071334078f8d3f8a$var$selectionConfig);
        let cursors = [];
        for (let r of state.selection.ranges){
            let prim = r == state.selection.main;
            if (r.empty ? !prim || $071334078f8d3f8a$var$CanHidePrimary : conf.drawRangeCursor) {
                let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
                let cursor = r.empty ? r : (0, $hB7kI.EditorSelection).cursor(r.head, r.head > r.anchor ? -1 : 1);
                for (let piece of $071334078f8d3f8a$export$9ddce7bd14f42a78.forRange(view, className, cursor))cursors.push(piece);
            }
        }
        return cursors;
    },
    update (update, dom) {
        if (update.transactions.some((tr)=>tr.selection)) dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        let confChange = $071334078f8d3f8a$var$configChanged(update);
        if (confChange) $071334078f8d3f8a$var$setBlinkRate(update.state, dom);
        return update.docChanged || update.selectionSet || confChange;
    },
    mount (dom, view) {
        $071334078f8d3f8a$var$setBlinkRate(view.state, dom);
    },
    class: "cm-cursorLayer"
});
function $071334078f8d3f8a$var$setBlinkRate(state, dom) {
    dom.style.animationDuration = state.facet($071334078f8d3f8a$var$selectionConfig).cursorBlinkRate + "ms";
}
const $071334078f8d3f8a$var$selectionLayer = /*@__PURE__*/ $071334078f8d3f8a$export$50a222d9023da98b({
    above: false,
    markers (view) {
        return view.state.selection.ranges.map((r)=>r.empty ? [] : $071334078f8d3f8a$export$9ddce7bd14f42a78.forRange(view, "cm-selectionBackground", r)).reduce((a, b)=>a.concat(b));
    },
    update (update, dom) {
        return update.docChanged || update.selectionSet || update.viewportChanged || $071334078f8d3f8a$var$configChanged(update);
    },
    class: "cm-selectionLayer"
});
const $071334078f8d3f8a$var$themeSpec = {
    ".cm-line": {
        "& ::selection": {
            backgroundColor: "transparent !important"
        },
        "&::selection": {
            backgroundColor: "transparent !important"
        }
    }
};
if ($071334078f8d3f8a$var$CanHidePrimary) $071334078f8d3f8a$var$themeSpec[".cm-line"].caretColor = "transparent !important";
const $071334078f8d3f8a$var$hideNativeSelection = /*@__PURE__*/ (0, $hB7kI.Prec).highest(/*@__PURE__*/ $071334078f8d3f8a$export$eece2fccabbb77c5.theme($071334078f8d3f8a$var$themeSpec));
const $071334078f8d3f8a$var$setDropCursorPos = /*@__PURE__*/ (0, $hB7kI.StateEffect).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
const $071334078f8d3f8a$var$dropCursorPos = /*@__PURE__*/ (0, $hB7kI.StateField).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is($071334078f8d3f8a$var$setDropCursorPos) ? e.value : pos, pos);
    }
});
const $071334078f8d3f8a$var$drawDropCursor = /*@__PURE__*/ $071334078f8d3f8a$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    update(update) {
        var _a;
        let cursorPos = update.state.field($071334078f8d3f8a$var$dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field($071334078f8d3f8a$var$dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        let pos = this.view.state.field($071334078f8d3f8a$var$dropCursorPos);
        let rect = pos != null && this.view.coordsAtPos(pos);
        if (!rect) return null;
        let outer = this.view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + this.view.scrollDOM.scrollLeft,
            top: rect.top - outer.top + this.view.scrollDOM.scrollTop,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            if (pos) {
                this.cursor.style.left = pos.left + "px";
                this.cursor.style.top = pos.top + "px";
                this.cursor.style.height = pos.height + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field($071334078f8d3f8a$var$dropCursorPos) != pos) this.view.dispatch({
            effects: $071334078f8d3f8a$var$setDropCursorPos.of(pos)
        });
    }
}, {
    eventHandlers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function $071334078f8d3f8a$export$b8e3092a3bfa2062() {
    return [
        $071334078f8d3f8a$var$dropCursorPos,
        $071334078f8d3f8a$var$drawDropCursor
    ];
}
function $071334078f8d3f8a$var$iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(let cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, m);
    }
}
function $071334078f8d3f8a$var$matchRanges(view, maxLength) {
    let visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    let result = [];
    for (let { from: from, to: to } of visible){
        from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
        to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
        if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
        else result.push({
            from: from,
            to: to
        });
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class $071334078f8d3f8a$export$9b928b0ca20b25cb {
    /**
    Create a decorator.
    */ constructor(config){
        const { regexp: regexp, decoration: decoration, decorate: decorate, boundary: boundary, maxLength: maxLength = 1000 } = config;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        if (decorate) this.addMatch = (match, view, from, add)=>decorate(add, from, from + match[0].length, match, view);
        else if (typeof decoration == "function") this.addMatch = (match, view, from, add)=>{
            let deco = decoration(match, view, from);
            if (deco) add(from, from + match[0].length, deco);
        };
        else if (decoration) this.addMatch = (match, _view, from, add)=>add(from, from + match[0].length, decoration);
        else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        let build = new (0, $hB7kI.RangeSetBuilder)(), add = build.add.bind(build);
        for (let { from: from, to: to } of $071334078f8d3f8a$var$matchRanges(view, this.maxLength))$071334078f8d3f8a$var$iterMatches(view.state.doc, this.regexp, from, to, (from, m)=>this.addMatch(m, view, from, add));
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        let changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to > update.view.viewport.from && from < update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportChanged || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        for (let r of view.visibleRanges){
            let from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
            if (to > from) {
                let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                if (this.boundary) {
                    for(; from > fromLine.from; from--)if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                        start = from;
                        break;
                    }
                    for(; to < toLine.to; to++)if (this.boundary.test(toLine.text[to - toLine.from])) {
                        end = to;
                        break;
                    }
                }
                let ranges = [], m;
                let add = (from, to, deco)=>ranges.push(deco.range(from, to));
                if (fromLine == toLine) {
                    this.regexp.lastIndex = start - fromLine.from;
                    while((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)this.addMatch(m, view, m.index + fromLine.from, add);
                } else $071334078f8d3f8a$var$iterMatches(view.state.doc, this.regexp, start, end, (from, m)=>this.addMatch(m, view, from, add));
                deco = deco.update({
                    filterFrom: start,
                    filterTo: end,
                    filter: (from, to)=>from < start || to > end,
                    add: ranges
                });
            }
        }
        return deco;
    }
}
const $071334078f8d3f8a$var$UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const $071334078f8d3f8a$var$Specials = /*@__PURE__*/ new RegExp("[\x00-\b\n-\x1f\x7f-\x9f\xad؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]", $071334078f8d3f8a$var$UnicodeRegexpSupport);
const $071334078f8d3f8a$var$Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
let $071334078f8d3f8a$var$_supportsTabSize = null;
function $071334078f8d3f8a$var$supportsTabSize() {
    var _a;
    if ($071334078f8d3f8a$var$_supportsTabSize == null && typeof document != "undefined" && document.body) {
        let styles = document.body.style;
        $071334078f8d3f8a$var$_supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return $071334078f8d3f8a$var$_supportsTabSize || false;
}
const $071334078f8d3f8a$var$specialCharConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (configs) {
        let config = (0, $hB7kI.combineConfig)(configs, {
            render: null,
            specialChars: $071334078f8d3f8a$var$Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !$071334078f8d3f8a$var$supportsTabSize()) config.specialChars = new RegExp("	|" + config.specialChars.source, $071334078f8d3f8a$var$UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, $071334078f8d3f8a$var$UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function $071334078f8d3f8a$export$76dc0899547f659c(/**
Configuration options.
*/ config = {}) {
    return [
        $071334078f8d3f8a$var$specialCharConfig.of(config),
        $071334078f8d3f8a$var$specialCharPlugin()
    ];
}
let $071334078f8d3f8a$var$_plugin = null;
function $071334078f8d3f8a$var$specialCharPlugin() {
    return $071334078f8d3f8a$var$_plugin || ($071334078f8d3f8a$var$_plugin = $071334078f8d3f8a$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.decorations = $071334078f8d3f8a$export$10e30b733df217ea.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet($071334078f8d3f8a$var$specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
        makeDecorator(conf) {
            return new $071334078f8d3f8a$export$9b928b0ca20b25cb({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    let { doc: doc } = view.state;
                    let code = (0, $hB7kI.codePointAt)(m[0], 0);
                    if (code == 9) {
                        let line = doc.lineAt(pos);
                        let size = view.state.tabSize, col = (0, $hB7kI.countColumn)(line.text, size, pos - line.from);
                        return $071334078f8d3f8a$export$10e30b733df217ea.replace({
                            widget: new $071334078f8d3f8a$var$TabWidget((size - col % size) * this.view.defaultCharacterWidth)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = $071334078f8d3f8a$export$10e30b733df217ea.replace({
                        widget: new $071334078f8d3f8a$var$SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            let conf = update.state.facet($071334078f8d3f8a$var$specialCharConfig);
            if (update.startState.facet($071334078f8d3f8a$var$specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
const $071334078f8d3f8a$var$DefaultPlaceholder = "•";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function $071334078f8d3f8a$var$placeholder$1(code) {
    if (code >= 32) return $071334078f8d3f8a$var$DefaultPlaceholder;
    if (code == 10) return "␤";
    return String.fromCharCode(9216 + code);
}
class $071334078f8d3f8a$var$SpecialCharWidget extends $071334078f8d3f8a$export$95cdd842edb044c5 {
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        let ph = $071334078f8d3f8a$var$placeholder$1(this.code);
        let desc = view.state.phrase("Control character") + " " + ($071334078f8d3f8a$var$Names[this.code] || "0x" + this.code.toString(16));
        let custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        let span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
class $071334078f8d3f8a$var$TabWidget extends $071334078f8d3f8a$export$95cdd842edb044c5 {
    constructor(width){
        super();
        this.width = width;
    }
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        let span = document.createElement("span");
        span.textContent = "	";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
const $071334078f8d3f8a$var$plugin = /*@__PURE__*/ $071334078f8d3f8a$export$44d5eccfd62adda7.fromClass(class {
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
    update(update) {
        let { view: view } = update;
        let height = view.viewState.editorHeight - view.defaultLineHeight - view.documentPadding.top - 0.5;
        if (height >= 0 && height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function $071334078f8d3f8a$export$1f905ef5d6deb4f() {
    return [
        $071334078f8d3f8a$var$plugin,
        $071334078f8d3f8a$var$contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin($071334078f8d3f8a$var$plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function $071334078f8d3f8a$export$1a7e096bee9035c() {
    return $071334078f8d3f8a$var$activeLineHighlighter;
}
const $071334078f8d3f8a$var$lineDeco = /*@__PURE__*/ $071334078f8d3f8a$export$10e30b733df217ea.line({
    class: "cm-activeLine"
});
const $071334078f8d3f8a$var$activeLineHighlighter = /*@__PURE__*/ $071334078f8d3f8a$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let lastLineStart = -1, deco = [];
        for (let r of view.state.selection.ranges){
            let line = view.lineBlockAt(r.head);
            if (line.from > lastLineStart) {
                deco.push($071334078f8d3f8a$var$lineDeco.range(line.from));
                lastLineStart = line.from;
            }
        }
        return $071334078f8d3f8a$export$10e30b733df217ea.set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
class $071334078f8d3f8a$var$Placeholder extends $071334078f8d3f8a$export$95cdd842edb044c5 {
    constructor(content){
        super();
        this.content = content;
    }
    toDOM() {
        let wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : this.content);
        if (typeof this.content == "string") wrap.setAttribute("aria-label", "placeholder " + this.content);
        else wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    coordsAt(dom) {
        let rects = dom.firstChild ? $071334078f8d3f8a$var$clientRectsFor(dom.firstChild) : [];
        if (!rects.length) return null;
        let style = window.getComputedStyle(dom.parentNode);
        let rect = $071334078f8d3f8a$var$flattenRect(rects[0], style.direction != "rtl");
        let lineHeight = parseInt(style.lineHeight);
        if (rect.bottom - rect.top > lineHeight * 1.5) return {
            left: rect.left,
            right: rect.right,
            top: rect.top,
            bottom: rect.top + lineHeight
        };
        return rect;
    }
    ignoreEvent() {
        return false;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function $071334078f8d3f8a$export$c7187bbd1a7a9244(content) {
    return $071334078f8d3f8a$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.placeholder = content ? $071334078f8d3f8a$export$10e30b733df217ea.set([
                $071334078f8d3f8a$export$10e30b733df217ea.widget({
                    widget: new $071334078f8d3f8a$var$Placeholder(content),
                    side: 1
                }).range(0)
            ]) : $071334078f8d3f8a$export$10e30b733df217ea.none;
        }
        get decorations() {
            return this.view.state.doc.length ? $071334078f8d3f8a$export$10e30b733df217ea.none : this.placeholder;
        }
    }, {
        decorations: (v)=>v.decorations
    });
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
const $071334078f8d3f8a$var$MaxOff = 2000;
function $071334078f8d3f8a$var$rectangleFor(state, a, b) {
    let startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    let ranges = [];
    if (a.off > $071334078f8d3f8a$var$MaxOff || b.off > $071334078f8d3f8a$var$MaxOff || a.col < 0 || b.col < 0) {
        let startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, $hB7kI.EditorSelection).range(line.from + startOff, line.to + endOff));
        }
    } else {
        let startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            let start = (0, $hB7kI.findColumn)(line.text, startCol, state.tabSize, true);
            if (start < 0) ranges.push((0, $hB7kI.EditorSelection).cursor(line.to));
            else {
                let end = (0, $hB7kI.findColumn)(line.text, endCol, state.tabSize);
                ranges.push((0, $hB7kI.EditorSelection).range(line.from + start, line.from + end));
            }
        }
    }
    return ranges;
}
function $071334078f8d3f8a$var$absoluteColumn(view, x) {
    let ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function $071334078f8d3f8a$var$getPos(view, event) {
    let offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let line = view.state.doc.lineAt(offset), off = offset - line.from;
    let col = off > $071334078f8d3f8a$var$MaxOff ? -1 : off == line.length ? $071334078f8d3f8a$var$absoluteColumn(view, event.clientX) : (0, $hB7kI.countColumn)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col: col,
        off: off
    };
}
function $071334078f8d3f8a$var$rectangleSelectionStyle(view, event) {
    let start = $071334078f8d3f8a$var$getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                let newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            let cur = $071334078f8d3f8a$var$getPos(view, event);
            if (!cur) return startSel;
            let ranges = $071334078f8d3f8a$var$rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, $hB7kI.EditorSelection).create(ranges.concat(startSel.ranges));
            else return (0, $hB7kI.EditorSelection).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function $071334078f8d3f8a$export$dd482925db1aabd3(options) {
    let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return $071334078f8d3f8a$export$eece2fccabbb77c5.mouseSelectionStyle.of((view, event)=>filter(event) ? $071334078f8d3f8a$var$rectangleSelectionStyle(view, event) : null);
}
const $071334078f8d3f8a$var$keys = {
    Alt: [
        18,
        (e)=>!!e.altKey
    ],
    Control: [
        17,
        (e)=>!!e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>!!e.shiftKey
    ],
    Meta: [
        91,
        (e)=>!!e.metaKey
    ]
};
const $071334078f8d3f8a$var$showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function $071334078f8d3f8a$export$9b6525222ac3b7fb(options = {}) {
    let [code, getter] = $071334078f8d3f8a$var$keys[options.key || "Alt"];
    let plugin = $071334078f8d3f8a$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
    }, {
        eventHandlers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            },
            mousemove (e) {
                this.set(getter(e));
            }
        }
    });
    return [
        plugin,
        $071334078f8d3f8a$export$eece2fccabbb77c5.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? $071334078f8d3f8a$var$showCrosshair : null;
        })
    ];
}
const $071334078f8d3f8a$var$Outside = "-10000px";
class $071334078f8d3f8a$var$TooltipViewManager {
    constructor(view, facet, createTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        this.tooltipViews = this.tooltips.map(createTooltipView);
    }
    update(update) {
        var _a;
        let input = update.state.facet(this.facet);
        let tooltips = input.filter((x)=>x);
        if (input === this.input) {
            for (let t of this.tooltipViews)if (t.update) t.update(update);
            return false;
        }
        let tooltipViews = [];
        for(let i = 0; i < tooltips.length; i++){
            let tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(let i = 0; i < this.tooltips.length; i++){
                let other = this.tooltips[i];
                if (other && other.create == tip.create) known = i;
            }
            if (known < 0) tooltipViews[i] = this.createTooltipView(tip);
            else {
                let tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        for (let t of this.tooltipViews)if (tooltipViews.indexOf(t) < 0) {
            t.dom.remove();
            (_a = t.destroy) === null || _a === void 0 || _a.call(t);
        }
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function $071334078f8d3f8a$export$1fc29293196e3bc(config = {}) {
    return $071334078f8d3f8a$var$tooltipConfig.of(config);
}
function $071334078f8d3f8a$var$windowSpace(view) {
    let { win: win } = view;
    return {
        top: 0,
        left: 0,
        bottom: win.innerHeight,
        right: win.innerWidth
    };
}
const $071334078f8d3f8a$var$tooltipConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: $071334078f8d3f8a$var$browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || $071334078f8d3f8a$var$windowSpace
        };
    }
});
const $071334078f8d3f8a$var$knownHeight = /*@__PURE__*/ new WeakMap();
const $071334078f8d3f8a$var$tooltipPlugin = /*@__PURE__*/ $071334078f8d3f8a$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.inView = true;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        let config = view.state.facet($071334078f8d3f8a$var$tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.manager = new $071334078f8d3f8a$var$TooltipViewManager(view, $071334078f8d3f8a$export$dba11b50e1aa3c12, (t)=>this.createTooltip(t));
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            for (let tooltip of this.manager.tooltipViews)this.intersectionObserver.observe(tooltip.dom);
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        let updated = this.manager.update(update);
        if (updated) this.observeIntersection();
        let shouldMeasure = updated || update.geometryChanged;
        let newConfig = update.state.facet($071334078f8d3f8a$var$tooltipConfig);
        if (newConfig.position != this.position) {
            this.position = newConfig.position;
            for (let t of this.manager.tooltipViews)t.dom.style.position = this.position;
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            for (let t of this.manager.tooltipViews)this.container.appendChild(t.dom);
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip) {
        let tooltipView = tooltip.create(this.view);
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            let arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.appendChild(arrow);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = $071334078f8d3f8a$var$Outside;
        this.container.appendChild(tooltipView.dom);
        if (tooltipView.mount) tooltipView.mount(this.view);
        return tooltipView;
    }
    destroy() {
        var _a, _b;
        this.view.win.removeEventListener("resize", this.measureSoon);
        for (let tooltipView of this.manager.tooltipViews){
            tooltipView.dom.remove();
            (_a = tooltipView.destroy) === null || _a === void 0 || _a.call(tooltipView);
        }
        (_b = this.intersectionObserver) === null || _b === void 0 || _b.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        let editor = this.view.dom.getBoundingClientRect();
        return {
            editor: editor,
            parent: this.parent ? this.container.getBoundingClientRect() : editor,
            pos: this.manager.tooltips.map((t, i)=>{
                let tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map(({ dom: dom })=>dom.getBoundingClientRect()),
            space: this.view.state.facet($071334078f8d3f8a$var$tooltipConfig).tooltipSpace(this.view)
        };
    }
    writeMeasure(measured) {
        var _a;
        let { editor: editor, space: space } = measured;
        let others = [];
        for(let i = 0; i < this.manager.tooltips.length; i++){
            let tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], { dom: dom } = tView;
            let pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || pos.bottom <= Math.max(editor.top, space.top) || pos.top >= Math.min(editor.bottom, space.bottom) || pos.right < Math.max(editor.left, space.left) - .1 || pos.left > Math.min(editor.right, space.right) + .1) {
                dom.style.top = $071334078f8d3f8a$var$Outside;
                continue;
            }
            let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            let arrowHeight = arrow ? 7 /* Size */  : 0;
            let width = size.right - size.left, height = (_a = $071334078f8d3f8a$var$knownHeight.get(tView)) !== null && _a !== void 0 ? _a : size.bottom - size.top;
            let offset = tView.offset || $071334078f8d3f8a$var$noOffset, ltr = this.view.textDirection == $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR;
            let left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.min(pos.left - (arrow ? 14 /* Offset */  : 0) + offset.x, space.right - width) : Math.max(space.left, pos.left - width + (arrow ? 14 /* Offset */  : 0) - offset.x);
            let above = !!tooltip.above;
            if (!tooltip.strictSide && (above ? pos.top - (size.bottom - size.top) - offset.y < space.top : pos.bottom + (size.bottom - size.top) + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = !above;
            let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
            if (spaceVert < height && tView.resize !== false) {
                if (spaceVert < this.view.defaultLineHeight) {
                    dom.style.top = $071334078f8d3f8a$var$Outside;
                    continue;
                }
                $071334078f8d3f8a$var$knownHeight.set(tView, height);
                dom.style.height = (height = spaceVert) + "px";
            } else if (dom.style.height) dom.style.height = "";
            let top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            let right = left + width;
            if (tView.overlap !== true) {
                for (let r of others)if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
            }
            if (this.position == "absolute") {
                dom.style.top = top - measured.parent.top + "px";
                dom.style.left = left - measured.parent.left + "px";
            } else {
                dom.style.top = top + "px";
                dom.style.left = left + "px";
            }
            if (arrow) arrow.style.left = `${pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Offset */  - 7 /* Size */ )}px`;
            if (tView.overlap !== true) others.push({
                left: left,
                top: top,
                right: right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned(measured.space);
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                if (!this.inView) for (let tv of this.manager.tooltipViews)tv.dom.style.top = $071334078f8d3f8a$var$Outside;
            }
        }
    }
}, {
    eventHandlers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
const $071334078f8d3f8a$var$baseTheme = /*@__PURE__*/ $071334078f8d3f8a$export$eece2fccabbb77c5.baseTheme({
    ".cm-tooltip": {
        zIndex: 100,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Size */ }px solid transparent`,
            borderRight: `${7 /* Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
const $071334078f8d3f8a$var$noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ const $071334078f8d3f8a$export$dba11b50e1aa3c12 = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    enables: [
        $071334078f8d3f8a$var$tooltipPlugin,
        $071334078f8d3f8a$var$baseTheme
    ]
});
const $071334078f8d3f8a$var$showHoverTooltip = /*@__PURE__*/ (0, $hB7kI.Facet).define();
class $071334078f8d3f8a$var$HoverTooltipHost {
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new $071334078f8d3f8a$var$TooltipViewManager(view, $071334078f8d3f8a$var$showHoverTooltip, (t)=>this.createHostedView(t));
    }
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new $071334078f8d3f8a$var$HoverTooltipHost(view);
    }
    createHostedView(tooltip) {
        let hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.appendChild(hostedView.dom);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.mount) hostedView.mount(view);
        this.mounted = true;
    }
    positioned(space) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.positioned) hostedView.positioned(space);
    }
    update(update) {
        this.manager.update(update);
    }
    destroy() {
        var _a;
        for (let t of this.manager.tooltipViews)(_a = t.destroy) === null || _a === void 0 || _a.call(t);
    }
}
const $071334078f8d3f8a$var$showHoverTooltipHost = /*@__PURE__*/ $071334078f8d3f8a$export$dba11b50e1aa3c12.compute([
    $071334078f8d3f8a$var$showHoverTooltip
], (state)=>{
    let tooltips = state.facet($071334078f8d3f8a$var$showHoverTooltip).filter((t)=>t);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.filter((t)=>t.end != null).map((t)=>t.end)),
        create: $071334078f8d3f8a$var$HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
class $071334078f8d3f8a$var$HoverPlugin {
    constructor(view, source, field, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update() {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active) return;
        let hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        let { lastMove: lastMove } = this;
        let pos = this.view.contentDOM.contains(lastMove.target) ? this.view.posAtCoords(lastMove) : null;
        if (pos == null) return;
        let posCoords = this.view.coordsAtPos(pos);
        if (posCoords == null || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - this.view.defaultCharacterWidth || lastMove.x > posCoords.right + this.view.defaultCharacterWidth) return;
        let bidi = this.view.bidiSpans(this.view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
        let rtl = bidi && bidi.dir == $071334078f8d3f8a$export$cacd6541cfeeb6c1.RTL ? -1 : 1;
        let open = this.source(this.view, pos, lastMove.x < posCoords.left ? -rtl : rtl);
        if (open === null || open === void 0 ? void 0 : open.then) {
            let pending = this.pending = {
                pos: pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    if (result) this.view.dispatch({
                        effects: this.setHover.of(result)
                    });
                }
            }, (e)=>$071334078f8d3f8a$export$f86b2a1a2ce291b3(this.view.state, e, "hover tooltip"));
        } else if (open) this.view.dispatch({
            effects: this.setHover.of(open)
        });
    }
    mousemove(event) {
        var _a;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        let tooltip = this.active;
        if (tooltip && !$071334078f8d3f8a$var$isInTooltip(this.lastMove.target) || this.pending) {
            let { pos: pos } = tooltip || this.pending, end = (_a = tooltip === null || tooltip === void 0 ? void 0 : tooltip.end) !== null && _a !== void 0 ? _a : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !$071334078f8d3f8a$var$isOverRange(this.view, pos, end, event.clientX, event.clientY, 6 /* MaxDist */ )) {
                this.view.dispatch({
                    effects: this.setHover.of(null)
                });
                this.pending = null;
            }
        }
    }
    mouseleave(e) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        if (this.active && !$071334078f8d3f8a$var$isInTooltip(e.relatedTarget)) this.view.dispatch({
            effects: this.setHover.of(null)
        });
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
}
function $071334078f8d3f8a$var$isInTooltip(elt) {
    for(let cur = elt; cur; cur = cur.parentNode)if (cur.nodeType == 1 && cur.classList.contains("cm-tooltip")) return true;
    return false;
}
function $071334078f8d3f8a$var$isOverRange(view, from, to, x, y, margin) {
    let range = document.createRange();
    let fromDOM = view.domAtPos(from), toDOM = view.domAtPos(to);
    range.setEnd(toDOM.node, toDOM.offset);
    range.setStart(fromDOM.node, fromDOM.offset);
    let rects = range.getClientRects();
    range.detach();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        let dist = Math.max(rect.top - y, y - rect.bottom, rect.left - x, x - rect.right);
        if (dist <= margin) return true;
    }
    return false;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.
*/ function $071334078f8d3f8a$export$69f8d9e63c4aa884(source, options = {}) {
    let setHover = (0, $hB7kI.StateEffect).define();
    let hoverState = (0, $hB7kI.StateField).define({
        create () {
            return null;
        },
        update (value, tr) {
            if (value && (options.hideOnChange && (tr.docChanged || tr.selection) || options.hideOn && options.hideOn(tr, value))) return null;
            if (value && tr.docChanged) {
                let newPos = tr.changes.mapPos(value.pos, -1, (0, $hB7kI.MapMode).TrackDel);
                if (newPos == null) return null;
                let copy = Object.assign(Object.create(null), value);
                copy.pos = newPos;
                if (value.end != null) copy.end = tr.changes.mapPos(value.end);
                value = copy;
            }
            for (let effect of tr.effects){
                if (effect.is(setHover)) value = effect.value;
                if (effect.is($071334078f8d3f8a$var$closeHoverTooltipEffect)) value = null;
            }
            return value;
        },
        provide: (f)=>$071334078f8d3f8a$var$showHoverTooltip.from(f)
    });
    return [
        hoverState,
        $071334078f8d3f8a$export$44d5eccfd62adda7.define((view)=>new $071334078f8d3f8a$var$HoverPlugin(view, source, hoverState, setHover, options.hoverTime || 300 /* Time */ )),
        $071334078f8d3f8a$var$showHoverTooltipHost
    ];
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function $071334078f8d3f8a$export$46455b4476d4b8e1(view, tooltip) {
    let plugin = view.plugin($071334078f8d3f8a$var$tooltipPlugin);
    if (!plugin) return null;
    let found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function $071334078f8d3f8a$export$7864d875805bc1b0(state) {
    return state.facet($071334078f8d3f8a$var$showHoverTooltip).some((x)=>x);
}
const $071334078f8d3f8a$var$closeHoverTooltipEffect = /*@__PURE__*/ (0, $hB7kI.StateEffect).define();
/**
Transaction effect that closes all hover tooltips.
*/ const $071334078f8d3f8a$export$f6974094db6525a = /*@__PURE__*/ $071334078f8d3f8a$var$closeHoverTooltipEffect.of(null);
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function $071334078f8d3f8a$export$912859096d593b90(view) {
    var _a;
    (_a = view.plugin($071334078f8d3f8a$var$tooltipPlugin)) === null || _a === void 0 || _a.maybeMeasure();
}
const $071334078f8d3f8a$var$panelConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (configs) {
        let topContainer, bottomContainer;
        for (let c of configs){
            topContainer = topContainer || c.topContainer;
            bottomContainer = bottomContainer || c.bottomContainer;
        }
        return {
            topContainer: topContainer,
            bottomContainer: bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function $071334078f8d3f8a$export$8128819a2322681a(config) {
    return config ? [
        $071334078f8d3f8a$var$panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function $071334078f8d3f8a$export$7361ed18ff57179e(view, panel) {
    let plugin = view.plugin($071334078f8d3f8a$var$panelPlugin);
    let index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
const $071334078f8d3f8a$var$panelPlugin = /*@__PURE__*/ $071334078f8d3f8a$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.input = view.state.facet($071334078f8d3f8a$export$e89c3c9af31c1e3b);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        let conf = view.state.facet($071334078f8d3f8a$var$panelConfig);
        this.top = new $071334078f8d3f8a$var$PanelGroup(view, true, conf.topContainer);
        this.bottom = new $071334078f8d3f8a$var$PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        for (let p of this.panels){
            p.dom.classList.add("cm-panel");
            if (p.mount) p.mount();
        }
    }
    update(update) {
        let conf = update.state.facet($071334078f8d3f8a$var$panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new $071334078f8d3f8a$var$PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new $071334078f8d3f8a$var$PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        let input = update.state.facet($071334078f8d3f8a$export$e89c3c9af31c1e3b);
        if (input != this.input) {
            let specs = input.filter((x)=>x);
            let panels = [], top = [], bottom = [], mount = [];
            for (let spec of specs){
                let known = this.specs.indexOf(spec), panel;
                if (known < 0) {
                    panel = spec(update.view);
                    mount.push(panel);
                } else {
                    panel = this.panels[known];
                    if (panel.update) panel.update(update);
                }
                panels.push(panel);
                (panel.top ? top : bottom).push(panel);
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            for (let p of mount){
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } else {
            for (let p of this.panels)if (p.update) p.update(update);
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
}, {
    provide: (plugin)=>$071334078f8d3f8a$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class $071334078f8d3f8a$var$PanelGroup {
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
    sync(panels) {
        for (let p of this.panels)if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            this.dom.style[this.top ? "top" : "bottom"] = "0";
            let parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        let curDOM = this.dom.firstChild;
        for (let panel of this.panels)if (panel.dom.parentNode == this.dom) {
            while(curDOM != panel.dom)curDOM = $071334078f8d3f8a$var$rm(curDOM);
            curDOM = curDOM.nextSibling;
        } else this.dom.insertBefore(panel.dom, curDOM);
        while(curDOM)curDOM = $071334078f8d3f8a$var$rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        for (let cls of this.classes.split(" "))if (cls) this.container.classList.remove(cls);
        for (let cls of (this.classes = this.view.themeClasses).split(" "))if (cls) this.container.classList.add(cls);
    }
}
function $071334078f8d3f8a$var$rm(node) {
    let next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ const $071334078f8d3f8a$export$e89c3c9af31c1e3b = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    enables: $071334078f8d3f8a$var$panelPlugin
});
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class $071334078f8d3f8a$export$591ab4c909549043 extends (0, $hB7kI.RangeValue) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
$071334078f8d3f8a$export$591ab4c909549043.prototype.elementClass = "";
$071334078f8d3f8a$export$591ab4c909549043.prototype.toDOM = undefined;
$071334078f8d3f8a$export$591ab4c909549043.prototype.mapMode = (0, $hB7kI.MapMode).TrackBefore;
$071334078f8d3f8a$export$591ab4c909549043.prototype.startSide = $071334078f8d3f8a$export$591ab4c909549043.prototype.endSide = -1;
$071334078f8d3f8a$export$591ab4c909549043.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ const $071334078f8d3f8a$export$113bd64f27ac1172 = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, $hB7kI.RangeSet).empty,
    lineMarker: ()=>null,
    widgetMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {}
};
const $071334078f8d3f8a$var$activeGutters = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function $071334078f8d3f8a$export$f2b922cb4a245974(config) {
    return [
        $071334078f8d3f8a$export$ec15ef01b8fbae61(),
        $071334078f8d3f8a$var$activeGutters.of(Object.assign(Object.assign({}, $071334078f8d3f8a$var$defaults), config))
    ];
}
const $071334078f8d3f8a$var$unfixGutters = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function $071334078f8d3f8a$export$ec15ef01b8fbae61(config) {
    let result = [
        $071334078f8d3f8a$var$gutterView
    ];
    if (config && config.fixed === false) result.push($071334078f8d3f8a$var$unfixGutters.of(true));
    return result;
}
const $071334078f8d3f8a$var$gutterView = /*@__PURE__*/ $071334078f8d3f8a$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight + "px";
        this.gutters = view.state.facet($071334078f8d3f8a$var$activeGutters).map((conf)=>new $071334078f8d3f8a$var$SingleGutterView(view, conf));
        for (let gutter of this.gutters)this.dom.appendChild(gutter.dom);
        this.fixed = !view.state.facet($071334078f8d3f8a$var$unfixGutters);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            let vpA = this.prevViewport, vpB = update.view.viewport;
            let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) this.dom.style.minHeight = this.view.contentHeight + "px";
        if (this.view.state.facet($071334078f8d3f8a$var$unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        let after = this.dom.nextSibling;
        if (detach) this.dom.remove();
        let lineClasses = (0, $hB7kI.RangeSet).iter(this.view.state.facet($071334078f8d3f8a$export$113bd64f27ac1172), this.view.viewport.from);
        let classSet = [];
        let contexts = this.gutters.map((gutter)=>new $071334078f8d3f8a$var$UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        for (let line of this.view.viewportLineBlocks){
            if (classSet.length) classSet = [];
            if (Array.isArray(line.type)) {
                let first = true;
                for (let b of line.type){
                    if (b.type == $071334078f8d3f8a$export$48808c686fe495c4.Text && first) {
                        $071334078f8d3f8a$var$advanceCursor(lineClasses, classSet, b.from);
                        for (let cx of contexts)cx.line(this.view, b, classSet);
                        first = false;
                    } else if (b.widget) for (let cx of contexts)cx.widget(this.view, b);
                }
            } else if (line.type == $071334078f8d3f8a$export$48808c686fe495c4.Text) {
                $071334078f8d3f8a$var$advanceCursor(lineClasses, classSet, line.from);
                for (let cx of contexts)cx.line(this.view, line, classSet);
            }
        }
        for (let cx of contexts)cx.finish();
        if (detach) this.view.scrollDOM.insertBefore(this.dom, after);
    }
    updateGutters(update) {
        let prev = update.startState.facet($071334078f8d3f8a$var$activeGutters), cur = update.state.facet($071334078f8d3f8a$var$activeGutters);
        let change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, $hB7kI.RangeSet).eq(update.startState.facet($071334078f8d3f8a$export$113bd64f27ac1172), update.state.facet($071334078f8d3f8a$export$113bd64f27ac1172), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            for (let gutter of this.gutters)if (gutter.update(update)) change = true;
        } else {
            change = true;
            let gutters = [];
            for (let conf of cur){
                let known = prev.indexOf(conf);
                if (known < 0) gutters.push(new $071334078f8d3f8a$var$SingleGutterView(this.view, conf));
                else {
                    this.gutters[known].update(update);
                    gutters.push(this.gutters[known]);
                }
            }
            for (let g of this.gutters){
                g.dom.remove();
                if (gutters.indexOf(g) < 0) g.destroy();
            }
            for (let g of gutters)this.dom.appendChild(g.dom);
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        for (let view of this.gutters)view.destroy();
        this.dom.remove();
    }
}, {
    provide: (plugin)=>$071334078f8d3f8a$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            return view.textDirection == $071334078f8d3f8a$export$cacd6541cfeeb6c1.LTR ? {
                left: value.dom.offsetWidth
            } : {
                right: value.dom.offsetWidth
            };
        })
});
function $071334078f8d3f8a$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $071334078f8d3f8a$var$advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class $071334078f8d3f8a$var$UpdateContext {
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.i = 0;
        this.cursor = (0, $hB7kI.RangeSet).iter(gutter.markers, viewport.from);
    }
    addElement(view, block, markers) {
        let { gutter: gutter } = this, above = block.top - this.height;
        if (this.i == gutter.elements.length) {
            let newElt = new $071334078f8d3f8a$var$GutterElement(view, block.height, above, markers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, block.height, above, markers);
        this.height = block.bottom;
        this.i++;
    }
    line(view, line, extraMarkers) {
        let localMarkers = [];
        $071334078f8d3f8a$var$advanceCursor(this.cursor, localMarkers, line.from);
        if (extraMarkers.length) localMarkers = localMarkers.concat(extraMarkers);
        let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        let gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        this.addElement(view, line, localMarkers);
    }
    widget(view, block) {
        let marker = this.gutter.config.widgetMarker(view, block.widget, block);
        if (marker) this.addElement(view, block, [
            marker
        ]);
    }
    finish() {
        let gutter = this.gutter;
        while(gutter.elements.length > this.i){
            let last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
}
class $071334078f8d3f8a$var$SingleGutterView {
    constructor(view, config){
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(let prop in config.domEventHandlers)this.dom.addEventListener(prop, (event)=>{
            let target = event.target, y;
            if (target != this.dom && this.dom.contains(target)) {
                while(target.parentNode != this.dom)target = target.parentNode;
                let rect = target.getBoundingClientRect();
                y = (rect.top + rect.bottom) / 2;
            } else y = event.clientY;
            let line = view.lineBlockAtHeight(y - view.documentTop);
            if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
        });
        this.markers = $071334078f8d3f8a$var$asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new $071334078f8d3f8a$var$GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
    update(update) {
        let prevMarkers = this.markers;
        this.markers = $071334078f8d3f8a$var$asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            let updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        let vp = update.view.viewport;
        return !(0, $hB7kI.RangeSet).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        for (let elt of this.elements)elt.destroy();
    }
}
class $071334078f8d3f8a$var$GutterElement {
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
    update(view, height, above, markers) {
        if (this.height != height) this.dom.style.height = (this.height = height) + "px";
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!$071334078f8d3f8a$var$sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        let cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(let iNew = 0, iOld = 0;;){
            let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                let c = marker.elementClass;
                if (c) cls += " " + c;
                for(let i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                let next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    let after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
}
function $071334078f8d3f8a$var$sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ const $071334078f8d3f8a$export$dd0c91e0a7121f5f = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $071334078f8d3f8a$var$lineNumberConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (values) {
        return (0, $hB7kI.combineConfig)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                let result = Object.assign({}, a);
                for(let event in b){
                    let exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                }
                return result;
            }
        });
    }
});
class $071334078f8d3f8a$var$NumberMarker extends $071334078f8d3f8a$export$591ab4c909549043 {
    constructor(number){
        super();
        this.number = number;
    }
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
}
function $071334078f8d3f8a$var$formatNumber(view, number) {
    return view.state.facet($071334078f8d3f8a$var$lineNumberConfig).formatNumber(number, view.state);
}
const $071334078f8d3f8a$var$lineNumberGutter = /*@__PURE__*/ $071334078f8d3f8a$var$activeGutters.compute([
    $071334078f8d3f8a$var$lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet($071334078f8d3f8a$export$dd0c91e0a7121f5f);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new $071334078f8d3f8a$var$NumberMarker($071334078f8d3f8a$var$formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        widgetMarker: ()=>null,
        lineMarkerChange: (update)=>update.startState.facet($071334078f8d3f8a$var$lineNumberConfig) != update.state.facet($071334078f8d3f8a$var$lineNumberConfig),
        initialSpacer (view) {
            return new $071334078f8d3f8a$var$NumberMarker($071334078f8d3f8a$var$formatNumber(view, $071334078f8d3f8a$var$maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            let max = $071334078f8d3f8a$var$formatNumber(update.view, $071334078f8d3f8a$var$maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new $071334078f8d3f8a$var$NumberMarker(max);
        },
        domEventHandlers: state.facet($071334078f8d3f8a$var$lineNumberConfig).domEventHandlers
    }));
/**
Create a line number gutter extension.
*/ function $071334078f8d3f8a$export$1a8cf111682eaa7d(config = {}) {
    return [
        $071334078f8d3f8a$var$lineNumberConfig.of(config),
        $071334078f8d3f8a$export$ec15ef01b8fbae61(),
        $071334078f8d3f8a$var$lineNumberGutter
    ];
}
function $071334078f8d3f8a$var$maxLineNumber(lines) {
    let last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
const $071334078f8d3f8a$var$activeLineGutterMarker = /*@__PURE__*/ new class extends $071334078f8d3f8a$export$591ab4c909549043 {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
const $071334078f8d3f8a$var$activeLineGutterHighlighter = /*@__PURE__*/ $071334078f8d3f8a$export$113bd64f27ac1172.compute([
    "selection"
], (state)=>{
    let marks = [], last = -1;
    for (let range of state.selection.ranges){
        let linePos = state.doc.lineAt(range.head).from;
        if (linePos > last) {
            last = linePos;
            marks.push($071334078f8d3f8a$var$activeLineGutterMarker.range(linePos));
        }
    }
    return (0, $hB7kI.RangeSet).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function $071334078f8d3f8a$export$93b52f08bb2c759c() {
    return $071334078f8d3f8a$var$activeLineGutterHighlighter;
}
const $071334078f8d3f8a$var$WhitespaceDeco = /*@__PURE__*/ new Map();
function $071334078f8d3f8a$var$getWhitespaceDeco(space) {
    let deco = $071334078f8d3f8a$var$WhitespaceDeco.get(space);
    if (!deco) $071334078f8d3f8a$var$WhitespaceDeco.set(space, deco = $071334078f8d3f8a$export$10e30b733df217ea.mark({
        attributes: space === "	" ? {
            class: "cm-highlightTab"
        } : {
            class: "cm-highlightSpace",
            "data-display": space.replace(/ /g, "\xb7")
        }
    }));
    return deco;
}
function $071334078f8d3f8a$var$matcher(decorator) {
    return $071334078f8d3f8a$export$44d5eccfd62adda7.define((view)=>({
            decorations: decorator.createDeco(view),
            update (u) {
                this.decorations = decorator.updateDeco(u, this.decorations);
            }
        }), {
        decorations: (v)=>v.decorations
    });
}
const $071334078f8d3f8a$var$whitespaceHighlighter = /*@__PURE__*/ $071334078f8d3f8a$var$matcher(/*@__PURE__*/ new $071334078f8d3f8a$export$9b928b0ca20b25cb({
    regexp: /\t| +/g,
    decoration: (match)=>$071334078f8d3f8a$var$getWhitespaceDeco(match[0]),
    boundary: /\S/
}));
/**
Returns an extension that highlights whitespace, adding a
`cm-highlightSpace` class to stretches of spaces, and a
`cm-highlightTab` class to individual tab characters. By default,
the former are shown as faint dots, and the latter as arrows.
*/ function $071334078f8d3f8a$export$beeff585f23bdb79() {
    return $071334078f8d3f8a$var$whitespaceHighlighter;
}
const $071334078f8d3f8a$var$trailingHighlighter = /*@__PURE__*/ $071334078f8d3f8a$var$matcher(/*@__PURE__*/ new $071334078f8d3f8a$export$9b928b0ca20b25cb({
    regexp: /\s+$/g,
    decoration: /*@__PURE__*/ $071334078f8d3f8a$export$10e30b733df217ea.mark({
        class: "cm-trailingSpace"
    }),
    boundary: /\S/
}));
/**
Returns an extension that adds a `cm-trailingSpace` class to all
trailing whitespace.
*/ function $071334078f8d3f8a$export$6e66b0e142f44c26() {
    return $071334078f8d3f8a$var$trailingHighlighter;
}
/**
@internal
*/ const $071334078f8d3f8a$export$91afc2cf83e15b44 = {
    HeightMap: $071334078f8d3f8a$var$HeightMap,
    HeightOracle: $071334078f8d3f8a$var$HeightOracle,
    MeasuredHeights: $071334078f8d3f8a$var$MeasuredHeights,
    QueryType: $071334078f8d3f8a$var$QueryType,
    ChangedRange: $071334078f8d3f8a$var$ChangedRange,
    computeOrder: $071334078f8d3f8a$var$computeOrder,
    moveVisually: $071334078f8d3f8a$var$moveVisually
};

});
parcelRequire.register("luNHI", function(module, exports) {

$parcel$export(module.exports, "StyleModule", () => $fa62f485c41d169a$export$b920c662d2efee20);
const $fa62f485c41d169a$var$C = "ͼ";
const $fa62f485c41d169a$var$COUNT = typeof Symbol == "undefined" ? "__" + $fa62f485c41d169a$var$C : Symbol.for($fa62f485c41d169a$var$C);
const $fa62f485c41d169a$var$SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const $fa62f485c41d169a$var$top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class $fa62f485c41d169a$export$b920c662d2efee20 {
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        let { finish: finish } = options || {};
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(let prop in spec){
                let value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(let prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        let id = $fa62f485c41d169a$var$top[$fa62f485c41d169a$var$COUNT] || 1;
        $fa62f485c41d169a$var$top[$fa62f485c41d169a$var$COUNT] = id + 1;
        return $fa62f485c41d169a$var$C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>)
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    static mount(root, modules) {
        (root[$fa62f485c41d169a$var$SET] || new $fa62f485c41d169a$var$StyleSet(root)).mount(Array.isArray(modules) ? modules : [
            modules
        ]);
    }
}
let $fa62f485c41d169a$var$adoptedSet = new Map //<Document, StyleSet>
;
class $fa62f485c41d169a$var$StyleSet {
    constructor(root){
        let doc = root.ownerDocument || root, win = doc.defaultView;
        if (!root.head && root.adoptedStyleSheets && win.CSSStyleSheet) {
            let adopted = $fa62f485c41d169a$var$adoptedSet.get(doc);
            if (adopted) {
                root.adoptedStyleSheets = [
                    adopted.sheet,
                    ...root.adoptedStyleSheets
                ];
                return root[$fa62f485c41d169a$var$SET] = adopted;
            }
            this.sheet = new win.CSSStyleSheet;
            root.adoptedStyleSheets = [
                this.sheet,
                ...root.adoptedStyleSheets
            ];
            $fa62f485c41d169a$var$adoptedSet.set(doc, this);
        } else {
            this.styleTag = doc.createElement("style");
            let target = root.head || root;
            target.insertBefore(this.styleTag, target.firstChild);
        }
        this.modules = [];
        root[$fa62f485c41d169a$var$SET] = this;
    }
    mount(modules) {
        let sheet = this.sheet;
        let pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(let i = 0; i < modules.length; i++){
            let mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(let k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (!sheet) {
            let text = "";
            for(let i = 0; i < this.modules.length; i++)text += this.modules[i].getRules() + "\n";
            this.styleTag.textContent = text;
        }
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.

});

parcelRequire.register("lNHdE", function(module, exports) {

$parcel$export(module.exports, "base", () => $fdefb3038aa23227$export$e2253033e6e1df16);
$parcel$export(module.exports, "shift", () => $fdefb3038aa23227$export$fba63a578e423eb);
$parcel$export(module.exports, "keyName", () => $fdefb3038aa23227$export$fb33aafd75404f4c);
var $fdefb3038aa23227$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $fdefb3038aa23227$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
};
var $fdefb3038aa23227$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $fdefb3038aa23227$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $fdefb3038aa23227$var$i = 0; $fdefb3038aa23227$var$i < 10; $fdefb3038aa23227$var$i++)$fdefb3038aa23227$export$e2253033e6e1df16[48 + $fdefb3038aa23227$var$i] = $fdefb3038aa23227$export$e2253033e6e1df16[96 + $fdefb3038aa23227$var$i] = String($fdefb3038aa23227$var$i);
// The function keys
for(var $fdefb3038aa23227$var$i = 1; $fdefb3038aa23227$var$i <= 24; $fdefb3038aa23227$var$i++)$fdefb3038aa23227$export$e2253033e6e1df16[$fdefb3038aa23227$var$i + 111] = "F" + $fdefb3038aa23227$var$i;
// And the alphabetic keys
for(var $fdefb3038aa23227$var$i = 65; $fdefb3038aa23227$var$i <= 90; $fdefb3038aa23227$var$i++){
    $fdefb3038aa23227$export$e2253033e6e1df16[$fdefb3038aa23227$var$i] = String.fromCharCode($fdefb3038aa23227$var$i + 32);
    $fdefb3038aa23227$export$fba63a578e423eb[$fdefb3038aa23227$var$i] = String.fromCharCode($fdefb3038aa23227$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $fdefb3038aa23227$var$code in $fdefb3038aa23227$export$e2253033e6e1df16)if (!$fdefb3038aa23227$export$fba63a578e423eb.hasOwnProperty($fdefb3038aa23227$var$code)) $fdefb3038aa23227$export$fba63a578e423eb[$fdefb3038aa23227$var$code] = $fdefb3038aa23227$export$e2253033e6e1df16[$fdefb3038aa23227$var$code];
function $fdefb3038aa23227$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $fdefb3038aa23227$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $fdefb3038aa23227$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $fdefb3038aa23227$export$fba63a578e423eb : $fdefb3038aa23227$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});


parcelRequire.register("6yW7d", function(module, exports) {

$parcel$export(module.exports, "Tag", () => $4c72ff8c9e8a407a$export$3288d34c523a1192);
$parcel$export(module.exports, "styleTags", () => $4c72ff8c9e8a407a$export$c537e79bb7b94295);
$parcel$export(module.exports, "tagHighlighter", () => $4c72ff8c9e8a407a$export$b7f6332ce20f80fb);
$parcel$export(module.exports, "highlightTree", () => $4c72ff8c9e8a407a$export$af82b3d076119fad);
$parcel$export(module.exports, "tags", () => $4c72ff8c9e8a407a$export$8b7a896ae75accbf);
$parcel$export(module.exports, "classHighlighter", () => $4c72ff8c9e8a407a$export$bf3ffb24fb17216c);

var $6DlXS = parcelRequire("6DlXS");
let $4c72ff8c9e8a407a$var$nextTagID = 0;
/**
Highlighting tags are markers that denote a highlighting category.
They are [associated](#highlight.styleTags) with parts of a syntax
tree by a language mode, and then mapped to an actual CSS style by
a [highlighter](#highlight.Highlighter).

Because syntax tree node types and highlight styles have to be
able to talk the same language, CodeMirror uses a mostly _closed_
[vocabulary](#highlight.tags) of syntax tags (as opposed to
traditional open string-based systems, which make it hard for
highlighting themes to cover all the tokens produced by the
various languages).

It _is_ possible to [define](#highlight.Tag^define) your own
highlighting tags for system-internal use (where you control both
the language package and the highlighter), but such tags will not
be picked up by regular highlighters (though you can derive them
from standard tags to allow highlighters to fall back to those).
*/ class $4c72ff8c9e8a407a$export$3288d34c523a1192 {
    /**
    @internal
    */ constructor(/**
    The set of this tag and all its parent tags, starting with
    this one itself and sorted in order of decreasing specificity.
    */ set, /**
    The base unmodified tag that this one is based on, if it's
    modified @internal
    */ base, /**
    The modifiers applied to this.base @internal
    */ modified){
        this.set = set;
        this.base = base;
        this.modified = modified;
        /**
        @internal
        */ this.id = $4c72ff8c9e8a407a$var$nextTagID++;
    }
    /**
    Define a new tag. If `parent` is given, the tag is treated as a
    sub-tag of that parent, and
    [highlighters](#highlight.tagHighlighter) that don't mention
    this tag will try to fall back to the parent tag (or grandparent
    tag, etc).
    */ static define(parent) {
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        let tag = new $4c72ff8c9e8a407a$export$3288d34c523a1192([], null, []);
        tag.set.push(tag);
        if (parent) for (let t of parent.set)tag.set.push(t);
        return tag;
    }
    /**
    Define a tag _modifier_, which is a function that, given a tag,
    will return a tag that is a subtag of the original. Applying the
    same modifier to a twice tag will return the same value (`m1(t1)
    == m1(t1)`) and applying multiple modifiers will, regardless or
    order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    
    When multiple modifiers are applied to a given base tag, each
    smaller set of modifiers is registered as a parent, so that for
    example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    `m1(m3(t1)`, and so on.
    */ static defineModifier() {
        let mod = new $4c72ff8c9e8a407a$var$Modifier;
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return $4c72ff8c9e8a407a$var$Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
}
let $4c72ff8c9e8a407a$var$nextModifierID = 0;
class $4c72ff8c9e8a407a$var$Modifier {
    constructor(){
        this.instances = [];
        this.id = $4c72ff8c9e8a407a$var$nextModifierID++;
    }
    static get(base, mods) {
        if (!mods.length) return base;
        let exists = mods[0].instances.find((t)=>t.base == base && $4c72ff8c9e8a407a$var$sameArray(mods, t.modified));
        if (exists) return exists;
        let set = [], tag = new $4c72ff8c9e8a407a$export$3288d34c523a1192(set, base, mods);
        for (let m of mods)m.instances.push(tag);
        let configs = $4c72ff8c9e8a407a$var$powerSet(mods);
        for (let parent of base.set)if (!parent.modified.length) for (let config of configs)set.push($4c72ff8c9e8a407a$var$Modifier.get(parent, config));
        return tag;
    }
}
function $4c72ff8c9e8a407a$var$sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function $4c72ff8c9e8a407a$var$powerSet(array) {
    let sets = [
        []
    ];
    for(let i = 0; i < array.length; i++)for(let j = 0, e = sets.length; j < e; j++)sets.push(sets[j].concat(array[i]));
    return sets.sort((a, b)=>b.length - a.length);
}
/**
This function is used to add a set of tags to a language syntax
via [`NodeSet.extend`](#common.NodeSet.extend) or
[`LRParser.configure`](#lr.LRParser.configure).

The argument object maps node selectors to [highlighting
tags](#highlight.Tag) or arrays of tags.

Node selectors may hold one or more (space-separated) node paths.
Such a path can be a [node name](#common.NodeType.name), or
multiple node names (or `*` wildcards) separated by slash
characters, as in `"Block/Declaration/VariableName"`. Such a path
matches the final node but only if its direct parent nodes are the
other nodes mentioned. A `*` in such a path matches any parent,
but only a single level—wildcards that match multiple parents
aren't supported, both for efficiency reasons and because Lezer
trees make it rather hard to reason about what they would match.)

A path can be ended with `/...` to indicate that the tag assigned
to the node should also apply to all child nodes, even if they
match their own style (by default, only the innermost style is
used).

When a path ends in `!`, as in `Attribute!`, no further matching
happens for the node's child nodes, and the entire node gets the
given style.

In this notation, node names that contain `/`, `!`, `*`, or `...`
must be quoted as JSON strings.

For example:

```javascript
parser.withProps(
  styleTags({
    // Style Number and BigNumber nodes
    "Number BigNumber": tags.number,
    // Style Escape nodes whose parent is String
    "String/Escape": tags.escape,
    // Style anything inside Attributes nodes
    "Attributes!": tags.meta,
    // Add a style to all content inside Italic nodes
    "Italic/...": tags.emphasis,
    // Style InvalidString nodes as both `string` and `invalid`
    "InvalidString": [tags.string, tags.invalid],
    // Style the node named "/" as punctuation
    '"/"': tags.punctuation
  })
)
```
*/ function $4c72ff8c9e8a407a$export$c537e79bb7b94295(spec) {
    let byName = Object.create(null);
    for(let prop in spec){
        let tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        for (let part of prop.split(" "))if (part) {
            let pieces = [], mode = 2 /* Normal */ , rest = part;
            for(let pos = 0;;){
                if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                    mode = 1 /* Inherit */ ;
                    break;
                }
                let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                if (!m) throw new RangeError("Invalid path: " + part);
                pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                pos += m[0].length;
                if (pos == part.length) break;
                let next = part[pos++];
                if (pos == part.length && next == "!") {
                    mode = 0 /* Opaque */ ;
                    break;
                }
                if (next != "/") throw new RangeError("Invalid path: " + part);
                rest = part.slice(pos);
            }
            let last = pieces.length - 1, inner = pieces[last];
            if (!inner) throw new RangeError("Invalid path: " + part);
            let rule = new $4c72ff8c9e8a407a$var$Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
            byName[inner] = rule.sort(byName[inner]);
        }
    }
    return $4c72ff8c9e8a407a$var$ruleNodeProp.add(byName);
}
const $4c72ff8c9e8a407a$var$ruleNodeProp = new (0, $6DlXS.NodeProp)();
class $4c72ff8c9e8a407a$var$Rule {
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
    get opaque() {
        return this.mode == 0 /* Opaque */ ;
    }
    get inherit() {
        return this.mode == 1 /* Inherit */ ;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
}
$4c72ff8c9e8a407a$var$Rule.empty = new $4c72ff8c9e8a407a$var$Rule([], 2 /* Normal */ , null);
/**
Define a [highlighter](#highlight.Highlighter) from an array of
tag/class pairs. Classes associated with more specific tags will
take precedence.
*/ function $4c72ff8c9e8a407a$export$b7f6332ce20f80fb(tags, options) {
    let map = Object.create(null);
    for (let style of tags){
        if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
        else for (let tag of style.tag)map[tag.id] = style.class;
    }
    let { scope: scope, all: all = null } = options || {};
    return {
        style: (tags)=>{
            let cls = all;
            for (let tag of tags)for (let sub of tag.set){
                let tagClass = map[sub.id];
                if (tagClass) {
                    cls = cls ? cls + " " + tagClass : tagClass;
                    break;
                }
            }
            return cls;
        },
        scope: scope
    };
}
function $4c72ff8c9e8a407a$var$highlightTags(highlighters, tags) {
    let result = null;
    for (let highlighter of highlighters){
        let value = highlighter.style(tags);
        if (value) result = result ? result + " " + value : value;
    }
    return result;
}
/**
Highlight the given [tree](#common.Tree) with the given
[highlighter](#highlight.Highlighter).
*/ function $4c72ff8c9e8a407a$export$af82b3d076119fad(tree, highlighter, /**
Assign styling to a region of the text. Will be called, in order
of position, for any ranges where more than zero classes apply.
`classes` is a space separated string of CSS classes.
*/ putStyle, /**
The start of the range to highlight.
*/ from = 0, /**
The end of the range.
*/ to = tree.length) {
    let builder = new $4c72ff8c9e8a407a$var$HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
class $4c72ff8c9e8a407a$var$HighlightBuilder {
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        let { type: type, from: start, to: end } = cursor;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        let cls = inheritedClass;
        let rule = $4c72ff8c9e8a407a$export$1519d79cc79711ec(cursor) || $4c72ff8c9e8a407a$var$Rule.empty;
        let tagCls = $4c72ff8c9e8a407a$var$highlightTags(highlighters, rule.tags);
        if (tagCls) {
            if (cls) cls += " ";
            cls += tagCls;
            if (rule.mode == 1 /* Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
        }
        this.startSpan(Math.max(from, start), cls);
        if (rule.opaque) return;
        let mounted = cursor.tree && cursor.tree.prop((0, $6DlXS.NodeProp).mounted);
        if (mounted && mounted.overlay) {
            let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            let innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            let hasChild = cursor.firstChild();
            for(let i = 0, pos = start;; i++){
                let next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                let nextPos = next ? next.from + start : end;
                let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(rangeTo, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), "", innerHighlighters);
                    this.startSpan(Math.min(to, pos), cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            if (mounted) inheritedClass = "";
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
}
/**
Match a syntax node's [highlight rules](#highlight.styleTags). If
there's a match, return its set of tags, and whether it is
opaque (uses a `!`) or applies to all child nodes (`/...`).
*/ function $4c72ff8c9e8a407a$export$1519d79cc79711ec(node) {
    let rule = node.type.prop($4c72ff8c9e8a407a$var$ruleNodeProp);
    while(rule && rule.context && !node.matchContext(rule.context))rule = rule.next;
    return rule || null;
}
const $4c72ff8c9e8a407a$var$t = $4c72ff8c9e8a407a$export$3288d34c523a1192.define;
const $4c72ff8c9e8a407a$var$comment = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$name = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$typeName = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name), $4c72ff8c9e8a407a$var$propertyName = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name), $4c72ff8c9e8a407a$var$literal = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$string = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal), $4c72ff8c9e8a407a$var$number = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal), $4c72ff8c9e8a407a$var$content = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$heading = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content), $4c72ff8c9e8a407a$var$keyword = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$operator = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$punctuation = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$bracket = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$punctuation), $4c72ff8c9e8a407a$var$meta = $4c72ff8c9e8a407a$var$t();
/**
The default set of highlighting [tags](#highlight.Tag).

This collection is heavily biased towards programming languages,
and necessarily incomplete. A full ontology of syntactic
constructs would fill a stack of books, and be impractical to
write themes for. So try to make do with this set. If all else
fails, [open an
issue](https://github.com/codemirror/codemirror.next) to propose a
new tag, or [define](#highlight.Tag^define) a local custom tag for
your use case.

Note that it is not obligatory to always attach the most specific
tag possible to an element—if your grammar can't easily
distinguish a certain type of element (such as a local variable),
it is okay to style it as its more general variant (a variable).

For tags that extend some parent tag, the documentation links to
the parent.
*/ const $4c72ff8c9e8a407a$export$8b7a896ae75accbf = {
    comment: /**
    A comment.
    */ $4c72ff8c9e8a407a$var$comment,
    /**
    A line [comment](#highlight.tags.comment).
    */ lineComment: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$comment),
    /**
    A block [comment](#highlight.tags.comment).
    */ blockComment: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$comment),
    /**
    A documentation [comment](#highlight.tags.comment).
    */ docComment: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$comment),
    name: /**
    Any kind of identifier.
    */ $4c72ff8c9e8a407a$var$name,
    /**
    The [name](#highlight.tags.name) of a variable.
    */ variableName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    /**
    A type [name](#highlight.tags.name).
    */ typeName: $4c72ff8c9e8a407a$var$typeName,
    /**
    A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    */ tagName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$typeName),
    /**
    A property or field [name](#highlight.tags.name).
    */ propertyName: $4c72ff8c9e8a407a$var$propertyName,
    /**
    An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    */ attributeName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$propertyName),
    /**
    The [name](#highlight.tags.name) of a class.
    */ className: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    /**
    A label [name](#highlight.tags.name).
    */ labelName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    /**
    A namespace [name](#highlight.tags.name).
    */ namespace: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    /**
    The [name](#highlight.tags.name) of a macro.
    */ macroName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    literal: /**
    A literal value.
    */ $4c72ff8c9e8a407a$var$literal,
    string: /**
    A string [literal](#highlight.tags.literal).
    */ $4c72ff8c9e8a407a$var$string,
    /**
    A documentation [string](#highlight.tags.string).
    */ docString: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$string),
    /**
    A character literal (subtag of [string](#highlight.tags.string)).
    */ character: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$string),
    /**
    An attribute value (subtag of [string](#highlight.tags.string)).
    */ attributeValue: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$string),
    number: /**
    A number [literal](#highlight.tags.literal).
    */ $4c72ff8c9e8a407a$var$number,
    /**
    An integer [number](#highlight.tags.number) literal.
    */ integer: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$number),
    /**
    A floating-point [number](#highlight.tags.number) literal.
    */ float: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$number),
    /**
    A boolean [literal](#highlight.tags.literal).
    */ bool: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    /**
    Regular expression [literal](#highlight.tags.literal).
    */ regexp: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    /**
    An escape [literal](#highlight.tags.literal), for example a
    backslash escape in a string.
    */ escape: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    /**
    A color [literal](#highlight.tags.literal).
    */ color: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    /**
    A URL [literal](#highlight.tags.literal).
    */ url: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    keyword: /**
    A language keyword.
    */ $4c72ff8c9e8a407a$var$keyword,
    /**
    The [keyword](#highlight.tags.keyword) for the self or this
    object.
    */ self: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    The [keyword](#highlight.tags.keyword) for null.
    */ null: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) denoting some atomic value.
    */ atom: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that represents a unit.
    */ unit: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A modifier [keyword](#highlight.tags.keyword).
    */ modifier: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that acts as an operator.
    */ operatorKeyword: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A control-flow related [keyword](#highlight.tags.keyword).
    */ controlKeyword: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that defines something.
    */ definitionKeyword: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) related to defining or
    interfacing with modules.
    */ moduleKeyword: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    operator: /**
    An operator.
    */ $4c72ff8c9e8a407a$var$operator,
    /**
    An [operator](#highlight.tags.operator) that dereferences something.
    */ derefOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Arithmetic-related [operator](#highlight.tags.operator).
    */ arithmeticOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Logical [operator](#highlight.tags.operator).
    */ logicOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Bit [operator](#highlight.tags.operator).
    */ bitwiseOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Comparison [operator](#highlight.tags.operator).
    */ compareOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    [Operator](#highlight.tags.operator) that updates its operand.
    */ updateOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    [Operator](#highlight.tags.operator) that defines something.
    */ definitionOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Type-related [operator](#highlight.tags.operator).
    */ typeOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Control-flow [operator](#highlight.tags.operator).
    */ controlOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    punctuation: /**
    Program or markup punctuation.
    */ $4c72ff8c9e8a407a$var$punctuation,
    /**
    [Punctuation](#highlight.tags.punctuation) that separates
    things.
    */ separator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$punctuation),
    bracket: /**
    Bracket-style [punctuation](#highlight.tags.punctuation).
    */ $4c72ff8c9e8a407a$var$bracket,
    /**
    Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    tokens).
    */ angleBracket: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$bracket),
    /**
    Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    tokens).
    */ squareBracket: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$bracket),
    /**
    Parentheses (usually `(` and `)` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ paren: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$bracket),
    /**
    Braces (usually `{` and `}` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ brace: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$bracket),
    content: /**
    Content, for example plain text in XML or markup documents.
    */ $4c72ff8c9e8a407a$var$content,
    heading: /**
    [Content](#highlight.tags.content) that represents a heading.
    */ $4c72ff8c9e8a407a$var$heading,
    /**
    A level 1 [heading](#highlight.tags.heading).
    */ heading1: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 2 [heading](#highlight.tags.heading).
    */ heading2: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 3 [heading](#highlight.tags.heading).
    */ heading3: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 4 [heading](#highlight.tags.heading).
    */ heading4: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 5 [heading](#highlight.tags.heading).
    */ heading5: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 6 [heading](#highlight.tags.heading).
    */ heading6: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A prose separator (such as a horizontal rule).
    */ contentSeparator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that represents a list.
    */ list: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that represents a quote.
    */ quote: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that is emphasized.
    */ emphasis: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that is styled strong.
    */ strong: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that is part of a link.
    */ link: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that is styled as code or
    monospace.
    */ monospace: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that has a strike-through
    style.
    */ strikethrough: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    Inserted text in a change-tracking format.
    */ inserted: $4c72ff8c9e8a407a$var$t(),
    /**
    Deleted text.
    */ deleted: $4c72ff8c9e8a407a$var$t(),
    /**
    Changed text.
    */ changed: $4c72ff8c9e8a407a$var$t(),
    /**
    An invalid or unsyntactic element.
    */ invalid: $4c72ff8c9e8a407a$var$t(),
    meta: /**
    Metadata or meta-instruction.
    */ $4c72ff8c9e8a407a$var$meta,
    /**
    [Metadata](#highlight.tags.meta) that applies to the entire
    document.
    */ documentMeta: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$meta),
    /**
    [Metadata](#highlight.tags.meta) that annotates or adds
    attributes to a given syntactic element.
    */ annotation: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$meta),
    /**
    Processing instruction or preprocessor directive. Subtag of
    [meta](#highlight.tags.meta).
    */ processingInstruction: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$meta),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that a
    given element is being defined. Expected to be used with the
    various [name](#highlight.tags.name) tags.
    */ definition: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that
    something is constant. Mostly expected to be used with
    [variable names](#highlight.tags.variableName).
    */ constant: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) used to indicate that
    a [variable](#highlight.tags.variableName) or [property
    name](#highlight.tags.propertyName) is being called or defined
    as a function.
    */ function: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that can be applied to
    [names](#highlight.tags.name) to indicate that they belong to
    the language's standard environment.
    */ standard: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates a given
    [names](#highlight.tags.name) is local to some scope.
    */ local: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    A generic variant [modifier](#highlight.Tag^defineModifier) that
    can be used to tag language-specific alternative variants of
    some common tag. It is recommended for themes to define special
    forms of at least the [string](#highlight.tags.string) and
    [variable name](#highlight.tags.variableName) tags, since those
    come up a lot.
    */ special: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier()
};
/**
This is a highlighter that adds stable, predictable classes to
tokens, for styling with external CSS.

The following tags are mapped to their name prefixed with `"tok-"`
(for example `"tok-comment"`):

* [`link`](#highlight.tags.link)
* [`heading`](#highlight.tags.heading)
* [`emphasis`](#highlight.tags.emphasis)
* [`strong`](#highlight.tags.strong)
* [`keyword`](#highlight.tags.keyword)
* [`atom`](#highlight.tags.atom)
* [`bool`](#highlight.tags.bool)
* [`url`](#highlight.tags.url)
* [`labelName`](#highlight.tags.labelName)
* [`inserted`](#highlight.tags.inserted)
* [`deleted`](#highlight.tags.deleted)
* [`literal`](#highlight.tags.literal)
* [`string`](#highlight.tags.string)
* [`number`](#highlight.tags.number)
* [`variableName`](#highlight.tags.variableName)
* [`typeName`](#highlight.tags.typeName)
* [`namespace`](#highlight.tags.namespace)
* [`className`](#highlight.tags.className)
* [`macroName`](#highlight.tags.macroName)
* [`propertyName`](#highlight.tags.propertyName)
* [`operator`](#highlight.tags.operator)
* [`comment`](#highlight.tags.comment)
* [`meta`](#highlight.tags.meta)
* [`punctuation`](#highlight.tags.punctuation)
* [`invalid`](#highlight.tags.invalid)

In addition, these mappings are provided:

* [`regexp`](#highlight.tags.regexp),
  [`escape`](#highlight.tags.escape), and
  [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
  are mapped to `"tok-string2"`
* [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName2"`
* [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-local"`
* [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-definition"`
* [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
  to `"tok-propertyName tok-definition"`
*/ const $4c72ff8c9e8a407a$export$bf3ffb24fb17216c = $4c72ff8c9e8a407a$export$b7f6332ce20f80fb([
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.link,
        class: "tok-link"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.heading,
        class: "tok-heading"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.strong,
        class: "tok-strong"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.keyword,
        class: "tok-keyword"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.atom,
        class: "tok-atom"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.bool,
        class: "tok-bool"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.url,
        class: "tok-url"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.labelName,
        class: "tok-labelName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.inserted,
        class: "tok-inserted"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.deleted,
        class: "tok-deleted"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.literal,
        class: "tok-literal"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.string,
        class: "tok-string"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.number,
        class: "tok-number"
    },
    {
        tag: [
            $4c72ff8c9e8a407a$export$8b7a896ae75accbf.regexp,
            $4c72ff8c9e8a407a$export$8b7a896ae75accbf.escape,
            $4c72ff8c9e8a407a$export$8b7a896ae75accbf.special($4c72ff8c9e8a407a$export$8b7a896ae75accbf.string)
        ],
        class: "tok-string2"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.variableName,
        class: "tok-variableName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.local($4c72ff8c9e8a407a$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.definition($4c72ff8c9e8a407a$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.special($4c72ff8c9e8a407a$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName2"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.definition($4c72ff8c9e8a407a$export$8b7a896ae75accbf.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.typeName,
        class: "tok-typeName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.namespace,
        class: "tok-namespace"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.className,
        class: "tok-className"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.macroName,
        class: "tok-macroName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.operator,
        class: "tok-operator"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.comment,
        class: "tok-comment"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.meta,
        class: "tok-meta"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.invalid,
        class: "tok-invalid"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.punctuation,
        class: "tok-punctuation"
    }
]);

});


parcelRequire.register("kOcYD", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("1Zafa")).resolve("cKHOo")),
    import("./" + (parcelRequire("1Zafa")).resolve("fBzfD"))
]).then(()=>parcelRequire("l1Lk2"));

});

parcelRequire.register("jz8kt", function(module, exports) {




module.exports = Promise.all([
    import("./" + (parcelRequire("1Zafa")).resolve("8zxEJ")),
    import("./" + (parcelRequire("1Zafa")).resolve("cKHOo")),
    import("./" + (parcelRequire("1Zafa")).resolve("fBzfD")),
    import("./" + (parcelRequire("1Zafa")).resolve("fcNr7"))
]).then(()=>parcelRequire("8e2sZ"));

});

parcelRequire.register("8Dy69", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("1Zafa")).resolve("cKHOo")),
    import("./" + (parcelRequire("1Zafa")).resolve("8zxEJ"))
]).then(()=>parcelRequire("bveFi"));

});

parcelRequire.register("eVHHD", function(module, exports) {





module.exports = Promise.all([
    import("./" + (parcelRequire("1Zafa")).resolve("8zxEJ")),
    import("./" + (parcelRequire("1Zafa")).resolve("fcNr7")),
    import("./" + (parcelRequire("1Zafa")).resolve("cKHOo")),
    import("./" + (parcelRequire("1Zafa")).resolve("fBzfD")),
    import("./" + (parcelRequire("1Zafa")).resolve("5OUUI"))
]).then(()=>parcelRequire("47LfZ"));

});

var $b8c53ef43392f031$exports = {};
"use strict";

$b8c53ef43392f031$exports = (parcelRequire("iwYKF"));



var $lx97N = parcelRequire("lx97N");
var $e08bedd2d92855da$export$882461b6382ed46c;
var $e08bedd2d92855da$export$757ceba2d55c277e;
"use strict";
var $0d985e384f32d040$exports = {};
"use strict";
function $0d985e384f32d040$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0d985e384f32d040$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0d985e384f32d040$var$checkDCE();

$0d985e384f32d040$exports = (parcelRequire("f2Jil"));


var $e08bedd2d92855da$var$i;
$e08bedd2d92855da$export$882461b6382ed46c = $0d985e384f32d040$exports.createRoot;
$e08bedd2d92855da$export$757ceba2d55c277e = $0d985e384f32d040$exports.hydrateRoot;


/**
 * React Router DOM v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lx97N = parcelRequire("lx97N");
/**
 * @remix-run/router v1.7.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d64590e8ac5fce5b$var$_extends() {
    $d64590e8ac5fce5b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d64590e8ac5fce5b$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d64590e8ac5fce5b$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d64590e8ac5fce5b$export$e19cd5f9376f8cee || ($d64590e8ac5fce5b$export$e19cd5f9376f8cee = {}));
const $d64590e8ac5fce5b$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d64590e8ac5fce5b$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d64590e8ac5fce5b$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d64590e8ac5fce5b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d64590e8ac5fce5b$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d64590e8ac5fce5b$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d64590e8ac5fce5b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d64590e8ac5fce5b$export$fe53371bee54353d(to);
    }
    return $d64590e8ac5fce5b$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d64590e8ac5fce5b$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d64590e8ac5fce5b$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $d64590e8ac5fce5b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d64590e8ac5fce5b$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d64590e8ac5fce5b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d64590e8ac5fce5b$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d64590e8ac5fce5b$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d64590e8ac5fce5b$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d64590e8ac5fce5b$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d64590e8ac5fce5b$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d64590e8ac5fce5b$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d64590e8ac5fce5b$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d64590e8ac5fce5b$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d64590e8ac5fce5b$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d64590e8ac5fce5b$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d64590e8ac5fce5b$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d64590e8ac5fce5b$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
        let location = $d64590e8ac5fce5b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d64590e8ac5fce5b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace;
        let location = $d64590e8ac5fce5b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d64590e8ac5fce5b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d64590e8ac5fce5b$export$fe53371bee54353d(to);
        $d64590e8ac5fce5b$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d64590e8ac5fce5b$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d64590e8ac5fce5b$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d64590e8ac5fce5b$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d64590e8ac5fce5b$var$ResultType || ($d64590e8ac5fce5b$var$ResultType = {}));
const $d64590e8ac5fce5b$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d64590e8ac5fce5b$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d64590e8ac5fce5b$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d64590e8ac5fce5b$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($d64590e8ac5fce5b$var$isIndexRoute(route)) {
            let indexRoute = $d64590e8ac5fce5b$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d64590e8ac5fce5b$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d64590e8ac5fce5b$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $d64590e8ac5fce5b$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d64590e8ac5fce5b$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d64590e8ac5fce5b$var$flattenRoutes(routes);
    $d64590e8ac5fce5b$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $d64590e8ac5fce5b$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $d64590e8ac5fce5b$var$safelyDecodeURI(pathname));
    return matches;
}
function $d64590e8ac5fce5b$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d64590e8ac5fce5b$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d64590e8ac5fce5b$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d64590e8ac5fce5b$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $d64590e8ac5fce5b$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d64590e8ac5fce5b$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d64590e8ac5fce5b$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d64590e8ac5fce5b$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d64590e8ac5fce5b$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d64590e8ac5fce5b$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d64590e8ac5fce5b$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d64590e8ac5fce5b$var$paramRe = /^:\w+$/;
const $d64590e8ac5fce5b$var$dynamicSegmentValue = 3;
const $d64590e8ac5fce5b$var$indexRouteValue = 2;
const $d64590e8ac5fce5b$var$emptySegmentValue = 1;
const $d64590e8ac5fce5b$var$staticSegmentValue = 10;
const $d64590e8ac5fce5b$var$splatPenalty = -2;
const $d64590e8ac5fce5b$var$isSplat = (s)=>s === "*";
function $d64590e8ac5fce5b$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d64590e8ac5fce5b$var$isSplat)) initialScore += $d64590e8ac5fce5b$var$splatPenalty;
    if (index) initialScore += $d64590e8ac5fce5b$var$indexRouteValue;
    return segments.filter((s)=>!$d64590e8ac5fce5b$var$isSplat(s)).reduce((score, segment)=>score + ($d64590e8ac5fce5b$var$paramRe.test(segment) ? $d64590e8ac5fce5b$var$dynamicSegmentValue : segment === "" ? $d64590e8ac5fce5b$var$emptySegmentValue : $d64590e8ac5fce5b$var$staticSegmentValue), initialScore);
}
function $d64590e8ac5fce5b$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d64590e8ac5fce5b$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d64590e8ac5fce5b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d64590e8ac5fce5b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d64590e8ac5fce5b$export$a5c6d149b50c1d86($d64590e8ac5fce5b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d64590e8ac5fce5b$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $d64590e8ac5fce5b$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d64590e8ac5fce5b$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d64590e8ac5fce5b$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $d64590e8ac5fce5b$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $d64590e8ac5fce5b$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $d64590e8ac5fce5b$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d64590e8ac5fce5b$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d64590e8ac5fce5b$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $d64590e8ac5fce5b$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $d64590e8ac5fce5b$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $d64590e8ac5fce5b$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $d64590e8ac5fce5b$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d64590e8ac5fce5b$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $d64590e8ac5fce5b$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d64590e8ac5fce5b$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d64590e8ac5fce5b$var$normalizeSearch(search),
        hash: $d64590e8ac5fce5b$var$normalizeHash(hash)
    };
}
function $d64590e8ac5fce5b$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d64590e8ac5fce5b$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d64590e8ac5fce5b$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $d64590e8ac5fce5b$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d64590e8ac5fce5b$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d64590e8ac5fce5b$var$_extends({}, toArg);
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d64590e8ac5fce5b$var$getInvalidPathError("?", "pathname", "search", to));
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d64590e8ac5fce5b$var$getInvalidPathError("#", "pathname", "hash", to));
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d64590e8ac5fce5b$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d64590e8ac5fce5b$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d64590e8ac5fce5b$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d64590e8ac5fce5b$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d64590e8ac5fce5b$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d64590e8ac5fce5b$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d64590e8ac5fce5b$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $d64590e8ac5fce5b$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d64590e8ac5fce5b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d64590e8ac5fce5b$export$42a99a7a4bc0e76a extends Error {
}
class $d64590e8ac5fce5b$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d64590e8ac5fce5b$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d64590e8ac5fce5b$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d64590e8ac5fce5b$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d64590e8ac5fce5b$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $d64590e8ac5fce5b$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $d64590e8ac5fce5b$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d64590e8ac5fce5b$var$unwrapTrackedPromise(value) {
    if (!$d64590e8ac5fce5b$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $d64590e8ac5fce5b$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d64590e8ac5fce5b$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d64590e8ac5fce5b$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d64590e8ac5fce5b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $d64590e8ac5fce5b$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d64590e8ac5fce5b$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d64590e8ac5fce5b$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d64590e8ac5fce5b$var$validMutationMethods = new Set($d64590e8ac5fce5b$var$validMutationMethodsArr);
const $d64590e8ac5fce5b$var$validRequestMethodsArr = [
    "get",
    ...$d64590e8ac5fce5b$var$validMutationMethodsArr
];
const $d64590e8ac5fce5b$var$validRequestMethods = new Set($d64590e8ac5fce5b$var$validRequestMethodsArr);
const $d64590e8ac5fce5b$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d64590e8ac5fce5b$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d64590e8ac5fce5b$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d64590e8ac5fce5b$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d64590e8ac5fce5b$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d64590e8ac5fce5b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d64590e8ac5fce5b$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d64590e8ac5fce5b$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d64590e8ac5fce5b$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d64590e8ac5fce5b$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d64590e8ac5fce5b$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $d64590e8ac5fce5b$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d64590e8ac5fce5b$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d64590e8ac5fce5b$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d64590e8ac5fce5b$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d64590e8ac5fce5b$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $d64590e8ac5fce5b$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d64590e8ac5fce5b$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $d64590e8ac5fce5b$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d64590e8ac5fce5b$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d64590e8ac5fce5b$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d64590e8ac5fce5b$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d64590e8ac5fce5b$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($d64590e8ac5fce5b$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d64590e8ac5fce5b$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d64590e8ac5fce5b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d64590e8ac5fce5b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d64590e8ac5fce5b$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d64590e8ac5fce5b$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d64590e8ac5fce5b$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d64590e8ac5fce5b$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $d64590e8ac5fce5b$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d64590e8ac5fce5b$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $d64590e8ac5fce5b$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d64590e8ac5fce5b$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d64590e8ac5fce5b$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$d64590e8ac5fce5b$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $d64590e8ac5fce5b$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $d64590e8ac5fce5b$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d64590e8ac5fce5b$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d64590e8ac5fce5b$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $d64590e8ac5fce5b$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d64590e8ac5fce5b$var$ResultType.error,
            error: $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $d64590e8ac5fce5b$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d64590e8ac5fce5b$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($d64590e8ac5fce5b$var$isDeferredResult(result)) throw $d64590e8ac5fce5b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d64590e8ac5fce5b$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d64590e8ac5fce5b$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d64590e8ac5fce5b$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d64590e8ac5fce5b$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($d64590e8ac5fce5b$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d64590e8ac5fce5b$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d64590e8ac5fce5b$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d64590e8ac5fce5b$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $d64590e8ac5fce5b$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d64590e8ac5fce5b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d64590e8ac5fce5b$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $d64590e8ac5fce5b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $d64590e8ac5fce5b$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d64590e8ac5fce5b$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $d64590e8ac5fce5b$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $d64590e8ac5fce5b$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $d64590e8ac5fce5b$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($d64590e8ac5fce5b$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(submission);
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        }
        // Process any non-redirect errors thrown
        if ($d64590e8ac5fce5b$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($d64590e8ac5fce5b$var$isDeferredResult(actionResult)) throw $d64590e8ac5fce5b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d64590e8ac5fce5b$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d64590e8ac5fce5b$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d64590e8ac5fce5b$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d64590e8ac5fce5b$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d64590e8ac5fce5b$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d64590e8ac5fce5b$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d64590e8ac5fce5b$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d64590e8ac5fce5b$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($d64590e8ac5fce5b$var$_extends({
                errors: errors,
                loaderData: $d64590e8ac5fce5b$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $d64590e8ac5fce5b$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $d64590e8ac5fce5b$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d64590e8ac5fce5b$var$isDeferredResult(result)) result = await $d64590e8ac5fce5b$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d64590e8ac5fce5b$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        }
        // Process any non-redirect errors thrown
        if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!$d64590e8ac5fce5b$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $d64590e8ac5fce5b$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $d64590e8ac5fce5b$var$createLocation(state.location, redirect.location, $d64590e8ac5fce5b$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $d64590e8ac5fce5b$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($d64590e8ac5fce5b$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $d64590e8ac5fce5b$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace : $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let activeSubmission = submission || $d64590e8ac5fce5b$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($d64590e8ac5fce5b$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $d64590e8ac5fce5b$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d64590e8ac5fce5b$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: $d64590e8ac5fce5b$var$getLoadingNavigation(redirectLocation),
            fetcherSubmission: activeSubmission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a submission, we will preserve it through the redirect navigation
            let overrideNavigation = $d64590e8ac5fce5b$var$getLoadingNavigation(redirectLocation, activeSubmission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d64590e8ac5fce5b$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $d64590e8ac5fce5b$var$callLoaderOrAction("loader", $d64590e8ac5fce5b$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $d64590e8ac5fce5b$var$ResultType.error,
                        error: $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $d64590e8ac5fce5b$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $d64590e8ac5fce5b$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $d64590e8ac5fce5b$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d64590e8ac5fce5b$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d64590e8ac5fce5b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d64590e8ac5fce5b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d64590e8ac5fce5b$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d64590e8ac5fce5b$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d64590e8ac5fce5b$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d64590e8ac5fce5b$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d64590e8ac5fce5b$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d64590e8ac5fce5b$var$createUseMatchesMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d64590e8ac5fce5b$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d64590e8ac5fce5b$export$4d0306f8f6a4585b = Symbol("deferred");
function $d64590e8ac5fce5b$export$3336b097a6fbc59a(routes, opts) {
    $d64590e8ac5fce5b$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d64590e8ac5fce5b$var$defaultMapRouteProperties;
    let dataRoutes = $d64590e8ac5fce5b$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d64590e8ac5fce5b$var$createLocation("", $d64590e8ac5fce5b$export$fe53371bee54353d(url), null, "default");
        let matches = $d64590e8ac5fce5b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d64590e8ac5fce5b$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d64590e8ac5fce5b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d64590e8ac5fce5b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($d64590e8ac5fce5b$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d64590e8ac5fce5b$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d64590e8ac5fce5b$var$createLocation("", $d64590e8ac5fce5b$export$fe53371bee54353d(url), null, "default");
        let matches = $d64590e8ac5fce5b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d64590e8ac5fce5b$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d64590e8ac5fce5b$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d64590e8ac5fce5b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d64590e8ac5fce5b$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d64590e8ac5fce5b$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d64590e8ac5fce5b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($d64590e8ac5fce5b$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d64590e8ac5fce5b$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $d64590e8ac5fce5b$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d64590e8ac5fce5b$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d64590e8ac5fce5b$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $d64590e8ac5fce5b$var$isResponse(result) ? result : $d64590e8ac5fce5b$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($d64590e8ac5fce5b$var$isQueryRouteResponse(e)) {
                if (e.type === $d64590e8ac5fce5b$var$ResultType.error && !$d64590e8ac5fce5b$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d64590e8ac5fce5b$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d64590e8ac5fce5b$var$ResultType.error,
                error: error
            };
        } else {
            result = await $d64590e8ac5fce5b$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($d64590e8ac5fce5b$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($d64590e8ac5fce5b$var$isDeferredResult(result)) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d64590e8ac5fce5b$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d64590e8ac5fce5b$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $d64590e8ac5fce5b$var$_extends({}, context, {
                statusCode: $d64590e8ac5fce5b$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $d64590e8ac5fce5b$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $d64590e8ac5fce5b$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $d64590e8ac5fce5b$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d64590e8ac5fce5b$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $d64590e8ac5fce5b$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d64590e8ac5fce5b$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d64590e8ac5fce5b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d64590e8ac5fce5b$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d64590e8ac5fce5b$export$fec11da027c70692(routes, context, error) {
    let newContext = $d64590e8ac5fce5b$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d64590e8ac5fce5b$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d64590e8ac5fce5b$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d64590e8ac5fce5b$export$cae722b0cc860f13(to ? to : ".", $d64590e8ac5fce5b$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $d64590e8ac5fce5b$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$d64590e8ac5fce5b$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d64590e8ac5fce5b$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d64590e8ac5fce5b$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d64590e8ac5fce5b$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d64590e8ac5fce5b$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d64590e8ac5fce5b$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d64590e8ac5fce5b$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d64590e8ac5fce5b$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d64590e8ac5fce5b$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d64590e8ac5fce5b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d64590e8ac5fce5b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d64590e8ac5fce5b$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d64590e8ac5fce5b$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d64590e8ac5fce5b$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d64590e8ac5fce5b$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d64590e8ac5fce5b$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d64590e8ac5fce5b$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d64590e8ac5fce5b$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d64590e8ac5fce5b$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d64590e8ac5fce5b$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $d64590e8ac5fce5b$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $d64590e8ac5fce5b$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $d64590e8ac5fce5b$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($d64590e8ac5fce5b$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d64590e8ac5fce5b$var$shouldRevalidateLoader(match, $d64590e8ac5fce5b$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d64590e8ac5fce5b$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $d64590e8ac5fce5b$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They only set `defaultShouldRevalidate` on
        // explicit revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        //
        // They automatically revalidate without even calling shouldRevalidate if:
        // - They were cancelled
        // - They're in the middle of their first load and therefore this is still
        //   an initial load and not a revalidation
        //
        // If neither of those is true, then they _always_ check shouldRevalidate
        let fetcher = state.fetchers.get(key);
        let isPerformingInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === undefined && // If a fetcher.load redirected then it'll be "loading" without any data
        // so ensure we're not processing the redirect from this fetcher
        !fetchRedirectIds.has(key);
        let fetcherMatch = $d64590e8ac5fce5b$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = cancelledFetcherLoads.includes(key) || isPerformingInitialLoad || $d64590e8ac5fce5b$var$shouldRevalidateLoader(fetcherMatch, $d64590e8ac5fce5b$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d64590e8ac5fce5b$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d64590e8ac5fce5b$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d64590e8ac5fce5b$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d64590e8ac5fce5b$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d64590e8ac5fce5b$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d64590e8ac5fce5b$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$d64590e8ac5fce5b$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d64590e8ac5fce5b$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $d64590e8ac5fce5b$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $d64590e8ac5fce5b$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $d64590e8ac5fce5b$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d64590e8ac5fce5b$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d64590e8ac5fce5b$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $d64590e8ac5fce5b$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($d64590e8ac5fce5b$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($d64590e8ac5fce5b$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $d64590e8ac5fce5b$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$d64590e8ac5fce5b$var$ABSOLUTE_URL_REGEX.test(location)) location = $d64590e8ac5fce5b$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $d64590e8ac5fce5b$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $d64590e8ac5fce5b$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $d64590e8ac5fce5b$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $d64590e8ac5fce5b$var$ResultType.error) return {
            type: resultType,
            error: new $d64590e8ac5fce5b$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $d64590e8ac5fce5b$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $d64590e8ac5fce5b$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($d64590e8ac5fce5b$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $d64590e8ac5fce5b$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $d64590e8ac5fce5b$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d64590e8ac5fce5b$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d64590e8ac5fce5b$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d64590e8ac5fce5b$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d64590e8ac5fce5b$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d64590e8ac5fce5b$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d64590e8ac5fce5b$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d64590e8ac5fce5b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!$d64590e8ac5fce5b$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d64590e8ac5fce5b$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($d64590e8ac5fce5b$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d64590e8ac5fce5b$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d64590e8ac5fce5b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $d64590e8ac5fce5b$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d64590e8ac5fce5b$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d64590e8ac5fce5b$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d64590e8ac5fce5b$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d64590e8ac5fce5b$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d64590e8ac5fce5b$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d64590e8ac5fce5b$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d64590e8ac5fce5b$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d64590e8ac5fce5b$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d64590e8ac5fce5b$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d64590e8ac5fce5b$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d64590e8ac5fce5b$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $d64590e8ac5fce5b$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d64590e8ac5fce5b$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($d64590e8ac5fce5b$var$isRedirectResult(result)) return result;
    }
}
function $d64590e8ac5fce5b$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(path) : path;
    return $d64590e8ac5fce5b$export$fe53371bee54353d($d64590e8ac5fce5b$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d64590e8ac5fce5b$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d64590e8ac5fce5b$var$isDeferredResult(result) {
    return result.type === $d64590e8ac5fce5b$var$ResultType.deferred;
}
function $d64590e8ac5fce5b$var$isErrorResult(result) {
    return result.type === $d64590e8ac5fce5b$var$ResultType.error;
}
function $d64590e8ac5fce5b$var$isRedirectResult(result) {
    return (result && result.type) === $d64590e8ac5fce5b$var$ResultType.redirect;
}
function $d64590e8ac5fce5b$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d64590e8ac5fce5b$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d64590e8ac5fce5b$var$isRedirectResponse(result) {
    if (!$d64590e8ac5fce5b$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d64590e8ac5fce5b$var$isQueryRouteResponse(obj) {
    return obj && $d64590e8ac5fce5b$var$isResponse(obj.response) && (obj.type === $d64590e8ac5fce5b$var$ResultType.data || $d64590e8ac5fce5b$var$ResultType.error);
}
function $d64590e8ac5fce5b$var$isValidMethod(method) {
    return $d64590e8ac5fce5b$var$validRequestMethods.has(method.toLowerCase());
}
function $d64590e8ac5fce5b$var$isMutationMethod(method) {
    return $d64590e8ac5fce5b$var$validMutationMethods.has(method.toLowerCase());
}
async function $d64590e8ac5fce5b$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d64590e8ac5fce5b$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d64590e8ac5fce5b$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $d64590e8ac5fce5b$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $d64590e8ac5fce5b$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $d64590e8ac5fce5b$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d64590e8ac5fce5b$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d64590e8ac5fce5b$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d64590e8ac5fce5b$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d64590e8ac5fce5b$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $d64590e8ac5fce5b$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d64590e8ac5fce5b$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d64590e8ac5fce5b$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d64590e8ac5fce5b$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d64590e8ac5fce5b$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d64590e8ac5fce5b$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d64590e8ac5fce5b$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d64590e8ac5fce5b$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    }
}
function $d64590e8ac5fce5b$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $d64590e8ac5fce5b$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

/**
 * React Router v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lx97N = parcelRequire("lx97N");

function $70ed8fdcf064e4a0$var$_extends() {
    $70ed8fdcf064e4a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70ed8fdcf064e4a0$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $70ed8fdcf064e4a0$export$3add0d5dce533e2e = /*#__PURE__*/ $lx97N.createContext(null);
const $70ed8fdcf064e4a0$export$145dfa71566a64dc = /*#__PURE__*/ $lx97N.createContext(null);
const $70ed8fdcf064e4a0$var$AwaitContext = /*#__PURE__*/ $lx97N.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $70ed8fdcf064e4a0$export$26749e8557646306 = /*#__PURE__*/ $lx97N.createContext(null);
const $70ed8fdcf064e4a0$export$c7914228fb69b0f5 = /*#__PURE__*/ $lx97N.createContext(null);
const $70ed8fdcf064e4a0$export$9072aa6dd1f93057 = /*#__PURE__*/ $lx97N.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $70ed8fdcf064e4a0$var$RouteErrorContext = /*#__PURE__*/ $lx97N.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $70ed8fdcf064e4a0$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$70ed8fdcf064e4a0$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $lx97N.useContext($70ed8fdcf064e4a0$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $70ed8fdcf064e4a0$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $70ed8fdcf064e4a0$export$9c954a9d03d32f4a() {
    return $lx97N.useContext($70ed8fdcf064e4a0$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $70ed8fdcf064e4a0$export$45d76561a5302f2b() {
    !$70ed8fdcf064e4a0$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return $lx97N.useContext($70ed8fdcf064e4a0$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $70ed8fdcf064e4a0$export$1b3f31771c5d07c() {
    return $lx97N.useContext($70ed8fdcf064e4a0$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $70ed8fdcf064e4a0$export$6c330e8992e8a295(pattern) {
    !$70ed8fdcf064e4a0$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $70ed8fdcf064e4a0$export$45d76561a5302f2b();
    return $lx97N.useMemo(()=>(0, $d64590e8ac5fce5b$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $70ed8fdcf064e4a0$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $70ed8fdcf064e4a0$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $lx97N.useContext($70ed8fdcf064e4a0$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $lx97N.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $70ed8fdcf064e4a0$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $lx97N.useContext($70ed8fdcf064e4a0$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $70ed8fdcf064e4a0$var$useNavigateStable() : $70ed8fdcf064e4a0$var$useNavigateUnstable();
}
function $70ed8fdcf064e4a0$var$useNavigateUnstable() {
    !$70ed8fdcf064e4a0$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let dataRouterContext = $lx97N.useContext($70ed8fdcf064e4a0$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $lx97N.useContext($70ed8fdcf064e4a0$export$26749e8557646306);
    let { matches: matches } = $lx97N.useContext($70ed8fdcf064e4a0$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $70ed8fdcf064e4a0$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d64590e8ac5fce5b$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $lx97N.useRef(false);
    $70ed8fdcf064e4a0$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lx97N.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $d64590e8ac5fce5b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $70ed8fdcf064e4a0$var$OutletContext = /*#__PURE__*/ $lx97N.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $70ed8fdcf064e4a0$export$4138103a3ae699cc() {
    return $lx97N.useContext($70ed8fdcf064e4a0$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $70ed8fdcf064e4a0$export$a3be3530d8e40d0b(context) {
    let outlet = $lx97N.useContext($70ed8fdcf064e4a0$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $70ed8fdcf064e4a0$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $lx97N.useContext($70ed8fdcf064e4a0$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $70ed8fdcf064e4a0$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $lx97N.useContext($70ed8fdcf064e4a0$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $70ed8fdcf064e4a0$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d64590e8ac5fce5b$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $lx97N.useMemo(()=>(0, $d64590e8ac5fce5b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $70ed8fdcf064e4a0$export$5d3fca4a98652595(routes, locationArg) {
    return $70ed8fdcf064e4a0$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $70ed8fdcf064e4a0$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$70ed8fdcf064e4a0$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $lx97N.useContext($70ed8fdcf064e4a0$export$26749e8557646306);
    let { matches: parentMatches } = $lx97N.useContext($70ed8fdcf064e4a0$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $70ed8fdcf064e4a0$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $d64590e8ac5fce5b$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $d64590e8ac5fce5b$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $70ed8fdcf064e4a0$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $70ed8fdcf064e4a0$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $d64590e8ac5fce5b$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $70ed8fdcf064e4a0$var$DefaultErrorComponent() {
    let error = $70ed8fdcf064e4a0$export$ed527bf60f6e05f2();
    let message = (0, $d64590e8ac5fce5b$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $lx97N.createElement($lx97N.Fragment, null, /*#__PURE__*/ $lx97N.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $lx97N.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $lx97N.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $70ed8fdcf064e4a0$var$defaultErrorElement = /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$DefaultErrorComponent, null);
class $70ed8fdcf064e4a0$var$RenderErrorBoundary extends $lx97N.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $70ed8fdcf064e4a0$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $lx97N.useContext($70ed8fdcf064e4a0$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $70ed8fdcf064e4a0$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $70ed8fdcf064e4a0$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $lx97N.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $70ed8fdcf064e4a0$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($70ed8fdcf064e4a0$var$DataRouterHook || ($70ed8fdcf064e4a0$var$DataRouterHook = {}));
var $70ed8fdcf064e4a0$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($70ed8fdcf064e4a0$var$DataRouterStateHook || ($70ed8fdcf064e4a0$var$DataRouterStateHook = {}));
function $70ed8fdcf064e4a0$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $70ed8fdcf064e4a0$var$useDataRouterContext(hookName) {
    let ctx = $lx97N.useContext($70ed8fdcf064e4a0$export$3add0d5dce533e2e);
    !ctx && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $70ed8fdcf064e4a0$var$useDataRouterState(hookName) {
    let state = $lx97N.useContext($70ed8fdcf064e4a0$export$145dfa71566a64dc);
    !state && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return state;
}
function $70ed8fdcf064e4a0$var$useRouteContext(hookName) {
    let route = $lx97N.useContext($70ed8fdcf064e4a0$export$9072aa6dd1f93057);
    !route && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $70ed8fdcf064e4a0$var$useCurrentRouteId(hookName) {
    let route = $70ed8fdcf064e4a0$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $70ed8fdcf064e4a0$export$5fc8298006ad9e58() {
    return $70ed8fdcf064e4a0$var$useCurrentRouteId($70ed8fdcf064e4a0$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $70ed8fdcf064e4a0$export$d0fd4b7106de2769() {
    let state = $70ed8fdcf064e4a0$var$useDataRouterState($70ed8fdcf064e4a0$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $70ed8fdcf064e4a0$export$600dc272ed516c15() {
    let dataRouterContext = $70ed8fdcf064e4a0$var$useDataRouterContext($70ed8fdcf064e4a0$var$DataRouterHook.UseRevalidator);
    let state = $70ed8fdcf064e4a0$var$useDataRouterState($70ed8fdcf064e4a0$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $70ed8fdcf064e4a0$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $70ed8fdcf064e4a0$var$useDataRouterState($70ed8fdcf064e4a0$var$DataRouterStateHook.UseMatches);
    return $lx97N.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $70ed8fdcf064e4a0$export$1448a5050d252c4d() {
    let state = $70ed8fdcf064e4a0$var$useDataRouterState($70ed8fdcf064e4a0$var$DataRouterStateHook.UseLoaderData);
    let routeId = $70ed8fdcf064e4a0$var$useCurrentRouteId($70ed8fdcf064e4a0$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $70ed8fdcf064e4a0$export$fd5d37484eab868d(routeId) {
    let state = $70ed8fdcf064e4a0$var$useDataRouterState($70ed8fdcf064e4a0$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $70ed8fdcf064e4a0$export$fdc00f3f26066d5e() {
    let state = $70ed8fdcf064e4a0$var$useDataRouterState($70ed8fdcf064e4a0$var$DataRouterStateHook.UseActionData);
    let route = $lx97N.useContext($70ed8fdcf064e4a0$export$9072aa6dd1f93057);
    !route && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $70ed8fdcf064e4a0$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $lx97N.useContext($70ed8fdcf064e4a0$var$RouteErrorContext);
    let state = $70ed8fdcf064e4a0$var$useDataRouterState($70ed8fdcf064e4a0$var$DataRouterStateHook.UseRouteError);
    let routeId = $70ed8fdcf064e4a0$var$useCurrentRouteId($70ed8fdcf064e4a0$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $70ed8fdcf064e4a0$export$78a72ddb39bdd145() {
    let value = $lx97N.useContext($70ed8fdcf064e4a0$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $70ed8fdcf064e4a0$export$17f53340677d5831() {
    let value = $lx97N.useContext($70ed8fdcf064e4a0$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $70ed8fdcf064e4a0$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $70ed8fdcf064e4a0$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $70ed8fdcf064e4a0$var$useDataRouterContext($70ed8fdcf064e4a0$var$DataRouterHook.UseBlocker);
    let state = $70ed8fdcf064e4a0$var$useDataRouterState($70ed8fdcf064e4a0$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $lx97N.useState("");
    let blockerFunction = $lx97N.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $70ed8fdcf064e4a0$var$_extends({}, currentLocation, {
                pathname: (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $70ed8fdcf064e4a0$var$_extends({}, nextLocation, {
                pathname: (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $lx97N.useEffect(()=>{
        let key = String(++$70ed8fdcf064e4a0$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $lx97N.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $d64590e8ac5fce5b$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $70ed8fdcf064e4a0$var$useNavigateStable() {
    let { router: router } = $70ed8fdcf064e4a0$var$useDataRouterContext($70ed8fdcf064e4a0$var$DataRouterHook.UseNavigateStable);
    let id = $70ed8fdcf064e4a0$var$useCurrentRouteId($70ed8fdcf064e4a0$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $lx97N.useRef(false);
    $70ed8fdcf064e4a0$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lx97N.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $70ed8fdcf064e4a0$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $70ed8fdcf064e4a0$var$alreadyWarned = {};
function $70ed8fdcf064e4a0$var$warningOnce(key, cond, message) {
    if (!cond && !$70ed8fdcf064e4a0$var$alreadyWarned[key]) $70ed8fdcf064e4a0$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $70ed8fdcf064e4a0$var$START_TRANSITION = "startTransition";
const $70ed8fdcf064e4a0$var$startTransitionImpl = $lx97N[$70ed8fdcf064e4a0$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $70ed8fdcf064e4a0$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $lx97N.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lx97N.useCallback((newState)=>{
        v7_startTransition && $70ed8fdcf064e4a0$var$startTransitionImpl ? $70ed8fdcf064e4a0$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lx97N.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $lx97N.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lx97N.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lx97N.createElement($lx97N.Fragment, null, /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $70ed8fdcf064e4a0$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $70ed8fdcf064e4a0$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $70ed8fdcf064e4a0$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $lx97N.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d64590e8ac5fce5b$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lx97N.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lx97N.useCallback((newState)=>{
        v7_startTransition && $70ed8fdcf064e4a0$var$startTransitionImpl ? $70ed8fdcf064e4a0$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lx97N.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $70ed8fdcf064e4a0$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$70ed8fdcf064e4a0$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let { matches: matches } = $lx97N.useContext($70ed8fdcf064e4a0$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $70ed8fdcf064e4a0$export$45d76561a5302f2b();
    let navigate = $70ed8fdcf064e4a0$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $d64590e8ac5fce5b$export$cae722b0cc860f13)(to, (0, $d64590e8ac5fce5b$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $lx97N.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $70ed8fdcf064e4a0$export$910ae8079b2c2852(props) {
    return $70ed8fdcf064e4a0$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $70ed8fdcf064e4a0$export$e7b0ac011bb776c6(_props) {
    (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $70ed8fdcf064e4a0$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $d64590e8ac5fce5b$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$70ed8fdcf064e4a0$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $lx97N.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $d64590e8ac5fce5b$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $lx97N.useMemo(()=>{
        let trailingPathname = (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $70ed8fdcf064e4a0$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $70ed8fdcf064e4a0$export$5d3fca4a98652595($70ed8fdcf064e4a0$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $70ed8fdcf064e4a0$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$ResolveAwait, null, children));
}
var $70ed8fdcf064e4a0$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($70ed8fdcf064e4a0$var$AwaitRenderStatus || ($70ed8fdcf064e4a0$var$AwaitRenderStatus = {}));
const $70ed8fdcf064e4a0$var$neverSettledPromise = new Promise(()=>{});
class $70ed8fdcf064e4a0$var$AwaitErrorBoundary extends $lx97N.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $70ed8fdcf064e4a0$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $70ed8fdcf064e4a0$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $70ed8fdcf064e4a0$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $70ed8fdcf064e4a0$var$AwaitRenderStatus.error : promise._data !== undefined ? $70ed8fdcf064e4a0$var$AwaitRenderStatus.success : $70ed8fdcf064e4a0$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $70ed8fdcf064e4a0$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $70ed8fdcf064e4a0$var$AwaitRenderStatus.error && promise._error instanceof (0, $d64590e8ac5fce5b$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $70ed8fdcf064e4a0$var$neverSettledPromise;
        if (status === $70ed8fdcf064e4a0$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $70ed8fdcf064e4a0$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $70ed8fdcf064e4a0$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $lx97N.createElement($70ed8fdcf064e4a0$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $70ed8fdcf064e4a0$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $70ed8fdcf064e4a0$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $lx97N.createElement($lx97N.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $70ed8fdcf064e4a0$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $lx97N.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $lx97N.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $lx97N.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $70ed8fdcf064e4a0$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $70ed8fdcf064e4a0$export$e7b0ac011bb776c6) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $70ed8fdcf064e4a0$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $70ed8fdcf064e4a0$export$daf73786167a7f72(matches) {
    return $70ed8fdcf064e4a0$var$_renderMatches(matches);
}
function $70ed8fdcf064e4a0$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $lx97N.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $lx97N.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $70ed8fdcf064e4a0$export$f30f7e456d254e83(routes, opts) {
    return (0, $d64590e8ac5fce5b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $70ed8fdcf064e4a0$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d64590e8ac5fce5b$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $70ed8fdcf064e4a0$export$52b333d321859367
    }).initialize();
}



function $e63ef3154ed2b0d6$var$_extends() {
    $e63ef3154ed2b0d6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e63ef3154ed2b0d6$var$_extends.apply(this, arguments);
}
function $e63ef3154ed2b0d6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $e63ef3154ed2b0d6$var$defaultMethod = "get";
const $e63ef3154ed2b0d6$var$defaultEncType = "application/x-www-form-urlencoded";
function $e63ef3154ed2b0d6$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $e63ef3154ed2b0d6$var$isButtonElement(object) {
    return $e63ef3154ed2b0d6$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $e63ef3154ed2b0d6$var$isFormElement(object) {
    return $e63ef3154ed2b0d6$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $e63ef3154ed2b0d6$var$isInputElement(object) {
    return $e63ef3154ed2b0d6$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $e63ef3154ed2b0d6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $e63ef3154ed2b0d6$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$e63ef3154ed2b0d6$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $e63ef3154ed2b0d6$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $e63ef3154ed2b0d6$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $e63ef3154ed2b0d6$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
// One-time check for submitter support
let $e63ef3154ed2b0d6$var$_formDataSupportsSubmitter = null;
function $e63ef3154ed2b0d6$var$isFormDataSubmitterSupported() {
    if ($e63ef3154ed2b0d6$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $e63ef3154ed2b0d6$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $e63ef3154ed2b0d6$var$_formDataSupportsSubmitter = true;
    }
    return $e63ef3154ed2b0d6$var$_formDataSupportsSubmitter;
}
const $e63ef3154ed2b0d6$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $e63ef3154ed2b0d6$var$getFormEncType(encType) {
    if (encType != null && !$e63ef3154ed2b0d6$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $e63ef3154ed2b0d6$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($e63ef3154ed2b0d6$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $e63ef3154ed2b0d6$var$defaultMethod;
        encType = $e63ef3154ed2b0d6$var$getFormEncType(target.getAttribute("enctype")) || $e63ef3154ed2b0d6$var$defaultEncType;
        formData = new FormData(target);
    } else if ($e63ef3154ed2b0d6$var$isButtonElement(target) || $e63ef3154ed2b0d6$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $e63ef3154ed2b0d6$var$defaultMethod;
        encType = $e63ef3154ed2b0d6$var$getFormEncType(target.getAttribute("formenctype")) || $e63ef3154ed2b0d6$var$getFormEncType(form.getAttribute("enctype")) || $e63ef3154ed2b0d6$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$e63ef3154ed2b0d6$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($e63ef3154ed2b0d6$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $e63ef3154ed2b0d6$var$defaultMethod;
        action = null;
        encType = $e63ef3154ed2b0d6$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $e63ef3154ed2b0d6$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $e63ef3154ed2b0d6$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $e63ef3154ed2b0d6$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $e63ef3154ed2b0d6$export$1f3f55432a00e06d(routes, opts) {
    return (0, $d64590e8ac5fce5b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e63ef3154ed2b0d6$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d64590e8ac5fce5b$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e63ef3154ed2b0d6$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $70ed8fdcf064e4a0$export$52b333d321859367)
    }).initialize();
}
function $e63ef3154ed2b0d6$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $d64590e8ac5fce5b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e63ef3154ed2b0d6$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d64590e8ac5fce5b$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e63ef3154ed2b0d6$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $70ed8fdcf064e4a0$export$52b333d321859367)
    }).initialize();
}
function $e63ef3154ed2b0d6$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $e63ef3154ed2b0d6$var$_extends({}, state, {
        errors: $e63ef3154ed2b0d6$var$deserializeErrors(state.errors)
    });
    return state;
}
function $e63ef3154ed2b0d6$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $d64590e8ac5fce5b$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message);
            // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $e63ef3154ed2b0d6$var$START_TRANSITION = "startTransition";
const $e63ef3154ed2b0d6$var$startTransitionImpl = $lx97N[$e63ef3154ed2b0d6$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $e63ef3154ed2b0d6$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $lx97N.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d64590e8ac5fce5b$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lx97N.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lx97N.useCallback((newState)=>{
        v7_startTransition && $e63ef3154ed2b0d6$var$startTransitionImpl ? $e63ef3154ed2b0d6$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lx97N.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lx97N.createElement((0, $70ed8fdcf064e4a0$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $e63ef3154ed2b0d6$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $lx97N.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d64590e8ac5fce5b$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lx97N.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lx97N.useCallback((newState)=>{
        v7_startTransition && $e63ef3154ed2b0d6$var$startTransitionImpl ? $e63ef3154ed2b0d6$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lx97N.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lx97N.createElement((0, $70ed8fdcf064e4a0$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $e63ef3154ed2b0d6$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $lx97N.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lx97N.useCallback((newState)=>{
        v7_startTransition && $e63ef3154ed2b0d6$var$startTransitionImpl ? $e63ef3154ed2b0d6$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lx97N.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lx97N.createElement((0, $70ed8fdcf064e4a0$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $e63ef3154ed2b0d6$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $e63ef3154ed2b0d6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $e63ef3154ed2b0d6$export$a6c7ac8248d6e38a = /*#__PURE__*/ $lx97N.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $e63ef3154ed2b0d6$var$_objectWithoutPropertiesLoose(_ref4, $e63ef3154ed2b0d6$var$_excluded);
    let { basename: basename } = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $e63ef3154ed2b0d6$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($e63ef3154ed2b0d6$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $70ed8fdcf064e4a0$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $e63ef3154ed2b0d6$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $lx97N.createElement("a", $e63ef3154ed2b0d6$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $e63ef3154ed2b0d6$export$b0d92dbee9b5b60d = /*#__PURE__*/ $lx97N.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $e63ef3154ed2b0d6$var$_objectWithoutPropertiesLoose(_ref5, $e63ef3154ed2b0d6$var$_excluded2);
    let path = (0, $70ed8fdcf064e4a0$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $70ed8fdcf064e4a0$export$45d76561a5302f2b)();
    let routerState = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$145dfa71566a64dc));
    let { navigator: navigator } = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $lx97N.createElement($e63ef3154ed2b0d6$export$a6c7ac8248d6e38a, $e63ef3154ed2b0d6$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $e63ef3154ed2b0d6$export$a7fed597f4b8afd8 = /*#__PURE__*/ $lx97N.forwardRef((props, ref)=>{
    let submit = $e63ef3154ed2b0d6$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $lx97N.createElement($e63ef3154ed2b0d6$var$FormImpl, $e63ef3154ed2b0d6$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $e63ef3154ed2b0d6$var$FormImpl = /*#__PURE__*/ $lx97N.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $e63ef3154ed2b0d6$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $e63ef3154ed2b0d6$var$_objectWithoutPropertiesLoose(_ref6, $e63ef3154ed2b0d6$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $e63ef3154ed2b0d6$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $lx97N.createElement("form", $e63ef3154ed2b0d6$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $e63ef3154ed2b0d6$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $e63ef3154ed2b0d6$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $e63ef3154ed2b0d6$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($e63ef3154ed2b0d6$var$DataRouterHook || ($e63ef3154ed2b0d6$var$DataRouterHook = {}));
var $e63ef3154ed2b0d6$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($e63ef3154ed2b0d6$var$DataRouterStateHook || ($e63ef3154ed2b0d6$var$DataRouterStateHook = {}));
function $e63ef3154ed2b0d6$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $e63ef3154ed2b0d6$var$useDataRouterContext(hookName) {
    let ctx = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$3add0d5dce533e2e));
    !ctx && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $e63ef3154ed2b0d6$var$useDataRouterState(hookName) {
    let state = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$145dfa71566a64dc));
    !state && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $e63ef3154ed2b0d6$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $70ed8fdcf064e4a0$export$9770f232ac06a008)();
    let location = (0, $70ed8fdcf064e4a0$export$45d76561a5302f2b)();
    let path = (0, $70ed8fdcf064e4a0$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $lx97N.useCallback((event)=>{
        if ($e63ef3154ed2b0d6$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $d64590e8ac5fce5b$export$fe53371bee54353d)(location) === (0, $d64590e8ac5fce5b$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $e63ef3154ed2b0d6$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $lx97N.useRef($e63ef3154ed2b0d6$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $lx97N.useRef(false);
    let location = (0, $70ed8fdcf064e4a0$export$45d76561a5302f2b)();
    let searchParams = $lx97N.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $e63ef3154ed2b0d6$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $70ed8fdcf064e4a0$export$9770f232ac06a008)();
    let setSearchParams = $lx97N.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $e63ef3154ed2b0d6$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $e63ef3154ed2b0d6$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $e63ef3154ed2b0d6$export$47c85c6e3a081d3() {
    let { router: router } = $e63ef3154ed2b0d6$var$useDataRouterContext($e63ef3154ed2b0d6$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$26749e8557646306));
    let currentRouteId = (0, $70ed8fdcf064e4a0$export$5fc8298006ad9e58)();
    return $lx97N.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $e63ef3154ed2b0d6$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $e63ef3154ed2b0d6$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $e63ef3154ed2b0d6$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $e63ef3154ed2b0d6$var$useDataRouterContext($e63ef3154ed2b0d6$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$26749e8557646306));
    return $lx97N.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $e63ef3154ed2b0d6$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $e63ef3154ed2b0d6$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $e63ef3154ed2b0d6$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$26749e8557646306));
    let routeContext = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$9072aa6dd1f93057));
    !routeContext && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $e63ef3154ed2b0d6$var$_extends({}, (0, $70ed8fdcf064e4a0$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $70ed8fdcf064e4a0$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $d64590e8ac5fce5b$export$fe53371bee54353d)(path);
}
function $e63ef3154ed2b0d6$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $lx97N.forwardRef((props, ref)=>{
        let submit = $e63ef3154ed2b0d6$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $lx97N.createElement($e63ef3154ed2b0d6$var$FormImpl, $e63ef3154ed2b0d6$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $e63ef3154ed2b0d6$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $e63ef3154ed2b0d6$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $e63ef3154ed2b0d6$var$useDataRouterContext($e63ef3154ed2b0d6$var$DataRouterHook.UseFetcher);
    let route = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$9072aa6dd1f93057));
    !route && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $lx97N.useState(()=>String(++$e63ef3154ed2b0d6$var$fetcherId));
    let [Form] = $lx97N.useState(()=>{
        !routeId && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        return $e63ef3154ed2b0d6$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $lx97N.useState(()=>(href)=>{
            !router && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
            !routeId && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $e63ef3154ed2b0d6$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $lx97N.useMemo(()=>$e63ef3154ed2b0d6$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $lx97N.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $e63ef3154ed2b0d6$export$fa996778a3a31087() {
    let state = $e63ef3154ed2b0d6$var$useDataRouterState($e63ef3154ed2b0d6$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $e63ef3154ed2b0d6$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $e63ef3154ed2b0d6$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $e63ef3154ed2b0d6$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $e63ef3154ed2b0d6$var$useDataRouterContext($e63ef3154ed2b0d6$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $e63ef3154ed2b0d6$var$useDataRouterState($e63ef3154ed2b0d6$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $lx97N.useContext((0, $70ed8fdcf064e4a0$export$26749e8557646306));
    let location = (0, $70ed8fdcf064e4a0$export$45d76561a5302f2b)();
    let matches = (0, $70ed8fdcf064e4a0$export$2378eb7f5ff86053)();
    let navigation = (0, $70ed8fdcf064e4a0$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $lx97N.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $e63ef3154ed2b0d6$var$usePageHide($lx97N.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $e63ef3154ed2b0d6$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $e63ef3154ed2b0d6$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($e63ef3154ed2b0d6$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lx97N.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $e63ef3154ed2b0d6$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $e63ef3154ed2b0d6$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lx97N.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($e63ef3154ed2b0d6$var$_extends({}, location, {
                    pathname: (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($e63ef3154ed2b0d6$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lx97N.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e63ef3154ed2b0d6$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $lx97N.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e63ef3154ed2b0d6$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $lx97N.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $e63ef3154ed2b0d6$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $70ed8fdcf064e4a0$export$2af03a1de5c0910)(when);
    $lx97N.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $lx97N.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}





var $937fbb3b934a0e39$exports = {};

$parcel$export($937fbb3b934a0e39$exports, "Container", () => $937fbb3b934a0e39$export$42a852a2b6b56249, (v) => $937fbb3b934a0e39$export$42a852a2b6b56249 = v);
var $937fbb3b934a0e39$export$42a852a2b6b56249;
$937fbb3b934a0e39$export$42a852a2b6b56249 = `zocBkG_Container`;


function $0cd418ba974578bd$export$2e2bcd8739ae039({ children: children, className: className = "" }) {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: `${className} ${(0, (/*@__PURE__*/$parcel$interopDefault($937fbb3b934a0e39$exports))).Container}`,
        children: children
    });
}




var $lx97N = parcelRequire("lx97N");
const $0ef5cc628c9d1d36$export$59a8eb9cff113544 = {
    bottomLeft: "bottomLeft",
    bottomRight: "bottomRight",
    topLeft: "topLeft",
    topRight: "topRight"
};
const $0ef5cc628c9d1d36$var$targets = Object.keys($0ef5cc628c9d1d36$export$59a8eb9cff113544);
const $0ef5cc628c9d1d36$var$Properties = {
    height: "height",
    x: "x",
    y: "y",
    width: "width"
};
const $0ef5cc628c9d1d36$var$properties = Object.keys($0ef5cc628c9d1d36$var$Properties);
const $0ef5cc628c9d1d36$var$PAUSE_DURATION = 500;
const $0ef5cc628c9d1d36$var$STAGE_DURATION = 1000;
const $0ef5cc628c9d1d36$var$pause = {
    type: "pause",
    duration: $0ef5cc628c9d1d36$var$PAUSE_DURATION
};
const $0ef5cc628c9d1d36$var$frames = [
    $0ef5cc628c9d1d36$var$pause,
    {
        type: "stage",
        duration: $0ef5cc628c9d1d36$var$STAGE_DURATION,
        paths: {
            bottomLeft: {
                x: 10,
                y: 165,
                width: 72,
                height: 72
            },
            bottomRight: {
                x: 92,
                y: 93,
                width: 146,
                height: 144
            },
            topLeft: {
                x: 10,
                y: 10,
                width: 72,
                height: 145
            },
            topRight: {
                x: 92,
                y: 10,
                width: 146,
                height: 73
            }
        }
    },
    $0ef5cc628c9d1d36$var$pause,
    {
        type: "stage",
        duration: $0ef5cc628c9d1d36$var$STAGE_DURATION,
        paths: {
            bottomLeft: {
                x: 10,
                y: 165,
                width: 146,
                height: 72
            },
            bottomRight: {
                x: 166,
                y: 93,
                width: 72,
                height: 144
            },
            topLeft: {
                x: 10,
                y: 10,
                width: 146,
                height: 145
            },
            topRight: {
                x: 166,
                y: 10,
                width: 72,
                height: 73
            }
        }
    },
    $0ef5cc628c9d1d36$var$pause,
    {
        type: "stage",
        duration: $0ef5cc628c9d1d36$var$STAGE_DURATION,
        paths: {
            bottomLeft: {
                x: 10,
                y: 78,
                width: 146,
                height: 159
            },
            bottomRight: {
                x: 166,
                y: 204,
                width: 72,
                height: 31
            },
            topLeft: {
                x: 10,
                y: 10,
                width: 146,
                height: 58
            },
            topRight: {
                x: 166,
                y: 10,
                width: 72,
                height: 184
            }
        }
    }
];
const $0ef5cc628c9d1d36$export$49bb65c2ea163039 = [];
const $0ef5cc628c9d1d36$var$stages = $0ef5cc628c9d1d36$var$frames.filter((step)=>step.type === "stage");
for(let index = 0; index < $0ef5cc628c9d1d36$var$frames.length; index++){
    const frame = $0ef5cc628c9d1d36$var$frames[index];
    switch(frame.type){
        case "pause":
            $0ef5cc628c9d1d36$export$49bb65c2ea163039.push(frame);
            break;
        case "stage":
            const fromStage = frame;
            const index1 = $0ef5cc628c9d1d36$var$stages.indexOf(fromStage);
            const toStage = index1 + 1 < $0ef5cc628c9d1d36$var$stages.length ? $0ef5cc628c9d1d36$var$stages[index1 + 1] : $0ef5cc628c9d1d36$var$stages[0];
            const changedProperties = [];
            $0ef5cc628c9d1d36$var$targets.forEach((target)=>{
                $0ef5cc628c9d1d36$var$properties.forEach((property)=>{
                    const from = fromStage.paths[target][property];
                    const to = toStage.paths[target][property];
                    if (from !== to) changedProperties.push({
                        target: target,
                        property: property,
                        from: from,
                        to: to
                    });
                });
            }, []);
            $0ef5cc628c9d1d36$export$49bb65c2ea163039.push({
                type: "animation",
                duration: frame.duration,
                properties: changedProperties
            });
            break;
    }
}



var $lx97N = parcelRequire("lx97N");
function $4891dd7cf736d046$export$a247a53d3dbd1105(svgRef, sequence) {
    (0, $lx97N.useEffect)(()=>{
        const svg = svgRef.current;
        const targetToPathElements = {
            bottomLeft: svg.children[1],
            bottomRight: svg.children[2],
            topLeft: svg.children[0],
            topRight: svg.children[3]
        };
        const startTime = performance.now();
        const duration = sequence.reduce((total, animation)=>total + animation.duration, 0);
        let animationFrameId = null;
        function animate() {
            const currentTime = performance.now();
            const elapsed = (currentTime - startTime) % duration;
            let segment;
            let accumulatedDuration = 0;
            for(let index = 0; index < sequence.length; index++){
                segment = sequence[index];
                if (elapsed >= accumulatedDuration && elapsed <= accumulatedDuration + segment.duration) break;
                else accumulatedDuration += segment.duration;
            }
            if (segment?.type === "animation") {
                const value = $4891dd7cf736d046$var$easing((elapsed - accumulatedDuration) / segment.duration);
                segment.properties.forEach(({ from: from, property: property, target: target, to: to })=>{
                    const pathElement = targetToPathElements[target];
                    pathElement.setAttribute(property, `${from + value * (to - from)}`);
                });
            }
            animationFrameId = requestAnimationFrame(animate);
        }
        animationFrameId = requestAnimationFrame(animate);
        return ()=>{
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
        };
    }, []);
}
// https://easings.net/#easeInOutBack
function $4891dd7cf736d046$var$easing(value) {
    const c1 = 1.70158;
    const c2 = c1 * 1.525;
    return value < 0.5 ? Math.pow(2 * value, 2) * ((c2 + 1) * 2 * value - c2) / 2 : (Math.pow(2 * value - 2, 2) * ((c2 + 1) * (value * 2 - 2) + c2) + 2) / 2;
}


var $7a6f3e6dd7416bda$exports = {};

$parcel$export($7a6f3e6dd7416bda$exports, "Svg", () => $7a6f3e6dd7416bda$export$e17b9c1182212c96, (v) => $7a6f3e6dd7416bda$export$e17b9c1182212c96 = v);
var $7a6f3e6dd7416bda$export$e17b9c1182212c96;
$7a6f3e6dd7416bda$export$e17b9c1182212c96 = `Co0QrW_Svg`;


function $49c110fe681dec3a$export$2e2bcd8739ae039({ className: className = "" }) {
    const svgRef = (0, $lx97N.useRef)(null);
    (0, $4891dd7cf736d046$export$a247a53d3dbd1105)(svgRef, (0, $0ef5cc628c9d1d36$export$49bb65c2ea163039));
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("svg", {
        className: `${className} ${(0, (/*@__PURE__*/$parcel$interopDefault($7a6f3e6dd7416bda$exports))).Svg}`,
        fill: "none",
        height: 248,
        ref: svgRef,
        width: 248,
        viewBox: "0 0 248 247",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("rect", {
                x: "10",
                y: "10",
                width: "72",
                height: "145",
                rx: "8",
                fill: "#D7B0FF"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("rect", {
                x: "10",
                y: "165",
                width: "72",
                height: "72",
                rx: "8",
                fill: "#F282AE"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("rect", {
                x: "92",
                y: "93",
                width: "146",
                height: "144",
                rx: "8",
                fill: "#88C0FE"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("rect", {
                x: "92",
                y: "10",
                width: "146",
                height: "73",
                rx: "8",
                fill: "#FADD7D"
            })
        ]
    });
}


var $d4f196dff1ad8d5b$exports = {};

$parcel$export($d4f196dff1ad8d5b$exports, "BottomRow", () => $d4f196dff1ad8d5b$export$2d43a53dbe6896b9, (v) => $d4f196dff1ad8d5b$export$2d43a53dbe6896b9 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "Code", () => $d4f196dff1ad8d5b$export$52f0f02147b12c03, (v) => $d4f196dff1ad8d5b$export$52f0f02147b12c03 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "Container", () => $d4f196dff1ad8d5b$export$42a852a2b6b56249, (v) => $d4f196dff1ad8d5b$export$42a852a2b6b56249 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "ExampleLink", () => $d4f196dff1ad8d5b$export$390e806094d13e6e, (v) => $d4f196dff1ad8d5b$export$390e806094d13e6e = v);
$parcel$export($d4f196dff1ad8d5b$exports, "ExamplesList", () => $d4f196dff1ad8d5b$export$d894408e6afa762e, (v) => $d4f196dff1ad8d5b$export$d894408e6afa762e = v);
$parcel$export($d4f196dff1ad8d5b$exports, "ExamplesListItem", () => $d4f196dff1ad8d5b$export$45135087948dea49, (v) => $d4f196dff1ad8d5b$export$45135087948dea49 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "ExamplesPanel", () => $d4f196dff1ad8d5b$export$fad6156fa43857c5, (v) => $d4f196dff1ad8d5b$export$fad6156fa43857c5 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "HeaderLink", () => $d4f196dff1ad8d5b$export$29c3409e43add430, (v) => $d4f196dff1ad8d5b$export$29c3409e43add430 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "HeaderLogo", () => $d4f196dff1ad8d5b$export$2351c626f671c828, (v) => $d4f196dff1ad8d5b$export$2351c626f671c828 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "HeaderRow", () => $d4f196dff1ad8d5b$export$f7dae34e2e37c751, (v) => $d4f196dff1ad8d5b$export$f7dae34e2e37c751 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "HeaderTagLine", () => $d4f196dff1ad8d5b$export$5e58e794e0f4659a, (v) => $d4f196dff1ad8d5b$export$5e58e794e0f4659a = v);
$parcel$export($d4f196dff1ad8d5b$exports, "HeaderText", () => $d4f196dff1ad8d5b$export$7c309220fd1fb205, (v) => $d4f196dff1ad8d5b$export$7c309220fd1fb205 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "HeaderTexts", () => $d4f196dff1ad8d5b$export$568d48d29cf6d9e2, (v) => $d4f196dff1ad8d5b$export$568d48d29cf6d9e2 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "InstallationPanel", () => $d4f196dff1ad8d5b$export$31597e7948c4b986, (v) => $d4f196dff1ad8d5b$export$31597e7948c4b986 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "ListItemNumber", () => $d4f196dff1ad8d5b$export$448080ad20b09ab8, (v) => $d4f196dff1ad8d5b$export$448080ad20b09ab8 = v);
$parcel$export($d4f196dff1ad8d5b$exports, "SubHeader", () => $d4f196dff1ad8d5b$export$3c0420c1ab00970c, (v) => $d4f196dff1ad8d5b$export$3c0420c1ab00970c = v);
$parcel$export($d4f196dff1ad8d5b$exports, "TopRow", () => $d4f196dff1ad8d5b$export$b416f8175c450f1c, (v) => $d4f196dff1ad8d5b$export$b416f8175c450f1c = v);
var $d4f196dff1ad8d5b$export$2d43a53dbe6896b9;
var $d4f196dff1ad8d5b$export$52f0f02147b12c03;
var $d4f196dff1ad8d5b$export$42a852a2b6b56249;
var $d4f196dff1ad8d5b$export$390e806094d13e6e;
var $d4f196dff1ad8d5b$export$d894408e6afa762e;
var $d4f196dff1ad8d5b$export$45135087948dea49;
var $d4f196dff1ad8d5b$export$fad6156fa43857c5;
var $d4f196dff1ad8d5b$export$29c3409e43add430;
var $d4f196dff1ad8d5b$export$2351c626f671c828;
var $d4f196dff1ad8d5b$export$f7dae34e2e37c751;
var $d4f196dff1ad8d5b$export$5e58e794e0f4659a;
var $d4f196dff1ad8d5b$export$7c309220fd1fb205;
var $d4f196dff1ad8d5b$export$568d48d29cf6d9e2;
var $d4f196dff1ad8d5b$export$31597e7948c4b986;
var $d4f196dff1ad8d5b$export$448080ad20b09ab8;
var $d4f196dff1ad8d5b$export$3c0420c1ab00970c;
var $d4f196dff1ad8d5b$export$b416f8175c450f1c;
$d4f196dff1ad8d5b$export$2d43a53dbe6896b9 = `AN1oZa_BottomRow`;
$d4f196dff1ad8d5b$export$52f0f02147b12c03 = `AN1oZa_Code`;
$d4f196dff1ad8d5b$export$42a852a2b6b56249 = `AN1oZa_Container`;
$d4f196dff1ad8d5b$export$390e806094d13e6e = `AN1oZa_ExampleLink`;
$d4f196dff1ad8d5b$export$d894408e6afa762e = `AN1oZa_ExamplesList`;
$d4f196dff1ad8d5b$export$45135087948dea49 = `AN1oZa_ExamplesListItem`;
$d4f196dff1ad8d5b$export$fad6156fa43857c5 = `AN1oZa_ExamplesPanel`;
$d4f196dff1ad8d5b$export$29c3409e43add430 = `AN1oZa_HeaderLink`;
$d4f196dff1ad8d5b$export$2351c626f671c828 = `AN1oZa_HeaderLogo`;
$d4f196dff1ad8d5b$export$f7dae34e2e37c751 = `AN1oZa_HeaderRow`;
$d4f196dff1ad8d5b$export$5e58e794e0f4659a = `AN1oZa_HeaderTagLine`;
$d4f196dff1ad8d5b$export$7c309220fd1fb205 = `AN1oZa_HeaderText`;
$d4f196dff1ad8d5b$export$568d48d29cf6d9e2 = `AN1oZa_HeaderTexts`;
$d4f196dff1ad8d5b$export$31597e7948c4b986 = `AN1oZa_InstallationPanel`;
$d4f196dff1ad8d5b$export$448080ad20b09ab8 = `AN1oZa_ListItemNumber`;
$d4f196dff1ad8d5b$export$3c0420c1ab00970c = `AN1oZa_SubHeader`;
$d4f196dff1ad8d5b$export$b416f8175c450f1c = `AN1oZa_TopRow`;


const $c577054c22bab523$var$LINKS = [
    {
        path: "horizontal",
        title: "Horizontal layouts"
    },
    {
        path: "vertical",
        title: "Vertical layouts"
    },
    {
        path: "nested",
        title: "Nested groups"
    },
    {
        path: "persistence",
        title: "Persistent layouts"
    },
    {
        path: "overflow",
        title: "Overflow content"
    },
    {
        path: "collapsible",
        title: "Collapsible panels"
    },
    {
        path: "conditional",
        title: "Conditional panels"
    },
    {
        path: "pixel-based-layouts",
        title: "Pixel based layouts"
    },
    {
        path: "external-persistence",
        title: "External persistence"
    },
    {
        path: "imperative-panel-api",
        title: "Imperative Panel API"
    },
    {
        path: "imperative-panel-group-api",
        title: "Imperative PanelGroup API"
    }
];
function $c577054c22bab523$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $0cd418ba974578bd$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).Container,
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).TopRow,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($c577054c22bab523$var$HeaderPanel, {})
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).BottomRow,
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($c577054c22bab523$var$ExamplesPanel, {}),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($c577054c22bab523$var$InstallationPanel, {})
                ]
            })
        ]
    });
}
function $c577054c22bab523$var$ExampleLink({ index: index, path: path, title: title }) {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).ExamplesListItem,
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).ListItemNumber,
                children: index + 1
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $e63ef3154ed2b0d6$export$a6c7ac8248d6e38a), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).ExampleLink,
                to: `/examples/${path}`,
                children: title
            })
        ]
    });
}
function $c577054c22bab523$var$ExamplesPanel() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).ExamplesPanel,
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).SubHeader,
                children: "Examples"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).ExamplesList,
                children: $c577054c22bab523$var$LINKS.map((link, index)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($c577054c22bab523$var$ExampleLink, {
                        index: index,
                        path: link.path,
                        title: link.title
                    }, index))
            })
        ]
    });
}
function $c577054c22bab523$var$HeaderPanel() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("a", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).HeaderLink,
        href: "https://github.com/bvaughn/react-resizable-panels",
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).Header,
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).HeaderRow,
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $49c110fe681dec3a$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).HeaderLogo
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).HeaderTexts,
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).HeaderText,
                                    children: "react"
                                }),
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).HeaderText,
                                    children: "resizable"
                                }),
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).HeaderText,
                                    children: "panels"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).HeaderTagLine,
                    children: "React components for resizable panels"
                })
            ]
        })
    });
}
function $c577054c22bab523$var$InstallationPanel() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).InstallationPanel,
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).SubHeader,
                children: "Installation"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d4f196dff1ad8d5b$exports))).Code,
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        className: "tok-comment",
                        children: "# npm"
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        className: "tok-operator",
                        children: "npm install "
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        className: "tok-variableName",
                        children: "react-resizable-panels"
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        className: "tok-comment",
                        children: "# yarn"
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        className: "tok-operator",
                        children: "yarn add "
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        className: "tok-variableName",
                        children: "react-resizable-panels"
                    })
                ]
            })
        ]
    });
}




var $lx97N = parcelRequire("lx97N");
const $eb14294b7841461b$export$4e09c449d6c407f7 = true;


const $3318dd6b4ac6739a$export$df77466336fe5355 = false;


// This module exists to work around Webpack issue https://github.com/webpack/webpack/issues/14814
// and limitations with ParcelJS parsing of the useId workaround (used below).
// For the time being, all react-resizable-panels must import "react" with the "* as React" syntax.
// To avoid mistakes, we use the ESLint "no-restricted-imports" to prevent "react" imports except in this file.
// See https://github.com/bvaughn/react-resizable-panels/issues/118
// eslint-disable-next-line no-restricted-imports

var $lx97N = parcelRequire("lx97N");
const { createElement: $aaa4f295803e727b$export$c8a8987d4410bf2d, createContext: $aaa4f295803e727b$export$fd42f52fd3ae1109, createRef: $aaa4f295803e727b$export$7d1e3a5e95ceca43, forwardRef: $aaa4f295803e727b$export$257a8862b851cb5b, useCallback: $aaa4f295803e727b$export$35808ee640e87ca7, useContext: $aaa4f295803e727b$export$fae74005e78b1a27, useEffect: $aaa4f295803e727b$export$6d9c69b0de29b591, useImperativeHandle: $aaa4f295803e727b$export$d5a552a76deda3c2, useLayoutEffect: $aaa4f295803e727b$export$e5c5a5f917a5871c, useMemo: $aaa4f295803e727b$export$1538c33de8887b59, useRef: $aaa4f295803e727b$export$b8f5890fc79d6aca, useState: $aaa4f295803e727b$export$60241385465d0a34 } = $lx97N;
// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const $aaa4f295803e727b$export$f680877a34711e37 = $lx97N["useId".toString()];


const $77e2580d2fa4de20$export$7d8c6d083caec74a = (0, $aaa4f295803e727b$export$fd42f52fd3ae1109)(null);
$77e2580d2fa4de20$export$7d8c6d083caec74a.displayName = "PanelGroupContext";




const $8acfb99206240232$var$useIsomorphicLayoutEffect = (0, $eb14294b7841461b$export$4e09c449d6c407f7) ? (0, $aaa4f295803e727b$export$e5c5a5f917a5871c) : ()=>{};
var $8acfb99206240232$export$2e2bcd8739ae039 = $8acfb99206240232$var$useIsomorphicLayoutEffect;



const $60b29bcfeb126d3d$var$wrappedUseId = typeof (0, $aaa4f295803e727b$export$f680877a34711e37) === "function" ? (0, $aaa4f295803e727b$export$f680877a34711e37) : ()=>null;
let $60b29bcfeb126d3d$var$counter = 0;
function $60b29bcfeb126d3d$export$2e2bcd8739ae039(idFromParams = null) {
    const idFromUseId = $60b29bcfeb126d3d$var$wrappedUseId();
    const idRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)(idFromParams || idFromUseId || null);
    if (idRef.current === null) idRef.current = "" + $60b29bcfeb126d3d$var$counter++;
    return idFromParams ?? idRef.current;
}



function $ab529e707bcaa627$export$35d79d63a6984ee1({ children: children, className: classNameFromProps = "", collapsedSizePercentage: collapsedSizePercentage, collapsedSizePixels: collapsedSizePixels, collapsible: collapsible, defaultSizePercentage: defaultSizePercentage, defaultSizePixels: defaultSizePixels, forwardedRef: forwardedRef, id: idFromProps, maxSizePercentage: maxSizePercentage, maxSizePixels: maxSizePixels, minSizePercentage: minSizePercentage, minSizePixels: minSizePixels, onCollapse: onCollapse, onExpand: onExpand, onResize: onResize, order: order, style: styleFromProps, tagName: Type = "div" }) {
    const context = (0, $aaa4f295803e727b$export$fae74005e78b1a27)((0, $77e2580d2fa4de20$export$7d8c6d083caec74a));
    if (context === null) throw Error(`Panel components must be rendered within a PanelGroup container`);
    const { collapsePanel: collapsePanel, expandPanel: expandPanel, getPanelSize: getPanelSize, getPanelStyle: getPanelStyle, isPanelCollapsed: isPanelCollapsed, registerPanel: registerPanel, resizePanel: resizePanel, unregisterPanel: unregisterPanel } = context;
    const panelId = (0, $60b29bcfeb126d3d$export$2e2bcd8739ae039)(idFromProps);
    const panelDataRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)({
        callbacks: {
            onCollapse: onCollapse,
            onExpand: onExpand,
            onResize: onResize
        },
        constraints: {
            collapsedSizePercentage: collapsedSizePercentage,
            collapsedSizePixels: collapsedSizePixels,
            collapsible: collapsible,
            defaultSizePercentage: defaultSizePercentage,
            defaultSizePixels: defaultSizePixels,
            maxSizePercentage: maxSizePercentage,
            maxSizePixels: maxSizePixels,
            minSizePercentage: minSizePercentage,
            minSizePixels: minSizePixels
        },
        id: panelId,
        idIsFromProps: idFromProps !== undefined,
        order: order
    });
    const devWarningsRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)({
        didLogMissingDefaultSizeWarning: false
    });
    // Normally we wouldn't log a warning during render,
    // but effects don't run on the server, so we can't do it there
    if (0, $3318dd6b4ac6739a$export$df77466336fe5355) {
        if (!devWarningsRef.current.didLogMissingDefaultSizeWarning) {
            if (!(0, $eb14294b7841461b$export$4e09c449d6c407f7) && defaultSizePercentage == null && defaultSizePixels == null) {
                devWarningsRef.current.didLogMissingDefaultSizeWarning = true;
                console.warn(`WARNING: Panel defaultSizePercentage or defaultSizePixels prop recommended to avoid layout shift after server rendering`);
            }
        }
    }
    (0, $8acfb99206240232$export$2e2bcd8739ae039)(()=>{
        const { callbacks: callbacks, constraints: constraints } = panelDataRef.current;
        panelDataRef.current.id = panelId;
        panelDataRef.current.idIsFromProps = idFromProps !== undefined;
        panelDataRef.current.order = order;
        callbacks.onCollapse = onCollapse;
        callbacks.onExpand = onExpand;
        callbacks.onResize = onResize;
        constraints.collapsedSizePercentage = collapsedSizePercentage;
        constraints.collapsedSizePixels = collapsedSizePixels;
        constraints.collapsible = collapsible;
        constraints.defaultSizePercentage = defaultSizePercentage;
        constraints.defaultSizePixels = defaultSizePixels;
        constraints.maxSizePercentage = maxSizePercentage;
        constraints.maxSizePixels = maxSizePixels;
        constraints.minSizePercentage = minSizePercentage;
        constraints.minSizePixels = minSizePixels;
    });
    (0, $8acfb99206240232$export$2e2bcd8739ae039)(()=>{
        const panelData = panelDataRef.current;
        registerPanel(panelData);
        return ()=>{
            unregisterPanel(panelData);
        };
    }, [
        order,
        panelId,
        registerPanel,
        unregisterPanel
    ]);
    (0, $aaa4f295803e727b$export$d5a552a76deda3c2)(forwardedRef, ()=>({
            collapse: ()=>{
                collapsePanel(panelDataRef.current);
            },
            expand: ()=>{
                expandPanel(panelDataRef.current);
            },
            getId () {
                return panelId;
            },
            getSize () {
                return getPanelSize(panelDataRef.current);
            },
            isCollapsed () {
                return isPanelCollapsed(panelDataRef.current);
            },
            isExpanded () {
                return !isPanelCollapsed(panelDataRef.current);
            },
            resize: (mixedSizes)=>{
                resizePanel(panelDataRef.current, mixedSizes);
            }
        }), [
        collapsePanel,
        expandPanel,
        getPanelSize,
        isPanelCollapsed,
        panelId,
        resizePanel
    ]);
    const style = getPanelStyle(panelDataRef.current);
    return (0, $aaa4f295803e727b$export$c8a8987d4410bf2d)(Type, {
        children: children,
        className: classNameFromProps,
        style: {
            ...style,
            ...styleFromProps
        },
        // CSS selectors
        "data-panel": "",
        "data-panel-id": panelId,
        // e2e test attributes
        "data-panel-collapsible": (0, $3318dd6b4ac6739a$export$df77466336fe5355) ? collapsible || undefined : undefined,
        "data-panel-size": (0, $3318dd6b4ac6739a$export$df77466336fe5355) ? parseFloat("" + style.flexGrow).toFixed(1) : undefined
    });
}
const $ab529e707bcaa627$export$2ddb90ad54e5f587 = (0, $aaa4f295803e727b$export$257a8862b851cb5b)((props, ref)=>(0, $aaa4f295803e727b$export$c8a8987d4410bf2d)($ab529e707bcaa627$export$35d79d63a6984ee1, {
        ...props,
        forwardedRef: ref
    }));
$ab529e707bcaa627$export$35d79d63a6984ee1.displayName = "Panel";
$ab529e707bcaa627$export$2ddb90ad54e5f587.displayName = "forwardRef(Panel)";







const $af01dfcf100a02a0$export$d6d3992f3becc879 = 10;


function $280e6084059d97a3$export$959aa6064dd8a2bb(pixels, groupSizePixels) {
    return pixels / groupSizePixels * 100;
}


function $53c240937fb3de5b$export$d4b7445a69bd4de7(panelConstraints, groupSizePixels) {
    let { collapsedSizePercentage: collapsedSizePercentage = 0, collapsedSizePixels: collapsedSizePixels, defaultSizePercentage: defaultSizePercentage, defaultSizePixels: defaultSizePixels, maxSizePercentage: maxSizePercentage = 100, maxSizePixels: maxSizePixels, minSizePercentage: minSizePercentage = 0, minSizePixels: minSizePixels } = panelConstraints;
    const hasPixelConstraints = collapsedSizePixels != null || defaultSizePixels != null || minSizePixels != null || maxSizePixels != null;
    if (hasPixelConstraints && groupSizePixels <= 0) {
        console.warn(`WARNING: Invalid group size: ${groupSizePixels}px`);
        return {
            collapsedSizePercentage: 0,
            defaultSizePercentage: defaultSizePercentage,
            maxSizePercentage: 0,
            minSizePercentage: 0
        };
    }
    if (collapsedSizePixels != null) collapsedSizePercentage = (0, $280e6084059d97a3$export$959aa6064dd8a2bb)(collapsedSizePixels, groupSizePixels);
    if (defaultSizePixels != null) defaultSizePercentage = (0, $280e6084059d97a3$export$959aa6064dd8a2bb)(defaultSizePixels, groupSizePixels);
    if (minSizePixels != null) minSizePercentage = (0, $280e6084059d97a3$export$959aa6064dd8a2bb)(minSizePixels, groupSizePixels);
    if (maxSizePixels != null) maxSizePercentage = (0, $280e6084059d97a3$export$959aa6064dd8a2bb)(maxSizePixels, groupSizePixels);
    return {
        collapsedSizePercentage: collapsedSizePercentage,
        defaultSizePercentage: defaultSizePercentage,
        maxSizePercentage: maxSizePercentage,
        minSizePercentage: minSizePercentage
    };
}


function $b8b2acf02a6d9543$export$2317728de084d6f9(panelConstraintsArray, panelIndex, groupSizePixels) {
    // All panel constraints, excluding the current one
    let totalMinConstraints = 0;
    let totalMaxConstraints = 0;
    for(let index = 0; index < panelConstraintsArray.length; index++)if (index !== panelIndex) {
        const { collapsible: collapsible } = panelConstraintsArray[index];
        const { collapsedSizePercentage: collapsedSizePercentage, maxSizePercentage: maxSizePercentage, minSizePercentage: minSizePercentage } = (0, $53c240937fb3de5b$export$d4b7445a69bd4de7)(panelConstraintsArray[index], groupSizePixels);
        totalMaxConstraints += maxSizePercentage;
        totalMinConstraints += collapsible ? collapsedSizePercentage : minSizePercentage;
    }
    const { collapsedSizePercentage: collapsedSizePercentage, defaultSizePercentage: defaultSizePercentage, maxSizePercentage: maxSizePercentage, minSizePercentage: minSizePercentage } = (0, $53c240937fb3de5b$export$d4b7445a69bd4de7)(panelConstraintsArray[panelIndex], groupSizePixels);
    return {
        collapsedSizePercentage: collapsedSizePercentage,
        defaultSizePercentage: defaultSizePercentage,
        maxSizePercentage: panelConstraintsArray.length > 1 ? Math.min(maxSizePercentage, 100 - totalMinConstraints) : maxSizePercentage,
        minSizePercentage: panelConstraintsArray.length > 1 ? Math.max(minSizePercentage, 100 - totalMaxConstraints) : minSizePercentage
    };
}



function $91299dba5bbe0e38$export$1d75b1119dff900(actual, expected, fractionDigits = (0, $af01dfcf100a02a0$export$d6d3992f3becc879)) {
    actual = parseFloat(actual.toFixed(fractionDigits));
    expected = parseFloat(expected.toFixed(fractionDigits));
    const delta = actual - expected;
    if (delta === 0) return 0;
    else return delta > 0 ? 1 : -1;
}


function $50bf8b919bea9957$export$db9c8bd2fae72e82(actual, expected, fractionDigits) {
    return (0, $91299dba5bbe0e38$export$1d75b1119dff900)(actual, expected, fractionDigits) === 0;
}




function $3a90ecb79eebe05c$export$2f98edcf4006376f({ groupSizePixels: groupSizePixels, panelConstraints: panelConstraints, panelIndex: panelIndex, size: size }) {
    const hasPixelConstraints = panelConstraints.some(({ collapsedSizePixels: collapsedSizePixels, defaultSizePixels: defaultSizePixels, minSizePixels: minSizePixels, maxSizePixels: maxSizePixels })=>collapsedSizePixels != null || defaultSizePixels != null || minSizePixels != null || maxSizePixels != null);
    if (hasPixelConstraints && groupSizePixels <= 0) {
        console.warn(`WARNING: Invalid group size: ${groupSizePixels}px`);
        return 0;
    }
    let { collapsible: collapsible } = panelConstraints[panelIndex];
    const { collapsedSizePercentage: collapsedSizePercentage, maxSizePercentage: maxSizePercentage, minSizePercentage: minSizePercentage } = (0, $b8b2acf02a6d9543$export$2317728de084d6f9)(panelConstraints, panelIndex, groupSizePixels);
    if (minSizePercentage != null) {
        if ((0, $91299dba5bbe0e38$export$1d75b1119dff900)(size, minSizePercentage) < 0) {
            if (collapsible) size = collapsedSizePercentage;
            else size = minSizePercentage;
        }
    }
    if (maxSizePercentage != null) size = Math.min(maxSizePercentage, size);
    return size;
}


let $52a540e312c50d97$var$isCheckingForInfiniteLoop = false;
function $52a540e312c50d97$export$7fead5cc734d205b({ delta: delta, groupSizePixels: groupSizePixels, layout: prevLayout, panelConstraints: panelConstraints, pivotIndices: pivotIndices, trigger: trigger }) {
    if ((0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(delta, 0)) return prevLayout;
    const nextLayout = [
        ...prevLayout
    ];
    let deltaApplied = 0;
    // A resizing panel affects the panels before or after it.
    //
    // A negative delta means the panel immediately after the resizer should grow/expand by decreasing its offset.
    // Other panels may also need to shrink/contract (and shift) to make room, depending on the min weights.
    //
    // A positive delta means the panel immediately before the resizer should "expand".
    // This is accomplished by shrinking/contracting (and shifting) one or more of the panels after the resizer.
    // First, check the panel we're pivoting around;
    // We should only expand or contract by as much as its constraints allow
    {
        const pivotIndex = delta < 0 ? pivotIndices[1] : pivotIndices[0];
        const initialSize = nextLayout[pivotIndex];
        const { collapsible: collapsible } = panelConstraints[pivotIndex];
        const { collapsedSizePercentage: collapsedSizePercentage, minSizePercentage: minSizePercentage } = (0, $b8b2acf02a6d9543$export$2317728de084d6f9)(panelConstraints, pivotIndex, groupSizePixels);
        const isCollapsed = collapsible && (0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(initialSize, collapsedSizePercentage);
        let unsafeSize = initialSize + Math.abs(delta);
        if (isCollapsed) switch(trigger){
            case "keyboard":
                if (minSizePercentage > unsafeSize) unsafeSize = minSizePercentage;
        }
        const safeSize = (0, $3a90ecb79eebe05c$export$2f98edcf4006376f)({
            groupSizePixels: groupSizePixels,
            panelConstraints: panelConstraints,
            panelIndex: pivotIndex,
            size: unsafeSize
        });
        if ((0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(initialSize, safeSize)) // If there's no room for the pivot panel to grow, we should ignore this change
        return nextLayout;
        else delta = delta < 0 ? initialSize - safeSize : safeSize - initialSize;
    }
    // Delta added to a panel needs to be subtracted from other panels
    // within the constraints that those panels allow
    {
        const pivotIndex = delta < 0 ? pivotIndices[0] : pivotIndices[1];
        let index = pivotIndex;
        while(index >= 0 && index < panelConstraints.length){
            const deltaRemaining = Math.abs(delta) - Math.abs(deltaApplied);
            const prevSize = prevLayout[index];
            const unsafeSize = prevSize - deltaRemaining;
            let safeSize = (0, $3a90ecb79eebe05c$export$2f98edcf4006376f)({
                groupSizePixels: groupSizePixels,
                panelConstraints: panelConstraints,
                panelIndex: index,
                size: unsafeSize
            });
            if (!(0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(prevSize, safeSize)) {
                deltaApplied += prevSize - safeSize;
                nextLayout[index] = safeSize;
                if (deltaApplied.toPrecision(3).localeCompare(Math.abs(delta).toPrecision(3), undefined, {
                    numeric: true
                }) >= 0) break;
            }
            if (delta < 0) index--;
            else index++;
        }
    }
    // If we were unable to resize any of the panels panels, return the previous state.
    // This will essentially bailout and ignore e.g. drags past a panel's boundaries
    if ((0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(deltaApplied, 0)) return prevLayout;
    {
        const pivotIndex = delta < 0 ? pivotIndices[1] : pivotIndices[0];
        const unsafeSize = prevLayout[pivotIndex] + deltaApplied;
        const safeSize = (0, $3a90ecb79eebe05c$export$2f98edcf4006376f)({
            groupSizePixels: groupSizePixels,
            panelConstraints: panelConstraints,
            panelIndex: pivotIndex,
            size: unsafeSize
        });
        // Adjust the pivot panel before, but only by the amount that surrounding panels were able to shrink/contract.
        nextLayout[pivotIndex] = safeSize;
        // Edge case where expanding or contracting one panel caused another one to change collapsed state
        if (!(0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(safeSize, unsafeSize)) {
            let deltaRemaining = unsafeSize - safeSize;
            const pivotIndex = delta < 0 ? pivotIndices[1] : pivotIndices[0];
            let index = pivotIndex;
            while(index >= 0 && index < panelConstraints.length){
                const prevSize = nextLayout[index];
                const unsafeSize = prevSize + deltaRemaining;
                const safeSize = (0, $3a90ecb79eebe05c$export$2f98edcf4006376f)({
                    groupSizePixels: groupSizePixels,
                    panelConstraints: panelConstraints,
                    panelIndex: index,
                    size: unsafeSize
                });
                if (!(0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(prevSize, safeSize)) {
                    deltaRemaining -= safeSize - prevSize;
                    nextLayout[index] = safeSize;
                }
                if ((0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(deltaRemaining, 0)) break;
                if (delta > 0) index--;
                else index++;
            }
            // If we can't redistribute, this layout is invalid;
            // There may be an incremental layout that is valid though
            if (!(0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(deltaRemaining, 0)) {
                let didSetInfiniteLoopCheckCounter = false;
                if ($52a540e312c50d97$var$isCheckingForInfiniteLoop === null) {
                    didSetInfiniteLoopCheckCounter = true;
                    $52a540e312c50d97$var$isCheckingForInfiniteLoop = true;
                }
                try {
                    return $52a540e312c50d97$export$7fead5cc734d205b({
                        delta: delta < 0 ? delta + 1 : delta - 1,
                        groupSizePixels: groupSizePixels,
                        layout: prevLayout,
                        panelConstraints: panelConstraints,
                        pivotIndices: pivotIndices,
                        trigger: trigger
                    });
                } catch (error) {
                    if (error instanceof RangeError) {
                        console.error(`Could not apply delta ${delta} to layout`);
                        return prevLayout;
                    }
                } finally{
                    if (didSetInfiniteLoopCheckCounter) $52a540e312c50d97$var$isCheckingForInfiniteLoop = false;
                }
            }
        }
    }
    return nextLayout;
}


function $d524cb4ee877d0ea$export$a7a9523472993e97(expectedCondition, message = "Assertion failed!") {
    if (!expectedCondition) {
        console.error(message);
        throw Error(message);
    }
}



function $2f521c3f0845bde7$export$c436620f45b24369({ sizePercentage: sizePercentage, sizePixels: sizePixels }, groupSizePixels) {
    if (sizePercentage != null) return sizePercentage;
    else if (sizePixels != null) return (0, $280e6084059d97a3$export$959aa6064dd8a2bb)(sizePixels, groupSizePixels);
    return undefined;
}


function $2a80429dac1ab499$export$b8372a468ba36f7d({ groupSizePixels: groupSizePixels, layout: layout, panelsArray: panelsArray, pivotIndices: pivotIndices }) {
    let currentMinSize = 0;
    let currentMaxSize = 100;
    let totalMinSize = 0;
    let totalMaxSize = 0;
    // A panel's effective min/max sizes also need to account for other panel's sizes.
    panelsArray.forEach((panelData, index)=>{
        const { constraints: constraints } = panelData;
        const { maxSizePercentage: maxSizePercentage, maxSizePixels: maxSizePixels, minSizePercentage: minSizePercentage, minSizePixels: minSizePixels } = constraints;
        const minSize = (0, $2f521c3f0845bde7$export$c436620f45b24369)({
            sizePercentage: minSizePercentage,
            sizePixels: minSizePixels
        }, groupSizePixels) ?? 0;
        const maxSize = (0, $2f521c3f0845bde7$export$c436620f45b24369)({
            sizePercentage: maxSizePercentage,
            sizePixels: maxSizePixels
        }, groupSizePixels) ?? 100;
        if (index === pivotIndices[0]) {
            currentMinSize = minSize;
            currentMaxSize = maxSize;
        } else {
            totalMinSize += minSize;
            totalMaxSize += maxSize;
        }
    });
    const valueMax = Math.min(currentMaxSize, 100 - totalMinSize);
    const valueMin = Math.max(currentMinSize, 100 - totalMaxSize);
    const valueNow = layout[pivotIndices[0]];
    return {
        valueMax: valueMax,
        valueMin: valueMin,
        valueNow: valueNow
    };
}


function $e99d67025d5a35f8$export$63eb605e437b214f(groupId) {
    return Array.from(document.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${groupId}"]`));
}


function $d4aeaf7db7fcf912$export$4c92fedbbc2381ca(groupId, id) {
    const handles = (0, $e99d67025d5a35f8$export$63eb605e437b214f)(groupId);
    const index = handles.findIndex((handle)=>handle.getAttribute("data-panel-resize-handle-id") === id);
    return index ?? null;
}


function $5e65faded090fabc$export$cf92598869f99b8f(groupId, dragHandleId) {
    const index = (0, $d4aeaf7db7fcf912$export$4c92fedbbc2381ca)(groupId, dragHandleId);
    return index != null ? [
        index,
        index + 1
    ] : [
        -1,
        -1
    ];
}


function $ccad9c604596b2d2$export$4e72aefa594058df(id) {
    const element = document.querySelector(`[data-panel-group][data-panel-group-id="${id}"]`);
    if (element) return element;
    return null;
}



function $bf1647d5321b3e7e$export$29b617c5e3d8da8c(groupId) {
    const panelGroupElement = (0, $ccad9c604596b2d2$export$4e72aefa594058df)(groupId);
    if (panelGroupElement == null) return NaN;
    const direction = panelGroupElement.getAttribute("data-panel-group-direction");
    const resizeHandles = (0, $e99d67025d5a35f8$export$63eb605e437b214f)(groupId);
    if (direction === "horizontal") return panelGroupElement.offsetWidth - resizeHandles.reduce((accumulated, handle)=>{
        return accumulated + handle.offsetWidth;
    }, 0);
    else return panelGroupElement.offsetHeight - resizeHandles.reduce((accumulated, handle)=>{
        return accumulated + handle.offsetHeight;
    }, 0);
}




function $f9cd8c3c387df70f$export$e6f7ba97d54c60f2(groupId) {
    const panelGroupElement = (0, $ccad9c604596b2d2$export$4e72aefa594058df)(groupId);
    if (panelGroupElement == null) return NaN;
    const direction = panelGroupElement.getAttribute("data-panel-group-direction");
    const resizeHandles = (0, $e99d67025d5a35f8$export$63eb605e437b214f)(groupId);
    if (direction === "horizontal") return panelGroupElement.offsetWidth - resizeHandles.reduce((accumulated, handle)=>{
        return accumulated + handle.offsetWidth;
    }, 0);
    else return panelGroupElement.offsetHeight - resizeHandles.reduce((accumulated, handle)=>{
        return accumulated + handle.offsetHeight;
    }, 0);
}




function $a7c4e7d97218e9bb$export$4c5229c874a62620(id) {
    const element = document.querySelector(`[data-panel-resize-handle-id="${id}"]`);
    if (element) return element;
    return null;
}



function $e7609a99b8fdd37a$export$68d3a33c21dfbe27(groupId, handleId, panelsArray) {
    const handle = (0, $a7c4e7d97218e9bb$export$4c5229c874a62620)(handleId);
    const handles = (0, $e99d67025d5a35f8$export$63eb605e437b214f)(groupId);
    const index = handle ? handles.indexOf(handle) : -1;
    const idBefore = panelsArray[index]?.id ?? null;
    const idAfter = panelsArray[index + 1]?.id ?? null;
    return [
        idBefore,
        idAfter
    ];
}





function $d9219661d18d6238$export$d9fcbe062527d159({ committedValuesRef: committedValuesRef, groupId: groupId, layout: layout, panelDataArray: panelDataArray, setLayout: setLayout }) {
    const devWarningsRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)({
        didWarnAboutMissingResizeHandle: false
    });
    (0, $8acfb99206240232$export$2e2bcd8739ae039)(()=>{
        const groupSizePixels = (0, $bf1647d5321b3e7e$export$29b617c5e3d8da8c)(groupId);
        const resizeHandleElements = (0, $e99d67025d5a35f8$export$63eb605e437b214f)(groupId);
        for(let index = 0; index < panelDataArray.length - 1; index++){
            const { valueMax: valueMax, valueMin: valueMin, valueNow: valueNow } = (0, $2a80429dac1ab499$export$b8372a468ba36f7d)({
                groupSizePixels: groupSizePixels,
                layout: layout,
                panelsArray: panelDataArray,
                pivotIndices: [
                    index,
                    index + 1
                ]
            });
            const resizeHandleElement = resizeHandleElements[index];
            if (resizeHandleElement == null) {
                if (0, $3318dd6b4ac6739a$export$df77466336fe5355) {
                    const { didWarnAboutMissingResizeHandle: didWarnAboutMissingResizeHandle } = devWarningsRef.current;
                    if (!didWarnAboutMissingResizeHandle) {
                        devWarningsRef.current.didWarnAboutMissingResizeHandle = true;
                        console.warn(`WARNING: Missing resize handle for PanelGroup "${groupId}"`);
                    }
                }
            } else {
                resizeHandleElement.setAttribute("aria-controls", panelDataArray[index].id);
                resizeHandleElement.setAttribute("aria-valuemax", "" + Math.round(valueMax));
                resizeHandleElement.setAttribute("aria-valuemin", "" + Math.round(valueMin));
                resizeHandleElement.setAttribute("aria-valuenow", "" + Math.round(valueNow));
            }
        }
        return ()=>{
            resizeHandleElements.forEach((resizeHandleElement, index)=>{
                resizeHandleElement.removeAttribute("aria-controls");
                resizeHandleElement.removeAttribute("aria-valuemax");
                resizeHandleElement.removeAttribute("aria-valuemin");
                resizeHandleElement.removeAttribute("aria-valuenow");
            });
        };
    }, [
        groupId,
        layout,
        panelDataArray
    ]);
    (0, $aaa4f295803e727b$export$6d9c69b0de29b591)(()=>{
        const { direction: direction, panelDataArray: panelDataArray } = committedValuesRef.current;
        const groupElement = (0, $ccad9c604596b2d2$export$4e72aefa594058df)(groupId);
        (0, $d524cb4ee877d0ea$export$a7a9523472993e97)(groupElement != null, `No group found for id "${groupId}"`);
        const { height: height, width: width } = groupElement.getBoundingClientRect();
        const handles = (0, $e99d67025d5a35f8$export$63eb605e437b214f)(groupId);
        const cleanupFunctions = handles.map((handle)=>{
            const handleId = handle.getAttribute("data-panel-resize-handle-id");
            const [idBefore, idAfter] = (0, $e7609a99b8fdd37a$export$68d3a33c21dfbe27)(groupId, handleId, panelDataArray);
            if (idBefore == null || idAfter == null) return ()=>{};
            const onKeyDown = (event)=>{
                if (event.defaultPrevented) return;
                switch(event.key){
                    case "Enter":
                        {
                            event.preventDefault();
                            const index = panelDataArray.findIndex((panelData)=>panelData.id === idBefore);
                            if (index >= 0) {
                                const panelData = panelDataArray[index];
                                const size = layout[index];
                                if (size != null) {
                                    const groupSizePixels = (0, $f9cd8c3c387df70f$export$e6f7ba97d54c60f2)(groupId);
                                    const minSize = (0, $2f521c3f0845bde7$export$c436620f45b24369)({
                                        sizePercentage: panelData.constraints.minSizePercentage,
                                        sizePixels: panelData.constraints.minSizePixels
                                    }, groupSizePixels) ?? 0;
                                    let delta = 0;
                                    if (size.toPrecision((0, $af01dfcf100a02a0$export$d6d3992f3becc879)) <= minSize.toPrecision((0, $af01dfcf100a02a0$export$d6d3992f3becc879))) delta = direction === "horizontal" ? width : height;
                                    else delta = -(direction === "horizontal" ? width : height);
                                    const nextLayout = (0, $52a540e312c50d97$export$7fead5cc734d205b)({
                                        delta: delta,
                                        groupSizePixels: groupSizePixels,
                                        layout: layout,
                                        panelConstraints: panelDataArray.map((panelData)=>panelData.constraints),
                                        pivotIndices: (0, $5e65faded090fabc$export$cf92598869f99b8f)(groupId, handleId),
                                        trigger: "keyboard"
                                    });
                                    if (layout !== nextLayout) setLayout(nextLayout);
                                }
                            }
                            break;
                        }
                }
            };
            handle.addEventListener("keydown", onKeyDown);
            return ()=>{
                handle.removeEventListener("keydown", onKeyDown);
            };
        });
        return ()=>{
            cleanupFunctions.forEach((cleanupFunction)=>cleanupFunction());
        };
    }, [
        committedValuesRef,
        groupId,
        layout,
        panelDataArray,
        setLayout
    ]);
}



function $496e0d889792e959$export$b141efd0b0fb9174(arrayA, arrayB) {
    if (arrayA.length !== arrayB.length) return false;
    for(let index = 0; index < arrayA.length; index++){
        if (arrayA[index] !== arrayB[index]) return false;
    }
    return true;
}





function $5c88e00ca90ee80e$export$e7bf60a870f429b0(event) {
    return event.type === "keydown";
}
function $5c88e00ca90ee80e$export$764db16956f554f8(event) {
    return event.type.startsWith("mouse");
}
function $5c88e00ca90ee80e$export$c4dfce035d43d1e0(event) {
    return event.type.startsWith("touch");
}


function $411ca3503af7ecb0$export$ae0c59ca751ba81d(direction, event) {
    const isHorizontal = direction === "horizontal";
    if ((0, $5c88e00ca90ee80e$export$764db16956f554f8)(event)) return isHorizontal ? event.clientX : event.clientY;
    else if ((0, $5c88e00ca90ee80e$export$c4dfce035d43d1e0)(event)) {
        const firstTouch = event.touches[0];
        return isHorizontal ? firstTouch.screenX : firstTouch.screenY;
    } else throw Error(`Unsupported event type "${event.type}"`);
}


function $de7865585ecd6f2c$export$e3b8a38f1f6abc89(event, dragHandleId, direction, initialDragState) {
    const isHorizontal = direction === "horizontal";
    const handleElement = (0, $a7c4e7d97218e9bb$export$4c5229c874a62620)(dragHandleId);
    const groupId = handleElement.getAttribute("data-panel-group-id");
    let { initialCursorPosition: initialCursorPosition } = initialDragState;
    const cursorPosition = (0, $411ca3503af7ecb0$export$ae0c59ca751ba81d)(direction, event);
    const groupElement = (0, $ccad9c604596b2d2$export$4e72aefa594058df)(groupId);
    const groupRect = groupElement.getBoundingClientRect();
    const groupSizeInPixels = isHorizontal ? groupRect.width : groupRect.height;
    const offsetPixels = cursorPosition - initialCursorPosition;
    const offsetPercentage = offsetPixels / groupSizeInPixels * 100;
    return offsetPercentage;
}



function $2f4df8f4953afd48$export$b08134b65f9db46a(event, groupId, dragHandleId, direction, initialDragState, keyboardResizeByOptions) {
    if ((0, $5c88e00ca90ee80e$export$e7bf60a870f429b0)(event)) {
        const isHorizontal = direction === "horizontal";
        const groupElement = (0, $ccad9c604596b2d2$export$4e72aefa594058df)(groupId);
        const rect = groupElement.getBoundingClientRect();
        const groupSizeInPixels = isHorizontal ? rect.width : rect.height;
        let delta = 0;
        if (event.shiftKey) delta = 100;
        else if (keyboardResizeByOptions.percentage != null) delta = keyboardResizeByOptions.percentage;
        else if (keyboardResizeByOptions.pixels != null) delta = keyboardResizeByOptions.pixels / groupSizeInPixels;
        else delta = 10;
        let movement = 0;
        switch(event.key){
            case "ArrowDown":
                movement = isHorizontal ? 0 : delta;
                break;
            case "ArrowLeft":
                movement = isHorizontal ? -delta : 0;
                break;
            case "ArrowRight":
                movement = isHorizontal ? delta : 0;
                break;
            case "ArrowUp":
                movement = isHorizontal ? 0 : -delta;
                break;
            case "End":
                movement = 100;
                break;
            case "Home":
                movement = -100;
                break;
        }
        return movement;
    } else return (0, $de7865585ecd6f2c$export$e3b8a38f1f6abc89)(event, dragHandleId, direction, initialDragState);
}



function $dda70b6d0c13b7b2$export$47337a21c443778e({ groupSizePixels: groupSizePixels, panelDataArray: panelDataArray }) {
    const layout = Array(panelDataArray.length);
    const panelDataConstraints = panelDataArray.map((panelData)=>panelData.constraints);
    let numPanelsWithSizes = 0;
    let remainingSize = 100;
    // Distribute default sizes first
    for(let index = 0; index < panelDataArray.length; index++){
        const { defaultSizePercentage: defaultSizePercentage } = (0, $b8b2acf02a6d9543$export$2317728de084d6f9)(panelDataConstraints, index, groupSizePixels);
        if (defaultSizePercentage != null) {
            numPanelsWithSizes++;
            layout[index] = defaultSizePercentage;
            remainingSize -= defaultSizePercentage;
        }
    }
    // Remaining size should be distributed evenly between panels without default sizes
    for(let index = 0; index < panelDataArray.length; index++){
        const { defaultSizePercentage: defaultSizePercentage } = (0, $b8b2acf02a6d9543$export$2317728de084d6f9)(panelDataConstraints, index, groupSizePixels);
        if (defaultSizePercentage != null) continue;
        const numRemainingPanels = panelDataArray.length - numPanelsWithSizes;
        const size = remainingSize / numRemainingPanels;
        numPanelsWithSizes++;
        layout[index] = size;
        remainingSize -= size;
    }
    return layout;
}



function $1a803393aaae0c7c$export$528dc9932b07582d(percentage, groupSizePixels) {
    return percentage / 100 * groupSizePixels;
}



function $8a0d71fa0900eb22$export$b8e48269e4faa934(groupId, panelsArray, layout, panelIdToLastNotifiedMixedSizesMap) {
    const groupSizePixels = (0, $bf1647d5321b3e7e$export$29b617c5e3d8da8c)(groupId);
    layout.forEach((sizePercentage, index)=>{
        const panelData = panelsArray[index];
        if (!panelData) // Handle initial mount (when panels are registered too late to be in the panels array)
        // The subsequent render+effects will handle the resize notification
        return;
        const { callbacks: callbacks, constraints: constraints, id: panelId } = panelData;
        const { collapsible: collapsible } = constraints;
        const mixedSizes = {
            sizePercentage: sizePercentage,
            sizePixels: (0, $1a803393aaae0c7c$export$528dc9932b07582d)(sizePercentage, groupSizePixels)
        };
        const lastNotifiedMixedSizes = panelIdToLastNotifiedMixedSizesMap[panelId];
        if (lastNotifiedMixedSizes == null || mixedSizes.sizePercentage !== lastNotifiedMixedSizes.sizePercentage || mixedSizes.sizePixels !== lastNotifiedMixedSizes.sizePixels) {
            panelIdToLastNotifiedMixedSizesMap[panelId] = mixedSizes;
            const { onCollapse: onCollapse, onExpand: onExpand, onResize: onResize } = callbacks;
            if (onResize) onResize(mixedSizes, lastNotifiedMixedSizes);
            if (collapsible && (onCollapse || onExpand)) {
                const collapsedSize = (0, $2f521c3f0845bde7$export$c436620f45b24369)({
                    sizePercentage: constraints.collapsedSizePercentage,
                    sizePixels: constraints.collapsedSizePixels
                }, groupSizePixels) ?? 0;
                const size = (0, $2f521c3f0845bde7$export$c436620f45b24369)(mixedSizes, groupSizePixels);
                if (onExpand && (lastNotifiedMixedSizes == null || lastNotifiedMixedSizes.sizePercentage === collapsedSize) && size !== collapsedSize) onExpand();
                if (onCollapse && (lastNotifiedMixedSizes == null || lastNotifiedMixedSizes.sizePercentage !== collapsedSize) && size === collapsedSize) onCollapse();
            }
        }
    });
}


function $0cbbb3648fa50434$export$a10903e2e57656c1(a, b) {
    if (a.length !== b.length) return false;
    else for(let index = 0; index < a.length; index++){
        if (a[index] != b[index]) return false;
    }
    return true;
}


// This method returns a number between 1 and 100 representing
function $a49015ff9a702d4d$export$fc25f3248e61edf5({ dragState: dragState, layout: layout, panelData: panelData, panelIndex: panelIndex, precision: precision = 3 }) {
    const size = layout[panelIndex];
    let flexGrow;
    if (panelData.length === 1) flexGrow = "100";
    else if (size == null) flexGrow = "0";
    else flexGrow = size.toPrecision(precision);
    return {
        flexBasis: 0,
        flexGrow: flexGrow,
        flexShrink: 1,
        // Without this, Panel sizes may be unintentionally overridden by their content
        overflow: "hidden",
        // Disable pointer events inside of a panel during resize
        // This avoid edge cases like nested iframes
        pointerEvents: dragState !== null ? "none" : undefined
    };
}




let $e76f44aab9610f5d$var$currentState = null;
let $e76f44aab9610f5d$var$element = null;
function $e76f44aab9610f5d$export$fa35f3322c52262f(state) {
    switch(state){
        case "horizontal":
            return "ew-resize";
        case "horizontal-max":
            return "w-resize";
        case "horizontal-min":
            return "e-resize";
        case "vertical":
            return "ns-resize";
        case "vertical-max":
            return "n-resize";
        case "vertical-min":
            return "s-resize";
    }
}
function $e76f44aab9610f5d$export$b61932ee18f96e08() {
    if ($e76f44aab9610f5d$var$element !== null) {
        document.head.removeChild($e76f44aab9610f5d$var$element);
        $e76f44aab9610f5d$var$currentState = null;
        $e76f44aab9610f5d$var$element = null;
    }
}
function $e76f44aab9610f5d$export$d395b5dfd066a659(state) {
    if ($e76f44aab9610f5d$var$currentState === state) return;
    $e76f44aab9610f5d$var$currentState = state;
    const style = $e76f44aab9610f5d$export$fa35f3322c52262f(state);
    if ($e76f44aab9610f5d$var$element === null) {
        $e76f44aab9610f5d$var$element = document.createElement("style");
        document.head.appendChild($e76f44aab9610f5d$var$element);
    }
    $e76f44aab9610f5d$var$element.innerHTML = `*{cursor: ${style}!important;}`;
}


function $7d9ce71cbcf2c626$export$2e2bcd8739ae039(callback, durationMs = 10) {
    let timeoutId = null;
    let callable = (...args)=>{
        if (timeoutId !== null) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            callback(...args);
        }, durationMs);
    };
    return callable;
}









function $53b314a6fc118f85$export$cb0adc12c8406347(storageObject) {
    try {
        if (typeof localStorage !== "undefined") {
            // Bypass this check for future calls
            storageObject.getItem = (name)=>{
                return localStorage.getItem(name);
            };
            storageObject.setItem = (name, value)=>{
                localStorage.setItem(name, value);
            };
        } else throw new Error("localStorage not supported in this environment");
    } catch (error) {
        console.error(error);
        storageObject.getItem = ()=>null;
        storageObject.setItem = ()=>{};
    }
}


// Note that Panel ids might be user-provided (stable) or useId generated (non-deterministic)
// so they should not be used as part of the serialization key.
// Using the min/max size attributes should work well enough as a backup.
// Pre-sorting by minSize allows remembering layouts even if panels are re-ordered/dragged.
function $85584e756332ea42$var$getSerializationKey(panels) {
    return panels.map((panel)=>{
        const { constraints: constraints, id: id, idIsFromProps: idIsFromProps, order: order } = panel;
        if (idIsFromProps) return id;
        else return `${order}:${JSON.stringify(constraints)}`;
    }).sort((a, b)=>a.localeCompare(b)).join(",");
}
function $85584e756332ea42$var$loadSerializedPanelGroupState(autoSaveId, storage) {
    try {
        const serialized = storage.getItem(`PanelGroup:sizes:${autoSaveId}`);
        if (serialized) {
            const parsed = JSON.parse(serialized);
            if (typeof parsed === "object" && parsed != null) return parsed;
        }
    } catch (error) {}
    return null;
}
function $85584e756332ea42$export$9c80c6617f0386da(autoSaveId, panels, storage) {
    const state = $85584e756332ea42$var$loadSerializedPanelGroupState(autoSaveId, storage);
    if (state) {
        const key = $85584e756332ea42$var$getSerializationKey(panels);
        return state[key] ?? null;
    }
    return null;
}
function $85584e756332ea42$export$af183b313c61be4f(autoSaveId, panels, sizes, storage) {
    const key = $85584e756332ea42$var$getSerializationKey(panels);
    const state = $85584e756332ea42$var$loadSerializedPanelGroupState(autoSaveId, storage) || {};
    state[key] = sizes;
    try {
        storage.setItem(`PanelGroup:sizes:${autoSaveId}`, JSON.stringify(state));
    } catch (error) {
        console.error(error);
    }
}


function $52db767f1ba6df81$export$36751ff517d35b21(constraints) {
    return constraints.some((constraints)=>{
        return constraints.collapsedSizePixels !== undefined || constraints.maxSizePixels !== undefined || constraints.minSizePixels !== undefined;
    });
}




function $8339b455ed9b763f$export$d00cfefa2c395b39({ groupSizePixels: groupSizePixels, panelConstraints: panelConstraints, panelId: panelId, panelIndex: panelIndex }) {
    if (0, $3318dd6b4ac6739a$export$df77466336fe5355) {
        const warnings = [];
        {
            const { collapsedSizePercentage: collapsedSizePercentage, collapsedSizePixels: collapsedSizePixels, defaultSizePercentage: defaultSizePercentage, defaultSizePixels: defaultSizePixels, maxSizePercentage: maxSizePercentage, maxSizePixels: maxSizePixels, minSizePercentage: minSizePercentage, minSizePixels: minSizePixels } = panelConstraints[panelIndex];
            const conflictingUnits = [];
            if (collapsedSizePercentage != null && collapsedSizePixels != null) conflictingUnits.push("collapsed size");
            if (defaultSizePercentage != null && defaultSizePixels != null) conflictingUnits.push("default size");
            if (maxSizePercentage != null && maxSizePixels != null) conflictingUnits.push("max size");
            if (minSizePercentage != null && minSizePixels != null) conflictingUnits.push("min size");
            if (conflictingUnits.length > 0) warnings.push(`should not specify both percentage and pixel units for: ${conflictingUnits.join(", ")}`);
        }
        {
            const { collapsedSizePercentage: collapsedSizePercentage, defaultSizePercentage: defaultSizePercentage, maxSizePercentage: maxSizePercentage, minSizePercentage: minSizePercentage } = (0, $b8b2acf02a6d9543$export$2317728de084d6f9)(panelConstraints, panelIndex, groupSizePixels);
            if (minSizePercentage > maxSizePercentage) warnings.push(`min size (${minSizePercentage}%) should not be greater than max size (${maxSizePercentage}%)`);
            if (defaultSizePercentage != null) {
                if (defaultSizePercentage < 0) warnings.push("default size should not be less than 0");
                else if (defaultSizePercentage < minSizePercentage) warnings.push("default size should not be less than min size");
                if (defaultSizePercentage > 100) warnings.push("default size should not be greater than 100");
                else if (defaultSizePercentage > maxSizePercentage) warnings.push("default size should not be greater than max size");
            }
            if (collapsedSizePercentage > minSizePercentage) warnings.push("collapsed size should not be greater than min size");
        }
        if (warnings.length > 0) {
            const name = panelId != null ? `Panel "${panelId}"` : "Panel";
            console.warn(`${name} has an invalid configuration:\n\n${warnings.join("\n")}`);
            return false;
        }
    }
    return true;
}





function $b69632d4043bd28d$export$64432a52a1035c18({ groupSizePixels: groupSizePixels, layout: prevLayout, panelConstraints: panelConstraints }) {
    const nextLayout = [
        ...prevLayout
    ];
    // Validate layout expectations
    if (nextLayout.length !== panelConstraints.length) throw Error(`Invalid ${panelConstraints.length} panel layout: ${nextLayout.map((size)=>`${size}%`).join(", ")}`);
    else if (!(0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(nextLayout.reduce((accumulated, current)=>accumulated + current, 0), 100)) // This is not ideal so we should warn about it, but it may be recoverable in some cases
    // (especially if the amount is small)
    {
        if (0, $3318dd6b4ac6739a$export$df77466336fe5355) console.warn(`WARNING: Invalid layout total size: ${nextLayout.map((size)=>`${size}%`).join(", ")}`);
    }
    let remainingSize = 0;
    // First pass: Validate the proposed layout given each panel's constraints
    for(let index = 0; index < panelConstraints.length; index++){
        const unsafeSize = nextLayout[index];
        const safeSize = (0, $3a90ecb79eebe05c$export$2f98edcf4006376f)({
            groupSizePixels: groupSizePixels,
            panelConstraints: panelConstraints,
            panelIndex: index,
            size: unsafeSize
        });
        if (unsafeSize != safeSize) {
            remainingSize += unsafeSize - safeSize;
            nextLayout[index] = safeSize;
        }
    }
    // If there is additional, left over space, assign it to any panel(s) that permits it
    // (It's not worth taking multiple additional passes to evenly distribute)
    if (!(0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(remainingSize, 0)) for(let index = 0; index < panelConstraints.length; index++){
        const prevSize = nextLayout[index];
        const unsafeSize = prevSize + remainingSize;
        const safeSize = (0, $3a90ecb79eebe05c$export$2f98edcf4006376f)({
            groupSizePixels: groupSizePixels,
            panelConstraints: panelConstraints,
            panelIndex: index,
            size: unsafeSize
        });
        if (prevSize !== safeSize) {
            remainingSize -= safeSize - prevSize;
            nextLayout[index] = safeSize;
            // Once we've used up the remainder, bail
            if ((0, $50bf8b919bea9957$export$db9c8bd2fae72e82)(remainingSize, 0)) break;
        }
    }
    return nextLayout;
}



const $975d9a9f17fa8705$var$LOCAL_STORAGE_DEBOUNCE_INTERVAL = 100;
const $975d9a9f17fa8705$var$defaultStorage = {
    getItem: (name)=>{
        (0, $53b314a6fc118f85$export$cb0adc12c8406347)($975d9a9f17fa8705$var$defaultStorage);
        return $975d9a9f17fa8705$var$defaultStorage.getItem(name);
    },
    setItem: (name, value)=>{
        (0, $53b314a6fc118f85$export$cb0adc12c8406347)($975d9a9f17fa8705$var$defaultStorage);
        $975d9a9f17fa8705$var$defaultStorage.setItem(name, value);
    }
};
const $975d9a9f17fa8705$var$debounceMap = {};
function $975d9a9f17fa8705$var$PanelGroupWithForwardedRef({ autoSaveId: autoSaveId, children: children, className: classNameFromProps = "", direction: direction, forwardedRef: forwardedRef, id: idFromProps, onLayout: onLayout = null, keyboardResizeByPercentage: keyboardResizeByPercentage = null, keyboardResizeByPixels: keyboardResizeByPixels = null, storage: storage = $975d9a9f17fa8705$var$defaultStorage, style: styleFromProps, tagName: Type = "div" }) {
    const groupId = (0, $60b29bcfeb126d3d$export$2e2bcd8739ae039)(idFromProps);
    const [dragState, setDragState] = (0, $aaa4f295803e727b$export$60241385465d0a34)(null);
    const [layout, setLayout] = (0, $aaa4f295803e727b$export$60241385465d0a34)([]);
    const [panelDataArray, setPanelDataArray] = (0, $aaa4f295803e727b$export$60241385465d0a34)([]);
    const panelIdToLastNotifiedMixedSizesMapRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)({});
    const panelSizeBeforeCollapseRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)(new Map());
    const prevDeltaRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)(0);
    const committedValuesRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)({
        direction: direction,
        dragState: dragState,
        id: groupId,
        keyboardResizeByPercentage: keyboardResizeByPercentage,
        keyboardResizeByPixels: keyboardResizeByPixels,
        layout: layout,
        onLayout: onLayout,
        panelDataArray: panelDataArray
    });
    const devWarningsRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)({
        didLogIdAndOrderWarning: false,
        didLogPanelConstraintsWarning: false,
        prevPanelIds: []
    });
    (0, $aaa4f295803e727b$export$d5a552a76deda3c2)(forwardedRef, ()=>({
            getId: ()=>committedValuesRef.current.id,
            getLayout: ()=>{
                const { id: groupId, layout: layout } = committedValuesRef.current;
                const groupSizePixels = (0, $bf1647d5321b3e7e$export$29b617c5e3d8da8c)(groupId);
                return layout.map((sizePercentage)=>{
                    return {
                        sizePercentage: sizePercentage,
                        sizePixels: (0, $1a803393aaae0c7c$export$528dc9932b07582d)(sizePercentage, groupSizePixels)
                    };
                });
            },
            setLayout: (mixedSizes)=>{
                const { id: groupId, layout: prevLayout, onLayout: onLayout, panelDataArray: panelDataArray } = committedValuesRef.current;
                const groupSizePixels = (0, $bf1647d5321b3e7e$export$29b617c5e3d8da8c)(groupId);
                const unsafeLayout = mixedSizes.map((mixedSize)=>(0, $2f521c3f0845bde7$export$c436620f45b24369)(mixedSize, groupSizePixels));
                const safeLayout = (0, $b69632d4043bd28d$export$64432a52a1035c18)({
                    groupSizePixels: groupSizePixels,
                    layout: unsafeLayout,
                    panelConstraints: panelDataArray.map((panelData)=>panelData.constraints)
                });
                if (!(0, $496e0d889792e959$export$b141efd0b0fb9174)(prevLayout, safeLayout)) {
                    setLayout(safeLayout);
                    if (onLayout) onLayout(safeLayout.map((sizePercentage)=>({
                            sizePercentage: sizePercentage,
                            sizePixels: (0, $1a803393aaae0c7c$export$528dc9932b07582d)(sizePercentage, groupSizePixels)
                        })));
                    (0, $8a0d71fa0900eb22$export$b8e48269e4faa934)(groupId, panelDataArray, safeLayout, panelIdToLastNotifiedMixedSizesMapRef.current);
                }
            }
        }), []);
    (0, $8acfb99206240232$export$2e2bcd8739ae039)(()=>{
        committedValuesRef.current.direction = direction;
        committedValuesRef.current.dragState = dragState;
        committedValuesRef.current.id = groupId;
        committedValuesRef.current.layout = layout;
        committedValuesRef.current.onLayout = onLayout;
        committedValuesRef.current.panelDataArray = panelDataArray;
    });
    (0, $d9219661d18d6238$export$d9fcbe062527d159)({
        committedValuesRef: committedValuesRef,
        groupId: groupId,
        layout: layout,
        panelDataArray: panelDataArray,
        setLayout: setLayout
    });
    (0, $aaa4f295803e727b$export$6d9c69b0de29b591)(()=>{
        // If this panel has been configured to persist sizing information, save sizes to local storage.
        if (autoSaveId) {
            if (layout.length === 0 || layout.length !== panelDataArray.length) return;
            // Limit the frequency of localStorage updates.
            if (!$975d9a9f17fa8705$var$debounceMap[autoSaveId]) $975d9a9f17fa8705$var$debounceMap[autoSaveId] = (0, $7d9ce71cbcf2c626$export$2e2bcd8739ae039)((0, $85584e756332ea42$export$af183b313c61be4f), $975d9a9f17fa8705$var$LOCAL_STORAGE_DEBOUNCE_INTERVAL);
            $975d9a9f17fa8705$var$debounceMap[autoSaveId](autoSaveId, panelDataArray, layout, storage);
        }
    }, [
        autoSaveId,
        layout,
        panelDataArray,
        storage
    ]);
    // Once all panels have registered themselves,
    // Compute the initial sizes based on default weights.
    // This assumes that panels register during initial mount (no conditional rendering)!
    (0, $8acfb99206240232$export$2e2bcd8739ae039)(()=>{
        const { id: groupId, layout: layout, onLayout: onLayout } = committedValuesRef.current;
        if (layout.length === panelDataArray.length) // Only compute (or restore) default layout once per panel configuration.
        return;
        // If this panel has been configured to persist sizing information,
        // default size should be restored from local storage if possible.
        let unsafeLayout = null;
        if (autoSaveId) unsafeLayout = (0, $85584e756332ea42$export$9c80c6617f0386da)(autoSaveId, panelDataArray, storage);
        const groupSizePixels = (0, $bf1647d5321b3e7e$export$29b617c5e3d8da8c)(groupId);
        if (groupSizePixels <= 0) // Wait until the group has rendered a non-zero size before computing layout.
        return;
        if (unsafeLayout == null) unsafeLayout = (0, $dda70b6d0c13b7b2$export$47337a21c443778e)({
            groupSizePixels: groupSizePixels,
            panelDataArray: panelDataArray
        });
        // Validate even saved layouts in case something has changed since last render
        // e.g. for pixel groups, this could be the size of the window
        const validatedLayout = (0, $b69632d4043bd28d$export$64432a52a1035c18)({
            groupSizePixels: groupSizePixels,
            layout: unsafeLayout,
            panelConstraints: panelDataArray.map((panelData)=>panelData.constraints)
        });
        if (!(0, $496e0d889792e959$export$b141efd0b0fb9174)(layout, validatedLayout)) setLayout(validatedLayout);
        if (onLayout) onLayout(validatedLayout.map((sizePercentage)=>({
                sizePercentage: sizePercentage,
                sizePixels: (0, $1a803393aaae0c7c$export$528dc9932b07582d)(sizePercentage, groupSizePixels)
            })));
        (0, $8a0d71fa0900eb22$export$b8e48269e4faa934)(groupId, panelDataArray, validatedLayout, panelIdToLastNotifiedMixedSizesMapRef.current);
    }, [
        autoSaveId,
        layout,
        panelDataArray,
        storage
    ]);
    (0, $8acfb99206240232$export$2e2bcd8739ae039)(()=>{
        const constraints = panelDataArray.map(({ constraints: constraints })=>constraints);
        if (!(0, $52db767f1ba6df81$export$36751ff517d35b21)(constraints)) // Avoid the overhead of ResizeObserver if no pixel constraints require monitoring
        return;
        if (typeof ResizeObserver === "undefined") console.warn(`WARNING: Pixel based constraints require ResizeObserver but it is not supported by the current browser.`);
        else {
            const resizeObserver = new ResizeObserver(()=>{
                const groupSizePixels = (0, $bf1647d5321b3e7e$export$29b617c5e3d8da8c)(groupId);
                const { layout: prevLayout, onLayout: onLayout } = committedValuesRef.current;
                const nextLayout = (0, $b69632d4043bd28d$export$64432a52a1035c18)({
                    groupSizePixels: groupSizePixels,
                    layout: prevLayout,
                    panelConstraints: panelDataArray.map((panelData)=>panelData.constraints)
                });
                if (!(0, $496e0d889792e959$export$b141efd0b0fb9174)(prevLayout, nextLayout)) {
                    setLayout(nextLayout);
                    if (onLayout) onLayout(nextLayout.map((sizePercentage)=>({
                            sizePercentage: sizePercentage,
                            sizePixels: (0, $1a803393aaae0c7c$export$528dc9932b07582d)(sizePercentage, groupSizePixels)
                        })));
                    (0, $8a0d71fa0900eb22$export$b8e48269e4faa934)(groupId, panelDataArray, nextLayout, panelIdToLastNotifiedMixedSizesMapRef.current);
                }
            });
            resizeObserver.observe((0, $ccad9c604596b2d2$export$4e72aefa594058df)(groupId));
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        groupId,
        panelDataArray
    ]);
    // DEV warnings
    (0, $aaa4f295803e727b$export$6d9c69b0de29b591)(()=>{
        if (0, $3318dd6b4ac6739a$export$df77466336fe5355) {
            const { didLogIdAndOrderWarning: didLogIdAndOrderWarning, didLogPanelConstraintsWarning: didLogPanelConstraintsWarning, prevPanelIds: prevPanelIds } = devWarningsRef.current;
            if (!didLogIdAndOrderWarning) {
                const { panelDataArray: panelDataArray } = committedValuesRef.current;
                const panelIds = panelDataArray.map(({ id: id })=>id);
                devWarningsRef.current.prevPanelIds = panelIds;
                const panelsHaveChanged = prevPanelIds.length > 0 && !(0, $496e0d889792e959$export$b141efd0b0fb9174)(prevPanelIds, panelIds);
                if (panelsHaveChanged) {
                    if (panelDataArray.find(({ idIsFromProps: idIsFromProps, order: order })=>!idIsFromProps || order == null)) {
                        devWarningsRef.current.didLogIdAndOrderWarning = true;
                        console.warn(`WARNING: Panel id and order props recommended when panels are dynamically rendered`);
                    }
                }
            }
            if (!didLogPanelConstraintsWarning) {
                const panelConstraints = panelDataArray.map((panelData)=>panelData.constraints);
                const groupSizePixels = (0, $bf1647d5321b3e7e$export$29b617c5e3d8da8c)(groupId);
                for(let panelIndex = 0; panelIndex < panelConstraints.length; panelIndex++){
                    const isValid = (0, $8339b455ed9b763f$export$d00cfefa2c395b39)({
                        groupSizePixels: groupSizePixels,
                        panelConstraints: panelConstraints,
                        panelId: panelDataArray[panelIndex].id,
                        panelIndex: panelIndex
                    });
                    if (!isValid) {
                        devWarningsRef.current.didLogPanelConstraintsWarning = true;
                        break;
                    }
                }
            }
        }
    });
    // External APIs are safe to memoize via committed values ref
    const collapsePanel = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((panelData)=>{
        const { layout: prevLayout, onLayout: onLayout, panelDataArray: panelDataArray } = committedValuesRef.current;
        if (panelData.constraints.collapsible) {
            const panelConstraintsArray = panelDataArray.map((panelData)=>panelData.constraints);
            const { collapsedSizePercentage: collapsedSizePercentage, panelSizePercentage: panelSizePercentage, pivotIndices: pivotIndices, groupSizePixels: groupSizePixels } = $975d9a9f17fa8705$var$panelDataHelper(groupId, panelDataArray, panelData, prevLayout);
            if (panelSizePercentage !== collapsedSizePercentage) {
                // Store size before collapse;
                // This is the size that gets restored if the expand() API is used.
                panelSizeBeforeCollapseRef.current.set(panelData.id, panelSizePercentage);
                const isLastPanel = panelDataArray.indexOf(panelData) === panelDataArray.length - 1;
                const delta = isLastPanel ? panelSizePercentage - collapsedSizePercentage : collapsedSizePercentage - panelSizePercentage;
                const nextLayout = (0, $52a540e312c50d97$export$7fead5cc734d205b)({
                    delta: delta,
                    groupSizePixels: groupSizePixels,
                    layout: prevLayout,
                    panelConstraints: panelConstraintsArray,
                    pivotIndices: pivotIndices,
                    trigger: "imperative-api"
                });
                if (!(0, $0cbbb3648fa50434$export$a10903e2e57656c1)(prevLayout, nextLayout)) {
                    setLayout(nextLayout);
                    if (onLayout) onLayout(nextLayout.map((sizePercentage)=>({
                            sizePercentage: sizePercentage,
                            sizePixels: (0, $1a803393aaae0c7c$export$528dc9932b07582d)(sizePercentage, groupSizePixels)
                        })));
                    (0, $8a0d71fa0900eb22$export$b8e48269e4faa934)(groupId, panelDataArray, nextLayout, panelIdToLastNotifiedMixedSizesMapRef.current);
                }
            }
        }
    }, [
        groupId
    ]);
    // External APIs are safe to memoize via committed values ref
    const expandPanel = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((panelData)=>{
        const { layout: prevLayout, onLayout: onLayout, panelDataArray: panelDataArray } = committedValuesRef.current;
        if (panelData.constraints.collapsible) {
            const panelConstraintsArray = panelDataArray.map((panelData)=>panelData.constraints);
            const { collapsedSizePercentage: collapsedSizePercentage, panelSizePercentage: panelSizePercentage, minSizePercentage: minSizePercentage, pivotIndices: pivotIndices, groupSizePixels: groupSizePixels } = $975d9a9f17fa8705$var$panelDataHelper(groupId, panelDataArray, panelData, prevLayout);
            if (panelSizePercentage === collapsedSizePercentage) {
                // Restore this panel to the size it was before it was collapsed, if possible.
                const prevPanelSizePercentage = panelSizeBeforeCollapseRef.current.get(panelData.id);
                const baseSizePercentage = prevPanelSizePercentage != null ? prevPanelSizePercentage : minSizePercentage;
                const isLastPanel = panelDataArray.indexOf(panelData) === panelDataArray.length - 1;
                const delta = isLastPanel ? panelSizePercentage - baseSizePercentage : baseSizePercentage - panelSizePercentage;
                const nextLayout = (0, $52a540e312c50d97$export$7fead5cc734d205b)({
                    delta: delta,
                    groupSizePixels: groupSizePixels,
                    layout: prevLayout,
                    panelConstraints: panelConstraintsArray,
                    pivotIndices: pivotIndices,
                    trigger: "imperative-api"
                });
                if (!(0, $0cbbb3648fa50434$export$a10903e2e57656c1)(prevLayout, nextLayout)) {
                    setLayout(nextLayout);
                    if (onLayout) onLayout(nextLayout.map((sizePercentage)=>({
                            sizePercentage: sizePercentage,
                            sizePixels: (0, $1a803393aaae0c7c$export$528dc9932b07582d)(sizePercentage, groupSizePixels)
                        })));
                    (0, $8a0d71fa0900eb22$export$b8e48269e4faa934)(groupId, panelDataArray, nextLayout, panelIdToLastNotifiedMixedSizesMapRef.current);
                }
            }
        }
    }, [
        groupId
    ]);
    // External APIs are safe to memoize via committed values ref
    const getPanelSize = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((panelData)=>{
        const { layout: layout, panelDataArray: panelDataArray } = committedValuesRef.current;
        const { panelSizePercentage: panelSizePercentage, panelSizePixels: panelSizePixels } = $975d9a9f17fa8705$var$panelDataHelper(groupId, panelDataArray, panelData, layout);
        return {
            sizePercentage: panelSizePercentage,
            sizePixels: panelSizePixels
        };
    }, [
        groupId
    ]);
    // This API should never read from committedValuesRef
    const getPanelStyle = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((panelData)=>{
        const panelIndex = panelDataArray.indexOf(panelData);
        return (0, $a49015ff9a702d4d$export$fc25f3248e61edf5)({
            dragState: dragState,
            layout: layout,
            panelData: panelDataArray,
            panelIndex: panelIndex
        });
    }, [
        dragState,
        layout,
        panelDataArray
    ]);
    // External APIs are safe to memoize via committed values ref
    const isPanelCollapsed = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((panelData)=>{
        const { layout: layout, panelDataArray: panelDataArray } = committedValuesRef.current;
        const { collapsedSizePercentage: collapsedSizePercentage, collapsible: collapsible, panelSizePercentage: panelSizePercentage } = $975d9a9f17fa8705$var$panelDataHelper(groupId, panelDataArray, panelData, layout);
        return collapsible === true && panelSizePercentage === collapsedSizePercentage;
    }, [
        groupId
    ]);
    // External APIs are safe to memoize via committed values ref
    const isPanelExpanded = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((panelData)=>{
        const { layout: layout, panelDataArray: panelDataArray } = committedValuesRef.current;
        const { collapsedSizePercentage: collapsedSizePercentage, collapsible: collapsible, panelSizePercentage: panelSizePercentage } = $975d9a9f17fa8705$var$panelDataHelper(groupId, panelDataArray, panelData, layout);
        return !collapsible || panelSizePercentage > collapsedSizePercentage;
    }, [
        groupId
    ]);
    const registerPanel = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((panelData)=>{
        setPanelDataArray((prevPanelDataArray)=>{
            const nextPanelDataArray = [
                ...prevPanelDataArray,
                panelData
            ];
            return nextPanelDataArray.sort((panelA, panelB)=>{
                const orderA = panelA.order;
                const orderB = panelB.order;
                if (orderA == null && orderB == null) return 0;
                else if (orderA == null) return -1;
                else if (orderB == null) return 1;
                else return orderA - orderB;
            });
        });
    }, []);
    const registerResizeHandle = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((dragHandleId)=>{
        return function resizeHandler(event) {
            event.preventDefault();
            const { direction: direction, dragState: dragState, id: groupId, keyboardResizeByPercentage: keyboardResizeByPercentage, keyboardResizeByPixels: keyboardResizeByPixels, onLayout: onLayout, panelDataArray: panelDataArray, layout: prevLayout } = committedValuesRef.current;
            const { initialLayout: initialLayout } = dragState ?? {};
            const pivotIndices = (0, $5e65faded090fabc$export$cf92598869f99b8f)(groupId, dragHandleId);
            let delta = (0, $2f4df8f4953afd48$export$b08134b65f9db46a)(event, groupId, dragHandleId, direction, dragState, {
                percentage: keyboardResizeByPercentage,
                pixels: keyboardResizeByPixels
            });
            if (delta === 0) return;
            // Support RTL layouts
            const isHorizontal = direction === "horizontal";
            if (document.dir === "rtl" && isHorizontal) delta = -delta;
            const groupSizePixels = (0, $bf1647d5321b3e7e$export$29b617c5e3d8da8c)(groupId);
            const panelConstraints = panelDataArray.map((panelData)=>panelData.constraints);
            const nextLayout = (0, $52a540e312c50d97$export$7fead5cc734d205b)({
                delta: delta,
                groupSizePixels: groupSizePixels,
                layout: initialLayout ?? prevLayout,
                panelConstraints: panelConstraints,
                pivotIndices: pivotIndices,
                trigger: (0, $5c88e00ca90ee80e$export$e7bf60a870f429b0)(event) ? "keyboard" : "mouse-or-touch"
            });
            const layoutChanged = !(0, $0cbbb3648fa50434$export$a10903e2e57656c1)(prevLayout, nextLayout);
            // Only update the cursor for layout changes triggered by touch/mouse events (not keyboard)
            // Update the cursor even if the layout hasn't changed (we may need to show an invalid cursor state)
            if ((0, $5c88e00ca90ee80e$export$764db16956f554f8)(event) || (0, $5c88e00ca90ee80e$export$c4dfce035d43d1e0)(event)) // Watch for multiple subsequent deltas; this might occur for tiny cursor movements.
            // In this case, Panel sizes might not change–
            // but updating cursor in this scenario would cause a flicker.
            {
                if (prevDeltaRef.current != delta) {
                    prevDeltaRef.current = delta;
                    if (!layoutChanged) {
                        // If the pointer has moved too far to resize the panel any further,
                        // update the cursor style for a visual clue.
                        // This mimics VS Code behavior.
                        if (isHorizontal) (0, $e76f44aab9610f5d$export$d395b5dfd066a659)(delta < 0 ? "horizontal-min" : "horizontal-max");
                        else (0, $e76f44aab9610f5d$export$d395b5dfd066a659)(delta < 0 ? "vertical-min" : "vertical-max");
                    } else // Reset the cursor style to the the normal resize cursor.
                    (0, $e76f44aab9610f5d$export$d395b5dfd066a659)(isHorizontal ? "horizontal" : "vertical");
                }
            }
            if (layoutChanged) {
                setLayout(nextLayout);
                if (onLayout) onLayout(nextLayout.map((sizePercentage)=>({
                        sizePercentage: sizePercentage,
                        sizePixels: (0, $1a803393aaae0c7c$export$528dc9932b07582d)(sizePercentage, groupSizePixels)
                    })));
                (0, $8a0d71fa0900eb22$export$b8e48269e4faa934)(groupId, panelDataArray, nextLayout, panelIdToLastNotifiedMixedSizesMapRef.current);
            }
        };
    }, []);
    // External APIs are safe to memoize via committed values ref
    const resizePanel = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((panelData, mixedSizes)=>{
        const { layout: prevLayout, onLayout: onLayout, panelDataArray: panelDataArray } = committedValuesRef.current;
        const panelConstraintsArray = panelDataArray.map((panelData)=>panelData.constraints);
        const { groupSizePixels: groupSizePixels, panelSizePercentage: panelSizePercentage, pivotIndices: pivotIndices } = $975d9a9f17fa8705$var$panelDataHelper(groupId, panelDataArray, panelData, prevLayout);
        const sizePercentage = (0, $2f521c3f0845bde7$export$c436620f45b24369)(mixedSizes, groupSizePixels);
        const isLastPanel = panelDataArray.indexOf(panelData) === panelDataArray.length - 1;
        const delta = isLastPanel ? panelSizePercentage - sizePercentage : sizePercentage - panelSizePercentage;
        const nextLayout = (0, $52a540e312c50d97$export$7fead5cc734d205b)({
            delta: delta,
            groupSizePixels: groupSizePixels,
            layout: prevLayout,
            panelConstraints: panelConstraintsArray,
            pivotIndices: pivotIndices,
            trigger: "imperative-api"
        });
        if (!(0, $0cbbb3648fa50434$export$a10903e2e57656c1)(prevLayout, nextLayout)) {
            setLayout(nextLayout);
            if (onLayout) onLayout(nextLayout.map((sizePercentage)=>({
                    sizePercentage: sizePercentage,
                    sizePixels: (0, $1a803393aaae0c7c$export$528dc9932b07582d)(sizePercentage, groupSizePixels)
                })));
            (0, $8a0d71fa0900eb22$export$b8e48269e4faa934)(groupId, panelDataArray, nextLayout, panelIdToLastNotifiedMixedSizesMapRef.current);
        }
    }, [
        groupId
    ]);
    const startDragging = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((dragHandleId, event)=>{
        const { direction: direction, layout: layout } = committedValuesRef.current;
        const handleElement = (0, $a7c4e7d97218e9bb$export$4c5229c874a62620)(dragHandleId);
        const initialCursorPosition = (0, $411ca3503af7ecb0$export$ae0c59ca751ba81d)(direction, event);
        setDragState({
            dragHandleId: dragHandleId,
            dragHandleRect: handleElement.getBoundingClientRect(),
            initialCursorPosition: initialCursorPosition,
            initialLayout: layout
        });
    }, []);
    const stopDragging = (0, $aaa4f295803e727b$export$35808ee640e87ca7)(()=>{
        (0, $e76f44aab9610f5d$export$b61932ee18f96e08)();
        setDragState(null);
    }, []);
    const unregisterPanel = (0, $aaa4f295803e727b$export$35808ee640e87ca7)((panelData)=>{
        delete panelIdToLastNotifiedMixedSizesMapRef.current[panelData.id];
        setPanelDataArray((panelDataArray)=>{
            const index = panelDataArray.indexOf(panelData);
            if (index >= 0) {
                panelDataArray = [
                    ...panelDataArray
                ];
                panelDataArray.splice(index, 1);
            }
            return panelDataArray;
        });
    }, []);
    const context = (0, $aaa4f295803e727b$export$1538c33de8887b59)(()=>({
            collapsePanel: collapsePanel,
            direction: direction,
            dragState: dragState,
            expandPanel: expandPanel,
            getPanelSize: getPanelSize,
            getPanelStyle: getPanelStyle,
            groupId: groupId,
            isPanelCollapsed: isPanelCollapsed,
            isPanelExpanded: isPanelExpanded,
            registerPanel: registerPanel,
            registerResizeHandle: registerResizeHandle,
            resizePanel: resizePanel,
            startDragging: startDragging,
            stopDragging: stopDragging,
            unregisterPanel: unregisterPanel
        }), [
        collapsePanel,
        dragState,
        direction,
        expandPanel,
        getPanelSize,
        getPanelStyle,
        groupId,
        isPanelCollapsed,
        isPanelExpanded,
        registerPanel,
        registerResizeHandle,
        resizePanel,
        startDragging,
        stopDragging,
        unregisterPanel
    ]);
    const style = {
        display: "flex",
        flexDirection: direction === "horizontal" ? "row" : "column",
        height: "100%",
        overflow: "hidden",
        width: "100%"
    };
    return (0, $aaa4f295803e727b$export$c8a8987d4410bf2d)((0, $77e2580d2fa4de20$export$7d8c6d083caec74a).Provider, {
        value: context
    }, (0, $aaa4f295803e727b$export$c8a8987d4410bf2d)(Type, {
        children: children,
        className: classNameFromProps,
        style: {
            ...style,
            ...styleFromProps
        },
        // CSS selectors
        "data-panel-group": "",
        "data-panel-group-direction": direction,
        "data-panel-group-id": groupId
    }));
}
const $975d9a9f17fa8705$export$1d05749f6f573bb = (0, $aaa4f295803e727b$export$257a8862b851cb5b)((props, ref)=>(0, $aaa4f295803e727b$export$c8a8987d4410bf2d)($975d9a9f17fa8705$var$PanelGroupWithForwardedRef, {
        ...props,
        forwardedRef: ref
    }));
$975d9a9f17fa8705$var$PanelGroupWithForwardedRef.displayName = "PanelGroup";
$975d9a9f17fa8705$export$1d05749f6f573bb.displayName = "forwardRef(PanelGroup)";
function $975d9a9f17fa8705$var$panelDataHelper(groupId, panelDataArray, panelData, layout) {
    const panelConstraintsArray = panelDataArray.map((panelData)=>panelData.constraints);
    const panelIndex = panelDataArray.indexOf(panelData);
    const panelConstraints = panelConstraintsArray[panelIndex];
    const groupSizePixels = (0, $bf1647d5321b3e7e$export$29b617c5e3d8da8c)(groupId);
    const percentagePanelConstraints = (0, $b8b2acf02a6d9543$export$2317728de084d6f9)(panelConstraintsArray, panelIndex, groupSizePixels);
    const isLastPanel = panelIndex === panelDataArray.length - 1;
    const pivotIndices = isLastPanel ? [
        panelIndex - 1,
        panelIndex
    ] : [
        panelIndex,
        panelIndex + 1
    ];
    const panelSizePercentage = layout[panelIndex];
    const panelSizePixels = (0, $1a803393aaae0c7c$export$528dc9932b07582d)(panelSizePercentage, groupSizePixels);
    return {
        ...percentagePanelConstraints,
        collapsible: panelConstraints.collapsible,
        panelSizePercentage: panelSizePercentage,
        panelSizePixels: panelSizePixels,
        groupSizePixels: groupSizePixels,
        pivotIndices: pivotIndices
    };
}









function $edac1138f0f6cc74$export$33b0bea6ac3ffb03({ disabled: disabled, handleId: handleId, resizeHandler: resizeHandler }) {
    (0, $aaa4f295803e727b$export$6d9c69b0de29b591)(()=>{
        if (disabled || resizeHandler == null) return;
        const handleElement = (0, $a7c4e7d97218e9bb$export$4c5229c874a62620)(handleId);
        if (handleElement == null) return;
        const onKeyDown = (event)=>{
            if (event.defaultPrevented) return;
            switch(event.key){
                case "ArrowDown":
                case "ArrowLeft":
                case "ArrowRight":
                case "ArrowUp":
                case "End":
                case "Home":
                    event.preventDefault();
                    resizeHandler(event);
                    break;
                case "F6":
                    {
                        event.preventDefault();
                        const groupId = handleElement.getAttribute("data-panel-group-id");
                        const handles = (0, $e99d67025d5a35f8$export$63eb605e437b214f)(groupId);
                        const index = (0, $d4aeaf7db7fcf912$export$4c92fedbbc2381ca)(groupId, handleId);
                        (0, $d524cb4ee877d0ea$export$a7a9523472993e97)(index !== null);
                        const nextIndex = event.shiftKey ? index > 0 ? index - 1 : handles.length - 1 : index + 1 < handles.length ? index + 1 : 0;
                        const nextHandle = handles[nextIndex];
                        nextHandle.focus();
                        break;
                    }
            }
        };
        handleElement.addEventListener("keydown", onKeyDown);
        return ()=>{
            handleElement.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        handleId,
        resizeHandler
    ]);
}




function $f94735aca202f120$export$8829ecf6b6b15484({ children: children = null, className: classNameFromProps = "", disabled: disabled = false, id: idFromProps = null, onDragging: onDragging, style: styleFromProps = {}, tagName: Type = "div" }) {
    const divElementRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)(null);
    // Use a ref to guard against users passing inline props
    const callbacksRef = (0, $aaa4f295803e727b$export$b8f5890fc79d6aca)({
        onDragging: onDragging
    });
    (0, $aaa4f295803e727b$export$6d9c69b0de29b591)(()=>{
        callbacksRef.current.onDragging = onDragging;
    });
    const panelGroupContext = (0, $aaa4f295803e727b$export$fae74005e78b1a27)((0, $77e2580d2fa4de20$export$7d8c6d083caec74a));
    if (panelGroupContext === null) throw Error(`PanelResizeHandle components must be rendered within a PanelGroup container`);
    const { direction: direction, dragState: dragState, groupId: groupId, registerResizeHandle: registerResizeHandle, startDragging: startDragging, stopDragging: stopDragging } = panelGroupContext;
    const resizeHandleId = (0, $60b29bcfeb126d3d$export$2e2bcd8739ae039)(idFromProps);
    const isDragging = dragState?.dragHandleId === resizeHandleId;
    const [isFocused, setIsFocused] = (0, $aaa4f295803e727b$export$60241385465d0a34)(false);
    const [resizeHandler, setResizeHandler] = (0, $aaa4f295803e727b$export$60241385465d0a34)(null);
    const stopDraggingAndBlur = (0, $aaa4f295803e727b$export$35808ee640e87ca7)(()=>{
        // Clicking on the drag handle shouldn't leave it focused;
        // That would cause the PanelGroup to think it was still active.
        const div = divElementRef.current;
        div.blur();
        stopDragging();
        const { onDragging: onDragging } = callbacksRef.current;
        if (onDragging) onDragging(false);
    }, [
        stopDragging
    ]);
    (0, $aaa4f295803e727b$export$6d9c69b0de29b591)(()=>{
        if (disabled) setResizeHandler(null);
        else {
            const resizeHandler = registerResizeHandle(resizeHandleId);
            setResizeHandler(()=>resizeHandler);
        }
    }, [
        disabled,
        resizeHandleId,
        registerResizeHandle
    ]);
    (0, $aaa4f295803e727b$export$6d9c69b0de29b591)(()=>{
        if (disabled || resizeHandler == null || !isDragging) return;
        const onMove = (event)=>{
            resizeHandler(event);
        };
        const onMouseLeave = (event)=>{
            resizeHandler(event);
        };
        const divElement = divElementRef.current;
        const targetDocument = divElement.ownerDocument;
        targetDocument.body.addEventListener("contextmenu", stopDraggingAndBlur);
        targetDocument.body.addEventListener("mousemove", onMove);
        targetDocument.body.addEventListener("touchmove", onMove);
        targetDocument.body.addEventListener("mouseleave", onMouseLeave);
        window.addEventListener("mouseup", stopDraggingAndBlur);
        window.addEventListener("touchend", stopDraggingAndBlur);
        return ()=>{
            targetDocument.body.removeEventListener("contextmenu", stopDraggingAndBlur);
            targetDocument.body.removeEventListener("mousemove", onMove);
            targetDocument.body.removeEventListener("touchmove", onMove);
            targetDocument.body.removeEventListener("mouseleave", onMouseLeave);
            window.removeEventListener("mouseup", stopDraggingAndBlur);
            window.removeEventListener("touchend", stopDraggingAndBlur);
        };
    }, [
        direction,
        disabled,
        isDragging,
        resizeHandler,
        stopDraggingAndBlur
    ]);
    (0, $edac1138f0f6cc74$export$33b0bea6ac3ffb03)({
        disabled: disabled,
        handleId: resizeHandleId,
        resizeHandler: resizeHandler
    });
    const style = {
        cursor: (0, $e76f44aab9610f5d$export$fa35f3322c52262f)(direction),
        touchAction: "none",
        userSelect: "none"
    };
    return (0, $aaa4f295803e727b$export$c8a8987d4410bf2d)(Type, {
        children: children,
        className: classNameFromProps,
        onBlur: ()=>setIsFocused(false),
        onFocus: ()=>setIsFocused(true),
        onMouseDown: (event)=>{
            startDragging(resizeHandleId, event.nativeEvent);
            const { onDragging: onDragging } = callbacksRef.current;
            if (onDragging) onDragging(true);
        },
        onMouseUp: stopDraggingAndBlur,
        onTouchCancel: stopDraggingAndBlur,
        onTouchEnd: stopDraggingAndBlur,
        onTouchStart: (event)=>{
            startDragging(resizeHandleId, event.nativeEvent);
            const { onDragging: onDragging } = callbacksRef.current;
            if (onDragging) onDragging(true);
        },
        ref: divElementRef,
        role: "separator",
        style: {
            ...style,
            ...styleFromProps
        },
        tabIndex: 0,
        // CSS selectors
        "data-panel-group-direction": direction,
        "data-panel-group-id": groupId,
        "data-resize-handle": "",
        "data-resize-handle-active": isDragging ? "pointer" : isFocused ? "keyboard" : undefined,
        "data-panel-resize-handle-enabled": !disabled,
        "data-panel-resize-handle-id": resizeHandleId
    });
}
$f94735aca202f120$export$8829ecf6b6b15484.displayName = "PanelResizeHandle";







var $e4291eaf9880bddb$exports = {};

$parcel$export($e4291eaf9880bddb$exports, "Icon", () => $e4291eaf9880bddb$export$f04a61298a47a40f, (v) => $e4291eaf9880bddb$export$f04a61298a47a40f = v);
var $e4291eaf9880bddb$export$f04a61298a47a40f;
$e4291eaf9880bddb$export$f04a61298a47a40f = `OG5fOa_Icon`;


function $9da32f0f5e294f66$export$2e2bcd8739ae039({ className: className = "", type: type }) {
    let path = "";
    switch(type){
        case "chevron-down":
            path = "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z";
            break;
        case "close":
            path = "M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z";
            break;
        case "collapse":
            path = "M19.5,3.09L15,7.59V4H13V11H20V9H16.41L20.91,4.5L19.5,3.09M4,13V15H7.59L3.09,19.5L4.5,20.91L9,16.41V20H11V13H4Z";
            break;
        case "css":
            path = "M5,3L4.35,6.34H17.94L17.5,8.5H3.92L3.26,11.83H16.85L16.09,15.64L10.61,17.45L5.86,15.64L6.19,14H2.85L2.06,18L9.91,21L18.96,18L20.16,11.97L20.4,10.76L21.94,3H5Z";
            break;
        case "expand":
            path = "M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z";
            break;
        case "files":
            path = "M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z";
            break;
        case "horizontal-collapse":
            path = "M13,20V4H15.03V20H13M10,20V4H12.03V20H10M5,8L9.03,12L5,16V13H2V11H5V8M20,16L16,12L20,8V11H23V13H20V16Z";
            break;
        case "horizontal-expand":
            path = "M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z";
            break;
        case "html":
            path = "M12,17.56L16.07,16.43L16.62,10.33H9.38L9.2,8.3H16.8L17,6.31H7L7.56,12.32H14.45L14.22,14.9L12,15.5L9.78,14.9L9.64,13.24H7.64L7.93,16.43L12,17.56M4.07,3H19.93L18.5,19.2L12,21L5.5,19.2L4.07,3Z";
            break;
        case "loading":
            path = "M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z";
            break;
        case "markdown":
            path = "M20.56 18H3.44C2.65 18 2 17.37 2 16.59V7.41C2 6.63 2.65 6 3.44 6H20.56C21.35 6 22 6.63 22 7.41V16.59C22 17.37 21.35 18 20.56 18M6.81 15.19V11.53L8.73 13.88L10.65 11.53V15.19H12.58V8.81H10.65L8.73 11.16L6.81 8.81H4.89V15.19H6.81M19.69 12H17.77V8.81H15.85V12H13.92L16.81 15.28L19.69 12Z";
            break;
        case "resize":
            path = "M10.59,12L14.59,8H11V6H18V13H16V9.41L12,13.41V16H20V4H8V12H10.59M22,2V18H12V22H2V12H6V2H22M10,14H4V20H10V14Z";
            break;
        case "resize-horizontal":
            path = "M18,16V13H15V22H13V2H15V11H18V8L22,12L18,16M2,12L6,16V13H9V22H11V2H9V11H6V8L2,12Z";
            break;
        case "resize-vertical":
            path = "M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z";
            break;
        case "search":
            path = "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z";
            break;
        case "typescript":
            path = "M3,3H21V21H3V3M13.71,17.86C14.21,18.84 15.22,19.59 16.8,19.59C18.4,19.59 19.6,18.76 19.6,17.23C19.6,15.82 18.79,15.19 17.35,14.57L16.93,14.39C16.2,14.08 15.89,13.87 15.89,13.37C15.89,12.96 16.2,12.64 16.7,12.64C17.18,12.64 17.5,12.85 17.79,13.37L19.1,12.5C18.55,11.54 17.77,11.17 16.7,11.17C15.19,11.17 14.22,12.13 14.22,13.4C14.22,14.78 15.03,15.43 16.25,15.95L16.67,16.13C17.45,16.47 17.91,16.68 17.91,17.26C17.91,17.74 17.46,18.09 16.76,18.09C15.93,18.09 15.45,17.66 15.09,17.06L13.71,17.86M13,11.25H8V12.75H9.5V20H11.25V12.75H13V11.25Z";
            break;
        case "warning":
            path = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M13,13V7H11V13H13M13,17V15H11V17H13Z";
            break;
    }
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("svg", {
        className: [
            className,
            (0, (/*@__PURE__*/$parcel$interopDefault($e4291eaf9880bddb$exports))).Icon
        ].join(" "),
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("path", {
            fill: "currentColor",
            d: path
        })
    });
}


var $318032591069a228$exports = {};

$parcel$export($318032591069a228$exports, "HorizontalIcon", () => $318032591069a228$export$ffa4d1c5f56b2bbd, (v) => $318032591069a228$export$ffa4d1c5f56b2bbd = v);
$parcel$export($318032591069a228$exports, "ResizeHandleInner", () => $318032591069a228$export$1607914c410fcace, (v) => $318032591069a228$export$1607914c410fcace = v);
$parcel$export($318032591069a228$exports, "ResizeHandleOuter", () => $318032591069a228$export$8d6dad94d45fa722, (v) => $318032591069a228$export$8d6dad94d45fa722 = v);
$parcel$export($318032591069a228$exports, "VerticalIcon", () => $318032591069a228$export$ba9edb5a0ba713fb, (v) => $318032591069a228$export$ba9edb5a0ba713fb = v);
var $318032591069a228$export$ffa4d1c5f56b2bbd;
var $318032591069a228$export$1607914c410fcace;
var $318032591069a228$export$8d6dad94d45fa722;
var $318032591069a228$export$ba9edb5a0ba713fb;
$318032591069a228$export$ffa4d1c5f56b2bbd = `AzW8qW_HorizontalIcon`;
$318032591069a228$export$1607914c410fcace = `AzW8qW_ResizeHandleInner`;
$318032591069a228$export$8d6dad94d45fa722 = `AzW8qW_ResizeHandleOuter`;
$318032591069a228$export$ba9edb5a0ba713fb = `AzW8qW_VerticalIcon`;


function $9c966142541466a3$export$33f2411a0ad35be7({ className: className = "", collapsed: collapsed = false, id: id }) {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $f94735aca202f120$export$8829ecf6b6b15484), {
        className: [
            (0, (/*@__PURE__*/$parcel$interopDefault($318032591069a228$exports))).ResizeHandleOuter,
            className
        ].join(" "),
        id: id,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($318032591069a228$exports))).ResizeHandleInner,
            "data-collapsed": collapsed || undefined,
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($318032591069a228$exports))).HorizontalIcon,
                    type: "resize-horizontal"
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($318032591069a228$exports))).VerticalIcon,
                    type: "resize-vertical"
                })
            ]
        })
    });
}




var $lx97N = parcelRequire("lx97N");



var $lx97N = parcelRequire("lx97N");

var $1LbwH = parcelRequire("1LbwH");

var $hB7kI = parcelRequire("hB7kI");

var $6yW7d = parcelRequire("6yW7d");

var $lx97N = parcelRequire("lx97N");
function $d85c068d1dd0b50e$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $d85c068d1dd0b50e$var$$b4d6e04d4e1b433b$exports = {};
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$b4d6e04d4e1b433b$exports, "STATUS_PENDING", ()=>$d85c068d1dd0b50e$export$102c3f975dbe36bd);
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$b4d6e04d4e1b433b$exports, "STATUS_RESOLVED", ()=>$d85c068d1dd0b50e$export$95b9efe7da5fb195);
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$b4d6e04d4e1b433b$exports, "STATUS_REJECTED", ()=>$d85c068d1dd0b50e$export$89864f7e9466db1c);
const $d85c068d1dd0b50e$export$102c3f975dbe36bd = "pending";
const $d85c068d1dd0b50e$export$95b9efe7da5fb195 = "resolved";
const $d85c068d1dd0b50e$export$89864f7e9466db1c = "rejected";
var $d85c068d1dd0b50e$var$$038032e94f37c99b$exports = {};
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$038032e94f37c99b$exports, "createCache", ()=>$d85c068d1dd0b50e$export$cf6fa0bbcc94b912);
var $d85c068d1dd0b50e$var$$4d5cae46926c5773$exports = {};
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$4d5cae46926c5773$exports, "createDeferred", ()=>$d85c068d1dd0b50e$export$e673efccd97e4223);
let $d85c068d1dd0b50e$var$$4d5cae46926c5773$var$MAX_LOOP_COUNT = 1000;
function $d85c068d1dd0b50e$export$e673efccd97e4223(debugLabel) {
    const resolveCallbacks = new Set();
    const rejectCallbacks = new Set();
    let status = "unresolved";
    let data = null;
    let callbacksRegisteredAfterResolutionCount = 0;
    // Guard against a case where promise resolution results in a new deferred listener being added.
    // That cause would result in an infinite loop.
    // Note that our guard counter should be somewhat high to avoid false positives.
    // It is a legitimate use-case to register handlers after a deferred has been resolved or rejected.
    const checkCircularThenableChain = ()=>{
        if (++callbacksRegisteredAfterResolutionCount > $d85c068d1dd0b50e$var$$4d5cae46926c5773$var$MAX_LOOP_COUNT) throw Error(`Circular thenable chain detected (infinite loop) for resource: ${debugLabel}`);
    };
    const deferred = {
        then (resolveCallback, rejectCallback) {
            switch(status){
                case "unresolved":
                    resolveCallbacks.add(resolveCallback);
                    rejectCallbacks.add(rejectCallback);
                    break;
                case "rejected":
                    checkCircularThenableChain();
                    rejectCallback(data);
                    break;
                case "resolved":
                    checkCircularThenableChain();
                    resolveCallback(data);
                    break;
            }
        },
        reject (error) {
            if (status !== "unresolved") throw Error(`Deferred has already been ${status}`);
            status = "rejected";
            data = error;
            rejectCallbacks.forEach((rejectCallback)=>{
                let thrownValue = null;
                try {
                    rejectCallback(error);
                } catch (error1) {
                    thrownValue = error1;
                }
                if (thrownValue !== null) throw thrownValue;
            });
            rejectCallbacks.clear();
            resolveCallbacks.clear();
        },
        resolve (value) {
            if (status !== "unresolved") throw Error(`Deferred has already been ${status}`);
            status = "resolved";
            data = value;
            resolveCallbacks.forEach((resolveCallback)=>{
                let thrownValue = null;
                try {
                    resolveCallback(value);
                } catch (error) {
                    thrownValue = error;
                }
                if (thrownValue !== null) throw thrownValue;
            });
            rejectCallbacks.clear();
            resolveCallbacks.clear();
        }
    };
    return deferred;
}
function $d85c068d1dd0b50e$var$$e2d2607e556ddad7$export$a7a9523472993e97(expectedCondition, message = "Assertion failed!") {
    if (!expectedCondition) {
        console.error(message);
        throw Error(message);
    }
}
function $d85c068d1dd0b50e$var$$fbad927ef8185060$export$5720014d5c94137d(record) {
    $d85c068d1dd0b50e$var$$e2d2607e556ddad7$export$a7a9523472993e97(record.status === $d85c068d1dd0b50e$export$102c3f975dbe36bd);
    return true;
}
var $d85c068d1dd0b50e$var$$e6e092424a433191$exports = {};
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$e6e092424a433191$exports, "isThennable", ()=>$d85c068d1dd0b50e$export$f8dbb9c12951c723);
function $d85c068d1dd0b50e$export$f8dbb9c12951c723(value) {
    return value != null && typeof value.then === "function";
}
function $d85c068d1dd0b50e$export$cf6fa0bbcc94b912(getKey, load, debugLabel) {
    const recordMap = new Map();
    const subscriberMap = new Map();
    function cache(value, ...params) {
        const cacheKey = getKey(...params);
        const record = {
            status: $d85c068d1dd0b50e$export$95b9efe7da5fb195,
            value: value
        };
        recordMap.set(cacheKey, record);
    }
    function evict(...params) {
        const cacheKey = getKey(...params);
        return recordMap.delete(cacheKey);
    }
    function getOrCreateRecord(...params) {
        const cacheKey = getKey(...params);
        let record = recordMap.get(cacheKey);
        if (record == null) {
            const deferred = $d85c068d1dd0b50e$export$e673efccd97e4223(debugLabel ? `${debugLabel} ${cacheKey}}` : cacheKey);
            record = {
                status: $d85c068d1dd0b50e$export$102c3f975dbe36bd,
                value: deferred
            };
            recordMap.set(cacheKey, record);
            notifySubscribers(...params);
            processPendingRecord(record, ...params);
        }
        return record;
    }
    function getStatus(...params) {
        const cacheKey = getKey(...params);
        const record = recordMap.get(cacheKey);
        return record === null || record === void 0 ? void 0 : record.status;
    }
    function getValue(...params) {
        const cacheKey = getKey(...params);
        const record = recordMap.get(cacheKey);
        if (record == null) throw Error("No record found");
        else if (record.status !== $d85c068d1dd0b50e$export$95b9efe7da5fb195) throw Error(`Record found with status "${record.status}"`);
        else return record.value;
    }
    function getValueIfCached(...params) {
        const cacheKey = getKey(...params);
        const record = recordMap.get(cacheKey);
        if ((record === null || record === void 0 ? void 0 : record.status) === $d85c068d1dd0b50e$export$95b9efe7da5fb195) return record.value;
    }
    function prefetch(...params) {
        fetchAsync(...params);
    }
    function fetchAsync(...params) {
        const record = getOrCreateRecord(...params);
        switch(record.status){
            case $d85c068d1dd0b50e$export$102c3f975dbe36bd:
            case $d85c068d1dd0b50e$export$95b9efe7da5fb195:
                return record.value;
            case $d85c068d1dd0b50e$export$89864f7e9466db1c:
                throw record.value;
        }
    }
    function fetchSuspense(...params) {
        const record = getOrCreateRecord(...params);
        if (record.status === $d85c068d1dd0b50e$export$95b9efe7da5fb195) return record.value;
        else throw record.value;
    }
    function notifySubscribers(...params) {
        const cacheKey = getKey(...params);
        const set = subscriberMap.get(cacheKey);
        if (set) {
            const status = getStatus(...params);
            set.forEach((callback)=>{
                callback(status);
            });
        }
    }
    async function processPendingRecord(record, ...params) {
        $d85c068d1dd0b50e$var$$fbad927ef8185060$export$5720014d5c94137d(record);
        const deferred = record.value;
        try {
            const valueOrThennable = load(...params);
            const value = $d85c068d1dd0b50e$export$f8dbb9c12951c723(valueOrThennable) ? await valueOrThennable : valueOrThennable;
            record.status = $d85c068d1dd0b50e$export$95b9efe7da5fb195;
            record.value = value;
            deferred.resolve(value);
        } catch (error) {
            record.status = $d85c068d1dd0b50e$export$89864f7e9466db1c;
            record.value = error;
            deferred.reject(error);
        } finally{
            notifySubscribers(...params);
        }
    }
    function subscribeToStatus(callback, ...params) {
        const cacheKey = getKey(...params);
        let set = subscriberMap.get(cacheKey);
        if (set) set.add(callback);
        else {
            set = new Set([
                callback
            ]);
            subscriberMap.set(cacheKey, set);
        }
        try {
            const status = getStatus(...params);
            callback(status);
        } finally{
            return ()=>{
                set.delete(callback);
                if (set.size === 0) subscriberMap.delete(cacheKey);
            };
        }
    }
    return {
        cache: cache,
        evict: evict,
        getStatus: getStatus,
        getValue: getValue,
        getValueIfCached: getValueIfCached,
        fetchAsync: fetchAsync,
        fetchSuspense: fetchSuspense,
        prefetch: prefetch,
        subscribeToStatus: subscribeToStatus
    };
}
var $d85c068d1dd0b50e$var$$9f18d97897599eb1$exports = {};
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$9f18d97897599eb1$exports, "createStreamingCache", ()=>$d85c068d1dd0b50e$export$ea911cd21ad60992);
function $d85c068d1dd0b50e$var$$1a3e0135b59678f3$export$f483e9abc61a334f(expectedCondition, message) {}
function $d85c068d1dd0b50e$export$ea911cd21ad60992(getKey, load, debugLabel) {
    const streamingValuesMap = new Map();
    function evict(...params) {
        const cacheKey = getKey(...params);
        return streamingValuesMap.delete(cacheKey);
    }
    function getOrCreateStreamingValues(...params) {
        const cacheKey = getKey(...params);
        let cached = streamingValuesMap.get(cacheKey);
        if (cached == null) {
            const resolver = $d85c068d1dd0b50e$export$e673efccd97e4223(debugLabel ? `${debugLabel}: ${cacheKey}` : cacheKey);
            const subscribers = new Set();
            const streamingValues = {
                complete: false,
                data: undefined,
                progress: undefined,
                resolver: resolver,
                status: $d85c068d1dd0b50e$export$102c3f975dbe36bd,
                subscribe: (callback)=>{
                    subscribers.add(callback);
                    return ()=>{
                        subscribers.delete(callback);
                    };
                },
                values: undefined
            };
            const notifySubscribers = ()=>{
                subscribers.forEach((subscriber)=>{
                    try {
                        subscriber();
                    } catch (error) {}
                });
            };
            const assertIncomplete = ()=>{
                if (streamingValues.complete) throw Error(`Stream has already been ${streamingValues.status}`);
            };
            const notifier = {
                update: (values, progress, data)=>{
                    assertIncomplete();
                    streamingValues.data = data;
                    if (streamingValues.values == null) streamingValues.values = [
                        ...values
                    ];
                    else streamingValues.values = streamingValues.values.concat(...values);
                    if (progress != null) {
                        $d85c068d1dd0b50e$var$$1a3e0135b59678f3$export$f483e9abc61a334f(progress >= 0 && progress <= 1, `Invalid progress: ${progress}; value must be between 0-1.`);
                        streamingValues.progress = progress;
                    }
                    notifySubscribers();
                },
                resolve: ()=>{
                    assertIncomplete();
                    streamingValues.complete = true;
                    streamingValues.progress = 1;
                    streamingValues.status = $d85c068d1dd0b50e$export$95b9efe7da5fb195;
                    notifySubscribers();
                    resolver.resolve(streamingValues);
                },
                reject: (error)=>{
                    assertIncomplete();
                    streamingValues.complete = true;
                    streamingValues.status = $d85c068d1dd0b50e$export$89864f7e9466db1c;
                    notifySubscribers();
                    resolver.reject(error);
                }
            };
            streamingValuesMap.set(cacheKey, streamingValues);
            load(notifier, ...params);
            return streamingValues;
        }
        return cached;
    }
    function prefetch(...params) {
        getOrCreateStreamingValues(...params);
    }
    function stream(...params) {
        return getOrCreateStreamingValues(...params);
    }
    return {
        evict: evict,
        prefetch: prefetch,
        stream: stream
    };
}
var $d85c068d1dd0b50e$var$$f0095c6fdcdc5fd0$exports = {};
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$f0095c6fdcdc5fd0$exports, "useCacheStatus", ()=>$d85c068d1dd0b50e$export$a0b0284d625c6d1d);
function $d85c068d1dd0b50e$export$a0b0284d625c6d1d(cache, ...params) {
    return (0, $lx97N.useSyncExternalStore)((callback)=>cache.subscribeToStatus(callback, ...params), ()=>cache.getStatus(...params), ()=>cache.getStatus(...params));
}
var $d85c068d1dd0b50e$var$$3ef79ba379079bd7$exports = {};
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$3ef79ba379079bd7$exports, "useStreamingValues", ()=>$d85c068d1dd0b50e$export$8433da63a5f207fd);
function $d85c068d1dd0b50e$var$$ecaf1857cf086d2f$export$de363e709c412c8a(callback, throttleByAmount) {
    let lastCalledAt = -Infinity;
    let timeoutId = null;
    const throttled = (...args)=>{
        const elapsed = performance.now() - lastCalledAt;
        if (elapsed >= throttleByAmount) {
            lastCalledAt = performance.now();
            callback(...args);
        } else {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                lastCalledAt = performance.now();
                callback(...args);
            }, throttleByAmount - elapsed);
        }
    };
    throttled.cancel = ()=>{
        clearTimeout(timeoutId);
    };
    return throttled;
}
function $d85c068d1dd0b50e$export$8433da63a5f207fd(streamingValues, options = {}) {
    const { throttleUpdatesBy: throttleUpdatesBy = 500 } = options;
    const ref = (0, $lx97N.useRef)({
        complete: false,
        data: undefined,
        progress: 0,
        values: undefined
    });
    const getValue = ()=>{
        const value = ref.current;
        if (value.complete !== streamingValues.complete || value.data !== streamingValues.data || value.progress !== streamingValues.progress || value.values !== streamingValues.values) ref.current = {
            complete: streamingValues.complete,
            data: streamingValues.data,
            progress: streamingValues.progress,
            values: streamingValues.values
        };
        return ref.current;
    };
    const throttledSubscribe = (0, $lx97N.useCallback)((callback)=>{
        const callbackWrapper = $d85c068d1dd0b50e$var$$ecaf1857cf086d2f$export$de363e709c412c8a(callback, throttleUpdatesBy);
        return streamingValues.subscribe(callbackWrapper);
    }, [
        streamingValues.subscribe,
        throttleUpdatesBy
    ]);
    return (0, $lx97N.useSyncExternalStore)(throttledSubscribe, getValue, getValue);
}
var $d85c068d1dd0b50e$var$$5663ad6d0c025dca$exports = {};
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$5663ad6d0c025dca$exports, "createInfallibleCache", ()=>$d85c068d1dd0b50e$export$f0e4809aa1287def);
function $d85c068d1dd0b50e$export$f0e4809aa1287def(suspenseCache) {
    return function createInfallibleSuspenseCache(...params) {
        try {
            return suspenseCache(...params);
        } catch (errorOrThennable) {
            if ($d85c068d1dd0b50e$export$f8dbb9c12951c723(errorOrThennable)) throw errorOrThennable;
            else return undefined;
        }
    };
}
var $d85c068d1dd0b50e$var$$21804676a98929ef$exports = {};
$d85c068d1dd0b50e$var$$parcel$export($d85c068d1dd0b50e$var$$21804676a98929ef$exports, "parallelize", ()=>$d85c068d1dd0b50e$export$ea1b43b85e3a4fd8);
function $d85c068d1dd0b50e$export$ea1b43b85e3a4fd8(...callbacks) {
    const values = [];
    let thrownValue = null;
    callbacks.forEach((callback)=>{
        try {
            values.push(callback());
        } catch (error) {
            thrownValue = error;
        }
    });
    if (thrownValue !== null) throw thrownValue;
    return values;
}
var $d85c068d1dd0b50e$var$$fbba0c634a17eace$exports = {};







const { fetchAsync: $36b8863c95c5797f$export$ecd75350b0814c5b, fetchSuspense: $36b8863c95c5797f$export$4ebdf975e29eb947 } = (0, $d85c068d1dd0b50e$export$cf6fa0bbcc94b912)((path)=>path, async (path)=>{
    switch(path){
        case "@codemirror/lang-css":
            return await (parcelRequire("kOcYD"));
        case "@codemirror/lang-html":
            return await (parcelRequire("jz8kt"));
        case "@codemirror/lang-javascript":
            return await (parcelRequire("8Dy69"));
        case "@codemirror/lang-markdown":
            return await (parcelRequire("eVHHD"));
        default:
            throw Error(`Unknown path: ${path}`);
    }
});


const $ad405bfc761d41cf$export$e75f75ae6a127ac1 = 500000;
const $ad405bfc761d41cf$export$656dc3249b75d6af = 5000;
const { fetchAsync: $ad405bfc761d41cf$export$8ef8505207e9ad01, fetchSuspense: $ad405bfc761d41cf$export$d98036f94aae2a34 } = (0, $d85c068d1dd0b50e$export$cf6fa0bbcc94b912)((code, language)=>`${code.length}-${language}`, async (code, language)=>{
    const languageExtension = await $ad405bfc761d41cf$var$getLanguageExtension(language);
    const parsedTokens = [];
    const currentLineState = {
        parsedTokens: [],
        rawString: ""
    };
    // The logic below to trim code sections only works with "\n"
    code = code.replace(/\r\n?|\n|\u2028|\u2029/g, "\n");
    if (code.length > $ad405bfc761d41cf$export$e75f75ae6a127ac1) {
        let index = $ad405bfc761d41cf$export$e75f75ae6a127ac1 - 1;
        while(index > 0 && code.charAt(index) !== "\n")index--;
        if (index === 0) while(index < code.length && code.charAt(index) !== "\n")index++;
        code = code.slice(0, index + 1);
    }
    const state = (0, $hB7kI.EditorState).create({
        doc: code,
        extensions: [
            languageExtension
        ]
    });
    const tree = (0, $1LbwH.ensureSyntaxTree)(state, $ad405bfc761d41cf$export$e75f75ae6a127ac1, $ad405bfc761d41cf$export$656dc3249b75d6af);
    if (tree === null) return [];
    let characterIndex = 0;
    let parsedCharacterIndex = 0;
    (0, $6yW7d.highlightTree)(tree, (0, $6yW7d.classHighlighter), (from, to, className)=>{
        if (from > characterIndex) // No style applied to the token between position and from.
        // This typically indicates white space or newline characters.
        $ad405bfc761d41cf$var$processSection(currentLineState, parsedTokens, code.slice(characterIndex, from), "");
        $ad405bfc761d41cf$var$processSection(currentLineState, parsedTokens, code.slice(from, to), className);
        characterIndex = to;
    });
    const maxPosition = code.length - 1;
    if (characterIndex < maxPosition) // No style applied on the trailing text.
    // This typically indicates white space or newline characters.
    $ad405bfc761d41cf$var$processSection(currentLineState, parsedTokens, code.slice(characterIndex, maxPosition), "");
    if (currentLineState.parsedTokens.length) parsedTokens.push(currentLineState.parsedTokens);
    parsedCharacterIndex += characterIndex + 1;
    // Anything that's left should de-opt to plain text.
    if (parsedCharacterIndex < code.length) {
        let nextIndex = code.indexOf("\n", parsedCharacterIndex);
        let parsedLineTokens = [];
        while(true){
            const line = nextIndex >= 0 ? code.substring(parsedCharacterIndex, nextIndex) : code.substring(parsedCharacterIndex);
            parsedLineTokens.push({
                columnIndex: 0,
                type: null,
                value: line
            });
            if (nextIndex >= 0) {
                parsedTokens.push(parsedLineTokens);
                parsedLineTokens = [];
            } else if (nextIndex === -1) break;
            parsedCharacterIndex = nextIndex + 1;
            nextIndex = code.indexOf("\n", parsedCharacterIndex);
        }
        if (parsedLineTokens.length) parsedTokens.push(parsedLineTokens);
    }
    return parsedTokens;
}, "SyntaxParsingCache");
function $ad405bfc761d41cf$var$processSection(currentLineState, parsedTokens, section, className) {
    const tokenType = className?.substring(4) ?? null; // Remove "tok-" prefix;
    let index = 0;
    let nextIndex = section.indexOf("\n");
    while(true){
        const substring = nextIndex >= 0 ? section.substring(index, nextIndex) : section.substring(index);
        const token = {
            columnIndex: currentLineState.rawString.length,
            type: tokenType,
            value: substring
        };
        currentLineState.parsedTokens.push(token);
        currentLineState.rawString += substring;
        if (nextIndex === -1) break;
        if (nextIndex >= 0) {
            parsedTokens.push(currentLineState.parsedTokens);
            currentLineState.parsedTokens = [];
            currentLineState.rawString = "";
        }
        index = nextIndex + 1;
        nextIndex = section.indexOf("\n", index);
    }
}
function $ad405bfc761d41cf$export$8f611fed3c043989(tokens) {
    return tokens.map((token)=>{
        const className = token.type ? `tok-${token.type}` : "";
        const escapedValue = $ad405bfc761d41cf$export$2bf939f54de7f222(token.value);
        return `<span class="${className}">${escapedValue}</span>`;
    }).join("");
}
function $ad405bfc761d41cf$export$2bf939f54de7f222(rawString) {
    return rawString.replace(/[\u00A0-\u9999<>\&]/g, (substring)=>"&#" + substring.charCodeAt(0) + ";");
}
async function $ad405bfc761d41cf$var$getLanguageExtension(language) {
    switch(language){
        case "css":
            const { cssLanguage: cssLanguage } = await (0, $36b8863c95c5797f$export$ecd75350b0814c5b)("@codemirror/lang-css");
            return cssLanguage.extension;
        case "html":
            const { htmlLanguage: htmlLanguage } = await (0, $36b8863c95c5797f$export$ecd75350b0814c5b)("@codemirror/lang-html");
            return htmlLanguage.extension;
        case "javascript":
            const { javascriptLanguage: javascriptLanguage } = await (0, $36b8863c95c5797f$export$ecd75350b0814c5b)("@codemirror/lang-javascript");
            return javascriptLanguage.extension;
        case "jsx":
            const { jsxLanguage: jsxLanguage } = await (0, $36b8863c95c5797f$export$ecd75350b0814c5b)("@codemirror/lang-javascript");
            return jsxLanguage.extension;
        case "markdown":
            const { markdownLanguage: markdownLanguage } = await (0, $36b8863c95c5797f$export$ecd75350b0814c5b)("@codemirror/lang-markdown");
            return markdownLanguage.extension;
        case "tsx":
            const { tsxLanguage: tsxLanguage } = await (0, $36b8863c95c5797f$export$ecd75350b0814c5b)("@codemirror/lang-javascript");
            return tsxLanguage.extension;
        case "typescript":
            const { typescriptLanguage: typescriptLanguage } = await (0, $36b8863c95c5797f$export$ecd75350b0814c5b)("@codemirror/lang-javascript");
            return typescriptLanguage.extension;
        default:
            throw Error(`Unsupported language: "${language}"`);
    }
}


var $d800845a913fb1ea$exports = {};

$parcel$export($d800845a913fb1ea$exports, "Code", () => $d800845a913fb1ea$export$52f0f02147b12c03, (v) => $d800845a913fb1ea$export$52f0f02147b12c03 = v);
$parcel$export($d800845a913fb1ea$exports, "LineNumber", () => $d800845a913fb1ea$export$d733a4bfd9217ad6, (v) => $d800845a913fb1ea$export$d733a4bfd9217ad6 = v);
$parcel$export($d800845a913fb1ea$exports, "Loader", () => $d800845a913fb1ea$export$3b0d6d7590275603, (v) => $d800845a913fb1ea$export$3b0d6d7590275603 = v);
var $d800845a913fb1ea$export$52f0f02147b12c03;
var $d800845a913fb1ea$export$d733a4bfd9217ad6;
var $d800845a913fb1ea$export$3b0d6d7590275603;
$d800845a913fb1ea$export$52f0f02147b12c03 = `Nlkloq_Code`;
$d800845a913fb1ea$export$d733a4bfd9217ad6 = `Nlkloq_LineNumber`;
$d800845a913fb1ea$export$3b0d6d7590275603 = `Nlkloq_Loader`;


function $99617ed31b4804f0$export$2e2bcd8739ae039({ className: className = "", code: code, language: language = "jsx", showLineNumbers: showLineNumbers = false }) {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $lx97N.Suspense), {
        fallback: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($99617ed31b4804f0$var$Fallback, {
            className: className,
            code: code,
            showLineNumbers: showLineNumbers
        }),
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($99617ed31b4804f0$var$Parser, {
            className: className,
            code: code,
            language: language,
            showLineNumbers: showLineNumbers
        })
    });
}
function $99617ed31b4804f0$var$Fallback({ className: className, code: code, showLineNumbers: showLineNumbers }) {
    const htmlLines = (0, $lx97N.useMemo)(()=>{
        return code.split("\n").map((line, index)=>{
            const escaped = (0, $ad405bfc761d41cf$export$2bf939f54de7f222)(line);
            if (showLineNumbers) return `<span class="${(0, (/*@__PURE__*/$parcel$interopDefault($d800845a913fb1ea$exports))).LineNumber}">${index + 1}</span> ${escaped}`;
            return escaped;
        });
    }, [
        showLineNumbers,
        code
    ]);
    const maxLineNumberLength = `${htmlLines.length + 1}`.length;
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
        className: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d800845a913fb1ea$exports))).Code,
            className
        ].join(" "),
        dangerouslySetInnerHTML: {
            __html: htmlLines.join("<br/>")
        },
        style: {
            // @ts-ignore
            "--max-line-number-length": `${maxLineNumberLength}ch`
        }
    });
}
function $99617ed31b4804f0$var$Parser({ className: className, code: code, language: language, showLineNumbers: showLineNumbers }) {
    const tokens = (0, $ad405bfc761d41cf$export$d98036f94aae2a34)(code, language);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($99617ed31b4804f0$var$TokenRenderer, {
        className: className,
        tokens: tokens,
        showLineNumbers: showLineNumbers
    });
}
function $99617ed31b4804f0$var$TokenRenderer({ className: className, showLineNumbers: showLineNumbers, tokens: tokens }) {
    const maxLineNumberLength = `${tokens.length + 1}`.length;
    const html = (0, $lx97N.useMemo)(()=>{
        return tokens.map((lineTokens, index)=>{
            const html = (0, $ad405bfc761d41cf$export$8f611fed3c043989)(lineTokens);
            if (showLineNumbers) return `<span class="${(0, (/*@__PURE__*/$parcel$interopDefault($d800845a913fb1ea$exports))).LineNumber}">${index + 1}</span> ${html}`;
            return html;
        }).join("<br/>");
    }, [
        showLineNumbers,
        tokens
    ]);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
        className: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d800845a913fb1ea$exports))).Code,
            className
        ].join(" "),
        dangerouslySetInnerHTML: {
            __html: html
        },
        style: {
            // @ts-ignore
            "--max-line-number-length": `${maxLineNumberLength}ch`
        }
    });
}


var $914fa7e3beef1e9c$exports = {};

$parcel$export($914fa7e3beef1e9c$exports, "Code", () => $914fa7e3beef1e9c$export$52f0f02147b12c03, (v) => $914fa7e3beef1e9c$export$52f0f02147b12c03 = v);
$parcel$export($914fa7e3beef1e9c$exports, "ExampleContainer", () => $914fa7e3beef1e9c$export$5501ba450bfeeb44, (v) => $914fa7e3beef1e9c$export$5501ba450bfeeb44 = v);
$parcel$export($914fa7e3beef1e9c$exports, "Header", () => $914fa7e3beef1e9c$export$8b251419efc915eb, (v) => $914fa7e3beef1e9c$export$8b251419efc915eb = v);
$parcel$export($914fa7e3beef1e9c$exports, "Route", () => $914fa7e3beef1e9c$export$e7b0ac011bb776c6, (v) => $914fa7e3beef1e9c$export$e7b0ac011bb776c6 = v);
$parcel$export($914fa7e3beef1e9c$exports, "Title", () => $914fa7e3beef1e9c$export$f99233281efd08a0, (v) => $914fa7e3beef1e9c$export$f99233281efd08a0 = v);
var $914fa7e3beef1e9c$export$52f0f02147b12c03;
var $914fa7e3beef1e9c$export$5501ba450bfeeb44;
var $914fa7e3beef1e9c$export$8b251419efc915eb;
var $914fa7e3beef1e9c$export$e7b0ac011bb776c6;
var $914fa7e3beef1e9c$export$f99233281efd08a0;
$914fa7e3beef1e9c$export$52f0f02147b12c03 = `FPzdnG_Code`;
$914fa7e3beef1e9c$export$5501ba450bfeeb44 = `FPzdnG_ExampleContainer`;
$914fa7e3beef1e9c$export$8b251419efc915eb = `FPzdnG_Header`;
$914fa7e3beef1e9c$export$e7b0ac011bb776c6 = `FPzdnG_Route`;
$914fa7e3beef1e9c$export$f99233281efd08a0 = `FPzdnG_Title`;


function $fe257bf6919f8c79$export$2e2bcd8739ae039({ code: code, exampleNode: exampleNode, headerNode: headerNode, language: language = "jsx", title: title }) {
    (0, $lx97N.useLayoutEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).Route,
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("h1", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).Header,
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $e63ef3154ed2b0d6$export$a6c7ac8248d6e38a), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).HomeLink,
                        to: "/",
                        children: "Home"
                    }),
                    "→",
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).Title,
                        children: title
                    })
                ]
            }),
            headerNode,
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).ExampleContainer,
                children: exampleNode
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).Code,
                code: code.trim(),
                language: language,
                showLineNumbers: true
            })
        ]
    });
}


var $7d9e0d4d6612ed4e$exports = {};

$parcel$export($7d9e0d4d6612ed4e$exports, "Button", () => $7d9e0d4d6612ed4e$export$353f5b6fc5456de1, (v) => $7d9e0d4d6612ed4e$export$353f5b6fc5456de1 = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "ButtonDisabled", () => $7d9e0d4d6612ed4e$export$a548b15ec67d872f, (v) => $7d9e0d4d6612ed4e$export$a548b15ec67d872f = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "Buttons", () => $7d9e0d4d6612ed4e$export$665d5a662b7213f3, (v) => $7d9e0d4d6612ed4e$export$665d5a662b7213f3 = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "Capitalize", () => $7d9e0d4d6612ed4e$export$b6e82024385b5296, (v) => $7d9e0d4d6612ed4e$export$b6e82024385b5296 = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "Centered", () => $7d9e0d4d6612ed4e$export$844f199b4427ce36, (v) => $7d9e0d4d6612ed4e$export$844f199b4427ce36 = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "InlineCode", () => $7d9e0d4d6612ed4e$export$7f1bf47c7f50a6aa, (v) => $7d9e0d4d6612ed4e$export$7f1bf47c7f50a6aa = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "Overflow", () => $7d9e0d4d6612ed4e$export$25d20c189d4a23b8, (v) => $7d9e0d4d6612ed4e$export$25d20c189d4a23b8 = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "Panel", () => $7d9e0d4d6612ed4e$export$2ddb90ad54e5f587, (v) => $7d9e0d4d6612ed4e$export$2ddb90ad54e5f587 = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "PanelColumn", () => $7d9e0d4d6612ed4e$export$9b88ed32c90dbdcb, (v) => $7d9e0d4d6612ed4e$export$9b88ed32c90dbdcb = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "PanelGroup", () => $7d9e0d4d6612ed4e$export$1d05749f6f573bb, (v) => $7d9e0d4d6612ed4e$export$1d05749f6f573bb = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "PanelGroupWrapper", () => $7d9e0d4d6612ed4e$export$606913875f408498, (v) => $7d9e0d4d6612ed4e$export$606913875f408498 = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "PanelRow", () => $7d9e0d4d6612ed4e$export$8f3ce8e34974de53, (v) => $7d9e0d4d6612ed4e$export$8f3ce8e34974de53 = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "WarningBlock", () => $7d9e0d4d6612ed4e$export$eae9c8a721b05332, (v) => $7d9e0d4d6612ed4e$export$eae9c8a721b05332 = v);
$parcel$export($7d9e0d4d6612ed4e$exports, "WarningIcon", () => $7d9e0d4d6612ed4e$export$f7dc499a72baa103, (v) => $7d9e0d4d6612ed4e$export$f7dc499a72baa103 = v);
var $7d9e0d4d6612ed4e$export$353f5b6fc5456de1;
var $7d9e0d4d6612ed4e$export$a548b15ec67d872f;
var $7d9e0d4d6612ed4e$export$665d5a662b7213f3;
var $7d9e0d4d6612ed4e$export$b6e82024385b5296;
var $7d9e0d4d6612ed4e$export$844f199b4427ce36;
var $7d9e0d4d6612ed4e$export$7f1bf47c7f50a6aa;
var $7d9e0d4d6612ed4e$export$25d20c189d4a23b8;
var $7d9e0d4d6612ed4e$export$2ddb90ad54e5f587;
var $7d9e0d4d6612ed4e$export$9b88ed32c90dbdcb;
var $7d9e0d4d6612ed4e$export$1d05749f6f573bb;
var $7d9e0d4d6612ed4e$export$606913875f408498;
var $7d9e0d4d6612ed4e$export$8f3ce8e34974de53;
var $7d9e0d4d6612ed4e$export$eae9c8a721b05332;
var $7d9e0d4d6612ed4e$export$f7dc499a72baa103;
$7d9e0d4d6612ed4e$export$353f5b6fc5456de1 = `_0btd0W_Button`;
$7d9e0d4d6612ed4e$export$a548b15ec67d872f = `_0btd0W_ButtonDisabled`;
$7d9e0d4d6612ed4e$export$665d5a662b7213f3 = `_0btd0W_Buttons`;
$7d9e0d4d6612ed4e$export$b6e82024385b5296 = `_0btd0W_Capitalize`;
$7d9e0d4d6612ed4e$export$844f199b4427ce36 = `_0btd0W_Centered`;
$7d9e0d4d6612ed4e$export$7f1bf47c7f50a6aa = `_0btd0W_InlineCode`;
$7d9e0d4d6612ed4e$export$25d20c189d4a23b8 = `_0btd0W_Overflow`;
$7d9e0d4d6612ed4e$export$2ddb90ad54e5f587 = `_0btd0W_Panel`;
$7d9e0d4d6612ed4e$export$9b88ed32c90dbdcb = `_0btd0W_PanelColumn`;
$7d9e0d4d6612ed4e$export$1d05749f6f573bb = `_0btd0W_PanelGroup`;
$7d9e0d4d6612ed4e$export$606913875f408498 = `_0btd0W_PanelGroupWrapper`;
$7d9e0d4d6612ed4e$export$8f3ce8e34974de53 = `_0btd0W_PanelRow`;
$7d9e0d4d6612ed4e$export$eae9c8a721b05332 = `_0btd0W_WarningBlock`;
$7d9e0d4d6612ed4e$export$f7dc499a72baa103 = `_0btd0W_WarningIcon`;


function $7e4f335662b3c697$export$2e2bcd8739ae039() {
    const [showLeftPanel, setShowLeftPanel] = (0, $lx97N.useState)(true);
    const [showRightPanel, setShowRightPanel] = (0, $lx97N.useState)(true);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $7e4f335662b3c697$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($7e4f335662b3c697$var$Content, {
            showLeftPanel: showLeftPanel,
            showRightPanel: showRightPanel
        }),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        "Panels can be conditionally rendered. The ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "order"
                        }),
                        " ensures they are (re)added in the correct order."
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        "If an ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "autoSaveId"
                        }),
                        " is provided, layouts will be stored separately for each panel combination."
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Buttons,
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("button", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Button,
                            onClick: ()=>setShowLeftPanel(!showLeftPanel),
                            children: [
                                showLeftPanel ? "Hide" : "Show",
                                " left panel"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("button", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Button,
                            onClick: ()=>setShowRightPanel(!showRightPanel),
                            children: [
                                showRightPanel ? "Hide" : "Show",
                                " right panel"
                            ]
                        })
                    ]
                })
            ]
        }),
        title: "Conditional panels"
    });
}
function $7e4f335662b3c697$var$Content({ showLeftPanel: showLeftPanel, showRightPanel: showRightPanel }) {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
            autoSaveId: "conditional",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
            direction: "horizontal",
            children: [
                showLeftPanel && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Panel,
                            id: "left",
                            minSizePercentage: 10,
                            order: 1,
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                children: "left"
                            })
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Panel,
                    id: "center",
                    minSizePercentage: 10,
                    order: 2,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "middle"
                    })
                }),
                showRightPanel && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Panel,
                            id: "right",
                            minSizePercentage: 10,
                            order: 3,
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                children: "right"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const $7e4f335662b3c697$var$CODE = `
<PanelGroup autoSaveId="conditional" direction="horizontal">
  {showLeftPanel && (
    <>
      <Panel id="left" order={1}>
        left
      </Panel>
      <PanelResizeHandle />
    </>
  )}
  <Panel id="center" order={2}>
    middle
  </Panel>
  {showRightPanel && (
    <>
      <PanelResizeHandle />
      <Panel id="right" order={3}>
        right
      </Panel>
    </>
  )}
</PanelGroup>
`;







var $lx97N = parcelRequire("lx97N");
var $3fbcb6b8042c89d9$var$$parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
var $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$exports = {};
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/ // Check `document` and `window` in case of server-side rendering
let $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject;
if (typeof window !== "undefined") $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject = window;
else if (typeof self !== "undefined") $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject = self;
else $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject = $3fbcb6b8042c89d9$var$$parcel$global;
let $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$cancelFrame = null;
let $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$requestFrame = null;
const $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$TIMEOUT_DURATION = 20;
const $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$clearTimeoutFn = $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject.clearTimeout;
const $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$setTimeoutFn = $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject.setTimeout;
const $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$cancelAnimationFrameFn = $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject.cancelAnimationFrame || $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject.mozCancelAnimationFrame || $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject.webkitCancelAnimationFrame;
const $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$requestAnimationFrameFn = $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject.requestAnimationFrame || $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject.mozRequestAnimationFrame || $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject.webkitRequestAnimationFrame;
if ($3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$cancelAnimationFrameFn == null || $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$requestAnimationFrameFn == null) {
    // For environments that don't support animation frame,
    // fallback to a setTimeout based approach.
    $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$cancelFrame = $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$clearTimeoutFn;
    $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$requestFrame = function requestAnimationFrameViaSetTimeout(callback) {
        return $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$setTimeoutFn(callback, $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$TIMEOUT_DURATION);
    };
} else {
    // Counter intuitively, environments that support animation frames can be trickier.
    // Chrome's "Throttle non-visible cross-origin iframes" flag can prevent rAFs from being called.
    // In this case, we should fallback to a setTimeout() implementation.
    $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$cancelFrame = function cancelFrame([animationFrameID, timeoutID]) {
        $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$cancelAnimationFrameFn(animationFrameID);
        $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$clearTimeoutFn(timeoutID);
    };
    $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$requestFrame = function requestAnimationFrameWithSetTimeoutFallback(callback) {
        const animationFrameID = $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$requestAnimationFrameFn(function animationFrameCallback() {
            $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$clearTimeoutFn(timeoutID);
            callback();
        });
        const timeoutID = $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$setTimeoutFn(function timeoutCallback() {
            $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$cancelAnimationFrameFn(animationFrameID);
            callback();
        }, $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$TIMEOUT_DURATION);
        return [
            animationFrameID,
            timeoutID
        ];
    };
}
function $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$createDetectElementResize(nonce) {
    let animationKeyframes;
    let animationName;
    let animationStartEvent;
    let animationStyle;
    let checkTriggers;
    let resetTriggers;
    let scrollListener;
    const attachEvent = typeof document !== "undefined" && document.attachEvent;
    if (!attachEvent) {
        resetTriggers = function(element) {
            const triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + "px";
            expandChild.style.height = expand.offsetHeight + 1 + "px";
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        checkTriggers = function(element) {
            return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
        };
        scrollListener = function(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === "function" && e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0) return;
            const element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$requestFrame(function animationFrame() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function forEachResizeListener(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ let animation = false;
        let keyframeprefix = "";
        animationStartEvent = "animationstart";
        const domPrefixes = "Webkit Moz O ms".split(" ");
        let startEvents = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" ");
        let pfx = "";
        {
            const elm = document.createElement("fakeelement");
            if (elm.style.animationName !== undefined) animation = true;
            if (animation === false) {
                for(let i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + "AnimationName"] !== undefined) {
                    pfx = domPrefixes[i];
                    keyframeprefix = "-" + pfx.toLowerCase() + "-";
                    animationStartEvent = startEvents[i];
                    animation = true;
                    break;
                }
            }
        }
        animationName = "resizeanim";
        animationKeyframes = "@" + keyframeprefix + "keyframes " + animationName + " { from { opacity: 0; } to { opacity: 0; } } ";
        animationStyle = keyframeprefix + "animation: 1ms " + animationName + "; ";
    }
    const createStyles = function(doc) {
        if (!doc.getElementById("detectElementResize")) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            const css = (animationKeyframes ? animationKeyframes : "") + ".resize-triggers { " + (animationStyle ? animationStyle : "") + "visibility: hidden; opacity: 0; } " + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName("head")[0], style = doc.createElement("style");
            style.id = "detectElementResize";
            style.type = "text/css";
            if (nonce != null) style.setAttribute("nonce", nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    const addResizeListener = function(element, fn) {
        if (attachEvent) element.attachEvent("onresize", fn);
        else {
            if (!element.__resizeTriggers__) {
                const doc = element.ownerDocument;
                const elementStyle = $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$windowObject.getComputedStyle(element);
                if (elementStyle && elementStyle.position === "static") element.style.position = "relative";
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement("div")).className = "resize-triggers";
                const expandTrigger = doc.createElement("div");
                expandTrigger.className = "expand-trigger";
                expandTrigger.appendChild(doc.createElement("div"));
                const contractTrigger = doc.createElement("div");
                contractTrigger.className = "contract-trigger";
                element.__resizeTriggers__.appendChild(expandTrigger);
                element.__resizeTriggers__.appendChild(contractTrigger);
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener("scroll", scrollListener, true);
                /* Listen for a css animation to detect element display/re-attach */ if (animationStartEvent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName === animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    const removeResizeListener = function(element, fn) {
        if (attachEvent) element.detachEvent("onresize", fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                element.removeEventListener("scroll", scrollListener, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}
$3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$exports = {
    createDetectElementResize: $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$var$createDetectElementResize
};
class $3fbcb6b8042c89d9$var$$6e2bb92d9db3b0c8$export$9d94f4ee1d930ff extends (0, $lx97N.Component) {
    static defaultProps = {
        onResize: ()=>{},
        disableHeight: false,
        disableWidth: false,
        style: {}
    };
    state = {
        height: this.props.defaultHeight || 0,
        width: this.props.defaultWidth || 0
    };
    _parentNode = null;
    _autoSizer = null;
    _detectElementResize = null;
    componentDidMount() {
        const { nonce: nonce } = this.props;
        if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
            // Delay access of parentNode until mount.
            // This handles edge-cases where the component has already been unmounted before its ref has been set,
            // As well as libraries like react-lite which have a slightly different lifecycle.
            this._parentNode = this._autoSizer.parentNode;
            // Defer requiring resize handler in order to support server-side rendering.
            // See issue #41
            const detectElementResize = (0, $3fbcb6b8042c89d9$var$$3e40d2fd7fdb47d2$exports.createDetectElementResize)(nonce);
            detectElementResize.addResizeListener(this._parentNode, this._onResize);
            this._detectElementResize = detectElementResize;
            this._onResize();
        }
    }
    componentWillUnmount() {
        if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
    }
    render() {
        const { children: children, defaultHeight: defaultHeight, defaultWidth: defaultWidth, disableHeight: disableHeight, disableWidth: disableWidth, nonce: nonce, onResize: onResize, style: style, tagName: tagName = "div", ...rest } = this.props;
        const { height: height, width: width } = this.state;
        // Outer div should not force width/height since that may prevent containers from shrinking.
        // Inner component should overflow and use calculated width/height.
        // See issue #68 for more information.
        const outerStyle = {
            overflow: "visible"
        };
        const childParams = {};
        // Avoid rendering children before the initial measurements have been collected.
        // At best this would just be wasting cycles.
        let bailoutOnChildren = false;
        if (!disableHeight) {
            if (height === 0) bailoutOnChildren = true;
            outerStyle.height = 0;
            childParams.height = height;
        }
        if (!disableWidth) {
            if (width === 0) bailoutOnChildren = true;
            outerStyle.width = 0;
            childParams.width = width;
        }
        return (0, $lx97N.createElement)(tagName, {
            ref: this._setRef,
            style: {
                ...outerStyle,
                ...style
            },
            ...rest
        }, !bailoutOnChildren && children(childParams));
    }
    _onResize = ()=>{
        const { disableHeight: disableHeight, disableWidth: disableWidth, onResize: onResize } = this.props;
        if (this._parentNode) {
            // Guard against AutoSizer component being removed from the DOM immediately after being added.
            // This can result in invalid style values which can result in NaN values if we don't handle them.
            // See issue #150 for more context.
            const rect = this._parentNode.getBoundingClientRect();
            const height = rect.height || 0;
            const width = rect.width || 0;
            const style = window.getComputedStyle(this._parentNode) || {};
            const paddingLeft = parseInt(style.paddingLeft, 10) || 0;
            const paddingRight = parseInt(style.paddingRight, 10) || 0;
            const paddingTop = parseInt(style.paddingTop, 10) || 0;
            const paddingBottom = parseInt(style.paddingBottom, 10) || 0;
            const newHeight = height - paddingTop - paddingBottom;
            const newWidth = width - paddingLeft - paddingRight;
            if (!disableHeight && this.state.height !== newHeight || !disableWidth && this.state.width !== newWidth) {
                this.setState({
                    height: height - paddingTop - paddingBottom,
                    width: width - paddingLeft - paddingRight
                });
                if (typeof onResize === "function") onResize({
                    height: height,
                    width: width
                });
            }
        }
    };
    _setRef = (autoSizer)=>{
        this._autoSizer = autoSizer;
    };
}
var $3fbcb6b8042c89d9$export$2e2bcd8739ae039 = $3fbcb6b8042c89d9$var$$6e2bb92d9db3b0c8$export$9d94f4ee1d930ff;



var $0bff86da382c299f$exports = {};

$parcel$export($0bff86da382c299f$exports, "AutoSizerInner", () => $0bff86da382c299f$export$ce3b421ecf1c453e, (v) => $0bff86da382c299f$export$ce3b421ecf1c453e = v);
$parcel$export($0bff86da382c299f$exports, "AutoSizerWrapper", () => $0bff86da382c299f$export$dd5cead13a610320, (v) => $0bff86da382c299f$export$dd5cead13a610320 = v);
$parcel$export($0bff86da382c299f$exports, "Small", () => $0bff86da382c299f$export$148e312beb132853, (v) => $0bff86da382c299f$export$148e312beb132853 = v);
var $0bff86da382c299f$export$ce3b421ecf1c453e;
var $0bff86da382c299f$export$dd5cead13a610320;
var $0bff86da382c299f$export$148e312beb132853;
$0bff86da382c299f$export$ce3b421ecf1c453e = `aU2vGa_AutoSizerInner`;
$0bff86da382c299f$export$dd5cead13a610320 = `aU2vGa_AutoSizerWrapper`;
$0bff86da382c299f$export$148e312beb132853 = `aU2vGa_Small`;





function $dea5e99b7171edb5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).Route,
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("h1", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).Header,
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $e63ef3154ed2b0d6$export$a6c7ac8248d6e38a), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).HomeLink,
                        to: "/",
                        children: "Home"
                    }),
                    "→",
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).Title,
                        children: "Pixel based layouts"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                children: [
                    "Resizable panels can specific either ",
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("strong", {
                        children: "percentage-based"
                    }),
                    " ",
                    "or ",
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("strong", {
                        children: "pixel-based"
                    }),
                    " layout constraints, although percentage-based constraints are generally recommended for performance purposes. The example below shows a horizontal panel group where the first panel is limited to a range of 100-200 pixels."
                ]
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).WarningBlock,
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).WarningIcon,
                        type: "warning"
                    }),
                    "Pixel units should only be used when necessary because they require the use of a ",
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                        children: "ResizerObserver"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).ExampleContainer,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
                    "data-short": true,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
                        direction: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                                minSizePixels: 100,
                                maxSizePixels: 200,
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0bff86da382c299f$exports))).AutoSizerWrapper,
                                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($dea5e99b7171edb5$var$Size, {
                                        direction: "horizontal",
                                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0bff86da382c299f$exports))).Small,
                                            children: "100px - 200px"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                                minSizePixels: 10,
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                    children: "middle"
                                })
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                                minSizePixels: 10,
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                    children: "right"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).Code,
                code: $dea5e99b7171edb5$var$CODE_HOOK.trim(),
                language: "jsx",
                showLineNumbers: true
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).ExampleContainer,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                    children: "Panels with pixel constraints can also be configured to collapse as shown below."
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).ExampleContainer,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
                    "data-short": true,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
                        direction: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                                minSizePixels: 10,
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                    children: "left"
                                })
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                                minSizePixels: 10,
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                    children: "middle"
                                })
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                                collapsible: true,
                                collapsedSizePixels: 75,
                                minSizePixels: 200,
                                maxSizePixels: 300,
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0bff86da382c299f$exports))).AutoSizerWrapper,
                                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($dea5e99b7171edb5$var$Size, {
                                        direction: "horizontal",
                                        children: [
                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0bff86da382c299f$exports))).Small,
                                                children: "200px - 300px"
                                            }),
                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0bff86da382c299f$exports))).Small,
                                                children: "collapse below 200px"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($914fa7e3beef1e9c$exports))).Code,
                code: $dea5e99b7171edb5$var$CODE_HOOK_COLLAPSIBLE.trim(),
                language: "jsx",
                showLineNumbers: true
            })
        ]
    });
}
function $dea5e99b7171edb5$var$Size({ children: children, direction: direction }) {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $3fbcb6b8042c89d9$export$2e2bcd8739ae039), {
        children: ({ height: height, width: width })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0bff86da382c299f$exports))).AutoSizerInner,
                style: {
                    height: `${height}px`,
                    width: `${width}px`
                },
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("center", {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                            children: [
                                direction === "horizontal" ? width : height,
                                "px"
                            ]
                        }),
                        children
                    ]
                })
            })
    });
}
const $dea5e99b7171edb5$var$CODE_HOOK = `
<PanelGroup direction="horizontal">
  <Panel minSizePixels={100} maxSizePixels={200} />
  <PanelResizeHandle />
  <Panel />
  <PanelResizeHandle />
  <Panel />
</PanelGroup>
`;
const $dea5e99b7171edb5$var$CODE_HOOK_COLLAPSIBLE = `
<PanelGroup direction="horizontal">
  <Panel />
  <PanelResizeHandle />
  <Panel />
  <PanelResizeHandle />
  <Panel collapsible={true} collapsedSizePixels={75} minSizePixels={200} maxSizePixels={300} />
</PanelGroup>
`;




var $lx97N = parcelRequire("lx97N");






function $dd14ea2961012e31$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $dd14ea2961012e31$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($dd14ea2961012e31$var$Content, {}),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        "By default, a ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "PanelGroup"
                        }),
                        " with an",
                        " ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "autoSaveId"
                        }),
                        " will store layout information in",
                        " ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "localStorage"
                        }),
                        ". This example shows how the how to use the",
                        " ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "storage"
                        }),
                        " prop to override that behavior. For this demo, layout is saved as part of the URL hash."
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).WarningBlock,
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).WarningIcon,
                            type: "warning"
                        }),
                        "Note the ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "storage"
                        }),
                        " API is ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("em", {
                            children: "synchronous"
                        }),
                        ". If an async source is used (e.g. a database) then values should be pre-fetched during the initial render (e.g. using Suspense)."
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).WarningBlock,
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).WarningIcon,
                            type: "warning"
                        }),
                        "Note calls to ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "storage.setItem"
                        }),
                        " are debounced by",
                        " ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("strong", {
                            children: "100ms"
                        }),
                        ". Depending on your implementation, you may wish to use a larger interval than that."
                    ]
                })
            ]
        }),
        title: "External persistence"
    });
}
function $dd14ea2961012e31$var$Content() {
    const navigate = (0, $70ed8fdcf064e4a0$export$9770f232ac06a008)();
    const urlStorage = (0, $lx97N.useMemo)(()=>({
            getItem (name) {
                try {
                    const raw = decodeURI(window.location.hash.substring(1));
                    if (raw) {
                        const parsed = JSON.parse(raw);
                        return parsed[name] || "";
                    }
                } catch (error) {
                    console.error(error);
                    return "";
                }
            },
            setItem (name, value) {
                const encoded = encodeURI(JSON.stringify({
                    [name]: value
                }));
                // Update the hash without interfering with the browser's Back button.
                navigate("#" + encoded, {
                    replace: true
                });
            }
        }), [
        navigate
    ]);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
            autoSaveId: "example",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
            direction: "horizontal",
            storage: urlStorage,
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    collapsible: true,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "left"
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "middle"
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    collapsible: true,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "right"
                    })
                })
            ]
        })
    });
}
const $dd14ea2961012e31$var$CODE = `
const navigate = useNavigate();

const urlStorage = useMemo(() => ({
  getItem(name) {
    try {
      const parsed = JSON.parse(decodeURI(window.location.hash.substring(1)));
      return parsed[name] || "";
    } catch (error) {
      console.error(error);
      return "";
    }
  },
  setItem(name, value) {
    const encoded = encodeURI(JSON.stringify({
      [name]: value
    }));

    // Update the hash without interfering with the browser's Back button.
    navigate('#' + encoded, { replace: true });
  }
}), [navigate]);

<PanelGroup autoSaveId="example" direction="horizontal" storage={urlStorage}>
  <Panel>left</Panel>
  <PanelResizeHandle />
  <Panel>middle</Panel>
  <PanelResizeHandle />
  <Panel>right</Panel>
</PanelGroup>
`;







function $0f6043888b379808$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $0f6043888b379808$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($0f6043888b379808$var$Content, {}),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        "This example is a 3-column horizontal ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "PanelGroup"
                        }),
                        ". Click/touch the empty space between the panels and drag to resize. Arrow keys can also be used to resize panels."
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        "These panels use the ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "minSize"
                        }),
                        " property to prevent them from being resized smaller than a minimal percentage of the overall group."
                    ]
                })
            ]
        }),
        title: "Horizontal layouts"
    });
}
function $0f6043888b379808$var$Content() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
            direction: "horizontal",
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    defaultSizePercentage: 30,
                    minSizePercentage: 20,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "left"
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    minSizePercentage: 30,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "middle"
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    defaultSizePercentage: 30,
                    minSizePercentage: 20,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "right"
                    })
                })
            ]
        })
    });
}
const $0f6043888b379808$var$CODE = `
<PanelGroup direction="horizontal">
  <Panel defaultSizePercentage={30} minSizePercentage={20}>
    left
  </Panel>
  <PanelResizeHandle />
  <Panel minSizePercentage={30}>
    middle
  </Panel>
  <PanelResizeHandle />
  <Panel defaultSizePercentage={30} minSizePercentage={20}>
    right
  </Panel>
</PanelGroup>
`;




var $lx97N = parcelRequire("lx97N");




var $e5a3297f5bc9cef6$exports = {};

$parcel$export($e5a3297f5bc9cef6$exports, "ResizeForm", () => $e5a3297f5bc9cef6$export$2300ed846b160106, (v) => $e5a3297f5bc9cef6$export$2300ed846b160106 = v);
$parcel$export($e5a3297f5bc9cef6$exports, "SizeInput", () => $e5a3297f5bc9cef6$export$5f567fa1fb6c85a7, (v) => $e5a3297f5bc9cef6$export$5f567fa1fb6c85a7 = v);
$parcel$export($e5a3297f5bc9cef6$exports, "ToggleRow", () => $e5a3297f5bc9cef6$export$8c9abd0860cfec30, (v) => $e5a3297f5bc9cef6$export$8c9abd0860cfec30 = v);
$parcel$export($e5a3297f5bc9cef6$exports, "Toggles", () => $e5a3297f5bc9cef6$export$f0c0043dcf460bd9, (v) => $e5a3297f5bc9cef6$export$f0c0043dcf460bd9 = v);
var $e5a3297f5bc9cef6$export$2300ed846b160106;
var $e5a3297f5bc9cef6$export$5f567fa1fb6c85a7;
var $e5a3297f5bc9cef6$export$8c9abd0860cfec30;
var $e5a3297f5bc9cef6$export$f0c0043dcf460bd9;
$e5a3297f5bc9cef6$export$2300ed846b160106 = `F9UJ7a_ResizeForm`;
$e5a3297f5bc9cef6$export$5f567fa1fb6c85a7 = `F9UJ7a_SizeInput`;
$e5a3297f5bc9cef6$export$8c9abd0860cfec30 = `F9UJ7a_ToggleRow`;
$e5a3297f5bc9cef6$export$f0c0043dcf460bd9 = `F9UJ7a_Toggles`;




function $c9067f6f07f1c14f$export$2e2bcd8739ae039() {
    const [sizes, setSizes] = (0, $lx97N.useState)({
        left: 20,
        middle: 60,
        right: 20
    });
    const onResize = (partialSizes)=>{
        setSizes((prevSizes)=>({
                ...prevSizes,
                ...partialSizes
            }));
    };
    const leftPanelRef = (0, $lx97N.useRef)(null);
    const middlePanelRef = (0, $lx97N.useRef)(null);
    const rightPanelRef = (0, $lx97N.useRef)(null);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $c9067f6f07f1c14f$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($c9067f6f07f1c14f$var$Content, {
            leftPanelRef: leftPanelRef,
            middlePanelRef: middlePanelRef,
            rightPanelRef: rightPanelRef,
            onResize: onResize,
            sizes: sizes
        }),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                    children: "Sometimes panels need to resize or collapse/expand in response to user actions. For example, double-clicking on a resize bar in VS Code resizes the panel to a size that fits all file names. This type of interaction can be implemented using the imperative API."
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "Panel"
                        }),
                        " provides the following imperative API methods:"
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).InlineCode,
                                    code: "collapse(): void",
                                    language: "typescript"
                                }),
                                "Collapse the panel to its minimum size"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).InlineCode,
                                    code: "expand(): void",
                                    language: "typescript"
                                }),
                                "Expand the panel to its previous size"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).InlineCode,
                                    code: "getCollapsed(): boolean",
                                    language: "typescript"
                                }),
                                "Panel is currently collapsed"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).InlineCode,
                                    code: `getSize(units?: "percentages" | "pixels"): number`,
                                    language: "typescript"
                                }),
                                "Panel's current size in the specified unit (or group default)"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).InlineCode,
                                    code: `resize(size: number, units?: "percentages" | "pixels"): void`,
                                    language: "typescript"
                                }),
                                "Resize the panel to the specified size in the specified unit (or group default)"
                            ]
                        })
                    ]
                })
            ]
        }),
        language: "tsx",
        title: "Imperative Panel API"
    });
}
function $c9067f6f07f1c14f$var$TogglesRow({ id: id, panelRef: panelRef, panelSize: panelSize }) {
    const [sizePercentage, setSizePercentage] = (0, $lx97N.useState)(20);
    const onInputChange = (event)=>{
        const input = event.currentTarget;
        setSizePercentage(parseInt(input.value));
    };
    const onFormSubmit = (event)=>{
        event.preventDefault();
        panelRef.current?.resize({
            sizePercentage: sizePercentage
        });
    };
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e5a3297f5bc9cef6$exports))).Toggles,
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                className: panelSize === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ButtonDisabled : (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Button,
                "data-test-id": `collapse-button-${id}`,
                onClick: ()=>panelRef.current?.collapse(),
                title: `Collapse ${id} panel`,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                    type: "horizontal-collapse"
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                className: panelSize !== 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ButtonDisabled : (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Button,
                "data-test-id": `expand-button-${id}`,
                onClick: ()=>panelRef.current?.expand(),
                title: `Expand ${id} panel`,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                    type: "horizontal-expand"
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("form", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e5a3297f5bc9cef6$exports))).ResizeForm,
                onSubmit: onFormSubmit,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e5a3297f5bc9cef6$exports))).SizeInput,
                    "data-test-id": `size-input-${id}`,
                    onChange: onInputChange,
                    min: 0,
                    max: 100,
                    size: 2,
                    type: "number",
                    value: sizePercentage
                })
            })
        ]
    });
}
function $c9067f6f07f1c14f$var$Content({ leftPanelRef: leftPanelRef, middlePanelRef: middlePanelRef, rightPanelRef: rightPanelRef, onResize: onResizeProp, sizes: sizes }) {
    const onResize = (partialSizes)=>{
        onResizeProp(partialSizes);
    };
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e5a3297f5bc9cef6$exports))).ToggleRow,
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($c9067f6f07f1c14f$var$TogglesRow, {
                        id: "left",
                        panelRef: leftPanelRef,
                        panelSize: sizes.left
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($c9067f6f07f1c14f$var$TogglesRow, {
                        id: "middle",
                        panelRef: middlePanelRef,
                        panelSize: sizes.middle
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($c9067f6f07f1c14f$var$TogglesRow, {
                        id: "right",
                        panelRef: rightPanelRef,
                        panelSize: sizes.right
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
                    direction: "horizontal",
                    id: "imperative-Panel-api",
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                            collapsible: true,
                            defaultSizePercentage: sizes.left,
                            id: "left",
                            maxSizePercentage: 30,
                            minSizePercentage: 10,
                            onResize: ({ sizePercentage: left })=>onResize({
                                    left: left
                                }),
                            order: 1,
                            ref: leftPanelRef,
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                children: [
                                    "left: ",
                                    Math.round(sizes.left)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                            collapsible: true,
                            id: "middle",
                            maxSizePercentage: 100,
                            minSizePercentage: 10,
                            onResize: ({ sizePercentage: middle })=>onResize({
                                    middle: middle
                                }),
                            order: 2,
                            ref: middlePanelRef,
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                children: [
                                    "middle: ",
                                    Math.round(sizes.middle)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                            collapsible: true,
                            defaultSizePercentage: sizes.right,
                            id: "right",
                            maxSizePercentage: 100,
                            minSizePercentage: 10,
                            onResize: ({ sizePercentage: right })=>onResize({
                                    right: right
                                }),
                            order: 3,
                            ref: rightPanelRef,
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                children: [
                                    "right: ",
                                    Math.round(sizes.right)
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
const $c9067f6f07f1c14f$var$CODE = `
import {
  ImperativePanelHandle,
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from "react-resizable-panels";

const ref = useRef<ImperativePanelHandle>(null);

const collapsePanel = () => {
  const panel = ref.current;
  if (panel) {
    panel.collapse();
  }
};

<PanelGroup direction="horizontal">
  <Panel collapsible ref={ref}>
    left
  </Panel>
  <PanelResizeHandle />
  <Panel>
    right
  </Panel>
</PanelGroup>
`;




var $lx97N = parcelRequire("lx97N");




var $7e1d68632c30ac3b$exports = {};

$parcel$export($7e1d68632c30ac3b$exports, "TopRow", () => $7e1d68632c30ac3b$export$b416f8175c450f1c, (v) => $7e1d68632c30ac3b$export$b416f8175c450f1c = v);
var $7e1d68632c30ac3b$export$b416f8175c450f1c;
$7e1d68632c30ac3b$export$b416f8175c450f1c = `g3D7gW_TopRow`;



function $452fb88e0ef71d46$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $452fb88e0ef71d46$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($452fb88e0ef71d46$var$Content, {}),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "PanelGroup"
                        }),
                        " provides the following imperative API methods:"
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).InlineCode,
                                    code: `getLayout(units?: "percentages" | "pixels"): number[]`,
                                    language: "typescript"
                                }),
                                "Current size of panels in the specified unit (or group default)"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).InlineCode,
                                    code: `setLayout(panelSizes: number[], units?: "percentages" | "pixels"): void`,
                                    language: "typescript"
                                }),
                                "Resize all panels using the specified unit (or group default)"
                            ]
                        })
                    ]
                })
            ]
        }),
        language: "tsx",
        title: "Imperative PanelGroup API"
    });
}
function $452fb88e0ef71d46$var$Content() {
    const [sizes, setSizes] = (0, $lx97N.useState)([]);
    const panelGroupRef = (0, $lx97N.useRef)(null);
    const onLayout = (mixedSizes)=>{
        setSizes(mixedSizes.map((mixedSize)=>mixedSize.sizePercentage));
    };
    const resetLayout = ()=>{
        const panelGroup = panelGroupRef.current;
        if (panelGroup) panelGroup.setLayout([
            {
                sizePercentage: 50
            },
            {
                sizePercentage: 50
            }
        ]);
    };
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7e1d68632c30ac3b$exports))).TopRow,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Button,
                    onClick: resetLayout,
                    children: "Reset layout"
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
                    direction: "horizontal",
                    id: "imperative-PanelGroup-api",
                    onLayout: onLayout,
                    ref: panelGroupRef,
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                            minSizePercentage: 10,
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                children: [
                                    "left: ",
                                    Math.round(sizes[0])
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                            minSizePercentage: 10,
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                children: [
                                    "right: ",
                                    Math.round(sizes[1])
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
const $452fb88e0ef71d46$var$CODE = `
import {
  ImperativePanelGroupHandle,
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from "react-resizable-panels";

const ref = useRef<ImperativePanelGroupHandle>(null);

const resetLayout = () => {
  const panelGroup = ref.current;
  if (panelGroup) {
    // Reset each Panel to 50% of the group's width
    panelGroup.setLayout([50, 50]);
  }
};

<PanelGroup direction="horizontal" ref={ref}>
  <Panel>left</Panel>
  <PanelResizeHandle />
  <Panel>right</Panel>
</PanelGroup>
`;







function $83518755cd0c0ce4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $83518755cd0c0ce4$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($83518755cd0c0ce4$var$Content, {}),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
            children: "This example shows nested groups."
        }),
        title: "Nested groups"
    });
}
function $83518755cd0c0ce4$var$Content() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
            direction: "horizontal",
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    defaultSizePercentage: 20,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "left"
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    minSizePercentage: 35,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
                        direction: "vertical",
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                                defaultSizePercentage: 35,
                                minSizePercentage: 10,
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                    children: "top"
                                })
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                                minSizePercentage: 10,
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
                                    direction: "horizontal",
                                    children: [
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                                            minSizePercentage: 10,
                                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                                children: "left"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                                        }),
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                                            minSizePercentage: 10,
                                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                                                children: "right"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    defaultSizePercentage: 20,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "right"
                    })
                })
            ]
        })
    });
}
const $83518755cd0c0ce4$var$CODE = `
<PanelGroup direction="horizontal">
  <Panel>
    left
  </Panel>
  <PanelResizeHandle />
  <Panel>
    <PanelGroup direction="vertical">
      <Panel>
        top
      </Panel>
      <PanelResizeHandle />
      <Panel>
        <PanelGroup direction="horizontal">
          <Panel>
            left
          </Panel>
          <PanelResizeHandle />
          <Panel>
            right
          </Panel>
        </PanelGroup>
      </Panel>
    </PanelGroup>
  </Panel>
  <PanelResizeHandle />
  <Panel>
    right
  </Panel>
</PanelGroup>
`;




var $lx97N = parcelRequire("lx97N");





function $01c257061870aa39$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $01c257061870aa39$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($01c257061870aa39$var$Content, {}),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
            children: "Panels clip their content by default, to avoid showing scrollbars while resizing. Content can still be configured to overflow within a panel though. This example shows how."
        }),
        title: "Overflow content"
    });
}
function $01c257061870aa39$var$Content() {
    const ref = (0, $lx97N.useRef)(null);
    const [width, setWidth] = (0, $lx97N.useState)(0);
    (0, $lx97N.useLayoutEffect)(()=>{
        const div = ref.current;
        const observer = new ResizeObserver(()=>{
            setWidth(div.offsetWidth);
        });
        observer.observe(div);
        return ()=>{
            observer.unobserve(div);
            observer.disconnect();
        };
    }, []);
    const useVerticalLayout = width < 800;
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
        ref: ref,
        style: {
            height: useVerticalLayout ? "30rem" : undefined
        },
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
            direction: useVerticalLayout ? "vertical" : "horizontal",
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                    defaultSizePercentage: 50,
                    minSizePercentage: 25,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        style: {
                            backgroundColor: "var(--color-background-code)"
                        },
                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Overflow,
                            code: $01c257061870aa39$var$TUTORIAL_CODE_LEFT.trim(),
                            language: "jsx",
                            showLineNumbers: true
                        })
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                    defaultSizePercentage: 50,
                    minSizePercentage: 25,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        style: {
                            backgroundColor: "var(--color-background-code)"
                        },
                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Overflow,
                            code: $01c257061870aa39$var$TUTORIAL_CODE_RIGHT.trim(),
                            language: "jsx",
                            showLineNumbers: true
                        })
                    })
                })
            ]
        })
    });
}
const $01c257061870aa39$var$CODE = `
<PanelGroup direction="horizontal">
  <Panel>
    <div style="overflow: auto">
      {/* Content */}
    </div>
  </Panel>
  <PanelResizeHandle />
  <Panel>
    <div style="overflow: auto">
      {/* Content */}
    </div>
  </Panel>
</PanelGroup>
`;
const $01c257061870aa39$var$TUTORIAL_CODE_LEFT = `
// https://reactjs.org/tutorial/tutorial.html#completing-the-game
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Game />);

function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
}
`;
const $01c257061870aa39$var$TUTORIAL_CODE_RIGHT = `
function Square(props) {
  return (
    <button className="square" onClick={props.onClick}>
      {props.value}
    </button>
  );
}

class Board extends React.Component {
  renderSquare(i) {
    return (
      <Square
        value={this.props.squares[i]}
        onClick={() => this.props.onClick(i)}
      />
    );
  }

  render() {
    return (
      <div>
        <div className="board-row">
          {this.renderSquare(0)}
          {this.renderSquare(1)}
          {this.renderSquare(2)}
        </div>
        <div className="board-row">
          {this.renderSquare(3)}
          {this.renderSquare(4)}
          {this.renderSquare(5)}
        </div>
        <div className="board-row">
          {this.renderSquare(6)}
          {this.renderSquare(7)}
          {this.renderSquare(8)}
        </div>
      </div>
    );
  }
}

class Game extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [
        {
          squares: Array(9).fill(null),
        },
      ],
      stepNumber: 0,
      xIsNext: true,
    };
  }

  handleClick(i) {
    const history = this.state.history.slice(0, this.state.stepNumber + 1);
    const current = history[history.length - 1];
    const squares = current.squares.slice();
    if (calculateWinner(squares) || squares[i]) {
      return;
    }
    squares[i] = this.state.xIsNext ? "X" : "O";
    this.setState({
      history: history.concat([
        {
          squares: squares,
        },
      ]),
      stepNumber: history.length,
      xIsNext: !this.state.xIsNext,
    });
  }

  jumpTo(step) {
    this.setState({
      stepNumber: step,
      xIsNext: step % 2 === 0,
    });
  }

  render() {
    const history = this.state.history;
    const current = history[this.state.stepNumber];
    const winner = calculateWinner(current.squares);

    const moves = history.map((step, move) => {
      const desc = move ? "Go to move #" + move : "Go to game start";
      return (
        <li key={move}>
          <button onClick={() => this.jumpTo(move)}>{desc}</button>
        </li>
      );
    });

    let status;
    if (winner) {
      status = "Winner: " + winner;
    } else {
      status = "Next player: " + (this.state.xIsNext ? "X" : "O");
    }

    return (
      <div className="game">
        <div className="game-board">
          <Board
            squares={current.squares}
            onClick={(i) => this.handleClick(i)}
          />
        </div>
        <div className="game-info">
          <div>{status}</div>
          <ol>{moves}</ol>
        </div>
      </div>
    );
  }
}
`;







function $139261b9c00dcaa5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $139261b9c00dcaa5$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($139261b9c00dcaa5$var$Content, {}),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
            children: [
                "Layouts are automatically saved when an ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                    children: "autoSaveId"
                }),
                " prop is provided. Try this by editing the layout below and then reloading the page."
            ]
        }),
        title: "Persistent layouts"
    });
}
function $139261b9c00dcaa5$var$Content() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
            autoSaveId: "persistence",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
            direction: "horizontal",
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "left"
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelRow,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "middle"
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "right"
                    })
                })
            ]
        })
    });
}
const $139261b9c00dcaa5$var$CODE = `
<PanelGroup autoSaveId="persistence" direction="horizontal">
  <Panel>
    left
  </Panel>
  <PanelResizeHandle />
  <Panel>
    middle
  </Panel>
  <PanelResizeHandle />
  <Panel>
    right
  </Panel>
</PanelGroup>
`;




var $lx97N = parcelRequire("lx97N");

// https://codepen.io/gaearon/pen/gWWZgR?editors=0010
const $58155992730ff39c$export$b9cc13ca8a0ed0bc = `
body {
  font: 14px "Century Gothic", Futura, sans-serif;
  margin: 20px;
}

ol, ul {
  padding-left: 30px;
}

.board-row:after {
  clear: both;
  content: "";
  display: table;
}

.status {
  margin-bottom: 10px;
}

.square {
  background: #fff;
  border: 1px solid #999;
  float: left;
  font-size: 24px;
  font-weight: bold;
  line-height: 34px;
  height: 34px;
  margin-right: -1px;
  margin-top: -1px;
  padding: 0;
  text-align: center;
  width: 34px;
}

.square:focus {
  outline: none;
}

.kbd-navigation .square:focus {
  background: #ddd;
}

.game {
  display: flex;
  flex-direction: row;
}

.game-info {
  margin-left: 20px;
}
`;
const $58155992730ff39c$export$2475c3bbb09aea07 = `
function Square(props) {
  return (
    <button className="square" onClick={props.onClick}>
      {props.value}
    </button>
  );
}

class Board extends React.Component {
  renderSquare(i) {
    return (
      <Square
        value={this.props.squares[i]}
        onClick={() => this.props.onClick(i)}
      />
    );
  }

  render() {
    return (
      <div>
        <div className="board-row">
          {this.renderSquare(0)}
          {this.renderSquare(1)}
          {this.renderSquare(2)}
        </div>
        <div className="board-row">
          {this.renderSquare(3)}
          {this.renderSquare(4)}
          {this.renderSquare(5)}
        </div>
        <div className="board-row">
          {this.renderSquare(6)}
          {this.renderSquare(7)}
          {this.renderSquare(8)}
        </div>
      </div>
    );
  }
}

class Game extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [
        {
          squares: Array(9).fill(null)
        }
      ],
      stepNumber: 0,
      xIsNext: true
    };
  }

  handleClick(i) {
    const history = this.state.history.slice(0, this.state.stepNumber + 1);
    const current = history[history.length - 1];
    const squares = current.squares.slice();
    if (calculateWinner(squares) || squares[i]) {
      return;
    }
    squares[i] = this.state.xIsNext ? "X" : "O";
    this.setState({
      history: history.concat([
        {
          squares: squares
        }
      ]),
      stepNumber: history.length,
      xIsNext: !this.state.xIsNext
    });
  }

  jumpTo(step) {
    this.setState({
      stepNumber: step,
      xIsNext: (step % 2) === 0
    });
  }

  render() {
    const history = this.state.history;
    const current = history[this.state.stepNumber];
    const winner = calculateWinner(current.squares);

    const moves = history.map((step, move) => {
      const desc = move ?
        'Go to move #' + move :
        'Go to game start';
      return (
        <li key={move}>
          <button onClick={() => this.jumpTo(move)}>{desc}</button>
        </li>
      );
    });

    let status;
    if (winner) {
      status = "Winner: " + winner;
    } else {
      status = "Next player: " + (this.state.xIsNext ? "X" : "O");
    }

    return (
      <div className="game">
        <div className="game-board">
          <Board
            squares={current.squares}
            onClick={i => this.handleClick(i)}
          />
        </div>
        <div className="game-info">
          <div>{status}</div>
          <ol>{moves}</ol>
        </div>
      </div>
    );
  }
}

// ========================================

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Game />);

function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6]
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
}
`;
const $58155992730ff39c$export$186d097d647783ac = `
<div id="errors" style="
  background: #c00;
  color: #fff;
  display: none;
  margin: -20px -20px 20px;
  padding: 20px;
  white-space: pre-wrap;
"></div>
<div id="root"></div>
<script>
window.addEventListener('mousedown', function(e) {
  document.body.classList.add('mouse-navigation');
  document.body.classList.remove('kbd-navigation');
});
window.addEventListener('keydown', function(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('kbd-navigation');
    document.body.classList.remove('mouse-navigation');
  }
});
window.addEventListener('click', function(e) {
  if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#') {
    e.preventDefault();
  }
});
window.onerror = function(message, source, line, col, error) {
  var text = error ? error.stack || error : message + ' (at ' + source + ':' + line + ':' + col + ')';
  errors.textContent += text + '\n';
  errors.style.display = '';
};
console.error = (function(old) {
  return function error() {
    errors.textContent += Array.prototype.slice.call(arguments).join(' ') + '\n';
    errors.style.display = '';
    old.apply(this, arguments);
  }
})(console.error);
</script>
`;
const $58155992730ff39c$export$bd9830b71362cd9d = `
# Tutorial: Intro to React
## This tutorial doesn’t assume any existing React knowledge.

Read more on [the React website](https://reactjs.org/tutorial/tutorial.html).
`;




var $3c04d27da32a3c51$exports = {};

$parcel$export($3c04d27da32a3c51$exports, "CloseButton", () => $3c04d27da32a3c51$export$de65de8213222d10, (v) => $3c04d27da32a3c51$export$de65de8213222d10 = v);
$parcel$export($3c04d27da32a3c51$exports, "CloseIcon", () => $3c04d27da32a3c51$export$cae179f078f4b4a4, (v) => $3c04d27da32a3c51$export$cae179f078f4b4a4 = v);
$parcel$export($3c04d27da32a3c51$exports, "DirectoryEntry", () => $3c04d27da32a3c51$export$51c46da272110b9a, (v) => $3c04d27da32a3c51$export$51c46da272110b9a = v);
$parcel$export($3c04d27da32a3c51$exports, "DirectoryName", () => $3c04d27da32a3c51$export$b778520f5cb384a0, (v) => $3c04d27da32a3c51$export$b778520f5cb384a0 = v);
$parcel$export($3c04d27da32a3c51$exports, "FileEntry", () => $3c04d27da32a3c51$export$af701efb7ddbdf6b, (v) => $3c04d27da32a3c51$export$af701efb7ddbdf6b = v);
$parcel$export($3c04d27da32a3c51$exports, "FileIcon", () => $3c04d27da32a3c51$export$8c1a3d13e85d78b7, (v) => $3c04d27da32a3c51$export$8c1a3d13e85d78b7 = v);
$parcel$export($3c04d27da32a3c51$exports, "FileList", () => $3c04d27da32a3c51$export$1e273ac3a2ccbf84, (v) => $3c04d27da32a3c51$export$1e273ac3a2ccbf84 = v);
$parcel$export($3c04d27da32a3c51$exports, "FileName", () => $3c04d27da32a3c51$export$2a0b83121174119c, (v) => $3c04d27da32a3c51$export$2a0b83121174119c = v);
$parcel$export($3c04d27da32a3c51$exports, "IDE", () => $3c04d27da32a3c51$export$484630cabf225e42, (v) => $3c04d27da32a3c51$export$484630cabf225e42 = v);
$parcel$export($3c04d27da32a3c51$exports, "ResizeHandle", () => $3c04d27da32a3c51$export$33f2411a0ad35be7, (v) => $3c04d27da32a3c51$export$33f2411a0ad35be7 = v);
$parcel$export($3c04d27da32a3c51$exports, "ResizeHandleCollapsed", () => $3c04d27da32a3c51$export$36de04b62ecccaea, (v) => $3c04d27da32a3c51$export$36de04b62ecccaea = v);
$parcel$export($3c04d27da32a3c51$exports, "SourceTab", () => $3c04d27da32a3c51$export$bc35284287341393, (v) => $3c04d27da32a3c51$export$bc35284287341393 = v);
$parcel$export($3c04d27da32a3c51$exports, "SourceTabs", () => $3c04d27da32a3c51$export$dfb9010d3bfbc5a0, (v) => $3c04d27da32a3c51$export$dfb9010d3bfbc5a0 = v);
$parcel$export($3c04d27da32a3c51$exports, "Toolbar", () => $3c04d27da32a3c51$export$4c260019440d418f, (v) => $3c04d27da32a3c51$export$4c260019440d418f = v);
$parcel$export($3c04d27da32a3c51$exports, "ToolbarIcon", () => $3c04d27da32a3c51$export$7dea8a01d77d462, (v) => $3c04d27da32a3c51$export$7dea8a01d77d462 = v);
$parcel$export($3c04d27da32a3c51$exports, "ToolbarIconActive", () => $3c04d27da32a3c51$export$ac6dd6dc72e97650, (v) => $3c04d27da32a3c51$export$ac6dd6dc72e97650 = v);
$parcel$export($3c04d27da32a3c51$exports, "filelist", () => $3c04d27da32a3c51$export$31d7bb65c9a33fab, (v) => $3c04d27da32a3c51$export$31d7bb65c9a33fab = v);
var $3c04d27da32a3c51$export$de65de8213222d10;
var $3c04d27da32a3c51$export$cae179f078f4b4a4;
var $3c04d27da32a3c51$export$51c46da272110b9a;
var $3c04d27da32a3c51$export$b778520f5cb384a0;
var $3c04d27da32a3c51$export$af701efb7ddbdf6b;
var $3c04d27da32a3c51$export$8c1a3d13e85d78b7;
var $3c04d27da32a3c51$export$1e273ac3a2ccbf84;
var $3c04d27da32a3c51$export$2a0b83121174119c;
var $3c04d27da32a3c51$export$484630cabf225e42;
var $3c04d27da32a3c51$export$33f2411a0ad35be7;
var $3c04d27da32a3c51$export$36de04b62ecccaea;
var $3c04d27da32a3c51$export$bc35284287341393;
var $3c04d27da32a3c51$export$dfb9010d3bfbc5a0;
var $3c04d27da32a3c51$export$4c260019440d418f;
var $3c04d27da32a3c51$export$7dea8a01d77d462;
var $3c04d27da32a3c51$export$ac6dd6dc72e97650;
var $3c04d27da32a3c51$export$31d7bb65c9a33fab;
$3c04d27da32a3c51$export$de65de8213222d10 = `cBt-Va_CloseButton`;
$3c04d27da32a3c51$export$cae179f078f4b4a4 = `cBt-Va_CloseIcon`;
$3c04d27da32a3c51$export$51c46da272110b9a = `cBt-Va_DirectoryEntry`;
$3c04d27da32a3c51$export$b778520f5cb384a0 = `cBt-Va_DirectoryName`;
$3c04d27da32a3c51$export$af701efb7ddbdf6b = `cBt-Va_FileEntry`;
$3c04d27da32a3c51$export$8c1a3d13e85d78b7 = `cBt-Va_FileIcon`;
$3c04d27da32a3c51$export$1e273ac3a2ccbf84 = `cBt-Va_FileList`;
$3c04d27da32a3c51$export$2a0b83121174119c = `cBt-Va_FileName`;
$3c04d27da32a3c51$export$484630cabf225e42 = `cBt-Va_IDE`;
$3c04d27da32a3c51$export$33f2411a0ad35be7 = `cBt-Va_ResizeHandle`;
$3c04d27da32a3c51$export$36de04b62ecccaea = `cBt-Va_ResizeHandleCollapsed`;
$3c04d27da32a3c51$export$bc35284287341393 = `cBt-Va_SourceTab`;
$3c04d27da32a3c51$export$dfb9010d3bfbc5a0 = `cBt-Va_SourceTabs`;
$3c04d27da32a3c51$export$4c260019440d418f = `cBt-Va_Toolbar`;
$3c04d27da32a3c51$export$7dea8a01d77d462 = `cBt-Va_ToolbarIcon`;
$3c04d27da32a3c51$export$ac6dd6dc72e97650 = `cBt-Va_ToolbarIconActive`;
$3c04d27da32a3c51$export$31d7bb65c9a33fab = `cBt-Va_filelist`;




function $eed0e2578f617aab$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $eed0e2578f617aab$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($eed0e2578f617aab$var$Content, {}),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        "The example below uses the ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "collapsedSize"
                        }),
                        ",",
                        " ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "collapsible"
                        }),
                        ", and ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "onCollapse"
                        }),
                        " props to mimic the UX of apps like VS Code by configuring a panel to be",
                        " ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("em", {
                            children: "collapsible"
                        }),
                        ". Panels can be collapsed all the way (to size 0) but in this example, the panel is configured to collapse to a size that allows the file icons to remain visible."
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                    children: "Drag the bar between the file browser and the source viewer to resize."
                })
            ]
        }),
        title: "Collapsible panels"
    });
}
function $eed0e2578f617aab$var$Content() {
    const [state, dispatch] = (0, $lx97N.useReducer)($eed0e2578f617aab$var$reducer, $eed0e2578f617aab$var$initialState);
    const { currentFileIndex: currentFileIndex, fileListCollapsed: fileListCollapsed, openFiles: openFiles } = state;
    const currentFile = openFiles[currentFileIndex] ?? null;
    const closeFile = (file)=>{
        dispatch({
            type: "close",
            file: file
        });
    };
    const openFile = (file)=>{
        dispatch({
            type: "open",
            file: file
        });
    };
    const onCollapse = ()=>{
        dispatch({
            type: "toggleCollapsed",
            collapsed: false
        });
    };
    const onExpand = ()=>{
        dispatch({
            type: "toggleCollapsed",
            collapsed: true
        });
    };
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).IDE,
            direction: "horizontal",
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).Toolbar,
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).ToolbarIconActive,
                            type: "files"
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).ToolbarIcon,
                            type: "search"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                    collapsedSizePixels: 36,
                    collapsible: true,
                    defaultSizePixels: 150,
                    maxSizePixels: 150,
                    minSizePixels: 60,
                    onCollapse: onCollapse,
                    onExpand: onExpand,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).FileList,
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).DirectoryEntry,
                                children: [
                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).SourceIcon,
                                        type: "chevron-down"
                                    }),
                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).DirectoryName,
                                        children: "source"
                                    })
                                ]
                            }),
                            $eed0e2578f617aab$var$FILES.map((file)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).FileEntry,
                                    "data-current": currentFile === file || undefined,
                                    onClick: (event)=>openFile(file),
                                    title: file.fileName,
                                    children: [
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).FileIcon,
                                            type: file.language
                                        }),
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).FileName,
                                            children: file.fileName
                                        })
                                    ]
                                }, file.fileName))
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $f94735aca202f120$export$8829ecf6b6b15484), {
                    className: fileListCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).ResizeHandleCollapsed : (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                    minSizePercentage: 50,
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).SourceTabs,
                            children: Array.from(openFiles).map((file)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).SourceTab,
                                    "data-current": currentFile === file || undefined,
                                    onClick: ()=>openFile(file),
                                    children: [
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).FileIcon,
                                            type: file.language
                                        }),
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                                            children: file.fileName
                                        }),
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).CloseButton,
                                            onClick: (event)=>{
                                                event.stopPropagation();
                                                closeFile(file);
                                            },
                                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3c04d27da32a3c51$exports))).CloseIcon,
                                                type: "close"
                                            })
                                        })
                                    ]
                                }, file.fileName))
                        }),
                        currentFile && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $99617ed31b4804f0$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Overflow,
                            code: currentFile.code.trim(),
                            language: currentFile.language,
                            showLineNumbers: true
                        })
                    ]
                })
            ]
        })
    });
}
const $eed0e2578f617aab$var$FILE_PATHS = [
    [
        "source/index.html",
        (0, $58155992730ff39c$export$186d097d647783ac)
    ],
    [
        "source/README.md",
        (0, $58155992730ff39c$export$bd9830b71362cd9d)
    ],
    [
        "source/styles.css",
        (0, $58155992730ff39c$export$b9cc13ca8a0ed0bc)
    ],
    [
        "source/TicTacToe.ts",
        (0, $58155992730ff39c$export$2475c3bbb09aea07)
    ]
];
const $eed0e2578f617aab$var$FILES = $eed0e2578f617aab$var$FILE_PATHS.map(([path, code])=>{
    const pathArray = path.split("/");
    const fileName = pathArray.pop();
    return {
        code: code,
        fileName: fileName,
        language: $eed0e2578f617aab$var$inferLanguageFromFileName(fileName),
        path: pathArray
    };
});
const $eed0e2578f617aab$var$CODE = `
<PanelGroup direction="horizontal">
  <SideTabBar />
  <Panel collapsible={true} collapsedSizePixels={35} minSizePercentage={10}>
    <SourceBrowser />
  </Panel>
  <PanelResizeHandle />
  <Panel>
    <SourceViewer />
  </Panel>
</PanelGroup>
`;
const $eed0e2578f617aab$var$initialState = {
    currentFileIndex: 0,
    fileListCollapsed: false,
    openFiles: [
        $eed0e2578f617aab$var$FILES[0]
    ]
};
function $eed0e2578f617aab$var$reducer(state, action) {
    switch(action.type){
        case "close":
            {
                const { file: file } = action;
                const { currentFileIndex: currentFileIndex, openFiles: openFiles } = state;
                let fileIndex = openFiles.findIndex(({ fileName: fileName })=>fileName === file.fileName);
                if (fileIndex === -1) // File not open; this shouldn't happen.
                return state;
                const newOpenFiles = openFiles.concat();
                newOpenFiles.splice(fileIndex, 1);
                let newCurrentFileIndex = currentFileIndex;
                if (newCurrentFileIndex >= newOpenFiles.length) newCurrentFileIndex = newOpenFiles.length - 1;
                return {
                    ...state,
                    currentFileIndex: newCurrentFileIndex,
                    openFiles: newOpenFiles
                };
            }
        case "open":
            {
                const { file: file } = action;
                const { openFiles: openFiles } = state;
                const fileIndex = openFiles.findIndex(({ fileName: fileName })=>fileName === file.fileName);
                if (fileIndex >= 0) return {
                    ...state,
                    currentFileIndex: fileIndex
                };
                else {
                    const newOpenFiles = [
                        ...openFiles,
                        file
                    ];
                    return {
                        ...state,
                        currentFileIndex: openFiles.length,
                        openFiles: newOpenFiles
                    };
                }
            }
        case "toggleCollapsed":
            return {
                ...state,
                fileListCollapsed: action.collapsed
            };
        default:
            throw `Unknown action type: ${action.type}`;
    }
}
function $eed0e2578f617aab$var$inferLanguageFromFileName(fileName) {
    const extension = fileName.split(".").pop();
    switch(extension){
        case "css":
            return "css";
        case "htm":
        case "html":
            return "html";
        case "js":
            return "javascript";
        case "jsx":
            return "jsx";
        case "md":
            return "markdown";
        case "tsx":
            return "tsx";
        case "ts":
            return "typescript";
        default:
            throw Error(`Unsupported extension "${extension}"`);
    }
}







function $4aedb424b99c66f4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $fe257bf6919f8c79$export$2e2bcd8739ae039), {
        code: $4aedb424b99c66f4$var$CODE,
        exampleNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($4aedb424b99c66f4$var$Content, {}),
        headerNode: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        "This example is a 2-row vertical ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "PanelGroup"
                        }),
                        ". Click/touch the empty space between the panels and drag to resize. Arrow keys can also be used to resize panels."
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        "These panels use the ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                            children: "maxSize"
                        }),
                        " property to prevent them from being resized larger than a maximal percentage of the overall group."
                    ]
                })
            ]
        }),
        title: "Vertical layouts"
    });
}
function $4aedb424b99c66f4$var$Content() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroupWrapper,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelGroup,
            direction: "vertical",
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                    defaultSizePercentage: 50,
                    maxSizePercentage: 75,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "top"
                    })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c966142541466a3$export$33f2411a0ad35be7), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).ResizeHandle
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).PanelColumn,
                    maxSizePercentage: 75,
                    minSizePercentage: 10,
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9e0d4d6612ed4e$exports))).Centered,
                        children: "bottom"
                    })
                })
            ]
        })
    });
}
const $4aedb424b99c66f4$var$CODE = `
<PanelGroup direction="vertical">
  <Panel maxSizePercentage={75}>
    top
  </Panel>
  <PanelResizeHandle />
  <Panel maxSizePercentage={75}>
    bottom
  </Panel>
</PanelGroup>
`;




var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");

function $20390a0e6c83aabe$var$isPanelElement(value) {
    return value?.type?.displayName === "forwardRef(Panel)";
}
function $20390a0e6c83aabe$var$isPanelGroupElement(value) {
    return value?.type?.displayName === "PanelGroup" || value?.type?.displayName === "forwardRef(PanelGroup)";
}
function $20390a0e6c83aabe$var$isPanelResizeHandleElement(value) {
    return value?.type?.displayName === "PanelResizeHandle";
}
function $20390a0e6c83aabe$var$isUrlPanel(value) {
    return value.type === "UrlPanel";
}
function $20390a0e6c83aabe$var$isUrlPanelGroup(value) {
    return value.type === "UrlPanelGroup";
}
function $20390a0e6c83aabe$var$isUrlPanelResizeHandle(value) {
    return value.type === "UrlPanelResizeHandle";
}
function $20390a0e6c83aabe$export$6b00172d732a54b4(urlPanelGroup) {
    const data = $20390a0e6c83aabe$var$UrlPanelGroupToData(urlPanelGroup);
    const serializedData = JSON.stringify(data);
    const encodedData = encodeURIComponent(serializedData);
    return encodedData;
}
function $20390a0e6c83aabe$var$UrlPanelToData(urlPanel) {
    return {
        children: (0, $lx97N.Children).toArray(urlPanel.props.children).map((child)=>{
            if ($20390a0e6c83aabe$var$isPanelGroupElement(child)) return $20390a0e6c83aabe$var$UrlPanelGroupToData(child);
            else return child;
        }),
        collapsedSizePercentage: urlPanel.props.collapsedSizePercentage,
        collapsedSizePixels: urlPanel.props.collapsedSizePixels,
        collapsible: urlPanel.props.collapsible,
        defaultSizePercentage: urlPanel.props.defaultSizePercentage,
        defaultSizePixels: urlPanel.props.defaultSizePixels,
        id: urlPanel.props.id,
        maxSizePercentage: urlPanel.props.maxSizePercentage,
        maxSizePixels: urlPanel.props.maxSizePixels,
        minSizePercentage: urlPanel.props.minSizePercentage,
        minSizePixels: urlPanel.props.minSizePixels,
        order: urlPanel.props.order,
        style: urlPanel.props.style,
        type: "UrlPanel"
    };
}
function $20390a0e6c83aabe$var$UrlPanelGroupToData(urlPanelGroup) {
    return {
        autoSaveId: urlPanelGroup.props.autoSaveId,
        children: (0, $lx97N.Children).toArray(urlPanelGroup.props.children).map((child)=>{
            if ($20390a0e6c83aabe$var$isPanelElement(child)) return $20390a0e6c83aabe$var$UrlPanelToData(child);
            else if ($20390a0e6c83aabe$var$isPanelResizeHandleElement(child)) return $20390a0e6c83aabe$var$UrlPanelResizeHandleToData(child);
            else throw Error("Invalid child");
        }),
        direction: urlPanelGroup.props.direction,
        id: urlPanelGroup.props.id,
        keyboardResizeByPercentage: urlPanelGroup.props.keyboardResizeByPercentage,
        keyboardResizeByPixels: urlPanelGroup.props.keyboardResizeByPixels,
        style: urlPanelGroup.props.style,
        type: "UrlPanelGroup"
    };
}
function $20390a0e6c83aabe$var$UrlPanelResizeHandleToData(urlPanelResizeHandle) {
    return {
        disabled: urlPanelResizeHandle.props.disabled,
        id: urlPanelResizeHandle.props.id,
        style: urlPanelResizeHandle.props.style,
        type: "UrlPanelResizeHandle"
    };
}
function $20390a0e6c83aabe$var$urlPanelToPanel(urlPanel, debugLogRef, idToRefMapRef, key) {
    let onCollapse = undefined;
    let onExpand = undefined;
    let onResize = undefined;
    const panelId = urlPanel.id;
    if (panelId) {
        onCollapse = ()=>{
            const debugLog = debugLogRef.current;
            if (debugLog) debugLog.log({
                panelId: panelId,
                type: "onCollapse"
            });
        };
        onExpand = ()=>{
            const debugLog = debugLogRef.current;
            if (debugLog) debugLog.log({
                panelId: panelId,
                type: "onExpand"
            });
        };
        onResize = (size)=>{
            const debugLog = debugLogRef.current;
            if (debugLog) debugLog.log({
                panelId: panelId,
                size: size,
                type: "onResize"
            });
        };
    }
    const refSetter = (panel)=>{
        if (panel) {
            const id = panel.getId();
            const idToRefMap = idToRefMapRef.current;
            idToRefMap.set(id, panel);
        }
    };
    return (0, $lx97N.createElement)((0, $ab529e707bcaa627$export$2ddb90ad54e5f587), {
        className: "Panel",
        collapsedSizePercentage: urlPanel.collapsedSizePercentage,
        collapsedSizePixels: urlPanel.collapsedSizePixels,
        collapsible: urlPanel.collapsible,
        defaultSizePercentage: urlPanel.defaultSizePercentage ?? undefined,
        defaultSizePixels: urlPanel.defaultSizePixels ?? undefined,
        id: urlPanel.id ?? undefined,
        key: key,
        maxSizePercentage: urlPanel.maxSizePercentage ?? undefined,
        maxSizePixels: urlPanel.maxSizePixels ?? undefined,
        minSizePercentage: urlPanel.minSizePercentage,
        minSizePixels: urlPanel.minSizePixels,
        onCollapse: onCollapse,
        onExpand: onExpand,
        onResize: onResize,
        order: urlPanel.order ?? undefined,
        ref: refSetter,
        style: urlPanel.style
    }, urlPanel.children.map((child, index)=>{
        if ($20390a0e6c83aabe$var$isUrlPanelGroup(child)) return $20390a0e6c83aabe$export$51cf372747a0666e(child, debugLogRef, idToRefMapRef, index);
        else return (0, $lx97N.createElement)((0, $lx97N.Fragment), {
            key: index
        }, child);
    }));
}
function $20390a0e6c83aabe$export$51cf372747a0666e(urlPanelGroup, debugLogRef, idToRefMapRef, key) {
    let onLayout = undefined;
    const groupId = urlPanelGroup.id;
    if (groupId) onLayout = (layout)=>{
        const debugLog = debugLogRef.current;
        if (debugLog) debugLog.log({
            groupId: groupId,
            type: "onLayout",
            layout: layout
        });
    };
    const refSetter = (panelGroup)=>{
        if (panelGroup) {
            const id = panelGroup.getId();
            const idToRefMap = idToRefMapRef.current;
            idToRefMap.set(id, panelGroup);
        }
    };
    return (0, $lx97N.createElement)((0, $975d9a9f17fa8705$export$1d05749f6f573bb), {
        autoSaveId: urlPanelGroup.autoSaveId,
        className: "PanelGroup",
        direction: urlPanelGroup.direction,
        id: urlPanelGroup.id,
        key: key,
        keyboardResizeByPercentage: urlPanelGroup.keyboardResizeByPercentage,
        keyboardResizeByPixels: urlPanelGroup.keyboardResizeByPixels,
        onLayout: onLayout,
        ref: refSetter,
        style: urlPanelGroup.style
    }, urlPanelGroup.children.map((child, index)=>{
        if ($20390a0e6c83aabe$var$isUrlPanel(child)) return $20390a0e6c83aabe$var$urlPanelToPanel(child, debugLogRef, idToRefMapRef, index);
        else if ($20390a0e6c83aabe$var$isUrlPanelResizeHandle(child)) return $20390a0e6c83aabe$var$urlPanelResizeHandleToPanelResizeHandle(child, debugLogRef, index);
        else throw Error("Invalid child");
    }));
}
function $20390a0e6c83aabe$var$urlPanelResizeHandleToPanelResizeHandle(urlPanelResizeHandle, debugLogRef, key) {
    let onDragging = undefined;
    const resizeHandleId = urlPanelResizeHandle.id;
    if (resizeHandleId) onDragging = (isDragging)=>{
        const debugLog = debugLogRef.current;
        if (debugLog) debugLog.log({
            isDragging: isDragging,
            resizeHandleId: resizeHandleId,
            type: "onDragging"
        });
    };
    return (0, $lx97N.createElement)((0, $f94735aca202f120$export$8829ecf6b6b15484), {
        className: "PanelResizeHandle",
        disabled: urlPanelResizeHandle.disabled,
        id: urlPanelResizeHandle.id,
        key: key,
        onDragging: onDragging,
        style: urlPanelResizeHandle.style
    });
}
function $20390a0e6c83aabe$export$dde5ae3cb56c357c(url) {
    const rawData = url.searchParams.get("urlPanelGroup");
    if (rawData) try {
        const decodedData = decodeURIComponent(rawData);
        const parsedData = JSON.parse(decodedData);
        if ($20390a0e6c83aabe$var$isUrlPanelGroup(parsedData)) return parsedData;
    } catch (error) {}
    return null;
}




var $lx97N = parcelRequire("lx97N");
function $2396ae0401407ce4$export$2e2bcd8739ae039({ apiRef: apiRef }) {
    const ref = (0, $lx97N.useRef)(null);
    (0, $lx97N.useImperativeHandle)(apiRef, ()=>({
            log: (logEntry)=>{
                const div = ref.current;
                if (div) try {
                    let objectsArray = [];
                    const textContent = div.textContent.trim();
                    if (textContent !== "") objectsArray = JSON.parse(textContent);
                    objectsArray.push(logEntry);
                    div.textContent = JSON.stringify(objectsArray);
                } catch (error) {}
            }
        }));
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        id: "debug",
        ref: ref,
        style: {
            display: "none"
        },
        children: "[]"
    });
}


function $5b87a86b893a8e03$export$a7a9523472993e97(expectedCondition, message = "Assertion failed!") {
    if (!expectedCondition) {
        console.error(message);
        throw Error(message);
    }
}
function $5b87a86b893a8e03$export$a34fc0f27ebfafa8(value) {
    $5b87a86b893a8e03$export$a7a9523472993e97($5b87a86b893a8e03$export$c962b33be83a4fc6(value), "Value is not an ImperativePanelHandle");
    return true;
}
function $5b87a86b893a8e03$export$2b7fb56583aec1cb(value) {
    $5b87a86b893a8e03$export$a7a9523472993e97($5b87a86b893a8e03$export$f4769e650b452d93(value), "Value is not an ImperativePanelGroupHandle");
    return true;
}
function $5b87a86b893a8e03$export$c962b33be83a4fc6(value) {
    return value != null && typeof value === "object" && typeof value.collapse === "function" && typeof value.expand === "function" && typeof value.isCollapsed === "function" && typeof value.isExpanded === "function" && typeof value.getSize === "function" && typeof value.resize === "function";
}
function $5b87a86b893a8e03$export$f4769e650b452d93(value) {
    return value != null && typeof value === "object" && typeof value.getLayout === "function" && typeof value.setLayout === "function";
}




var $43074fc64f81c691$exports = {};

$parcel$export($43074fc64f81c691$exports, "Children", () => $43074fc64f81c691$export$dca3b0875bd9a954, (v) => $43074fc64f81c691$export$dca3b0875bd9a954 = v);
$parcel$export($43074fc64f81c691$exports, "Container", () => $43074fc64f81c691$export$42a852a2b6b56249, (v) => $43074fc64f81c691$export$42a852a2b6b56249 = v);
$parcel$export($43074fc64f81c691$exports, "FormColumn", () => $43074fc64f81c691$export$721f69dc1a24ae03, (v) => $43074fc64f81c691$export$721f69dc1a24ae03 = v);
$parcel$export($43074fc64f81c691$exports, "FormRow", () => $43074fc64f81c691$export$b534bc812df080fd, (v) => $43074fc64f81c691$export$b534bc812df080fd = v);
$parcel$export($43074fc64f81c691$exports, "Input", () => $43074fc64f81c691$export$f5b8910cec6cf069, (v) => $43074fc64f81c691$export$f5b8910cec6cf069 = v);
$parcel$export($43074fc64f81c691$exports, "Spacer", () => $43074fc64f81c691$export$d7a54cba636a8cd6, (v) => $43074fc64f81c691$export$d7a54cba636a8cd6 = v);
var $43074fc64f81c691$export$dca3b0875bd9a954;
var $43074fc64f81c691$export$42a852a2b6b56249;
var $43074fc64f81c691$export$721f69dc1a24ae03;
var $43074fc64f81c691$export$b534bc812df080fd;
var $43074fc64f81c691$export$f5b8910cec6cf069;
var $43074fc64f81c691$export$d7a54cba636a8cd6;
$43074fc64f81c691$export$dca3b0875bd9a954 = `KuJPWW_Children`;
$43074fc64f81c691$export$42a852a2b6b56249 = `KuJPWW_Container`;
$43074fc64f81c691$export$721f69dc1a24ae03 = `KuJPWW_FormColumn`;
$43074fc64f81c691$export$b534bc812df080fd = `KuJPWW_FormRow`;
$43074fc64f81c691$export$f5b8910cec6cf069 = `KuJPWW_Input`;
$43074fc64f81c691$export$d7a54cba636a8cd6 = `KuJPWW_Spacer`;


// Special route that can be configured via URL parameters.
class $5da0ce824b269670$var$ErrorBoundary extends (0, $lx97N.Component) {
    componentDidCatch(error, errorInfo) {
        console.error(error);
    }
    render() {
        return this.state.didError ? null : this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            didError: false
        };
    }
}
function $5da0ce824b269670$var$EndToEndTesting() {
    const [urlData, setUrlData] = (0, $lx97N.useState)(()=>{
        const url = new URL(((window, true), window.location.href));
        return (0, $20390a0e6c83aabe$export$dde5ae3cb56c357c)(url);
    });
    const [panelId, setPanelId] = (0, $lx97N.useState)("");
    const [panelIds, setPanelIds] = (0, $lx97N.useState)([]);
    const [panelGroupId, setPanelGroupId] = (0, $lx97N.useState)("");
    const [panelGroupIds, setPanelGroupIds] = (0, $lx97N.useState)([]);
    const [sizePercentage, setSizePercentage] = (0, $lx97N.useState)(undefined);
    const [sizePixels, setSizePixels] = (0, $lx97N.useState)(undefined);
    const [layoutString, setLayoutString] = (0, $lx97N.useState)("");
    const debugLogRef = (0, $lx97N.useRef)(null);
    const idToRefMapRef = (0, $lx97N.useRef)(new Map());
    (0, $lx97N.useLayoutEffect)(()=>{
        const populateDropDowns = ()=>{
            const panelElements = document.querySelectorAll("[data-panel-id]");
            const panelIds = Array.from(panelElements).map((element)=>element.getAttribute("data-panel-id"));
            setPanelIds(panelIds);
            setPanelId(panelIds[0]);
            const panelGroupElements = document.querySelectorAll("[data-panel-group]");
            const panelGroupIds = Array.from(panelGroupElements).map((element)=>element.getAttribute("data-panel-group-id"));
            setPanelGroupIds(panelGroupIds);
            setPanelGroupId(panelGroupIds[0]);
        };
        window.addEventListener("popstate", (event)=>{
            const url = new URL(((window, true), window.location.href));
            setUrlData((0, $20390a0e6c83aabe$export$dde5ae3cb56c357c)(url));
            populateDropDowns();
        });
        populateDropDowns();
    }, []);
    (0, $lx97N.useLayoutEffect)(()=>{
        const calculatePanelSize = (panelElement)=>{
            if (panelElement.childElementCount > 0) return; // Don't override nested groups
            // Let layout effects fire first
            setTimeout(()=>{
                const panelId = panelElement.getAttribute("data-panel-id");
                if (panelId != null) {
                    const panel = idToRefMapRef.current.get(panelId);
                    if (panel != null) {
                        const { sizePercentage: sizePercentage, sizePixels: sizePixels } = panel.getSize();
                        panelElement.textContent = `${sizePercentage.toFixed(1)}%\n${sizePixels.toFixed(1)}px`;
                    }
                }
            }, 0);
        };
        const mutationObserver = new MutationObserver((records)=>{
            records.forEach((record)=>{
                calculatePanelSize(record.target);
            });
        });
        const resizeObserver = new ResizeObserver((records)=>{
            records.forEach((record)=>{
                calculatePanelSize(record.target);
            });
        });
        const elements = document.querySelectorAll("[data-panel]");
        Array.from(elements).forEach((element)=>{
            mutationObserver.observe(element, {
                attributes: true
            });
            resizeObserver.observe(element);
            calculatePanelSize(element);
        });
        return ()=>{
            mutationObserver.disconnect();
            resizeObserver.disconnect();
        };
    }, [
        urlData
    ]);
    const children = urlData ? (0, $20390a0e6c83aabe$export$51cf372747a0666e)(urlData, debugLogRef, idToRefMapRef) : null;
    const onLayoutInputChange = (event)=>{
        const value = event.currentTarget.value;
        setLayoutString(value.startsWith("[") ? value : `[${value}]`);
    };
    const onPanelIdSelectChange = (event)=>{
        const value = event.currentTarget.value;
        setPanelId(value);
    };
    const onPanelGroupIdSelectChange = (event)=>{
        const value = event.currentTarget.value;
        setPanelGroupId(value);
    };
    const onSizeInputChange = (event)=>{
        const value = event.currentTarget.value;
        if (value.endsWith("%")) {
            setSizePercentage(parseFloat(value));
            setSizePixels(undefined);
        } else if (value.endsWith("px")) {
            setSizePercentage(undefined);
            setSizePixels(parseFloat(value));
        } else throw Error(`Invalid size: ${value}`);
    };
    const onCollapseButtonClick = ()=>{
        const idToRefMap = idToRefMapRef.current;
        const panel = idToRefMap.get(panelId);
        if (panel && (0, $5b87a86b893a8e03$export$a34fc0f27ebfafa8)(panel)) panel.collapse();
    };
    const onExpandButtonClick = ()=>{
        const idToRefMap = idToRefMapRef.current;
        const panel = idToRefMap.get(panelId);
        if (panel && (0, $5b87a86b893a8e03$export$a34fc0f27ebfafa8)(panel)) panel.expand();
    };
    const onResizeButtonClick = ()=>{
        const idToRefMap = idToRefMapRef.current;
        const panel = idToRefMap.get(panelId);
        if (panel && (0, $5b87a86b893a8e03$export$a34fc0f27ebfafa8)(panel)) panel.resize({
            sizePercentage: sizePercentage,
            sizePixels: sizePixels
        });
    };
    const onSetLayoutButton = ()=>{
        const idToRefMap = idToRefMapRef.current;
        const panelGroup = idToRefMap.get(panelGroupId);
        if (panelGroup && (0, $5b87a86b893a8e03$export$2b7fb56583aec1cb)(panelGroup)) {
            const trimmedLayoutString = layoutString.substring(1, layoutString.length - 1);
            const layout = trimmedLayoutString.split(",").map((text)=>{
                if (text.endsWith("%")) return {
                    sizePercentage: parseFloat(text)
                };
                else if (text.endsWith("px")) return {
                    sizePixels: parseFloat(text)
                };
                else throw Error(`Invalid layout: ${layoutString}`);
            });
            panelGroup.setLayout(layout);
        }
    };
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($43074fc64f81c691$exports))).Container,
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($43074fc64f81c691$exports))).FormRow,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($43074fc64f81c691$exports))).FormColumn,
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("select", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($43074fc64f81c691$exports))).Input,
                            id: "panelIdSelect",
                            onChange: onPanelIdSelectChange,
                            placeholder: "Panel id",
                            children: panelIds.map((panelId)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("option", {
                                    value: panelId,
                                    children: panelId
                                }, panelId))
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                            id: "collapseButton",
                            onClick: onCollapseButtonClick,
                            title: "Collapse panel",
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                                type: "collapse"
                            })
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                            id: "expandButton",
                            onClick: onExpandButtonClick,
                            title: "Expand panel",
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                                type: "expand"
                            })
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($43074fc64f81c691$exports))).Input,
                            id: "sizeInput",
                            onChange: onSizeInputChange,
                            placeholder: "Size (% or px)",
                            type: "text"
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                            id: "resizeButton",
                            onClick: onResizeButtonClick,
                            title: "Resize panel",
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                                type: "resize"
                            })
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($43074fc64f81c691$exports))).Spacer
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("select", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($43074fc64f81c691$exports))).Input,
                            id: "panelGroupIdSelect",
                            onChange: onPanelGroupIdSelectChange,
                            placeholder: "Panel group id",
                            children: panelGroupIds.map((panelGroupId)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("option", {
                                    value: panelGroupId,
                                    children: panelGroupId
                                }, panelGroupId))
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($43074fc64f81c691$exports))).Input,
                            id: "layoutInput",
                            onChange: onLayoutInputChange,
                            placeholder: "Layout",
                            type: "string"
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                            id: "setLayoutButton",
                            onClick: onSetLayoutButton,
                            title: "Set layout",
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9da32f0f5e294f66$export$2e2bcd8739ae039), {
                                type: "resize"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $2396ae0401407ce4$export$2e2bcd8739ae039), {
                apiRef: debugLogRef
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($43074fc64f81c691$exports))).Children,
                children: children
            })
        ]
    });
}
function $5da0ce824b269670$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($5da0ce824b269670$var$ErrorBoundary, {
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($5da0ce824b269670$var$EndToEndTesting, {})
    });
}


const $33cb4a9d324822ff$var$router = (0, $e63ef3154ed2b0d6$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $c577054c22bab523$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/conditional",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $7e4f335662b3c697$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/pixel-based-layouts",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $dea5e99b7171edb5$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/external-persistence",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $dd14ea2961012e31$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/horizontal",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $0f6043888b379808$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/imperative-panel-api",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $c9067f6f07f1c14f$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/imperative-panel-group-api",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $452fb88e0ef71d46$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/nested",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $83518755cd0c0ce4$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/overflow",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $01c257061870aa39$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/persistence",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $139261b9c00dcaa5$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/collapsible",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $eed0e2578f617aab$export$2e2bcd8739ae039), {})
    },
    {
        path: "/examples/vertical",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $4aedb424b99c66f4$export$2e2bcd8739ae039), {})
    },
    // Special route used by e2e tests
    {
        path: "/__e2e",
        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $5da0ce824b269670$export$2e2bcd8739ae039), {})
    }
]);
const $33cb4a9d324822ff$var$rootElement = document.getElementById("root");
const $33cb4a9d324822ff$var$root = (0, $e08bedd2d92855da$export$882461b6382ed46c)($33cb4a9d324822ff$var$rootElement);
$33cb4a9d324822ff$var$root.render(/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $lx97N.StrictMode), {
    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $70ed8fdcf064e4a0$export$323e4fc2fa4753fb), {
        router: $33cb4a9d324822ff$var$router
    })
}));


//# sourceMappingURL=index.be37a108.js.map
